import Ti, { defineComponent as _l } from "vue";
import t1 from "./tailwind.config.js";
function e1(i, t) {
  let e;
  if (!i || Number.isNaN(i) || i === "") return "$0";
  const n = i.toString().match(/^\$/), { minimumFractionDigits: s = 0 } = t || {}, r = parseInt(i, 10);
  if (Number.isNaN(r))
    return i;
  e = r, e = e.toLocaleString(
    "en-US",
    {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: s || 0
    }
  );
  const a = e < 0;
  return n && (e = e.toString().replace(/^/, "$")), a && n && (e = e.replace(/^/, "-$")), a && (e = e.replace(/-/, "-$")), !a && n && (e = e.replace(/^/, "$")), e.match(/^\$\$/) && (e = e.replace(/^\$\$/, "")), e;
}
const i1 = (i) => typeof i == "string" ? i.toUpperCase() : i;
function n1(i, t) {
  return new Date(i).toLocaleDateString(t);
}
function s1(i) {
  return i && parseInt(i, 10).toLocaleString();
}
const r1 = {
  install(i) {
    i.filter("currency", e1), i.filter("uppercase", i1), i.filter("javascriptDateFormatter", n1), i.filter("numberWithCommas", s1);
  }
};
function wt(i, t) {
  return t.length && t.indexOf(i) !== -1;
}
function U(i, t, e, n, s, r, a, o) {
  var l = typeof i == "function" ? i.options : i;
  return t && (l.render = t, l.staticRenderFns = e, l._compiled = !0), r && (l._scopeId = "data-v-" + r), {
    exports: i,
    options: l
  };
}
const a1 = {
  name: "AcvBadge",
  props: {
    /**
    * Badge variant style
    */
    variant: {
      type: String,
      default: "primary",
      validator(i) {
        return wt(i, ["primary", "secondary"]);
      }
    },
    /**
    * Content to be rendered within badge
    */
    content: {
      type: [String, Number],
      default: null
    },
    /**
    * Shows only the bubble without content
    */
    mini: {
      type: Boolean,
      default: !1
    },
    /**
    * Adds disabled styling to the badge
    */
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    computedClasses() {
      return {
        [`acv-badge--${this.variant}`]: !0,
        "acv-badge--disabled": this.disabled,
        "acv-badge--mini": !this.showingContent
      };
    },
    showingContent() {
      return !this.mini && !!this.content;
    }
  }
};
var o1 = function() {
  var t = this, e = t._self._c;
  return e("div", t._g({ class: ["acv-badge", t.computedClasses] }, t.$listeners), [t.showingContent ? e("span", { staticClass: "acv-badge__content" }, [t._v(" " + t._s(t.content) + " ")]) : t._e()]);
}, l1 = [], c1 = /* @__PURE__ */ U(
  a1,
  o1,
  l1,
  !1,
  null,
  "a3ab0b34"
);
const xa = c1.exports, Gd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: xa
}, Symbol.toStringTag, { value: "Module" }));
var u1 = {
  circle: function(t) {
    return `
  	M ` + t / 2 + ", " + t / 2 + `
    m 0, -` + t / 2 + `
    a ` + t / 2 + "," + t / 2 + " 0 1 1 0," + t + `
    a ` + t / 2 + "," + t / 2 + " 0 1 1 0,-" + t + `
  `;
  },
  semicircle: function(t) {
    return `
  	M ` + t / 2 + ", " + t / 2 + `
    m -` + t / 2 + `, 0
    a ` + t / 2 + "," + t / 2 + " 0 1 1 " + t + `,0
  `;
  },
  line: function(t) {
    return `
  	M 0,` + t / 2 + `
    L ` + t + "," + t / 2 + `
  `;
  },
  square: function(t) {
    return `
  	M 0,0
    L ` + t + `,0
    L ` + t + "," + t + `
    L 0,` + t + `
    Z
	`;
  }
}, d1 = {
  render: function() {
    var t = this, e = t.$createElement, n = t._self._c || e;
    return n("div", { staticClass: "vue-progress-path", class: t.cssClass, style: t.style }, [n("svg", { attrs: { width: t.finalWidth, height: t.finalHeight, viewBox: "0 0 " + t.finalWidth + " " + t.finalHeight } }, [n("g", { attrs: { transform: "translate(" + (t.finalWidth - t.size) / 2 + ", " + (t.finalHeight - t.size) / 2 + ") rotate(" + t.finalRotation + ", " + t.size / 2 + ", " + t.size / 2 + ")" } }, [n("g", { staticClass: "container" }, [t.hideBackground ? t._e() : n("path", { staticClass: "background", attrs: { d: t.path } }), n("path", { ref: "path", staticClass: "progress", attrs: { d: t.path, "stroke-dasharray": t.finalDasharray + " " + t.finalDasharray, "stroke-dashoffset": t.finalDashoffset } })])])])]);
  },
  staticRenderFns: [],
  name: "Progress",
  props: {
    counterClockwise: {
      type: Boolean,
      default: !1
    },
    fillDuration: {
      type: [String, Number],
      default: 1
    },
    height: {
      type: [String, Number],
      default: 0
    },
    hideBackground: {
      type: Boolean,
      default: !1
    },
    indeterminate: {
      type: Boolean,
      default: !1
    },
    progress: {
      type: Number,
      default: 0,
      validate: function(t) {
        return t >= -1 && t <= 1;
      }
    },
    rotate: {
      type: Boolean,
      default: !1
    },
    rotationDuration: {
      type: [String, Number],
      default: 1
    },
    shape: {
      type: String,
      default: null
    },
    size: {
      type: [String, Number],
      default: 100
    },
    staticPath: {
      type: Boolean,
      default: !1
    },
    width: {
      type: [String, Number],
      default: 0
    }
  },
  data: function() {
    return {
      dasharray: 0,
      dashoffset: 0,
      rotation: 0,
      animating: !1
    };
  },
  computed: {
    cssClass: function() {
      return {
        indeterminate: this.indeterminate
      };
    },
    finalDasharray: function() {
      return this.finalDashoffset === 0 || this.finalDashoffset === this.dasharray * 2 ? 0 : this.dasharray;
    },
    finalDashoffset: function() {
      return this.animating ? this.dashoffset : this.finalProgress < 0 ? -this.dasharray * this.finalProgress + this.dasharray : (1 - this.finalProgress) * this.dasharray;
    },
    finalHeight: function() {
      return this.height || parseFloat(this.size) + 50;
    },
    finalProgress: function() {
      return this.counterClockwise ? -this.progress : this.progress;
    },
    finalRotation: function() {
      return this.animating ? this.rotation : 0;
    },
    finalShape: function() {
      return this.shape ? this.shape : jr.defaultShape;
    },
    finalWidth: function() {
      return this.width || parseFloat(this.size) + 50;
    },
    style: function() {
      return {
        width: this.finalWidth + "px",
        height: this.finalHeight + "px"
      };
    },
    svgStyle: function() {
      return {};
    },
    path: function() {
      var t = u1[this.finalShape] || this.finalShape;
      if (t)
        return typeof t == "function" && (t = t(this.size)), t;
    }
  },
  watch: {
    indeterminate: {
      handler: function(t) {
        t ? this.startAnimation() : this.stopAnimation();
      },
      immediate: !0
    },
    path: {
      handler: function() {
        var t = this;
        this.$nextTick(function() {
          t.dasharray = t.$refs.path.getTotalLength();
        });
      },
      immediate: !0
    }
  },
  methods: {
    frame: function(t) {
      var e = t - this._animationLastFrame;
      if (this._animationLastFrame = t, this.rotate) {
        var n = this.counterClockwise ? -1 : 1, s = e * 360 / (parseFloat(this.rotationDuration) * 1e3);
        this.rotation += s * n, this.counterClockwise ? this.rotation < 0 && (this.rotation += 360) : this.rotation > 360 && (this.rotation -= 360);
      }
      if (!this.staticPath) {
        var r = this.dasharray * 2, a = this.counterClockwise ? 1 : -1, o = e * r / (parseFloat(this.fillDuration) * 1e3);
        this.dashoffset += o * a, this.counterClockwise ? this.dashoffset < 0 && (this.dashoffset += r) : this.dashoffset > r && (this.dashoffset -= r);
      }
      this.animating && requestAnimationFrame(this.frame);
    },
    startAnimation: function() {
      this.dashoffset = this.dasharray, this.rotation = 0, this.animating = !0, this._animationLastFrame = performance.now(), requestAnimationFrame(this.frame);
    },
    stopAnimation: function() {
      this.animating = !1;
    }
  },
  beforeDestroy: function() {
    this.stopAnimation();
  }
}, jr = {};
function h1(i, t) {
  i.component(t + "progress", d1);
}
var Kd = {
  // eslint-disable-next-line no-undef
  version: "0.0.2",
  install: function(t, e) {
    jr = Object.assign({}, {
      installComponents: !0,
      componentsPrefix: "loading-",
      defaultShape: "circle"
    }, e), jr.installComponents && h1(t, jr.componentsPrefix);
  }
}, Qr = null;
typeof window < "u" ? Qr = window.Vue : typeof global < "u" && (Qr = global.Vue);
Qr && Qr.use(Kd);
Ti.use(Kd);
const f1 = {
  name: "AcvProgressIndicator",
  props: {
    /**
     * Options: `primary`, `secondary`, `tertiary`, `informational`
     */
    variant: {
      type: String,
      default: "primary",
      validator(i) {
        return wt(i, ["primary", "secondary", "tertiary", "informational"]);
      }
    },
    /**
     * Sets a predefined render mode with default options.
     * Options can be overridden via props.
     */
    mode: {
      type: String,
      default: "circular",
      validator(i) {
        return wt(i, [
          "circular",
          "linear"
        ]);
      }
    },
    /**
     * `determinate` indicators display how long a process will take and are useful
     * when the process completion rate can be detected. Use `progress` for updates.
     * <br/>
     * `indeterminate` is meant for when the time to completion is unknown.
     *
     */
    indeterminate: {
      type: Boolean,
      default: !0
    },
    /**
     * `counterClockwise` controls the direction of the spin/progress bar
     */
    counterClockwise: {
      type: Boolean,
      default: !1
    },
    /**
     * The amount in seconds it takes for the indeterminate progress bar to fill up
     */
    fillDuration: {
      type: [String, Number],
      default: 1
    },
    height: {
      type: [String, Number],
      default: 0
    },
    /**
     * Show/hide the track the progress bar follows
     */
    hideBackground: {
      type: Boolean,
      default: !1
    },
    /**
     * A floating number between 0 - 1 the indicates the current progress of the indicator.
     */
    progress: {
      type: Number,
      default: 0,
      validator(i) {
        return i >= -1 && i <= 1;
      }
    },
    /**
     * Enables a rotation animation on the progress indicator
     */
    rotate: {
      type: Boolean,
      default: !1
    },
    /**
     * Controls the speed when rotate = `true`
     */
    rotationDuration: {
      type: [String, Number],
      default: 1
    },
    shape: {
      type: String,
      default: "circle",
      validator(i) {
        return wt(i, [
          "circle",
          "line"
        ]);
      }
    },
    size: {
      type: [String, Number],
      default: 100
    },
    width: {
      type: [String, Number],
      default: 0
    },
    /**
     * The stroke size in px. Only supports up to 20px by default. For larger sizes,
     * use the following CSS selector to override:
       ```css
       .vue-progress-path path {
          stroke-width: 12;
        }
        ```
     */
    stroke: {
      type: [String, Number],
      default: 5,
      validator(i) {
        return i >= 1 && i <= 15;
      }
    }
  },
  data: () => ({
    modes: {
      circular: {
        fillDuration: 1,
        rotate: !0,
        rotationDuration: 1,
        shape: "circle"
      },
      linear: {
        fillDuration: 1,
        rotate: !1,
        rotationDuration: void 0,
        shape: "line"
      }
    }
  }),
  computed: {
    loadingProgressOptions() {
      return {
        ...{
          indeterminate: this.indeterminate,
          counterClockwise: this.counterClockwise,
          fillDuration: this.fillDuration,
          height: this.height,
          hideBackground: this.hideBackground,
          progress: this.progress,
          rotate: this.rotate,
          rotationDuration: this.rotationDuration,
          shape: this.shape,
          size: this.size,
          width: this.width
        },
        ...this.$props,
        ...this.modes[this.mode]
      };
    },
    extraClasses() {
      return [
        ...[
          `acv-progress-indicator--${this.variant}`,
          `acv-progress-indicator--${this.shape}`,
          `stroke-${this.stroke}`
        ]
      ];
    }
  }
};
var p1 = function() {
  var t = this, e = t._self._c;
  return e("loading-progress", t._b({ class: [
    ...t.extraClasses
  ] }, "loading-progress", { ...t.loadingProgressOptions }, !1));
}, g1 = [], m1 = /* @__PURE__ */ U(
  f1,
  p1,
  g1,
  !1,
  null,
  "76d45681"
);
const Ca = m1.exports, v1 = {
  name: "AcvButton",
  components: {
    AcvProgressIndicator: Ca,
    AcvIcon: () => Promise.resolve().then(() => Ie)
  },
  props: {
    /**
     * Object with options to customize the progress indicator.
     * Fields map directly to the props on
     * [AcvProgressIndicator.vue](https://github.com/acv-auctions/acv-web-vuejs/blob/master/src/shared/components/ProgressIndicator/ProgressIndicator.vue)
     */
    progressIndicatorOptions: {
      type: Object,
      default: () => ({})
    },
    /**
    * Type of button to be render
    */
    type: {
      type: String,
      default: "button",
      validator(i) {
        return wt(i, ["button", "submit"]);
      }
    },
    /**
    * Button variant style
    */
    variant: {
      type: String,
      default: "primary",
      validator(i) {
        return wt(i, [
          "primary",
          "secondary",
          "tertiary",
          "link",
          "error",
          "suspended",
          "error-secondary"
        ]);
      }
    },
    /**
    * Height of the button
    */
    size: {
      type: String,
      default: "large",
      validator(i) {
        return wt(i, [
          "large",
          "medium",
          "small"
        ]);
      }
    },
    /**
    * Renders the button as a square
    */
    square: {
      type: Boolean,
      default: !1
    },
    /**
     * Checks if the button should be disabled
     */
    disabled: {
      type: Boolean,
      default: !1
    },
    /**
     * Shows an indeterminate progress indicator.
     * Use the prop `progressIndicatorOptions` to customize the indicator.
     */
    loading: {
      type: Boolean,
      default: !1
    },
    /**
    * Prepends an icon before the button text content
    */
    iconPrepend: {
      type: String,
      default: ""
    },
    /**
    * Appends an icon before the button content
    */
    iconAppend: {
      type: String,
      default: ""
    }
  },
  computed: {
    computedProgressIndicatorOptions() {
      const i = {
        variant: ["secondary", "tertiary", "link", "suspended"].includes(this.variant) ? "primary" : "secondary",
        mode: "circular",
        indeterminate: !0,
        stroke: 2
      }, t = {
        small: {
          size: 8,
          height: 10,
          width: 10
        },
        medium: {
          size: 12,
          height: 14,
          width: 14
        },
        large: {
          size: 12,
          height: 14,
          width: 14
        }
      }[this.size];
      return {
        ...{
          ...i,
          ...t
        },
        ...this.progressIndicatorOptions
      };
    },
    computedClasses() {
      return {
        [`acv-button--${this.variant}`]: !0,
        [`acv-button--${this.size}`]: !0,
        "acv-button--square": this.square
      };
    },
    hasPrepend() {
      return this.$slots.prepend || this.iconPrepend;
    },
    hasAppend() {
      return this.$slots.append || this.iconAppend;
    },
    inputListeners() {
      return {
        ...this.$listeners,
        click: (i) => {
          this.$emit("click", i), this.$el.blur();
        }
      };
    }
  }
};
var A1 = function() {
  var t = this, e = t._self._c;
  return e("button", t._g({ class: ["acv-button ripple", t.computedClasses], attrs: { type: t.type, disabled: t.disabled } }, t.inputListeners), [t.hasPrepend ? [e("div", { staticClass: "acv-button__prepend" }, [t._t("prepend", function() {
    return [t.iconPrepend ? e("acv-icon", { staticClass: "acv-button__icon acv-button__icon--prepend", attrs: { icon: t.iconPrepend } }) : t._e()];
  })], 2)] : t._e(), t.loading ? e("acv-progress-indicator", t._b({ staticClass: "acv-button__progress-indicator" }, "acv-progress-indicator", t.computedProgressIndicatorOptions, !1)) : t._t("default"), t.hasAppend ? [e("div", { staticClass: "acv-button__append" }, [t._t("append", function() {
    return [t.iconAppend ? e("acv-icon", { staticClass: "acv-button__icon acv-button__icon--append", attrs: { icon: t.iconAppend } }) : t._e()];
  })], 2)] : t._e()], 2);
}, b1 = [], y1 = /* @__PURE__ */ U(
  v1,
  A1,
  b1,
  !1,
  null,
  "ab6e3ee6"
);
const bi = y1.exports, Xd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: bi
}, Symbol.toStringTag, { value: "Module" })), _1 = [
  ["account-circle", "account_circle"],
  ["add-a-photo", "add_a_photo"],
  ["arrow-back", "arrow_back"],
  ["arrow-back-ios", "arrow_back_ios"],
  ["arrow-drop-down", "arrow_drop_down"],
  ["arrow-drop-up", "arrow_drop_up"],
  ["arrow-forward", "arrow_forward"],
  ["arrow-forward-ios", "arrow_forward_ios"],
  ["ascending", "arrow_upward"],
  ["attach-money", "attach_money"],
  ["bar-graph", "bar_chart"],
  ["calendar", "calendar_today"],
  ["caution-message", "error_outline"],
  ["chevron-left", "chevron_left"],
  ["chevron-right", "chevron_right"],
  ["cloud-download", "cloud_download"],
  ["complete", "check_circle"],
  ["copy", "content_copy"],
  ["credit-score", "credit_score"],
  ["criteria-not-met", "radio_button_unchecked"],
  ["descending", "arrow_downward"],
  ["envelope", "mail"],
  ["exclamation", "priority_high"],
  ["exclamation-triangle", "warning_amber"],
  ["expand-less", "expand_less"],
  ["expand-more", "expand_more"],
  ["external-link", "launch"],
  ["feedback", "feed"],
  ["file-download", "save_alt"],
  ["filter", "tune"],
  ["finalize-auction", "priority_high"],
  ["flash-off", "flash_off"],
  ["grid", "grid_view"],
  ["highest-bidder", "keyboard_double_arrow_up"],
  ["incomplete-clear", "cancel"],
  ["info", "info_outline"],
  ["large-card", "view_agenda"],
  ["live-appraisal", "podcasts"],
  ["location", "location_on"],
  ["market-report", "multiline_chart"],
  ["marketplace", "store"],
  ["md-info", "info"],
  ["md-merge", "merge"],
  ["md-save", "save"],
  ["md-sort", "sort"],
  ["merge", "call_merge"],
  ["more-horiz", "more_horiz"],
  ["more-vert", "more_vert"],
  ["my-acv", "directions_car"],
  ["near-reserve", "trending_up"],
  ["new-auction", "gavel"],
  ["notification", "public"],
  ["offer-recieved", "mail"],
  ["offer-sent", "send"],
  ["outbid", "keyboard_double_arrow_down"],
  ["paper-plane", "send"],
  ["payment", "credit_card"],
  ["pending-proxy", "keyboard_double_arrow_right"],
  ["play", "play_arrow"],
  ["plus", "add"],
  ["price-check", "price_check"],
  ["qr-code-scanner", "qr_code_scanner"],
  ["question", "help"],
  ["redo-alt", "refresh"],
  ["report-a-problem", "warning_amber"],
  ["reserve-met", "check"],
  ["save-solid", "bookmark"],
  ["save", "bookmark_border"],
  ["select", "unfold_more"],
  ["selling", "attach_money"],
  ["show-chart", "show_chart"],
  ["sort", "swap_vert"],
  ["spinner", "refresh"],
  ["success-message", "check_circle_outline"],
  ["timer", "schedule"],
  ["vehicle", "directions_car"],
  ["viewed", "visibility"],
  ["volume-off", "volume_off"],
  ["volume-on", "volume_up"],
  ["watchlist", "favorite_border"],
  ["watchlisted", "favorite"],
  ["won", "emoji_events"],
  ["zoom-in", "zoom_in"],
  ["zoom-out", "zoom_out"]
], x1 = {
  name: "AcvIcon",
  props: {
    icon: {
      type: String,
      required: !0
    },
    iconStyle: {
      type: String,
      default: "round",
      validator(i) {
        return wt(i, [
          "round",
          "outlined"
        ]);
      }
    },
    /**
     * Flag to trigger condition met and animation
     */
    animateIcon: {
      type: Boolean,
      default: !1
    },
    /**
    * Spins the icon
    */
    spin: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      // Maps ACV design system icon names to md names
      iconMap: new Map(_1)
    };
  },
  computed: {
    selectedClass() {
      return {
        spin: this.spin,
        "material-icons-round": this.iconStyle === "round",
        "material-icons-outlined": this.iconStyle === "outlined"
      };
    },
    mappedName() {
      return this.iconMap.get(this.icon) || this.icon;
    }
  }
};
var C1 = function() {
  var t = this, e = t._self._c;
  return e("div", t._g({ class: ["acv-icon", t.selectedClass] }, t.$listeners), [t.animateIcon ? e("div", { class: ["acv-icon-container__icon-container"] }, [e("div", { class: ["acv-icon-container__icon-animation"] }, [e("span", [t._v(" " + t._s(t.mappedName) + " ")])])]) : e("span", [t._v(" " + t._s(t.mappedName) + " ")])]);
}, S1 = [], w1 = /* @__PURE__ */ U(
  x1,
  C1,
  S1,
  !1,
  null,
  "78622975"
);
const ie = w1.exports, Ie = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ie
}, Symbol.toStringTag, { value: "Module" })), k1 = {
  name: "AcvBanner",
  components: {
    AcvButton: bi,
    AcvIcon: ie
  },
  props: {
    /**
    * Banner variant style
    */
    variant: {
      type: String,
      default: "caution",
      validator(i) {
        return wt(i, [
          "caution",
          "success",
          "informational",
          "error"
        ]);
      }
    },
    /**
    * Content body
    */
    content: {
      type: [Number, String],
      default: ""
    },
    /**
    * Content for button
    */
    buttonContent: {
      type: [Number, String],
      default: ""
    },
    /**
     * Banner icon
     */
    icon: {
      type: String,
      default: ""
    },
    /**
     * Banner borders
     */
    borders: {
      type: Boolean,
      default: !0
    },
    /**
     * Icon outlines
     */
    iconOutline: {
      type: Boolean,
      default: !0
    }
  },
  computed: {
    computedClasses() {
      return {
        [`acv-banner--${this.variant}`]: !0,
        "has-button": this.hasButton,
        "acv-banner--no-borders": !this.borders,
        "acv-banner--no-icon-outline": !this.iconOutline
      };
    },
    computedIconType() {
      if (this.icon)
        return this.icon;
      switch (this.variant) {
        case "caution":
        case "error":
          return "caution-message";
        case "success":
          return "success-message";
        case "informational":
          return "info";
        default:
          return "caution-message";
      }
    },
    hasButton() {
      return !!this.$slots.button || this.buttonContent;
    }
  },
  methods: {
    handleBannerAction(i) {
      this.$emit("banner-button-click", i);
    }
  }
};
var O1 = function() {
  var t = this, e = t._self._c;
  return e("div", { class: ["acv-banner", t.computedClasses] }, [e("div", { staticClass: "acv-banner__content" }, [t._t("icon", function() {
    return [e("acv-icon", { staticClass: "acv-banner__icon", attrs: { icon: t.computedIconType } })];
  }), e("div", { staticClass: "acv-banner__information" }, [t._t("default", function() {
    return [t._v(" " + t._s(t.content) + " ")];
  })], 2)], 2), t._t("additional-checks"), t.hasButton ? e("acv-button", { staticClass: "acv-banner__button", attrs: { slot: "button", variant: "link" }, on: { click: t.handleBannerAction }, slot: "button" }, [e("span", [t._v(t._s(t.buttonContent))])]) : t._e()], 2);
}, M1 = [], T1 = /* @__PURE__ */ U(
  k1,
  O1,
  M1,
  !1,
  null,
  "bd324d87"
);
const Qd = T1.exports, D1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Qd
}, Symbol.toStringTag, { value: "Module" })), P1 = {
  name: "AcvBottomNavigation",
  components: {
    AcvBadge: xa,
    AcvIcon: ie
  },
  props: {
    /**
    * Array of items consisting of:
    * <br/>
    * - `iconType`<br/>
    * - `displayName`<br/>
    * - `name` <br/>
    * - `count` - shows the badge counter beside the icon <br/>
    * - `badgeMini` - shows the badge as mini <br/>
    * - `path` - if using withRouter <br/>
    * - `class` - give button a custom class <br/>
    * - `fuzzy` - allows fuzzy matching for item name being part of active item <br/>
    * <br/>
    * Each item renders a `slot` as well by their name property in
    * lower case separated with dashes ending with section and provides slot props
    */
    items: {
      type: Array,
      default: () => []
    },
    /**
    * Item to preselect the bottom navigation with on mount
    */
    defaultItem: {
      type: String,
      default: ""
    },
    /**
    * Determines if the component use vue-router to render `router-links` and
    * use the `path` and `name` from the item's vue router route
    */
    withRouter: {
      type: Boolean,
      default: !1
    },
    /**
    * Shows the label only on the active item
    */
    showOnlyActiveLabel: {
      type: Boolean,
      default: !1
    }
  },
  data: () => ({
    active: ""
  }),
  computed: {
    activeItem: {
      get() {
        return this.active || this.defaultItem;
      },
      set(i) {
        this.active = i;
      }
    }
  },
  methods: {
    componentRender(i) {
      return i.preventRouting ? "div" : this.withRouter ? "router-link" : "div";
    },
    handleRoutingClickEvent(i) {
      return i.name === this.$route.name ? "click.native.prevent" : "click";
    },
    formattedItemName(i) {
      return i.displayName || i.name;
    },
    slotName(i) {
      return `${i.name.toLowerCase().replace(" ", "-")}-section`;
    },
    iconSlotName(i) {
      return `${i.name.toLowerCase().replace(" ", "-")}-section-icon`;
    },
    isActive(i) {
      return i.fuzzy ? this.activeItem.toLowerCase().includes(i.name.toLowerCase()) : this.activeItem.toLowerCase() === i.name.toLowerCase();
    },
    setActiveItem(i) {
      this.activeItem = i.name, this.$emit("item-click", { name: i.name });
    }
  }
};
var L1 = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "acv-bottom-navigation" }, [e("div", { staticClass: "acv-bottom-navigation__content", class: {
    "only-active-label": t.showOnlyActiveLabel
  } }, t._l(t.items, function(n, s) {
    return e("button", { key: s, staticClass: "acv-bottom-navigation__item ripple", class: [n.class, {
      "acv-bottom-navigation__item--active": t.isActive(n)
    }], attrs: { "aria-label": t.formattedItemName(n), type: "button" }, on: { click: function(r) {
      return t.setActiveItem(n);
    } } }, [e(t.componentRender(n), { tag: "component", attrs: { to: t.withRouter && n.path, event: t.withRouter && t.handleRoutingClickEvent(n) } }, [t._t(t.slotName(n), function() {
      return [e("div", { staticClass: "acv-bottom-navigation__item__icon-area" }, [t._t(t.iconSlotName(n), function() {
        return [n.iconType ? e("acv-icon", { staticClass: "acv-bottom-navigation__item__icon", attrs: { icon: n.iconType } }) : t._e()];
      }), n.count ? e("acv-badge", { attrs: { content: n.count, mini: n.badgeMini } }) : t._e()], 2), e("span", { staticClass: "acv-bottom-navigation__item__content" }, [t._v(" " + t._s(t.formattedItemName(n)) + " ")]), e("span", { staticClass: "sr-only" }, [t._v(t._s(t.formattedItemName(n)))])];
    }, { item: n, activeItem: t.activeItem })], 2)], 1);
  }), 0)]);
}, I1 = [], E1 = /* @__PURE__ */ U(
  P1,
  L1,
  I1,
  !1,
  null,
  "bf2fa81d"
);
const $1 = E1.exports;
var hi = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function as(i) {
  return i && i.__esModule && Object.prototype.hasOwnProperty.call(i, "default") ? i.default : i;
}
var pn = Ti;
pn = "default" in pn ? pn.default : pn;
var B1 = "2.2.2", R1 = /^2\./.test(pn.version);
R1 || pn.util.warn("VueClickaway " + B1 + " only supports Vue 2.x, and does not support Vue " + pn.version);
var Un = "_vue_clickaway_handler";
function Dc(i, t, e) {
  Jd(i, t);
  var n = e.context, s = t.value;
  if (typeof s == "function") {
    var r = !1;
    setTimeout(function() {
      r = !0;
    }, 0), i[Un] = function(a) {
      var o = a.path || (a.composedPath ? a.composedPath() : void 0);
      if (r && (o ? o.indexOf(i) < 0 : !i.contains(a.target)))
        return s.call(n, a);
    }, t.arg ? document.documentElement.addEventListener(t.arg, i[Un], !1) : document.documentElement.addEventListener("click", i[Un], !1);
  }
}
function Jd(i, t) {
  t.arg ? document.documentElement.removeEventListener(t.arg, i[Un], !1) : document.documentElement.removeEventListener("click", i[Un], !1), delete i[Un];
}
var F1 = {
  bind: Dc,
  update: function(i, t, e) {
    t.value !== t.oldValue && Dc(i, t, e);
  },
  unbind: Jd
}, On = F1;
const N1 = {
  name: "AcvTooltip",
  props: {
    /**
    * The target element CSS selector
    */
    target: {
      type: String,
      default: ""
    },
    /**
    * Where the tooltip should appear in relation to the target element
    */
    position: {
      type: String,
      default: "bottom",
      validator(i) {
        return wt(i, ["top", "right", "bottom", "left"]);
      }
    },
    /**
    * The value in pixels to add to the top positioning
    */
    topOffset: {
      type: Number,
      default: 0
    },
    /**
    * Changes tooltip position to be absolute. Useful for tooltips in containers
    * with transformation translation stylings
    */
    absolutePositioned: {
      type: Boolean,
      default: !1
    },
    /**
    * The value in pixels to add to the left positioning
    */
    leftOffset: {
      type: Number,
      default: 0
    },
    /**
    * The z-index value that would be applied to the tooltip
    */
    zIndex: {
      type: Number,
      default: 100
    },
    /**
    * Prevents wrapping of the tooltip content
    */
    preventWrap: {
      type: Boolean,
      default: !1
    },
    /**
     * Changes the styling of the tooltip according to the desired variant style.
     */
    variant: {
      type: String,
      default: "dark",
      validator(i) {
        return wt(i, ["dark", "light"]);
      }
    },
    /**
     * Changes the type of corner used in the tooltip
     * When true the rounded corner variant will be used otherwise straight corners.
     */
    roundedCorner: {
      type: Boolean,
      default: !0
    }
  },
  data() {
    return {
      visible: !1,
      targetElement: null,
      tooltipContentsStyles: {
        position: "fixed",
        zIndex: this.zIndex
      }
    };
  },
  computed: {
    tooltipContentElement() {
      return document.querySelector(`#${this.tooltipId} .tooltip-content`);
    },
    tooltipId() {
      return `acv-${this._uid}-tooltip`;
    },
    tooltipClasses() {
      return {
        "tooltip-content-container-row": ["left", "right"].includes(this.position),
        "tooltip-content-container-column": ["top", "bottom"].includes(this.position),
        "tooltip-content-container-dark": this.variant === "dark",
        "tooltip-content-container-light": this.variant === "light",
        "tooltip-content-container-rounded-corner": this.roundedCorner,
        "no-wrap": this.preventWrap,
        visible: this.visible
      };
    }
  },
  watch: {
    target() {
      this.initialize();
    }
  },
  mounted() {
    this.initialize();
  },
  destroyed() {
    this.removeListeners();
  },
  methods: {
    initialize() {
      const i = this.target;
      i && (this.targetElement = document.querySelector(i)), this.targetElement, this.removeListeners(), this.addListeners();
    },
    calculateTooltipContentsStyles() {
      const i = {};
      if (this.targetElement && this.tooltipContentElement) {
        const t = this.targetElement.getBoundingClientRect(), e = this.tooltipContentElement.getBoundingClientRect(), {
          height: n,
          top: s,
          width: r,
          left: a
        } = t, {
          height: o,
          width: l
        } = e;
        let c = 0, u = 0, d = 0, h = 0;
        if (["bottom", "top"].includes(this.position) && (c = s, u = n, d = a, h = r), this.absolutePositioned && (i.position = "absolute"), ["bottom", "top"].includes(this.position)) {
          const f = this.absolutePositioned ? 0 : d;
          i.left = this.absolutePositioned ? `${f + h / 2 - l / 2 + this.leftOffset}px` : `${f + h / 2 - l / 2 + this.leftOffset}px`;
        }
        switch (["left", "right"].includes(this.position) && (i.top = this.absolutePositioned ? `${0 - n + this.topOffset - 5}px` : `${s - o / 2 + n / 2 + this.topOffset}px`), this.position) {
          case "top": {
            const f = this.absolutePositioned ? 0 - u : c;
            i.top = this.absolutePositioned ? `${f - o + this.topOffset - 4}px` : `${f - o + this.topOffset - 4}px`;
            break;
          }
          case "right": {
            const f = this.absolutePositioned ? 0 : a;
            i.left = this.absolutePositioned ? `${f + r + this.leftOffset + 5}px` : `${f + r + this.leftOffset + 5}px`;
            break;
          }
          case "bottom": {
            const f = this.absolutePositioned ? 0 : c + u;
            i.top = this.absolutePositioned ? `${f + this.topOffset + 4}px` : `${f + this.topOffset + 4}px`;
            break;
          }
          case "left": {
            const f = this.absolutePositioned ? 0 : a;
            i.left = this.absolutePositioned ? `${f - l + this.leftOffset - 5}px` : `${f - l + this.leftOffset - 5}px`;
            break;
          }
        }
      }
      return i;
    },
    addListeners() {
      this.targetElement && (this.targetElement.addEventListener("mouseenter", this.setVisible), this.targetElement.addEventListener("mouseleave", this.setNotVisible));
    },
    removeListeners() {
      this.targetElement && (this.targetElement.removeEventListener("mouseenter", this.setVisible), this.targetElement.removeEventListener("mouseleave", this.setNotVisible));
    },
    setVisible() {
      this.tooltipContentsStyles = {
        ...this.tooltipContentsStyles,
        ...this.calculateTooltipContentsStyles()
      }, this.visible = !0;
    },
    setNotVisible() {
      this.visible = !1;
    }
  }
};
var H1 = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "acv-tooltip", class: { "absolute-positioned": t.absolutePositioned } }, [e("div", { staticClass: "tooltip-content-container", class: [t.tooltipClasses], style: t.tooltipContentsStyles, attrs: { id: t.tooltipId } }, [e("div", { staticClass: "tooltip-content" }, [t._t("default")], 2)])]);
}, V1 = [], z1 = /* @__PURE__ */ U(
  N1,
  H1,
  V1,
  !1,
  null,
  "286905e3"
);
const os = z1.exports, j1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: os
}, Symbol.toStringTag, { value: "Module" })), W1 = {
  name: "AcvIconButton",
  components: {
    AcvIcon: () => Promise.resolve().then(() => Ie),
    AcvTooltip: os
  },
  inheritAttrs: !1,
  props: {
    /**
    * Icon shown within the button
    */
    iconType: {
      type: String,
      default: ""
    },
    /**
    * Button classes
    */
    buttonClasses: {
      type: [String, Object, Array],
      default: ""
    },
    /**
    * Disables the button
    */
    disabled: {
      type: Boolean,
      default: !1
    },
    /**
    * Determines if a tooltip should be shown for the target element
    */
    showTooltip: {
      type: Boolean,
      default: !0
    },
    /**
    * Where the tooltip should appear in relation to the target element
    */
    position: {
      type: String,
      default: "bottom"
    },
    /**
    * The value in pixels to add to the top positioning
    */
    topOffset: {
      type: Number,
      default: 0
    },
    /**
    * The value in pixels to add to the left positioning
    */
    leftOffset: {
      type: Number,
      default: 0
    },
    /**
    * The z-index value that would be applied to the tooltip
    */
    zIndex: {
      type: Number,
      default: 100
    },
    /**
    * Aria label for the icon button
    */
    ariaLabel: {
      type: String,
      default: ""
    }
  },
  computed: {
    inputId() {
      return this.$attrs.id || this.id || `${this.$options.name}-${this._uid}`;
    },
    inputListeners() {
      return {
        ...this.$listeners,
        click: (i) => {
          this.$emit("click", i), this.$refs[`icon-button-${this.inputId}`].blur();
        }
      };
    }
  },
  watch: {
    disabled(i, t) {
      i && !t && this.setNotVisibleTooltip();
    }
  },
  methods: {
    setNotVisibleTooltip() {
      this.$refs.tooltip && this.$refs.tooltip.setNotVisible();
    }
  }
};
var Y1 = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "acv-icon-button__container" }, [e("button", t._g(t._b({ ref: `icon-button-${t.inputId}`, class: ["acv-icon-button ripple", t.buttonClasses, `acv-icon-button--${t.inputId}`], attrs: { disabled: t.disabled, "aria-label": t.ariaLabel || t.iconType, type: "button" } }, "button", t.$attrs, !1), t.inputListeners), [t._t("icon", function() {
    return [t.iconType ? e("acv-icon", { staticClass: "acv-icon-button__icon", attrs: { icon: t.iconType } }) : t._e()];
  })], 2), t.showTooltip ? e("acv-tooltip", { ref: "tooltip", attrs: { position: t.position, "top-offset": t.topOffset, "left-offset": t.leftOffset, "z-index": t.zIndex, target: `.acv-icon-button--${t.inputId}`, "prevent-wrap": "" } }, [t._t("default")], 2) : t._e()], 1);
}, U1 = [], Z1 = /* @__PURE__ */ U(
  W1,
  Y1,
  U1,
  !1,
  null,
  "5347bd96"
);
const Ee = Z1.exports, xl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ee
}, Symbol.toStringTag, { value: "Module" })), G1 = {
  name: "AcvBottomSheet",
  components: {
    AcvIconButton: Ee,
    AcvButton: bi
  },
  directives: {
    onClickaway: On
  },
  props: {
    /**
    * Expanded state of the bottom sheet
    */
    value: {
      type: Boolean,
      default: !1
    },
    /**
    * Makes the drawer section rounded corners
    */
    round: {
      type: Boolean,
      default: !0
    },
    /**
    * Header text for the header area
    */
    header: {
      type: String,
      default: ""
    },
    /**
    * Show icon in header area
    */
    showHeaderIcon: {
      type: Boolean,
      default: !1
    },
    /**
    * Allow clickaway to collapse an expanded sheet
    */
    clickAwayEnabled: {
      type: Boolean,
      default: !1
    },
    /**
    * Shows a done button at the bottom of the sheet
    */
    showDoneButton: {
      type: Boolean,
      default: !1
    },
    /**
    * Text content for Done button
    */
    doneButtonText: {
      type: String,
      default: ""
    },
    /**
    * Shows the handle while collapsed
    */
    hasHandleLip: {
      type: Boolean,
      default: !1
    },
    /**
    * Additional drawer classes
    */
    drawerClasses: {
      type: [String, Object, Array],
      default: ""
    },
    /**
    * Additional handle classes
    */
    handleClasses: {
      type: [String, Object, Array],
      default: ""
    },
    /**
    * Additional header classes
    */
    headerClasses: {
      type: [String, Object, Array],
      default: ""
    },
    /**
    * Additional content classes
    */
    contentClasses: {
      type: [String, Object, Array],
      default: ""
    }
  },
  computed: {
    expanded: {
      get() {
        return this.value;
      },
      set(i) {
        this.$emit("input", i);
      }
    },
    computedDrawerClasses() {
      return {
        "acv-bottom-sheet__drawer--round": this.round,
        "acv-bottom-sheet__drawer--collapsed": !this.expanded,
        "acv-bottom-sheet__drawer--expanded": this.expanded,
        "has-handle-lip": this.hasHandleLip,
        "has-header": this.hasHeader
      };
    },
    hasHeader() {
      return !!this.$slots.header || this.header;
    },
    hasDoneButton() {
      return !!this.$slots["done-button"] || this.showDoneButton;
    },
    listeners() {
      return {
        ...this.$listeners,
        click: () => {
          this.toggleExpansion();
        }
      };
    }
  },
  methods: {
    toggleExpansion() {
      this.expanded = !this.value;
    },
    handleClickAway() {
      this.expanded && this.clickAwayEnabled && this.toggleExpansion();
    },
    handleDoneButtonClick(i) {
      this.toggleExpansion(), this.$emit("done-button-clicked", i);
    }
  }
};
var K1 = function() {
  var t = this, e = t._self._c;
  return e("div", { directives: [{ name: "on-clickaway", rawName: "v-on-clickaway:mousedown", value: t.handleClickAway, expression: "handleClickAway", arg: "mousedown" }], staticClass: "acv-bottom-sheet" }, [e("div", { staticClass: "acv-bottom-sheet__drawer", class: [t.computedDrawerClasses, t.drawerClasses] }, [e("div", t._g({ staticClass: "acv-bottom-sheet__drawer-handle", class: t.handleClasses }, t.listeners), [e("button", { staticClass: "acv-bottom-sheet__drawer-handle-button", attrs: { "aria-label": "Open / Close Sheet", type: "button" } }), e("div", { staticClass: "acv-bottom-sheet__drawer-handle-header", class: [t.headerClasses, { "has-header": t.hasHeader }] }, [e("h6", [t._t("header", function() {
    return [t._v(" " + t._s(t.header) + " ")];
  })], 2), t.showHeaderIcon && t.hasHeader ? [t._t("header-icon", function() {
    return [e("acv-icon-button", { staticClass: "acv-bottom-sheet__drawer-handle-header-icon", attrs: { "icon-type": t.expanded ? "expand-less" : "expand-more", "show-tooltip": !1 } })];
  })] : t._e()], 2)]), e("div", { staticClass: "acv-bottom-sheet__drawer-content", class: [t.contentClasses, {
    "has-header": t.hasHeader,
    "has-button": t.hasDoneButton
  }] }, [t._t("default")], 2), t.hasDoneButton ? [e("div", { staticClass: "acv-bottom-sheet__drawer-done", class: { "has-header": t.hasHeader } }, [t._t("done-button", function() {
    return [e("acv-button", { attrs: { variant: "primary" }, on: { click: function(n) {
      return t.handleDoneButtonClick(n);
    } } }, [t._v(" " + t._s(t.doneButtonText || "Done") + " ")])];
  })], 2)] : t._e()], 2)]);
}, X1 = [], Q1 = /* @__PURE__ */ U(
  G1,
  K1,
  X1,
  !1,
  null,
  "3044a561"
);
const J1 = Q1.exports, q1 = {
  bgLight: {
    type: [Boolean, String],
    default: !1
  },
  bgWhite: {
    type: [Boolean, String],
    default: !1
  },
  bgTransparent: {
    type: [Boolean, String],
    default: !1
  },
  bgDarkMode: {
    type: [Boolean, String],
    default: !1
  },
  bgOrange: {
    type: [Boolean, String],
    default: !1
  }
}, tm = {
  backgroundClasses() {
    return {
      "bg-light": this.bgLight === !0 || this.bgLight === "true",
      "bg-white": this.bgWhite === !0 || this.bgWhite === "true",
      "bg-transparent": this.bgTransparent === !0 || this.bgTransparent === "true",
      "bg-dark-mode": this.bgDarkMode === !0 || this.bgDarkMode === "true",
      "bg-orange": this.bgOrange === !0 || this.bgOrange === "true"
    };
  }
}, yi = {
  props: q1,
  computed: tm
}, em = {
  borderTop: {
    type: [Boolean, String],
    default: !1
  },
  elevated: {
    type: [Boolean, String],
    default: !1
  },
  flat: {
    type: [Boolean, String],
    default: !1
  },
  outlined: {
    type: [Boolean, String],
    default: !1
  },
  tile: {
    type: [Boolean, String],
    default: !1
  }
}, im = {
  borderClasses() {
    return {
      "primary-top-border": this.borderTop === "primary" || this.borderTop === !0,
      "secondary-top-border": this.borderTop === "secondary",
      elevated: this.elevated === !0 || this.elevated === "true",
      flat: this.flat === !0 || this.flat === "true",
      outlined: this.outlined === !0 || this.outlined === "true",
      title: this.tile === !0 || this.tile === "true"
    };
  }
}, Mn = {
  props: em,
  computed: im
}, nm = {
  activeClass: {
    type: String,
    default: ""
  },
  exactActiveClass: {
    type: String,
    default: ""
  },
  href: {
    type: String,
    default: ""
  },
  link: {
    type: Boolean,
    default: !1
  },
  to: {
    type: [Object, String],
    default: void 0
  },
  target: {
    type: String,
    default: void 0
  }
}, sm = {
  navigationTag() {
    return this.to ? "router-link" : this.href ? "a" : "";
  },
  navigationBindings() {
    switch (this.navigationTag) {
      case "router-link":
        return {
          to: this.to,
          activeClass: this.activeClass,
          exactActiveClass: this.exactActiveClass
        };
      case "a":
        return {
          href: this.href,
          target: this.target
        };
      default:
        return {};
    }
  },
  navigationClasses() {
    return {
      "--link": this.link
    };
  }
}, qd = {
  props: nm,
  computed: sm
}, rm = {
  height: {
    type: [Number, String],
    default: void 0
  },
  width: {
    type: [Number, String],
    default: void 0
  },
  full: {
    type: [String, Boolean],
    default: void 0
  },
  maxHeight: {
    type: [Number, String],
    default: void 0
  },
  maxWidth: {
    type: [Number, String],
    default: void 0
  },
  minHeight: {
    type: [Number, String],
    default: void 0
  },
  minWidth: {
    type: [Number, String],
    default: void 0
  },
  margin: {
    type: [Number, String],
    default: void 0
  },
  marginBottom: {
    type: [Number, String],
    default: void 0
  },
  marginLeft: {
    type: [Number, String],
    default: void 0
  },
  marginRight: {
    type: [Number, String],
    default: void 0
  },
  marginTop: {
    type: [Number, String],
    default: void 0
  },
  marginVertical: {
    type: [Number, String],
    default: void 0
  },
  marginHorizontal: {
    type: [Number, String],
    default: void 0
  },
  padding: {
    type: [Number, String],
    default: void 0
  },
  paddingBottom: {
    type: [Number, String],
    default: void 0
  },
  paddingLeft: {
    type: [Number, String],
    default: void 0
  },
  paddingRight: {
    type: [Number, String],
    default: void 0
  },
  paddingTop: {
    type: [Number, String],
    default: void 0
  },
  paddingVertical: {
    type: [Number, String],
    default: void 0
  },
  paddingHorizontal: {
    type: [Number, String],
    default: void 0
  }
}, am = () => ({
  sizeMap: {
    small: "15px",
    medium: "30px",
    large: "60px"
  }
}), om = {
  /**
   * Inline style object for sizing.
  */
  sizeStyles() {
    return {
      ...this.sizeObject,
      ...this.marginObject,
      ...this.paddingObject
    };
  },
  /**
   * Object containing all sizing values.
  */
  sizeObject() {
    const i = {
      height: this.height,
      width: this.width,
      minHeight: this.minHeight,
      maxHeight: this.maxHeight,
      minWidth: this.minWidth,
      maxWidth: this.maxWidth
    };
    return this.full === !0 ? (i.width = "100%", i.height = "100%") : this.full === "vertical" ? i.height = "100%" : this.full === "horizontal" && (i.width = "100%"), this.formatStyleObject(i), i;
  },
  /**
   * Object containing all margin values.
  */
  marginObject() {
    const i = {
      margin: this.margin,
      marginLeft: this.marginLeft,
      marginRight: this.marginRight,
      marginTop: this.marginTop,
      marginBottom: this.marginBottom
    };
    return this.marginVertical && (i.marginTop = this.marginVertical, i.marginBottom = this.marginVertical), this.marginHorizontal && (i.marginLeft = this.marginHorizontal, i.marginRight = this.marginHorizontal), this.formatStyleObject(i), i;
  },
  /**
   * Object containing all padding values for the Flexbox.
  */
  paddingObject() {
    const i = {
      padding: this.padding,
      paddingLeft: this.paddingLeft,
      paddingRight: this.paddingRight,
      paddingTop: this.paddingTop,
      paddingBottom: this.paddingBottom
    };
    return this.paddingVertical && (i.paddingTop = this.paddingVertical, i.paddingBottom = this.paddingVertical), this.paddingHorizontal && (i.paddingLeft = this.paddingHorizontal, i.paddingRight = this.paddingHorizontal), this.formatStyleObject(i), i;
  }
}, lm = {
  /**
   * Converts a prop into a size CSS property
   */
  getSize(i) {
    return i in this.sizeMap ? this.sizeMap[i] : i;
  },
  stringEndsWithValidCssUnit(i) {
    return i.endsWith("px") || i.endsWith("%") || i.endsWith("vh") || i.endsWith("vw") || i.endsWith("em") || i.endsWith("rem");
  },
  formatStyleObject(i) {
    const t = i;
    Object.keys(t).forEach((e) => {
      typeof t[e] == "number" ? t[e] = `${t[e]}px` : typeof t[e] == "string" && t[e].length ? (typeof parseInt(t[e], 10) == "number" && !this.stringEndsWithValidCssUnit(t[e]) && (t[e] = `${t[e]}px`), t[e] = this.getSize(t[e])) : delete t[e];
    });
  }
}, fe = {
  props: rm,
  data: am,
  computed: om,
  methods: lm
}, cm = {
  name: "AcvCard",
  mixins: [
    yi,
    Mn,
    qd,
    fe
  ],
  props: {
    tag: {
      type: String,
      default: "div"
    },
    bgWhite: {
      type: [Boolean, String],
      default: !0
    },
    elevated: {
      type: [Boolean, String],
      default: !0
    }
  },
  computed: {
    is() {
      return this.navigationTag ? this.navigationTag : this.tag;
    },
    bindings() {
      return {
        ...this.navigationBindings
      };
    },
    classes() {
      return {
        ...this.borderClasses,
        ...this.navigationProperties,
        ...this.backgroundClasses
      };
    }
  }
};
var um = function() {
  var t = this, e = t._self._c;
  return e(t.is, t._b({ tag: "component", staticClass: "acv-card", class: t.classes, style: [t.sizeStyles], on: { click: function(n) {
    return t.$emit("click", n);
  } } }, "component", t.bindings, !1), [t._t("default")], 2);
}, dm = [], hm = /* @__PURE__ */ U(
  cm,
  um,
  dm,
  !1,
  null,
  "ae98f17a"
);
const th = hm.exports, fm = {
  fontSize: {
    type: [Number, String],
    default: void 0
  },
  fontWeight: {
    type: [Number, String],
    default: void 0
  },
  lineHeight: {
    type: [Number, String],
    default: void 0
  },
  color: {
    type: String,
    default: void 0
  },
  uppercase: {
    type: Boolean,
    default: !1
  }
}, pm = {
  fontStyles() {
    const i = !this.fontSize || Number.isNaN(this.fontSize) ? this.fontSize : `${parseInt(this.fontSize, 10)}px`, t = !this.lineHeight || Number.isNaN(this.lineHeight) ? this.lineHeight : `${parseInt(this.lineHeight, 10)}px`;
    return {
      fontSize: i,
      fontWeight: this.fontWeight,
      lineHeight: t,
      color: this.color
    };
  },
  fontClasses() {
    return {
      uppercase: this.uppercase
    };
  }
}, en = {
  props: fm,
  computed: pm
}, gm = {
  name: "AcvCardSubtitle",
  mixins: [
    en,
    fe
  ]
};
var mm = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "acv-card-subtitle", class: t.fontClasses, style: [t.fontStyles, t.sizeStyles] }, [t._t("default")], 2);
}, vm = [], Am = /* @__PURE__ */ U(
  gm,
  mm,
  vm,
  !1,
  null,
  "35868863"
);
const bm = Am.exports, ym = {
  name: "AcvCardText",
  mixins: [
    en,
    fe
  ]
};
var _m = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "acv-card-text", class: t.fontClasses, style: [t.fontStyles, t.sizeStyles] }, [t._t("default")], 2);
}, xm = [], Cm = /* @__PURE__ */ U(
  ym,
  _m,
  xm,
  !1,
  null,
  "a1781b0c"
);
const Sm = Cm.exports, wm = {
  name: "AcvCardTitle",
  mixins: [
    en,
    fe
  ]
};
var km = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "acv-card-title", class: t.fontClasses, style: [t.fontStyles, t.sizeStyles] }, [t._t("default")], 2);
}, Om = [], Mm = /* @__PURE__ */ U(
  wm,
  km,
  Om,
  !1,
  null,
  "0635b120"
);
const Tm = Mm.exports, Dm = {
  name: "AcvChip",
  components: {
    AcvIcon: () => Promise.resolve().then(() => Ie),
    AcvIconButton: () => Promise.resolve().then(() => xl)
  },
  props: {
    /**
    * For the chip bar, so we can have a seamless transition between chips
    */
    chipBarStyles: {
      type: Boolean,
      default: !1
    },
    /**
    * For the chip bar, so we can have chip(s) "selected"
    */
    active: {
      type: Boolean,
      default: !1
    },
    /**
    * Icon for the chip
    */
    iconType: {
      type: String,
      default: ""
    },
    /**
     * text content for chip
     */
    label: {
      type: String,
      default: ""
    },
    /**
    * Shows a close icon within the chip
    */
    showClose: {
      type: Boolean,
      default: !1
    },
    /**
    * Makes the chip a solid color w/o outline
    */
    solidBackground: {
      type: Boolean,
      default: !1
    },
    /**
    * Hides the border outline for non-solid bg, non-default variant chips
    */
    hideBorder: {
      type: Boolean,
      default: !1
    },
    /**
    * Disables the chip
    */
    disabled: {
      type: Boolean,
      default: !1
    },
    /**
    * Makes chip more pill-shaped
    */
    rounded: {
      type: Boolean,
      default: !1
    },
    /**
     *  controls the colors
     */
    variant: {
      type: String,
      default: "default",
      validator(i) {
        return wt(
          i,
          [
            "default",
            "informational",
            "success",
            "primary"
          ]
        );
      }
    }
  },
  computed: {
    themeClasses() {
      const i = this.solidBackground ? " acv-chip--solid-bg" : "", t = this.hideBorder && this.variant !== "default" ? " acv-chip--hide-border" : "", e = this.rounded ? " acv-chip--rounded" : "", n = this.chipBarStyles ? " acv-chip--chip-bar-styles" : "", s = this.active ? " acv-chip--active" : "";
      return `acv-chip--${this.variant}${i}${t}${e}${n}${s}`;
    }
  },
  methods: {
    handleClose(i) {
      this.disabled || this.$emit("close", i);
    }
  }
};
var Pm = function() {
  var t = this, e = t._self._c;
  return e("div", t._g({ class: [
    "acv-chip",
    t.themeClasses
  ], attrs: { disabled: t.disabled } }, t.$listeners), [t._t("prepend"), t.iconType ? e("acv-icon", { staticClass: "acv-chip__icon", attrs: { icon: t.iconType } }) : t._e(), e("div", { staticClass: "acv-chip__content" }, [t._t("default", function() {
    return [t._v(" " + t._s(t.label) + " ")];
  })], 2), t.showClose ? e("acv-icon-button", { staticClass: "acv-chip__close", attrs: { "icon-type": "close", "show-tooltip": !1, disabled: t.disabled }, on: { click: function(n) {
    return n.stopPropagation(), n.preventDefault(), t.handleClose.apply(null, arguments);
  } } }) : t._e(), t._t("append")], 2);
}, Lm = [], Im = /* @__PURE__ */ U(
  Dm,
  Pm,
  Lm,
  !1,
  null,
  "0e6e8b93"
);
const Em = Im.exports, $m = {
  name: "AcvCollapse",
  methods: {
    beforeEnter(i) {
      const t = i;
      t.style.height || (t.style.height = "0px");
    },
    enter(i) {
      requestAnimationFrame(() => {
        const t = i;
        t.style.height = `${t.scrollHeight}px`;
      });
    },
    afterEnter(i) {
      const t = i;
      t.style.height = null;
    },
    beforeLeave(i) {
      const t = i;
      t.style.height || (t.style.height = `${t.offsetHeight}px`);
    },
    leave(i) {
      requestAnimationFrame(() => {
        const t = i;
        t.style.height = "0px";
      });
    },
    afterLeave(i) {
      const t = i;
      t.style.height = null;
    }
  }
};
var Bm = function() {
  var t = this, e = t._self._c;
  return e("transition", { attrs: { "enter-active-class": "enter-active", "leave-active-class": "leave-active" }, on: { "before-enter": t.beforeEnter, enter: t.enter, "after-enter": t.afterEnter, "before-leave": t.beforeLeave, leave: t.leave, "after-leave": t.afterLeave } }, [t._t("default")], 2);
}, Rm = [], Fm = /* @__PURE__ */ U(
  $m,
  Bm,
  Rm,
  !1,
  null,
  "75e086e9"
);
const eh = Fm.exports, Nm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: eh
}, Symbol.toStringTag, { value: "Module" }));
var ih = { exports: {} };
(function(i, t) {
  (function(e, n) {
    i.exports = n();
  })(hi, function() {
    var e = 1e3, n = 6e4, s = 36e5, r = "millisecond", a = "second", o = "minute", l = "hour", c = "day", u = "week", d = "month", h = "quarter", f = "year", p = "date", g = "Invalid Date", m = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, v = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, b = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(j) {
      var w = ["th", "st", "nd", "rd"], I = j % 100;
      return "[" + j + (w[(I - 20) % 10] || w[I] || w[0]) + "]";
    } }, _ = function(j, w, I) {
      var T = String(j);
      return !T || T.length >= w ? j : "" + Array(w + 1 - T.length).join(I) + j;
    }, S = { s: _, z: function(j) {
      var w = -j.utcOffset(), I = Math.abs(w), T = Math.floor(I / 60), V = I % 60;
      return (w <= 0 ? "+" : "-") + _(T, 2, "0") + ":" + _(V, 2, "0");
    }, m: function j(w, I) {
      if (w.date() < I.date()) return -j(I, w);
      var T = 12 * (I.year() - w.year()) + (I.month() - w.month()), V = w.clone().add(T, d), N = I - V < 0, z = w.clone().add(T + (N ? -1 : 1), d);
      return +(-(T + (I - V) / (N ? V - z : z - V)) || 0);
    }, a: function(j) {
      return j < 0 ? Math.ceil(j) || 0 : Math.floor(j);
    }, p: function(j) {
      return { M: d, y: f, w: u, d: c, D: p, h: l, m: o, s: a, ms: r, Q: h }[j] || String(j || "").toLowerCase().replace(/s$/, "");
    }, u: function(j) {
      return j === void 0;
    } }, C = "en", O = {};
    O[C] = b;
    var k = "$isDayjsObject", P = function(j) {
      return j instanceof L || !(!j || !j[k]);
    }, x = function j(w, I, T) {
      var V;
      if (!w) return C;
      if (typeof w == "string") {
        var N = w.toLowerCase();
        O[N] && (V = N), I && (O[N] = I, V = N);
        var z = w.split("-");
        if (!V && z.length > 1) return j(z[0]);
      } else {
        var E = w.name;
        O[E] = w, V = E;
      }
      return !T && V && (C = V), V || !T && C;
    }, R = function(j, w) {
      if (P(j)) return j.clone();
      var I = typeof w == "object" ? w : {};
      return I.date = j, I.args = arguments, new L(I);
    }, B = S;
    B.l = x, B.i = P, B.w = function(j, w) {
      return R(j, { locale: w.$L, utc: w.$u, x: w.$x, $offset: w.$offset });
    };
    var L = function() {
      function j(I) {
        this.$L = x(I.locale, null, !0), this.parse(I), this.$x = this.$x || I.x || {}, this[k] = !0;
      }
      var w = j.prototype;
      return w.parse = function(I) {
        this.$d = function(T) {
          var V = T.date, N = T.utc;
          if (V === null) return /* @__PURE__ */ new Date(NaN);
          if (B.u(V)) return /* @__PURE__ */ new Date();
          if (V instanceof Date) return new Date(V);
          if (typeof V == "string" && !/Z$/i.test(V)) {
            var z = V.match(m);
            if (z) {
              var E = z[2] - 1 || 0, H = (z[7] || "0").substring(0, 3);
              return N ? new Date(Date.UTC(z[1], E, z[3] || 1, z[4] || 0, z[5] || 0, z[6] || 0, H)) : new Date(z[1], E, z[3] || 1, z[4] || 0, z[5] || 0, z[6] || 0, H);
            }
          }
          return new Date(V);
        }(I), this.init();
      }, w.init = function() {
        var I = this.$d;
        this.$y = I.getFullYear(), this.$M = I.getMonth(), this.$D = I.getDate(), this.$W = I.getDay(), this.$H = I.getHours(), this.$m = I.getMinutes(), this.$s = I.getSeconds(), this.$ms = I.getMilliseconds();
      }, w.$utils = function() {
        return B;
      }, w.isValid = function() {
        return this.$d.toString() !== g;
      }, w.isSame = function(I, T) {
        var V = R(I);
        return this.startOf(T) <= V && V <= this.endOf(T);
      }, w.isAfter = function(I, T) {
        return R(I) < this.startOf(T);
      }, w.isBefore = function(I, T) {
        return this.endOf(T) < R(I);
      }, w.$g = function(I, T, V) {
        return B.u(I) ? this[T] : this.set(V, I);
      }, w.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, w.valueOf = function() {
        return this.$d.getTime();
      }, w.startOf = function(I, T) {
        var V = this, N = !!B.u(T) || T, z = B.p(I), E = function(Q, ot) {
          var st = B.w(V.$u ? Date.UTC(V.$y, ot, Q) : new Date(V.$y, ot, Q), V);
          return N ? st : st.endOf(c);
        }, H = function(Q, ot) {
          return B.w(V.toDate()[Q].apply(V.toDate("s"), (N ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(ot)), V);
        }, y = this.$W, $ = this.$M, D = this.$D, Z = "set" + (this.$u ? "UTC" : "");
        switch (z) {
          case f:
            return N ? E(1, 0) : E(31, 11);
          case d:
            return N ? E(1, $) : E(0, $ + 1);
          case u:
            var J = this.$locale().weekStart || 0, lt = (y < J ? y + 7 : y) - J;
            return E(N ? D - lt : D + (6 - lt), $);
          case c:
          case p:
            return H(Z + "Hours", 0);
          case l:
            return H(Z + "Minutes", 1);
          case o:
            return H(Z + "Seconds", 2);
          case a:
            return H(Z + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, w.endOf = function(I) {
        return this.startOf(I, !1);
      }, w.$set = function(I, T) {
        var V, N = B.p(I), z = "set" + (this.$u ? "UTC" : ""), E = (V = {}, V[c] = z + "Date", V[p] = z + "Date", V[d] = z + "Month", V[f] = z + "FullYear", V[l] = z + "Hours", V[o] = z + "Minutes", V[a] = z + "Seconds", V[r] = z + "Milliseconds", V)[N], H = N === c ? this.$D + (T - this.$W) : T;
        if (N === d || N === f) {
          var y = this.clone().set(p, 1);
          y.$d[E](H), y.init(), this.$d = y.set(p, Math.min(this.$D, y.daysInMonth())).$d;
        } else E && this.$d[E](H);
        return this.init(), this;
      }, w.set = function(I, T) {
        return this.clone().$set(I, T);
      }, w.get = function(I) {
        return this[B.p(I)]();
      }, w.add = function(I, T) {
        var V, N = this;
        I = Number(I);
        var z = B.p(T), E = function($) {
          var D = R(N);
          return B.w(D.date(D.date() + Math.round($ * I)), N);
        };
        if (z === d) return this.set(d, this.$M + I);
        if (z === f) return this.set(f, this.$y + I);
        if (z === c) return E(1);
        if (z === u) return E(7);
        var H = (V = {}, V[o] = n, V[l] = s, V[a] = e, V)[z] || 1, y = this.$d.getTime() + I * H;
        return B.w(y, this);
      }, w.subtract = function(I, T) {
        return this.add(-1 * I, T);
      }, w.format = function(I) {
        var T = this, V = this.$locale();
        if (!this.isValid()) return V.invalidDate || g;
        var N = I || "YYYY-MM-DDTHH:mm:ssZ", z = B.z(this), E = this.$H, H = this.$m, y = this.$M, $ = V.weekdays, D = V.months, Z = V.meridiem, J = function(ot, st, ft, Rt) {
          return ot && (ot[st] || ot(T, N)) || ft[st].slice(0, Rt);
        }, lt = function(ot) {
          return B.s(E % 12 || 12, ot, "0");
        }, Q = Z || function(ot, st, ft) {
          var Rt = ot < 12 ? "AM" : "PM";
          return ft ? Rt.toLowerCase() : Rt;
        };
        return N.replace(v, function(ot, st) {
          return st || function(ft) {
            switch (ft) {
              case "YY":
                return String(T.$y).slice(-2);
              case "YYYY":
                return B.s(T.$y, 4, "0");
              case "M":
                return y + 1;
              case "MM":
                return B.s(y + 1, 2, "0");
              case "MMM":
                return J(V.monthsShort, y, D, 3);
              case "MMMM":
                return J(D, y);
              case "D":
                return T.$D;
              case "DD":
                return B.s(T.$D, 2, "0");
              case "d":
                return String(T.$W);
              case "dd":
                return J(V.weekdaysMin, T.$W, $, 2);
              case "ddd":
                return J(V.weekdaysShort, T.$W, $, 3);
              case "dddd":
                return $[T.$W];
              case "H":
                return String(E);
              case "HH":
                return B.s(E, 2, "0");
              case "h":
                return lt(1);
              case "hh":
                return lt(2);
              case "a":
                return Q(E, H, !0);
              case "A":
                return Q(E, H, !1);
              case "m":
                return String(H);
              case "mm":
                return B.s(H, 2, "0");
              case "s":
                return String(T.$s);
              case "ss":
                return B.s(T.$s, 2, "0");
              case "SSS":
                return B.s(T.$ms, 3, "0");
              case "Z":
                return z;
            }
            return null;
          }(ot) || z.replace(":", "");
        });
      }, w.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, w.diff = function(I, T, V) {
        var N, z = this, E = B.p(T), H = R(I), y = (H.utcOffset() - this.utcOffset()) * n, $ = this - H, D = function() {
          return B.m(z, H);
        };
        switch (E) {
          case f:
            N = D() / 12;
            break;
          case d:
            N = D();
            break;
          case h:
            N = D() / 3;
            break;
          case u:
            N = ($ - y) / 6048e5;
            break;
          case c:
            N = ($ - y) / 864e5;
            break;
          case l:
            N = $ / s;
            break;
          case o:
            N = $ / n;
            break;
          case a:
            N = $ / e;
            break;
          default:
            N = $;
        }
        return V ? N : B.a(N);
      }, w.daysInMonth = function() {
        return this.endOf(d).$D;
      }, w.$locale = function() {
        return O[this.$L];
      }, w.locale = function(I, T) {
        if (!I) return this.$L;
        var V = this.clone(), N = x(I, T, !0);
        return N && (V.$L = N), V;
      }, w.clone = function() {
        return B.w(this.$d, this);
      }, w.toDate = function() {
        return new Date(this.valueOf());
      }, w.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, w.toISOString = function() {
        return this.$d.toISOString();
      }, w.toString = function() {
        return this.$d.toUTCString();
      }, j;
    }(), Y = L.prototype;
    return R.prototype = Y, [["$ms", r], ["$s", a], ["$m", o], ["$H", l], ["$W", c], ["$M", d], ["$y", f], ["$D", p]].forEach(function(j) {
      Y[j[1]] = function(w) {
        return this.$g(w, j[0], j[1]);
      };
    }), R.extend = function(j, w) {
      return j.$i || (j(w, L, R), j.$i = !0), R;
    }, R.locale = x, R.isDayjs = P, R.unix = function(j) {
      return R(1e3 * j);
    }, R.en = O[C], R.Ls = O, R.p = {}, R;
  });
})(ih);
var Hm = ih.exports;
const Oe = /* @__PURE__ */ as(Hm);
var nh = { exports: {} };
(function(i, t) {
  (function(e, n) {
    i.exports = n();
  })(hi, function() {
    return function(e, n) {
      n.prototype.isSameOrBefore = function(s, r) {
        return this.isSame(s, r) || this.isBefore(s, r);
      };
    };
  });
})(nh);
var Vm = nh.exports;
const zm = /* @__PURE__ */ as(Vm);
Oe.extend(zm);
const jm = {
  name: "AcvDataGrid",
  components: {
    AcvDataPagination: () => Promise.resolve().then(() => rh),
    AcvLabel: () => Promise.resolve().then(() => Ah),
    AcvSelect: () => Promise.resolve().then(() => ah),
    AcvIcon: () => Promise.resolve().then(() => Ie)
  },
  props: {
    rows: {
      type: Array,
      required: !0
    },
    footer: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    columns: {
      type: Array,
      default: () => []
    },
    hideHeader: {
      type: Boolean,
      default: !1
    },
    hideFooter: {
      type: Boolean,
      default: !0
    },
    filterable: {
      type: Boolean,
      default: !0
    },
    sortable: {
      type: Boolean,
      default: !0
    },
    pageSizeOptions: {
      type: Array,
      default: () => [
        { value: 10 },
        { value: 25 },
        { value: 50 },
        { value: 100 }
      ]
    },
    paging: {
      type: String,
      default: "bottom",
      validator(i) {
        return wt(i, [
          "top",
          "bottom",
          "both",
          "none"
        ]);
      }
    },
    pageSizeSelectorLabel: {
      type: String,
      default: "Rows per page:"
    },
    filterTextInputPlaceholder: {
      type: String,
      default: "Enter search terms here..."
    },
    filterText: {
      type: String,
      default: ""
    },
    selectedPageSize: {
      type: Number,
      default: 10
    },
    filterTextWordDelimiter: {
      type: String,
      default: ","
    },
    rowTitleKey: {
      type: String,
      default: ""
    },
    rowTitle: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: !1
    },
    skipSortReset: {
      type: Boolean,
      default: !1
    },
    immediateSortColumn: {
      type: Object,
      default: () => ({})
    },
    showSortIcon: {
      type: Boolean,
      default: !1
    },
    // safety net just in case
    enableSortAsTimestamp: {
      type: Boolean,
      default: !1
    }
  },
  data: () => ({
    rowDataPath: "",
    sortedColumn: null,
    sortOrder: null,
    sortKey: null,
    currentPageNumber: 1,
    internalFilterText: "",
    internalSelectedPageSize: { value: 10 }
  }),
  computed: {
    visibleColumnKeys() {
      return this.visibleColumns.map((i) => i.key);
    },
    visibleColumns() {
      return this.columns.length > 0 ? this.columns.filter((i) => !i.hidden) : this.rows.length ? Object.keys(this.rows[0]).map((i) => ({ key: i })) : [];
    },
    visibleRows() {
      return this.paging !== "none" ? this.sortedFilteredRows.slice(this.currentPageNumberStartIndex, this.nextPageStartIndex) : this.sortedFilteredRows;
    },
    filterableColumns() {
      return this.columns.length > 0 ? this.columns.filter((i) => i.filterable) : this.rows.length ? Object.keys(this.rows[0]).map((i) => ({ key: i })) : [];
    },
    filterableColumnKeys() {
      return this.filterableColumns.map((i) => i.key);
    },
    sortedFilteredRows() {
      let i = [...this.rows];
      return this.internalFilterText && (i = this.filterRows(i)), this.sortedColumn && (i = this.sortRows(i)), i;
    },
    totalVisibleRows() {
      return this.visibleRows.length;
    },
    totalSortedFilteredRows() {
      return this.sortedFilteredRows.length;
    },
    totalRows() {
      return this.rows.length;
    },
    filterTerms() {
      return this.internalFilterText.split(this.filterTextWordDelimiter).map((e) => e.trim()).filter((e) => e.length > 0);
    },
    currentPageNumberStartIndex() {
      return (this.currentPageNumber - 1) * this.internalSelectedPageSize.value;
    },
    nextPageStartIndex() {
      return this.currentPageNumberStartIndex + this.internalSelectedPageSize.value;
    },
    lastPageNumber() {
      return Math.ceil(this.sortedFilteredRows.length / this.internalSelectedPageSize.value) || 1;
    }
  },
  watch: {
    filterText: {
      immediate: !0,
      handler(i) {
        this.internalFilterText = i;
      }
    },
    rows: {
      handler() {
        this.currentPageNumber > this.lastPageNumber && (this.currentPageNumber = this.lastPageNumber);
      }
    },
    selectedPageSize: {
      immediate: !0,
      handler(i, t) {
        this.internalSelectedPageSize = { value: i }, this.handlePageSizeChanged(i, t);
      }
    },
    internalSelectedPageSize: {
      immediate: !0,
      handler(i, t) {
        this.handlePageSizeChanged(i && i.value, t && t.value);
      }
    },
    paging() {
      this.resetSortingFilterPaging();
    },
    filterable() {
      this.resetSortingFilterPaging();
    },
    sortable() {
      this.resetSortingFilterPaging();
    },
    pageSizeOptions() {
      this.resetSortingFilterPaging();
    }
  },
  created() {
    if (Object.keys(this.immediateSortColumn).length) {
      const { columnKey: i, order: t } = this.immediateSortColumn;
      i && ["asc", "desc"].includes(t) && this.setSort(i, t, !1);
    }
  },
  methods: {
    handleHeaderClicked(i, t) {
      this.$emit("headerCellClicked", { column: i, columnIndex: t }), this.setSort(i.key);
    },
    getSortIconForColumn(i) {
      return i.key === this.sortedColumn ? this.sortOrder === "asc" ? "arrow_upward" : "arrow_downward" : this.showSortIcon ? "sort" : "";
    },
    resetSortingFilterPaging() {
      this.currentPageNumber = 1, this.skipSortReset || (this.sortedColumn = null, this.sortOrder = null), this.internalFilterText = "";
    },
    handlePageSizeChanged(i, t) {
      this.currentPageNumber = 1, this.$emit("pageSizeChanged", {
        newPageSize: i,
        previousPageSize: t
      });
    },
    findRowIndex(i) {
      return this.rows.findIndex((t) => i === t);
    },
    setSort(i, t, e = !0) {
      const n = this.visibleColumns.find((s) => s.key === i);
      return !this.sortable || !n.sortable ? !1 : (t !== "asc" && t !== "desc" ? (this.sortedColumn !== n.key && (this.sortOrder = null, this.sortedColumn = null), this.sortedColumn = n.key, this.sortOrder === "asc" ? this.sortOrder = "desc" : this.sortOrder === "desc" ? (this.sortOrder = null, this.sortedColumn = null) : this.sortOrder = "asc") : (this.sortedColumn = n.key, this.sortOrder = t), this.sortKey = n.sortKey, e && this.$emit("sorted", {
        columnClicked: n.key,
        column: this.sortedColumn,
        order: this.sortOrder,
        key: this.sortKey,
        rows: this.sortedFilteredRows
      }), !0);
    },
    sortRows(i) {
      return this.$emit("sort-rows", {
        payload: "inside method"
      }), [...i].sort((n, s) => {
        let r, a;
        const o = this.rowDataPath ? n[this.rowDataPath] : n, l = this.rowDataPath ? s[this.rowDataPath] : s;
        r = this.sortKey ? o[this.sortKey] : o[this.sortedColumn], a = this.sortKey ? l[this.sortKey] : l[this.sortedColumn], r = r || "", a = a || "";
        const d = !!r && typeof r == "string" && (!!a && typeof a == "string");
        let h = !1;
        if (this.enableSortAsTimestamp) {
          const f = Oe(r).isValid(), p = Oe(a).isValid();
          h = !!f && !!p;
        }
        return this.sortOrder === "desc" ? h ? Oe(a).isSameOrBefore(r) ? -1 : 1 : d ? a.localeCompare(r, "en", { sensitivity: "accent", numeric: !0 }) : r > a ? -1 : 1 : this.sortOrder === "asc" ? h ? Oe(r).isSameOrBefore(a) ? -1 : 1 : d ? r.localeCompare(a, "en", { sensitivity: "accent", numeric: !0 }) : r > a ? 1 : -1 : 0;
      });
    },
    filterRows(i) {
      if (!this.filterable || !i.length)
        return i;
      let t = [...i];
      return this.filterableColumnKeys.length && (t = t.filter(this.findFilterTermsInRow)), this.$emit("filtered", {
        filterText: this.filterText,
        rows: t
      }), t;
    },
    findFilterTermsInRow(i) {
      let t = !1;
      for (let e = 0; e < this.filterableColumnKeys.length; e += 1) {
        const n = this.filterableColumnKeys[e];
        let s = i[n];
        if (this.rowDataPath && (s = i[this.rowDataPath][n]), t = this.findFilterTermsInCell(s), t)
          break;
      }
      return t;
    },
    findFilterTermsInCell(i) {
      let t = !1;
      for (let e = 0; e < this.filterTerms.length; e += 1) {
        const n = this.filterTerms[e];
        if (t = i == null ? void 0 : i.toString().trim().toLowerCase().includes(n.toLowerCase()), t)
          break;
      }
      return t;
    },
    goToPage(i) {
      const t = this.currentPageNumber;
      this.currentPageNumber = i, this.$emit("pageChanged", {
        currentPageNumber: this.currentPageNumber,
        previousPageNumber: t
      });
    },
    handlePaginationClick(i) {
      i > 0 && i <= this.lastPageNumber && i !== this.currentPageNumber && this.goToPage(i);
    }
  }
};
var Wm = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "acv-data-grid-wrapper data-grid-wrapper" }, [e("div", { staticClass: "grid-filter-wrapper" }, [t._t("filter-input", function() {
    return [t.filterable ? e("input", { directives: [{ name: "model", rawName: "v-model", value: t.internalFilterText, expression: "internalFilterText" }], attrs: { type: "text", name: "grid-filter-input", placeholder: t.filterTextInputPlaceholder }, domProps: { value: t.internalFilterText }, on: { input: function(n) {
      n.target.composing || (t.internalFilterText = n.target.value);
    } } }) : t._e()];
  })], 2), t.paging === "top" || t.paging === "both" ? e("div", { staticClass: "grid-pagination-wrapper" }, [e("div", { staticClass: "grid-pagination-pager-wrapper" }, [t._t("top-pager", function() {
    return [e("acv-data-pagination", { attrs: { "current-page-number": t.currentPageNumber, "total-row-count": t.totalSortedFilteredRows, "page-size": t.internalSelectedPageSize.value }, on: { goToPage: t.handlePaginationClick } })];
  }, { currentPageNumber: t.currentPageNumber, selectedPageSize: t.internalSelectedPageSize.value, totalVisibleRows: t.totalVisibleRows, totalSortedFilteredRows: t.totalSortedFilteredRows, totalRows: t.totalRows })], 2), e("div", { staticClass: "grid-pagination-size-select-wrapper" }, [t._t("top-page-size-selector", function() {
    return [e("acv-label", { attrs: { uppercase: !1, "font-size": "15", "margin-bottom": 0, "margin-right": 0, "padding-right": "15px" } }, [t._v(" " + t._s(t.pageSizeSelectorLabel) + " ")]), e("acv-select", { attrs: { options: t.pageSizeOptions, "aria-label": "Select number of rows to view per page" }, model: { value: t.internalSelectedPageSize, callback: function(n) {
      t.internalSelectedPageSize = n;
    }, expression: "internalSelectedPageSize" } })];
  })], 2)]) : t._e(), e("div", { staticClass: "grid" }, [t.hideHeader ? t._e() : e("div", { staticClass: "grid-header-row grid-row hidden-xs" }, t._l(t.visibleColumns, function(n, s) {
    return e("div", { key: n.key, staticClass: "grid-header-cell cell", class: [
      n.key === t.sortedColumn ? "sorted-by" : "",
      n.key,
      n.cssClasses ? n.cssClasses : "",
      t.sortable && n.sortable ? "--hover" : ""
    ], on: { click: function(r) {
      return t.handleHeaderClicked(n, s);
    }, keypress: function(r) {
      return !r.type.indexOf("key") && t._k(r.keyCode, "space", 32, r.key, [" ", "Spacebar"]) ? null : t.handleHeaderClicked(n, s);
    } } }, [t._t(`${n.key}-header-label`, function() {
      return [e("div", [t._v(" " + t._s(n.label || n.key) + " ")])];
    }, { column: n, index: s, sortedBy: n.key === t.sortedColumn, sortOrder: n.key === t.sortedColumn ? t.sortOrder : "" }), t._t(`${n.key}-sort-icon`, function() {
      return [n.sortable && t.getSortIconForColumn(n) ? e("acv-icon", { staticClass: "header-sort-icon", attrs: { icon: t.getSortIconForColumn(n) } }) : t._e()];
    }, { column: n, index: s, sortedBy: n.key === t.sortedColumn, sortOrder: n.key === t.sortedColumn ? t.sortOrder : "" })], 2);
  }), 0), t.visibleRows.length ? t._e() : e("div", { staticClass: "no-results-wrapper" }, [t._t("no-results", function() {
    return [t._v(" No results found. ")];
  }, { filterText: t.internalFilterText })], 2), e("div", { staticClass: "grid-data-rows" }, [t._l(t.visibleRows, function(n, s) {
    return e(n.tag || "div", t._b({ key: t.findRowIndex(n), tag: "component", staticClass: "grid-data-row grid-row", on: { click: function(r) {
      return r.preventDefault(), t.$emit("rowClicked", { row: n, rowIndex: s, $event: r });
    } } }, "component", n.props, !1), [n.rowTitle || n.rowTitleKey || t.rowTitle || t.rowTitleKey ? e("div", { staticClass: "row-title visible-xs" }, [t._v(" " + t._s(n.rowTitle || n[n.rowTitleKey] || t.rowTitle || n[t.rowTitleKey]) + " ")]) : t._e(), t._t("row", function() {
      return t._l(t.visibleColumns, function(r, a) {
        return e("div", { key: `${t.findRowIndex(n)}_${r.key}`, staticClass: "grid-row-cell cell", class: [
          r.key,
          r.cssClasses ? r.cssClasses : ""
        ], on: { click: function(o) {
          return t.$emit("cellClicked", { column: r, columnIndex: a, data: n[r.key] });
        }, keypress: function(o) {
          return !o.type.indexOf("key") && t._k(o.keyCode, "space", 32, o.key, [" ", "Spacebar"]) ? null : t.$emit("cellClicked", { column: r, columnIndex: a, data: n[r.key] });
        } } }, [e("div", { staticClass: "visible-xs header-label" }, [t._t(`${r.key}-header-label`, function() {
          return [t._v(" " + t._s(r.label || r.key) + " ")];
        }, { column: r, index: a, sortedBy: r.key === t.sortedColumn, sortOrder: r.key === t.sortedColumn ? t.sortOrder : "" })], 2), e("div", { staticClass: "data-cell" }, [t._t(`${r.key}-data-cell`, function() {
          return [t._v(" " + t._s(n[r.key]) + " ")];
        }, { data: n[r.key], index: a })], 2)]);
      });
    }, { row: n, index: s })], 2);
  }), t.hideFooter ? t._e() : e(t.footer.tag || "div", t._b({ key: "footer-row", tag: "component", staticClass: "grid-data-row grid-row grid-footer-row", on: { click: function(n) {
    return n.preventDefault(), t.$emit("footerRowClicked", { $event: n });
  } } }, "component", t.footer.props, !1), [t._t("footer", function() {
    return t._l(t.visibleColumns, function(n, s) {
      return e("div", { key: `footer_${n.key}`, staticClass: "grid-row-cell cell", class: [
        n.key,
        n.cssClasses ? n.cssClasses : ""
      ], on: { click: function(r) {
        return t.$emit("footerCellClicked", { column: n, columnIndex: s, data: t.footer[n.key] });
      }, keypress: function(r) {
        return !r.type.indexOf("key") && t._k(r.keyCode, "space", 32, r.key, [" ", "Spacebar"]) ? null : t.$emit("footerCellClicked", { column: n, columnIndex: s, data: t.footer[n.key] });
      } } }, [e("div", { staticClass: "data-cell" }, [t._t(`${n.key}-footer-cell`, function() {
        return [t._v(" " + t._s(t.footer[n.key]) + " ")];
      }, { data: t.footer[n.key], visibleRows: t.visibleRows, sortedFilteredRows: t.sortedFilteredRows, rows: t.rows, index: s })], 2)]);
    });
  }, { footer: t.footer, visibleRows: t.visibleRows })], 2)], 2)]), t.paging === "bottom" || t.paging === "both" ? e("div", { staticClass: "bottom-grid-pagination-wrapper" }, [e("div", { staticClass: "grid-pagination-pager-wrapper" }, [t._t("bottom-pager", function() {
    return [e("acv-data-pagination", { attrs: { "current-page-number": t.currentPageNumber, "total-row-count": t.totalSortedFilteredRows, "page-size": t.internalSelectedPageSize.value }, on: { goToPage: t.handlePaginationClick } })];
  }, { currentPageNumber: t.currentPageNumber, selectedPageSize: t.internalSelectedPageSize.value, totalVisibleRows: t.totalVisibleRows, totalSortedFilteredRows: t.totalSortedFilteredRows, totalRows: t.totalRows })], 2), e("div", { staticClass: "grid-pagination-size-select-wrapper" }, [t._t("bottom-page-size-selector", function() {
    return [e("acv-label", { attrs: { uppercase: !1, "font-size": "15", "margin-bottom": 0, "margin-right": 0, "padding-right": "15px" } }, [t._v(" " + t._s(t.pageSizeSelectorLabel) + " ")]), e("acv-select", { attrs: { options: t.pageSizeOptions, "aria-label": "Select number of rows to view per page" }, model: { value: t.internalSelectedPageSize, callback: function(n) {
      t.internalSelectedPageSize = n;
    }, expression: "internalSelectedPageSize" } })];
  })], 2)]) : t._e()]);
}, Ym = [], Um = /* @__PURE__ */ U(
  jm,
  Wm,
  Ym,
  !1,
  null,
  "83a11d6b"
);
const Cl = Um.exports, Zm = {
  name: "AcvDataPagination",
  props: {
    currentPageNumber: {
      type: Number,
      default: 1
    },
    totalRowCount: {
      type: Number,
      default: 0
    },
    pageLinkCount: {
      type: Number,
      default: 5
    },
    pageSize: {
      type: Number,
      default: 10
    },
    showPageNumbers: {
      type: Boolean,
      default: !0
    }
  },
  computed: {
    lastPageNumber() {
      return Math.ceil(this.totalRowCount / this.pageSize) || 1;
    },
    totalPageLinks() {
      return this.lastPageNumber;
    },
    lastPageNumberVisible() {
      return Math.ceil(this.pageLinkCount + this.currentPageNumber - 1) <= this.lastPageNumber;
    }
  },
  methods: {
    centerCurrentNumber(i, t) {
      const e = this.showPageNumbers ? 4 : 1;
      return Math.abs(i - t) < e || t === 0;
    }
  }
};
var Gm = function() {
  var t = this, e = t._self._c;
  return t.showPageNumbers ? e("div", { directives: [{ name: "show", rawName: "v-show", value: t.totalPageLinks > 1, expression: "totalPageLinks > 1" }], staticClass: "acv-pagination pagination tw-flexbox-row-align-center" }, [e("ul", [e("li", [e("a", { staticClass: "jumpTo jumpToFirst", class: { active: t.currentPageNumber === 1 }, on: { click: function(n) {
    return n.preventDefault(), t.$emit("goToPage", 1);
  }, keypress: function(n) {
    return !n.type.indexOf("key") && t._k(n.keyCode, "space", 32, n.key, [" ", "Spacebar"]) ? null : (n.preventDefault(), t.$emit("goToPage", 1));
  } } }, [t._v(" First ")])]), e("li", [e("a", { staticClass: "jumpTo", class: { active: t.currentPageNumber === 1 }, on: { click: function(n) {
    return n.preventDefault(), t.$emit("goToPage", t.currentPageNumber - 1);
  }, keypress: function(n) {
    return !n.type.indexOf("key") && t._k(n.keyCode, "space", 32, n.key, [" ", "Spacebar"]) ? null : (n.preventDefault(), t.$emit("goToPage", t.currentPageNumber - 1));
  } } }, [t._v(" ‹‹ ")])]), e("transition-group", { attrs: { name: "list" } }, t._l(t.totalPageLinks, function(n) {
    return e("li", { directives: [{ name: "show", rawName: "v-show", value: t.centerCurrentNumber(n, t.currentPageNumber), expression: "centerCurrentNumber(pageNumber, currentPageNumber)" }], key: n, class: { activeNumber: n === t.currentPageNumber }, on: { click: function(s) {
      return s.preventDefault(), t.$emit("goToPage", n);
    }, keypress: function(s) {
      return !s.type.indexOf("key") && t._k(s.keyCode, "space", 32, s.key, [" ", "Spacebar"]) ? null : (s.preventDefault(), t.$emit("goToPage", n));
    } } }, [e("a", [t._v(" " + t._s(n) + " ")])]);
  }), 0), t.lastPageNumberVisible ? e("li", [t._v(" ... "), e("a", { on: { click: function(n) {
    return n.preventDefault(), t.$emit("goToPage", t.lastPageNumber);
  }, keypress: function(n) {
    return !n.type.indexOf("key") && t._k(n.keyCode, "space", 32, n.key, [" ", "Spacebar"]) ? null : (n.preventDefault(), t.$emit("goToPage", t.lastPageNumber));
  } } }, [t._v(" " + t._s(t.lastPageNumber) + " ")])]) : t._e(), e("li", [e("a", { staticClass: "jumpTo", class: { active: t.lastPageNumber === t.currentPageNumber }, on: { click: function(n) {
    return n.preventDefault(), t.$emit("goToPage", t.currentPageNumber + 1);
  }, keypress: function(n) {
    return !n.type.indexOf("key") && t._k(n.keyCode, "space", 32, n.key, [" ", "Spacebar"]) ? null : (n.preventDefault(), t.$emit("goToPage", t.currentPageNumber + 1));
  } } }, [t._v(" ›› ")])]), e("li", [e("a", { staticClass: "jumpTo jumpToLast", class: { active: t.lastPageNumber === t.currentPageNumber }, on: { click: function(n) {
    return n.preventDefault(), t.$emit("goToPage", t.lastPageNumber);
  }, keypress: function(n) {
    return !n.type.indexOf("key") && t._k(n.keyCode, "space", 32, n.key, [" ", "Spacebar"]) ? null : (n.preventDefault(), t.$emit("goToPage", t.lastPageNumber));
  } } }, [t._v(" Last ")])])], 1)]) : e("div", { directives: [{ name: "show", rawName: "v-show", value: t.totalPageLinks > 1, expression: "totalPageLinks > 1" }], staticClass: "acv-pagination pagination tw-flexbox-row-align-center" }, [e("ul", [e("li", [e("a", { staticClass: "jumpTo", class: { active: t.currentPageNumber === 1 }, on: { click: function(n) {
    n.preventDefault(), t.$emit("goToPage", Math.max(t.currentPageNumber - 1, 1));
  }, keypress: function(n) {
    if (!n.type.indexOf("key") && t._k(n.keyCode, "space", 32, n.key, [" ", "Spacebar"])) return null;
    n.preventDefault(), t.$emit("goToPage", Math.max(t.currentPageNumber - 1, 1));
  } } }, [t._v(" ‹ ")])]), e("transition-group", { attrs: { name: "list" } }, t._l(t.totalPageLinks, function(n) {
    return e("li", { directives: [{ name: "show", rawName: "v-show", value: t.centerCurrentNumber(n, t.currentPageNumber), expression: "centerCurrentNumber(pageNumber, currentPageNumber)" }], key: n, class: { activeNumber: n === t.currentPageNumber }, on: { click: function(s) {
      return s.preventDefault(), t.$emit("goToPage", n);
    }, keypress: function(s) {
      return !s.type.indexOf("key") && t._k(s.keyCode, "space", 32, s.key, [" ", "Spacebar"]) ? null : (s.preventDefault(), t.$emit("goToPage", n));
    } } }, [e("a", [t._v(" " + t._s(n) + " ")])]);
  }), 0), e("li", [e("a", { staticClass: "jumpTo", class: { active: t.lastPageNumber === t.currentPageNumber }, on: { click: function(n) {
    n.preventDefault(), t.$emit("goToPage", Math.min(t.currentPageNumber + 1, t.lastPageNumber));
  }, keypress: function(n) {
    if (!n.type.indexOf("key") && t._k(n.keyCode, "space", 32, n.key, [" ", "Spacebar"])) return null;
    n.preventDefault(), t.$emit("goToPage", Math.min(t.currentPageNumber + 1, t.lastPageNumber));
  } } }, [t._v(" › ")])])], 1)]);
}, Km = [], Xm = /* @__PURE__ */ U(
  Zm,
  Gm,
  Km,
  !1,
  null,
  "76e2fca9"
);
const sh = Xm.exports, rh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: sh
}, Symbol.toStringTag, { value: "Module" })), Qm = {
  name: "AcvDataTable",
  components: {
    AcvDataPagination: () => Promise.resolve().then(() => rh),
    AcvLabel: () => Promise.resolve().then(() => Ah),
    AcvSelect: () => Promise.resolve().then(() => ah),
    AcvIcon: () => Promise.resolve().then(() => Ie)
  },
  extends: Cl,
  props: {
    dense: {
      type: Boolean,
      default: !1
    },
    rowClass: {
      type: [String, Array, Object],
      default: ""
    },
    pageSizeSlectorLabel: {
      type: String,
      default: "View"
    }
  }
};
var Jm = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "acv-data-table data-table" }, [e("div", { staticClass: "filters" }, [t._t("filters", function() {
    return [t.filterable ? e("input", { directives: [{ name: "model", rawName: "v-model", value: t.internalFilterText, expression: "internalFilterText" }], attrs: { type: "text", name: "grid-filter-input", placeholder: t.filterTextInputPlaceholder }, domProps: { value: t.internalFilterText }, on: { input: function(n) {
      n.target.composing || (t.internalFilterText = n.target.value);
    } } }) : t._e()];
  })], 2), t.paging === "top" || t.paging === "both" ? e("div", { staticClass: "pagination" }, [e("div", { staticClass: "pagination__pager" }, [t._t("top-pager", function() {
    return [e("acv-data-pagination", { attrs: { "current-page-number": t.currentPageNumber, "total-row-count": t.totalSortedFilteredRows, "page-size": t.internalSelectedPageSize.value }, on: { goToPage: t.handlePaginationClick } })];
  }, { currentPageNumber: t.currentPageNumber, selectedPageSize: t.internalSelectedPageSize.value, totalVisibleRows: t.totalVisibleRows, totalSortedFilteredRows: t.totalSortedFilteredRows, totalRows: t.totalRows })], 2), e("div", { staticClass: "pagination__page-size" }, [t._t("top-page-size", function() {
    return [e("acv-label", { attrs: { uppercase: !1, "font-size": "15", "margin-bottom": "0", "margin-right": "0", "padding-right": "15px" } }, [t._v(" " + t._s(t.pageSizeSelectorLabel) + " ")]), e("acv-select", { attrs: { options: t.pageSizeOptions, "aria-label": "Select number of rows to view per page" }, model: { value: t.internalSelectedPageSize, callback: function(n) {
      t.internalSelectedPageSize = n;
    }, expression: "internalSelectedPageSize" } })];
  })], 2)]) : t._e(), e("table", { staticClass: "table", class: { dense: t.dense } }, [t.hideHeader ? t._e() : e("thead", [e("tr", t._l(t.visibleColumns, function(n, s) {
    return e("th", { key: n.key, class: [
      n.key === t.sortedColumn ? "sorted-by" : "",
      n.key,
      n.cssClasses ? n.cssClasses : "",
      t.sortable && n.sortable ? "--hover" : ""
    ], on: { click: function(r) {
      return t.handleHeaderClicked(n, s);
    } } }, [e("div", { staticClass: "tw-flexbox-row-align-center-justify-between" }, [t._t(`${n.key}-header-label`, function() {
      return [t._v(" " + t._s(n.label || n.key) + " ")];
    }, { column: n, index: s, sortedBy: n.key === t.sortedColumn, sortOrder: n.key === t.sortedColumn ? t.sortOrder : "" }), t.sortable ? t._t(`${n.key}-sort-icon`, function() {
      return [n.sortable && t.getSortIconForColumn(n) ? e("acv-icon", { staticClass: "header-sort-icon", attrs: { icon: t.getSortIconForColumn(n) } }) : t._e()];
    }, { column: n, index: s, sortedBy: n.key === t.sortedColumn, sortOrder: n.key === t.sortedColumn ? t.sortOrder : "" }) : t._e()], 2)]);
  }), 0)]), t.totalRows && !t.loading ? e("tbody", t._l(t.visibleRows, function(n, s) {
    return e("tr", { key: t.findRowIndex(n), class: t.rowClass, on: { click: function(r) {
      return t.$emit("rowClicked", { row: n, rowIndex: s });
    }, mouseover: function(r) {
      return t.$emit("rowMouseover", { row: n, rowIndex: s });
    }, mouseout: function(r) {
      return t.$emit("rowMouseout", { row: n, rowIndex: s });
    }, focusin: function(r) {
      return t.$emit("rowMouseover", { row: n, rowIndex: s });
    }, focusout: function(r) {
      return t.$emit("rowMouseout", { row: n, rowIndex: s });
    } } }, [t._t("row", function() {
      return t._l(t.visibleColumns, function(r, a) {
        return e("td", { key: `${t.findRowIndex(n)}_${r.key}`, class: [
          r.key,
          r.cssClasses ? r.cssClasses : ""
        ], attrs: { "data-th": r.label || r.key }, on: { click: function(o) {
          return t.$emit("cellClicked", { column: r, columnIndex: a, data: n[r.key] });
        }, keypress: function(o) {
          return !o.type.indexOf("key") && t._k(o.keyCode, "space", 32, o.key, [" ", "Spacebar"]) ? null : t.$emit("cellClicked", { column: r, columnIndex: a, data: n[r.key] });
        } } }, [t._t(`${r.key}-data-cell`, function() {
          return [t._v(" " + t._s(n[r.key]) + " ")];
        }, { data: n[r.key], row: n, index: a })], 2);
      });
    }, { row: n, index: s })], 2);
  }), 0) : e("tbody", [!t.visibleRows.length && !t.loading ? e("tr", { staticClass: "no-results" }, [e("td", { attrs: { colspan: t.visibleColumns.length || 1 } }, [t._t("no-results", function() {
    return [t._v(" No results found. ")];
  }, { filterText: t.internalFilterText })], 2)]) : t.loading ? e("tr", { staticClass: "loading" }, [e("td", { attrs: { colspan: t.visibleColumns.length || 1 } }, [t._t("loading", function() {
    return [t._v(" Loading... ")];
  }, { filterText: t.internalFilterText })], 2)]) : t._e()])]), t.paging === "bottom" || t.paging === "both" ? e("div", { staticClass: "bottom-pagination" }, [e("div", { staticClass: "pagination__pager" }, [t._t("bottom-pager", function() {
    return [e("acv-data-pagination", { attrs: { "current-page-number": t.currentPageNumber, "total-row-count": t.totalSortedFilteredRows, "page-size": t.internalSelectedPageSize.value }, on: { goToPage: t.handlePaginationClick } })];
  }, { currentPageNumber: t.currentPageNumber, selectedPageSize: t.internalSelectedPageSize.value, totalVisibleRows: t.totalVisibleRows, totalSortedFilteredRows: t.totalSortedFilteredRows, totalRows: t.totalRows })], 2), e("div", { staticClass: "pagination__page-size" }, [t._t("bottom-page-size", function() {
    return [e("acv-label", { attrs: { uppercase: !1, "font-size": "15", "margin-bottom": "0", "margin-right": "0", "padding-right": "15px" } }, [t._v(" " + t._s(t.pageSizeSelectorLabel) + " ")]), e("acv-select", { attrs: { options: t.pageSizeOptions, "aria-label": "Select number of rows to view per page" }, model: { value: t.internalSelectedPageSize, callback: function(n) {
      t.internalSelectedPageSize = n;
    }, expression: "internalSelectedPageSize" } })];
  })], 2)]) : t._e()]);
}, qm = [], t0 = /* @__PURE__ */ U(
  Qm,
  Jm,
  qm,
  !1,
  null,
  "faa737e4"
);
const e0 = t0.exports, i0 = {
  id: {
    type: String,
    default: ""
  }
}, n0 = {
  internalId() {
    return this.id || `${this.$options.name}-${this._uid}`;
  },
  internalValue: {
    get() {
      return this.value;
    },
    set(i) {
      this.$emit("input", i);
    }
  }
}, ue = {
  computed: n0,
  props: i0
}, s0 = {
  name: "AcvSelect",
  deprecated: "AcvSelect is deprecated. Please use AcvSelectField",
  mixins: [
    ue
  ],
  props: {
    value: {
      type: [Object, String, Number],
      default: () => {
      }
    },
    options: {
      type: Array,
      required: !0
    },
    required: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    label: {
      type: String,
      default: ""
    },
    labelIsScreenReadyOnly: {
      type: Boolean,
      default: !1
    },
    ariaLabel: {
      type: String,
      default: ""
    },
    optionDisplayKey: {
      type: String,
      default: "description"
    },
    optionValueKey: {
      type: String,
      default: "value"
    }
  },
  computed: {
    ariaLabelText() {
      return this.ariaLabel || this.label;
    }
  },
  mounted() {
    (!this.value || Object.keys(this.value).length === 0) && ([this.internalValue] = this.options);
  },
  methods: {
    optionDisplayText(i) {
      return i[this.optionDisplayKey] || i[this.optionValueKey] || i;
    }
  }
};
var r0 = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "acv-select-wrapper" }, [t.label ? e("label", { class: { "sr-only": t.labelIsScreenReadyOnly }, attrs: { for: t.internalId } }, [t._v(" " + t._s(t.label) + " ")]) : t._e(), e("div", { staticClass: "control-group" }, [t._t("before-select"), e("div", { staticClass: "select", class: {
    "tw-cursor-not-allowed": t.disabled
  } }, [e("select", { directives: [{ name: "model", rawName: "v-model", value: t.internalValue, expression: "internalValue" }], staticClass: "form-control", attrs: { id: t.internalId, required: t.required, disabled: t.disabled, name: t.internalId, "aria-label": t.ariaLabelText }, on: { input: function(n) {
    return t.$emit("selectChanged", t.options);
  }, change: function(n) {
    var s = Array.prototype.filter.call(n.target.options, function(r) {
      return r.selected;
    }).map(function(r) {
      var a = "_value" in r ? r._value : r.value;
      return a;
    });
    t.internalValue = n.target.multiple ? s : s[0];
  } } }, t._l(t.options, function(n, s) {
    return e("option", { key: n.id ? n.id : s, attrs: { disabled: n.disabled }, domProps: { value: n } }, [e("span", { domProps: { innerHTML: t._s(t.optionDisplayText(n)) } })]);
  }), 0), e("div", { staticClass: "select__arrow" })]), t._t("after-select")], 2)]);
}, a0 = [], o0 = /* @__PURE__ */ U(
  s0,
  r0,
  a0,
  !1,
  null,
  "04df8be4"
);
const Sl = o0.exports, ah = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Sl
}, Symbol.toStringTag, { value: "Module" })), l0 = {
  name: "AcvPagination",
  components: {
    AcvIconButton: Ee,
    AcvSelect: Sl
  },
  model: {
    event: "change",
    prop: "value"
  },
  props: {
    /**
     * label string for the page size selection
     */
    label: {
      type: String,
      default: "Rows per page"
    },
    /**
     * An array of  integer values for the page size options.
     */
    pageSizeOptions: {
      type: Array,
      default: () => [
        10,
        20,
        50,
        100
      ]
    },
    /**
     *  The count of the total rows in the table
     */
    totalRowCount: {
      type: Number,
      default: 0
    },
    /**
     * The value used in v-model. The expected format is as follows:
     *
     * {
     *   currentPage: 1,  //  Integer value
     *   pageSize: 10, // the selected page size, this value must be in the pageSizeOptions Array
     * }
     */
    value: {
      type: Object,
      default: null
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    currentPage() {
      var i;
      return ((i = this.value) == null ? void 0 : i.currentPage) || 1;
    },
    currentPageFirst() {
      return this.totalVisibleRowCount === 0 ? 0 : this.pageSize * (this.currentPage - 1) + 1;
    },
    currentPageLast() {
      return this.totalVisibleRowCount === 0 ? 0 : this.currentPageFirst + this.totalVisibleRowCount - 1;
    },
    hasNextPage() {
      return this.totalRowCount > this.currentPageLast;
    },
    hasPreviousPage() {
      return this.currentPageFirst > 1;
    },
    lastPageNumber() {
      return Math.ceil(this.totalRowCount / this.pageSize);
    },
    pageSize: {
      get() {
        var i;
        return ((i = this.value) == null ? void 0 : i.pageSize) || 10;
      },
      set(i) {
        this.pageSize !== i && this.emitChange({ pageSize: i, currentPage: 1 });
      }
    },
    showPageSizeSelect() {
      return this.pageSizeOptions.length > 1;
    },
    totalVisibleRowCount() {
      if (this.totalRowCount === 0)
        return 0;
      if (this.totalRowCount < this.pageSize)
        return this.totalRowCount;
      const i = this.totalRowCount % this.pageSize;
      return i > 0 && this.currentPage === this.lastPageNumber ? i : this.pageSize;
    }
  },
  methods: {
    emitChange(i) {
      this.$emit("change", i);
    },
    goToNextPage() {
      this.emitChange({
        pageSize: this.pageSize,
        currentPage: this.currentPage + 1
      });
    },
    goToPreviousPage() {
      this.emitChange({
        pageSize: this.pageSize,
        currentPage: this.currentPage - 1
      });
    }
  }
};
var c0 = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "acv-pagination" }, [t._t("before"), t.showPageSizeSelect ? e("div", { staticClass: "acv-pagination__page-size" }, [e("acv-select", { attrs: { label: t.label, options: t.pageSizeOptions, disabled: t.disabled }, model: { value: t.pageSize, callback: function(n) {
    t.pageSize = n;
  }, expression: "pageSize" } })], 1) : t._e(), e("div", { staticClass: "acv-pagination__pager" }, [e("span", { staticClass: "pager-text" }, [t._t("pager-text", function() {
    return [t._v(" " + t._s(t.currentPageFirst) + "-" + t._s(t.currentPageLast) + " of " + t._s(t.totalRowCount) + " ")];
  }, { currentPageFirst: t.currentPageFirst, currentPageLast: t.currentPageLast, totalRowCount: t.totalRowCount })], 2), e("acv-icon-button", { staticClass: "pager-button previous", attrs: { "icon-type": "chevron-left", "show-tooltip": !1, disabled: t.disabled || !t.hasPreviousPage }, on: { click: function(n) {
    return n.preventDefault(), t.goToPreviousPage.apply(null, arguments);
  } } }), e("acv-icon-button", { staticClass: "pager-button next", attrs: { "icon-type": "chevron-right", "show-tooltip": !1, disabled: t.disabled || !t.hasNextPage }, on: { click: function(n) {
    return n.preventDefault(), t.goToNextPage.apply(null, arguments);
  } } })], 1), t._t("after")], 2);
}, u0 = [], d0 = /* @__PURE__ */ U(
  l0,
  c0,
  u0,
  !1,
  null,
  "1588eb3f"
);
const oh = d0.exports, lh = {
  beforeCreate() {
    this.$emit("before-create");
  },
  created() {
    this.$emit("created");
  },
  beforeMount() {
    this.$emit("before-mount");
  },
  mounted() {
    this.$emit("mounted");
  },
  beforeUpdate() {
    this.$emit("before-update");
  },
  updated() {
    this.$emit("updated");
  },
  beforeDestroy() {
    this.$emit("before-destroy");
  },
  destroyed() {
    this.$emit("destroyed");
  }
}, h0 = {
  name: "AcvDialog",
  directives: {
    onClickaway: On
  },
  components: {
    AcvButton: bi,
    AcvIconButton: Ee
  },
  mixins: [
    lh
  ],
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    /**
     * Centers the dialog in the middle of the viewport
     */
    centered: {
      type: Boolean,
      default: !0
    },
    /**
     * Include slide transition of dialog content
     */
    slide: {
      type: Boolean,
      default: !1
    },
    /**
     * Title of the dialog, if absent the header won't be shown
     */
    title: {
      type: String,
      default: ""
    },
    /**
     * Body text
     */
    body: {
      type: String,
      default: ""
    },
    /**
     * The text to overlay on the submit button
     */
    submitText: {
      type: String,
      default: "Submit"
    },
    /**
     * The text to overlay on the cancel button
     */
    cancelText: {
      type: String,
      default: "Cancel"
    },
    /**
     * Whether or not to show the dialog. Use with v-model
     */
    value: {
      type: Boolean,
      default: !1
    },
    /**
     * Enabled/disable the ability to click outside the dialog box and close it
     */
    clickAway: {
      type: Boolean,
      default: !0
    },
    /**
     * Allows close icon, clickaway on backdrop and escape key to close the dialog
     */
    hasClose: {
      type: Boolean,
      default: !0
    },
    /**
     * Hide/show the dialog's footer
     */
    showFooter: {
      type: Boolean,
      default: !0
    },
    /**
     * Disable the buttons while submitting
     */
    submitting: {
      type: Boolean,
      default: !1
    },
    /**
     * Disable the submit button
     */
    submitDisable: {
      type: Boolean,
      default: !1
    },
    /**
     * Disable the cancel button
     */
    cancelDisable: {
      type: Boolean,
      default: !1
    },
    /**
     * Disables scrolling of content on the body tag behind the dialog
     */
    disableBodyScrolling: {
      type: Boolean,
      default: !1
    },
    /**
    * Focus the dialog on open
    */
    shouldFocus: {
      type: Boolean,
      default: !0
    },
    /**
    * Determines if the dialog should be considered inactive after submit click
    */
    inactiveAfterSubmission: {
      type: Boolean,
      default: !1
    },
    /**
    * Determines if the dialog should be considered inactive after cancel click
    */
    inactiveAfterCancellation: {
      type: Boolean,
      default: !0
    },
    /**
    * Size of the dialog
    */
    size: {
      type: String,
      default: "medium",
      validator(i) {
        return wt(i, [
          "large",
          "medium"
        ]);
      }
    }
  },
  data() {
    return {
      isActive: !!this.value,
      outerContentClicked: null
    };
  },
  computed: {
    showHeader() {
      return this.title !== "";
    },
    dialogClasses() {
      return {
        centered: this.centered,
        slide: this.slide
      };
    },
    dialogContentClasses() {
      return {
        medium: this.size === "medium",
        large: this.size === "large"
      };
    }
  },
  watch: {
    isActive(i) {
      if (this.disableBodyScrolling) {
        const t = document.querySelector("body");
        i ? t.classList.add("no-scroll") : t.classList.contains("no-scroll") && t.classList.remove("no-scroll");
      }
      i ? (this.setupListeners(), this.shouldFocus && this.focusDialog()) : this.removeListeners(), this.$emit("change", i);
    },
    value(i) {
      this.isActive = i;
    }
  },
  beforeDestroy() {
    if (this.removeListeners(), this.disableBodyScrolling) {
      const i = document.querySelector("body");
      i.classList.contains("no-scroll") && i.classList.remove("no-scroll");
    }
  },
  methods: {
    setupListeners() {
      window.addEventListener("keyup", this.keyup), this.$el.addEventListener("mousedown", this.setInitialMouseDown);
    },
    removeListeners() {
      window.removeEventListener("keyup", this.keyup), this.$el.removeEventListener("mousedown", this.setInitialMouseDown), this.outerContentClicked = null;
    },
    setInitialMouseDown({ target: i }) {
      this.outerContentClicked = i.classList.contains("acv-dialog-outer-content");
    },
    keyup(i) {
      (i.code === "Escape" || ["Escape", "Esc"].includes(i.key) || i.keyCode === 27) && this.close();
    },
    close() {
      this.hasClose && (this.isActive = !1, this.$emit("closed"));
    },
    handleSubmit() {
      this.inactiveAfterSubmission && (this.isActive = !1), this.$emit("submitted");
    },
    handleCancel() {
      this.inactiveAfterCancellation && (this.isActive = !1), this.$emit("canceled");
    },
    handleClickAway({ target: i }) {
      this.isActive && this.clickAway && this.outerContentClicked && i.classList.contains("acv-dialog-outer-content") && this.close();
    },
    hide() {
      this.isActive = !1, this.$emit("hidden");
    },
    show() {
      this.isActive = !0, this.$emit("shown");
    },
    focusDialog() {
      this.$nextTick(() => {
        document.activeElement.blur(), this.$el.querySelector(".acv-dialog-outer-content").focus();
      });
    }
  }
};
var f0 = function() {
  var t = this, e = t._self._c;
  return e("transition", { attrs: { appear: "", name: "acv-dialog-transition" } }, [e("div", { directives: [{ name: "show", rawName: "v-show", value: t.isActive, expression: "isActive" }], staticClass: "acv-dialog", class: t.dialogClasses }, [e("div", { staticClass: "acv-dialog-outer-content", attrs: { tabindex: "0" } }, [e("transition", { attrs: { name: "acv-dialog-content-slide-transition", appear: "" } }, [e("div", { directives: [{ name: "show", rawName: "v-show", value: t.isActive, expression: "isActive" }, { name: "on-clickaway", rawName: "v-on-clickaway", value: t.handleClickAway, expression: "handleClickAway" }], staticClass: "acv-dialog-content tw-flexbox-col-align-start", class: t.dialogContentClasses, attrs: { role: "dialog", "aria-label": "title" } }, [t.showHeader ? e("div", { staticClass: "acv-dialog-content__header" }, [t._t("header", function() {
    return [e("h6", { staticClass: "acv-dialog-content__header--title" }, [t._v(" " + t._s(t.title) + " ")]), t.hasClose ? e("acv-icon-button", { attrs: { "icon-type": "close", "show-tooltip": !1 }, on: { click: t.close } }) : t._e()];
  })], 2) : t._e(), e("div", { staticClass: "acv-dialog-content__body body-sm" }, [t._t("body", function() {
    return [t._v(" " + t._s(t.body) + " ")];
  })], 2), t.showFooter ? e("div", { staticClass: "acv-dialog-content__footer tw-flexbox-row-justify-end" }, [t._t("footer", function() {
    return [t.cancelText ? e("acv-button", { staticClass: "tw-mr-2", attrs: { variant: "tertiary", disabled: t.submitting || t.cancelDisable }, on: { click: t.handleCancel } }, [t._v(" " + t._s(t.cancelText) + " ")]) : t._e(), t.submitText ? e("acv-button", { attrs: { variant: "primary", disabled: t.submitting || t.submitDisable, loading: t.submitting }, on: { click: t.handleSubmit } }, [t._v(" " + t._s(t.submitText) + " ")]) : t._e()];
  })], 2) : t._e()])])], 1), e("div", { staticClass: "acv-dialog-backdrop" })])]);
}, p0 = [], g0 = /* @__PURE__ */ U(
  h0,
  f0,
  p0,
  !1,
  null,
  "23d5ab19"
);
const m0 = g0.exports, v0 = {
  name: "AcvDivider",
  props: {
    /**
    * Changes orientation to vertical
    */
    vertical: {
      type: Boolean,
      default: !1
    },
    /**
    * Includes text in the middle of the horizontal divider
    */
    content: {
      type: String,
      default: ""
    }
  },
  computed: {
    computedClasses() {
      return {
        "acv-divider--horizontal": !this.vertical,
        "acv-divider--vertical": this.vertical
      };
    },
    hasContent() {
      return !this.vertical && (!!this.$slots.content || this.content);
    }
  }
};
var A0 = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "acv-divider", class: t.computedClasses, attrs: { role: "separator", "aria-orientation": t.vertical ? "vertical" : "horizontal" } }, [t.hasContent ? e("span", { staticClass: "acv-divider__content" }, [t._t("default", function() {
    return [t._v(" " + t._s(t.content) + " ")];
  })], 2) : t._e()]);
}, b0 = [], y0 = /* @__PURE__ */ U(
  v0,
  A0,
  b0,
  !1,
  null,
  "e9633ac6"
);
const Js = y0.exports, _0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Js
}, Symbol.toStringTag, { value: "Module" })), x0 = {
  name: "AcvEmptyState",
  components: {
    AcvCard: th,
    AcvIcon: ie,
    AcvButton: bi
  },
  props: {
    titleText: {
      type: String,
      default: ""
    },
    bodyText: {
      type: String,
      default: ""
    },
    buttonLink: {
      type: String,
      default: ""
    },
    buttonText: {
      type: String,
      default: ""
    },
    isLoading: {
      type: Boolean,
      default: !1
    },
    isClickable: {
      type: Boolean,
      default: !1
    }
  }
};
var C0 = function() {
  var t = this, e = t._self._c;
  return e("acv-card", { staticClass: "acv-empty-state" }, [e("div", { directives: [{ name: "show", rawName: "v-show", value: t.isLoading, expression: "isLoading" }] }, [e("h3", [e("acv-icon", { attrs: { icon: "rotate_right", spin: "" } })], 1)]), e("div", { directives: [{ name: "show", rawName: "v-show", value: !t.isLoading, expression: "!isLoading" }], staticClass: "background-container" }, [e("div", { staticClass: "gradient-block" }, [t._t("title", function() {
    return [e("h2", { staticClass: "empty-title" }, [t._v(" " + t._s(t.titleText) + " ")])];
  }, { titleText: t.titleText }), t._t("body", function() {
    return [e("p", { staticClass: "bg-text" }, [t._v(" " + t._s(t.bodyText) + " ")])];
  }, { bodyText: t.bodyText })], 2), e("div", { staticClass: "button-container" }, [e("div", { directives: [{ name: "show", rawName: "v-show", value: t.isClickable, expression: "isClickable" }] }, [t._t("button", function() {
    return [t.buttonLink ? e("acv-button", { staticClass: "button", attrs: { text: t.buttonText }, on: { click: function(n) {
      return n.preventDefault(), t.$router.push(t.buttonLink);
    } } }) : t._e()];
  })], 2)])])]);
}, S0 = [], w0 = /* @__PURE__ */ U(
  x0,
  C0,
  S0,
  !1,
  null,
  "4f47d512"
);
const k0 = w0.exports, Vo = 350, Pc = (i, t) => {
  const e = i;
  t ? (e.style.display = null, e.style.height = "0px", e.style.height = `${e.scrollHeight}px`, setTimeout(() => {
    e.style.height = null, e.dispatchEvent(new Event("shown"));
  }, Vo)) : (e.style.height = `${e.scrollHeight}px`, setTimeout(() => {
    e.style.height = "0px", setTimeout(() => {
      e.style.height = null, e.style.display = "none", e.dispatchEvent(new Event("hidden"));
    }, Vo);
  }));
}, O0 = (i, t, e = "hidden") => {
  const n = i, s = t;
  n.visibleState = e === "shown", s.style.cssText += `
    display: ${n.visibleState ? null : "none"};
    will-change: height;
    overflow: hidden;
    transition: height ${Vo}ms ease-in-out;
  `;
}, Jr = (i, t) => {
  const e = i;
  requestAnimationFrame(() => {
    e.visibleState ? Pc(t, !1) : Pc(t, !0), e.visibleState = !e.visibleState;
  });
}, ch = (i, t) => {
  t && (i.removeEventListener("click", () => Jr(i, t)), i.removeEventListener("keydown", () => Jr(i, t)));
}, M0 = (i, t) => {
  ch(i, t), i.addEventListener("click", () => Jr(i, t)), i.addEventListener("keydown", (e) => {
    (["Space", "Enter"].includes(e.code) || ["Space", "Enter"].includes(e.key) || [32, 39].includes(e.keyCode)) && Jr(i, t);
  });
}, T0 = (i, { value: t, arg: e }) => {
  const n = document.getElementById(t);
  n && (O0(i, n, e), M0(i, n));
}, D0 = (i, { value: t }) => {
  const e = document.getElementById(t);
  ch(i, e);
}, uh = {
  inserted: T0,
  unbind: D0
}, P0 = {
  name: "AcvExpansionPanel",
  components: {
    AcvIconButton: Ee
  },
  directives: {
    toggle: uh
  },
  props: {
    label: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: ""
    },
    mini: {
      type: Boolean,
      default: !1
    },
    openByDefault: {
      type: Boolean,
      default: !1
    },
    withBorders: {
      type: Boolean,
      default: !1
    },
    collapsible: {
      type: Boolean,
      default: !0
    }
  },
  data() {
    return {
      expanded: this.openByDefault,
      alreadyExpanded: !1
    };
  },
  computed: {
    expansionPanelId() {
      return this.$attrs.id || this.id || `${this.$options.name}-${this._uid}`;
    },
    computedClasses() {
      return {
        "acv-expansion-panel--with-borders": this.withBorders,
        expanded: this.expanded || !this.collapsible,
        "has-content": this.hasContent
      };
    },
    hasContent() {
      return !!this.$slots.default;
    },
    hasLabel() {
      return this.label || !!this.$slots["label-area"];
    },
    hasIcon() {
      return this.computedIcon || !!this.$slots["icon-area"];
    },
    computedIcon() {
      return this.icon ? this.icon : this.collapsible ? this.expanded ? "expand_less" : "expand_more" : "";
    }
  },
  methods: {
    handleVisibility(i) {
      this.expanded = i, this.$emit(i ? "shown" : "hidden");
    },
    defaultExpansion() {
      return this.collapsible && this.openByDefault && !this.alreadyExpanded ? (this.expanded = !0, this.alreadyExpanded = !0, "shown") : "";
    },
    getContentContainer() {
      return this.collapsible ? this.expansionPanelId : !1;
    }
  }
};
var L0 = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "acv-expansion-panel", class: t.computedClasses }, [e("div", { directives: [{ name: "toggle", rawName: "v-toggle:[defaultExpansion()]", value: t.getContentContainer(), expression: "getContentContainer()", arg: t.defaultExpansion() }], staticClass: "acv-expansion-panel__header" }, [e("div", { staticClass: "acv-expansion-panel__header--left", class: { mini: t.mini } }, [t.hasLabel ? [t._t("label-area", function() {
    return [e("span", { staticClass: "acv-expansion-panel__label tw-truncate" }, [t._v(t._s(t.label) + " ")])];
  })] : t._e()], 2), e("div", { staticClass: "acv-expansion-panel__header--right" }, [t.hasIcon ? [t._t("icon-area", function() {
    return [e("acv-icon-button", { attrs: { "icon-type": t.computedIcon, "show-tooltip": !1 } })];
  })] : t._e()], 2)]), e("div", { staticClass: "acv-expansion-panel__content-container", attrs: { id: t.expansionPanelId }, on: { shown: function(n) {
    return t.handleVisibility(!0);
  }, hidden: function(n) {
    return t.handleVisibility(!1);
  } } }, [e("div", { staticClass: "acv-expansion-panel__content" }, [t._t("default")], 2)])]);
}, I0 = [], E0 = /* @__PURE__ */ U(
  P0,
  L0,
  I0,
  !1,
  null,
  "fbb1d0e7"
);
const $0 = E0.exports;
var dh = { exports: {} };
(function(i, t) {
  (function(e, n) {
    i.exports = n();
  })(hi, function() {
    return function(e) {
      function n(r) {
        if (s[r]) return s[r].exports;
        var a = s[r] = { i: r, l: !1, exports: {} };
        return e[r].call(a.exports, a, a.exports, n), a.l = !0, a.exports;
      }
      var s = {};
      return n.m = e, n.c = s, n.i = function(r) {
        return r;
      }, n.d = function(r, a, o) {
        n.o(r, a) || Object.defineProperty(r, a, { configurable: !1, enumerable: !0, get: o });
      }, n.n = function(r) {
        var a = r && r.__esModule ? function() {
          return r.default;
        } : function() {
          return r;
        };
        return n.d(a, "a", a), a;
      }, n.o = function(r, a) {
        return Object.prototype.hasOwnProperty.call(r, a);
      }, n.p = ".", n(n.s = 10);
    }([function(e, n) {
      e.exports = { "#": { pattern: /\d/ }, X: { pattern: /[0-9a-zA-Z]/ }, S: { pattern: /[a-zA-Z]/ }, A: { pattern: /[a-zA-Z]/, transform: function(s) {
        return s.toLocaleUpperCase();
      } }, a: { pattern: /[a-zA-Z]/, transform: function(s) {
        return s.toLocaleLowerCase();
      } }, "!": { escape: !0 } };
    }, function(e, n, s) {
      function r(c) {
        var u = document.createEvent("Event");
        return u.initEvent(c, !0, !0), u;
      }
      var a = s(2), o = s(0), l = s.n(o);
      n.a = function(c, u) {
        var d = u.value;
        if ((Array.isArray(d) || typeof d == "string") && (d = { mask: d, tokens: l.a }), c.tagName.toLocaleUpperCase() !== "INPUT") {
          var h = c.getElementsByTagName("input");
          if (h.length !== 1) throw new Error("v-mask directive requires 1 input, found " + h.length);
          c = h[0];
        }
        c.oninput = function(p) {
          if (p.isTrusted) {
            var g = c.selectionEnd, m = c.value[g - 1];
            for (c.value = s.i(a.a)(c.value, d.mask, !0, d.tokens); g < c.value.length && c.value.charAt(g - 1) !== m; ) g++;
            c === document.activeElement && (c.setSelectionRange(g, g), setTimeout(function() {
              c.setSelectionRange(g, g);
            }, 0)), c.dispatchEvent(r("input"));
          }
        };
        var f = s.i(a.a)(c.value, d.mask, !0, d.tokens);
        f !== c.value && (c.value = f, c.dispatchEvent(r("input")));
      };
    }, function(e, n, s) {
      var r = s(6), a = s(5);
      n.a = function(o, l) {
        var c = !(arguments.length > 2 && arguments[2] !== void 0) || arguments[2], u = arguments[3];
        return Array.isArray(l) ? s.i(a.a)(r.a, l, u)(o, l, c, u) : s.i(r.a)(o, l, c, u);
      };
    }, function(e, n, s) {
      function r(h) {
        h.component(u.a.name, u.a), h.directive("mask", l.a);
      }
      Object.defineProperty(n, "__esModule", { value: !0 });
      var a = s(0), o = s.n(a), l = s(1), c = s(7), u = s.n(c);
      s.d(n, "TheMask", function() {
        return u.a;
      }), s.d(n, "mask", function() {
        return l.a;
      }), s.d(n, "tokens", function() {
        return o.a;
      }), s.d(n, "version", function() {
        return d;
      });
      var d = "0.11.1";
      n.default = r, typeof window < "u" && window.Vue && window.Vue.use(r);
    }, function(e, n, s) {
      Object.defineProperty(n, "__esModule", { value: !0 });
      var r = s(1), a = s(0), o = s.n(a), l = s(2);
      n.default = { name: "TheMask", props: { value: [String, Number], mask: { type: [String, Array], required: !0 }, masked: { type: Boolean, default: !1 }, tokens: { type: Object, default: function() {
        return o.a;
      } } }, directives: { mask: r.a }, data: function() {
        return { lastValue: null, display: this.value };
      }, watch: { value: function(c) {
        c !== this.lastValue && (this.display = c);
      }, masked: function() {
        this.refresh(this.display);
      } }, computed: { config: function() {
        return { mask: this.mask, tokens: this.tokens, masked: this.masked };
      } }, methods: { onInput: function(c) {
        c.isTrusted || this.refresh(c.target.value);
      }, refresh: function(u) {
        this.display = u;
        var u = s.i(l.a)(u, this.mask, this.masked, this.tokens);
        u !== this.lastValue && (this.lastValue = u, this.$emit("input", u));
      } } };
    }, function(e, n, s) {
      function r(a, o, l) {
        return o = o.sort(function(c, u) {
          return c.length - u.length;
        }), function(c, u) {
          for (var d = !(arguments.length > 2 && arguments[2] !== void 0) || arguments[2], h = 0; h < o.length; ) {
            var f = o[h];
            h++;
            var p = o[h];
            if (!(p && a(c, p, !0, l).length > f.length)) return a(c, f, d, l);
          }
          return "";
        };
      }
      n.a = r;
    }, function(e, n, s) {
      function r(a, o) {
        var l = !(arguments.length > 2 && arguments[2] !== void 0) || arguments[2], c = arguments[3];
        a = a || "", o = o || "";
        for (var u = 0, d = 0, h = ""; u < o.length && d < a.length; ) {
          var f = o[u], p = c[f], g = a[d];
          p && !p.escape ? (p.pattern.test(g) && (h += p.transform ? p.transform(g) : g, u++), d++) : (p && p.escape && (u++, f = o[u]), l && (h += f), g === f && d++, u++);
        }
        for (var m = ""; u < o.length && l; ) {
          var f = o[u];
          if (c[f]) {
            m = "";
            break;
          }
          m += f, u++;
        }
        return h + m;
      }
      n.a = r;
    }, function(e, n, s) {
      var r = s(8)(s(4), s(9), null, null);
      e.exports = r.exports;
    }, function(e, n) {
      e.exports = function(s, r, a, o) {
        var l, c = s = s || {}, u = typeof s.default;
        u !== "object" && u !== "function" || (l = s, c = s.default);
        var d = typeof c == "function" ? c.options : c;
        if (r && (d.render = r.render, d.staticRenderFns = r.staticRenderFns), a && (d._scopeId = a), o) {
          var h = d.computed || (d.computed = {});
          Object.keys(o).forEach(function(f) {
            var p = o[f];
            h[f] = function() {
              return p;
            };
          });
        }
        return { esModule: l, exports: c, options: d };
      };
    }, function(e, n) {
      e.exports = { render: function() {
        var s = this, r = s.$createElement;
        return (s._self._c || r)("input", { directives: [{ name: "mask", rawName: "v-mask", value: s.config, expression: "config" }], attrs: { type: "text" }, domProps: { value: s.display }, on: { input: s.onInput } });
      }, staticRenderFns: [] };
    }, function(e, n, s) {
      e.exports = s(3);
    }]);
  });
})(dh);
var Sa = dh.exports;
const B0 = {
  name: "AcvValidationMessages",
  components: {
    AcvIcon: () => Promise.resolve().then(() => Ie)
  },
  props: {
    /**
    * Validation object for the Vuelidate context and messages to be shown in the form of:<br/>
    * -`context` - Object - Vuelidate property <br/>
    * -`messages` - Object - keys being the vuelidate rule and values being
    * the message to be shown <br />
    * -`showIcon` - Boolean - shows an icon on the first validation message
    */
    validation: {
      type: Object,
      default: () => ({})
    },
    /**
    * Message to be shown
    */
    message: {
      type: String,
      default: ""
    },
    /**
    * Determines if an icon should be shown on the message prop
    */
    showIcon: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    hasValidations() {
      var i, t, e;
      return this.validation && ((i = this.validation) != null && i.context) ? Object.keys((e = (t = this.validation) == null ? void 0 : t.context) == null ? void 0 : e.$params).length : !!this.message;
    },
    validationParams() {
      var i, t, e;
      return this.validation && ((i = this.validation) != null && i.context) ? (e = (t = this.validation) == null ? void 0 : t.context) == null ? void 0 : e.$params : {};
    },
    hasIcon() {
      var i;
      return this.message && this.showIcon || this.validation && ((i = this.validation) == null ? void 0 : i.showIcon);
    }
  }
};
var R0 = function() {
  var t = this, e = t._self._c;
  return t.hasValidations ? e("div", { staticClass: "acv-validation-messages" }, [t._l(t.validationParams, function(n, s) {
    return [!t.validation.context[s] && t.validation.context.$invalid && t.validation.context.$dirty ? e("span", { key: s, staticClass: "validation-message" }, [t.validation.messages[s] ? e("span", [t.hasIcon ? e("acv-icon", { attrs: { icon: "expand_less" } }) : t._e(), t._v(" " + t._s(t.validation.messages[s]) + " ")], 1) : t._e()]) : t._e()];
  }), t.message ? [e("span", { staticClass: "validation-message" }, [t.hasIcon ? e("acv-icon", { attrs: { icon: "expand_less" } }) : t._e(), t._v(" " + t._s(t.message) + " ")], 1)] : t._e()], 2) : t._e();
}, F0 = [], N0 = /* @__PURE__ */ U(
  B0,
  R0,
  F0,
  !1,
  null,
  null
);
const hh = N0.exports, Di = {
  prefix: "",
  suffix: "",
  thousands: ",",
  decimal: ".",
  precision: 2,
  allowBlank: !1
};
function H0(i, t, e) {
  return Math.max(i, Math.min(t, e));
}
function fh(i) {
  return H0(0, i, 20);
}
function wl(i) {
  return i ? i.toString() : "";
}
function ph(i, t) {
  const e = t ? "" : "0";
  return wl(i).replace(/\D+/g, "") || e;
}
function gh(i, t) {
  const e = 10 ** t;
  return (parseFloat(i) / e).toFixed(fh(t));
}
function V0(i, t) {
  return i.replace(/(\d)(?=(?:\d{3})+\b)/gm, `$1${t}`);
}
function z0(i, t, e) {
  return t ? i + e + t : i;
}
function qr(i, t = Di) {
  let e = i;
  if (t.allowBlank && Number.isNaN(parseInt(e, 10)))
    return "";
  typeof e == "number" && (e = e.toFixed(fh(t.precision)));
  const n = e.indexOf("-") >= 0 ? "-" : "", s = ph(e, t.allowBlank), r = gh(s, t.precision), a = wl(r).split(".");
  let o = a[0];
  const l = a[1];
  return o = V0(o, t.thousands), t.prefix + n + z0(o, l, t.decimal) + t.suffix;
}
function Bs(i, t, e = !1) {
  const n = wl(i).indexOf("-") >= 0 ? -1 : 1, s = ph(i, e), r = gh(s, t), a = parseFloat(r) * n;
  return e && Number.isNaN(a) ? "" : a;
}
function Lc(i, t) {
  const e = () => {
    i.setSelectionRange(t, t);
  };
  i === document.activeElement && (e(), setTimeout(e, 1));
}
function Ka(i) {
  const t = document.createEvent("Event");
  return t.initEvent(i, !0, !0), t;
}
function mh(i, t) {
  let e = i;
  if (!t.value)
    return;
  const n = { ...Di, ...t.value };
  if (e.tagName.toLocaleUpperCase() !== "INPUT") {
    const s = e.getElementsByTagName("input");
    if (s.length !== 1)
      throw new Error(`v-money requires 1 input, found ${s.length}`);
    [e] = s;
  }
  e.onkeydown = (s) => {
    if (n.allowBlank && (s.keyCode === 8 || s.keyCode === 46)) {
      const a = e.value.length - e.selectionEnd === 0, o = Bs(e.value, n.precision, n.allowBlank);
      a && o === 0 && (e.value = "", e.dispatchEvent(Ka("input")));
    }
  }, e.oninput = () => {
    let s = e.value.length - e.selectionEnd;
    const r = Bs(e.value, n.precision, n.allowBlank);
    e.value = qr(r, n), s = Math.max(s, n.suffix.length), s = e.value.length - s, s = Math.max(s, n.prefix.length + 1), Lc(e, s), e.dispatchEvent(Ka("change"));
  }, e.onfocus = () => {
    Lc(e, e.value.length - n.suffix.length);
  }, e.oninput(), e.dispatchEvent(Ka("input"));
}
const j0 = {
  name: "AcvBaseInput",
  components: {
    AcvValidationMessages: hh
  },
  directives: {
    mask: (i, t) => {
      t.value && Sa.mask(i, t);
    },
    money: mh
  },
  inheritAttrs: !1,
  props: {
    /**
    * Additional classes for the input element
    */
    additionalInputClasses: {
      type: Object,
      default: () => ({})
    },
    /**
    * Additional classes for the span element displaying as the label
    */
    additionalLabelClasses: {
      type: Object,
      default: () => ({})
    },
    /**
    * Additional classes for the surrounding label container element
    */
    additionalLabelContainerClasses: {
      type: Object,
      default: () => ({})
    },
    /**
    * Hides the label
    */
    hideLabel: {
      type: Boolean,
      default: !1
    },
    /**
    * Label content
    */
    label: {
      type: [String, Number],
      required: !0
    },
    /**
    * Disables the input field
    */
    disabled: {
      type: Boolean,
      default: !1
    },
    /**
    * Value for the input field
    */
    value: {
      type: [String, Number, Object, Boolean],
      default: null
    },
    /**
    * Adjusts indeterminate state of the checkbox
    */
    indeterminate: {
      type: Boolean,
      default: !1
    },
    /**
    * Mask text with Vue-The-Mask
    */
    mask: {
      type: String,
      default: void 0
    },
    /**
    * Money text masking
    */
    moneyMask: {
      type: Object,
      default: void 0
    },
    /**
    * Assistive text shown for input
    */
    assistiveText: {
      type: [String, Number],
      default: null
    },
    /**
    * Validation object with Vuelidate for validation messages
    */
    validation: {
      type: Object,
      default: () => ({})
    },
    /**
    * When enabled, gives an invalid effect to the input
    */
    invalid: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    hasInput() {
      return !!this.value || typeof this.value == "number" && this.value === 0;
    },
    hasLabel() {
      return !this.hideLabel && this.label;
    },
    inputClasses() {
      return this.additionalInputClasses;
    },
    inputId() {
      return this.$attrs.id || this.id || `${this.$options.name}-${this._uid}`;
    },
    inputListeners() {
      return this.$listeners;
    },
    labelClasses() {
      return this.additionalLabelClasses;
    },
    labelContainerClasses() {
      return this.additionalLabelContainerClasses;
    },
    isDisabled() {
      return this.disabled;
    },
    hasValidations() {
      return this.validation && Object.keys(this.validation).length;
    },
    invalidValidation() {
      return this.hasValidations && this.validation.context.$invalid && this.validation.context.$dirty;
    },
    hasError() {
      return this.invalidValidation || this.invalid;
    },
    props() {
      return {
        ...this.$props,
        id: this.inputId,
        additionalLabelClasses: void 0,
        additionalInputClasses: void 0,
        additionalLabelContainerClasses: void 0
      };
    }
  },
  methods: {
    handleBlur() {
      this.$refs[`base-input-input-${this.inputId}`].blur();
    }
  }
};
var W0 = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "acv-input__container" }, [e("label", { class: {
    "acv-input": !0,
    ...t.labelContainerClasses
  }, attrs: { for: t.inputId, "aria-label": t.label, disabled: t.isDisabled } }, [t._t("prepend"), t._t("input", function() {
    return [e("input", t._g(t._b({ directives: [{ name: "mask", rawName: "v-mask", value: t.mask, expression: "mask" }, { name: "money", rawName: "v-money", value: t.moneyMask, expression: "moneyMask" }], ref: `base-input-input-${t.inputId}`, class: {
      "has-label": t.hasLabel,
      "has-input": t.hasInput,
      "has-error": t.hasError,
      ...t.inputClasses
    }, domProps: { indeterminate: t.indeterminate } }, "input", { ...t.$attrs, ...t.props }, !1), t.inputListeners))];
  }, null, {
    ...t.$attrs,
    ...t.props,
    hideLabel: t.hideLabel,
    hasInput: t.hasInput,
    inputClasses: t.inputClasses,
    indeterminate: t.indeterminate,
    inputListeners: t.inputListeners
  }), t._t("between"), t._t("label", function() {
    return [e("span", { class: {
      "acv-input__label": !0,
      "sr-only": t.hideLabel,
      [`label-${t.inputId}`]: !0,
      ...t.labelClasses
    }, attrs: { "aria-label": t.label, "aria-hidden": t.hideLabel } }, [t._v(" " + t._s(t.label) + " ")])];
  }), t._t("append")], 2), t._t("assistive-text", function() {
    return [t.assistiveText ? e("div", { staticClass: "acv-input__assistive-text", class: {
      "has-input": t.hasInput,
      "has-error": t.hasError
    } }, [e("span", { staticClass: "acv-input__assistive-text__content" }, [t._v(t._s(t.assistiveText))])]) : t._e()];
  }), t._t("validation", function() {
    return [t.hasValidations ? e("acv-validation-messages", { attrs: { validation: t.validation } }) : t._e()];
  })], 2);
}, Y0 = [], U0 = /* @__PURE__ */ U(
  j0,
  W0,
  Y0,
  !1,
  null,
  null
);
const Ce = U0.exports, Z0 = {
  name: "AcvCheckbox",
  components: {
    AcvBaseInput: Ce,
    AcvIcon: ie
  },
  extends: Ce,
  mixins: [
    yi
  ],
  model: {
    prop: "modelValue",
    event: "change"
  },
  props: {
    /**
    * The inherited v-model value
    */
    modelValue: {
      type: [Boolean, Array],
      default: !1
    },
    /**
    * Determines if the checkbox should be displayed as a button
    */
    button: {
      type: Boolean,
      default: !1
    },
    /**
    * Icon type shown for checkbox button
    */
    iconType: {
      type: String,
      default: "check"
    },
    /**
    * Determines single selection only when model value is defined as an array
    */
    singleSelection: {
      type: Boolean,
      default: !1
    },
    /**
    * Allows the clickable label area to be full width
    */
    fullWidth: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    hasIcon() {
      return !!this.$slots.icon || this.iconType;
    },
    hasLabel() {
      return !!this.$slots.label || this.label;
    },
    computedCheckBoxButtonClasses() {
      return {
        "acv-checkbox-button--checked": this.isChecked
      };
    },
    isArray() {
      return Array.isArray(this.modelValue);
    },
    isChecked() {
      return this.isArray ? this.modelValue.includes(this.value) : this.modelValue;
    },
    inputListeners() {
      return {
        ...this.$listeners,
        change: () => {
          this.determineCheckboxChange();
        }
      };
    }
  },
  methods: {
    determineCheckboxChange() {
      if (!this.disabled) {
        let i;
        this.isArray ? this.singleSelection ? i = [this.value] : this.isChecked ? i = this.modelValue.filter((t) => t !== this.value) : i = [...this.modelValue, this.value] : i = !this.modelValue, this.$emit("change", i), this.$emit("button-clicked", i), this.button ? this.$refs[`checkbox-button-${this.inputId}`].blur() : this.$refs[`base-input-${this.inputId}`].handleBlur();
      }
    }
  }
};
var G0 = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "acv-checkbox-wrapper", class: { "tw-w-full": t.fullWidth } }, [t.button ? [e("button", { ref: `checkbox-button-${t.inputId}`, class: ["acv-checkbox-button ripple", t.computedCheckBoxButtonClasses], attrs: { type: "button", disabled: t.disabled }, on: { click: function(n) {
    return n.preventDefault(), n.stopPropagation(), t.determineCheckboxChange.apply(null, arguments);
  } } }, [t.hasIcon ? t._t("checked-icon", function() {
    return [e("acv-icon", { directives: [{ name: "show", rawName: "v-show", value: t.isChecked, expression: "isChecked" }], staticClass: "acv-checkbox-button__icon", attrs: { icon: t.iconType } })];
  }) : t._e(), t.hasLabel ? t._t("label", function() {
    return [t._v(" " + t._s(t.label) + " ")];
  }) : t._e()], 2)] : [e("acv-base-input", t._g(t._b({ ref: `base-input-${t.inputId}`, attrs: { type: "checkbox", role: "checkbox", "additional-label-container-classes": {
    "acv-checkbox": !0
  }, checked: t.isChecked }, scopedSlots: t._u([{ key: "prepend", fn: function() {
    return [t._t("prepend")];
  }, proxy: !0 }, { key: "between", fn: function() {
    return [e("div", { staticClass: "acv-checkbox__control", class: { ...t.backgroundClasses } }), t._t("between")];
  }, proxy: !0 }, { key: "label", fn: function() {
    return [t._t("label")];
  }, proxy: !0 }, { key: "append", fn: function() {
    return [t._t("append")];
  }, proxy: !0 }], null, !0) }, "acv-base-input", { ...t.$attrs, ...t.$props }, !1), t.inputListeners))]], 2);
}, K0 = [], X0 = /* @__PURE__ */ U(
  Z0,
  G0,
  K0,
  !1,
  null,
  "773df860"
);
const ls = X0.exports, Q0 = {
  name: "AcvCheckboxList",
  components: {
    AcvCheckbox: ls
  },
  props: {
    id: {
      type: String,
      default: ""
    },
    headerElement: {
      type: String,
      default: "h3"
    },
    options: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: null
    },
    isMultiSelect: {
      type: Boolean,
      default: !1
    },
    defaultSelections: {
      type: Array,
      default: () => []
    },
    disabledSelections: {
      type: Array,
      default: () => []
    },
    value: {
      type: Object,
      default: () => {
      }
    },
    bgDarkMode: {
      type: Boolean,
      default: !1
    },
    bgOrange: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    internalId() {
      return this.id || `${this.$options.name}-${this._uid}`;
    }
  },
  watch: {
    defaultSelections(i) {
      this.options.forEach((t) => {
        Ti.set(t, "selected", !1);
      }), Ti.set(this.options[i], "selected", !0);
    }
  },
  created() {
    this.defaultSelections.length > 0 && this.options.forEach((i, t) => {
      Ti.set(i, "selected", this.defaultSelections.includes(t));
    });
  },
  methods: {
    isDisabled(i) {
      return this.disabledSelections.includes(i);
    },
    setSelectedValue(i, t, e) {
      this.isDisabled(e) || (this.isMultiSelect ? (Ti.set(t, "selected", !t.selected), this.$emit("change", t)) : (this.options.forEach((n) => {
        Ti.set(n, "selected", !1);
      }), Ti.set(t, "selected", !t.selected), this.$emit("change", t)));
    }
  }
};
var J0 = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "acv-checkbox-list" }, [t.title ? e(t.headerElement, { tag: "component", staticClass: "margin-pull margin-top-10" }, [t._v(" " + t._s(t.title) + " ")]) : t._e(), t._l(t.options, function(n, s) {
    return e("div", { key: n.id ? n.id : s, staticClass: "multiselect-checkbox", class: {
      active: n.selected,
      disabled: t.isDisabled(s)
    }, on: { click: function(r) {
      return r.preventDefault(), t.setSelectedValue(r, n, s);
    }, keypress: function(r) {
      return !r.type.indexOf("key") && t._k(r.keyCode, "space", 32, r.key, [" ", "Spacebar"]) ? null : (r.preventDefault(), t.setSelectedValue(r, n, s));
    } } }, [e("div", { staticClass: "left-wrapper" }, [e("div", { staticClass: "title" }, [t._v(" " + t._s(n.formatted_title || n.title) + " ")]), e("div", { staticClass: "subtitle" }, [t._t(`description-${n.id}`, function() {
      return [t._v(" " + t._s(n.description) + " ")];
    }, { option: n })], 2)]), e("div", { staticClass: "right-wrapper" }, [e("acv-checkbox", { attrs: { id: `checkbox-list-${t.internalId}-${n.id ? n.id : s}`, label: n.formatted_title || n.title, disabled: t.isDisabled(s), "bg-dark-mode": t.bgDarkMode, "bg-orange": t.bgOrange }, scopedSlots: t._u([{ key: "label", fn: function() {
      return [e("div", { staticClass: "sr-only" }, [t._v(" " + t._s(n.formatted_title || n.title) + " " + t._s(n.description) + " ")])];
    }, proxy: !0 }], null, !0), model: { value: n.selected, callback: function(r) {
      t.$set(n, "selected", r);
    }, expression: "option.selected" } })], 1)]);
  })], 2);
}, q0 = [], t2 = /* @__PURE__ */ U(
  Q0,
  J0,
  q0,
  !1,
  null,
  "2332483b"
);
const e2 = t2.exports, i2 = {
  name: "AcvList",
  mixins: [
    yi,
    Mn,
    fe
  ],
  props: {
    divider: {
      type: [Boolean, String],
      default: !0
    },
    striped: {
      type: [Boolean, String],
      default: !1
    }
  },
  computed: {
    computedClasses() {
      return {
        ...this.borderClasses,
        ...this.backgroundClasses,
        divider: this.divider === "true" || this.divider === !0,
        striped: this.striped === "true" || this.striped === !0
      };
    }
  }
};
var n2 = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "acv-list", class: t.computedClasses, style: [t.sizeStyles] }, [t._t("default")], 2);
}, s2 = [], r2 = /* @__PURE__ */ U(
  i2,
  n2,
  s2,
  !1,
  null,
  "77a29bbc"
);
const cs = r2.exports, a2 = {
  name: "AcvListItem",
  mixins: [
    yi,
    Mn,
    qd,
    fe
  ],
  props: {
    tag: {
      type: String,
      default: "div"
    }
  },
  computed: {
    is() {
      return this.navigationTag ? this.navigationTag : this.tag;
    },
    bindings() {
      return {
        ...this.navigationBindings
      };
    },
    classes() {
      return {
        ...this.backgroundClasses,
        ...this.borderClasses,
        ...this.navigationClasses
      };
    }
  }
};
var o2 = function() {
  var t = this, e = t._self._c;
  return e(t.is, t._b({ tag: "component", staticClass: "acv-list-item", class: t.classes, style: [t.sizeStyles], on: { click: function(n) {
    return t.$emit("click", n);
  } } }, "component", t.bindings, !1), [t._t("default")], 2);
}, l2 = [], c2 = /* @__PURE__ */ U(
  a2,
  o2,
  l2,
  !1,
  null,
  "754bcea6"
);
const us = c2.exports, u2 = {
  name: "AcvListItemContent"
};
var d2 = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "acv-list-item-content" }, [t._t("default")], 2);
}, h2 = [], f2 = /* @__PURE__ */ U(
  u2,
  d2,
  h2,
  !1,
  null,
  "eb23b56e"
);
const vh = f2.exports, p2 = {
  name: "AcvCheckboxTree",
  components: {
    AcvList: cs,
    AcvListItem: us,
    AcvListItemContent: vh,
    AcvCheckbox: ls,
    AcvIcon: ie,
    AcvTooltip: os
  },
  mixins: [
    ue
  ],
  props: {
    /**
    * Unique identifier property within each option object
    */
    idKey: {
      type: String,
      default: "id"
    },
    /**
    * Label property within each option object
    */
    labelKey: {
      type: String,
      default: "label"
    },
    /**
    * Value property within each option object
    */
    valueKey: {
      type: String,
      default: "value"
    },
    /**
    * Disabled property within each option object
    */
    disabledKey: {
      type: String,
      default: "disabled"
    },
    /**
    * Used in conjuction with `showingNumberOfSubOptionsSelected` to show the
    * number of selected sub options out of the parent option count property
    */
    countKey: {
      type: String,
      default: "count"
    },
    /**
    * Property in each sub options exist for each option object
    */
    subOptionsKey: {
      type: String,
      default: "options"
    },
    /**
    * Used when dealing with two arrays for sub options within each option object. <br/>
    * Handles the existence of selected sub options between arrays and menu states for each option
    */
    subOptionsReducedKey: {
      type: String,
      default: "options"
    },
    /**
    * Allows for the number of sub options selected to be shown out of the parent option
    * count property
    */
    showingNumberOfSubOptionsSelected: {
      type: Boolean,
      default: !1
    },
    /**
    * Determines if the sub options menus should be expanded on load with a watcher
    */
    expandSubOptionsOnLoad: {
      type: Boolean,
      default: !1
    },
    /**
    * Places a select all option within the sub options menu
    */
    hasSelectAllOptions: {
      type: Boolean,
      default: !0
    },
    /**
    * Text for the select all options checkbox option
    */
    selectAllText: {
      type: String,
      default: "Select All"
    },
    /**
    * Determines how many sub options should be shown by default. <br/>
    * If the option object has `multipleSubOptionSections` enabled, this is ignored
    */
    defaultVisibleSubOptions: {
      type: Number,
      default: 8
    },
    /**
    * v-model for the options array of object
    */
    value: {
      type: Array,
      default: () => []
    },
    /**
    * Text for the sub options menu while expanded to allow for collapsing
    */
    subOptionExpandedText: {
      type: String,
      default: "FEWER"
    },
    /**
    * Text for the sub options menu while collapsed to expand out
    */
    subOptionCollapsedText: {
      type: String,
      default: "MORE -"
    },
    /**
    * Shows count of hidden sub options beside the sub options menu expanded/collapsed text
    */
    showHiddenSubOptionsNumber: {
      type: Boolean,
      default: !0
    },
    /**
    * Changes styling of checkboxes to dark
    */
    bgDarkMode: {
      type: Boolean,
      default: !1
    },
    /**
    * Changes styling of checkboxes to orange
    */
    bgOrange: {
      type: Boolean,
      default: !1
    },
    /**
    * Changes checkboxes to button styling
    */
    buttons: {
      type: Boolean,
      default: !1
    },
    /**
    * Arranges checkboxes in a two-columnar style
    */
    twoColumns: {
      type: Boolean,
      default: !1
    },
    /**
    * Allows parent checkboxes to be indeterminate based on their sub options
    */
    shouldSetParentIndeterminate: {
      type: Boolean,
      default: !1
    },
    /**
    * Sets the parent option as truthy when the sub option is truthy while the
    * parent object was falsey
    */
    setParentOptionTruthyOnSubOption: {
      type: Boolean,
      default: !1
    },
    /**
    * Allows the clickable label area to be full width for each checkbox
    */
    fullWidth: {
      type: Boolean,
      default: !1
    },
    /**
    * Allows deselect all the sub options of the same parent when all of this are selected
    */
    allowClearAllSubOptions: {
      type: Boolean,
      default: !0
    },
    maxSelectableOptions: {
      type: Number,
      default: null
    },
    disabledOptionsLabel: {
      type: String,
      default: ""
    }
  },
  data: () => ({
    expandedOptions: {},
    expandedSubOptions: {}
  }),
  computed: {
    options() {
      return this.shouldSetParentIndeterminate && this.internalValue.forEach((i) => {
        const t = i, e = [...new Set(t[this.subOptionsKey].map((n) => n[this.valueKey]))];
        e.length > 1 || e[0] ? t.indeterminate = !i[this.valueKey] : e.length === 1 && !e[0] && (t.indeterminate = !1);
      }), this.internalValue;
    },
    totalSelectedOptions() {
      return this.options.reduce((i, t) => i + (t[this.valueKey] ? 1 : 0) + (t[this.subOptionsKey] || []).filter((e) => e[this.valueKey]).length, 0);
    },
    maxSelectableOptionsReached() {
      return this.totalSelectedOptions === this.maxSelectableOptions;
    },
    disabledOptionLabel() {
      return this.disabledOptionsLabel || `${this.maxSelectableOptions}/${this.maxSelectableOptions} options already selected`;
    }
  },
  watch: {
    expandSubOptionsOnLoad: {
      immediate: !0,
      handler(i, t) {
        i && i !== t && this.handleExpansionListing();
      }
    }
  },
  methods: {
    getOptionKey(i, t, e) {
      const n = e ? `${i[this.idKey]}-${e[this.idKey]}` : i[this.idKey];
      return `${this.internalId}-${n || t}`;
    },
    getSubOptionExpansionText(i) {
      const t = this.expandedSubOptions[i[this.idKey]];
      let e = "";
      return t ? e = this.subOptionExpandedText : (e = this.subOptionCollapsedText, this.showHiddenSubOptionsNumber && (e = `${e}(${this.numberOfHiddenSubOptions(i)})`)), e;
    },
    getVisibleSubOptions(i) {
      return this.expandedSubOptions[i[this.idKey]] ? i[this.subOptionsKey] : i[this.subOptionsKey].slice(0, this.defaultVisibleSubOptions);
    },
    hasHiddenSubOptions(i) {
      return "multipleSubOptionSections" in i ? i.multipleSubOptionSections : this.numberOfHiddenSubOptions(i) > 0;
    },
    numberOfHiddenSubOptions(i) {
      return i[this.subOptionsKey].length - this.defaultVisibleSubOptions;
    },
    getSelectAllForOption(i) {
      return i[this.subOptionsKey].filter((e) => e[this.valueKey] === !0).length === 0;
    },
    setExpansionStates(i, t) {
      this.$set(
        t,
        i[this.idKey],
        !t[i[this.idKey]]
      );
    },
    handleExpandIconClicked(i, t, e) {
      this.setExpansionStates(i, t), this.$emit(e, {
        option: i[this.idKey],
        expanded: t[i[this.idKey]],
        expandedOptions: t
      });
    },
    handleParentOptionChanged(i, t) {
      i || (this.setSubOptionsValue(i, t), this.expandedSubOptions[t[this.idKey]] && this.setExpansionStates(t, this.expandedSubOptions), this.expandedOptions[t[this.idKey]] && this.handleExpandIconClicked(
        t,
        this.expandedOptions,
        "optionsExpansionToggled"
      )), this.internalValue = [
        ...this.internalValue
      ];
    },
    handleSubOptionChanged(i, t, e) {
      const n = e[this.subOptionsKey].filter((r) => r[this.valueKey] === !0).length === e[this.subOptionsKey].length;
      !e[this.valueKey] && i && this.setParentOptionTruthyOnSubOption && this.$nextTick(() => {
        this.setOptionsValue(!0, e);
      }), n && this.allowClearAllSubOptions && this.$nextTick(() => {
        this.setSubOptionsValue(!1, e);
      }), this.internalValue = [
        ...this.internalValue
      ];
    },
    setSubOptionsValue(i, t) {
      if (this.hasSubOptions(t)) {
        const e = t[this.subOptionsKey].map((r) => ({
          ...r,
          [this.valueKey]: i
        })), n = {
          ...t,
          [this.subOptionsKey]: e
        }, s = this.getExistingOptionIndex(t);
        this.internalValue[s] = n;
      }
    },
    setOptionsValue(i, t) {
      const e = {
        ...t,
        [this.valueKey]: i
      }, n = this.getExistingOptionIndex(t);
      this.internalValue[n] = e, this.internalValue = [
        ...this.internalValue
      ];
    },
    hasSubOptions(i) {
      return i[this.subOptionsKey] && i[this.subOptionsKey].length;
    },
    getExistingOptionIndex(i) {
      return this.internalValue.findIndex((t) => t[this.idKey] === i[this.idKey]);
    },
    hasSelectedOptionsInCollection(i, t) {
      return [...new Set(i[this[t]].map((e) => e[this.valueKey]))];
    },
    getNumberOfSubOptionsSelected(i) {
      let t;
      return this.showingNumberOfSubOptionsSelected && i[this.countKey] && (t = i[this.subOptionsKey].filter((e) => e[this.valueKey]).length), t ? `${t}/${i[this.countKey]} Selected` : "";
    },
    handleExpansionListing() {
      this.options.forEach((i) => {
        if ([this.subOptionsReducedKey] in i) {
          const t = this.hasSelectedOptionsInCollection(
            i,
            "subOptionsKey"
          ), e = this.hasSelectedOptionsInCollection(
            i,
            "subOptionsReducedKey"
          );
          !this.expandedSubOptions[i[this.idKey]] && (t.length > 1 || t[0]) && e.length === 1 && !e[0] && this.handleExpandIconClicked(
            i,
            this.expandedSubOptions,
            "subOptionsExpansionToggled"
          );
        }
      });
    }
  }
};
var g2 = function() {
  var t = this, e = t._self._c;
  return e("acv-list", { staticClass: "acv-checkbox-tree", class: [t.twoColumns ? "two-columns" : ""], attrs: { divider: !1 } }, t._l(t.options, function(n, s) {
    return e("acv-list-item", { key: t.getOptionKey(n, s) }, [e("acv-list-item-content", { staticClass: "list-item-content" }, [e("div", { staticClass: "tw-flexbox-row-align-center-justify-between" }, [e("div", { staticClass: "tw-flexbox-row-align-center-justify-between", class: { "tw-w-full": t.fullWidth } }, [t._t(`${t.getOptionKey(n, s)}-before`, null, { option: n }), e("acv-checkbox", { attrs: { id: `option-${t.getOptionKey(n, s)}`, "full-width": t.fullWidth, indeterminate: n.indeterminate, "bg-dark-mode": t.bgDarkMode, "bg-orange": t.bgOrange, button: t.buttons, label: n[t.labelKey], disabled: t.maxSelectableOptionsReached && !n[t.valueKey] || n[t.disabledKey] }, on: { change: function(r) {
      return t.handleParentOptionChanged(r, n);
    } }, model: { value: n[t.valueKey], callback: function(r) {
      t.$set(n, t.valueKey, r);
    }, expression: "option[valueKey]" } }), t.maxSelectableOptionsReached && !n[t.valueKey] ? e("acv-tooltip", { attrs: { target: `label[for=option-${t.getOptionKey(n, s)}] > div`, position: "right" } }, [t._v(" " + t._s(t.disabledOptionLabel) + " ")]) : t._e()], 2), e("div", { staticClass: "tw-flexbox-row-align-center-justify-end", class: { "tw-w-full": t.fullWidth } }, [t.showingNumberOfSubOptionsSelected ? e("span", { staticClass: "sub-options-selected-count" }, [t._v(" " + t._s(t.getNumberOfSubOptionsSelected(n)) + " ")]) : t._e(), e("div", { class: {
      "expansion-icon-area": t.hasSubOptions(n)
    }, on: { click: function(r) {
      return t.handleExpandIconClicked(
        n,
        t.expandedOptions,
        "optionsExpansionToggled"
      );
    }, keypress: function(r) {
      return !r.type.indexOf("key") && t._k(r.keyCode, "space", 32, r.key, [" ", "Spacebar"]) ? null : t.handleExpandIconClicked(
        n,
        t.expandedOptions,
        "optionsExpansionToggled"
      );
    } } }, [t._t(`${t.getOptionKey(n, s)}-expansionIcon`, function() {
      return [t.hasSubOptions(n) ? e("acv-icon", { staticClass: "expansion-icon", class: `expansion-icon-${n[t.idKey]}`, attrs: { icon: t.expandedOptions[n[t.idKey]] ? "expand-less" : "expand-more" } }) : t._e()];
    })], 2), t._t(`${t.getOptionKey(n, s)}-after`, null, { option: n })], 2)]), e("transition", { attrs: { name: "toggle-sub-options" } }, [t.hasSubOptions(n) && t.expandedOptions[n[t.idKey]] ? e("acv-list", { staticClass: "sub-checkbox-tree", class: [
      `sub-checkbox-tree-${t.getOptionKey(n, s)}`,
      { "has-hidden-sub-options": t.hasHiddenSubOptions(n) }
    ], attrs: { divider: !1 } }, [t.hasSelectAllOptions && !t.maxSelectableOptions ? e("acv-list-item", { class: `select-all-container-${t.getOptionKey(n, s)}` }, [e("acv-checkbox", { attrs: { id: `select-all-${t.getOptionKey(n, s)}`, "full-width": t.fullWidth, "bg-dark-mode": t.bgDarkMode, "bg-orange": t.bgOrange, value: t.getSelectAllForOption(n), disabled: t.getSelectAllForOption(n) || n[t.disabledKey], button: t.buttons, label: t.selectAllText }, on: { change: function(r) {
      return t.setSubOptionsValue(!1, n);
    } } })], 1) : t._e(), e("transition-group", { attrs: { name: "toggle-sub-options" } }, t._l(t.getVisibleSubOptions(n), function(r, a) {
      return e("acv-list-item", { key: t.getOptionKey(r, a, n), staticClass: "sub-option-item" }, [e("div", { staticClass: "tw-flexbox-row-align-center-justify-between", class: { "tw-w-full": t.fullWidth } }, [t._t(`${t.getOptionKey(r, a, n)}-before`, null, { subOption: r }), e("acv-checkbox", { attrs: { id: `sub-option-${t.getOptionKey(r, a, n)}`, "full-width": t.fullWidth, button: t.buttons, "bg-dark-mode": t.bgDarkMode, "bg-orange": t.bgOrange, label: r[t.labelKey], disabled: t.maxSelectableOptionsReached && !r[t.valueKey] || n[t.disabledKey] }, on: { change: function(o) {
        return t.handleSubOptionChanged(o, r, n);
      } }, model: { value: r[t.valueKey], callback: function(o) {
        t.$set(r, t.valueKey, o);
      }, expression: "subOption[valueKey]" } }), t.maxSelectableOptionsReached && !r[t.valueKey] ? e("acv-tooltip", { attrs: { target: `label[for=sub-option-${t.getOptionKey(r, a, n)}] > div`, position: "right" } }, [t._v(" " + t._s(t.disabledOptionLabel) + " ")]) : t._e()], 2), t._t(`${t.getOptionKey(r, a, n)}-after`, null, { subOption: r })], 2);
    }), 1), t.hasHiddenSubOptions(n) ? e("acv-list-item", { staticClass: "sub-options-expansion-text" }, [e("div", { staticClass: "tw-flexbox-row-align-center tw-w-full", on: { click: function(r) {
      return t.handleExpandIconClicked(
        n,
        t.expandedSubOptions,
        "subOptionsExpansionToggled"
      );
    }, keypress: function(r) {
      return !r.type.indexOf("key") && t._k(r.keyCode, "space", 32, r.key, [" ", "Spacebar"]) ? null : t.handleExpandIconClicked(
        n,
        t.expandedSubOptions,
        "subOptionsExpansionToggled"
      );
    } } }, [t._t(`${t.getOptionKey(n, s)}-subOptionExpansionIcon`, function() {
      return [e("div", { staticClass: "sub-option-expansion-icon tw-flexbox-row-align-center", class: `sub-option-expansion-icon-${t.getOptionKey(n, s)}` }, [t._v(" " + t._s(t.getSubOptionExpansionText(n)) + " ")])];
    }, { option: n })], 2)]) : t._e()], 1) : t._e()], 1)], 1)], 1);
  }), 1);
}, m2 = [], v2 = /* @__PURE__ */ U(
  p2,
  g2,
  m2,
  !1,
  null,
  "a0cc9975"
);
const A2 = v2.exports, b2 = {
  name: "AcvLabel",
  mixins: [
    en,
    fe
  ],
  props: {
    tag: {
      type: String,
      default: "div"
    },
    uppercase: {
      type: Boolean,
      default: !0
    }
  }
};
var y2 = function() {
  var t = this, e = t._self._c;
  return e(t.tag, { tag: "component", staticClass: "acv-label", class: t.fontClasses, style: [t.fontStyles, t.sizeStyles] }, [t._t("default")], 2);
}, _2 = [], x2 = /* @__PURE__ */ U(
  b2,
  y2,
  _2,
  !1,
  null,
  "20598cae"
);
const wa = x2.exports, Ah = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: wa
}, Symbol.toStringTag, { value: "Module" })), C2 = {
  name: "AcvConfirmationTextInputs",
  components: {
    AcvCurrencyInput: () => Promise.resolve().then(() => B2),
    AcvLabel: wa
  },
  mixins: [
    ue
  ],
  props: {
    value: {
      type: Object,
      default: () => ({
        value: "",
        confirmValue: ""
      })
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    inputLabel: {
      type: String,
      required: !0
    },
    isCurrencyInput: {
      type: Boolean,
      default: !1
    },
    currencyInputMaskOptions: {
      type: Object,
      default: () => {
      }
    }
  },
  watch: {
    // eslint-disable-next-line func-names
    "value.value": function() {
      this.$emit("input", this.internalValue), this.checkValuesMatch();
    },
    // eslint-disable-next-line func-names
    "value.confirmValue": function() {
      this.$emit("input", this.internalValue), this.checkValuesMatch();
    }
  },
  mounted() {
    this.checkValuesMatch();
  },
  methods: {
    checkValuesMatch() {
      const i = this.internalValue.value === this.internalValue.confirmValue;
      this.$emit("values-match-changed", i);
    }
  }
};
var S2 = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "acv-confirmation-text-inputs" }, [t._t("before-inputs"), e("acv-label", { staticClass: "info-label", attrs: { for: `${t.internalId}`, tag: "label", uppercase: !1 } }, [t._v(" " + t._s(t.inputLabel) + " ")]), e("div", { staticClass: "price" }, [t.isCurrencyInput ? e("acv-currency-input", { attrs: { id: `${t.internalId}`, disabled: t.disabled, "mask-options": t.currencyInputMaskOptions }, on: { keyup: function(n) {
    return t.$emit("keyup", n);
  } }, model: { value: t.internalValue.value, callback: function(n) {
    t.$set(t.internalValue, "value", n);
  }, expression: "internalValue.value" } }) : e("input", { directives: [{ name: "model", rawName: "v-model", value: t.internalValue.value, expression: "internalValue.value" }], attrs: { id: `${t.internalId}`, name: `${t.internalId}`, disabled: t.disabled, type: "text" }, domProps: { value: t.internalValue.value }, on: { keyup: function(n) {
    return t.$emit("keyup", n);
  }, input: function(n) {
    n.target.composing || t.$set(t.internalValue, "value", n.target.value);
  } } })], 1), t._t("between-inputs"), e("acv-label", { staticClass: "info-label", attrs: { for: `confirm-${t.internalId}`, tag: "label", uppercase: !1 } }, [t._v(" Confirm " + t._s(t.inputLabel) + " ")]), e("div", { staticClass: "price" }, [t.isCurrencyInput ? e("acv-currency-input", { attrs: { id: `confirm-${t.internalId}`, disabled: t.disabled, "mask-options": t.currencyInputMaskOptions }, on: { keyup: function(n) {
    return t.$emit("keyup", n);
  } }, model: { value: t.internalValue.confirmValue, callback: function(n) {
    t.$set(t.internalValue, "confirmValue", n);
  }, expression: "internalValue.confirmValue" } }) : e("input", { directives: [{ name: "model", rawName: "v-model", value: t.internalValue.confirmValue, expression: "internalValue.confirmValue" }], attrs: { id: `confirm-${t.internalId}`, name: `confirm-${t.internalId}`, disabled: t.disabled, type: "text" }, domProps: { value: t.internalValue.confirmValue }, on: { keyup: function(n) {
    return t.$emit("keyup", n);
  }, input: function(n) {
    n.target.composing || t.$set(t.internalValue, "confirmValue", n.target.value);
  } } })], 1), t._t("after-inputs")], 2);
}, w2 = [], k2 = /* @__PURE__ */ U(
  C2,
  S2,
  w2,
  !1,
  null,
  "bdf89e21"
);
const O2 = k2.exports, M2 = {
  name: "AcvMoney",
  deprecated: "AcvMoney is deprecated. Please use AcvMoneyField",
  directives: { money: mh },
  mixins: [
    ue
  ],
  props: {
    value: {
      required: !0,
      type: [Number, String],
      default: 0
    },
    masked: {
      type: Boolean,
      default: !1
    },
    precision: {
      type: Number,
      default: () => Di.precision
    },
    decimal: {
      type: String,
      default: () => Di.decimal
    },
    thousands: {
      type: String,
      default: () => Di.thousands
    },
    prefix: {
      type: String,
      default: () => Di.prefix
    },
    suffix: {
      type: String,
      default: () => Di.suffix
    },
    allowBlank: {
      type: Boolean,
      default: () => Di.allowBlank
    },
    placeholder: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      formattedValue: ""
    };
  },
  watch: {
    value: {
      immediate: !0,
      handler(i) {
        const t = qr(i, this.$props);
        t !== this.formattedValue && (this.formattedValue = t);
      }
    }
  },
  methods: {
    change(i) {
      this.$emit("input", this.masked ? i.target.value : Bs(i.target.value, this.precision, this.allowBlank));
    }
  }
};
var T2 = function() {
  var t = this, e = t._self._c;
  return e("input", { directives: [{ name: "money", rawName: "v-money", value: {
    precision: t.precision,
    decimal: t.decimal,
    thousands: t.thousands,
    prefix: t.prefix,
    suffix: t.suffix,
    allowBlank: t.allowBlank
  }, expression: `{
    precision, decimal, thousands, prefix, suffix, allowBlank,
  }` }], staticClass: "v-money", attrs: { id: t.internalId, name: t.internalId, type: "tel", autocomplete: "off", placeholder: t.placeholder }, domProps: { value: t.formattedValue }, on: { change: t.change, keyup: function(n) {
    return t.$emit("keyup", n);
  }, keydown: function(n) {
    return t.$emit("keydown", n);
  } } });
}, D2 = [], P2 = /* @__PURE__ */ U(
  M2,
  T2,
  D2,
  !1,
  null,
  null
);
const bh = P2.exports, L2 = {
  name: "AcvCurrencyInput",
  components: {
    AcvMoney: bh,
    AcvIcon: () => Promise.resolve().then(() => Ie)
  },
  mixins: [
    ue
  ],
  props: {
    value: {
      type: [Number, String],
      default: 0
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    maskOptions: {
      type: Object,
      default: () => {
      }
    },
    showCurrencySymbol: {
      type: Boolean,
      default: !0
    },
    currencySymbol: {
      type: String,
      default: "attach_money"
    },
    placeholder: {
      type: String,
      default: null
    },
    step: {
      type: Number,
      default: 50
    },
    maxlength: {
      type: Number,
      default: void 0
    }
  },
  data() {
    return {
      defaultvMoneyMaskOptions: {
        decimal: "",
        thousands: ",",
        prefix: "",
        suffix: "",
        precision: 0,
        masked: !1,
        allowBlank: !0
      }
    };
  },
  computed: {
    vMoneyMaskOptions() {
      return { ...this.defaultvMoneyMaskOptions, ...this.maskOptions };
    }
  },
  methods: {
    up() {
      this.internalValue += this.step;
    },
    down() {
      const i = this.internalValue - this.step;
      this.internalValue = i > 0 ? i : 0;
    }
  }
};
var I2 = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "acv-currency-input" }, [e("div", { staticClass: "input-group" }, [e("div", { staticClass: "input-group-prepend" }, [e("span", { staticClass: "input-group-text", class: {
    "sr-only": !t.showCurrencySymbol
  }, attrs: { id: "dollar-addon" } }, [e("acv-icon", { attrs: { icon: t.currencySymbol } })], 1)]), e("label", { staticClass: "sr-only", attrs: { for: t.internalId } }, [t._v(" " + t._s(t.internalId) + " ")]), e("acv-money", t._b({ staticClass: "form-control", attrs: { id: t.internalId, disabled: t.disabled, name: t.internalId, "aria-describedby": "dollar-addon", placeholder: t.placeholder, maxlength: t.maxlength }, on: { keyup: function(n) {
    return t.$emit("keyup", n);
  }, keydown: [function(n) {
    return !n.type.indexOf("key") && t._k(n.keyCode, "up", 38, n.key, ["Up", "ArrowUp"]) ? null : (n.preventDefault(), t.up.apply(null, arguments));
  }, function(n) {
    return !n.type.indexOf("key") && t._k(n.keyCode, "down", 40, n.key, ["Down", "ArrowDown"]) ? null : (n.preventDefault(), t.down.apply(null, arguments));
  }] }, model: { value: t.internalValue, callback: function(n) {
    t.internalValue = n;
  }, expression: "internalValue" } }, "acv-money", t.vMoneyMaskOptions, !1))], 1)]);
}, E2 = [], $2 = /* @__PURE__ */ U(
  L2,
  I2,
  E2,
  !1,
  null,
  "dc666af0"
);
const yh = $2.exports, B2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: yh
}, Symbol.toStringTag, { value: "Module" }));
function Zn(i) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Zn = function(t) {
    return typeof t;
  } : Zn = function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Zn(i);
}
function R2(i, t) {
  if (!(i instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function F2(i, t) {
  for (var e = 0; e < t.length; e++) {
    var n = t[e];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(i, n.key, n);
  }
}
function N2(i, t, e) {
  return t && F2(i.prototype, t), i;
}
function H2(i, t, e) {
  return t in i ? Object.defineProperty(i, t, {
    value: e,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : i[t] = e, i;
}
function kl(i) {
  for (var t = 1; t < arguments.length; t++) {
    var e = arguments[t] != null ? arguments[t] : {}, n = Object.keys(e);
    typeof Object.getOwnPropertySymbols == "function" && (n = n.concat(Object.getOwnPropertySymbols(e).filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    }))), n.forEach(function(s) {
      H2(i, s, e[s]);
    });
  }
  return i;
}
var V2 = /* @__PURE__ */ function() {
  function i(t, e, n, s) {
    R2(this, i), this.language = t, this.months = e, this.monthsAbbr = n, this.days = s, this.rtl = !1, this.ymd = !1, this.yearSuffix = "";
  }
  return N2(i, [{
    key: "language",
    get: function() {
      return this._language;
    },
    set: function(e) {
      if (typeof e != "string")
        throw new TypeError("Language must be a string");
      this._language = e;
    }
  }, {
    key: "months",
    get: function() {
      return this._months;
    },
    set: function(e) {
      if (e.length !== 12)
        throw new RangeError("There must be 12 months for ".concat(this.language, " language"));
      this._months = e;
    }
  }, {
    key: "monthsAbbr",
    get: function() {
      return this._monthsAbbr;
    },
    set: function(e) {
      if (e.length !== 12)
        throw new RangeError("There must be 12 abbreviated months for ".concat(this.language, " language"));
      this._monthsAbbr = e;
    }
  }, {
    key: "days",
    get: function() {
      return this._days;
    },
    set: function(e) {
      if (e.length !== 7)
        throw new RangeError("There must be 7 days for ".concat(this.language, " language"));
      this._days = e;
    }
  }]), i;
}(), _h = new V2("English", ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]), xh = {
  /**
   * @type {Boolean}
   */
  useUtc: !1,
  /**
   * Returns the full year, using UTC or not
   * @param {Date} date
   */
  getFullYear: function(t) {
    return this.useUtc ? t.getUTCFullYear() : t.getFullYear();
  },
  /**
   * Returns the month, using UTC or not
   * @param {Date} date
   */
  getMonth: function(t) {
    return this.useUtc ? t.getUTCMonth() : t.getMonth();
  },
  /**
   * Returns the date, using UTC or not
   * @param {Date} date
   */
  getDate: function(t) {
    return this.useUtc ? t.getUTCDate() : t.getDate();
  },
  /**
   * Returns the day, using UTC or not
   * @param {Date} date
   */
  getDay: function(t) {
    return this.useUtc ? t.getUTCDay() : t.getDay();
  },
  /**
   * Returns the hours, using UTC or not
   * @param {Date} date
   */
  getHours: function(t) {
    return this.useUtc ? t.getUTCHours() : t.getHours();
  },
  /**
   * Returns the minutes, using UTC or not
   * @param {Date} date
   */
  getMinutes: function(t) {
    return this.useUtc ? t.getUTCMinutes() : t.getMinutes();
  },
  /**
   * Sets the full year, using UTC or not
   * @param {Date} date
   */
  setFullYear: function(t, e, n) {
    return this.useUtc ? t.setUTCFullYear(e) : t.setFullYear(e);
  },
  /**
   * Sets the month, using UTC or not
   * @param {Date} date
   */
  setMonth: function(t, e, n) {
    return this.useUtc ? t.setUTCMonth(e) : t.setMonth(e);
  },
  /**
   * Sets the date, using UTC or not
   * @param {Date} date
   * @param {Number} value
   */
  setDate: function(t, e, n) {
    return this.useUtc ? t.setUTCDate(e) : t.setDate(e);
  },
  /**
   * Check if date1 is equivalent to date2, without comparing the time
   * @see https://stackoverflow.com/a/6202196/4455925
   * @param {Date} date1
   * @param {Date} date2
   */
  compareDates: function(t, e) {
    var n = new Date(t.getTime()), s = new Date(e.getTime());
    return this.useUtc ? (n.setUTCHours(0, 0, 0, 0), s.setUTCHours(0, 0, 0, 0)) : (n.setHours(0, 0, 0, 0), s.setHours(0, 0, 0, 0)), n.getTime() === s.getTime();
  },
  /**
   * Validates a date object
   * @param {Date} date - an object instantiated with the new Date constructor
   * @return {Boolean}
   */
  isValidDate: function(t) {
    return Object.prototype.toString.call(t) !== "[object Date]" ? !1 : !isNaN(t.getTime());
  },
  /**
   * Return abbreviated week day name
   * @param {Date}
   * @param {Array}
   * @return {String}
   */
  getDayNameAbbr: function(t, e) {
    if (Zn(t) !== "object")
      throw TypeError("Invalid Type");
    return e[this.getDay(t)];
  },
  /**
   * Return name of the month
   * @param {Number|Date}
   * @param {Array}
   * @return {String}
   */
  getMonthName: function(t, e) {
    if (!e)
      throw Error("missing 2nd parameter Months array");
    if (Zn(t) === "object")
      return e[this.getMonth(t)];
    if (typeof t == "number")
      return e[t];
    throw TypeError("Invalid type");
  },
  /**
   * Return an abbreviated version of the month
   * @param {Number|Date}
   * @return {String}
   */
  getMonthNameAbbr: function(t, e) {
    if (!e)
      throw Error("missing 2nd paramter Months array");
    if (Zn(t) === "object")
      return e[this.getMonth(t)];
    if (typeof t == "number")
      return e[t];
    throw TypeError("Invalid type");
  },
  /**
   * Alternative get total number of days in month
   * @param {Number} year
   * @param {Number} m
   * @return {Number}
   */
  daysInMonth: function(t, e) {
    return /8|3|5|10/.test(e) ? 30 : e === 1 ? !(t % 4) && t % 100 || !(t % 400) ? 29 : 28 : 31;
  },
  /**
   * Get nth suffix for date
   * @param {Number} day
   * @return {String}
   */
  getNthSuffix: function(t) {
    switch (t) {
      case 1:
      case 21:
      case 31:
        return "st";
      case 2:
      case 22:
        return "nd";
      case 3:
      case 23:
        return "rd";
      default:
        return "th";
    }
  },
  /**
   * Formats date object
   * @param {Date}
   * @param {String}
   * @param {Object}
   * @return {String}
   */
  formatDate: function(t, e, n) {
    n = n || _h;
    var s = this.getFullYear(t), r = this.getMonth(t) + 1, a = this.getDate(t), o = e.replace(/dd/, ("0" + a).slice(-2)).replace(/d/, a).replace(/yyyy/, s).replace(/yy/, String(s).slice(2)).replace(/MMMM/, this.getMonthName(this.getMonth(t), n.months)).replace(/MMM/, this.getMonthNameAbbr(this.getMonth(t), n.monthsAbbr)).replace(/MM/, ("0" + r).slice(-2)).replace(/M(?!a|ä|e)/, r).replace(/su/, this.getNthSuffix(this.getDate(t))).replace(/D(?!e|é|i)/, this.getDayNameAbbr(t, n.days));
    return o;
  },
  /**
   * Creates an array of dates for each day in between two dates.
   * @param {Date} start
   * @param {Date} end
   * @return {Array}
   */
  createDateArray: function(t, e) {
    for (var n = []; t <= e; )
      n.push(new Date(t)), t = this.setDate(new Date(t), this.getDate(new Date(t)) + 1);
    return n;
  },
  /**
   * method used as a prop validator for input values
   * @param {*} val
   * @return {Boolean}
   */
  validateDateInput: function(t) {
    return t === null || t instanceof Date || typeof t == "string" || typeof t == "number";
  }
}, qs = function(t) {
  return kl({}, xh, {
    useUtc: t
  });
}, Ic = kl({}, xh), z2 = {
  props: {
    selectedDate: Date,
    resetTypedDate: [Date],
    format: [String, Function],
    translation: Object,
    inline: Boolean,
    id: String,
    name: String,
    refName: String,
    openDate: Date,
    placeholder: String,
    inputClass: [String, Object, Array],
    clearButton: Boolean,
    clearButtonIcon: String,
    calendarButton: Boolean,
    calendarButtonIcon: String,
    calendarButtonIconContent: String,
    disabled: Boolean,
    required: Boolean,
    typeable: Boolean,
    bootstrapStyling: Boolean,
    useUtc: Boolean
  },
  data: function() {
    var t = qs(this.useUtc);
    return {
      input: null,
      typedDate: !1,
      utils: t
    };
  },
  computed: {
    formattedValue: function() {
      return this.selectedDate ? this.typedDate ? this.typedDate : typeof this.format == "function" ? this.format(this.selectedDate) : this.utils.formatDate(new Date(this.selectedDate), this.format, this.translation) : null;
    },
    computedInputClass: function() {
      return this.bootstrapStyling ? typeof this.inputClass == "string" ? [this.inputClass, "form-control"].join(" ") : kl({
        "form-control": !0
      }, this.inputClass) : this.inputClass;
    }
  },
  watch: {
    resetTypedDate: function() {
      this.typedDate = !1;
    }
  },
  methods: {
    showCalendar: function() {
      this.$emit("showCalendar");
    },
    /**
     * Attempt to parse a typed date
     * @param {Event} event
     */
    parseTypedDate: function(t) {
      if ([
        27,
        // escape
        13
        // enter
      ].includes(t.keyCode) && this.input.blur(), this.typeable) {
        var e = Date.parse(this.input.value);
        isNaN(e) || (this.typedDate = this.input.value, this.$emit("typedDate", new Date(this.typedDate)));
      }
    },
    /**
     * nullify the typed date to defer to regular formatting
     * called once the input is blurred
     */
    inputBlurred: function() {
      this.typeable && isNaN(Date.parse(this.input.value)) && (this.clearDate(), this.input.value = null, this.typedDate = null), this.$emit("closeCalendar");
    },
    /**
     * emit a clearDate event
     */
    clearDate: function() {
      this.$emit("clearDate");
    }
  },
  mounted: function() {
    this.input = this.$el.querySelector("input");
  }
};
function j2(i, t, e, n, s, r, a, o, l, c) {
  typeof a != "boolean" && (l = o, o = a, a = !1);
  var u = typeof e == "function" ? e.options : e;
  i && i.render && (u.render = i.render, u.staticRenderFns = i.staticRenderFns, u._compiled = !0, s && (u.functional = !0)), n && (u._scopeId = n);
  var d;
  if (r ? (d = function(g) {
    g = g || // cached call
    this.$vnode && this.$vnode.ssrContext || // stateful
    this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, !g && typeof __VUE_SSR_CONTEXT__ < "u" && (g = __VUE_SSR_CONTEXT__), t && t.call(this, l(g)), g && g._registeredComponents && g._registeredComponents.add(r);
  }, u._ssrRegister = d) : t && (d = a ? function() {
    t.call(this, c(this.$root.$options.shadowRoot));
  } : function(p) {
    t.call(this, o(p));
  }), d)
    if (u.functional) {
      var h = u.render;
      u.render = function(g, m) {
        return d.call(m), h(g, m);
      };
    } else {
      var f = u.beforeCreate;
      u.beforeCreate = f ? [].concat(f, d) : [d];
    }
  return e;
}
var tr = j2;
const W2 = z2;
var Ch = function() {
  var i = this, t = i.$createElement, e = i._self._c || t;
  return e(
    "div",
    { class: { "input-group": i.bootstrapStyling } },
    [
      i.calendarButton ? e(
        "span",
        {
          staticClass: "vdp-datepicker__calendar-button",
          class: { "input-group-prepend": i.bootstrapStyling },
          style: { "cursor:not-allowed;": i.disabled },
          on: { click: i.showCalendar }
        },
        [
          e(
            "span",
            { class: { "input-group-text": i.bootstrapStyling } },
            [
              e("i", { class: i.calendarButtonIcon }, [
                i._v(
                  `
        ` + i._s(i.calendarButtonIconContent) + `
        `
                ),
                i.calendarButtonIcon ? i._e() : e("span", [i._v("…")])
              ])
            ]
          )
        ]
      ) : i._e(),
      i._v(" "),
      e("input", {
        ref: i.refName,
        class: i.computedInputClass,
        attrs: {
          type: i.inline ? "hidden" : "text",
          name: i.name,
          id: i.id,
          "open-date": i.openDate,
          placeholder: i.placeholder,
          "clear-button": i.clearButton,
          disabled: i.disabled,
          required: i.required,
          readonly: !i.typeable,
          autocomplete: "off"
        },
        domProps: { value: i.formattedValue },
        on: {
          click: i.showCalendar,
          keyup: i.parseTypedDate,
          blur: i.inputBlurred
        }
      }),
      i._v(" "),
      i.clearButton && i.selectedDate ? e(
        "span",
        {
          staticClass: "vdp-datepicker__clear-button",
          class: { "input-group-append": i.bootstrapStyling },
          on: {
            click: function(n) {
              return i.clearDate();
            }
          }
        },
        [
          e(
            "span",
            { class: { "input-group-text": i.bootstrapStyling } },
            [
              e("i", { class: i.clearButtonIcon }, [
                i.clearButtonIcon ? i._e() : e("span", [i._v("×")])
              ])
            ]
          )
        ]
      ) : i._e(),
      i._v(" "),
      i._t("afterDateInput")
    ],
    2
  );
}, Y2 = [];
Ch._withStripped = !0;
const U2 = void 0, Z2 = void 0, G2 = void 0, K2 = !1;
var X2 = tr(
  { render: Ch, staticRenderFns: Y2 },
  U2,
  W2,
  Z2,
  K2,
  G2,
  void 0,
  void 0
), Q2 = {
  props: {
    showDayView: Boolean,
    selectedDate: Date,
    pageDate: Date,
    pageTimestamp: Number,
    fullMonthName: Boolean,
    allowedToShowView: Function,
    dayCellContent: {
      type: Function,
      default: function(t) {
        return t.date;
      }
    },
    disabledDates: Object,
    highlighted: Object,
    calendarClass: [String, Object, Array],
    calendarStyle: Object,
    translation: Object,
    isRtl: Boolean,
    mondayFirst: Boolean,
    useUtc: Boolean
  },
  data: function() {
    var t = qs(this.useUtc);
    return {
      utils: t
    };
  },
  computed: {
    /**
     * Returns an array of day names
     * @return {String[]}
     */
    daysOfWeek: function() {
      if (this.mondayFirst) {
        var t = this.translation.days.slice();
        return t.push(t.shift()), t;
      }
      return this.translation.days;
    },
    /**
     * Returns the day number of the week less one for the first of the current month
     * Used to show amount of empty cells before the first in the day calendar layout
     * @return {Number}
     */
    blankDays: function() {
      var t = this.pageDate, e = this.useUtc ? new Date(Date.UTC(t.getUTCFullYear(), t.getUTCMonth(), 1)) : new Date(t.getFullYear(), t.getMonth(), 1, t.getHours(), t.getMinutes());
      return this.mondayFirst ? this.utils.getDay(e) > 0 ? this.utils.getDay(e) - 1 : 6 : this.utils.getDay(e);
    },
    /**
     * @return {Object[]}
     */
    days: function() {
      for (var t = this.pageDate, e = [], n = this.useUtc ? new Date(Date.UTC(t.getUTCFullYear(), t.getUTCMonth(), 1)) : new Date(t.getFullYear(), t.getMonth(), 1, t.getHours(), t.getMinutes()), s = this.utils.daysInMonth(this.utils.getFullYear(n), this.utils.getMonth(n)), r = 0; r < s; r++)
        e.push({
          date: this.utils.getDate(n),
          timestamp: n.getTime(),
          isSelected: this.isSelectedDate(n),
          isDisabled: this.isDisabledDate(n),
          isHighlighted: this.isHighlightedDate(n),
          isHighlightStart: this.isHighlightStart(n),
          isHighlightEnd: this.isHighlightEnd(n),
          isToday: this.utils.compareDates(n, /* @__PURE__ */ new Date()),
          isWeekend: this.utils.getDay(n) === 0 || this.utils.getDay(n) === 6,
          isSaturday: this.utils.getDay(n) === 6,
          isSunday: this.utils.getDay(n) === 0
        }), this.utils.setDate(n, this.utils.getDate(n) + 1);
      return e;
    },
    /**
     * Gets the name of the month the current page is on
     * @return {String}
     */
    currMonthName: function() {
      var t = this.fullMonthName ? this.translation.months : this.translation.monthsAbbr;
      return this.utils.getMonthNameAbbr(this.utils.getMonth(this.pageDate), t);
    },
    /**
     * Gets the name of the year that current page is on
     * @return {Number}
     */
    currYearName: function() {
      var t = this.translation.yearSuffix;
      return "".concat(this.utils.getFullYear(this.pageDate)).concat(t);
    },
    /**
     * Is this translation using year/month/day format?
     * @return {Boolean}
     */
    isYmd: function() {
      return this.translation.ymd && this.translation.ymd === !0;
    },
    /**
     * Is the left hand navigation button disabled?
     * @return {Boolean}
     */
    isLeftNavDisabled: function() {
      return this.isRtl ? this.isNextMonthDisabled(this.pageTimestamp) : this.isPreviousMonthDisabled(this.pageTimestamp);
    },
    /**
     * Is the right hand navigation button disabled?
     * @return {Boolean}
     */
    isRightNavDisabled: function() {
      return this.isRtl ? this.isPreviousMonthDisabled(this.pageTimestamp) : this.isNextMonthDisabled(this.pageTimestamp);
    }
  },
  methods: {
    selectDate: function(t) {
      if (t.isDisabled)
        return this.$emit("selectedDisabled", t), !1;
      this.$emit("selectDate", t);
    },
    /**
     * @return {Number}
     */
    getPageMonth: function() {
      return this.utils.getMonth(this.pageDate);
    },
    /**
     * Emit an event to show the month picker
     */
    showMonthCalendar: function() {
      this.$emit("showMonthCalendar");
    },
    /**
     * Change the page month
     * @param {Number} incrementBy
     */
    changeMonth: function(t) {
      var e = this.pageDate;
      this.utils.setMonth(e, this.utils.getMonth(e) + t), this.$emit("changedMonth", e);
    },
    /**
     * Decrement the page month
     */
    previousMonth: function() {
      this.isPreviousMonthDisabled() || this.changeMonth(-1);
    },
    /**
     * Is the previous month disabled?
     * @return {Boolean}
     */
    isPreviousMonthDisabled: function() {
      if (!this.disabledDates || !this.disabledDates.to)
        return !1;
      var t = this.pageDate;
      return this.utils.getMonth(this.disabledDates.to) >= this.utils.getMonth(t) && this.utils.getFullYear(this.disabledDates.to) >= this.utils.getFullYear(t);
    },
    /**
     * Increment the current page month
     */
    nextMonth: function() {
      this.isNextMonthDisabled() || this.changeMonth(1);
    },
    /**
     * Is the next month disabled?
     * @return {Boolean}
     */
    isNextMonthDisabled: function() {
      if (!this.disabledDates || !this.disabledDates.from)
        return !1;
      var t = this.pageDate;
      return this.utils.getMonth(this.disabledDates.from) <= this.utils.getMonth(t) && this.utils.getFullYear(this.disabledDates.from) <= this.utils.getFullYear(t);
    },
    /**
     * Whether a day is selected
     * @param {Date}
     * @return {Boolean}
     */
    isSelectedDate: function(t) {
      return this.selectedDate && this.utils.compareDates(this.selectedDate, t);
    },
    /**
     * Whether a day is disabled
     * @param {Date}
     * @return {Boolean}
     */
    isDisabledDate: function(t) {
      var e = this, n = !1;
      return typeof this.disabledDates > "u" ? !1 : (typeof this.disabledDates.dates < "u" && this.disabledDates.dates.forEach(function(s) {
        if (e.utils.compareDates(t, s))
          return n = !0, !0;
      }), typeof this.disabledDates.to < "u" && this.disabledDates.to && t < this.disabledDates.to && (n = !0), typeof this.disabledDates.from < "u" && this.disabledDates.from && t > this.disabledDates.from && (n = !0), typeof this.disabledDates.ranges < "u" && this.disabledDates.ranges.forEach(function(s) {
        if (typeof s.from < "u" && s.from && typeof s.to < "u" && s.to && t < s.to && t > s.from)
          return n = !0, !0;
      }), typeof this.disabledDates.days < "u" && this.disabledDates.days.indexOf(this.utils.getDay(t)) !== -1 && (n = !0), typeof this.disabledDates.daysOfMonth < "u" && this.disabledDates.daysOfMonth.indexOf(this.utils.getDate(t)) !== -1 && (n = !0), typeof this.disabledDates.customPredictor == "function" && this.disabledDates.customPredictor(t) && (n = !0), n);
    },
    /**
     * Whether a day is highlighted (only if it is not disabled already except when highlighted.includeDisabled is true)
     * @param {Date}
     * @return {Boolean}
     */
    isHighlightedDate: function(t) {
      var e = this;
      if (!(this.highlighted && this.highlighted.includeDisabled) && this.isDisabledDate(t))
        return !1;
      var n = !1;
      return typeof this.highlighted > "u" ? !1 : (typeof this.highlighted.dates < "u" && this.highlighted.dates.forEach(function(s) {
        if (e.utils.compareDates(t, s))
          return n = !0, !0;
      }), this.isDefined(this.highlighted.from) && this.isDefined(this.highlighted.to) && (n = t >= this.highlighted.from && t <= this.highlighted.to), typeof this.highlighted.days < "u" && this.highlighted.days.indexOf(this.utils.getDay(t)) !== -1 && (n = !0), typeof this.highlighted.daysOfMonth < "u" && this.highlighted.daysOfMonth.indexOf(this.utils.getDate(t)) !== -1 && (n = !0), typeof this.highlighted.customPredictor == "function" && this.highlighted.customPredictor(t) && (n = !0), n);
    },
    dayClasses: function(t) {
      return {
        selected: t.isSelected,
        disabled: t.isDisabled,
        highlighted: t.isHighlighted,
        today: t.isToday,
        weekend: t.isWeekend,
        sat: t.isSaturday,
        sun: t.isSunday,
        "highlight-start": t.isHighlightStart,
        "highlight-end": t.isHighlightEnd
      };
    },
    /**
     * Whether a day is highlighted and it is the first date
     * in the highlighted range of dates
     * @param {Date}
     * @return {Boolean}
     */
    isHighlightStart: function(t) {
      return this.isHighlightedDate(t) && this.highlighted.from instanceof Date && this.utils.getFullYear(this.highlighted.from) === this.utils.getFullYear(t) && this.utils.getMonth(this.highlighted.from) === this.utils.getMonth(t) && this.utils.getDate(this.highlighted.from) === this.utils.getDate(t);
    },
    /**
     * Whether a day is highlighted and it is the first date
     * in the highlighted range of dates
     * @param {Date}
     * @return {Boolean}
     */
    isHighlightEnd: function(t) {
      return this.isHighlightedDate(t) && this.highlighted.to instanceof Date && this.utils.getFullYear(this.highlighted.to) === this.utils.getFullYear(t) && this.utils.getMonth(this.highlighted.to) === this.utils.getMonth(t) && this.utils.getDate(this.highlighted.to) === this.utils.getDate(t);
    },
    /**
     * Helper
     * @param  {mixed}  prop
     * @return {Boolean}
     */
    isDefined: function(t) {
      return typeof t < "u" && t;
    }
  }
  // eslint-disable-next-line
};
const J2 = Q2;
var Sh = function() {
  var i = this, t = i.$createElement, e = i._self._c || t;
  return e(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: i.showDayView,
          expression: "showDayView"
        }
      ],
      class: [i.calendarClass, "vdp-datepicker__calendar"],
      style: i.calendarStyle,
      on: {
        mousedown: function(n) {
          n.preventDefault();
        }
      }
    },
    [
      i._t("beforeCalendarHeader"),
      i._v(" "),
      e("header", [
        e(
          "span",
          {
            staticClass: "prev",
            class: { disabled: i.isLeftNavDisabled },
            on: {
              click: function(n) {
                i.isRtl ? i.nextMonth() : i.previousMonth();
              }
            }
          },
          [i._v("<")]
        ),
        i._v(" "),
        e(
          "span",
          {
            staticClass: "day__month_btn",
            class: i.allowedToShowView("month") ? "up" : "",
            on: { click: i.showMonthCalendar }
          },
          [
            i._v(
              i._s(i.isYmd ? i.currYearName : i.currMonthName) + " " + i._s(i.isYmd ? i.currMonthName : i.currYearName)
            )
          ]
        ),
        i._v(" "),
        e(
          "span",
          {
            staticClass: "next",
            class: { disabled: i.isRightNavDisabled },
            on: {
              click: function(n) {
                i.isRtl ? i.previousMonth() : i.nextMonth();
              }
            }
          },
          [i._v(">")]
        )
      ]),
      i._v(" "),
      e(
        "div",
        { class: i.isRtl ? "flex-rtl" : "" },
        [
          i._l(i.daysOfWeek, function(n) {
            return e(
              "span",
              { key: n.timestamp, staticClass: "cell day-header" },
              [i._v(i._s(n))]
            );
          }),
          i._v(" "),
          i.blankDays > 0 ? i._l(i.blankDays, function(n) {
            return e("span", {
              key: n.timestamp,
              staticClass: "cell day blank"
            });
          }) : i._e(),
          i._l(i.days, function(n) {
            return e("span", {
              key: n.timestamp,
              staticClass: "cell day",
              class: i.dayClasses(n),
              domProps: { innerHTML: i._s(i.dayCellContent(n)) },
              on: {
                click: function(s) {
                  return i.selectDate(n);
                }
              }
            });
          })
        ],
        2
      )
    ],
    2
  );
}, q2 = [];
Sh._withStripped = !0;
const tv = void 0, ev = void 0, iv = void 0, nv = !1;
var sv = tr(
  { render: Sh, staticRenderFns: q2 },
  tv,
  J2,
  ev,
  nv,
  iv,
  void 0,
  void 0
), rv = {
  props: {
    showMonthView: Boolean,
    selectedDate: Date,
    pageDate: Date,
    pageTimestamp: Number,
    disabledDates: Object,
    calendarClass: [String, Object, Array],
    calendarStyle: Object,
    translation: Object,
    isRtl: Boolean,
    allowedToShowView: Function,
    useUtc: Boolean
  },
  data: function() {
    var t = qs(this.useUtc);
    return {
      utils: t
    };
  },
  computed: {
    months: function() {
      for (var t = this.pageDate, e = [], n = this.useUtc ? new Date(Date.UTC(t.getUTCFullYear(), 0, t.getUTCDate())) : new Date(t.getFullYear(), 0, t.getDate(), t.getHours(), t.getMinutes()), s = 0; s < 12; s++)
        e.push({
          month: this.utils.getMonthName(s, this.translation.months),
          timestamp: n.getTime(),
          isSelected: this.isSelectedMonth(n),
          isDisabled: this.isDisabledMonth(n)
        }), this.utils.setMonth(n, this.utils.getMonth(n) + 1);
      return e;
    },
    /**
     * Get year name on current page.
     * @return {String}
     */
    pageYearName: function() {
      var t = this.translation.yearSuffix;
      return "".concat(this.utils.getFullYear(this.pageDate)).concat(t);
    },
    /**
     * Is the left hand navigation disabled
     * @return {Boolean}
     */
    isLeftNavDisabled: function() {
      return this.isRtl ? this.isNextYearDisabled(this.pageTimestamp) : this.isPreviousYearDisabled(this.pageTimestamp);
    },
    /**
     * Is the right hand navigation disabled
     * @return {Boolean}
     */
    isRightNavDisabled: function() {
      return this.isRtl ? this.isPreviousYearDisabled(this.pageTimestamp) : this.isNextYearDisabled(this.pageTimestamp);
    }
  },
  methods: {
    /**
     * Emits a selectMonth event
     * @param {Object} month
     */
    selectMonth: function(t) {
      if (t.isDisabled)
        return !1;
      this.$emit("selectMonth", t);
    },
    /**
     * Changes the year up or down
     * @param {Number} incrementBy
     */
    changeYear: function(t) {
      var e = this.pageDate;
      this.utils.setFullYear(e, this.utils.getFullYear(e) + t), this.$emit("changedYear", e);
    },
    /**
     * Decrements the year
     */
    previousYear: function() {
      this.isPreviousYearDisabled() || this.changeYear(-1);
    },
    /**
     * Checks if the previous year is disabled or not
     * @return {Boolean}
     */
    isPreviousYearDisabled: function() {
      return !this.disabledDates || !this.disabledDates.to ? !1 : this.utils.getFullYear(this.disabledDates.to) >= this.utils.getFullYear(this.pageDate);
    },
    /**
     * Increments the year
     */
    nextYear: function() {
      this.isNextYearDisabled() || this.changeYear(1);
    },
    /**
     * Checks if the next year is disabled or not
     * @return {Boolean}
     */
    isNextYearDisabled: function() {
      return !this.disabledDates || !this.disabledDates.from ? !1 : this.utils.getFullYear(this.disabledDates.from) <= this.utils.getFullYear(this.pageDate);
    },
    /**
     * Emits an event that shows the year calendar
     */
    showYearCalendar: function() {
      this.$emit("showYearCalendar");
    },
    /**
     * Whether the selected date is in this month
     * @param {Date}
     * @return {Boolean}
     */
    isSelectedMonth: function(t) {
      return this.selectedDate && this.utils.getFullYear(this.selectedDate) === this.utils.getFullYear(t) && this.utils.getMonth(this.selectedDate) === this.utils.getMonth(t);
    },
    /**
     * Whether a month is disabled
     * @param {Date}
     * @return {Boolean}
     */
    isDisabledMonth: function(t) {
      var e = !1;
      return typeof this.disabledDates > "u" ? !1 : (typeof this.disabledDates.to < "u" && this.disabledDates.to && (this.utils.getMonth(t) < this.utils.getMonth(this.disabledDates.to) && this.utils.getFullYear(t) <= this.utils.getFullYear(this.disabledDates.to) || this.utils.getFullYear(t) < this.utils.getFullYear(this.disabledDates.to)) && (e = !0), typeof this.disabledDates.from < "u" && this.disabledDates.from && (this.utils.getMonth(t) > this.utils.getMonth(this.disabledDates.from) && this.utils.getFullYear(t) >= this.utils.getFullYear(this.disabledDates.from) || this.utils.getFullYear(t) > this.utils.getFullYear(this.disabledDates.from)) && (e = !0), typeof this.disabledDates.customPredictor == "function" && this.disabledDates.customPredictor(t) && (e = !0), e);
    }
  }
  // eslint-disable-next-line
};
const av = rv;
var wh = function() {
  var i = this, t = i.$createElement, e = i._self._c || t;
  return e(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: i.showMonthView,
          expression: "showMonthView"
        }
      ],
      class: [i.calendarClass, "vdp-datepicker__calendar"],
      style: i.calendarStyle,
      on: {
        mousedown: function(n) {
          n.preventDefault();
        }
      }
    },
    [
      i._t("beforeCalendarHeader"),
      i._v(" "),
      e("header", [
        e(
          "span",
          {
            staticClass: "prev",
            class: { disabled: i.isLeftNavDisabled },
            on: {
              click: function(n) {
                i.isRtl ? i.nextYear() : i.previousYear();
              }
            }
          },
          [i._v("<")]
        ),
        i._v(" "),
        e(
          "span",
          {
            staticClass: "month__year_btn",
            class: i.allowedToShowView("year") ? "up" : "",
            on: { click: i.showYearCalendar }
          },
          [i._v(i._s(i.pageYearName))]
        ),
        i._v(" "),
        e(
          "span",
          {
            staticClass: "next",
            class: { disabled: i.isRightNavDisabled },
            on: {
              click: function(n) {
                i.isRtl ? i.previousYear() : i.nextYear();
              }
            }
          },
          [i._v(">")]
        )
      ]),
      i._v(" "),
      i._l(i.months, function(n) {
        return e(
          "span",
          {
            key: n.timestamp,
            staticClass: "cell month",
            class: { selected: n.isSelected, disabled: n.isDisabled },
            on: {
              click: function(s) {
                return s.stopPropagation(), i.selectMonth(n);
              }
            }
          },
          [i._v(i._s(n.month))]
        );
      })
    ],
    2
  );
}, ov = [];
wh._withStripped = !0;
const lv = void 0, cv = void 0, uv = void 0, dv = !1;
var hv = tr(
  { render: wh, staticRenderFns: ov },
  lv,
  av,
  cv,
  dv,
  uv,
  void 0,
  void 0
), fv = {
  props: {
    showYearView: Boolean,
    selectedDate: Date,
    pageDate: Date,
    pageTimestamp: Number,
    disabledDates: Object,
    highlighted: Object,
    calendarClass: [String, Object, Array],
    calendarStyle: Object,
    translation: Object,
    isRtl: Boolean,
    allowedToShowView: Function,
    useUtc: Boolean
  },
  computed: {
    years: function() {
      for (var t = this.pageDate, e = [], n = this.useUtc ? new Date(Date.UTC(Math.floor(t.getUTCFullYear() / 10) * 10, t.getUTCMonth(), t.getUTCDate())) : new Date(Math.floor(t.getFullYear() / 10) * 10, t.getMonth(), t.getDate(), t.getHours(), t.getMinutes()), s = 0; s < 10; s++)
        e.push({
          year: this.utils.getFullYear(n),
          timestamp: n.getTime(),
          isSelected: this.isSelectedYear(n),
          isDisabled: this.isDisabledYear(n)
        }), this.utils.setFullYear(n, this.utils.getFullYear(n) + 1);
      return e;
    },
    /**
     * @return {String}
     */
    getPageDecade: function() {
      var t = Math.floor(this.utils.getFullYear(this.pageDate) / 10) * 10, e = t + 9, n = this.translation.yearSuffix;
      return "".concat(t, " - ").concat(e).concat(n);
    },
    /**
     * Is the left hand navigation button disabled?
     * @return {Boolean}
     */
    isLeftNavDisabled: function() {
      return this.isRtl ? this.isNextDecadeDisabled(this.pageTimestamp) : this.isPreviousDecadeDisabled(this.pageTimestamp);
    },
    /**
     * Is the right hand navigation button disabled?
     * @return {Boolean}
     */
    isRightNavDisabled: function() {
      return this.isRtl ? this.isPreviousDecadeDisabled(this.pageTimestamp) : this.isNextDecadeDisabled(this.pageTimestamp);
    }
  },
  data: function() {
    var t = qs(this.useUtc);
    return {
      utils: t
    };
  },
  methods: {
    selectYear: function(t) {
      if (t.isDisabled)
        return !1;
      this.$emit("selectYear", t);
    },
    changeYear: function(t) {
      var e = this.pageDate;
      this.utils.setFullYear(e, this.utils.getFullYear(e) + t), this.$emit("changedDecade", e);
    },
    previousDecade: function() {
      if (this.isPreviousDecadeDisabled())
        return !1;
      this.changeYear(-10);
    },
    isPreviousDecadeDisabled: function() {
      if (!this.disabledDates || !this.disabledDates.to)
        return !1;
      var t = this.utils.getFullYear(this.disabledDates.to), e = Math.floor(this.utils.getFullYear(this.pageDate) / 10) * 10 - 1;
      return t > e;
    },
    nextDecade: function() {
      if (this.isNextDecadeDisabled())
        return !1;
      this.changeYear(10);
    },
    isNextDecadeDisabled: function() {
      if (!this.disabledDates || !this.disabledDates.from)
        return !1;
      var t = this.utils.getFullYear(this.disabledDates.from), e = Math.ceil(this.utils.getFullYear(this.pageDate) / 10) * 10;
      return t < e;
    },
    /**
     * Whether the selected date is in this year
     * @param {Date}
     * @return {Boolean}
     */
    isSelectedYear: function(t) {
      return this.selectedDate && this.utils.getFullYear(this.selectedDate) === this.utils.getFullYear(t);
    },
    /**
     * Whether a year is disabled
     * @param {Date}
     * @return {Boolean}
     */
    isDisabledYear: function(t) {
      var e = !1;
      return typeof this.disabledDates > "u" || !this.disabledDates ? !1 : (typeof this.disabledDates.to < "u" && this.disabledDates.to && this.utils.getFullYear(t) < this.utils.getFullYear(this.disabledDates.to) && (e = !0), typeof this.disabledDates.from < "u" && this.disabledDates.from && this.utils.getFullYear(t) > this.utils.getFullYear(this.disabledDates.from) && (e = !0), typeof this.disabledDates.customPredictor == "function" && this.disabledDates.customPredictor(t) && (e = !0), e);
    }
  }
  // eslint-disable-next-line
};
const pv = fv;
var kh = function() {
  var i = this, t = i.$createElement, e = i._self._c || t;
  return e(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: i.showYearView,
          expression: "showYearView"
        }
      ],
      class: [i.calendarClass, "vdp-datepicker__calendar"],
      style: i.calendarStyle,
      on: {
        mousedown: function(n) {
          n.preventDefault();
        }
      }
    },
    [
      i._t("beforeCalendarHeader"),
      i._v(" "),
      e("header", [
        e(
          "span",
          {
            staticClass: "prev",
            class: { disabled: i.isLeftNavDisabled },
            on: {
              click: function(n) {
                i.isRtl ? i.nextDecade() : i.previousDecade();
              }
            }
          },
          [i._v("<")]
        ),
        i._v(" "),
        e("span", [i._v(i._s(i.getPageDecade))]),
        i._v(" "),
        e(
          "span",
          {
            staticClass: "next",
            class: { disabled: i.isRightNavDisabled },
            on: {
              click: function(n) {
                i.isRtl ? i.previousDecade() : i.nextDecade();
              }
            }
          },
          [i._v(">")]
        )
      ]),
      i._v(" "),
      i._l(i.years, function(n) {
        return e(
          "span",
          {
            key: n.timestamp,
            staticClass: "cell year",
            class: { selected: n.isSelected, disabled: n.isDisabled },
            on: {
              click: function(s) {
                return s.stopPropagation(), i.selectYear(n);
              }
            }
          },
          [i._v(i._s(n.year))]
        );
      })
    ],
    2
  );
}, gv = [];
kh._withStripped = !0;
const mv = void 0, vv = void 0, Av = void 0, bv = !1;
var yv = tr(
  { render: kh, staticRenderFns: gv },
  mv,
  pv,
  vv,
  bv,
  Av,
  void 0,
  void 0
), _v = {
  components: {
    DateInput: X2,
    PickerDay: sv,
    PickerMonth: hv,
    PickerYear: yv
  },
  props: {
    value: {
      validator: function(t) {
        return Ic.validateDateInput(t);
      }
    },
    name: String,
    refName: String,
    id: String,
    format: {
      type: [String, Function],
      default: "dd MMM yyyy"
    },
    language: {
      type: Object,
      default: function() {
        return _h;
      }
    },
    openDate: {
      validator: function(t) {
        return Ic.validateDateInput(t);
      }
    },
    dayCellContent: Function,
    fullMonthName: Boolean,
    disabledDates: Object,
    highlighted: Object,
    placeholder: String,
    inline: Boolean,
    calendarClass: [String, Object, Array],
    inputClass: [String, Object, Array],
    wrapperClass: [String, Object, Array],
    mondayFirst: Boolean,
    clearButton: Boolean,
    clearButtonIcon: String,
    calendarButton: Boolean,
    calendarButtonIcon: String,
    calendarButtonIconContent: String,
    bootstrapStyling: Boolean,
    initialView: String,
    disabled: Boolean,
    required: Boolean,
    typeable: Boolean,
    useUtc: Boolean,
    minimumView: {
      type: String,
      default: "day"
    },
    maximumView: {
      type: String,
      default: "year"
    }
  },
  data: function() {
    var t = this.openDate ? new Date(this.openDate) : /* @__PURE__ */ new Date(), e = qs(this.useUtc), n = e.setDate(t, 1);
    return {
      /*
       * Vue cannot observe changes to a Date Object so date must be stored as a timestamp
       * This represents the first day of the current viewing month
       * {Number}
       */
      pageTimestamp: n,
      /*
       * Selected Date
       * {Date}
       */
      selectedDate: null,
      /*
       * Flags to show calendar views
       * {Boolean}
       */
      showDayView: !1,
      showMonthView: !1,
      showYearView: !1,
      /*
       * Positioning
       */
      calendarHeight: 0,
      resetTypedDate: /* @__PURE__ */ new Date(),
      utils: e
    };
  },
  watch: {
    value: function(t) {
      this.setValue(t);
    },
    openDate: function() {
      this.setPageDate();
    },
    initialView: function() {
      this.setInitialView();
    }
  },
  computed: {
    computedInitialView: function() {
      return this.initialView ? this.initialView : this.minimumView;
    },
    pageDate: function() {
      return new Date(this.pageTimestamp);
    },
    translation: function() {
      return this.language;
    },
    calendarStyle: function() {
      return {
        position: this.isInline ? "static" : void 0
      };
    },
    isOpen: function() {
      return this.showDayView || this.showMonthView || this.showYearView;
    },
    isInline: function() {
      return !!this.inline;
    },
    isRtl: function() {
      return this.translation.rtl === !0;
    }
  },
  methods: {
    /**
     * Called in the event that the user navigates to date pages and
     * closes the picker without selecting a date.
     */
    resetDefaultPageDate: function() {
      if (this.selectedDate === null) {
        this.setPageDate();
        return;
      }
      this.setPageDate(this.selectedDate);
    },
    /**
     * Effectively a toggle to show/hide the calendar
     * @return {mixed}
     */
    showCalendar: function() {
      if (this.disabled || this.isInline)
        return !1;
      if (this.isOpen)
        return this.close(!0);
      this.setInitialView();
    },
    /**
     * Sets the initial picker page view: day, month or year
     */
    setInitialView: function() {
      var t = this.computedInitialView;
      if (!this.allowedToShowView(t))
        throw new Error("initialView '".concat(this.initialView, "' cannot be rendered based on minimum '").concat(this.minimumView, "' and maximum '").concat(this.maximumView, "'"));
      switch (t) {
        case "year":
          this.showYearCalendar();
          break;
        case "month":
          this.showMonthCalendar();
          break;
        default:
          this.showDayCalendar();
          break;
      }
    },
    /**
     * Are we allowed to show a specific picker view?
     * @param {String} view
     * @return {Boolean}
     */
    allowedToShowView: function(t) {
      var e = ["day", "month", "year"], n = e.indexOf(this.minimumView), s = e.indexOf(this.maximumView), r = e.indexOf(t);
      return r >= n && r <= s;
    },
    /**
     * Show the day picker
     * @return {Boolean}
     */
    showDayCalendar: function() {
      return this.allowedToShowView("day") ? (this.close(), this.showDayView = !0, !0) : !1;
    },
    /**
     * Show the month picker
     * @return {Boolean}
     */
    showMonthCalendar: function() {
      return this.allowedToShowView("month") ? (this.close(), this.showMonthView = !0, !0) : !1;
    },
    /**
     * Show the year picker
     * @return {Boolean}
     */
    showYearCalendar: function() {
      return this.allowedToShowView("year") ? (this.close(), this.showYearView = !0, !0) : !1;
    },
    /**
     * Set the selected date
     * @param {Number} timestamp
     */
    setDate: function(t) {
      var e = new Date(t);
      this.selectedDate = e, this.setPageDate(e), this.$emit("selected", e), this.$emit("input", e);
    },
    /**
     * Clear the selected date
     */
    clearDate: function() {
      this.selectedDate = null, this.setPageDate(), this.$emit("selected", null), this.$emit("input", null), this.$emit("cleared");
    },
    /**
     * @param {Object} date
     */
    selectDate: function(t) {
      this.setDate(t.timestamp), this.isInline || this.close(!0), this.resetTypedDate = /* @__PURE__ */ new Date();
    },
    /**
     * @param {Object} date
     */
    selectDisabledDate: function(t) {
      this.$emit("selectedDisabled", t);
    },
    /**
     * @param {Object} month
     */
    selectMonth: function(t) {
      var e = new Date(t.timestamp);
      this.allowedToShowView("day") ? (this.setPageDate(e), this.$emit("changedMonth", t), this.showDayCalendar()) : this.selectDate(t);
    },
    /**
     * @param {Object} year
     */
    selectYear: function(t) {
      var e = new Date(t.timestamp);
      this.allowedToShowView("month") ? (this.setPageDate(e), this.$emit("changedYear", t), this.showMonthCalendar()) : this.selectDate(t);
    },
    /**
     * Set the datepicker value
     * @param {Date|String|Number|null} date
     */
    setValue: function(t) {
      if (typeof t == "string" || typeof t == "number") {
        var e = new Date(t);
        t = isNaN(e.valueOf()) ? null : e;
      }
      if (!t) {
        this.setPageDate(), this.selectedDate = null;
        return;
      }
      this.selectedDate = t, this.setPageDate(t);
    },
    /**
     * Sets the date that the calendar should open on
     */
    setPageDate: function(t) {
      t || (this.openDate ? t = new Date(this.openDate) : t = /* @__PURE__ */ new Date()), this.pageTimestamp = this.utils.setDate(new Date(t), 1);
    },
    /**
     * Handles a month change from the day picker
     */
    handleChangedMonthFromDayPicker: function(t) {
      this.setPageDate(t), this.$emit("changedMonth", t);
    },
    /**
     * Set the date from a typedDate event
     */
    setTypedDate: function(t) {
      this.setDate(t.getTime());
    },
    /**
     * Close all calendar layers
     * @param {Boolean} emitEvent - emit close event
     */
    close: function(t) {
      this.showDayView = this.showMonthView = this.showYearView = !1, this.isInline || (t && this.$emit("closed"), document.removeEventListener("click", this.clickOutside, !1));
    },
    /**
     * Initiate the component
     */
    init: function() {
      this.value && this.setValue(this.value), this.isInline && this.setInitialView();
    }
  },
  mounted: function() {
    this.init();
  }
}, xv = typeof navigator < "u" && /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function Cv(i) {
  return function(t, e) {
    return wv(t, e);
  };
}
var Sv = document.head || document.getElementsByTagName("head")[0], Ec = {};
function wv(i, t) {
  var e = xv ? t.media || "default" : i, n = Ec[e] || (Ec[e] = {
    ids: /* @__PURE__ */ new Set(),
    styles: []
  });
  if (!n.ids.has(i)) {
    n.ids.add(i);
    var s = t.source;
    if (t.map && (s += `
/*# sourceURL=` + t.map.sources[0] + " */", s += `
/*# sourceMappingURL=data:application/json;base64,` + btoa(unescape(encodeURIComponent(JSON.stringify(t.map)))) + " */"), n.element || (n.element = document.createElement("style"), n.element.type = "text/css", t.media && n.element.setAttribute("media", t.media), Sv.appendChild(n.element)), "styleSheet" in n.element)
      n.styles.push(s), n.element.styleSheet.cssText = n.styles.filter(Boolean).join(`
`);
    else {
      var r = n.ids.size - 1, a = document.createTextNode(s), o = n.element.childNodes;
      o[r] && n.element.removeChild(o[r]), o.length ? n.element.insertBefore(a, o[r]) : n.element.appendChild(a);
    }
  }
}
var kv = Cv;
const Ov = _v;
var Oh = function() {
  var i = this, t = i.$createElement, e = i._self._c || t;
  return e(
    "div",
    {
      staticClass: "vdp-datepicker",
      class: [i.wrapperClass, i.isRtl ? "rtl" : ""]
    },
    [
      e(
        "date-input",
        {
          attrs: {
            selectedDate: i.selectedDate,
            resetTypedDate: i.resetTypedDate,
            format: i.format,
            translation: i.translation,
            inline: i.inline,
            id: i.id,
            name: i.name,
            refName: i.refName,
            openDate: i.openDate,
            placeholder: i.placeholder,
            inputClass: i.inputClass,
            typeable: i.typeable,
            clearButton: i.clearButton,
            clearButtonIcon: i.clearButtonIcon,
            calendarButton: i.calendarButton,
            calendarButtonIcon: i.calendarButtonIcon,
            calendarButtonIconContent: i.calendarButtonIconContent,
            disabled: i.disabled,
            required: i.required,
            bootstrapStyling: i.bootstrapStyling,
            "use-utc": i.useUtc
          },
          on: {
            showCalendar: i.showCalendar,
            closeCalendar: i.close,
            typedDate: i.setTypedDate,
            clearDate: i.clearDate
          }
        },
        [i._t("afterDateInput", null, { slot: "afterDateInput" })],
        2
      ),
      i._v(" "),
      i.allowedToShowView("day") ? e(
        "picker-day",
        {
          attrs: {
            pageDate: i.pageDate,
            selectedDate: i.selectedDate,
            showDayView: i.showDayView,
            fullMonthName: i.fullMonthName,
            allowedToShowView: i.allowedToShowView,
            disabledDates: i.disabledDates,
            highlighted: i.highlighted,
            calendarClass: i.calendarClass,
            calendarStyle: i.calendarStyle,
            translation: i.translation,
            pageTimestamp: i.pageTimestamp,
            isRtl: i.isRtl,
            mondayFirst: i.mondayFirst,
            dayCellContent: i.dayCellContent,
            "use-utc": i.useUtc
          },
          on: {
            changedMonth: i.handleChangedMonthFromDayPicker,
            selectDate: i.selectDate,
            showMonthCalendar: i.showMonthCalendar,
            selectedDisabled: i.selectDisabledDate
          }
        },
        [
          i._t("beforeCalendarHeader", null, {
            slot: "beforeCalendarHeader"
          })
        ],
        2
      ) : i._e(),
      i._v(" "),
      i.allowedToShowView("month") ? e(
        "picker-month",
        {
          attrs: {
            pageDate: i.pageDate,
            selectedDate: i.selectedDate,
            showMonthView: i.showMonthView,
            allowedToShowView: i.allowedToShowView,
            disabledDates: i.disabledDates,
            calendarClass: i.calendarClass,
            calendarStyle: i.calendarStyle,
            translation: i.translation,
            isRtl: i.isRtl,
            "use-utc": i.useUtc
          },
          on: {
            selectMonth: i.selectMonth,
            showYearCalendar: i.showYearCalendar,
            changedYear: i.setPageDate
          }
        },
        [
          i._t("beforeCalendarHeader", null, {
            slot: "beforeCalendarHeader"
          })
        ],
        2
      ) : i._e(),
      i._v(" "),
      i.allowedToShowView("year") ? e(
        "picker-year",
        {
          attrs: {
            pageDate: i.pageDate,
            selectedDate: i.selectedDate,
            showYearView: i.showYearView,
            allowedToShowView: i.allowedToShowView,
            disabledDates: i.disabledDates,
            calendarClass: i.calendarClass,
            calendarStyle: i.calendarStyle,
            translation: i.translation,
            isRtl: i.isRtl,
            "use-utc": i.useUtc
          },
          on: { selectYear: i.selectYear, changedDecade: i.setPageDate }
        },
        [
          i._t("beforeCalendarHeader", null, {
            slot: "beforeCalendarHeader"
          })
        ],
        2
      ) : i._e()
    ],
    1
  );
}, Mv = [];
Oh._withStripped = !0;
const Tv = function(i) {
  i && i("data-v-64ca2bb5_0", { source: `.rtl {
  direction: rtl;
}
.vdp-datepicker {
  position: relative;
  text-align: left;
}
.vdp-datepicker * {
  box-sizing: border-box;
}
.vdp-datepicker__calendar {
  position: absolute;
  z-index: 100;
  background: #fff;
  width: 300px;
  border: 1px solid #ccc;
}
.vdp-datepicker__calendar header {
  display: block;
  line-height: 40px;
}
.vdp-datepicker__calendar header span {
  display: inline-block;
  text-align: center;
  width: 71.42857142857143%;
  float: left;
}
.vdp-datepicker__calendar header .prev,
.vdp-datepicker__calendar header .next {
  width: 14.285714285714286%;
  float: left;
  text-indent: -10000px;
  position: relative;
}
.vdp-datepicker__calendar header .prev:after,
.vdp-datepicker__calendar header .next:after {
  content: '';
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  border: 6px solid transparent;
}
.vdp-datepicker__calendar header .prev:after {
  border-right: 10px solid #000;
  margin-left: -5px;
}
.vdp-datepicker__calendar header .prev.disabled:after {
  border-right: 10px solid #ddd;
}
.vdp-datepicker__calendar header .next:after {
  border-left: 10px solid #000;
  margin-left: 5px;
}
.vdp-datepicker__calendar header .next.disabled:after {
  border-left: 10px solid #ddd;
}
.vdp-datepicker__calendar header .prev:not(.disabled),
.vdp-datepicker__calendar header .next:not(.disabled),
.vdp-datepicker__calendar header .up:not(.disabled) {
  cursor: pointer;
}
.vdp-datepicker__calendar header .prev:not(.disabled):hover,
.vdp-datepicker__calendar header .next:not(.disabled):hover,
.vdp-datepicker__calendar header .up:not(.disabled):hover {
  background: #eee;
}
.vdp-datepicker__calendar .disabled {
  color: #ddd;
  cursor: default;
}
.vdp-datepicker__calendar .flex-rtl {
  display: flex;
  width: inherit;
  flex-wrap: wrap;
}
.vdp-datepicker__calendar .cell {
  display: inline-block;
  padding: 0 5px;
  width: 14.285714285714286%;
  height: 40px;
  line-height: 40px;
  text-align: center;
  vertical-align: middle;
  border: 1px solid transparent;
}
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day,
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month,
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year {
  cursor: pointer;
}
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover,
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover,
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover {
  border: 1px solid #4bd;
}
.vdp-datepicker__calendar .cell.selected {
  background: #4bd;
}
.vdp-datepicker__calendar .cell.selected:hover {
  background: #4bd;
}
.vdp-datepicker__calendar .cell.selected.highlighted {
  background: #4bd;
}
.vdp-datepicker__calendar .cell.highlighted {
  background: #cae5ed;
}
.vdp-datepicker__calendar .cell.highlighted.disabled {
  color: #a3a3a3;
}
.vdp-datepicker__calendar .cell.grey {
  color: #888;
}
.vdp-datepicker__calendar .cell.grey:hover {
  background: inherit;
}
.vdp-datepicker__calendar .cell.day-header {
  font-size: 75%;
  white-space: nowrap;
  cursor: inherit;
}
.vdp-datepicker__calendar .cell.day-header:hover {
  background: inherit;
}
.vdp-datepicker__calendar .month,
.vdp-datepicker__calendar .year {
  width: 33.333%;
}
.vdp-datepicker__clear-button,
.vdp-datepicker__calendar-button {
  cursor: pointer;
  font-style: normal;
}
.vdp-datepicker__clear-button.disabled,
.vdp-datepicker__calendar-button.disabled {
  color: #999;
  cursor: default;
}
`, map: { version: 3, sources: ["Datepicker.vue"], names: [], mappings: "AAAA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;AACb;AACA;;EAEE,0BAA0B;EAC1B,WAAW;EACX,qBAAqB;EACrB,kBAAkB;AACpB;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,4CAA4C;EAC5C,6BAA6B;AAC/B;AACA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,4BAA4B;AAC9B;AACA;;;EAGE,eAAe;AACjB;AACA;;;EAGE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,aAAa;EACb,cAAc;EACd,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,cAAc;EACd,0BAA0B;EAC1B,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,6BAA6B;AAC/B;AACA;;;EAGE,eAAe;AACjB;AACA;;;EAGE,sBAAsB;AACxB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,eAAe;EACf,kBAAkB;AACpB;AACA;;EAEE,WAAW;EACX,eAAe;AACjB", file: "Datepicker.vue", sourcesContent: [`.rtl {
  direction: rtl;
}
.vdp-datepicker {
  position: relative;
  text-align: left;
}
.vdp-datepicker * {
  box-sizing: border-box;
}
.vdp-datepicker__calendar {
  position: absolute;
  z-index: 100;
  background: #fff;
  width: 300px;
  border: 1px solid #ccc;
}
.vdp-datepicker__calendar header {
  display: block;
  line-height: 40px;
}
.vdp-datepicker__calendar header span {
  display: inline-block;
  text-align: center;
  width: 71.42857142857143%;
  float: left;
}
.vdp-datepicker__calendar header .prev,
.vdp-datepicker__calendar header .next {
  width: 14.285714285714286%;
  float: left;
  text-indent: -10000px;
  position: relative;
}
.vdp-datepicker__calendar header .prev:after,
.vdp-datepicker__calendar header .next:after {
  content: '';
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  border: 6px solid transparent;
}
.vdp-datepicker__calendar header .prev:after {
  border-right: 10px solid #000;
  margin-left: -5px;
}
.vdp-datepicker__calendar header .prev.disabled:after {
  border-right: 10px solid #ddd;
}
.vdp-datepicker__calendar header .next:after {
  border-left: 10px solid #000;
  margin-left: 5px;
}
.vdp-datepicker__calendar header .next.disabled:after {
  border-left: 10px solid #ddd;
}
.vdp-datepicker__calendar header .prev:not(.disabled),
.vdp-datepicker__calendar header .next:not(.disabled),
.vdp-datepicker__calendar header .up:not(.disabled) {
  cursor: pointer;
}
.vdp-datepicker__calendar header .prev:not(.disabled):hover,
.vdp-datepicker__calendar header .next:not(.disabled):hover,
.vdp-datepicker__calendar header .up:not(.disabled):hover {
  background: #eee;
}
.vdp-datepicker__calendar .disabled {
  color: #ddd;
  cursor: default;
}
.vdp-datepicker__calendar .flex-rtl {
  display: flex;
  width: inherit;
  flex-wrap: wrap;
}
.vdp-datepicker__calendar .cell {
  display: inline-block;
  padding: 0 5px;
  width: 14.285714285714286%;
  height: 40px;
  line-height: 40px;
  text-align: center;
  vertical-align: middle;
  border: 1px solid transparent;
}
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day,
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month,
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year {
  cursor: pointer;
}
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover,
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover,
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover {
  border: 1px solid #4bd;
}
.vdp-datepicker__calendar .cell.selected {
  background: #4bd;
}
.vdp-datepicker__calendar .cell.selected:hover {
  background: #4bd;
}
.vdp-datepicker__calendar .cell.selected.highlighted {
  background: #4bd;
}
.vdp-datepicker__calendar .cell.highlighted {
  background: #cae5ed;
}
.vdp-datepicker__calendar .cell.highlighted.disabled {
  color: #a3a3a3;
}
.vdp-datepicker__calendar .cell.grey {
  color: #888;
}
.vdp-datepicker__calendar .cell.grey:hover {
  background: inherit;
}
.vdp-datepicker__calendar .cell.day-header {
  font-size: 75%;
  white-space: nowrap;
  cursor: inherit;
}
.vdp-datepicker__calendar .cell.day-header:hover {
  background: inherit;
}
.vdp-datepicker__calendar .month,
.vdp-datepicker__calendar .year {
  width: 33.333%;
}
.vdp-datepicker__clear-button,
.vdp-datepicker__calendar-button {
  cursor: pointer;
  font-style: normal;
}
.vdp-datepicker__clear-button.disabled,
.vdp-datepicker__calendar-button.disabled {
  color: #999;
  cursor: default;
}
`] }, media: void 0 });
}, Dv = void 0, Pv = void 0, Lv = !1;
var Iv = tr(
  { render: Oh, staticRenderFns: Mv },
  Tv,
  Ov,
  Dv,
  Lv,
  Pv,
  kv,
  void 0
), Mh = { exports: {} };
(function(i, t) {
  (function(e, n) {
    i.exports = n();
  })(hi, function() {
    var e = "minute", n = /[+-]\d\d(?::?\d\d)?/g, s = /([+-]|\d\d)/g;
    return function(r, a, o) {
      var l = a.prototype;
      o.utc = function(g) {
        var m = { date: g, utc: !0, args: arguments };
        return new a(m);
      }, l.utc = function(g) {
        var m = o(this.toDate(), { locale: this.$L, utc: !0 });
        return g ? m.add(this.utcOffset(), e) : m;
      }, l.local = function() {
        return o(this.toDate(), { locale: this.$L, utc: !1 });
      };
      var c = l.parse;
      l.parse = function(g) {
        g.utc && (this.$u = !0), this.$utils().u(g.$offset) || (this.$offset = g.$offset), c.call(this, g);
      };
      var u = l.init;
      l.init = function() {
        if (this.$u) {
          var g = this.$d;
          this.$y = g.getUTCFullYear(), this.$M = g.getUTCMonth(), this.$D = g.getUTCDate(), this.$W = g.getUTCDay(), this.$H = g.getUTCHours(), this.$m = g.getUTCMinutes(), this.$s = g.getUTCSeconds(), this.$ms = g.getUTCMilliseconds();
        } else u.call(this);
      };
      var d = l.utcOffset;
      l.utcOffset = function(g, m) {
        var v = this.$utils().u;
        if (v(g)) return this.$u ? 0 : v(this.$offset) ? d.call(this) : this.$offset;
        if (typeof g == "string" && (g = function(C) {
          C === void 0 && (C = "");
          var O = C.match(n);
          if (!O) return null;
          var k = ("" + O[0]).match(s) || ["-", 0, 0], P = k[0], x = 60 * +k[1] + +k[2];
          return x === 0 ? 0 : P === "+" ? x : -x;
        }(g), g === null)) return this;
        var b = Math.abs(g) <= 16 ? 60 * g : g, _ = this;
        if (m) return _.$offset = b, _.$u = g === 0, _;
        if (g !== 0) {
          var S = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
          (_ = this.local().add(b + S, e)).$offset = b, _.$x.$localOffset = S;
        } else _ = this.utc();
        return _;
      };
      var h = l.format;
      l.format = function(g) {
        var m = g || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
        return h.call(this, m);
      }, l.valueOf = function() {
        var g = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
        return this.$d.valueOf() - 6e4 * g;
      }, l.isUTC = function() {
        return !!this.$u;
      }, l.toISOString = function() {
        return this.toDate().toISOString();
      }, l.toString = function() {
        return this.toDate().toUTCString();
      };
      var f = l.toDate;
      l.toDate = function(g) {
        return g === "s" && this.$offset ? o(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : f.call(this);
      };
      var p = l.diff;
      l.diff = function(g, m, v) {
        if (g && this.$u === g.$u) return p.call(this, g, m, v);
        var b = this.local(), _ = o(g).local();
        return p.call(b, _, m, v);
      };
    };
  });
})(Mh);
var Ev = Mh.exports;
const $v = /* @__PURE__ */ as(Ev), Bv = {
  name: "AcvTextField",
  components: {
    AcvBaseInput: Ce,
    AcvIconButton: Ee
  },
  extends: Ce,
  props: {
    /**
    * Input type for input field
    */
    type: {
      type: String,
      default: "text",
      validator(i) {
        return wt(i, [
          "text",
          "tel",
          "email",
          "password",
          "url",
          "number",
          "search"
        ]);
      }
    },
    /**
    * Inputmode for the input field when on mobile devices
    */
    inputmode: {
      type: String,
      default: "text",
      validator(i) {
        return wt(i, [
          "none",
          "text",
          "numeric",
          "decimal",
          "tel",
          "search",
          "email",
          "url"
        ]);
      }
    },
    /**
    * V-model value for the input field
    */
    value: {
      type: [String, Number],
      default: ""
    },
    /**
    * Font awesome icon to be placed prepended to the front of the input area
    */
    iconPrepend: {
      type: String,
      default: ""
    },
    /**
    * Font awesome icon to be placed appended to the end of the input area
    */
    iconAppend: {
      type: String,
      default: ""
    },
    /**
    * Prefix character of 1 length which is placed after the icon prepend
    * and before the placeholder
    */
    prefix: {
      type: [String, Number],
      default: "",
      validator(i) {
        return String(i).length <= 1;
      }
    },
    /**
    * Suffix characters of max 3 length which is placed after the placeholder
    * and before the clear icon
    */
    suffix: {
      type: [String, Number],
      default: "",
      validator(i) {
        return String(i).length <= 3;
      }
    },
    /**
    * Aligns input content to the right
    */
    alignRight: {
      type: Boolean,
      default: !1
    },
    /**
    * Enable the clear icon to be shown after the suffix and before the appended icon
    */
    showClear: {
      type: Boolean,
      default: !0
    },
    /**
    * Enable autocomplete
    */
    autocomplete: {
      type: Boolean,
      default: !0
    }
  },
  computed: {
    labelClasses() {
      return {
        "has-prepend": this.hasPrepend,
        "has-prefix": this.hasPrefix
      };
    },
    inputClasses() {
      return {
        "has-prepend": this.hasPrepend,
        "has-prefix": this.hasPrefix,
        "has-suffix": this.hasSuffix,
        "has-clear": this.hasClear,
        "has-append": this.hasAppend,
        "align-right": this.alignRight
      };
    },
    prefixClasses() {
      return {
        "has-label": this.hasLabel
      };
    },
    suffixClasses() {
      return {
        "has-label": this.hasLabel
      };
    },
    inputListeners() {
      return {
        ...this.$listeners,
        input: (i) => {
          this.$emit("input", i.target.value);
        }
      };
    },
    hasPrepend() {
      return !!this.$slots.prepend || this.iconPrepend;
    },
    hasPrefix() {
      return !!this.$slots.prefix || this.prefix;
    },
    hasSuffix() {
      return !!this.$slots.suffix || this.suffix;
    },
    hasClear() {
      return !!this.$slots["clear-area"] || this.showClear;
    },
    hasAppend() {
      return !!this.$slots.append || this.iconAppend;
    },
    autocompleteSetting() {
      return this.type === "search" ? "off" : this.autocomplete ? void 0 : "off";
    }
  },
  methods: {
    iconPrependClick(i) {
      this.isDisabled || this.$emit("icon-prepend-click", i);
    },
    iconAppendClick(i) {
      this.isDisabled || this.$emit("icon-append-click", i);
    },
    focusInput() {
      const i = this.$refs[this.inputId].$el.querySelector("input");
      i && i.focus();
    },
    clearInputContent(i) {
      this.isDisabled || (this.$emit("input", ""), this.$emit("clear-click", i), this.focusInput());
    }
  }
};
var Rv = function() {
  var t = this, e = t._self._c;
  return e("acv-base-input", t._g(t._b({ ref: t.inputId, attrs: { type: t.type, "additional-input-classes": t.inputClasses, "additional-label-classes": t.labelClasses, autocomplete: t.autocompleteSetting, role: "textbox" }, scopedSlots: t._u([t.hasPrepend || t.hasPrefix ? { key: "prepend", fn: function() {
    return [e("div", { staticClass: "acv-input__prepend" }, [t._t("prepend", function() {
      return [t.iconPrepend ? e("acv-icon-button", { staticClass: "acv-input__icon acv-input__icon--prepend", attrs: { "icon-type": t.iconPrepend, "show-tooltip": !1, disabled: t.isDisabled }, on: { click: function(n) {
        return n.stopPropagation(), n.preventDefault(), t.iconPrependClick.apply(null, arguments);
      } } }) : t._e()];
    }), t._t("prefix", function() {
      return [t.prefix ? e("span", { staticClass: "acv-input__prefix", class: [t.prefixClasses] }, [t._v(t._s(t.prefix))]) : t._e()];
    })], 2)];
  }, proxy: !0 } : null, { key: "between", fn: function() {
    return [t._t("between")];
  }, proxy: !0 }, { key: "label", fn: function() {
    return [t._t("label")];
  }, proxy: !0 }, t.hasAppend || t.hasClear || t.hasSuffix ? { key: "append", fn: function() {
    return [e("div", { staticClass: "acv-input__append" }, [t._t("suffix", function() {
      return [t.suffix ? e("span", { staticClass: "acv-input__suffix", class: [t.suffixClasses] }, [t._v(t._s(t.suffix))]) : t._e()];
    }), t._t("clear-area", function() {
      return [t.showClear && t.hasInput ? e("acv-icon-button", { staticClass: "acv-input__icon acv-input__icon--clear", attrs: { "show-tooltip": !1, disabled: t.isDisabled, "icon-type": "close" }, on: { click: function(n) {
        return n.stopPropagation(), n.preventDefault(), t.clearInputContent.apply(null, arguments);
      } } }) : t._e()];
    }), t._t("append", function() {
      return [t.iconAppend ? e("acv-icon-button", { staticClass: "acv-input__icon acv-input__icon--append", attrs: { "icon-type": t.iconAppend, "show-tooltip": !1, disabled: t.isDisabled }, on: { click: function(n) {
        return n.stopPropagation(), n.preventDefault(), t.iconAppendClick.apply(null, arguments);
      } } }) : t._e()];
    })], 2)];
  }, proxy: !0 } : null, { key: "assistive-text", fn: function() {
    return [t._t("assistive-text")];
  }, proxy: !0 }, { key: "validation", fn: function() {
    return [t._t("validation")];
  }, proxy: !0 }], null, !0) }, "acv-base-input", { ...t.$attrs, ...t.$props }, !1), t.inputListeners));
}, Fv = [], Nv = /* @__PURE__ */ U(
  Bv,
  Rv,
  Fv,
  !1,
  null,
  "3a1eb02d"
);
const Pe = Nv.exports, Hv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Pe
}, Symbol.toStringTag, { value: "Module" }));
Oe.extend($v);
const Vv = {
  name: "AcvDateField",
  directives: { onClickAway: On },
  components: {
    Datepicker: Iv,
    AcvTextField: Pe
  },
  extends: Pe,
  props: {
    allowEmptyValue: {
      type: Boolean,
      default: !1
    },
    name: {
      type: String,
      required: !0
    },
    required: {
      type: Boolean,
      required: !1,
      default: !1
    },
    placeholder: {
      type: String,
      required: !1,
      default: null
    },
    showIcon: {
      type: Boolean,
      required: !1,
      default: !0
    },
    disabledDates: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    format: {
      type: String,
      required: !1,
      default: "MMM D, YYYY"
    },
    value: {
      type: [String, Date],
      default: ""
    },
    displayInLocal: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      showCalendar: !1,
      model: this.allowEmptyValue ? "" : /* @__PURE__ */ new Date()
    };
  },
  computed: {
    formattedValue() {
      return this.allowEmptyValue && !this.model ? "" : this.displayInLocal ? Oe(this.model).local().format(this.format) : Oe.utc(this.model).format(this.format);
    }
  },
  watch: {
    value: {
      immediate: !0,
      handler(i) {
        this.model = this.allowEmptyValue && !i ? "" : i;
      }
    },
    model: {
      immediate: !0,
      handler(i) {
        if (i) {
          const t = {
            utc: Oe.utc(i),
            formatted: Oe.utc(i).format(this.format),
            local: Oe(i).local()
          };
          this.$emit("set-date-values", t);
        }
      }
    }
  },
  methods: {
    toggleCalendar(i) {
      this.showCalendar = i;
    },
    handleClickAway() {
      this.showCalendar && this.toggleCalendar(!1);
    },
    handleInputChange(i) {
      this.toggleCalendar(!1), this.$emit("input", i);
    }
  }
};
var zv = function() {
  var t = this, e = t._self._c;
  return e("div", { directives: [{ name: "on-clickAway", rawName: "v-on-clickAway:mousedown", value: t.handleClickAway, expression: "handleClickAway", arg: "mousedown" }], staticClass: "calendar-field" }, [e("acv-text-field", t._b({ ref: "field", attrs: { value: t.formattedValue, name: t.name, required: t.required, placeholder: t.placeholder, "icon-append": t.showIcon ? "calendar_today" : null, "show-clear": !1 }, on: { click: function(n) {
    return t.toggleCalendar(!t.showCalendar);
  }, "icon-append-click": function(n) {
    return t.toggleCalendar(!t.showCalendar);
  } } }, "acv-text-field", { ...t.$attrs, ...t.$props }, !1)), e("div", { staticClass: "calendar-container" }, [t.showCalendar ? e("datepicker", { attrs: { format: t.format, inline: "", "disabled-dates": t.disabledDates }, on: { input: t.handleInputChange }, model: { value: t.model, callback: function(n) {
    t.model = n;
  }, expression: "model" } }) : t._e()], 1)], 1);
}, jv = [], Wv = /* @__PURE__ */ U(
  Vv,
  zv,
  jv,
  !1,
  null,
  "e12fc24e"
);
const Yv = Wv.exports, Uv = {
  name: "AcvFloatingActionButton",
  components: {
    AcvIcon: () => Promise.resolve().then(() => Ie),
    AcvBadge: () => Promise.resolve().then(() => Gd)
  },
  props: {
    /**
    * Button type
    */
    type: {
      type: String,
      default: "button",
      validator(i) {
        return wt(i, ["button", "submit"]);
      }
    },
    /**
    * Button variant style
    */
    variant: {
      type: String,
      default: "primary",
      validator(i) {
        return wt(i, ["primary", "secondary", "error"]);
      }
    },
    /**
    * Mode for the floating action button being either mini which only shows icon or extended
    */
    mode: {
      type: String,
      default: "mini",
      validator(i) {
        return wt(i, ["extended", "mini"]);
      }
    },
    /**
     * Checks if the button should be disabled
     */
    disabled: {
      type: Boolean,
      default: !1
    },
    /**
    * Prepends an icon before the button text content
    */
    iconType: {
      type: String,
      default: ""
    },
    /**
    * Shows badge with the count provided
    */
    count: {
      type: [String, Number],
      default: null
    },
    /**
    * Shows the badge in mini form
    */
    badgeMini: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    computedClasses() {
      return {
        [`acv-floating-action-button--${this.variant}`]: !0,
        "acv-floating-action-button--extended": this.isExtended,
        "acv-floating-action-button--mini": this.isMini
      };
    },
    hasIcon() {
      return !!this.$slots.icon || this.iconType;
    },
    isExtended() {
      return this.mode === "extended";
    },
    isMini() {
      return this.mode === "mini";
    },
    hasBadge() {
      return !!this.$slots.badge || this.count || this.badgeMini;
    },
    badgeVariant() {
      if (this.hasBadge)
        switch (this.variant) {
          case "primary":
            return "secondary";
          case "secondary":
            return "primary";
          default:
            return "primary";
        }
      return null;
    }
  }
};
var Zv = function() {
  var t = this, e = t._self._c;
  return e("button", t._g({ class: ["acv-floating-action-button ripple", t.computedClasses], attrs: { disabled: t.disabled, type: t.type } }, t.$listeners), [t.isExtended ? [t._t("prepend")] : t._e(), t.hasIcon ? [t._t("icon", function() {
    return [t.iconType ? e("acv-icon", { staticClass: "acv-floating-action-button__icon", attrs: { icon: t.iconType } }) : t._e()];
  })] : t._e(), t.isExtended ? [t._t("default")] : t._e(), t.isExtended ? [t._t("append")] : t._e(), t.hasBadge ? [t._t("badge", function() {
    return [e("acv-badge", { staticClass: "acv-floating-action-button__badge", attrs: { content: t.count, variant: t.badgeVariant, mini: t.badgeMini } })];
  })] : t._e()], 2);
}, Gv = [], Kv = /* @__PURE__ */ U(
  Uv,
  Zv,
  Gv,
  !1,
  null,
  "882a0160"
);
const Xv = Kv.exports, Qv = {
  name: "AcvMoneyField",
  components: {
    AcvTextField: Pe
  },
  extends: Pe,
  props: {
    /**
    * Money value provided
    */
    value: {
      type: [String, Number],
      default: 0
    },
    /**
    * Determines if the return value is formatted based on the mask
    */
    masked: {
      type: Boolean,
      default: !1
    },
    /**
    * Money mask props allowed with default values
    */
    moneyMask: {
      type: Object,
      default: () => ({})
    },
    /**
    * Optional label content
    */
    label: {
      type: [String, Number],
      default: ""
    },
    /**
    * Optional placeholder content shown when prefix or suffix
    * on the base input are provided
    */
    placeholder: {
      type: String,
      default: ""
    }
  },
  computed: {
    computedMoneyMask() {
      return {
        ...Di,
        ...this.moneyMask
      };
    },
    computedProps() {
      return {
        ...this.$props,
        moneyMask: this.computedMoneyMask,
        prefix: this.$props.prefix !== void 0 ? this.$props.prefix : "$"
      };
    },
    computedMoneyValue: {
      get() {
        var t;
        return ((t = this.placeholder) == null ? void 0 : t.length) > 0 && this.value === 0 ? "" : this.masked ? this.value : qr(this.value, this.computedMoneyMask);
      },
      set(i) {
        const t = Bs(
          i,
          this.computedMoneyMask.precision,
          this.computedMoneyMask.allowBlank
        ), e = Bs(
          this.computedMoneyValue,
          this.computedMoneyMask.precision,
          this.computedMoneyMask.allowBlank
        );
        if (t === e) return;
        const n = this.masked ? qr(t, this.computedMoneyMask) : t;
        this.$emit("input", n);
      }
    },
    hasGoodLabel() {
      return !!this.label && this.label.length > 0;
    },
    inputListeners() {
      return {
        ...this.$listeners,
        input: void 0
      };
    }
  },
  methods: {
    getTextFieldSlotName(i) {
      let t;
      return i.includes("money") && ([, t] = i.split("money-")), t;
    },
    focusInput() {
      var i;
      return (i = this.$refs.textField) == null ? void 0 : i.focusInput();
    }
  }
};
var Jv = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "acv-money-field" }, [e("acv-text-field", t._g(t._b({ ref: "textField", staticClass: "acv-money-field-container", class: {
    "currency-no-label": !t.hasGoodLabel
  }, attrs: { type: "tel", inputmode: "tel", autocomplete: !1 }, scopedSlots: t._u([t._l(Object.keys(t.$slots), function(n) {
    return { key: t.getTextFieldSlotName(n), fn: function() {
      return [t._t(n)];
    }, proxy: !0 };
  })], null, !0), model: { value: t.computedMoneyValue, callback: function(n) {
    t.computedMoneyValue = n;
  }, expression: "computedMoneyValue" } }, "acv-text-field", { ...t.$attrs, ...t.computedProps }, !1), t.inputListeners))], 1);
}, qv = [], t3 = /* @__PURE__ */ U(
  Qv,
  Jv,
  qv,
  !1,
  null,
  null
);
const e3 = t3.exports, i3 = {
  name: "AcvMultiSelect",
  mixins: [ue],
  props: {
    disabled: {
      type: Boolean,
      default: !1
    },
    labelKey: {
      type: String,
      default: "label"
    },
    multiSelect: {
      type: Boolean,
      default: !0
    },
    options: {
      type: Array,
      required: !0
    },
    showSelectAllOption: {
      type: Boolean,
      default: !0
    },
    titleText: {
      type: String,
      default: ""
    },
    selectAllText: {
      type: String,
      default: "Select All"
    },
    selectAllOverride: {
      type: Boolean,
      default: null
    },
    value: {
      type: [Array, Number, Object, String],
      default: () => []
    }
  },
  computed: {
    selectAll: {
      get() {
        return this.selectAllOverride ? this.selectAllOverride : this.internalValue.length === this.options.length;
      },
      set(i) {
        this.internalValue = i ? this.options : [], this.$emit("selectAllChanged", i);
      }
    },
    showSelectAll() {
      return this.showSelectAllOption && this.multiSelect;
    }
  },
  methods: {
    generateKey(i, t, e) {
      return i.key ? `${this.internalId}-${i.key}` : `${t}-${e}`;
    }
  }
};
var n3 = function() {
  var t = this, e = t._self._c;
  return e("div", { class: {
    "acv-multiselect": !0,
    "--disabled": t.disabled
  } }, [t.titleText ? e("span", { staticClass: "multiselect__input__label" }, [t._v(t._s(t.titleText))]) : t._e(), t.showSelectAll ? e("div", { staticClass: "multiselect" }, [e("input", { directives: [{ name: "model", rawName: "v-model", value: t.selectAll, expression: "selectAll" }], staticClass: "checkbox__styled", attrs: { id: `${t.internalId}_select__all__checkbox`, type: "checkbox" }, domProps: { checked: Array.isArray(t.selectAll) ? t._i(t.selectAll, null) > -1 : t.selectAll }, on: { change: function(n) {
    var s = t.selectAll, r = n.target, a = !!r.checked;
    if (Array.isArray(s)) {
      var o = null, l = t._i(s, o);
      r.checked ? l < 0 && (t.selectAll = s.concat([o])) : l > -1 && (t.selectAll = s.slice(0, l).concat(s.slice(l + 1)));
    } else
      t.selectAll = a;
  } } }), e("label", { attrs: { for: `${t.internalId}_select__all__checkbox` } }, [e("b", [t._v(t._s(t.selectAllText))])])]) : t._e(), t._l(t.options, function(n, s) {
    return e("div", { key: t.generateKey(n, s, t._uid), staticClass: "multiselect" }, [t._t(`${t.generateKey(n, s, t._uid)}-before-input`, null, { option: n, optionIndex: s }), t._t(`${t.generateKey(n, s, t._uid)}-input`, function() {
      return [t.multiSelect ? e("input", { directives: [{ name: "model", rawName: "v-model", value: t.internalValue, expression: "internalValue" }], staticClass: "checkbox__styled", attrs: { id: t.generateKey(n, s, t._uid), disabled: n.disabled, type: "checkbox" }, domProps: { value: n, checked: Array.isArray(t.internalValue) ? t._i(t.internalValue, n) > -1 : t.internalValue }, on: { change: function(r) {
        var a = t.internalValue, o = r.target, l = !!o.checked;
        if (Array.isArray(a)) {
          var c = n, u = t._i(a, c);
          o.checked ? u < 0 && (t.internalValue = a.concat([c])) : u > -1 && (t.internalValue = a.slice(0, u).concat(a.slice(u + 1)));
        } else
          t.internalValue = l;
      } } }) : e("input", { directives: [{ name: "model", rawName: "v-model", value: t.internalValue, expression: "internalValue" }], staticClass: "checkbox__styled checkbox__rounded", attrs: { id: t.generateKey(n, s, t._uid), disabled: n.disabled, type: "radio" }, domProps: { value: n, checked: t._q(t.internalValue, n) }, on: { change: function(r) {
        t.internalValue = n;
      } } }), e("label", { attrs: { for: t.generateKey(n, s, t._uid) } }, [t._v(t._s(n[t.labelKey] || n))])];
    }, { option: n, optionIndex: s }), t._t(`${t.generateKey(n, s, t._uid)}-after-input`, null, { option: n, optionIndex: s })], 2);
  })], 2);
}, s3 = [], r3 = /* @__PURE__ */ U(
  i3,
  n3,
  s3,
  !1,
  null,
  "aafb0b1a"
);
const a3 = r3.exports, o3 = {
  name: "AcvPhoneNumber",
  components: {
    AcvTextField: Pe
  },
  extends: Pe,
  props: {
    /**
    * The v-model value provided which can be a String or Object.<br/>
    * If `withExtension` is `true`, this should be provided as an `Object` with properties
    * being the `phoneKey` and `extensionKey` defined. <br/>Else, it should be a `String`
    */
    value: {
      type: [String, Object],
      default: ""
    },
    /**
    * The mask for the phone input field based on Vue-The-Mask
    */
    mask: {
      type: String,
      default: "(###) ###-####"
    },
    /**
    * The placeholder for the phone input field
    */
    placeholder: {
      type: String,
      default: "(555) 555-5555"
    },
    /**
    * Determines if there is a extension field present
    */
    withExtension: {
      type: Boolean,
      default: !1
    },
    /**
    * If `withExtension` is enabled, the property in the `v-model` value that the
    * phone number field value is within
    */
    phoneKey: {
      type: String,
      default: "phone"
    },
    /**
    * If `withExtension` is enabled, the property in the `v-model` value that the
    * extension field value is within
    */
    extensionKey: {
      type: String,
      default: "ext"
    },
    /**
    * If props which are directly the accepted props of the `TextField` component
    * which would be defined for the extension field
    */
    extensionProps: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    defaultExtensionProps: {
      mask: "x###",
      placeholder: "x123",
      label: "Ext",
      validation: {}
    }
  }),
  computed: {
    computedPhoneValue: {
      get() {
        return this.withExtension ? this.value[this.phoneKey] : this.value;
      },
      set(i) {
        const t = this.withExtension ? {
          [this.phoneKey]: i,
          [this.extensionKey]: this.value[this.extensionKey]
        } : i;
        this.$emit("input", t);
      }
    },
    computedExtensionValue: {
      get() {
        return this.withExtension ? this.value[this.extensionKey] : void 0;
      },
      set(i) {
        const t = this.withExtension ? {
          [this.phoneKey]: this.value[this.phoneKey],
          [this.extensionKey]: i
        } : void 0;
        this.$emit("input", t);
      }
    },
    inputListeners() {
      return {
        ...this.$listeners,
        input: void 0
      };
    },
    computedContainerClass() {
      return {
        "has-extension": this.withExtension
      };
    },
    computedExtensionProps() {
      return { ...this.defaultExtensionProps, ...this.extensionProps };
    }
  },
  methods: {
    getTextFieldSlotName(i) {
      let t;
      return i.includes("phone") && ([, t] = i.split("phone-")), i.includes("ext") && ([, t] = i.split("ext-")), t;
    }
  }
};
var l3 = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "acv-phone-number-container", class: t.computedContainerClass }, [e("acv-text-field", t._g(t._b({ staticClass: "acv-phone-number-input-container", attrs: { type: "tel", inputmode: "tel" }, scopedSlots: t._u([t._l(Object.keys(t.$slots), function(n) {
    return { key: t.getTextFieldSlotName(n), fn: function() {
      return [t._t(n)];
    }, proxy: !0 };
  })], null, !0), model: { value: t.computedPhoneValue, callback: function(n) {
    t.computedPhoneValue = n;
  }, expression: "computedPhoneValue" } }, "acv-text-field", { ...t.$attrs, ...t.$props }, !1), t.inputListeners)), t.withExtension ? e("acv-text-field", t._g(t._b({ staticClass: "acv-phone-number-extension-container", attrs: { type: "tel", inputmode: "tel" }, scopedSlots: t._u([t._l(Object.keys(t.$slots), function(n) {
    return { key: t.getTextFieldSlotName(n), fn: function() {
      return [t._t(n)];
    }, proxy: !0 };
  })], null, !0), model: { value: t.computedExtensionValue, callback: function(n) {
    t.computedExtensionValue = n;
  }, expression: "computedExtensionValue" } }, "acv-text-field", t.computedExtensionProps, !1), t.inputListeners)) : t._e()], 1);
}, c3 = [], u3 = /* @__PURE__ */ U(
  o3,
  l3,
  c3,
  !1,
  null,
  "022a2b7a"
);
const d3 = u3.exports, h3 = {
  name: "AcvRadio",
  components: {
    AcvBaseInput: Ce
  },
  extends: Ce,
  mixins: [
    yi
  ],
  model: {
    prop: "modelValue",
    event: "change"
  },
  props: {
    /**
    * The inherited v-model value
    */
    modelValue: {
      type: [String, Number, Boolean, Object],
      default: null
    },
    /**
    * Allows the clickable label area to be full width
    */
    fullWidth: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    checked() {
      return this.value === this.modelValue;
    },
    inputListeners() {
      return {
        ...this.$listeners,
        change: () => {
          this.$emit("change", this.value), this.$refs[`base-input-${this.inputId}`].handleBlur();
        }
      };
    }
  }
};
var f3 = function() {
  var t = this, e = t._self._c;
  return e("acv-base-input", t._g(t._b({ ref: `base-input-${t.inputId}`, class: { "tw-w-full": t.fullWidth }, attrs: { type: "radio", role: "radio", "additional-label-container-classes": {
    "acv-radio": !0
  }, checked: t.checked }, scopedSlots: t._u([{ key: "prepend", fn: function() {
    return [t._t("prepend")];
  }, proxy: !0 }, { key: "between", fn: function() {
    return [e("div", { staticClass: "acv-radio__control", class: { ...t.backgroundClasses } }), t._t("between")];
  }, proxy: !0 }, { key: "label", fn: function() {
    return [t._t("label")];
  }, proxy: !0 }, { key: "append", fn: function() {
    return [t._t("append")];
  }, proxy: !0 }], null, !0) }, "acv-base-input", { ...t.$attrs, ...t.$props }, !1), t.inputListeners));
}, p3 = [], g3 = /* @__PURE__ */ U(
  h3,
  f3,
  p3,
  !1,
  null,
  "730e8113"
);
const Ol = g3.exports, m3 = {
  name: "AcvRadioTree",
  components: {
    AcvList: cs,
    AcvListItem: us,
    AcvRadio: Ol
  },
  model: {
    prop: "modelValue",
    event: "change"
  },
  props: {
    /**
    * Changes styling of radios to dark
    */
    bgDarkMode: {
      type: Boolean,
      default: !1
    },
    /**
    * Changes styling of radios to orange
    */
    bgOrange: {
      type: Boolean,
      default: !1
    },
    /**
    * Property in each sub options exist for each option object
    */
    childOptionsKey: {
      type: String,
      default: "options"
    },
    /**
    * Unique label property within each option object
    */
    labelKey: {
      type: String,
      default: "label"
    },
    /**
    * Value property within each option object
    */
    valueKey: {
      type: String,
      default: "value"
    },
    /**
    * v-model for the selected radio option
    */
    modelValue: {
      type: [Object, String, Boolean, Number],
      default: null
    },
    /**
    * Array Collection of option objects to be rendered as radios
    */
    options: {
      type: Array,
      default: () => []
    },
    /**
    * Allows the clickable label area to be full width for each radio
    */
    fullWidth: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      selectedParentOption: null,
      selectedChildOption: null
    };
  },
  computed: {
    selectedOption() {
      return this.selectedChildOption || this.selectedParentOption;
    }
  },
  watch: {
    modelValue: {
      immediate: !0,
      handler(i) {
        if (i !== this.selectedOption)
          if (this.options.find((e) => e[this.valueKey] === i))
            this.selectedParentOption = i, this.selectedChildOption = null;
          else {
            const e = this.options.find((n) => {
              var s;
              return (s = n[this.childOptionsKey]) == null ? void 0 : s.find((r) => r[this.valueKey] === i);
            });
            e && (this.selectedChildOption = i, this.selectedParentOption = e[this.valueKey]);
          }
      }
    }
  },
  methods: {
    handleChildOptionChanged(i, t) {
      this.selectedParentOption = t[this.valueKey], this.$emit("change", this.selectedOption);
    },
    handleParentOptionChanged(i) {
      this.hasChildOptions(i) ? this.selectedChildOption = i[this.childOptionsKey][0][this.valueKey] : this.selectedChildOption = null, this.$emit("change", this.selectedOption);
    },
    hasChildOptions(i) {
      return i[this.childOptionsKey] && i[this.childOptionsKey].length;
    },
    labelToId(i) {
      const t = / /gi;
      return i == null ? void 0 : i.trim().replace(t, "_").toLowerCase();
    }
  }
};
var v3 = function() {
  var t = this, e = t._self._c;
  return e("acv-list", { staticClass: "acv-radio-tree", attrs: { divider: !1 } }, t._l(t.options, function(n, s) {
    return e("acv-list-item", { key: `${n[t.labelKey]}-${s}`, class: {
      "has-child": t.hasChildOptions(n)
    } }, [e("div", { staticClass: "tw-flexbox-row-align-center-justify-between tw-w-full" }, [e("acv-radio", { attrs: { id: `parent-radio-${t.labelToId(n[t.labelKey])}`, "full-width": t.fullWidth, "bg-dark-mode": t.bgDarkMode, "bg-orange": t.bgOrange, value: n[t.valueKey], label: n[t.labelKey], name: n[t.labelKey] }, on: { change: function(r) {
      return t.handleParentOptionChanged(n);
    } }, scopedSlots: t._u([{ key: "label", fn: function() {
      return [t._t(`label-parent-${n[t.labelKey]}`)];
    }, proxy: !0 }], null, !0), model: { value: t.selectedParentOption, callback: function(r) {
      t.selectedParentOption = r;
    }, expression: "selectedParentOption" } }), t._t(`append-parent-${n[t.labelKey]}`)], 2), t._t(`after-parent-${n[t.labelKey]}`), e("transition", { attrs: { name: "collapse-expand" } }, [t.hasChildOptions(n) ? e("acv-list", { directives: [{ name: "show", rawName: "v-show", value: t.selectedParentOption === n[t.valueKey], expression: "selectedParentOption === option[valueKey]" }], class: [
      "child-radio-tree",
      `child-radio-tree-${n[t.labelKey]}`
    ], attrs: { divider: !1 } }, t._l(n[t.childOptionsKey], function(r, a) {
      return e("acv-list-item", { key: `${r[t.labelKey]}-${a}`, staticClass: "child-radio-tree__item" }, [e("div", { staticClass: "tw-flexbox-row-align-center-justify-between tw-w-full" }, [e("acv-radio", { attrs: { id: `child-radio-${t.labelToId(r[t.labelKey])}`, "full-width": t.fullWidth, "bg-dark-mode": t.bgDarkMode, "bg-orange": t.bgOrange, value: r[t.valueKey], label: r[t.labelKey], name: r[t.labelKey] }, on: { change: function(o) {
        return t.handleChildOptionChanged(r, n);
      } }, scopedSlots: t._u([{ key: "label", fn: function() {
        return [t._t(`label-child-${r[t.labelKey]}`)];
      }, proxy: !0 }], null, !0), model: { value: t.selectedChildOption, callback: function(o) {
        t.selectedChildOption = o;
      }, expression: "selectedChildOption" } }), t._t(`append-child-${r[t.labelKey]}`)], 2)]);
    }), 1) : t._e()], 1)], 2);
  }), 1);
}, A3 = [], b3 = /* @__PURE__ */ U(
  m3,
  v3,
  A3,
  !1,
  null,
  "9beaa431"
);
const y3 = b3.exports, _3 = _l({
  name: "VueSliderDot",
  emits: ["drag-start"],
  props: {
    value: { type: [String, Number], default: 0 },
    tooltip: {
      type: String,
      required: !0
    },
    tooltipPlacement: {
      type: String,
      validator: (i) => ["top", "right", "bottom", "left"].indexOf(i) > -1,
      required: !0
    },
    tooltipFormatter: {
      type: [String, Function]
    },
    focus: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    dotStyle: { type: [Object, Array] },
    tooltipStyle: { type: [Object, Array] }
  },
  computed: {
    dotClasses() {
      return [
        "vue-slider-dot",
        {
          "vue-slider-dot-hover": this.tooltip === "hover" || this.tooltip === "active",
          "vue-slider-dot-disabled": this.disabled,
          "vue-slider-dot-focus": this.focus
        }
      ];
    },
    handleClasses() {
      return [
        "vue-slider-dot-handle",
        {
          "vue-slider-dot-handle-disabled": this.disabled,
          "vue-slider-dot-handle-focus": this.focus
        }
      ];
    },
    tooltipClasses() {
      return [
        "vue-slider-dot-tooltip",
        [`vue-slider-dot-tooltip-${this.tooltipPlacement}`],
        {
          "vue-slider-dot-tooltip-show": this.showTooltip
        }
      ];
    },
    tooltipInnerClasses() {
      return [
        "vue-slider-dot-tooltip-inner",
        [`vue-slider-dot-tooltip-inner-${this.tooltipPlacement}`],
        {
          "vue-slider-dot-tooltip-inner-disabled": this.disabled,
          "vue-slider-dot-tooltip-inner-focus": this.focus
        }
      ];
    },
    showTooltip() {
      switch (this.tooltip) {
        case "always":
          return !0;
        case "none":
          return !1;
        case "focus":
        case "active":
          return !!this.focus;
        default:
          return !1;
      }
    },
    tooltipValue() {
      return this.tooltipFormatter ? typeof this.tooltipFormatter == "string" ? this.tooltipFormatter.replace(/\{value\}/, String(this.value)) : this.tooltipFormatter(this.value) : this.value;
    }
  },
  methods: {
    dragStart() {
      if (this.disabled)
        return !1;
      this.$emit("drag-start");
    }
  }
});
var x3 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { ref: "dot", class: t.dotClasses, attrs: { "aria-valuetext": t.tooltipValue }, on: { "&mousedown": function(n) {
    return t.dragStart.apply(null, arguments);
  }, "&touchstart": function(n) {
    return t.dragStart.apply(null, arguments);
  } } }, [t._t("dot", function() {
    return [e("div", { class: t.handleClasses, style: t.dotStyle })];
  }), t.tooltip !== "none" ? e("div", { class: t.tooltipClasses }, [t._t("tooltip", function() {
    return [e("div", { class: t.tooltipInnerClasses, style: t.tooltipStyle }, [e("span", { staticClass: "vue-slider-dot-tooltip-text" }, [t._v(t._s(t.tooltipValue))])])];
  })], 2) : t._e()], 2);
}, C3 = [], S3 = /* @__PURE__ */ U(
  _3,
  x3,
  C3,
  !1,
  null,
  null
);
const w3 = S3.exports, k3 = _l({
  name: "VueSliderMark",
  emits: ["press-label"],
  props: {
    mark: {
      type: Object,
      required: !0
    },
    hideLabel: { type: Boolean },
    stepStyle: { type: [Object, Array] },
    stepActiveStyle: { type: [Object, Array] },
    labelStyle: { type: [Object, Array] },
    labelActiveStyle: { type: [Object, Array] }
  },
  computed: {
    marksClasses() {
      return [
        "vue-slider-mark",
        {
          "vue-slider-mark-active": this.mark.active
        }
      ];
    },
    stepClasses() {
      return [
        "vue-slider-mark-step",
        {
          "vue-slider-mark-step-active": this.mark.active
        }
      ];
    },
    labelClasses() {
      return [
        "vue-slider-mark-label",
        {
          "vue-slider-mark-label-active": this.mark.active
        }
      ];
    }
  },
  methods: {
    labelClickHandle(i) {
      i.stopPropagation(), this.$emit("PressLabel", this.mark.pos);
    }
  }
});
var O3 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", { class: t.marksClasses }, [t._t("step", function() {
    return [e("div", { class: t.stepClasses, style: [
      t.stepStyle,
      t.mark.style,
      t.mark.active ? t.stepActiveStyle : null,
      t.mark.active ? t.mark.activeStyle : null
    ] })];
  }), t.hideLabel ? t._e() : t._t("label", function() {
    return [e("div", { class: t.labelClasses, style: [
      t.labelStyle,
      t.mark.labelStyle,
      t.mark.active ? t.labelActiveStyle : null,
      t.mark.active ? t.mark.labelActiveStyle : null
    ], on: { click: t.labelClickHandle } }, [t._v(" " + t._s(t.mark.label) + " ")])];
  })], 2);
}, M3 = [], T3 = /* @__PURE__ */ U(
  k3,
  O3,
  M3,
  !1,
  null,
  null
);
const D3 = T3.exports, ps = (i) => typeof i == "number" ? `${i}px` : i, P3 = (i) => {
  const t = document.documentElement, e = document.body, n = i.getBoundingClientRect();
  return {
    y: n.top + (window.pageYOffset || t.scrollTop) - (t.clientTop || e.clientTop || 0),
    x: n.left + (window.pageXOffset || t.scrollLeft) - (t.clientLeft || e.clientLeft || 0)
  };
}, L3 = (i, t, e) => {
  const n = "targetTouches" in i ? i.targetTouches[0] : i, s = P3(t), r = {
    x: n.pageX - s.x,
    y: n.pageY - s.y
  };
  return {
    x: e ? t.offsetWidth - r.x : r.x,
    y: e ? t.offsetHeight - r.y : r.y
  };
}, I3 = (i, t) => {
  if (t.hook) {
    const e = t.hook(i);
    if (typeof e == "function") return e;
    if (!e) return null;
  }
  switch (i.keyCode) {
    case 38:
      return (e) => t.direction === "ttb" ? e - 1 : e + 1;
    case 39:
      return (e) => t.direction === "rtl" ? e - 1 : e + 1;
    case 40:
      return (e) => t.direction === "ttb" ? e + 1 : e - 1;
    case 37:
      return (e) => t.direction === "rtl" ? e + 1 : e - 1;
    case 35:
      return () => t.max;
    case 36:
      return () => t.min;
    case 33:
      return (e) => e + 10;
    case 34:
      return (e) => e - 10;
    default:
      return null;
  }
};
class wi {
  constructor(t) {
    this.num = t;
  }
  decimal(t, e) {
    const n = this.num, s = this.getDecimalLen(n), r = this.getDecimalLen(t);
    let a = 0;
    switch (e) {
      case "+":
        a = this.getExponent(s, r), this.num = (this.safeRoundUp(n, a) + this.safeRoundUp(t, a)) / a;
        break;
      case "-":
        a = this.getExponent(s, r), this.num = (this.safeRoundUp(n, a) - this.safeRoundUp(t, a)) / a;
        break;
      case "*":
        this.num = this.safeRoundUp(
          this.safeRoundUp(n, this.getExponent(s)),
          this.safeRoundUp(t, this.getExponent(r))
        ) / this.getExponent(s + r);
        break;
      case "/":
        a = this.getExponent(s, r), this.num = this.safeRoundUp(n, a) / this.safeRoundUp(t, a);
        break;
      case "%":
        a = this.getExponent(s, r), this.num = this.safeRoundUp(n, a) % this.safeRoundUp(t, a) / a;
        break;
    }
    return this;
  }
  plus(t) {
    return this.decimal(t, "+");
  }
  minus(t) {
    return this.decimal(t, "-");
  }
  multiply(t) {
    return this.decimal(t, "*");
  }
  divide(t) {
    return this.decimal(t, "/");
  }
  remainder(t) {
    return this.decimal(t, "%");
  }
  toNumber() {
    return this.num;
  }
  getDecimalLen(t) {
    const e = `${t}`.split("e");
    return (`${e[0]}`.split(".")[1] || "").length - (e[1] ? +e[1] : 0);
  }
  getExponent(t, e) {
    return Math.pow(10, e !== void 0 ? Math.max(t, e) : t);
  }
  // fix: 9999999.99995 * 100000 = 999999999994.9999
  safeRoundUp(t, e) {
    return Math.round(t * e);
  }
}
const E3 = {
  1: 'The type of the "value" is illegal',
  2: 'The prop "interval" is invalid, "(max - min)" must be divisible by "interval"',
  3: 'The "value" must be greater than or equal to the "min".',
  4: 'The "value" must be less than or equal to the "max".',
  5: 'When "order" is false, the parameters "minRange", "maxRange", "fixed", "enabled" are invalid.'
};
class $3 {
  constructor(t) {
    this.dotsPos = [], this.dotsValue = [], this.cacheRangeDir = {}, this.data = t.data, this.max = t.max, this.min = t.min, this.interval = t.interval, this.order = t.order, this.marks = t.marks, this.included = t.included, this.process = t.process, this.adsorb = t.adsorb, this.dotOptions = t.dotOptions, this.onError = t.onError, this.order ? (this.minRange = t.minRange || 0, this.maxRange = t.maxRange || 0, this.enableCross = t.enableCross, this.fixed = t.fixed) : ((t.minRange || t.maxRange || !t.enableCross || t.fixed) && this.emitError(
      5
      /* ORDER */
    ), this.minRange = 0, this.maxRange = 0, this.enableCross = !0, this.fixed = !1), this.setValue(t.value);
  }
  setValue(t) {
    this.setDotsValue(Array.isArray(t) ? [...t] : [t], !0);
  }
  setDotsValue(t, e) {
    this.dotsValue = t, e && this.syncDotsPos();
  }
  // Set the slider position
  setDotsPos(t) {
    const e = this.order ? [...t].sort((n, s) => n - s) : t;
    this.dotsPos = e, this.setDotsValue(e.map((n) => this.getValueByPos(n)), this.adsorb);
  }
  // Get value by position
  getValueByPos(t) {
    let e = this.parsePos(t);
    if (this.included) {
      let n = 100;
      this.markList.forEach((s) => {
        const r = Math.abs(s.pos - t);
        r < n && (n = r, e = s.value);
      });
    }
    return e;
  }
  // Sync slider position
  syncDotsPos() {
    this.dotsPos = this.dotsValue.map((t) => this.parseValue(t));
  }
  /**
   * Get all the marks
   *
   * @readonly
   * @type {Mark[]}
   * @memberof Control
   */
  get markList() {
    if (!this.marks)
      return [];
    const t = (e, n) => {
      const s = this.parseValue(e);
      return {
        pos: s,
        value: e,
        label: e,
        active: this.isActiveByPos(s),
        ...n
      };
    };
    return this.marks === !0 ? this.getValues().map((e) => t(e)) : Object.prototype.toString.call(this.marks) === "[object Object]" ? Object.keys(this.marks).sort((e, n) => +e - +n).map((e) => {
      const n = this.marks[e];
      return t(e, typeof n != "string" ? n : { label: n });
    }) : Array.isArray(this.marks) ? this.marks.map((e) => t(e)) : typeof this.marks == "function" ? this.getValues().map((e) => ({ value: e, result: this.marks(e) })).filter(({ result: e }) => !!e).map(({ value: e, result: n }) => t(e, n)) : [];
  }
  /**
   * Get the most recent slider index by position
   *
   * @param {number} pos
   * @returns {number}
   * @memberof Control
   */
  getRecentDot(t) {
    const e = this.dotsPos.map((n) => Math.abs(n - t));
    return e.indexOf(Math.min(...e));
  }
  /**
   * Get index by value
   *
   * @param {Value} value
   * @returns {number}
   * @memberof Control
   */
  getIndexByValue(t) {
    return this.data ? this.data.indexOf(t) : new wi(+t).minus(this.min).divide(this.interval).toNumber();
  }
  /**
   * Get value by index
   *
   * @param {index} number
   * @returns {Value}
   * @memberof Control
   */
  getValueByIndex(t) {
    return t < 0 ? t = 0 : t > this.total && (t = this.total), this.data ? this.data[t] : new wi(t).multiply(this.interval).plus(this.min).toNumber();
  }
  /**
   * Set the position of a single slider
   *
   * @param {number} pos
   * @param {number} index
   */
  setDotPos(t, e) {
    t = this.getValidPos(t, e).pos;
    const n = t - this.dotsPos[e];
    if (!n)
      return;
    let s = new Array(this.dotsPos.length);
    this.fixed ? s = this.getFixedChangePosArr(n, e) : this.minRange || this.maxRange ? s = this.getLimitRangeChangePosArr(t, n, e) : s[e] = n, this.setDotsPos(this.dotsPos.map((r, a) => r + (s[a] || 0)));
  }
  /**
   * In fixed mode, get the position of all slider changes
   *
   * @param {number} changePos Change distance of a single slider
   * @param {number} index slider index
   * @returns {DotsPosChangeArray}
   * @memberof Control
   */
  getFixedChangePosArr(t, e) {
    return this.dotsPos.forEach((n, s) => {
      if (s !== e) {
        const { pos: r, inRange: a } = this.getValidPos(n + t, s);
        a || (t = Math.min(Math.abs(r - n), Math.abs(t)) * (t < 0 ? -1 : 1));
      }
    }), this.dotsPos.map((n) => t);
  }
  /**
   * In minRange/maxRange mode, get the position of all slider changes
   *
   * @param {number} pos position of a single slider
   * @param {number} changePos Change distance of a single slider
   * @param {number} index slider index
   * @returns {DotsPosChangeArray}
   * @memberof Control
   */
  getLimitRangeChangePosArr(t, e, n) {
    const s = [{ index: n, changePos: e }], r = e;
    return [this.minRange, this.maxRange].forEach((a, o) => {
      if (!a)
        return !1;
      const l = o === 0, c = e > 0;
      let u = 0;
      l ? u = c ? 1 : -1 : u = c ? -1 : 1;
      const d = (g, m) => {
        const v = Math.abs(g - m);
        return l ? v < this.minRangeDir : v > this.maxRangeDir;
      };
      let h = n + u, f = this.dotsPos[h], p = t;
      for (; this.isPos(f) && d(f, p); ) {
        const { pos: g } = this.getValidPos(f + r, h);
        s.push({
          index: h,
          changePos: g - f
        }), h = h + u, p = g, f = this.dotsPos[h];
      }
    }), this.dotsPos.map((a, o) => {
      const l = s.filter((c) => c.index === o);
      return l.length ? l[0].changePos : 0;
    });
  }
  isPos(t) {
    return typeof t == "number";
  }
  /**
   * Get a valid position by pos
   *
   * @param {number} pos
   * @param {number} index
   * @returns {{ pos: number, inRange: boolean }}
   */
  getValidPos(t, e) {
    const n = this.valuePosRange[e];
    let s = !0;
    return t < n[0] ? (t = n[0], s = !1) : t > n[1] && (t = n[1], s = !1), {
      pos: t,
      inRange: s
    };
  }
  /**
   * Calculate the position of the slider by value
   *
   * @param {Value} val
   * @returns {number}
   */
  parseValue(t) {
    if (this.data)
      t = this.data.indexOf(t);
    else if (typeof t == "number" || typeof t == "string") {
      if (t = +t, t < this.min)
        return this.emitError(
          3
          /* MIN */
        ), 0;
      if (t > this.max)
        return this.emitError(
          4
          /* MAX */
        ), 0;
      if (typeof t != "number" || t !== t)
        return this.emitError(
          1
          /* VALUE */
        ), 0;
      t = new wi(t).minus(this.min).divide(this.interval).toNumber();
    }
    const e = new wi(t).multiply(this.gap).toNumber();
    return e < 0 ? 0 : e > 100 ? 100 : e;
  }
  /**
   * Calculate the value by position
   *
   * @param {number} pos
   * @returns {Value}
   * @memberof Control
   */
  parsePos(t) {
    const e = Math.round(t / this.gap);
    return this.getValueByIndex(e);
  }
  /**
   * Determine if the location is active
   *
   * @param {number} pos
   * @returns {boolean}
   * @memberof Control
   */
  isActiveByPos(t) {
    return this.processArray.some(([e, n]) => t >= e && t <= n);
  }
  /**
   * Get each value
   *
   * @returns {Value[]}
   * @memberof Control
   */
  getValues() {
    if (this.data)
      return this.data;
    {
      const t = [];
      for (let e = 0; e <= this.total; e++)
        t.push(
          new wi(e).multiply(this.interval).plus(this.min).toNumber()
        );
      return t;
    }
  }
  /**
   * Calculate the distance of the range
   * @param range number
   */
  getRangeDir(t) {
    return t ? new wi(t).divide(
      new wi(this.data ? this.data.length - 1 : this.max).minus(this.data ? 0 : this.min).toNumber()
    ).multiply(100).toNumber() : 100;
  }
  emitError(t) {
    this.onError && this.onError(t, E3[t]);
  }
  get processArray() {
    if (this.process) {
      if (typeof this.process == "function")
        return this.process(this.dotsPos);
      if (this.dotsPos.length === 1)
        return [[0, this.dotsPos[0]]];
      if (this.dotsPos.length > 1)
        return [[Math.min(...this.dotsPos), Math.max(...this.dotsPos)]];
    }
    return [];
  }
  /**
   * The total number of values
   *
   * @type {number}
   * @memberof Control
   */
  get total() {
    let t = 0;
    return this.data ? t = this.data.length - 1 : t = new wi(this.max).minus(this.min).divide(this.interval).toNumber(), t - Math.floor(t) !== 0 ? (this.emitError(
      2
      /* INTERVAL */
    ), 0) : t;
  }
  // Distance between each value
  get gap() {
    return 100 / this.total;
  }
  // The minimum distance between the two sliders
  get minRangeDir() {
    return this.cacheRangeDir[this.minRange] ? this.cacheRangeDir[this.minRange] : this.cacheRangeDir[this.minRange] = this.getRangeDir(this.minRange);
  }
  // Maximum distance between the two sliders
  get maxRangeDir() {
    return this.cacheRangeDir[this.maxRange] ? this.cacheRangeDir[this.maxRange] : this.cacheRangeDir[this.maxRange] = this.getRangeDir(this.maxRange);
  }
  getDotRange(t, e, n) {
    if (!this.dotOptions)
      return n;
    const s = Array.isArray(this.dotOptions) ? this.dotOptions[t] : this.dotOptions;
    return s && s[e] !== void 0 ? this.parseValue(s[e]) : n;
  }
  /**
   * Sliding range of each slider
   *
   * @type {Array<[number, number]>}
   * @memberof Control
   */
  get valuePosRange() {
    const t = this.dotsPos, e = [];
    return t.forEach((n, s) => {
      e.push([
        Math.max(
          this.minRange ? this.minRangeDir * s : 0,
          this.enableCross ? 0 : t[s - 1] || 0,
          this.getDotRange(s, "min", 0)
        ),
        Math.min(
          this.minRange ? 100 - this.minRangeDir * (t.length - 1 - s) : 100,
          this.enableCross ? 100 : t[s + 1] || 100,
          this.getDotRange(s, "max", 100)
        )
      ]);
    }), e;
  }
  get dotsIndex() {
    return this.dotsValue.map((t) => this.getIndexByValue(t));
  }
}
class B3 {
  constructor(t) {
    this.states = 0, this.map = t;
  }
  add(t) {
    this.states |= t;
  }
  delete(t) {
    this.states &= ~t;
  }
  toggle(t) {
    this.has(t) ? this.delete(t) : this.add(t);
  }
  has(t) {
    return !!(this.states & t);
  }
}
const te = {
  None: 0,
  Drag: 2,
  Focus: 4
}, Xa = 4, R3 = _l({
  name: "VueSlider",
  components: {
    VueSliderDot: w3,
    VueSliderMark: D3
  },
  emits: ["change", "drag-start", "dragging", "drag-end", "error", "update:modelValue"],
  data() {
    return {
      control: null,
      states: new B3(te),
      // The width of the component is divided into one hundred, the width of each one.
      scale: 1,
      // Currently dragged slider index
      focusDotIndex: 0
    };
  },
  props: {
    modelValue: {
      type: [Number, String, Array],
      default: 0
    },
    silent: { type: Boolean, default: !1 },
    direction: {
      type: String,
      default: "ltr",
      validator: (i) => ["ltr", "rtl", "ttb", "btt"].indexOf(i) > -1
    },
    width: { type: [Number, String] },
    height: { type: [Number, String] },
    // The size of the slider, optional [width, height] | size
    dotSize: {
      type: [Number, Array],
      default: 14
    },
    // whether or not the slider should be fully contained within its containing element
    contained: { type: Boolean, default: !1 },
    min: { type: Number, default: 0 },
    max: { type: Number, default: 100 },
    interval: { type: Number, default: 1 },
    disabled: { type: Boolean, default: !1 },
    clickable: { type: Boolean, default: !0 },
    dragOnClick: { type: Boolean, default: !1 },
    duration: { type: Number, default: 0.5 },
    vData: {
      type: [Object, Array]
    },
    dataValue: { type: String, default: "value" },
    dataLabel: { type: String, default: "label" },
    lazy: { type: Boolean, default: !1 },
    tooltip: {
      type: String,
      default: "active",
      validator: (i) => ["none", "always", "focus", "hover", "active"].indexOf(i) > -1
    },
    tooltipPlacement: {
      type: [String, Array],
      validator: (i) => (Array.isArray(i) ? i : [i]).every(
        (t) => ["top", "right", "bottom", "left"].indexOf(t) > -1
      )
    },
    tooltipFormatter: {
      type: [String, Array, Function]
    },
    // Keyboard control
    useKeyboard: { type: Boolean, default: !0 },
    // Keyboard controlled hook function
    keydownHook: {
      // eslint-disable-next-line no-unused-vars
      type: Function
    },
    // Whether to allow sliders to cross, only in range mode
    enableCross: { type: Boolean, default: !0 },
    // Whether to fix the slider interval, only in range mode
    fixed: { type: Boolean, default: !1 },
    // Whether to sort values, only in range mode
    // When order is false, the parameters [minRange, maxRange, fixed, enableCross] are invalid
    // e.g. When order = false, [50, 30] will not be automatically sorted into [30, 50]
    order: { type: Boolean, default: !0 },
    // Minimum distance between sliders, only in range mode
    minRange: { type: Number },
    // Maximum distance between sliders, only in range mode
    maxRange: { type: Number },
    marks: {
      type: [Boolean, Object, Array, Function],
      default: !1
    },
    process: {
      type: [Boolean, Function],
      default: !0
    },
    // If the value is true , mark will be an independent value
    included: { type: Boolean },
    // If the value is true , dot will automatically adsorb to the nearest value
    adsorb: { type: Boolean },
    hideLabel: { type: Boolean },
    // Slider settings, multiple sliders can be distinguished by array type.
    dotOptions: {
      type: [Object, Array]
    },
    // Set custom attributes on the slider.
    dotAttrs: { type: Object },
    railStyle: { type: Object },
    processStyle: { type: Object },
    dotStyle: { type: Object },
    tooltipStyle: { type: Object },
    stepStyle: { type: Object },
    stepActiveStyle: { type: Object },
    labelStyle: { type: Object },
    labelActiveStyle: { type: Object }
  },
  computed: {
    isHorizontal() {
      return this.direction === "ltr" || this.direction === "rtl";
    },
    isReverse() {
      return this.direction === "rtl" || this.direction === "btt";
    },
    tailSize() {
      return ps((this.isHorizontal ? this.height : this.width) || Xa);
    },
    containerClasses() {
      return [
        "vue-slider",
        [`vue-slider-${this.direction}`],
        {
          "vue-slider-disabled": this.disabled
        }
      ];
    },
    containerStyles() {
      const [i, t] = Array.isArray(this.dotSize) ? this.dotSize : [this.dotSize, this.dotSize], e = this.width ? ps(this.width) : this.isHorizontal ? "auto" : ps(Xa), n = this.height ? ps(this.height) : this.isHorizontal ? ps(Xa) : "auto";
      return {
        padding: this.contained ? `${t / 2}px ${i / 2}px` : this.isHorizontal ? `${t / 2}px 0` : `0 ${i / 2}px`,
        width: e,
        height: n
      };
    },
    processArray() {
      return this.control.processArray.map(([i, t, e], n) => {
        i > t && ([i, t] = [t, i]);
        const s = this.isHorizontal ? "width" : "height";
        return {
          start: i,
          end: t,
          index: n,
          style: {
            [this.isHorizontal ? "height" : "width"]: "100%",
            [this.isHorizontal ? "top" : "left"]: 0,
            [this.mainDirection]: `${i}%`,
            [s]: `${t - i}%`,
            transitionProperty: `${s},${this.mainDirection}`,
            transitionDuration: `${this.animateTime}s`,
            ...this.processStyle,
            ...e
          }
        };
      });
    },
    dotBaseStyle() {
      const [i, t] = Array.isArray(this.dotSize) ? this.dotSize : [this.dotSize, this.dotSize];
      let e;
      return this.isHorizontal ? e = {
        transform: `translate(${this.isReverse ? "50%" : "-50%"}, -50%)`,
        WebkitTransform: `translate(${this.isReverse ? "50%" : "-50%"}, -50%)`,
        top: "50%",
        [this.direction === "ltr" ? "left" : "right"]: "0"
      } : e = {
        transform: `translate(-50%, ${this.isReverse ? "50%" : "-50%"})`,
        WebkitTransform: `translate(-50%, ${this.isReverse ? "50%" : "-50%"})`,
        left: "50%",
        [this.direction === "btt" ? "bottom" : "top"]: "0"
      }, {
        width: `${i}px`,
        height: `${t}px`,
        ...e
      };
    },
    mainDirection() {
      switch (this.direction) {
        case "ltr":
          return "left";
        case "rtl":
          return "right";
        case "btt":
          return "bottom";
        case "ttb":
          return "top";
        default:
          return "left";
      }
    },
    tooltipDirections() {
      const i = this.tooltipPlacement || (this.isHorizontal ? "top" : "left");
      return Array.isArray(i) ? i : this.dots.map(() => i);
    },
    dots() {
      return this.control.dotsPos.map((i, t) => ({
        pos: i,
        index: t,
        value: this.control.dotsValue[t],
        focus: this.states.has(te.Focus) && this.focusDotIndex === t,
        disabled: this.disabled,
        style: this.dotStyle,
        ...(Array.isArray(this.dotOptions) ? this.dotOptions[t] : this.dotOptions) || {}
      }));
    },
    animateTime() {
      return this.states.has(te.Drag) ? 0 : this.duration;
    },
    canSort() {
      return this.order && !this.minRange && !this.maxRange && !this.fixed && this.enableCross;
    },
    sliderData() {
      return this.isObjectArrayData(this.vData) ? this.vData.map((i) => i[this.dataValue]) : this.isObjectData(this.vData) ? Object.keys(this.vData) : this.vData;
    },
    sliderMarks() {
      return this.marks ? this.marks : this.isObjectArrayData(this.vData) ? (i) => {
        const t = { label: i };
        return this.vData.some((e) => e[this.dataValue] === i ? (t.label = e[this.dataLabel], !0) : !1), t;
      } : this.isObjectData(this.vData) ? this.vData : void 0;
    },
    sliderTooltipFormatter() {
      if (this.tooltipFormatter)
        return this.tooltipFormatter;
      if (this.isObjectArrayData(this.vData))
        return (i) => {
          let t = "" + i;
          return this.vData.some((e) => e[this.dataValue] === i ? (t = e[this.dataLabel], !0) : !1), t;
        };
      if (this.isObjectData(this.vData)) {
        const i = this.vData;
        return (t) => i[t];
      } else
        return;
    },
    // Slider value and component internal value are inconsistent
    isNotSync() {
      const i = this.control.dotsValue;
      return Array.isArray(this.modelValue) ? this.modelValue.length !== i.length || this.modelValue.some((t, e) => t !== i[e]) : this.modelValue !== i[0];
    },
    /**
     * Get the drag range of the slider
     *
     * @private
     * @param {number} index slider index
     * @returns {[number, number]} range [start, end]
     * @memberof VueSlider
     */
    dragRange() {
      const i = this.dots[this.focusDotIndex - 1], t = this.dots[this.focusDotIndex + 1];
      return [i ? i.pos : -1 / 0, t ? t.pos : 1 / 0];
    }
  },
  watch: {
    modelValue() {
      this.control && !this.states.has(te.Drag) && this.isNotSync && this.control.setValue(this.modelValue);
    }
  },
  methods: {
    isObjectData(i) {
      return !!i && Object.prototype.toString.call(i) === "[object Object]";
    },
    isObjectArrayData(i) {
      return !!i && Array.isArray(i) && i.length > 0 && typeof i[0] == "object";
    },
    bindEvent() {
      document.addEventListener("touchmove", this.dragMove, { passive: !1 }), document.addEventListener("touchend", this.dragEnd, { passive: !1 }), document.addEventListener("mousedown", this.blurHandle), document.addEventListener("mousemove", this.dragMove), document.addEventListener("mouseup", this.dragEnd), document.addEventListener("mouseleave", this.dragEnd), document.addEventListener("keydown", this.keydownHandle);
    },
    unbindEvent() {
      document.removeEventListener("touchmove", this.dragMove), document.removeEventListener("touchend", this.dragEnd), document.removeEventListener("mousedown", this.blurHandle), document.removeEventListener("mousemove", this.dragMove), document.removeEventListener("mouseup", this.dragEnd), document.removeEventListener("mouseleave", this.dragEnd), document.removeEventListener("keydown", this.keydownHandle);
    },
    setScale() {
      this.scale = new wi(
        Math.floor(this.isHorizontal ? this.$el.offsetWidth : this.$el.offsetHeight)
      ).divide(100).toNumber();
    },
    initControl() {
      this.control = new $3({
        value: this.modelValue,
        data: this.sliderData,
        enableCross: this.enableCross,
        fixed: this.fixed,
        max: this.max,
        min: this.min,
        interval: this.interval,
        minRange: this.minRange,
        maxRange: this.maxRange,
        order: this.order,
        marks: this.sliderMarks,
        included: this.included,
        process: this.process,
        adsorb: this.adsorb,
        dotOptions: this.dotOptions,
        onError: this.emitError
      }), [
        "data",
        "enableCross",
        "fixed",
        "max",
        "min",
        "interval",
        "minRange",
        "maxRange",
        "order",
        "marks",
        "process",
        "adsorb",
        "included",
        "dotOptions"
      ].forEach((i) => {
        this.$watch(i, (t) => {
          if (i === "data" && Array.isArray(this.control.data) && Array.isArray(t) && this.control.data.length === t.length && t.every((e, n) => e === this.control.data[n]))
            return !1;
          switch (i) {
            case "data":
            case "dataLabel":
            case "dataValue":
              this.control.data = this.sliderData;
              break;
            case "mark":
              this.control.marks = this.sliderMarks;
              break;
            default:
              this.control[i] = t;
          }
          ["data", "max", "min", "interval"].indexOf(i) > -1 && this.control.syncDotsPos();
        });
      });
    },
    syncValueByPos() {
      const i = this.control.dotsValue;
      if (this.isDiff(i, Array.isArray(this.modelValue) ? this.modelValue : [this.modelValue])) {
        const t = i.length === 1 ? i[0] : [...i];
        this.$emit("change", t, this.focusDotIndex), this.$emit("update:modelValue", t);
      }
    },
    isDiff(i, t) {
      return i.length !== t.length || i.some((e, n) => e !== t[n]);
    },
    emitError(i, t) {
      this.silent || console.error(`[VueSlider error]: ${t}`), this.$emit("error", i, t);
    },
    dragStartOnProcess(i) {
      if (this.dragOnClick) {
        this.setScale();
        const t = this.getPosByEvent(i), e = this.control.getRecentDot(t);
        if (this.dots[e].disabled)
          return;
        this.dragStart(e), this.control.setDotPos(t, this.focusDotIndex), this.lazy || this.syncValueByPos();
      }
    },
    dragStart(i) {
      this.focusDotIndex = i, this.setScale(), this.states.add(te.Drag), this.states.add(te.Focus), this.$emit("drag-start", this.focusDotIndex);
    },
    dragMove(i) {
      if (!this.states.has(te.Drag))
        return !1;
      i.preventDefault();
      const t = this.getPosByEvent(i);
      this.isCrossDot(t), this.control.setDotPos(t, this.focusDotIndex), this.lazy || this.syncValueByPos();
      const e = this.control.dotsValue;
      this.$emit("dragging", e.length === 1 ? e[0] : [...e], this.focusDotIndex);
    },
    // If the component is sorted, then when the slider crosses, toggle the currently selected slider index
    isCrossDot(i) {
      if (this.canSort) {
        const t = this.focusDotIndex;
        let e = i;
        if (e > this.dragRange[1] ? (e = this.dragRange[1], this.focusDotIndex++) : e < this.dragRange[0] && (e = this.dragRange[0], this.focusDotIndex--), t !== this.focusDotIndex) {
          const n = this.$refs[`dot-${this.focusDotIndex}`];
          n && n.$el && n.$el.focus(), this.control.setDotPos(e, t);
        }
      }
    },
    dragEnd(i) {
      if (!this.states.has(te.Drag))
        return !1;
      setTimeout(() => {
        this.lazy && this.syncValueByPos(), this.included && this.isNotSync ? this.control.setValue(this.modelValue) : this.control.syncDotsPos(), this.states.delete(te.Drag), (!this.useKeyboard || "targetTouches" in i) && this.states.delete(te.Focus), this.$emit("drag-end", this.focusDotIndex);
      });
    },
    blurHandle(i) {
      if (!this.states.has(te.Focus) || !this.$refs.container || this.$refs.container.contains(i.target))
        return !1;
      this.states.delete(te.Focus);
    },
    clickHandle(i) {
      if (!this.clickable || this.disabled)
        return !1;
      if (this.states.has(te.Drag))
        return;
      this.setScale();
      const t = this.getPosByEvent(i);
      this.setValueByPos(t);
    },
    focus(i, t = 0) {
      i.disabled || (this.states.add(te.Focus), this.focusDotIndex = t);
    },
    blur() {
      this.states.delete(te.Focus);
    },
    getValue() {
      const i = this.control.dotsValue;
      return i.length === 1 ? i[0] : i;
    },
    getIndex() {
      const i = this.control.dotsIndex;
      return i.length === 1 ? i[0] : i;
    },
    setValue(i) {
      this.control.setValue(Array.isArray(i) ? [...i] : [i]), this.syncValueByPos();
    },
    setIndex(i) {
      const t = Array.isArray(i) ? i.map((e) => this.control.getValueByIndex(e)) : this.control.getValueByIndex(i);
      this.setValue(t);
    },
    setValueByPos(i) {
      const t = this.control.getRecentDot(i);
      if (this.disabled || this.dots[t].disabled)
        return !1;
      this.focusDotIndex = t, this.control.setDotPos(i, t), this.syncValueByPos(), this.useKeyboard && this.states.add(te.Focus), setTimeout(() => {
        this.included && this.isNotSync ? this.control.setValue(this.modelValue) : this.control.syncDotsPos();
      });
    },
    keydownHandle(i) {
      if (!this.useKeyboard || !this.states.has(te.Focus))
        return !1;
      const t = this.included && this.marks, e = I3(i, {
        direction: this.direction,
        max: t ? this.control.markList.length - 1 : this.control.total,
        min: 0,
        hook: this.keydownHook
      });
      if (e) {
        i.preventDefault();
        let n = -1, s = 0;
        t ? (this.control.markList.some((r, a) => r.value === this.control.dotsValue[this.focusDotIndex] ? (n = e(a), !0) : !1), n < 0 ? n = 0 : n > this.control.markList.length - 1 && (n = this.control.markList.length - 1), s = this.control.markList[n].pos) : (n = e(
          this.control.getIndexByValue(this.control.dotsValue[this.focusDotIndex])
        ), s = this.control.parseValue(this.control.getValueByIndex(n))), this.isCrossDot(s), this.control.setDotPos(s, this.focusDotIndex), this.syncValueByPos();
      }
    },
    getPosByEvent(i) {
      return L3(i, this.$el, this.isReverse)[this.isHorizontal ? "x" : "y"] / this.scale;
    },
    renderSlot(i, t, e) {
      const n = this.$slots[i];
      return n ? n(t) : e;
    }
  },
  created() {
    this.initControl();
  },
  mounted() {
    this.bindEvent();
  },
  beforeUnmount() {
    this.unbindEvent();
  }
});
var F3 = function() {
  var t = this, e = t._self._c;
  return t._self._setupProxy, e("div", t._b({ ref: "container", class: t.containerClasses, style: t.containerStyles, on: { click: t.clickHandle, "&touchstart": function(n) {
    return t.dragStartOnProcess.apply(null, arguments);
  }, "&mousedown": function(n) {
    return t.dragStartOnProcess.apply(null, arguments);
  } } }, "div", t.$attrs, !1), [e("div", { staticClass: "vue-slider-rail", style: t.railStyle }, [t._l(t.processArray, function(n, s) {
    return t._t("process", function() {
      return [e("div", { key: `process-${s}`, staticClass: "vue-slider-process", style: n.style })];
    }, null, n);
  }), t.sliderMarks && t.control ? e("div", { staticClass: "vue-slider-marks" }, [t._l(t.control.markList, function(n, s) {
    return t._t("mark", function() {
      return [e("vue-slider-mark", { key: `mark-${s}`, style: {
        [t.isHorizontal ? "height" : "width"]: "100%",
        [t.isHorizontal ? "width" : "height"]: t.tailSize,
        [t.mainDirection]: `${n.pos}%`
      }, attrs: { mark: n, hideLabel: t.hideLabel, stepStyle: t.stepStyle, stepActiveStyle: t.stepActiveStyle, labelStyle: t.labelStyle, labelActiveStyle: t.labelActiveStyle }, on: { "press-label": (r) => t.clickable && t.setValueByPos(r) }, scopedSlots: t._u([{ key: "step", fn: function() {
        return [t._t("step", null, null, n)];
      }, proxy: !0 }, { key: "label", fn: function() {
        return [t._t("label", null, null, n)];
      }, proxy: !0 }], null, !0) })];
    }, null, n);
  })], 2) : t._e(), t._l(t.dots, function(n, s) {
    return e("vue-slider-dot", t._b({ key: `dot-${s}`, ref: `dot-${s}`, refInFor: !0, style: [
      t.dotBaseStyle,
      {
        [t.mainDirection]: `${n.pos}%`,
        transition: `${t.mainDirection} ${t.animateTime}s`
      }
    ], attrs: { value: n.value, disabled: n.disabled, focus: n.focus, "dot-style": [
      n.style,
      n.disabled ? n.disabledStyle : null,
      n.focus ? n.focusStyle : null
    ], tooltip: n.tooltip || t.tooltip, "tooltip-style": [
      t.tooltipStyle,
      n.tooltipStyle,
      n.disabled ? n.tooltipDisabledStyle : null,
      n.focus ? n.tooltipFocusStyle : null
    ], "tooltip-formatter": Array.isArray(t.sliderTooltipFormatter) ? t.sliderTooltipFormatter[s] : t.sliderTooltipFormatter, "tooltip-placement": t.tooltipDirections[s], role: "slider", "aria-valuenow": n.value, "aria-valuemin": t.min, "aria-valuemax": t.max, "aria-orientation": t.isHorizontal ? "horizontal" : "vertical", tabindex: "0" }, on: { "drag-start": () => t.dragStart(s), focus: () => t.focus(n, s), blur: () => t.blur() }, scopedSlots: t._u([{ key: "dot", fn: function() {
      return [t._t("dot", null, null, n)];
    }, proxy: !0 }, { key: "tooltip", fn: function() {
      return [t._t("tooltip", null, null, n)];
    }, proxy: !0 }], null, !0) }, "vue-slider-dot", t.dotAttrs, !1));
  })], 2), t._t("default", null, { value: t.getValue() })], 2);
}, N3 = [], H3 = /* @__PURE__ */ U(
  R3,
  F3,
  N3,
  !1,
  null,
  null
);
const V3 = H3.exports, z3 = {
  name: "AcvRangeSlider",
  components: {
    VueSlider: V3
  },
  mixins: [
    ue,
    yi
  ],
  props: {
    /**
    * V-model for the value of the Vue Slider
    * Listens on events that are deatiled in their documentation
    */
    value: {
      type: [Array, Number],
      default: () => []
    },
    /**
    * Custom data values that would be correlate to each point
    */
    data: {
      type: [Array, Object],
      default: null
    },
    /**
    * The interval value between two points
    */
    interval: {
      type: Number,
      default: 1
    },
    /**
    * Minimum distance between two points
    */
    minRange: {
      type: Number,
      default: 100
    },
    /**
    * Lowest possible interval value
    */
    min: {
      type: Number,
      default: 0
    },
    /**
    * Highest possible interval value
    */
    max: {
      type: Number,
      default: 100
    },
    /**
    * Disables the slider
    */
    disabled: {
      type: Boolean,
      default: !1
    },
    /**
    * Determines if a tooltip should be shown on different states
    */
    tooltip: {
      type: String,
      default: "none"
    },
    /**
    * Changes the dot styles
    */
    sliderHandleIcon: {
      type: String,
      default: "circle"
    },
    /**
    * Adjusts dot size
    */
    dotSize: {
      type: [Number, Array],
      default: 14
      // 14px is component default
    }
  },
  computed: {
    sliderHandleIconClass() {
      switch (this.sliderHandleIcon) {
        case "arrowUp":
          return "arrow-up";
        case "arrowDown":
          return "arrow-down";
        default:
          return "circle";
      }
    }
  },
  methods: {
    handleValueUpdate(i) {
      this.internalValue = i;
    }
  }
};
var j3 = function() {
  var t = this, e = t._self._c;
  return e("vue-slider", t._g({ ref: "AcvRangeSlider", staticClass: "acv-range-slider", class: {
    ...t.backgroundClasses
  }, attrs: { interval: t.interval, "min-range": t.minRange, data: t.data, min: t.min, max: t.max, disabled: t.disabled, tooltip: t.tooltip, order: !1, silent: !0, "dot-size": t.dotSize, "model-value": t.internalValue }, on: { "update:modelValue": t.handleValueUpdate }, scopedSlots: t._u([{ key: "dot", fn: function() {
    return [e("div", { staticClass: "vue-slider-dot-handle", class: t.sliderHandleIconClass })];
  }, proxy: !0 }]) }, t.$listeners));
}, W3 = [], Y3 = /* @__PURE__ */ U(
  z3,
  j3,
  W3,
  !1,
  null,
  "7b9dff6e"
);
const U3 = Y3.exports, Z3 = {
  strictMatch(i, t) {
    const e = t.toLowerCase();
    return typeof i == "string" ? i.toLowerCase().includes(e) : i.filterableValue.toLowerCase().includes(e);
  },
  looseMatch(i, t) {
    const e = t.toLowerCase().split("");
    return typeof i == "string" ? e.every((n) => i.toLowerCase().includes(n)) : e.every((n) => i.filterableValue.toLowerCase().includes(n));
  },
  filterItems(i, t, e = !0) {
    if (!t || !t.length)
      return i;
    const n = e ? this.strictMatch : this.looseMatch;
    return i.filter((s) => n(s, t));
  },
  getBestMatch(i, t) {
    if (!t || !t.length)
      return { isMatched: !1, matchedTerm: null };
    const e = i.find((n) => this.strictMatch(n, t));
    return {
      isMatched: !!e,
      matchedTerm: e || null
    };
  }
}, Th = {
  methods: Z3
}, G3 = {
  name: "AcvSearchBar",
  components: { AcvList: cs, AcvListItem: us, AcvTextField: Pe },
  mixins: [Th],
  props: {
    label: {
      type: String,
      default: "Search"
    },
    hideLabel: {
      type: Boolean,
      default: !1
    },
    items: {
      type: Array,
      default: () => []
    },
    includeAutocomplete: {
      type: Boolean,
      default: !0
    },
    autocompleteStrictMatch: {
      type: Boolean,
      default: !0
    },
    width: {
      type: String,
      default: "350px"
    }
  },
  data: () => ({
    searchText: "",
    selectedIndex: -1,
    isBlurred: !0
  }),
  computed: {
    sortedItems() {
      return [...this.items].sort();
    },
    filteredItems() {
      return this.filterItems(this.sortedItems, this.searchText, this.autocompleteStrictMatch);
    },
    shouldDisplayList() {
      return this.includeAutocomplete && this.searchText && this.filteredItems.length > 0 && !this.isBlurred;
    },
    styleProps() {
      return { "--width": this.width };
    }
  },
  methods: {
    selectItem() {
      this.selectedIndex === -1 ? this.$emit("item-selected", this.searchText) : this.shouldDisplayList && this.$emit("item-selected", this.filteredItems[this.selectedIndex]), this.searchText = "";
    },
    selectItemByClick(i) {
      this.selectedIndex = i, this.selectItem();
    },
    downKeyPressed() {
      this.shouldDisplayList && (this.selectedIndex = Math.min(this.selectedIndex + 1, this.filteredItems.length - 1));
    },
    upKeyPressed() {
      this.shouldDisplayList && (this.selectedIndex = Math.max(this.selectedIndex - 1, -1));
    },
    handleInputChange() {
      this.selectedIndex = -1, this.includeAutocomplete || this.$emit("search-text-changed", this.searchText);
    },
    handleBlur() {
      setTimeout(() => {
        this.isBlurred = !0;
      }, 200);
    },
    handleFocus() {
      this.isBlurred = !1;
    }
  }
};
var K3 = function() {
  var t = this, e = t._self._c;
  return e("div", [e("acv-text-field", { ref: "searchBar", staticClass: "search-bar", style: t.styleProps, attrs: { label: t.label, "hide-label": t.hideLabel, "show-clear": !0, type: "search", "icon-prepend": "search" }, on: { keydown: [function(n) {
    return !n.type.indexOf("key") && t._k(n.keyCode, "down", 40, n.key, ["Down", "ArrowDown"]) ? null : (n.preventDefault(), t.downKeyPressed.apply(null, arguments));
  }, function(n) {
    return !n.type.indexOf("key") && t._k(n.keyCode, "up", 38, n.key, ["Up", "ArrowUp"]) ? null : (n.preventDefault(), t.upKeyPressed.apply(null, arguments));
  }, function(n) {
    return !n.type.indexOf("key") && t._k(n.keyCode, "enter", 13, n.key, "Enter") ? null : (n.preventDefault(), t.selectItem.apply(null, arguments));
  }], input: t.handleInputChange, blur: t.handleBlur, focus: t.handleFocus }, model: { value: t.searchText, callback: function(n) {
    t.searchText = n;
  }, expression: "searchText" } }), t.shouldDisplayList ? e("acv-list", { staticClass: "autocomplete-list" }, [e("div", { staticClass: "list-container" }, t._l(t.filteredItems, function(n, s) {
    return e("acv-list-item", { key: `filtered-item-${s}`, staticClass: "acv-autocomplete-item", class: { "selected-item": s === t.selectedIndex }, on: { click: function(r) {
      return t.selectItemByClick(s);
    } } }, [t._v(" " + t._s(n.filterableValue) + " ")]);
  }), 1)]) : t._e()], 1);
}, X3 = [], Q3 = /* @__PURE__ */ U(
  G3,
  K3,
  X3,
  !1,
  null,
  "c8fd22cb"
);
const J3 = Q3.exports, q3 = {
  name: "AcvSegmentedControl",
  components: {
    AcvCheckbox: ls,
    AcvDivider: Js
  },
  model: {
    prop: "modelValue",
    event: "change"
  },
  props: {
    /**
     * The inherited v-model value
     */
    modelValue: {
      type: [Boolean, Array],
      default: !1
    },
    /**
     * Checks if the button should be disabled
     */
    disabledList: {
      type: Array,
      default: () => []
    },
    /**
     * Range to render
     */
    items: {
      type: Array,
      default: () => []
    },
    /**
     * Allows wrapping of elements
     */
    allowWrap: {
      type: Boolean,
      default: !1
    }
  },
  data: () => ({
    selection: []
  }),
  computed: {
    computedClasses() {
      return {
        "acv-segmented-control--wrap": this.allowWrap
      };
    }
  },
  watch: {
    modelValue: {
      immediate: !0,
      handler() {
        var i;
        this.selection = ((i = this.modelValue) == null ? void 0 : i.length) > 0 ? this.modelValue : [];
      }
    }
  },
  methods: {
    checkDisable(i) {
      return this.disabledList.includes(i);
    },
    showCheckDividers(i) {
      if (this.items.length - 1 === i)
        return !1;
      if (this.selection.length > 0) {
        const t = this.items.indexOf(this.selection[0]);
        if (t === i || t - 1 === i)
          return !1;
      }
      return !0;
    }
  }
};
var tA = function() {
  var t = this, e = t._self._c;
  return e("div", { class: ["acv-segmented-control", t.computedClasses] }, [t._l(t.items, function(n, s) {
    return [e("acv-checkbox", t._g({ key: `button-${s}`, attrs: { "icon-type": "", value: n, label: n, button: !0, "single-selection": !0, disabled: t.checkDisable(n) }, model: { value: t.selection, callback: function(r) {
      t.selection = r;
    }, expression: "selection" } }, t.$listeners)), e("acv-divider", { key: `divider-${s}`, class: { hidden: !t.showCheckDividers(s) }, attrs: { vertical: !0 } })];
  })], 2);
}, eA = [], iA = /* @__PURE__ */ U(
  q3,
  tA,
  eA,
  !1,
  null,
  "64c64931"
);
const Dh = iA.exports, nA = {
  name: "AcvSelectField",
  components: {
    AcvBaseInput: Ce,
    AcvIcon: () => Promise.resolve().then(() => Ie)
  },
  extends: Ce,
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    value: {
      type: [String, Number, Object, Array],
      default: null
    },
    options: {
      type: Array,
      required: !0
    },
    /**
    * If options is an array of objects, use this prop to control which field on each object
    * to use for the option text. Ignored when options is an array of primitives.
    */
    optionDisplayKey: {
      type: String,
      default: "description"
    },
    /**
    * If options is an array of objects, use this prop to control which field on each object
    * to use to disable that option. Ignored when options is an array of primitives.
    */
    optionDisabledKey: {
      type: String,
      default: "disabled"
    },
    label: {
      type: String,
      default: ""
    },
    /**
    * Icon shown prepended or appended to the select field
    */
    icon: {
      type: String,
      default: "arrow_drop_down"
    },
    /**
    * When enabled, prepends the icon to the select field and right aligns the option
    */
    iconBefore: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    internalValue: {
      get() {
        return this.encodeOptionValue(this.value);
      },
      set() {
      }
    },
    inputListeners() {
      return {
        ...this.$listeners,
        change: ({
          target: {
            value: i
          }
        }) => {
          this.$emit("change", this.decodeOptionValue(i));
        }
      };
    },
    labelClasses() {
      return {
        ...this.additionalLabelClasses,
        "has-input": this.value
      };
    },
    inputClasses() {
      return {
        ...this.additionalInputClasses,
        "has-label": this.hasLabel,
        "has-error": this.hasError,
        [`has-${this.iconBefore ? "prepend" : "append"}`]: !0
      };
    }
  },
  methods: {
    encodeOptionValue(i) {
      return btoa(unescape(encodeURIComponent(JSON.stringify(i))));
    },
    decodeOptionValue(i) {
      return JSON.parse(decodeURIComponent(escape(atob(i))));
    },
    optionDisplayText(i) {
      return i[this.optionDisplayKey] || i;
    }
  }
};
var sA = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "acv-select-container" }, [e("acv-base-input", t._b({ staticClass: "acv-select", attrs: { "additional-label-classes": t.labelClasses, role: "listbox" }, scopedSlots: t._u([t.iconBefore ? { key: "prepend", fn: function() {
    return [e("acv-icon", { staticClass: "acv-select__icon acv-select__icon--prepend", attrs: { icon: t.icon } })];
  }, proxy: !0 } : null, { key: "input", fn: function() {
    return [e("select", t._g(t._b({ directives: [{ name: "model", rawName: "v-model", value: t.internalValue, expression: "internalValue" }], staticClass: "body-base", class: { ...t.inputClasses }, on: { change: function(n) {
      var s = Array.prototype.filter.call(n.target.options, function(r) {
        return r.selected;
      }).map(function(r) {
        var a = "_value" in r ? r._value : r.value;
        return a;
      });
      t.internalValue = n.target.multiple ? s : s[0];
    } } }, "select", { ...t.$attrs, ...t.$props }, !1), t.inputListeners), [t._l(t.options, function(n, s) {
      return [e("option", { key: s, attrs: { disabled: n[t.optionDisabledKey] }, domProps: { value: t.encodeOptionValue(n) } }, [t._t(`option-${s}`, function() {
        return [t._v(" " + t._s(t.optionDisplayText(n)) + " ")];
      }, { option: n })], 2)];
    })], 2)];
  }, proxy: !0 }, t.iconBefore ? null : { key: "append", fn: function() {
    return [e("acv-icon", { staticClass: "acv-select__icon acv-select__icon--append", attrs: { icon: t.icon } })];
  }, proxy: !0 }], null, !0) }, "acv-base-input", { ...t.$attrs, ...t.$props }, !1), [t._l(Object.keys(t.$slots), function(n) {
    return t._t(n, null, { slot: n });
  })], 2)], 1);
}, rA = [], aA = /* @__PURE__ */ U(
  nA,
  sA,
  rA,
  !1,
  null,
  "2b08521f"
);
const oA = aA.exports, lA = {
  name: "AcvTextarea",
  components: {
    AcvBaseInput: Ce,
    AcvIcon: () => Promise.resolve().then(() => Ie)
  },
  extends: Ce,
  props: {
    /**
    * Inherited v-model
    */
    value: {
      type: [String, Number],
      default: ""
    },
    /**
     * Icon shown in the top right
     */
    icon: {
      type: String,
      default: "edit"
    },
    /**
     * Error Icon shown when has error is truthy
     */
    errorIcon: {
      type: String,
      default: "error"
    }
  },
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set() {
      }
    },
    inputListeners() {
      return {
        ...this.$listeners,
        input: (i) => {
          this.$emit("input", i.target.value);
        }
      };
    },
    labelClasses() {
      return {
        ...this.additionalLabelClasses,
        "has-input": this.value
      };
    },
    inputClasses() {
      return {
        ...this.additionalInputClasses,
        "has-input": this.hasInput,
        "has-label": this.hasLabel,
        "has-error": this.hasError,
        "has-icon": this.iconToShow
      };
    },
    hasIcon() {
      return this.$slots.icon || this.iconToShow;
    },
    iconToShow() {
      return this.hasError ? this.errorIcon : this.icon;
    }
  },
  methods: {
    focusInput() {
      const i = this.$refs[this.inputId].$el.querySelector("textarea");
      i && i.focus();
    }
  }
};
var cA = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "acv-textarea-container" }, [e("acv-base-input", t._b({ staticClass: "acv-textarea", attrs: { "additional-label-classes": t.labelClasses, role: "textbox" }, scopedSlots: t._u([{ key: "input", fn: function() {
    return [e("textarea", t._g(t._b({ directives: [{ name: "model", rawName: "v-model", value: t.internalValue, expression: "internalValue" }], class: { ...t.inputClasses }, domProps: { value: t.internalValue }, on: { input: function(n) {
      n.target.composing || (t.internalValue = n.target.value);
    } } }, "textarea", { ...t.$attrs, ...t.$props }, !1), t.inputListeners))];
  }, proxy: !0 }, t.hasIcon ? { key: "between", fn: function() {
    return [t._t("icon", function() {
      return [t.iconToShow ? e("acv-icon", { staticClass: "acv-input__icon", attrs: { icon: t.iconToShow } }) : t._e()];
    })];
  }, proxy: !0 } : null], null, !0) }, "acv-base-input", { ...t.$attrs, ...t.$props }, !1), [t._l(Object.keys(t.$slots), function(n) {
    return t._t(n, null, { slot: n });
  })], 2)], 1);
}, uA = [], dA = /* @__PURE__ */ U(
  lA,
  cA,
  uA,
  !1,
  null,
  "c767601f"
);
const hA = dA.exports, fA = {
  name: "AcvTimeField",
  directives: { onClickAway: On },
  components: { AcvListItem: us, AcvList: cs, AcvTextField: Pe },
  extends: Pe,
  mixins: [Th],
  props: {
    label: {
      type: String,
      default: "Time"
    },
    timeSlots: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    highlightedMatch: null,
    scheduleTime: "",
    selectedIndex: -1,
    shouldDisplayList: !1
  }),
  computed: {
    filteredBind() {
      const { timeSlots: i, ...t } = this.$props;
      return t;
    }
  },
  methods: {
    // UI and Interaction Control
    handleClickAway() {
      this.toggleList(!1), this.confirmSelection();
    },
    handleIconClick(i) {
      this.toggleList(i), this.shouldDisplayList && this.focusInput();
    },
    handleInputChange() {
      this.resetSelectedIndexAndMatched(), this.bestMatched = this.getBestMatch(this.timeSlots, this.scheduleTime), this.toggleList(!0), this.bestMatched.isMatched && (this.highlightedMatch = this.bestMatched.matchedTerm, this.selectedIndex = this.timeSlots.indexOf(this.highlightedMatch), this.scrollToHighlighted());
    },
    handleKeyPress(i) {
      this.shouldDisplayList && (i === "up" ? this.selectedIndex = Math.max(this.selectedIndex - 1, 0) : i === "down" && (this.selectedIndex = Math.min(this.selectedIndex + 1, this.timeSlots.length - 1)), this.scheduleTime = this.selectConfirm(), this.scrollToHighlighted());
    },
    handleListItemClick(i) {
      this.selectedIndex = i, this.confirmSelection();
    },
    scrollToHighlighted() {
      this.$nextTick(() => {
        const i = this.$el.querySelector(".selected-time");
        i && i.scrollIntoView({ behavior: "auto", block: "center" });
      });
    },
    toggleList(i) {
      this.shouldDisplayList = i, this.shouldDisplayList && this.scrollToHighlighted();
    },
    confirmSelection() {
      this.scheduleTime = this.selectedIndex !== -1 ? this.selectConfirm() : this.inputConfirm(), this.toggleList(!1), this.$emit("confirm-selection", this.scheduleTime);
    },
    // Data Processing
    validateAndFormatTime(i) {
      const t = i.match(/^(0?[1-9]|1[0-2]):([0-5][0-9])\s?(am|pm)$/i);
      if (t) {
        let [, e, , n] = t;
        const [, , s] = t;
        return e = e.padStart(2, "0"), n = n.toLowerCase(), `${e}:${s} ${n}`;
      }
      return null;
    },
    // Helpers
    focusInput() {
      var i;
      return (i = this.$refs.textField) == null ? void 0 : i.focusInput();
    },
    getTextFieldSlotName(i) {
      return i.includes("time") ? i.split("time-")[1] : void 0;
    },
    inputConfirm() {
      return this.validateAndFormatTime(this.scheduleTime) || this.scheduleTime;
    },
    resetSelectedIndexAndMatched() {
      this.selectedIndex = -1, this.highlightedMatch = null;
    },
    selectConfirm() {
      return this.highlightedMatch = this.timeSlots[this.selectedIndex], this.highlightedMatch;
    }
  }
};
var pA = function() {
  var t = this, e = t._self._c;
  return e("div", { directives: [{ name: "on-clickAway", rawName: "v-on-clickAway:mousedown", value: t.handleClickAway, expression: "handleClickAway", arg: "mousedown" }], staticClass: "time-field-container" }, [e("acv-text-field", t._b({ ref: "textField", staticClass: "time-field", attrs: { "icon-append": "schedule", "show-clear": !1, autocomplete: !1 }, on: { "icon-append-click": function(n) {
    return t.handleIconClick(!t.shouldDisplayList);
  }, focus: function(n) {
    return t.toggleList(!0);
  }, input: t.handleInputChange, keydown: [function(n) {
    return !n.type.indexOf("key") && t._k(n.keyCode, "enter", 13, n.key, "Enter") ? null : (n.preventDefault(), t.confirmSelection.apply(null, arguments));
  }, function(n) {
    return !n.type.indexOf("key") && t._k(n.keyCode, "down", 40, n.key, ["Down", "ArrowDown"]) ? null : (n.preventDefault(), t.handleKeyPress("down"));
  }, function(n) {
    return !n.type.indexOf("key") && t._k(n.keyCode, "up", 38, n.key, ["Up", "ArrowUp"]) ? null : (n.preventDefault(), t.handleKeyPress("up"));
  }, function(n) {
    return !n.type.indexOf("key") && t._k(n.keyCode, "esc", 27, n.key, ["Esc", "Escape"]) ? null : (n.preventDefault(), t.toggleList(!1));
  }] }, scopedSlots: t._u([t._l(Object.keys(t.$slots), function(n) {
    return { key: t.getTextFieldSlotName(n), fn: function() {
      return [t._t(n)];
    }, proxy: !0 };
  })], null, !0), model: { value: t.scheduleTime, callback: function(n) {
    t.scheduleTime = n;
  }, expression: "scheduleTime" } }, "acv-text-field", t.filteredBind, !1)), t.shouldDisplayList ? e("div", { staticClass: "autocomplete-list" }, [e("acv-list", [e("div", { staticClass: "list-container" }, t._l(t.timeSlots, function(n, s) {
    return e("acv-list-item", { key: `filtered-time-${s}`, ref: s === t.selectedIndex ? "highlightedTime" : null, refInFor: !0, staticClass: "acv-autocomplete-item", class: { "selected-time": n === t.highlightedMatch }, attrs: { tabindex: "0" }, on: { click: function(r) {
      return t.handleListItemClick(s);
    } } }, [t._v(" " + t._s(n) + " ")]);
  }), 1)])], 1) : t._e()], 1);
}, gA = [], mA = /* @__PURE__ */ U(
  fA,
  pA,
  gA,
  !1,
  null,
  "2adba272"
);
const vA = mA.exports, AA = {
  name: "AcvToggleButtonGroup",
  mixins: [
    ue
  ],
  props: {
    value: {
      type: Object,
      default: () => {
      }
    },
    options: {
      type: Array,
      required: !0
    },
    title: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    name: {
      type: String,
      default: "toggle-button-checkbox-value"
    }
  }
};
var bA = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "acv-toggle-button-group-container toggle-button-group-container" }, [t.title ? e("h3", { staticClass: "toggle-button-group-title" }, [t._v(" " + t._s(t.title) + " ")]) : t._e(), t._l(t.options, function(n, s) {
    return e("div", { key: n.value, staticClass: "toggle-button-container" }, [e("input", { directives: [{ name: "model", rawName: "v-model", value: t.internalValue, expression: "internalValue" }], attrs: { id: `toggle-button-checkbox-${t.internalId}-${n.value}-${s}`, type: "radio", name: t.name, disabled: t.disabled }, domProps: { value: n, checked: t._q(t.internalValue, n) }, on: { change: function(r) {
      t.internalValue = n;
    } } }), e("label", { class: [n.cssClass, { checked: t.internalValue === n, disabled: t.disabled }], attrs: { for: `toggle-button-checkbox-${t.internalId}-${n.value}-${s}` } }, [t._t("before-label", null, { option: n }), t._v(" " + t._s(n.label) + " "), t._t("after-label", null, { option: n })], 2)]);
  })], 2);
}, yA = [], _A = /* @__PURE__ */ U(
  AA,
  bA,
  yA,
  !1,
  null,
  "12d5c9a9"
);
const xA = _A.exports, CA = {
  name: "AcvToggleSwitch",
  components: {
    AcvBaseInput: Ce
  },
  extends: Ce,
  mixins: [
    yi
  ],
  model: {
    prop: "modelValue",
    event: "change"
  },
  props: {
    /**
    * The inherited v-model value
    */
    modelValue: {
      type: Boolean,
      default: !1
    },
    /**
    * Hides the checkmark when checked
    */
    hideCheck: {
      type: Boolean,
      default: !1
    },
    /**
    * Gives the control indicator more transparency
    */
    transparentToggle: {
      type: Boolean,
      default: !1
    },
    /**
    * Changes the styling to round
    */
    round: {
      type: Boolean,
      default: !1
    },
    /**
    * Shows On / Off in the control container itself
    */
    innerStates: {
      type: Boolean,
      default: !1
    },
    /**
    * Emits change on the v-model when the control container is clicked
    */
    changeViaClick: {
      type: Boolean,
      default: !1
    },
    /**
    * Allows the clickable label area to be full width
    */
    fullWidth: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    computedControlContainerClasses() {
      return {
        "acv-toggle-switch__control-container--round": this.round,
        "acv-toggle-switch__control-container--inner-states": this.innerStates
      };
    },
    computedControlClasses() {
      return {
        "acv-toggle-switch__control-container__control--round": this.round,
        "acv-toggle-switch__control-container__control--hide-check": this.hideCheck,
        "acv-toggle-switch__control-container__control--transparent": this.transparentToggle
      };
    },
    isChecked() {
      return this.modelValue;
    },
    inputListeners() {
      return {
        ...this.$listeners,
        change: () => {
          this.$emit("change", !this.modelValue), this.$refs[`base-input-${this.inputId}`].handleBlur();
        }
      };
    }
  },
  methods: {
    toggleClick() {
      this.changeViaClick && !this.disabled && this.inputListeners.change();
    }
  }
};
var SA = function() {
  var t = this, e = t._self._c;
  return e("acv-base-input", t._g(t._b({ ref: `base-input-${t.inputId}`, class: { "tw-w-full": t.fullWidth }, attrs: { type: "checkbox", role: "checkbox", "additional-label-container-classes": {
    "acv-toggle-switch": !0
  }, checked: t.isChecked }, scopedSlots: t._u([{ key: "prepend", fn: function() {
    return [t._t("prepend")];
  }, proxy: !0 }, { key: "between", fn: function() {
    return [e("div", { staticClass: "acv-toggle-switch__control-container", class: {
      ...t.backgroundClasses,
      ...t.computedControlContainerClasses
    }, on: { click: t.toggleClick, keypress: function(n) {
      return !n.type.indexOf("key") && t._k(n.keyCode, "space", 32, n.key, [" ", "Spacebar"]) ? null : t.toggleClick.apply(null, arguments);
    } } }, [e("div", { staticClass: "acv-toggle-switch__control-container__control", class: { ...t.computedControlClasses } })]), t._t("between")];
  }, proxy: !0 }, { key: "label", fn: function() {
    return [t._t("label")];
  }, proxy: !0 }, { key: "append", fn: function() {
    return [t._t("append")];
  }, proxy: !0 }], null, !0) }, "acv-base-input", { ...t.$attrs, ...t.$props }, !1), t.inputListeners));
}, wA = [], kA = /* @__PURE__ */ U(
  CA,
  SA,
  wA,
  !1,
  null,
  "cbf093dd"
);
const Ph = kA.exports, OA = {
  name: "AcvZipCodeInput",
  components: {
    AcvTextField: Pe
  },
  extends: Pe,
  props: {
    label: {
      type: String,
      default: "Zip Code:"
    },
    mask: {
      type: String,
      default: "#####"
    },
    /**
    * Inputmode for the input field when on mobile devices
    */
    inputmode: {
      type: String,
      default: "numeric",
      validator(i) {
        return wt(i, [
          "numeric"
        ]);
      }
    }
  }
}, MA = null, TA = null;
var DA = /* @__PURE__ */ U(
  OA,
  MA,
  TA,
  !1,
  null,
  null
);
const PA = DA.exports, LA = {
  name: "AcvIntersectionObserver",
  props: {
    id: {
      type: String,
      default: ""
    },
    root: {
      type: Object,
      default: null
    },
    rootMargin: {
      type: String,
      default: "0px"
    },
    threshold: {
      type: [Number, Array],
      default: 0.1
    }
  },
  data() {
    return {
      observer: null
    };
  },
  computed: {
    elementId() {
      return this.id || `acv-intersection-observer-${this._uid}`;
    },
    elementSelector() {
      return `#${this.elementId}`;
    },
    intersectionObserverOptions() {
      return {
        root: this.root,
        rootMargin: this.rootMargin,
        threshold: this.threshold || 0
      };
    }
  },
  watch: {
    id() {
      this.$nextTick(() => {
        this.initIntersectionObserver();
      });
    },
    intersectionObserverOptions() {
      this.$nextTick(() => {
        this.initIntersectionObserver();
      });
    }
  },
  mounted() {
    this.initIntersectionObserver();
  },
  destroyed() {
    this.disconnectObserver();
  },
  methods: {
    intersecting([i]) {
      this.$emit("intersection", i.isIntersecting);
    },
    disconnectObserver() {
      this.observer && this.observer.disconnect();
    },
    initIntersectionObserver() {
      this.disconnectObserver(), this.observer = new IntersectionObserver(
        this.intersecting,
        this.intersectionObserverOptions
      );
      const i = document.querySelector(this.elementSelector);
      i ? (this.observer.observe(i), this.$emit("intersection-observer-initialized", i)) : (this.$emit("invalid-element-selector", {
        elementSelector: this.elementSelector,
        id: this.id,
        root: this.root,
        rootMargin: this.rootMargin,
        threshold: this.threshold
      }), this.disconnectObserver());
    }
  }
};
var IA = function() {
  var t = this, e = t._self._c;
  return e("span", { attrs: { id: t.elementId } }, [t._t("default")], 2);
}, EA = [], $A = /* @__PURE__ */ U(
  LA,
  IA,
  EA,
  !1,
  null,
  null
);
const Lh = $A.exports;
var Kt = function() {
  return Kt = Object.assign || function(t) {
    for (var e, n = 1, s = arguments.length; n < s; n++) {
      e = arguments[n];
      for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
    }
    return t;
  }, Kt.apply(this, arguments);
};
typeof window < "u" && (window.NodeList && !NodeList.prototype.forEach && (NodeList.prototype.forEach = Array.prototype.forEach), typeof window.CustomEvent != "function" && (window.CustomEvent = function(t, e) {
  e = e || { bubbles: !1, cancelable: !1, detail: null };
  var n = document.createEvent("CustomEvent");
  return n.initCustomEvent(t, e.bubbles, e.cancelable, e.detail), n;
}));
function Ih(i, t) {
  for (var e = i.length; e--; )
    if (i[e].pointerId === t.pointerId)
      return e;
  return -1;
}
function zo(i, t) {
  var e;
  if (t.touches) {
    e = 0;
    for (var n = 0, s = t.touches; n < s.length; n++) {
      var r = s[n];
      r.pointerId = e++, zo(i, r);
    }
    return;
  }
  e = Ih(i, t), e > -1 && i.splice(e, 1), i.push(t);
}
function BA(i, t) {
  if (t.touches) {
    for (; i.length; )
      i.pop();
    return;
  }
  var e = Ih(i, t);
  e > -1 && i.splice(e, 1);
}
function $c(i) {
  i = i.slice(0);
  for (var t = i.pop(), e; e = i.pop(); )
    t = {
      clientX: (e.clientX - t.clientX) / 2 + t.clientX,
      clientY: (e.clientY - t.clientY) / 2 + t.clientY
    };
  return t;
}
function Qa(i) {
  if (i.length < 2)
    return 0;
  var t = i[0], e = i[1];
  return Math.sqrt(Math.pow(Math.abs(e.clientX - t.clientX), 2) + Math.pow(Math.abs(e.clientY - t.clientY), 2));
}
var Rs = {
  down: "mousedown",
  move: "mousemove",
  up: "mouseup mouseleave"
};
typeof window < "u" && (typeof window.PointerEvent == "function" ? Rs = {
  down: "pointerdown",
  move: "pointermove",
  up: "pointerup pointerleave pointercancel"
} : typeof window.TouchEvent == "function" && (Rs = {
  down: "touchstart",
  move: "touchmove",
  up: "touchend touchcancel"
}));
function Ja(i, t, e, n) {
  Rs[i].split(" ").forEach(function(s) {
    t.addEventListener(s, e, n);
  });
}
function qa(i, t, e) {
  Rs[i].split(" ").forEach(function(n) {
    t.removeEventListener(n, e);
  });
}
var RA = typeof document < "u" && !!document.documentMode, to;
function FA() {
  return to || (to = document.createElement("div").style);
}
var Bc = ["webkit", "moz", "ms"], mr = {};
function Ml(i) {
  if (mr[i])
    return mr[i];
  var t = FA();
  if (i in t)
    return mr[i] = i;
  for (var e = i[0].toUpperCase() + i.slice(1), n = Bc.length; n--; ) {
    var s = "".concat(Bc[n]).concat(e);
    if (s in t)
      return mr[i] = s;
  }
}
function vr(i, t) {
  return parseFloat(t[Ml(i)]) || 0;
}
function Ar(i, t, e) {
  e === void 0 && (e = window.getComputedStyle(i));
  var n = t === "border" ? "Width" : "";
  return {
    left: vr("".concat(t, "Left").concat(n), e),
    right: vr("".concat(t, "Right").concat(n), e),
    top: vr("".concat(t, "Top").concat(n), e),
    bottom: vr("".concat(t, "Bottom").concat(n), e)
  };
}
function Vn(i, t, e) {
  i.style[Ml(t)] = e;
}
function NA(i, t) {
  var e = Ml("transform");
  Vn(i, "transition", "".concat(e, " ").concat(t.duration, "ms ").concat(t.easing));
}
function HA(i, t, e) {
  var n = t.x, s = t.y, r = t.scale, a = t.isSVG;
  if (Vn(i, "transform", "scale(".concat(r, ") translate(").concat(n, "px, ").concat(s, "px)")), a && RA) {
    var o = window.getComputedStyle(i).getPropertyValue("transform");
    i.setAttribute("transform", o);
  }
}
function eo(i) {
  var t = i.parentNode, e = window.getComputedStyle(i), n = window.getComputedStyle(t), s = i.getBoundingClientRect(), r = t.getBoundingClientRect();
  return {
    elem: {
      style: e,
      width: s.width,
      height: s.height,
      top: s.top,
      bottom: s.bottom,
      left: s.left,
      right: s.right,
      margin: Ar(i, "margin", e),
      border: Ar(i, "border", e)
    },
    parent: {
      style: n,
      width: r.width,
      height: r.height,
      top: r.top,
      bottom: r.bottom,
      left: r.left,
      right: r.right,
      padding: Ar(t, "padding", n),
      border: Ar(t, "border", n)
    }
  };
}
function VA(i) {
  var t = i.ownerDocument, e = i.parentNode;
  return t && e && t.nodeType === 9 && e.nodeType === 1 && t.documentElement.contains(e);
}
function zA(i) {
  return (i.getAttribute("class") || "").trim();
}
function jA(i, t) {
  return i.nodeType === 1 && " ".concat(zA(i), " ").indexOf(" ".concat(t, " ")) > -1;
}
function WA(i, t) {
  for (var e = i; e != null; e = e.parentNode)
    if (jA(e, t.excludeClass) || t.exclude.indexOf(e) > -1)
      return !0;
  return !1;
}
var YA = /^http:[\w\.\/]+svg$/;
function UA(i) {
  return YA.test(i.namespaceURI) && i.nodeName.toLowerCase() !== "svg";
}
function ZA(i) {
  var t = {};
  for (var e in i)
    i.hasOwnProperty(e) && (t[e] = i[e]);
  return t;
}
var Eh = {
  animate: !1,
  canvas: !1,
  cursor: "move",
  disablePan: !1,
  disableZoom: !1,
  disableXAxis: !1,
  disableYAxis: !1,
  duration: 200,
  easing: "ease-in-out",
  exclude: [],
  excludeClass: "panzoom-exclude",
  handleStartEvent: function(i) {
    i.preventDefault(), i.stopPropagation();
  },
  maxScale: 4,
  minScale: 0.125,
  overflow: "hidden",
  panOnlyWhenZoomed: !1,
  pinchAndPan: !1,
  relative: !1,
  setTransform: HA,
  startX: 0,
  startY: 0,
  startScale: 1,
  step: 0.3,
  touchAction: "none"
};
function Tl(i, t) {
  if (!i)
    throw new Error("Panzoom requires an element as an argument");
  if (i.nodeType !== 1)
    throw new Error("Panzoom requires an element with a nodeType of 1");
  if (!VA(i))
    throw new Error("Panzoom should be called on elements that have been attached to the DOM");
  t = Kt(Kt({}, Eh), t);
  var e = UA(i), n = i.parentNode;
  n.style.overflow = t.overflow, n.style.userSelect = "none", n.style.touchAction = t.touchAction, (t.canvas ? n : i).style.cursor = t.cursor, i.style.userSelect = "none", i.style.touchAction = t.touchAction, Vn(i, "transformOrigin", typeof t.origin == "string" ? t.origin : e ? "0 0" : "50% 50%");
  function s() {
    n.style.overflow = "", n.style.userSelect = "", n.style.touchAction = "", n.style.cursor = "", i.style.cursor = "", i.style.userSelect = "", i.style.touchAction = "", Vn(i, "transformOrigin", "");
  }
  function r(N) {
    N === void 0 && (N = {});
    for (var z in N)
      N.hasOwnProperty(z) && (t[z] = N[z]);
    (N.hasOwnProperty("cursor") || N.hasOwnProperty("canvas")) && (n.style.cursor = i.style.cursor = "", (t.canvas ? n : i).style.cursor = t.cursor), N.hasOwnProperty("overflow") && (n.style.overflow = N.overflow), N.hasOwnProperty("touchAction") && (n.style.touchAction = N.touchAction, i.style.touchAction = N.touchAction);
  }
  var a = 0, o = 0, l = 1, c = !1;
  g(t.startScale, { animate: !1, force: !0 }), setTimeout(function() {
    p(t.startX, t.startY, { animate: !1, force: !0 });
  });
  function u(N, z, E) {
    if (!E.silent) {
      var H = new CustomEvent(N, { detail: z });
      i.dispatchEvent(H);
    }
  }
  function d(N, z, E) {
    var H = { x: a, y: o, scale: l, isSVG: e, originalEvent: E };
    return requestAnimationFrame(function() {
      typeof z.animate == "boolean" && (z.animate ? NA(i, z) : Vn(i, "transition", "none")), z.setTransform(i, H, z), u(N, H, z), u("panzoomchange", H, z);
    }), H;
  }
  function h(N, z, E, H) {
    var y = Kt(Kt({}, t), H), $ = { x: a, y: o, opts: y };
    if (!y.force && (y.disablePan || y.panOnlyWhenZoomed && l === y.startScale))
      return $;
    if (N = parseFloat(N), z = parseFloat(z), y.disableXAxis || ($.x = (y.relative ? a : 0) + N), y.disableYAxis || ($.y = (y.relative ? o : 0) + z), y.contain) {
      var D = eo(i), Z = D.elem.width / l, J = D.elem.height / l, lt = Z * E, Q = J * E, ot = (lt - Z) / 2, st = (Q - J) / 2;
      if (y.contain === "inside") {
        var ft = (-D.elem.margin.left - D.parent.padding.left + ot) / E, Rt = (D.parent.width - lt - D.parent.padding.left - D.elem.margin.left - D.parent.border.left - D.parent.border.right + ot) / E;
        $.x = Math.max(Math.min($.x, Rt), ft);
        var pe = (-D.elem.margin.top - D.parent.padding.top + st) / E, It = (D.parent.height - Q - D.parent.padding.top - D.elem.margin.top - D.parent.border.top - D.parent.border.bottom + st) / E;
        $.y = Math.max(Math.min($.y, It), pe);
      } else if (y.contain === "outside") {
        var ft = (-(lt - D.parent.width) - D.parent.padding.left - D.parent.border.left - D.parent.border.right + ot) / E, Rt = (ot - D.parent.padding.left) / E;
        $.x = Math.max(Math.min($.x, Rt), ft);
        var pe = (-(Q - D.parent.height) - D.parent.padding.top - D.parent.border.top - D.parent.border.bottom + st) / E, It = (st - D.parent.padding.top) / E;
        $.y = Math.max(Math.min($.y, It), pe);
      }
    }
    return y.roundPixels && ($.x = Math.round($.x), $.y = Math.round($.y)), $;
  }
  function f(N, z) {
    var E = Kt(Kt({}, t), z), H = { scale: l, opts: E };
    if (!E.force && E.disableZoom)
      return H;
    var y = t.minScale, $ = t.maxScale;
    if (E.contain) {
      var D = eo(i), Z = D.elem.width / l, J = D.elem.height / l;
      if (Z > 1 && J > 1) {
        var lt = D.parent.width - D.parent.border.left - D.parent.border.right, Q = D.parent.height - D.parent.border.top - D.parent.border.bottom, ot = lt / Z, st = Q / J;
        t.contain === "inside" ? $ = Math.min($, ot, st) : t.contain === "outside" && (y = Math.max(y, ot, st));
      }
    }
    return H.scale = Math.min(Math.max(N, y), $), H;
  }
  function p(N, z, E, H) {
    var y = h(N, z, l, E);
    return a !== y.x || o !== y.y ? (a = y.x, o = y.y, d("panzoompan", y.opts, H)) : { x: a, y: o, scale: l, isSVG: e, originalEvent: H };
  }
  function g(N, z, E) {
    var H = f(N, z), y = H.opts;
    if (!(!y.force && y.disableZoom)) {
      N = H.scale;
      var $ = a, D = o;
      if (y.focal) {
        var Z = y.focal;
        $ = (Z.x / N - Z.x / l + a * N) / N, D = (Z.y / N - Z.y / l + o * N) / N;
      }
      var J = h($, D, N, { relative: !1, force: !0 });
      return a = J.x, o = J.y, l = N, d("panzoomzoom", y, E);
    }
  }
  function m(N, z) {
    var E = Kt(Kt(Kt({}, t), { animate: !0 }), z);
    return g(l * Math.exp((N ? 1 : -1) * E.step), E);
  }
  function v(N) {
    return m(!0, N);
  }
  function b(N) {
    return m(!1, N);
  }
  function _(N, z, E, H) {
    var y = eo(i), $ = {
      width: y.parent.width - y.parent.padding.left - y.parent.padding.right - y.parent.border.left - y.parent.border.right,
      height: y.parent.height - y.parent.padding.top - y.parent.padding.bottom - y.parent.border.top - y.parent.border.bottom
    }, D = z.clientX - y.parent.left - y.parent.padding.left - y.parent.border.left - y.elem.margin.left, Z = z.clientY - y.parent.top - y.parent.padding.top - y.parent.border.top - y.elem.margin.top;
    e || (D -= y.elem.width / l / 2, Z -= y.elem.height / l / 2);
    var J = {
      x: D / $.width * ($.width * N),
      y: Z / $.height * ($.height * N)
    };
    return g(N, Kt(Kt({}, E), { animate: !1, focal: J }), H);
  }
  function S(N, z) {
    N.preventDefault();
    var E = Kt(Kt(Kt({}, t), z), { animate: !1 }), H = N.deltaY === 0 && N.deltaX ? N.deltaX : N.deltaY, y = H < 0 ? 1 : -1, $ = f(l * Math.exp(y * E.step / 3), E).scale;
    return _($, N, E, N);
  }
  function C(N) {
    var z = Kt(Kt(Kt({}, t), { animate: !0, force: !0 }), N);
    l = f(z.startScale, z).scale;
    var E = h(z.startX, z.startY, l, z);
    return a = E.x, o = E.y, d("panzoomreset", z);
  }
  var O, k, P, x, R, B, L = [];
  function Y(N) {
    if (!WA(N.target, t)) {
      zo(L, N), c = !0, t.handleStartEvent(N), O = a, k = o, u("panzoomstart", { x: a, y: o, scale: l, isSVG: e, originalEvent: N }, t);
      var z = $c(L);
      P = z.clientX, x = z.clientY, R = l, B = Qa(L);
    }
  }
  function j(N) {
    if (!(!c || O === void 0 || k === void 0 || P === void 0 || x === void 0)) {
      zo(L, N);
      var z = $c(L), E = L.length > 1, H = l;
      if (E) {
        B === 0 && (B = Qa(L));
        var y = Qa(L) - B;
        H = f(y * t.step / 80 + R).scale, _(H, z, { animate: !1 }, N);
      }
      (!E || t.pinchAndPan) && p(O + (z.clientX - P) / H, k + (z.clientY - x) / H, {
        animate: !1
      }, N);
    }
  }
  function w(N) {
    L.length === 1 && u("panzoomend", { x: a, y: o, scale: l, isSVG: e, originalEvent: N }, t), BA(L, N), c && (c = !1, O = k = P = x = void 0);
  }
  var I = !1;
  function T() {
    I || (I = !0, Ja("down", t.canvas ? n : i, Y), Ja("move", document, j, { passive: !0 }), Ja("up", document, w, { passive: !0 }));
  }
  function V() {
    I = !1, qa("down", t.canvas ? n : i, Y), qa("move", document, j), qa("up", document, w);
  }
  return t.noBind || T(), {
    bind: T,
    destroy: V,
    eventNames: Rs,
    getPan: function() {
      return { x: a, y: o };
    },
    getScale: function() {
      return l;
    },
    getOptions: function() {
      return ZA(t);
    },
    handleDown: Y,
    handleMove: j,
    handleUp: w,
    pan: p,
    reset: C,
    resetStyle: s,
    setOptions: r,
    setStyle: function(N, z) {
      return Vn(i, N, z);
    },
    zoom: g,
    zoomIn: v,
    zoomOut: b,
    zoomToPoint: _,
    zoomWithWheel: S
  };
}
Tl.defaultOptions = Eh;
const $n = {
  addEventListeners(i, t, e) {
    for (let n = 0, s = t.length; n < s; n += 1)
      i.addEventListener(t[n], e);
  },
  removeEventListeners(i, t, e) {
    for (let n = 0, s = t.length; n < s; n += 1)
      i.removeEventListener(t[n], e);
  }
}, Lt = () => typeof window < "u" && window ? window.matchMedia("(pointer: coarse)").matches : !1, Rc = ["mousedown", "touchstart"], Fc = ["mousemove", "touchmove"], Nc = ["mouseup", "mouseleave", "touchend"];
let br;
const $h = {
  inserted(i, t) {
    if (!document) return;
    const e = i;
    function n(a) {
      var c, u, d, h;
      Lt() || a.preventDefault();
      const o = Lt() ? (u = (c = a.touches) == null ? void 0 : c[0]) == null ? void 0 : u.clientX : a.clientX, l = Lt() ? (h = (d = a.touches) == null ? void 0 : d[0]) == null ? void 0 : h.clientY : a.clientY;
      e.lastCoords = {
        x: o,
        y: l
      }, e.firstCoords = {
        x: o,
        y: l
      }, t.value({
        el: e,
        evt: a,
        first: !0,
        clientX: o,
        clientY: l
      }), br = e;
    }
    function s(a) {
      var o, l, c, u;
      if (e === br && (Lt() || a.preventDefault(), e.lastCoords)) {
        const d = Lt() ? (l = (o = a.touches) == null ? void 0 : o[0]) == null ? void 0 : l.clientX : a.clientX, h = Lt() ? (u = (c = a.touches) == null ? void 0 : c[0]) == null ? void 0 : u.clientY : a.clientY, f = d - e.lastCoords.x, p = h - e.lastCoords.y, g = d - e.firstCoords.x, m = h - e.firstCoords.y, { clientX: v } = a, { clientY: b } = a;
        t.value({
          el: e,
          evt: a,
          deltaX: f,
          deltaY: p,
          offsetX: g,
          offsetY: m,
          clientX: v,
          clientY: b
        }), e.lastCoords = {
          x: d,
          y: h
        };
      }
    }
    function r(a) {
      var c, u, d, h;
      if (e !== br) return;
      Lt() || a.preventDefault();
      const o = Lt() ? (u = (c = a.changedTouches) == null ? void 0 : c[0]) == null ? void 0 : u.clientX : a.clientX, l = Lt() ? (h = (d = a.changedTouches) == null ? void 0 : d[0]) == null ? void 0 : h.clientY : a.clientY;
      e.lastCoords = null, t.value({
        el: e,
        evt: a,
        last: !0,
        clientX: o,
        clientY: l
      }), br = null;
    }
    $n.addEventListeners(
      e,
      Rc,
      n
    ), $n.addEventListeners(
      document.documentElement,
      Fc,
      s
    ), $n.addEventListeners(
      document.documentElement,
      Nc,
      r
    );
  },
  unbind(i) {
    $n.removeEventListeners(i, Rc), $n.removeEventListeners(document.documentElement, Fc), $n.removeEventListeners(document.documentElement, Nc);
  }
};
/*!
 * perfect-scrollbar v1.5.6
 * Copyright 2024 Hyunje Jun, MDBootstrap and Contributors
 * Licensed under MIT
 */
function fi(i) {
  return getComputedStyle(i);
}
function ve(i, t) {
  for (var e in t) {
    var n = t[e];
    typeof n == "number" && (n = n + "px"), i.style[e] = n;
  }
  return i;
}
function yr(i) {
  var t = document.createElement("div");
  return t.className = i, t;
}
var Hc = typeof Element < "u" && (Element.prototype.matches || Element.prototype.webkitMatchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector);
function Vi(i, t) {
  if (!Hc)
    throw new Error("No element matching method supported");
  return Hc.call(i, t);
}
function zn(i) {
  i.remove ? i.remove() : i.parentNode && i.parentNode.removeChild(i);
}
function Vc(i, t) {
  return Array.prototype.filter.call(
    i.children,
    function(e) {
      return Vi(e, t);
    }
  );
}
var Zt = {
  main: "ps",
  rtl: "ps__rtl",
  element: {
    thumb: function(i) {
      return "ps__thumb-" + i;
    },
    rail: function(i) {
      return "ps__rail-" + i;
    },
    consuming: "ps__child--consume"
  },
  state: {
    focus: "ps--focus",
    clicking: "ps--clicking",
    active: function(i) {
      return "ps--active-" + i;
    },
    scrolling: function(i) {
      return "ps--scrolling-" + i;
    }
  }
}, Bh = { x: null, y: null };
function Rh(i, t) {
  var e = i.element.classList, n = Zt.state.scrolling(t);
  e.contains(n) ? clearTimeout(Bh[t]) : e.add(n);
}
function Fh(i, t) {
  Bh[t] = setTimeout(
    function() {
      return i.isAlive && i.element.classList.remove(Zt.state.scrolling(t));
    },
    i.settings.scrollingThreshold
  );
}
function GA(i, t) {
  Rh(i, t), Fh(i, t);
}
var er = function(t) {
  this.element = t, this.handlers = {};
}, Nh = { isEmpty: { configurable: !0 } };
er.prototype.bind = function(t, e) {
  typeof this.handlers[t] > "u" && (this.handlers[t] = []), this.handlers[t].push(e), this.element.addEventListener(t, e, !1);
};
er.prototype.unbind = function(t, e) {
  var n = this;
  this.handlers[t] = this.handlers[t].filter(function(s) {
    return e && s !== e ? !0 : (n.element.removeEventListener(t, s, !1), !1);
  });
};
er.prototype.unbindAll = function() {
  for (var t in this.handlers)
    this.unbind(t);
};
Nh.isEmpty.get = function() {
  var i = this;
  return Object.keys(this.handlers).every(
    function(t) {
      return i.handlers[t].length === 0;
    }
  );
};
Object.defineProperties(er.prototype, Nh);
var ds = function() {
  this.eventElements = [];
};
ds.prototype.eventElement = function(t) {
  var e = this.eventElements.filter(function(n) {
    return n.element === t;
  })[0];
  return e || (e = new er(t), this.eventElements.push(e)), e;
};
ds.prototype.bind = function(t, e, n) {
  this.eventElement(t).bind(e, n);
};
ds.prototype.unbind = function(t, e, n) {
  var s = this.eventElement(t);
  s.unbind(e, n), s.isEmpty && this.eventElements.splice(this.eventElements.indexOf(s), 1);
};
ds.prototype.unbindAll = function() {
  this.eventElements.forEach(function(t) {
    return t.unbindAll();
  }), this.eventElements = [];
};
ds.prototype.once = function(t, e, n) {
  var s = this.eventElement(t), r = function(a) {
    s.unbind(e, r), n(a);
  };
  s.bind(e, r);
};
function _r(i) {
  if (typeof window.CustomEvent == "function")
    return new CustomEvent(i);
  var t = document.createEvent("CustomEvent");
  return t.initCustomEvent(i, !1, !1, void 0), t;
}
function ta(i, t, e, n, s) {
  n === void 0 && (n = !0), s === void 0 && (s = !1);
  var r;
  if (t === "top")
    r = ["contentHeight", "containerHeight", "scrollTop", "y", "up", "down"];
  else if (t === "left")
    r = ["contentWidth", "containerWidth", "scrollLeft", "x", "left", "right"];
  else
    throw new Error("A proper axis should be provided");
  KA(i, e, r, n, s);
}
function KA(i, t, e, n, s) {
  var r = e[0], a = e[1], o = e[2], l = e[3], c = e[4], u = e[5];
  n === void 0 && (n = !0), s === void 0 && (s = !1);
  var d = i.element;
  i.reach[l] = null, d[o] < 1 && (i.reach[l] = "start"), d[o] > i[r] - i[a] - 1 && (i.reach[l] = "end"), t && (d.dispatchEvent(_r("ps-scroll-" + l)), t < 0 ? d.dispatchEvent(_r("ps-scroll-" + c)) : t > 0 && d.dispatchEvent(_r("ps-scroll-" + u)), n && GA(i, l)), i.reach[l] && (t || s) && d.dispatchEvent(_r("ps-" + l + "-reach-" + i.reach[l]));
}
function Ft(i) {
  return parseInt(i, 10) || 0;
}
function XA(i) {
  return Vi(i, "input,[contenteditable]") || Vi(i, "select,[contenteditable]") || Vi(i, "textarea,[contenteditable]") || Vi(i, "button,[contenteditable]");
}
function QA(i) {
  var t = fi(i);
  return Ft(t.width) + Ft(t.paddingLeft) + Ft(t.paddingRight) + Ft(t.borderLeftWidth) + Ft(t.borderRightWidth);
}
var Hn = {
  isWebKit: typeof document < "u" && "WebkitAppearance" in document.documentElement.style,
  supportsTouch: typeof window < "u" && ("ontouchstart" in window || "maxTouchPoints" in window.navigator && window.navigator.maxTouchPoints > 0 || window.DocumentTouch && document instanceof window.DocumentTouch),
  supportsIePointer: typeof navigator < "u" && navigator.msMaxTouchPoints,
  isChrome: typeof navigator < "u" && /Chrome/i.test(navigator && navigator.userAgent)
};
function Ii(i) {
  var t = i.element, e = Math.floor(t.scrollTop), n = t.getBoundingClientRect();
  i.containerWidth = Math.floor(n.width), i.containerHeight = Math.floor(n.height), i.contentWidth = t.scrollWidth, i.contentHeight = t.scrollHeight, t.contains(i.scrollbarXRail) || (Vc(t, Zt.element.rail("x")).forEach(function(s) {
    return zn(s);
  }), t.appendChild(i.scrollbarXRail)), t.contains(i.scrollbarYRail) || (Vc(t, Zt.element.rail("y")).forEach(function(s) {
    return zn(s);
  }), t.appendChild(i.scrollbarYRail)), !i.settings.suppressScrollX && i.containerWidth + i.settings.scrollXMarginOffset < i.contentWidth ? (i.scrollbarXActive = !0, i.railXWidth = i.containerWidth - i.railXMarginWidth, i.railXRatio = i.containerWidth / i.railXWidth, i.scrollbarXWidth = zc(i, Ft(i.railXWidth * i.containerWidth / i.contentWidth)), i.scrollbarXLeft = Ft(
    (i.negativeScrollAdjustment + t.scrollLeft) * (i.railXWidth - i.scrollbarXWidth) / (i.contentWidth - i.containerWidth)
  )) : i.scrollbarXActive = !1, !i.settings.suppressScrollY && i.containerHeight + i.settings.scrollYMarginOffset < i.contentHeight ? (i.scrollbarYActive = !0, i.railYHeight = i.containerHeight - i.railYMarginHeight, i.railYRatio = i.containerHeight / i.railYHeight, i.scrollbarYHeight = zc(
    i,
    Ft(i.railYHeight * i.containerHeight / i.contentHeight)
  ), i.scrollbarYTop = Ft(
    e * (i.railYHeight - i.scrollbarYHeight) / (i.contentHeight - i.containerHeight)
  )) : i.scrollbarYActive = !1, i.scrollbarXLeft >= i.railXWidth - i.scrollbarXWidth && (i.scrollbarXLeft = i.railXWidth - i.scrollbarXWidth), i.scrollbarYTop >= i.railYHeight - i.scrollbarYHeight && (i.scrollbarYTop = i.railYHeight - i.scrollbarYHeight), JA(t, i), i.scrollbarXActive ? t.classList.add(Zt.state.active("x")) : (t.classList.remove(Zt.state.active("x")), i.scrollbarXWidth = 0, i.scrollbarXLeft = 0, t.scrollLeft = i.isRtl === !0 ? i.contentWidth : 0), i.scrollbarYActive ? t.classList.add(Zt.state.active("y")) : (t.classList.remove(Zt.state.active("y")), i.scrollbarYHeight = 0, i.scrollbarYTop = 0, t.scrollTop = 0);
}
function zc(i, t) {
  return i.settings.minScrollbarLength && (t = Math.max(t, i.settings.minScrollbarLength)), i.settings.maxScrollbarLength && (t = Math.min(t, i.settings.maxScrollbarLength)), t;
}
function JA(i, t) {
  var e = { width: t.railXWidth }, n = Math.floor(i.scrollTop);
  t.isRtl ? e.left = t.negativeScrollAdjustment + i.scrollLeft + t.containerWidth - t.contentWidth : e.left = i.scrollLeft, t.isScrollbarXUsingBottom ? e.bottom = t.scrollbarXBottom - n : e.top = t.scrollbarXTop + n, ve(t.scrollbarXRail, e);
  var s = { top: n, height: t.railYHeight };
  t.isScrollbarYUsingRight ? t.isRtl ? s.right = t.contentWidth - (t.negativeScrollAdjustment + i.scrollLeft) - t.scrollbarYRight - t.scrollbarYOuterWidth - 9 : s.right = t.scrollbarYRight - i.scrollLeft : t.isRtl ? s.left = t.negativeScrollAdjustment + i.scrollLeft + t.containerWidth * 2 - t.contentWidth - t.scrollbarYLeft - t.scrollbarYOuterWidth : s.left = t.scrollbarYLeft + i.scrollLeft, ve(t.scrollbarYRail, s), ve(t.scrollbarX, {
    left: t.scrollbarXLeft,
    width: t.scrollbarXWidth - t.railBorderXWidth
  }), ve(t.scrollbarY, {
    top: t.scrollbarYTop,
    height: t.scrollbarYHeight - t.railBorderYWidth
  });
}
function qA(i) {
  i.event.bind(i.scrollbarY, "mousedown", function(t) {
    return t.stopPropagation();
  }), i.event.bind(i.scrollbarYRail, "mousedown", function(t) {
    var e = t.pageY - window.pageYOffset - i.scrollbarYRail.getBoundingClientRect().top, n = e > i.scrollbarYTop ? 1 : -1;
    i.element.scrollTop += n * i.containerHeight, Ii(i), t.stopPropagation();
  }), i.event.bind(i.scrollbarX, "mousedown", function(t) {
    return t.stopPropagation();
  }), i.event.bind(i.scrollbarXRail, "mousedown", function(t) {
    var e = t.pageX - window.pageXOffset - i.scrollbarXRail.getBoundingClientRect().left, n = e > i.scrollbarXLeft ? 1 : -1;
    i.element.scrollLeft += n * i.containerWidth, Ii(i), t.stopPropagation();
  });
}
var xr = null;
function tb(i) {
  jc(i, [
    "containerHeight",
    "contentHeight",
    "pageY",
    "railYHeight",
    "scrollbarY",
    "scrollbarYHeight",
    "scrollTop",
    "y",
    "scrollbarYRail"
  ]), jc(i, [
    "containerWidth",
    "contentWidth",
    "pageX",
    "railXWidth",
    "scrollbarX",
    "scrollbarXWidth",
    "scrollLeft",
    "x",
    "scrollbarXRail"
  ]);
}
function jc(i, t) {
  var e = t[0], n = t[1], s = t[2], r = t[3], a = t[4], o = t[5], l = t[6], c = t[7], u = t[8], d = i.element, h = null, f = null, p = null;
  function g(b) {
    b.touches && b.touches[0] && (b[s] = b.touches[0]["page" + c.toUpperCase()]), xr === a && (d[l] = h + p * (b[s] - f), Rh(i, c), Ii(i), b.stopPropagation(), b.preventDefault());
  }
  function m() {
    Fh(i, c), i[u].classList.remove(Zt.state.clicking), document.removeEventListener("mousemove", g), document.removeEventListener("mouseup", m), document.removeEventListener("touchmove", g), document.removeEventListener("touchend", m), xr = null;
  }
  function v(b) {
    xr === null && (xr = a, h = d[l], b.touches && (b[s] = b.touches[0]["page" + c.toUpperCase()]), f = b[s], p = (i[n] - i[e]) / (i[r] - i[o]), b.touches ? (document.addEventListener("touchmove", g, { passive: !1 }), document.addEventListener("touchend", m)) : (document.addEventListener("mousemove", g), document.addEventListener("mouseup", m)), i[u].classList.add(Zt.state.clicking)), b.stopPropagation(), b.cancelable && b.preventDefault();
  }
  i[a].addEventListener("mousedown", v), i[a].addEventListener("touchstart", v);
}
function eb(i) {
  var t = i.element, e = function() {
    return Vi(t, ":hover");
  }, n = function() {
    return Vi(i.scrollbarX, ":focus") || Vi(i.scrollbarY, ":focus");
  };
  function s(r, a) {
    var o = Math.floor(t.scrollTop);
    if (r === 0) {
      if (!i.scrollbarYActive)
        return !1;
      if (o === 0 && a > 0 || o >= i.contentHeight - i.containerHeight && a < 0)
        return !i.settings.wheelPropagation;
    }
    var l = t.scrollLeft;
    if (a === 0) {
      if (!i.scrollbarXActive)
        return !1;
      if (l === 0 && r < 0 || l >= i.contentWidth - i.containerWidth && r > 0)
        return !i.settings.wheelPropagation;
    }
    return !0;
  }
  i.event.bind(i.ownerDocument, "keydown", function(r) {
    if (!(r.isDefaultPrevented && r.isDefaultPrevented() || r.defaultPrevented) && !(!e() && !n())) {
      var a = document.activeElement ? document.activeElement : i.ownerDocument.activeElement;
      if (a) {
        if (a.tagName === "IFRAME")
          a = a.contentDocument.activeElement;
        else
          for (; a.shadowRoot; )
            a = a.shadowRoot.activeElement;
        if (XA(a))
          return;
      }
      var o = 0, l = 0;
      switch (r.which) {
        case 37:
          r.metaKey ? o = -i.contentWidth : r.altKey ? o = -i.containerWidth : o = -30;
          break;
        case 38:
          r.metaKey ? l = i.contentHeight : r.altKey ? l = i.containerHeight : l = 30;
          break;
        case 39:
          r.metaKey ? o = i.contentWidth : r.altKey ? o = i.containerWidth : o = 30;
          break;
        case 40:
          r.metaKey ? l = -i.contentHeight : r.altKey ? l = -i.containerHeight : l = -30;
          break;
        case 32:
          r.shiftKey ? l = i.containerHeight : l = -i.containerHeight;
          break;
        case 33:
          l = i.containerHeight;
          break;
        case 34:
          l = -i.containerHeight;
          break;
        case 36:
          l = i.contentHeight;
          break;
        case 35:
          l = -i.contentHeight;
          break;
        default:
          return;
      }
      i.settings.suppressScrollX && o !== 0 || i.settings.suppressScrollY && l !== 0 || (t.scrollTop -= l, t.scrollLeft += o, Ii(i), s(o, l) && r.preventDefault());
    }
  });
}
function ib(i) {
  var t = i.element;
  function e(a, o) {
    var l = Math.floor(t.scrollTop), c = t.scrollTop === 0, u = l + t.offsetHeight === t.scrollHeight, d = t.scrollLeft === 0, h = t.scrollLeft + t.offsetWidth === t.scrollWidth, f;
    return Math.abs(o) > Math.abs(a) ? f = c || u : f = d || h, f ? !i.settings.wheelPropagation : !0;
  }
  function n(a) {
    var o = a.deltaX, l = -1 * a.deltaY;
    return (typeof o > "u" || typeof l > "u") && (o = -1 * a.wheelDeltaX / 6, l = a.wheelDeltaY / 6), a.deltaMode && a.deltaMode === 1 && (o *= 10, l *= 10), o !== o && l !== l && (o = 0, l = a.wheelDelta), a.shiftKey ? [-l, -o] : [o, l];
  }
  function s(a, o, l) {
    if (!Hn.isWebKit && t.querySelector("select:focus"))
      return !0;
    if (!t.contains(a))
      return !1;
    for (var c = a; c && c !== t; ) {
      if (c.classList.contains(Zt.element.consuming))
        return !0;
      var u = fi(c);
      if (l && u.overflowY.match(/(scroll|auto)/)) {
        var d = c.scrollHeight - c.clientHeight;
        if (d > 0 && (c.scrollTop > 0 && l < 0 || c.scrollTop < d && l > 0))
          return !0;
      }
      if (o && u.overflowX.match(/(scroll|auto)/)) {
        var h = c.scrollWidth - c.clientWidth;
        if (h > 0 && (c.scrollLeft > 0 && o < 0 || c.scrollLeft < h && o > 0))
          return !0;
      }
      c = c.parentNode;
    }
    return !1;
  }
  function r(a) {
    var o = n(a), l = o[0], c = o[1];
    if (!s(a.target, l, c)) {
      var u = !1;
      i.settings.useBothWheelAxes ? i.scrollbarYActive && !i.scrollbarXActive ? (c ? t.scrollTop -= c * i.settings.wheelSpeed : t.scrollTop += l * i.settings.wheelSpeed, u = !0) : i.scrollbarXActive && !i.scrollbarYActive && (l ? t.scrollLeft += l * i.settings.wheelSpeed : t.scrollLeft -= c * i.settings.wheelSpeed, u = !0) : (t.scrollTop -= c * i.settings.wheelSpeed, t.scrollLeft += l * i.settings.wheelSpeed), Ii(i), u = u || e(l, c), u && !a.ctrlKey && (a.stopPropagation(), a.preventDefault());
    }
  }
  typeof window.onwheel < "u" ? i.event.bind(t, "wheel", r) : typeof window.onmousewheel < "u" && i.event.bind(t, "mousewheel", r);
}
function nb(i) {
  if (!Hn.supportsTouch && !Hn.supportsIePointer)
    return;
  var t = i.element, e = {
    startOffset: {},
    startTime: 0,
    speed: {},
    easingLoop: null
  };
  function n(d, h) {
    var f = Math.floor(t.scrollTop), p = t.scrollLeft, g = Math.abs(d), m = Math.abs(h);
    if (m > g) {
      if (h < 0 && f === i.contentHeight - i.containerHeight || h > 0 && f === 0)
        return window.scrollY === 0 && h > 0 && Hn.isChrome;
    } else if (g > m && (d < 0 && p === i.contentWidth - i.containerWidth || d > 0 && p === 0))
      return !0;
    return !0;
  }
  function s(d, h) {
    t.scrollTop -= h, t.scrollLeft -= d, Ii(i);
  }
  function r(d) {
    return d.targetTouches ? d.targetTouches[0] : d;
  }
  function a(d) {
    return d.target === i.scrollbarX || d.target === i.scrollbarY || d.pointerType && d.pointerType === "pen" && d.buttons === 0 ? !1 : !!(d.targetTouches && d.targetTouches.length === 1 || d.pointerType && d.pointerType !== "mouse" && d.pointerType !== d.MSPOINTER_TYPE_MOUSE);
  }
  function o(d) {
    if (a(d)) {
      var h = r(d);
      e.startOffset.pageX = h.pageX, e.startOffset.pageY = h.pageY, e.startTime = (/* @__PURE__ */ new Date()).getTime(), e.easingLoop !== null && clearInterval(e.easingLoop);
    }
  }
  function l(d, h, f) {
    if (!t.contains(d))
      return !1;
    for (var p = d; p && p !== t; ) {
      if (p.classList.contains(Zt.element.consuming))
        return !0;
      var g = fi(p);
      if (f && g.overflowY.match(/(scroll|auto)/)) {
        var m = p.scrollHeight - p.clientHeight;
        if (m > 0 && (p.scrollTop > 0 && f < 0 || p.scrollTop < m && f > 0))
          return !0;
      }
      if (h && g.overflowX.match(/(scroll|auto)/)) {
        var v = p.scrollWidth - p.clientWidth;
        if (v > 0 && (p.scrollLeft > 0 && h < 0 || p.scrollLeft < v && h > 0))
          return !0;
      }
      p = p.parentNode;
    }
    return !1;
  }
  function c(d) {
    if (a(d)) {
      var h = r(d), f = { pageX: h.pageX, pageY: h.pageY }, p = f.pageX - e.startOffset.pageX, g = f.pageY - e.startOffset.pageY;
      if (l(d.target, p, g))
        return;
      s(p, g), e.startOffset = f;
      var m = (/* @__PURE__ */ new Date()).getTime(), v = m - e.startTime;
      v > 0 && (e.speed.x = p / v, e.speed.y = g / v, e.startTime = m), n(p, g) && d.cancelable && d.preventDefault();
    }
  }
  function u() {
    i.settings.swipeEasing && (clearInterval(e.easingLoop), e.easingLoop = setInterval(function() {
      if (i.isInitialized) {
        clearInterval(e.easingLoop);
        return;
      }
      if (!e.speed.x && !e.speed.y) {
        clearInterval(e.easingLoop);
        return;
      }
      if (Math.abs(e.speed.x) < 0.01 && Math.abs(e.speed.y) < 0.01) {
        clearInterval(e.easingLoop);
        return;
      }
      s(e.speed.x * 30, e.speed.y * 30), e.speed.x *= 0.8, e.speed.y *= 0.8;
    }, 10));
  }
  Hn.supportsTouch ? (i.event.bind(t, "touchstart", o), i.event.bind(t, "touchmove", c), i.event.bind(t, "touchend", u)) : Hn.supportsIePointer && (window.PointerEvent ? (i.event.bind(t, "pointerdown", o), i.event.bind(t, "pointermove", c), i.event.bind(t, "pointerup", u)) : window.MSPointerEvent && (i.event.bind(t, "MSPointerDown", o), i.event.bind(t, "MSPointerMove", c), i.event.bind(t, "MSPointerUp", u)));
}
var sb = function() {
  return {
    handlers: ["click-rail", "drag-thumb", "keyboard", "wheel", "touch"],
    maxScrollbarLength: null,
    minScrollbarLength: null,
    scrollingThreshold: 1e3,
    scrollXMarginOffset: 0,
    scrollYMarginOffset: 0,
    suppressScrollX: !1,
    suppressScrollY: !1,
    swipeEasing: !0,
    useBothWheelAxes: !1,
    wheelPropagation: !0,
    wheelSpeed: 1
  };
}, rb = {
  "click-rail": qA,
  "drag-thumb": tb,
  keyboard: eb,
  wheel: ib,
  touch: nb
}, ir = function(t, e) {
  var n = this;
  if (e === void 0 && (e = {}), typeof t == "string" && (t = document.querySelector(t)), !t || !t.nodeName)
    throw new Error("no element is specified to initialize PerfectScrollbar");
  this.element = t, t.classList.add(Zt.main), this.settings = sb();
  for (var s in e)
    this.settings[s] = e[s];
  this.containerWidth = null, this.containerHeight = null, this.contentWidth = null, this.contentHeight = null;
  var r = function() {
    return t.classList.add(Zt.state.focus);
  }, a = function() {
    return t.classList.remove(Zt.state.focus);
  };
  this.isRtl = fi(t).direction === "rtl", this.isRtl === !0 && t.classList.add(Zt.rtl), this.isNegativeScroll = function() {
    var c = t.scrollLeft, u = null;
    return t.scrollLeft = -1, u = t.scrollLeft < 0, t.scrollLeft = c, u;
  }(), this.negativeScrollAdjustment = this.isNegativeScroll ? t.scrollWidth - t.clientWidth : 0, this.event = new ds(), this.ownerDocument = t.ownerDocument || document, this.scrollbarXRail = yr(Zt.element.rail("x")), t.appendChild(this.scrollbarXRail), this.scrollbarX = yr(Zt.element.thumb("x")), this.scrollbarXRail.appendChild(this.scrollbarX), this.scrollbarX.setAttribute("tabindex", 0), this.event.bind(this.scrollbarX, "focus", r), this.event.bind(this.scrollbarX, "blur", a), this.scrollbarXActive = null, this.scrollbarXWidth = null, this.scrollbarXLeft = null;
  var o = fi(this.scrollbarXRail);
  this.scrollbarXBottom = parseInt(o.bottom, 10), isNaN(this.scrollbarXBottom) ? (this.isScrollbarXUsingBottom = !1, this.scrollbarXTop = Ft(o.top)) : this.isScrollbarXUsingBottom = !0, this.railBorderXWidth = Ft(o.borderLeftWidth) + Ft(o.borderRightWidth), ve(this.scrollbarXRail, { display: "block" }), this.railXMarginWidth = Ft(o.marginLeft) + Ft(o.marginRight), ve(this.scrollbarXRail, { display: "" }), this.railXWidth = null, this.railXRatio = null, this.scrollbarYRail = yr(Zt.element.rail("y")), t.appendChild(this.scrollbarYRail), this.scrollbarY = yr(Zt.element.thumb("y")), this.scrollbarYRail.appendChild(this.scrollbarY), this.scrollbarY.setAttribute("tabindex", 0), this.event.bind(this.scrollbarY, "focus", r), this.event.bind(this.scrollbarY, "blur", a), this.scrollbarYActive = null, this.scrollbarYHeight = null, this.scrollbarYTop = null;
  var l = fi(this.scrollbarYRail);
  this.scrollbarYRight = parseInt(l.right, 10), isNaN(this.scrollbarYRight) ? (this.isScrollbarYUsingRight = !1, this.scrollbarYLeft = Ft(l.left)) : this.isScrollbarYUsingRight = !0, this.scrollbarYOuterWidth = this.isRtl ? QA(this.scrollbarY) : null, this.railBorderYWidth = Ft(l.borderTopWidth) + Ft(l.borderBottomWidth), ve(this.scrollbarYRail, { display: "block" }), this.railYMarginHeight = Ft(l.marginTop) + Ft(l.marginBottom), ve(this.scrollbarYRail, { display: "" }), this.railYHeight = null, this.railYRatio = null, this.reach = {
    x: t.scrollLeft <= 0 ? "start" : t.scrollLeft >= this.contentWidth - this.containerWidth ? "end" : null,
    y: t.scrollTop <= 0 ? "start" : t.scrollTop >= this.contentHeight - this.containerHeight ? "end" : null
  }, this.isAlive = !0, this.settings.handlers.forEach(function(c) {
    return rb[c](n);
  }), this.lastScrollTop = Math.floor(t.scrollTop), this.lastScrollLeft = t.scrollLeft, this.event.bind(this.element, "scroll", function(c) {
    return n.onScroll(c);
  }), Ii(this);
};
ir.prototype.update = function() {
  this.isAlive && (this.negativeScrollAdjustment = this.isNegativeScroll ? this.element.scrollWidth - this.element.clientWidth : 0, ve(this.scrollbarXRail, { display: "block" }), ve(this.scrollbarYRail, { display: "block" }), this.railXMarginWidth = Ft(fi(this.scrollbarXRail).marginLeft) + Ft(fi(this.scrollbarXRail).marginRight), this.railYMarginHeight = Ft(fi(this.scrollbarYRail).marginTop) + Ft(fi(this.scrollbarYRail).marginBottom), ve(this.scrollbarXRail, { display: "none" }), ve(this.scrollbarYRail, { display: "none" }), Ii(this), ta(this, "top", 0, !1, !0), ta(this, "left", 0, !1, !0), ve(this.scrollbarXRail, { display: "" }), ve(this.scrollbarYRail, { display: "" }));
};
ir.prototype.onScroll = function(t) {
  this.isAlive && (Ii(this), ta(this, "top", this.element.scrollTop - this.lastScrollTop), ta(this, "left", this.element.scrollLeft - this.lastScrollLeft), this.lastScrollTop = Math.floor(this.element.scrollTop), this.lastScrollLeft = this.element.scrollLeft);
};
ir.prototype.destroy = function() {
  this.isAlive && (this.event.unbindAll(), zn(this.scrollbarX), zn(this.scrollbarY), zn(this.scrollbarXRail), zn(this.scrollbarYRail), this.removePsClasses(), this.element = null, this.scrollbarX = null, this.scrollbarY = null, this.scrollbarXRail = null, this.scrollbarYRail = null, this.isAlive = !1);
};
ir.prototype.removePsClasses = function() {
  this.element.className = this.element.className.split(" ").filter(function(t) {
    return !t.match(/^ps([-_].+|)$/);
  }).join(" ");
};
var ab = {
  name: "PerfectScrollbar",
  props: {
    options: {
      type: Object,
      required: !1,
      default: () => {
      }
    },
    tag: {
      type: String,
      required: !1,
      default: "div"
    },
    watchOptions: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  data() {
    return {
      ps: null
    };
  },
  watch: {
    watchOptions(i) {
      !i && this.watcher ? this.watcher() : this.createWatcher();
    }
  },
  mounted() {
    this.create(), this.watchOptions && this.createWatcher();
  },
  updated() {
    this.$nextTick(() => {
      this.update();
    });
  },
  beforeDestroy() {
    this.destroy();
  },
  methods: {
    create() {
      this.ps && this.$isServer || (this.ps = new ir(this.$refs.container, this.options));
    },
    createWatcher() {
      this.watcher = this.$watch("options", () => {
        this.destroy(), this.create();
      }, {
        deep: !0
      });
    },
    update() {
      this.ps && this.ps.update();
    },
    destroy() {
      this.ps && (this.ps.destroy(), this.ps = null);
    }
  },
  render(i) {
    return i(
      this.tag,
      {
        ref: "container",
        class: "ps",
        on: this.$listeners
      },
      this.$slots.default
    );
  }
};
const ob = {
  name: "AcvScrollbar",
  components: {
    PerfectScrollbar: ab
  },
  props: {
    options: {
      type: Object,
      default: () => {
      }
    }
  },
  computed: {
    refName() {
      return this.$attrs.id || this.id || `${this.$options.name}-${this._uid}`;
    }
  },
  methods: {
    updateScroll() {
      this.$refs[this.refName].update();
    }
  }
};
var lb = function() {
  var t = this, e = t._self._c;
  return e("perfect-scrollbar", t._g({ ref: t.refName, staticClass: "acv-scrollbar", attrs: { settings: t.options } }, t.$listeners), [t._t("default")], 2);
}, cb = [], ub = /* @__PURE__ */ U(
  ob,
  lb,
  cb,
  !1,
  null,
  "08444a3f"
);
const ka = ub.exports, db = {
  name: "AcvGalleryCategoryBar",
  props: {
    categories: {
      type: Object,
      default: () => ({})
    },
    showCounts: {
      type: Boolean,
      default: !0
    }
  },
  data: () => ({
    activeCategory: ""
  }),
  computed: {
    hasCategories() {
      return Object.keys(this.categories).length;
    }
  },
  watch: {
    activeCategory: {
      immediate: !0,
      handler(i, t) {
        if (i && i !== t) {
          const e = document.querySelector(`.acv-gallery-category-bar__categories__category[data-category=${i}]`);
          e && this.scrollCategoryIntoView(e);
        }
      }
    }
  },
  methods: {
    displayText(i, t) {
      return [
        i,
        this.showCounts ? `(${t})` : ""
      ].filter(Boolean).join(" ");
    },
    handleCategoryClick(i) {
      this.changeActiveCategory(i), this.activeCategory && this.$emit("category-clicked", this.activeCategory);
    },
    changeActiveCategory(i) {
      if (this.activeCategory === i) return;
      document.querySelector(`.acv-gallery-category-bar__categories__category[data-category=${i}]`) && (this.activeCategory = i);
    },
    scrollCategoryIntoView(i) {
      const t = document.querySelector(".acv-gallery-category-bar__categories");
      if (t && i)
        if (i.offsetLeft + i.clientWidth / 2 > window.innerWidth / 2) {
          const e = i.offsetLeft - window.innerWidth / 2;
          e < t.scrollWidth ? t.scrollLeft = e + i.clientWidth / 2 : t.scrollLeft = t.scrollWidth;
        } else
          t.scrollLeft = 0;
    }
  }
};
var hb = function() {
  var t = this, e = t._self._c;
  return t.hasCategories ? e("div", { staticClass: "acv-gallery-category-bar" }, [e("div", { staticClass: "acv-gallery-category-bar__categories" }, t._l(t.categories, function(n, s) {
    return e("button", { key: s, staticClass: "acv-gallery-category-bar__categories__category", class: {
      "acv-gallery-category-bar__categories__category--active": t.activeCategory === s
    }, attrs: { type: "button", "data-category": s }, on: { click: function(r) {
      return t.handleCategoryClick(s);
    } } }, [t._v(" " + t._s(t.displayText(s, n)) + " ")]);
  }), 0)]) : t._e();
}, fb = [], pb = /* @__PURE__ */ U(
  db,
  hb,
  fb,
  !1,
  null,
  "d4de4c8c"
);
const Hh = pb.exports, Wc = [
  {
    size: "1000"
  },
  {
    size: "600"
  },
  {
    size: "300"
  },
  {
    size: "150"
  }
], gb = {
  name: "AcvLazyImage",
  props: {
    /**
    * Image source to be shown
    */
    src: {
      type: String,
      required: !0
    },
    /**
    * Placeholder image source while the image source is loading
    */
    srcPlaceholder: {
      type: String,
      default: ""
    },
    /**
    * Error placeholder image source when retry limit is reached on error
    */
    errorPlaceholder: {
      type: String,
      default: ""
    },
    /**
    * Alt text for image
    */
    alt: {
      type: String,
      default: ""
    },
    /**
    * Determines if the image should be lazy loaded into the viewport or eager loaded.<br/>
    * If truthy and the image is not visibly shown on initial render, the onload
    * events will not trigger properly
    */
    lazy: {
      type: Boolean,
      default: !1
    },
    /**
    * Fixed width of the expected image to generate a single image source in the srcSet
    */
    fixedWidth: {
      type: Number,
      default: null
    },
    /**
    * Fixed height of the expected image to generate a single image source in the srcSet
    */
    fixedHeight: {
      type: Number,
      default: null
    }
  },
  data: () => ({
    imageSrc: "",
    imageLoading: !0,
    imageLoadTimeout: null,
    failImageRetries: 2,
    failImageLimit: null
  }),
  computed: {
    imageSuccessfullyLoaded() {
      return this.imageSrc === this.src && this.imageSrc !== this.srcPlaceholder;
    },
    computedImageClasses() {
      return {
        "acv-lazy-image--loaded": !this.imageLoading || this.failImageLimit
      };
    },
    hasFixedDimensions() {
      return this.fixedWidth && this.fixedHeight;
    },
    srcDimensionsMatchTwBreakpoints() {
      const i = this.imageSrc.match(/[0-9]{1,9}x[0-9]{1,9}/g)[0].split("x");
      return i[0] === i[1] && Wc.find((t) => t.size === i[0]);
    },
    shouldUseTwBreakpoints() {
      return /[0-9]{1,9}x[0-9]{1,9}/.test(this.imageSrc) && this.imageSrc !== this.srcPlaceholder;
    },
    imageSrcSet() {
      if (this.shouldUseTwBreakpoints) {
        if (this.hasFixedDimensions)
          return `${this.imageSrc.replace(/[0-9]{1,9}x[0-9]{1,9}/, `${this.fixedWidth}x${this.fixedHeight}`)} ${this.fixedWidth}w`;
        if (!this.srcDimensionsMatchTwBreakpoints)
          return "";
        const i = [];
        return Wc.forEach((t) => {
          i.push(`${this.imageSrc.replace(/[0-9]{1,9}x[0-9]{1,9}/, `${t.size}x${t.size}`)} ${t.size}w`);
        }), i.join(",");
      }
      return "";
    },
    sizes() {
      if (this.shouldUseTwBreakpoints && this.srcDimensionsMatchTwBreakpoints) {
        const i = this.$tailwindHelper.getCurrentBreakpointByKey("tw-lg").value, t = this.$tailwindHelper.getCurrentBreakpointByKey("tw-md").value, e = this.$tailwindHelper.getCurrentBreakpointByKey("tw-sm").value;
        return `(min-width: ${i}px) 600px, (min-width: ${t}px) 300px, (min-width: ${e}px) 150px, 25vw`;
      }
      return "";
    }
  },
  watch: {
    src(i, t) {
      i !== t && t && !this.imageSuccessfullyLoaded && this.setImageSrc();
    }
  },
  mounted() {
    !this.failImageLimit && !this.imageSuccessfullyLoaded && (this.srcPlaceholder ? this.imageSrc = this.srcPlaceholder : this.setImageSrc());
  },
  beforeDestroy() {
    this.clearTimeout();
  },
  methods: {
    setImageSrc() {
      this.imageSrc = this.src;
    },
    handleImageLoaded(i) {
      this.src && !this.imageSuccessfullyLoaded && !this.failImageLimit ? (this.imageLoading = !0, this.imageLoadTimeout || (this.imageLoadTimeout = setTimeout(this.setImageSrc, 50))) : (this.imageLoading = !1, this.$emit("load", i));
    },
    retryImageLoad(i) {
      if (this.imageSrc && !this.failImageLimit) {
        this.clearTimeout();
        const t = i;
        this.failImageRetries === 0 ? (this.failImageLimit = !0, this.errorPlaceholder && (this.imageSrc = this.errorPlaceholder), this.$emit("error", i)) : (this.srcPlaceholder ? (this.imageSrc = this.srcPlaceholder, t.target.src = this.srcPlaceholder) : (this.imageSrc = "", t.target.src = ""), this.handleImageLoaded(), this.failImageRetries -= 1);
      }
    },
    clearTimeout() {
      this.imageLoadTimeout && (clearInterval(this.imageLoadTimeout), this.imageLoadTimeout = null);
    }
  }
};
var mb = function() {
  var t = this, e = t._self._c;
  return e("img", { class: ["acv-lazy-image", t.computedImageClasses], attrs: { src: t.imageSrc, alt: t.imageLoading ? "" : t.alt, loading: t.lazy ? "lazy" : "eager", srcset: t.imageSrcSet, sizes: t.sizes }, on: { load: function(n) {
    return t.handleImageLoaded(n);
  }, error: function(n) {
    return t.retryImageLoad(n);
  } } });
}, vb = [], Ab = /* @__PURE__ */ U(
  gb,
  mb,
  vb,
  !1,
  null,
  "c14f985c"
);
const Dl = Ab.exports, bb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Dl
}, Symbol.toStringTag, { value: "Module" })), yb = "data:image/png;base64,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", _b = {
  name: "AcvGalleryList",
  components: {
    AcvLazyImage: Dl
  },
  props: {
    images: {
      type: Array,
      default: () => []
    },
    categories: {
      type: Object,
      default: () => ({})
    },
    categoriesKey: {
      type: String,
      default: "category"
    },
    showCategories: {
      type: Boolean,
      default: !0
    },
    noCategoriesText: {
      type: String,
      default: "Additional"
    },
    showCounts: {
      type: Boolean,
      default: !0
    }
  },
  data: () => ({
    emptyPicture: yb,
    automatedScrollTimer: null
  }),
  computed: {
    sections() {
      return this.showCategories && Object.keys(this.categories).length ? Object.keys(this.categories).reduce((i, t) => (i.push({
        name: t,
        count: this.categories[t],
        photos: this.getPhotosFromCategory(t)
      }), i), []) : [
        { photos: [...this.images] }
      ];
    }
  },
  mounted() {
    this.$el.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    getPhotosFromCategory(i) {
      return i === this.noCategoriesText ? this.images.filter((t) => t[this.categoriesKey] === this.noCategoriesText || !t[this.categoriesKey]) : this.images.filter((t) => t.category === i);
    },
    handlePhotoClick(i) {
      this.$emit("view-photo", i);
    },
    handleScroll({ target: i }) {
      if (this.automatedScrollTimer) return;
      const t = Array.from(
        document.querySelectorAll(".acv-gallery-list__section")
      ).map((n) => ({ offset: n.offsetTop, category: n.dataset.category })), e = t.findLastIndex((n) => n.offset - 30 <= i.scrollTop);
      this.$emit("scrolled-section", t[e].category);
    },
    scrollToSection(i, t = !1) {
      t ? this.scrollSectionIntoView(i, "instant") : window.requestAnimationFrame(() => {
        this.clearAutomatedScrollTimer(), this.automatedScrollTimer = setTimeout(() => {
          this.scrollSectionIntoView(i, "smooth"), setTimeout(() => {
            this.clearAutomatedScrollTimer();
          }, 1500);
        }, 350);
      });
    },
    scrollSectionIntoView(i, t = "smooth") {
      const e = document.querySelector(`.acv-gallery-list__section[data-category=${i}]`);
      e && e.scrollIntoView({
        behavior: t,
        block: "start",
        inline: "nearest"
      });
    },
    clearAutomatedScrollTimer() {
      this.automatedScrollTimer && (clearTimeout(this.automatedScrollTimer), this.automatedScrollTimer = null);
    }
  }
};
var xb = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "acv-gallery-list" }, t._l(t.sections, function(n, s) {
    return e("section", { key: s, staticClass: "acv-gallery-list__section", attrs: { "data-category": n.name } }, [n.name ? e("div", { staticClass: "acv-gallery-list__section__header" }, [e("span", [t._v(t._s(n.name))]), t.showCounts ? e("span", [t._v(" " + t._s(`${n.count} Image${n.count > 1 ? "s" : ""}`) + " ")]) : t._e()]) : t._e(), e("div", { staticClass: "acv-gallery-list__section__photos" }, t._l(n.photos, function(r, a) {
      return e("div", { key: a, staticClass: "acv-gallery-list__section__photos__photo" }, [e("acv-lazy-image", { attrs: { src: r.thumbnail || r.src || r || "", "src-placeholder": t.emptyPicture, "error-placeholder": t.emptyPicture, alt: r.caption || r.alt || "", lazy: "", tabindex: "0" }, nativeOn: { click: function(o) {
        return o.stopPropagation(), t.handlePhotoClick(r);
      }, keypress: function(o) {
        return !o.type.indexOf("key") && t._k(o.keyCode, "space", 32, o.key, [" ", "Spacebar"]) ? null : (o.stopPropagation(), t.handlePhotoClick(r));
      } } })], 1);
    }), 0)]);
  }), 0);
}, Cb = [], Sb = /* @__PURE__ */ U(
  _b,
  xb,
  Cb,
  !1,
  null,
  "aed6f34e"
);
const Vh = Sb.exports, wb = {
  name: "AcvGallery",
  components: {
    AcvGalleryCategoryBar: Hh,
    AcvGalleryList: Vh,
    AcvIcon: ie,
    AcvIconButton: Ee,
    AcvScrollbar: ka
  },
  directives: {
    dragged: $h
  },
  model: {
    prop: "index",
    event: "change"
  },
  props: {
    /**
     * Images to be displayed in carousel and thumbnails<br/>
     * Each image can be a string of the url or an object of the following properties:<br/>
     * `src` - image url<br/>
     * `thumbnail` - thumbnail url. If omitted, the src will be used<br/>
     * `caption` - caption text to be overlayed on the image<br/>
     * `alt` - alt text. If omitted, the caption will be used<br/>
     * `category` - category. If omitted, the `noCategoriesText` will be used<br/>
     */
    images: {
      type: Array,
      required: !0
    },
    /**
     * The inherited v-model for the index of the image to be opened in the carousel
     */
    index: {
      type: Number,
      default: null
    },
    /**
    * Shows the full screen or thumbnail view on initial load
    */
    defaultView: {
      type: String,
      validator: (i) => wt(i, ["fullScreen", "thumbnails"]),
      default: "fullScreen"
    },
    /**
    * Shows a mobile listing of photos before the carousel
    */
    hasMobileListing: {
      type: Boolean,
      default: !0
    },
    /**
    * Label shown for top left back button on mobile to leave the gallery-list and close the gallery
    */
    closeListingMobileLabel: {
      type: String,
      default: "Back to Listing"
    },
    /**
    * Label shown for top left back button on mobile to leave the carousel to see the gallery-list
    */
    closeCarouselMobileLabel: {
      type: String,
      default: "Back to Gallery"
    },
    /**
     * Determines whether to show images in the thumbnails
     */
    thumbnails: {
      type: Boolean,
      default: !0
    },
    /**
    * Enables zooming and panzooming on the current image
    */
    zoom: {
      type: Boolean,
      default: !0
    },
    /**
    * Show the image count based on image being viewed out of total images
    */
    showImageCount: {
      type: Boolean,
      default: !0
    },
    /**
     * Indicates whether the images carousel should loop around itself
     */
    loop: {
      type: Boolean,
      default: !0
    },
    /**
    * Enables drag horizontally for navigation
    */
    dragToNavigate: {
      type: Boolean,
      default: !0
    },
    /**
    * Enables drag vertically to close
    */
    dragToClose: {
      type: Boolean,
      default: !0
    },
    /**
    * Vertical drag threshold to close the gallery with dragToClose enabled
    */
    verticalDragThreshold: {
      type: Number,
      default: 80
    },
    /**
    * Horizontal drag threshold for carousel navigation with dragToNavigate enabled
    */
    horizontalDragThreshold: {
      type: Number,
      default: 100
    },
    /**
    * Allows clicking the image to go to the next image
    * Disables clicking the image to zoom and panzoom
    */
    clickToNext: {
      type: Boolean,
      default: !1
    },
    /**
    * Allows a caption to be shown for the current image
    */
    showCaption: {
      type: Boolean,
      default: !0
    },
    /**
    * Shows categories of images based on similar keys
    */
    showCategories: {
      type: Boolean,
      default: !1
    },
    /**
    * Determines the unique category key to generate unique category
    */
    categoriesKey: {
      type: String,
      default: "category"
    },
    /**
    * Shows the counts for the categories based on the provided image keys
    */
    showCounts: {
      type: Boolean,
      default: !0
    },
    /**
    * Text to show for images that have no category
    */
    noCategoriesText: {
      type: String,
      default: "Additional"
    },
    /**
    * FullScreen icon to full screen the carousel image, hiding the thumbnails
    */
    fullScreenIcon: {
      type: String,
      default: "fullscreen"
    },
    /**
    * Shrink icon to shrink a carousel image, showing the thumbnails
    */
    shrinkIcon: {
      type: String,
      default: "compress"
    },
    /**
    * Close icon to close the gallery
    */
    closeIcon: {
      type: String,
      default: "close"
    },
    /**
    * Icon denoting previous image navigation in carousel
    */
    previousCarouselIcon: {
      type: String,
      default: "arrow_back"
    },
    /**
    * Icon denoting next image navigation in carousel
    */
    nextCarouselIcon: {
      type: String,
      default: "arrow_forward"
    },
    /**
    * Icon denoting previous image navigation in thumbnails
    */
    previousThumbnailIcon: {
      type: String,
      default: "chevron_left"
    },
    /**
    * Icon denoting next image navigation in thumbnails
    */
    nextThumbnailIcon: {
      type: String,
      default: "chevron_right"
    }
  },
  data() {
    return {
      viewBeingShown: this.defaultView,
      showingMobilePhotoList: !1,
      wrapperStyles: {},
      sliderStyles: {},
      prevImageStyles: {},
      imageStyles: {},
      nextImageStyles: {},
      transitionImage: {},
      dragging: !1,
      dragCoords: {
        x: 0,
        y: 0,
        lockX: !1,
        lockY: !1
      },
      panning: !1,
      panZoomInstance: null,
      panZoomOptions: {
        maxScale: 5,
        minScale: 1,
        step: 1,
        contain: "outside",
        panOnlyWhenZoomed: !0,
        overflow: "visible"
      },
      zoomLevels: [1, 2, 3, 5],
      zoomFactor: null,
      panZoomCoords: {
        x: 0,
        y: 0
      }
    };
  },
  computed: {
    isOpen() {
      return this.index !== null;
    },
    prevImage() {
      return this.index > 0 ? this.index - 1 : this.loop ? this.images.length - 1 : this.index;
    },
    nextImage() {
      return this.index < this.images.length - 1 ? this.index + 1 : this.loop ? 0 : this.index;
    },
    imagePosition() {
      return `${this.index + 1}/${this.images.length}`;
    },
    hasTransitionImage() {
      return Object.keys(this.transitionImage).length;
    },
    categories() {
      if (this.showCategories) {
        const i = {};
        return this.images.forEach((t) => {
          const e = t[this.categoriesKey] || this.noCategoriesText;
          i[e] ? i[e] += 1 : i[e] = 1;
        }), i;
      }
      return {};
    },
    hasCategories() {
      return Object.keys(this.categories).length;
    },
    mobileBackButtonText() {
      return this.showingMobilePhotoList ? this.closeListingMobileLabel : this.closeCarouselMobileLabel;
    },
    isInFullScreen() {
      return this.viewBeingShown === "fullScreen";
    },
    isShowingThumbnails() {
      return this.viewBeingShown === "thumbnails";
    },
    minZoom() {
      return this.zoomFactor <= this.panZoomOptions.minScale;
    },
    hasLockedDirection() {
      return this.dragCoords.lockX || this.dragCoords.lockY;
    },
    controlBarButtons() {
      return [
        ...this.zoomLevels.map((t) => ({
          visibility: this.zoom && this.isInFullScreen,
          iconText: `${t}x`,
          key: "zoom",
          message: `Zoom by ${t}x`,
          disabled: this.zoomFactor === t,
          action: this.handleZoomButtonClick,
          params: t
        })),
        {
          visibility: this.isInFullScreen && this.thumbnails && this.shrinkIcon || this.isShowingThumbnails && this.fullScreenIcon,
          icon: this.isInFullScreen ? this.shrinkIcon : this.fullScreenIcon,
          key: "view",
          message: this.isInFullScreen ? "Show Thumbnails" : "Expand",
          action: this.setGalleryView,
          params: this.isInFullScreen ? "thumbnails" : "fullScreen"
        },
        {
          visibility: this.closeIcon,
          icon: this.closeIcon,
          key: "close",
          message: "Close",
          action: this.close
        }
      ];
    }
  },
  watch: {
    isOpen(i) {
      var e;
      const t = document.querySelector("body");
      i ? (Lt() && (t.style.touchAction = "pan-x pan-y"), document.activeElement && document.activeElement.blur(), t.classList.add("no-scroll"), this.hasMobileListing && this.checkIsMobile() && (this.scrollMobileListingToCategory(
        ((e = this.images[this.index]) == null ? void 0 : e.category) || this.noCategoriesText,
        !0
      ), this.showingMobilePhotoList = !0), this.setupListeners(), this.determineAdjacentImageStyles(), this.$emit("open", this.index), Lt() && this.isInFullScreen && this.zoom && this.instantiatePanzoom()) : (Lt() && (document.querySelector("body").style.touchAction = ""), t.classList.contains("no-scroll") && t.classList.remove("no-scroll"), this.removeListeners(), this.teardownPanzoom(), this.resetDefaults());
    },
    index(i, t) {
      Lt() && this.resetPanzoom(), i !== null && i !== t && (this.showCategories && this.scrollGalleryCategoryBar(), this.isShowingThumbnails && this.scrollThumbnailIntoView());
    },
    viewBeingShown() {
      this.zoom && (this.isShowingThumbnails && (this.resetPanzoom(), this.teardownPanzoom(), this.scrollThumbnailIntoView()), this.isInFullScreen && Lt() && this.instantiatePanzoom());
    },
    thumbnails(i, t) {
      !i && t && this.isShowingThumbnails && this.setGalleryView("fullScreen");
    }
  },
  beforeDestroy() {
    this.removeListeners(), this.teardownPanzoom();
    const i = document.querySelector("body");
    i.classList.contains("no-scroll") && i.classList.remove("no-scroll");
  },
  created() {
    this.zoomFactor = this.panZoomOptions.minScale;
  },
  methods: {
    checkIsMobile() {
      return ["tw-sm", "tw-md"].includes(this.$tailwindHelper.getCurrentBreakpoint().key);
    },
    setGalleryView(i) {
      this.$refs["control-button-view"] && this.$refs["control-button-view"][0].setNotVisibleTooltip(), this.viewBeingShown = i, this.$emit("full-screen-toggled", this.isInFullScreen);
    },
    setupListeners() {
      window.addEventListener("keyup", this.keyup), window.addEventListener("resize", this.handleResize);
    },
    removeListeners() {
      window.removeEventListener("keyup", this.keyup), window.removeEventListener("resize", this.handleResize), this.$refs["carousel-image"] && (this.$refs["carousel-image"].removeEventListener("panzoomstart", this.handlePanZoomStart), this.$refs["carousel-image"].removeEventListener("panzoompan", this.handlePanZoomMove), this.$refs["carousel-image"].removeEventListener("panzoomend", this.handlePanZoomEnd));
    },
    close() {
      const i = this.index;
      this.goto(null), this.$emit("close", i);
    },
    prev() {
      this.$emit("prev", this.prevImage), this.goto(this.prevImage);
    },
    next() {
      this.$emit("next", this.nextImage), this.goto(this.nextImage);
    },
    goto(i) {
      this.$emit("change", i);
    },
    keyup(i) {
      this.showingMobilePhotoList || (["ArrowRight", "Space"].includes(i.code) || ["ArrowRight", "Right", "Space"].includes(i.key) || [39, 32].includes(i.keyCode) ? this.next() : i.code === "ArrowLeft" || ["ArrowLeft", "Left"].includes(i.key) || i.keyCode === 37 ? this.prev() : (i.code === "Escape" || ["Escape", "Esc"].includes(i.key) || i.keyCode === 27) && (this.minZoom ? this.close() : this.changeZoomFactor(this.zoomLevels[0])));
    },
    scrollGalleryCategoryBar() {
      if (this.checkIsMobile()) {
        const i = this.images[this.index].category ? this.images[this.index].category : this.noCategoriesText;
        this.changeGalleryCategoryBarCategory(i);
      }
    },
    changeGalleryCategoryBarCategory(i) {
      window.requestAnimationFrame(() => {
        this.$refs["gallery-category-bar"] && this.$refs["gallery-category-bar"].changeActiveCategory(i);
      });
    },
    scrollMobileListingToCategory(i, t = !1) {
      window.requestAnimationFrame(() => {
        this.$refs["gallery-list"] && this.$refs["gallery-list"].scrollToSection(i, t);
      });
    },
    handleBackButtonClicked() {
      this.showingMobilePhotoList || !this.hasMobileListing ? this.close() : this.showingMobilePhotoList = !0;
    },
    handleListPhotoClicked(i) {
      const t = this.images.findIndex((e) => (e.thumbnail || e.src || e) === (i.thumbnail || i.src || i));
      this.goto(t), setTimeout(() => {
        this.showingMobilePhotoList = !1;
      }, 100);
    },
    scrollThumbnailIntoView() {
      this.$nextTick(() => {
        var e;
        const { thumbnails: i } = this.$refs, t = (e = this.$refs["thumbnail-item"]) == null ? void 0 : e[this.index];
        if (i && t)
          if (t.offsetLeft + t.clientWidth / 2 > window.innerWidth / 2) {
            const n = t.offsetLeft - window.innerWidth / 2;
            n < i.scrollWidth ? i.scrollLeft = n + t.clientWidth / 2 : i.scrollLeft = i.scrollWidth;
          } else
            i.scrollLeft = 0;
      });
    },
    onDragged({
      evt: i,
      offsetX: t,
      offsetY: e,
      first: n,
      last: s
    }) {
      var r;
      if (i.stopPropagation(), ![2, 3].includes(i.which)) {
        if (Lt() && this.panZoomInstance && this.zoom && ((r = i == null ? void 0 : i.touches) == null ? void 0 : r.length) > 1) {
          this.zoomFactor = this.panZoomInstance.getScale().toFixed(2), this.resetDrag(), this.minZoom && this.resetPanzoom();
          return;
        }
        if (!this.showingMobilePhotoList && this.minZoom) {
          if (n) {
            this.dragStart(i);
            return;
          }
          if (s) {
            this.dragging && this.dragEnd(i);
            return;
          }
          this.dragging && this.dragMove(i, t, e);
        }
      }
    },
    dragStart() {
      this.dragging = !0, this.wrapperStyles = {
        ...this.wrapperStyles,
        cursor: "grab"
      }, this.prevImageStyles = {
        ...this.prevImageStyles,
        opacity: 1
      }, this.nextImageStyles = {
        ...this.nextImageStyles,
        opacity: 1
      };
    },
    dragMove(i, t, e) {
      this.wrapperStyles = {
        ...this.wrapperStyles,
        cursor: "grabbing"
      }, this.dragCoords.x = t, this.dragCoords.y = e;
      const n = Math.abs(t), s = Math.abs(e);
      this.hasLockedDirection || (this.dragToNavigate && n >= s && s < n ? this.dragCoords.lockX = !0 : this.dragToClose && s > n && n < s && (this.dragCoords.lockY = !0));
      let r;
      if (this.dragToNavigate && this.dragCoords.lockX)
        r = `translate(${t}px, 0px)`;
      else if (this.dragToClose && this.dragCoords.lockY && (r = `translate(0px, ${e}px)`, s > this.verticalDragThreshold)) {
        let a = 100 - s + this.verticalDragThreshold;
        a <= 0 ? a = 0 : a >= 100 && (a = 100), this.wrapperStyles = {
          ...this.wrapperStyles,
          opacity: `${a}%`
        };
      }
      r && (this.sliderStyles = {
        ...this.sliderStyles,
        transform: r
      });
    },
    dragEnd(i) {
      this.dragging = !1, this.wrapperStyles = {
        ...this.wrapperStyles,
        cursor: "grab"
      }, this.dragToClose && this.dragCoords.lockY && Math.abs(this.dragCoords.y) > this.verticalDragThreshold ? this.close() : !this.dragCoords.x && !this.dragCoords.y ? i.target.classList.contains("acv-gallery__carousel__slider__image--current") ? this.clickToNext ? this.next() : this.isShowingThumbnails ? this.setGalleryView("fullScreen") : !Lt() && this.zoom && (this.panZoomInstance || this.instantiatePanzoom(), setTimeout(() => {
        this.handleCarouselImageClick(i);
      }, 20)) : !Lt() && (i.target.classList.contains("acv-gallery") || i.target.classList.contains("acv-gallery__carousel") || i.target.classList.contains("acv-gallery__carousel__slider")) && this.close() : this.dragToNavigate && (this.dragCoords.lockX && this.dragCoords.x > this.horizontalDragThreshold ? this.determineSliderNavigation("prev") : this.dragCoords.lockX && this.dragCoords.x < -this.horizontalDragThreshold ? this.determineSliderNavigation("next") : this.sliderStyles = {}), this.resetDrag();
    },
    resetDrag() {
      setTimeout(() => {
        this.wrapperStyles = {}, this.dragCoords.lockX = !1, this.dragCoords.lockY = !1, this.dragCoords.x = 0, this.dragCoords.y = 0;
      }, 50);
    },
    determineSliderNavigation(i) {
      if (!this.loop && (this.nextImage === this.index && i === "next" || this.prevImage === this.index && i === "prev")) {
        this.sliderStyles = {};
        return;
      }
      const [{ x: { value: t } }] = this.$refs["carousel-slider"].attributeStyleMap.get("transform");
      let e = Math.abs(t);
      for (; e < this.$refs.carousel.clientWidth; ) {
        e += 1;
        const s = `translate(${i === "prev" ? e : -e}px, 0px)`;
        this.sliderStyles = {
          ...this.sliderStyles,
          transform: s,
          transitionDuration: "300ms"
        };
      }
      let n;
      i === "next" ? n = this.images[this.nextImage] : i === "prev" && (n = this.images[this.prevImage]), this.transitionImage = {
        src: n.src || n,
        caption: n.caption || n.alt,
        style: {
          zIndex: 1,
          transform: `translate(${i === "prev" ? -e : e}px, 0px)`
        }
      }, setTimeout(() => {
        this[i](), this.prevImageStyles = {
          ...this.prevImageStyles,
          opacity: 0
        }, this.nextImageStyles = {
          ...this.nextImageStyles,
          opacity: 0
        }, setTimeout(() => {
          this.sliderStyles = {
            ...this.sliderStyles,
            transform: "translate(0px, 0px)",
            transitionDuration: "0ms"
          }, this.transitionImage = {};
        }, 150);
      }, 285);
    },
    determineAdjacentImageStyles() {
      this.$nextTick(() => {
        if (this.$refs.carousel) {
          const { clientWidth: i } = this.$refs.carousel, t = this.checkIsMobile() ? this.horizontalDragThreshold / 2 : 0;
          if (this.$refs["carousel-previous-image"]) {
            const { width: e } = this.$refs["carousel-previous-image"], n = this.calculateAdjacentImageTranslation(e, i);
            this.prevImageStyles = {
              ...this.prevImageStyles,
              transform: `translate(${-(n + t)}px, 0px)`
            };
          }
          if (this.$refs["carousel-next-image"]) {
            const { width: e } = this.$refs["carousel-next-image"], n = this.calculateAdjacentImageTranslation(e, i);
            this.nextImageStyles = {
              ...this.nextImageStyles,
              transform: `translate(${n + t}px, 0px)`
            };
          }
        }
      });
    },
    calculateAdjacentImageTranslation(i, t) {
      let e;
      return i >= t || t + i >= t ? e = t : e = t + i, e;
    },
    handleResize(i) {
      this.determineAdjacentImageStyles(), this.checkIsMobile() ? this.isShowingThumbnails && this.setGalleryView("fullScreen") : this.showingMobilePhotoList && (this.showingMobilePhotoList = !1), this.$emit("resize", i);
    },
    handleCategoryClicked(i) {
      if (this.showingMobilePhotoList)
        this.scrollMobileListingToCategory(i, !1), this.$emit("category-clicked", i);
      else {
        const t = this.images.findIndex((e) => i === this.noCategoriesText ? e[this.categoriesKey] === this.noCategoriesText || !e[this.categoriesKey] : e[this.categoriesKey] === i);
        t > -1 && (this.goto(t), this.$emit("category-clicked", i), setTimeout(() => {
          this.scrollThumbnailIntoView();
        }, 50));
      }
    },
    isActiveCategory(i) {
      return i === this.noCategoriesText ? this.images[this.index][this.categoriesKey] === this.noCategoriesText || !this.images[this.index][this.categoriesKey] : this.images[this.index][this.categoriesKey] === i;
    },
    getPlacementInCategory(i) {
      if (!this.checkIsMobile()) return "";
      const t = (i == null ? void 0 : i.category) || this.noCategoriesText, e = t === this.noCategoriesText ? this.images.filter((s) => s.category === this.noCategoriesText || !s.category) : this.images.filter((s) => s.category === t);
      return `Photo ${e.findIndex((s) => (s.src || s) === (i.src || i)) + 1} of ${e.length}`;
    },
    instantiatePanzoom() {
      this.$nextTick(() => {
        this.$refs["carousel-image"] && (this.panZoomInstance = Tl(this.$refs["carousel-image"], this.panZoomOptions), this.$refs["carousel-image"].addEventListener("panzoomstart", this.handlePanZoomStart), this.$refs["carousel-image"].addEventListener("panzoompan", this.handlePanZoomMove), this.$refs["carousel-image"].addEventListener("panzoomend", this.handlePanZoomEnd));
      });
    },
    changeZoomFactor(i, t = null) {
      this.zoomFactor !== i && i && (t ? this.panZoomInstance.zoomToPoint(i, t, { animate: !0 }) : this.panZoomInstance.zoom(i, { animate: !0 }), i === this.panZoomOptions.minScale ? (this.resetPanzoom(), this.teardownPanzoom()) : this.zoomFactor = i, this.$emit("zoom", this.images[this.index], i));
    },
    handleZoomButtonClick(i) {
      this.panZoomInstance || this.instantiatePanzoom(), setTimeout(() => {
        this.changeZoomFactor(i);
      }, 10);
    },
    handleCarouselImageClick(i) {
      const t = this.zoomLevels.findIndex((e) => e === this.zoomFactor);
      t !== this.zoomLevels.length - 1 ? this.changeZoomFactor(this.zoomLevels[t + 1], i) : this.changeZoomFactor(this.zoomLevels[0], i);
    },
    handlePanZoomStart(i) {
      const { x: t, y: e } = i.detail;
      this.panZoomCoords.x = t, this.panZoomCoords.y = e, this.imageStyles = {
        ...this.imageStyles,
        cursor: "grab"
      };
    },
    handlePanZoomMove() {
      this.panning = !0, this.imageStyles = {
        ...this.imageStyles,
        cursor: "grabbing"
      };
    },
    handlePanZoomEnd(i) {
      const { x: t, y: e, originalEvent: n } = i.detail;
      this.panning = !1, this.imageStyles = {
        ...this.imageStyles,
        cursor: "grab"
      }, this.panZoomCoords.x === t && this.panZoomCoords.y === e && !Lt() && this.handleCarouselImageClick(n);
    },
    resetPanzoom() {
      this.panZoomInstance && (this.panZoomInstance.reset(), this.zoomFactor = this.panZoomOptions.minScale);
    },
    teardownPanzoom() {
      this.panZoomInstance && (this.panZoomInstance.destroy(), this.panZoomInstance = null);
    },
    resetDefaults() {
      this.viewBeingShown = this.defaultView, this.showingMobilePhotoList = !1, this.wrapperStyles = {}, this.sliderStyles = {}, this.prevImageStyles = {}, this.imageStyles = {}, this.nextImageStyles = {}, this.transitionImage = {}, this.dragging = !1, this.dragCoords = {
        x: 0,
        y: 0,
        lockX: !1,
        lockY: !1
      }, this.panning = !1, this.panZoomOptions = {
        maxScale: 5,
        minScale: 1,
        step: 1,
        contain: "outside",
        panOnlyWhenZoomed: !0,
        overflow: "visible"
      }, this.zoomFactor = this.panZoomOptions.minScale, this.panZoomCoords = {
        x: 0,
        y: 0
      };
    }
  }
};
var kb = function() {
  var t = this, e = t._self._c;
  return e("transition", { attrs: { name: "fade" } }, [t.isOpen ? e("div", { directives: [{ name: "dragged", rawName: "v-dragged", value: t.onDragged, expression: "onDragged" }], ref: "gallery", staticClass: "acv-gallery", style: t.wrapperStyles }, [e("div", { staticClass: "acv-gallery__control-bar", class: { zoomed: !t.minZoom }, on: { click: function(n) {
    n.stopPropagation();
  } } }, [e("div", { staticClass: "acv-gallery__control-bar--left" }, [t._t("control-bar-left", function() {
    return [e("span", { staticClass: "acv-gallery__control-bar__back", on: { click: function(n) {
      return n.stopPropagation(), t.handleBackButtonClicked.apply(null, arguments);
    }, keypress: function(n) {
      return !n.type.indexOf("key") && t._k(n.keyCode, "space", 32, n.key, [" ", "Spacebar"]) ? null : (n.stopPropagation(), t.handleBackButtonClicked.apply(null, arguments));
    } } }, [e("acv-icon", { staticClass: "acv-gallery__control acv-gallery__control--back", attrs: { icon: "arrow_back" } }), t._v(" " + t._s(t.mobileBackButtonText) + " ")], 1), t.showImageCount ? e("span", { staticClass: "acv-gallery__control-bar__total" }, [t._v(" " + t._s(t.imagePosition) + " ")]) : t._e()];
  })], 2), e("div", { staticClass: "acv-gallery__control-bar--right" }, [t._t("control-bar-right", function() {
    return t._l(t.controlBarButtons, function(n, s) {
      return e("acv-icon-button", { directives: [{ name: "show", rawName: "v-show", value: n.visibility, expression: "controlButton.visibility" }], key: s, ref: `control-button-${n.key}`, refInFor: !0, class: [
        "acv-gallery__control",
        `acv-gallery__control--${n.key}`
      ], attrs: { "icon-type": n.icon, disabled: n.disabled }, on: { click: function(r) {
        return r.stopPropagation(), n.action(n.params);
      }, keypress: function(r) {
        return !r.type.indexOf("key") && t._k(r.keyCode, "space", 32, r.key, [" ", "Spacebar"]) ? null : (r.stopPropagation(), n.action(n.params));
      } }, scopedSlots: t._u([n.iconText ? { key: "icon", fn: function() {
        return [e("span", [t._v(t._s(n.iconText))])];
      }, proxy: !0 } : null], null, !0) }, [t._v(" " + t._s(n.message) + " ")]);
    });
  })], 2)]), t.showCategories ? e("acv-gallery-category-bar", { ref: "gallery-category-bar", class: { zoomed: !t.minZoom }, attrs: { categories: t.categories, "show-counts": t.showCounts }, on: { "category-clicked": t.handleCategoryClicked }, nativeOn: { click: function(n) {
    n.stopPropagation();
  }, touchmove: function(n) {
    n.stopPropagation();
  } } }) : t._e(), t.hasMobileListing ? e("acv-gallery-list", { directives: [{ name: "show", rawName: "v-show", value: t.showingMobilePhotoList, expression: "showingMobilePhotoList" }], ref: "gallery-list", attrs: { images: t.images, categories: t.categories, "show-counts": t.showCounts, "categories-key": t.categoriesKey, "no-categories-text": t.noCategoriesText }, on: { "view-photo": t.handleListPhotoClicked, "scrolled-section": t.changeGalleryCategoryBarCategory } }) : t._e(), e("div", { ref: "carousel", staticClass: "acv-gallery__carousel tw-flexbox-row-align-center-justify-center", class: {
    "acv-gallery__carousel--thumbs": t.isShowingThumbnails,
    "acv-gallery__carousel--zoomed": !t.minZoom,
    "acv-gallery__carousel--mobile-listing": t.showingMobilePhotoList,
    "acv-gallery__carousel--full-screen": t.isInFullScreen
  } }, [t.prevImage !== t.index ? e("div", { staticClass: "acv-gallery__carousel__slider__control acv-gallery__carousel__slider__control--prev", on: { click: function(n) {
    return n.stopPropagation(), t.prev.apply(null, arguments);
  }, keypress: function(n) {
    return !n.type.indexOf("key") && t._k(n.keyCode, "space", 32, n.key, [" ", "Spacebar"]) ? null : (n.stopPropagation(), t.prev.apply(null, arguments));
  } } }, [t._t("previous", function() {
    return [t.previousCarouselIcon ? e("acv-icon", { staticClass: "acv-gallery__control acv-gallery__control--prev", attrs: { icon: t.previousCarouselIcon } }) : t._e()];
  })], 2) : t._e(), e("div", { ref: "carousel-slider", staticClass: "acv-gallery__carousel__slider", class: {
    "has-categories": t.hasCategories && t.showCategories,
    "full-screen": t.isInFullScreen,
    thumbs: t.isShowingThumbnails
  }, style: t.sliderStyles }, [t.images[t.prevImage] ? e("img", { ref: "carousel-previous-image", staticClass: "acv-gallery__carousel__slider__image acv-gallery__carousel__slider__image--prev", style: t.prevImageStyles, attrs: { src: t.images[t.prevImage].src || t.images[t.prevImage] || "", alt: t.images[t.prevImage].alt || t.images[t.prevImage].caption || "" } }) : t._e(), t.images[t.index] ? e("img", { ref: "carousel-image", staticClass: "acv-gallery__carousel__slider__image acv-gallery__carousel__slider__image--current", class: { panning: t.panning }, style: t.imageStyles, attrs: { src: t.images[t.index].src || t.images[t.index] || "", alt: t.images[t.index].alt || t.images[t.index].caption || "", tabindex: "0" } }) : t._e(), t.images[t.nextImage] ? e("img", { ref: "carousel-next-image", staticClass: "acv-gallery__carousel__slider__image acv-gallery__carousel__slider__image--next", style: t.nextImageStyles, attrs: { src: t.images[t.nextImage].src || t.images[t.nextImage] || "", alt: t.images[t.nextImage].alt || t.images[t.nextImage].caption || "" } }) : t._e(), t.hasTransitionImage ? e("img", { staticClass: "acv-gallery__carousel__slider__image acv-gallery__carousel__slider__image--transition", style: t.transitionImage.style, attrs: { src: t.transitionImage.src, alt: t.transitionImage.alt || t.transitionImage.caption || "" } }) : t._e()]), t.showCategories ? e("acv-scrollbar", { staticClass: "acv-gallery__carousel__categories", on: { click: function(n) {
    n.stopPropagation();
  } } }, [t._t("categories", function() {
    return t._l(t.categories, function(n, s) {
      return e("p", { key: s, staticClass: "tw-flexbox-row-align-center-justify-between", class: [
        "acv-gallery__carousel__categories__category",
        s,
        t.isActiveCategory(s) ? "acv-gallery__carousel__categories__category--active" : ""
      ], on: { click: function(r) {
        return r.stopPropagation(), t.handleCategoryClicked(s);
      }, keypress: function(r) {
        return !r.type.indexOf("key") && t._k(r.keyCode, "space", 32, r.key, [" ", "Spacebar"]) ? null : (r.stopPropagation(), t.handleCategoryClicked(s));
      } } }, [e("span", [t._v(t._s(s))]), t.showCounts ? e("span", [t._v(" " + t._s(n) + " ")]) : t._e()]);
    });
  })], 2) : t._e(), !t.showingMobilePhotoList && t.showCaption ? [t._t("caption", function() {
    return [t.images[t.index].caption || t.getPlacementInCategory(t.images[t.index]) ? e("div", { staticClass: "acv-gallery__carousel__caption" }, [t.images[t.index].caption ? e("h6", { staticClass: "acv-gallery__carousel__caption__description" }, [t._v(" " + t._s(t.images[t.index].caption) + " ")]) : t._e(), t.getPlacementInCategory(t.images[t.index]) ? e("span", { staticClass: "acv-gallery__carousel__caption__placement" }, [t._v(" " + t._s(t.getPlacementInCategory(t.images[t.index])) + " ")]) : t._e()]) : t._e()];
  })] : t._e(), t.nextImage !== t.index ? e("div", { staticClass: "acv-gallery__carousel__slider__control acv-gallery__carousel__slider__control--next", on: { click: function(n) {
    return n.stopPropagation(), t.next.apply(null, arguments);
  }, keypress: function(n) {
    return !n.type.indexOf("key") && t._k(n.keyCode, "space", 32, n.key, [" ", "Spacebar"]) ? null : (n.stopPropagation(), t.next.apply(null, arguments));
  } } }, [t._t("next", function() {
    return [t.nextCarouselIcon ? e("acv-icon", { staticClass: "acv-gallery__control acv-gallery__control--next", attrs: { icon: t.nextCarouselIcon } }) : t._e()];
  })], 2) : t._e()], 2), t.showingMobilePhotoList ? t._e() : [e("transition", { attrs: { name: "slide-up" } }, [e("div", { directives: [{ name: "show", rawName: "v-show", value: t.isShowingThumbnails, expression: "isShowingThumbnails" }], ref: "thumbnails", staticClass: "acv-gallery__thumbs", on: { click: function(n) {
    n.stopPropagation();
  }, touchmove: function(n) {
    n.stopPropagation();
  }, wheel: function(n) {
    n.stopPropagation();
  } } }, [t.images.length > 1 && t.previousThumbnailIcon ? e("acv-icon-button", { staticClass: "acv-gallery__thumbs__control acv-gallery__thumbs__control--prev", attrs: { "icon-type": t.previousThumbnailIcon, "show-tooltip": !1 }, on: { click: t.prev, keypress: function(n) {
    return !n.type.indexOf("key") && t._k(n.keyCode, "space", 32, n.key, [" ", "Spacebar"]) ? null : (n.stopPropagation(), t.prev.apply(null, arguments));
  } } }) : t._e(), t._l(t.images, function(n, s) {
    return e("img", { key: s, ref: "thumbnail-item", refInFor: !0, staticClass: "acv-gallery__thumbs__item", class: { "acv-gallery__thumbs__item--active": s === t.index }, attrs: { loading: "lazy", src: n.thumbnail || n.src || n || "", alt: t.images[s].alt || t.images[s].caption || "" }, on: { click: function(r) {
      return r.stopPropagation(), t.goto(s);
    }, keypress: function(r) {
      return !r.type.indexOf("key") && t._k(r.keyCode, "space", 32, r.key, [" ", "Spacebar"]) ? null : (r.stopPropagation(), t.goto(s));
    } } });
  }), t.images.length > 1 && t.nextThumbnailIcon ? e("acv-icon-button", { staticClass: "acv-gallery__thumbs__control acv-gallery__thumbs__control--next", attrs: { "icon-type": t.nextThumbnailIcon, "show-tooltip": !1 }, on: { click: t.next, keypress: function(n) {
    return !n.type.indexOf("key") && t._k(n.keyCode, "space", 32, n.key, [" ", "Spacebar"]) ? null : (n.stopPropagation(), t.next.apply(null, arguments));
  } } }) : t._e()], 2)])]], 2) : t._e()]);
}, Ob = [], Mb = /* @__PURE__ */ U(
  wb,
  kb,
  Ob,
  !1,
  null,
  "379b504b"
);
const Tb = Mb.exports, Db = (i) => {
  i.classList.add("loading");
}, Pb = (i) => {
  i.classList.remove("loading");
}, zh = (i, t) => {
  t.value ? Db(i) : Pb(i);
}, Lb = (i, t) => {
  i.classList.add("shimmer"), zh(i, t);
}, Ib = {
  bind: Lb,
  update: zh
}, Eb = {
  shimmer: Ib
}, $b = {
  shimmerLoading: {
    type: Boolean,
    default: !1
  }
}, Bb = {
  directives: Eb,
  props: $b
}, Rb = {
  name: "AcvTable",
  mixins: [
    Bb
  ],
  props: {
    rows: {
      type: [Array, Object],
      default: () => []
    },
    numberOfLoadingRows: {
      type: Number,
      default: 3
    },
    shimmerLoading: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    displayRows() {
      return this.shimmerLoading ? [...new Array(this.numberOfLoadingRows)] : this.rows;
    }
  }
};
var Fb = function() {
  var t = this, e = t._self._c;
  return e("table", { staticClass: "acv-table table table-striped" }, [e("tbody", t._l(t.displayRows, function(n, s) {
    return e("tr", { key: n && n.id ? n.id : s }, [t._t("row", function() {
      return [e("td", { directives: [{ name: "shimmer", rawName: "v-shimmer", value: t.shimmerLoading, expression: "shimmerLoading" }] }, [e("div", [t._v(" " + t._s(n || " ") + " ")])])];
    }, { row: n, idx: s })], 2);
  }), 0)]);
}, Nb = [], Hb = /* @__PURE__ */ U(
  Rb,
  Fb,
  Nb,
  !1,
  null,
  "bf22c5b6"
);
const Vb = Hb.exports, zb = {
  name: "AcvLightbox",
  components: {
    AcvIcon: ie,
    AcvIconButton: Ee,
    AcvScrollbar: ka
  },
  directives: {
    dragged: $h
  },
  model: {
    prop: "index",
    event: "change"
  },
  props: {
    /**
     * Images to be displayed in carousel and thumbnails<br/>
     * Each image can be a string of the url or an object of the following properties:<br/>
     * `src` - image url<br/>
     * `thumbnail` - thumbnail url. If omitted, the src will be used<br/>
     * `caption` - caption text to be overlayed on the image<br/>
     * `alt` - alt text. If omitted, the caption will be used<br/>
     * `category` - category. If omitted, the `noCategoriesText` will be used<br/>
     */
    images: {
      type: Array,
      required: !0
    },
    /**
     * The inherited v-model for the index of the image to be opened in the carousel
     */
    index: {
      type: Number,
      default: null
    },
    /**
    * Shows the full screen or thumbnail view on initial load
    */
    defaultView: {
      type: String,
      validator: (i) => wt(i, ["fullScreen", "thumbnails"]),
      default: "fullScreen"
    },
    /**
     * Determines whether to show images in the thumbnails
     */
    thumbnails: {
      type: Boolean,
      default: !0
    },
    /**
    * Enables zooming and panzooming on the current image
    */
    zoom: {
      type: Boolean,
      default: !0
    },
    /**
    * Show the image count based on image being viewed out of total images
    */
    showImageCount: {
      type: Boolean,
      default: !0
    },
    /**
     * Indicates whether the images carousel should loop around itself
     */
    loop: {
      type: Boolean,
      default: !0
    },
    /**
    * Enables drag horizontally for navigation
    */
    dragToNavigate: {
      type: Boolean,
      default: !0
    },
    /**
    * Enables drag vertically to close
    */
    dragToClose: {
      type: Boolean,
      default: !0
    },
    /**
    * Vertical drag threshold to close the lightbox with dragToClose enabled
    */
    verticalDragThreshold: {
      type: Number,
      default: 80
    },
    /**
    * Horizontal drag threshold for carousel navigation with dragToNavigate enabled
    */
    horizontalDragThreshold: {
      type: Number,
      default: 100
    },
    /**
    * Allows clicking the image to go to the next image
    * Disables clicking the image to zoom and panzoom
    */
    clickToNext: {
      type: Boolean,
      default: !1
    },
    /**
    * Allows a caption to be shown for the current image
    */
    showCaption: {
      type: Boolean,
      default: !0
    },
    /**
    * Shows categories of images based on similar keys
    */
    showCategories: {
      type: Boolean,
      default: !1
    },
    /**
    * Determines the unique category key to generate unique category
    */
    categoriesKey: {
      type: String,
      default: "category"
    },
    /**
    * Shows the counts for the categories based on the provided image keys
    */
    showCategoryCounts: {
      type: Boolean,
      default: !0
    },
    /**
    * Text to show for images that have no category
    */
    noCategoriesText: {
      type: String,
      default: "additional"
    },
    /**
    * Menu icon for categories menu on mobile
    */
    menuIcon: {
      type: String,
      default: "menu"
    },
    /**
    * Zoom in icon to zoom in on a full screen image
    */
    zoomInIcon: {
      type: String,
      default: "zoom_in"
    },
    /**
    * Zoom out icon to zoom out on a full screen image
    */
    zoomOutIcon: {
      type: String,
      default: "zoom_out"
    },
    /**
    * FullScreen icon to full screen the carousel image, hiding the thumbnails
    */
    fullScreenIcon: {
      type: String,
      default: "fullscreen"
    },
    /**
    * Shrink icon to shrink a carousel image, showing the thumbnails
    */
    shrinkIcon: {
      type: String,
      default: "compress"
    },
    /**
    * Close icon to close the lightbox
    */
    closeIcon: {
      type: String,
      default: "close"
    },
    /**
    * Icon denoting previous image navigation in carousel
    */
    previousCarouselIcon: {
      type: String,
      default: "arrow_back"
    },
    /**
    * Icon denoting next image navigation in carousel
    */
    nextCarouselIcon: {
      type: String,
      default: "arrow_forward"
    },
    /**
    * Icon denoting previous image navigation in thumbnails
    */
    previousThumbnailIcon: {
      type: String,
      default: "chevron_left"
    },
    /**
    * Icon denoting next image navigation in thumbnails
    */
    nextThumbnailIcon: {
      type: String,
      default: "chevron_right"
    }
  },
  data() {
    return {
      viewBeingShown: this.defaultView,
      showingMobileCategoriesMenu: !1,
      wrapperStyles: {},
      sliderStyles: {},
      prevImageStyles: {},
      imageStyles: {},
      nextImageStyles: {},
      transitionImage: {},
      dragging: !1,
      dragCoords: {
        x: 0,
        y: 0,
        lockX: !1,
        lockY: !1
      },
      panning: !1,
      panZoomInstance: null,
      panZoomOptions: {
        maxScale: 1.5,
        minScale: 1,
        step: 0.5,
        contain: "outside",
        panOnlyWhenZoomed: !0,
        overflow: "visible"
      },
      zoomFactor: null,
      panZoomCoords: {
        x: 0,
        y: 0
      }
    };
  },
  computed: {
    isOpen() {
      return this.index !== null;
    },
    prevImage() {
      return this.index > 0 ? this.index - 1 : this.loop ? this.images.length - 1 : this.index;
    },
    nextImage() {
      return this.index < this.images.length - 1 ? this.index + 1 : this.loop ? 0 : this.index;
    },
    imagePosition() {
      return `${this.index + 1}/${this.images.length}`;
    },
    hasTransitionImage() {
      return Object.keys(this.transitionImage).length;
    },
    categories() {
      if (this.showCategories) {
        const i = {};
        return this.images.forEach((t) => {
          const e = t[this.categoriesKey] || this.noCategoriesText;
          i[e] ? i[e] += 1 : i[e] = 1;
        }), i;
      }
      return !1;
    },
    isShowingCategories() {
      return this.categories ? this.checkIsMobile() ? this.showingMobileCategoriesMenu : !this.maxZoom : !1;
    },
    isInFullScreen() {
      return this.viewBeingShown === "fullScreen";
    },
    isShowingThumbnails() {
      return this.viewBeingShown === "thumbnails";
    },
    maxZoom() {
      return this.zoomFactor >= this.panZoomOptions.maxScale;
    },
    minZoom() {
      return this.zoomFactor <= this.panZoomOptions.minScale;
    },
    hasLockedDirection() {
      return this.dragCoords.lockX || this.dragCoords.lockY;
    },
    controlBarButtons() {
      return [
        {
          visibility: this.showCategories,
          icon: this.menuIcon,
          key: "menu",
          message: "Show Categories",
          action: this.handleCategoriesMenuClicked
        },
        {
          visibility: this.zoom && this.isInFullScreen && this.zoomInIcon,
          icon: this.zoomInIcon,
          key: "zoom-in",
          message: "Zoom In",
          disabled: this.maxZoom,
          action: this.handleZoomButtonClick,
          params: "in"
        },
        {
          visibility: this.zoom && this.isInFullScreen && this.zoomOutIcon,
          icon: this.zoomOutIcon,
          key: "zoom-out",
          message: "Zoom Out",
          disabled: this.minZoom,
          action: this.handleZoomButtonClick,
          params: "out"
        },
        {
          visibility: this.isInFullScreen && this.thumbnails && this.shrinkIcon || this.isShowingThumbnails && this.fullScreenIcon,
          icon: this.isInFullScreen ? this.shrinkIcon : this.fullScreenIcon,
          key: "view",
          message: this.isInFullScreen ? "Show Thumbnails" : "Expand",
          action: this.setLightboxView,
          params: this.isInFullScreen ? "thumbnails" : "fullScreen"
        },
        {
          visibility: this.closeIcon,
          icon: this.closeIcon,
          key: "close",
          message: "Close",
          action: this.close
        }
      ];
    }
  },
  watch: {
    isOpen(i) {
      i ? (document.activeElement && document.activeElement.blur(), this.setupListeners(), this.determineAdjacentImageStyles(), this.$emit("open", this.index), Lt() && (document.querySelector("body").style.touchAction = "pan-x pan-y", this.isInFullScreen && this.zoom && this.instantiatePanzoom())) : (Lt() && (document.querySelector("body").style.touchAction = ""), this.removeListeners(), this.teardownPanzoom(), this.resetDefaults());
    },
    index(i, t) {
      Lt() && this.resetPanzoom(), this.isShowingThumbnails && i !== null && i !== t && this.scrollThumbnailIntoView();
    },
    viewBeingShown() {
      this.zoom && (this.isShowingThumbnails && (this.resetPanzoom(), this.teardownPanzoom(), this.scrollThumbnailIntoView()), this.isInFullScreen && Lt() && this.instantiatePanzoom());
    },
    thumbnails(i, t) {
      !i && t && this.isShowingThumbnails && this.setLightboxView("fullScreen");
    },
    zoomFactor() {
      this.zoom && !this.clickToNext && (this.minZoom ? this.imageStyles = {
        ...this.imageStyles,
        cursor: "zoom-in"
      } : this.imageStyles = {
        ...this.imageStyles,
        cursor: "zoom-out"
      });
    }
  },
  beforeDestroy() {
    this.removeListeners(), this.teardownPanzoom();
  },
  created() {
    this.zoomFactor = this.panZoomOptions.minScale;
  },
  methods: {
    checkIsMobile() {
      return ["tw-sm", "tw-md"].includes(this.$tailwindHelper.getCurrentBreakpoint().key);
    },
    setLightboxView(i) {
      this.$refs["control-button-view"] && this.$refs["control-button-view"][0].setNotVisibleTooltip(), this.viewBeingShown = i, this.$emit("full-screen-toggled", this.isInFullScreen);
    },
    setupListeners() {
      window.addEventListener("keyup", this.keyup), window.addEventListener("resize", this.handleResize);
    },
    removeListeners() {
      window.removeEventListener("keyup", this.keyup), window.removeEventListener("resize", this.handleResize), this.$refs["carousel-image"] && (this.$refs["carousel-image"].removeEventListener("panzoomstart", this.handlePanZoomStart), this.$refs["carousel-image"].removeEventListener("panzoompan", this.handlePanZoomMove), this.$refs["carousel-image"].removeEventListener("panzoomend", this.handlePanZoomEnd));
    },
    close() {
      if (!this.showingMobileCategoriesMenu) {
        const i = this.index;
        this.goto(null), this.$emit("close", i);
      }
    },
    prev() {
      this.$emit("prev", this.prevImage), this.goto(this.prevImage);
    },
    next() {
      this.$emit("next", this.nextImage), this.goto(this.nextImage);
    },
    goto(i) {
      this.$emit("change", i);
    },
    keyup(i) {
      ["ArrowRight", "Space"].includes(i.code) || ["ArrowRight", "Right", "Space"].includes(i.key) || [39, 32].includes(i.keyCode) ? this.next() : i.code === "ArrowLeft" || ["ArrowLeft", "Left"].includes(i.key) || i.keyCode === 37 ? this.prev() : (i.code === "Escape" || ["Escape", "Esc"].includes(i.key) || i.keyCode === 27) && this.close();
    },
    scrollThumbnailIntoView() {
      this.$nextTick(() => {
        var e;
        const { thumbnails: i } = this.$refs, t = (e = this.$refs["thumbnail-item"]) == null ? void 0 : e[this.index];
        if (i && t)
          if (t.offsetLeft + t.clientWidth / 2 > window.innerWidth / 2) {
            const n = t.offsetLeft - window.innerWidth / 2;
            n < i.scrollWidth ? i.scrollLeft = n + t.clientWidth / 2 : i.scrollLeft = i.scrollWidth;
          } else
            i.scrollLeft = 0;
      });
    },
    onDragged({
      evt: i,
      offsetX: t,
      offsetY: e,
      first: n,
      last: s
    }) {
      var r;
      if (i.stopPropagation(), ![2, 3].includes(i.which)) {
        if (Lt() && this.panZoomInstance && this.zoom && ((r = i == null ? void 0 : i.touches) == null ? void 0 : r.length) > 1) {
          this.zoomFactor = this.panZoomInstance.getScale().toFixed(2), this.resetDrag(), this.minZoom && this.resetPanzoom();
          return;
        }
        if (!this.showingMobileCategoriesMenu && this.minZoom) {
          if (n) {
            this.dragStart(i);
            return;
          }
          if (s) {
            this.dragging && this.dragEnd(i);
            return;
          }
          this.dragging && this.dragMove(i, t, e);
        }
      }
    },
    dragStart() {
      this.dragging = !0, this.wrapperStyles = {
        ...this.wrapperStyles,
        cursor: "grab"
      }, this.prevImageStyles = {
        ...this.prevImageStyles,
        opacity: 1
      }, this.nextImageStyles = {
        ...this.nextImageStyles,
        opacity: 1
      };
    },
    dragMove(i, t, e) {
      this.wrapperStyles = {
        ...this.wrapperStyles,
        cursor: "grabbing"
      }, this.dragCoords.x = t, this.dragCoords.y = e;
      const n = Math.abs(t), s = Math.abs(e);
      this.hasLockedDirection || (this.dragToNavigate && n >= s && s < n ? this.dragCoords.lockX = !0 : this.dragToClose && s > n && n < s && (this.dragCoords.lockY = !0));
      let r;
      if (this.dragToNavigate && this.dragCoords.lockX)
        r = `translate(${t}px, 0px)`;
      else if (this.dragToClose && this.dragCoords.lockY && (r = `translate(0px, ${e}px)`, s > this.verticalDragThreshold)) {
        let a = 100 - s + this.verticalDragThreshold;
        a <= 0 ? a = 0 : a >= 100 && (a = 100), this.wrapperStyles = {
          ...this.wrapperStyles,
          opacity: `${a}%`
        };
      }
      r && (this.sliderStyles = {
        ...this.sliderStyles,
        transform: r
      });
    },
    dragEnd(i) {
      this.dragging = !1, this.wrapperStyles = {
        ...this.wrapperStyles,
        cursor: "grab"
      }, this.dragToClose && this.dragCoords.lockY && Math.abs(this.dragCoords.y) > this.verticalDragThreshold ? this.close() : !this.dragCoords.x && !this.dragCoords.y ? i.target.classList.contains("acv-lightbox__carousel") ? this.close() : i.target.classList.contains("acv-lightbox__carousel__slider__image--current") && (this.clickToNext ? this.next() : this.isShowingThumbnails ? this.setLightboxView("fullScreen") : !Lt() && this.zoom && (this.panZoomInstance || this.instantiatePanzoom(), setTimeout(() => {
        this.handleCarouselImageClick(i);
      }, 10))) : this.dragToNavigate && (this.dragCoords.lockX && this.dragCoords.x > this.horizontalDragThreshold ? this.determineSliderNavigation("prev") : this.dragCoords.lockX && this.dragCoords.x < -this.horizontalDragThreshold ? this.determineSliderNavigation("next") : this.sliderStyles = {}), this.resetDrag();
    },
    resetDrag() {
      setTimeout(() => {
        this.wrapperStyles = {}, this.dragCoords.lockX = !1, this.dragCoords.lockY = !1, this.dragCoords.x = 0, this.dragCoords.y = 0;
      }, 50);
    },
    determineSliderNavigation(i) {
      if (!this.loop && (this.nextImage === this.index && i === "next" || this.prevImage === this.index && i === "prev")) {
        this.sliderStyles = {};
        return;
      }
      const [{ x: { value: t } }] = this.$refs["carousel-slider"].attributeStyleMap.get("transform");
      let e = Math.abs(t);
      for (; e < this.$refs.lightbox.clientWidth; ) {
        e += 1;
        const s = `translate(${i === "prev" ? e : -e}px, 0px)`;
        this.sliderStyles = {
          ...this.sliderStyles,
          transform: s,
          transitionDuration: "300ms"
        };
      }
      let n;
      i === "next" ? n = this.images[this.nextImage] : i === "prev" && (n = this.images[this.prevImage]), this.transitionImage = {
        src: n.src || n,
        caption: n.caption || n.alt,
        style: {
          zIndex: 1,
          transform: `translate(${i === "prev" ? -e : e}px, 0px)`
        }
      }, setTimeout(() => {
        this[i](), this.prevImageStyles = {
          ...this.prevImageStyles,
          opacity: 0
        }, this.nextImageStyles = {
          ...this.nextImageStyles,
          opacity: 0
        }, setTimeout(() => {
          this.sliderStyles = {
            ...this.sliderStyles,
            transform: "translate(0px, 0px)",
            transitionDuration: "0ms"
          }, this.transitionImage = {};
        }, 150);
      }, 285);
    },
    determineAdjacentImageStyles() {
      this.$nextTick(() => {
        if (this.$refs.lightbox) {
          const { clientWidth: i } = this.$refs.lightbox, t = this.checkIsMobile() ? this.horizontalDragThreshold / 2 : 0;
          if (this.$refs["carousel-previous-image"]) {
            const { width: e } = this.$refs["carousel-previous-image"], n = this.calculateAdjacentImageTranslation(e, i);
            this.prevImageStyles = {
              ...this.prevImageStyles,
              transform: `translate(${-(n + t)}px, 0px)`
            };
          }
          if (this.$refs["carousel-next-image"]) {
            const { width: e } = this.$refs["carousel-next-image"], n = this.calculateAdjacentImageTranslation(e, i);
            this.nextImageStyles = {
              ...this.nextImageStyles,
              transform: `translate(${n + t}px, 0px)`
            };
          }
        }
      });
    },
    calculateAdjacentImageTranslation(i, t) {
      let e;
      return i >= t || t + i >= t ? e = t : e = t + i, e;
    },
    handleResize(i) {
      this.determineAdjacentImageStyles(), this.showingMobileCategoriesMenu && (this.showingMobileCategoriesMenu = !1), this.$emit("resize", i);
    },
    handleCategoryClicked(i) {
      const t = this.images.findIndex((e) => e[this.categoriesKey] === (i === this.noCategoriesText ? void 0 : i));
      t > -1 && (this.goto(t), this.$emit("category-clicked", i), this.showingMobileCategoriesMenu && setTimeout(() => {
        this.showingMobileCategoriesMenu = !1, this.scrollThumbnailIntoView();
      }, 50));
    },
    handleCategoriesMenuClicked() {
      this.showingMobileCategoriesMenu = !this.showingMobileCategoriesMenu, this.$emit("mobile-categories-menu-toggled", this.showingMobileCategoriesMenu);
    },
    isActiveCategory(i) {
      return this.images[this.index][this.categoriesKey] === (i === this.noCategoriesText ? void 0 : i);
    },
    toggleZoom(i, t = null) {
      let e;
      i === "in" && this.minZoom ? e = this.panZoomOptions.maxScale : i === "out" && this.maxZoom && (e = this.panZoomOptions.minScale), e && (t ? this.panZoomInstance.zoomToPoint(e, t, { animate: !0 }) : this.panZoomInstance.zoom(e, { animate: !0 }), e === this.panZoomOptions.minScale ? (this.resetPanzoom(), this.teardownPanzoom()) : this.zoomFactor = e, this.$emit(`zoom-${i}`, this.images[this.index]));
    },
    handleZoomButtonClick(i) {
      this.panZoomInstance || this.instantiatePanzoom(), setTimeout(() => {
        this.toggleZoom(i);
      }, 10);
    },
    handleCarouselImageClick(i) {
      this.minZoom ? this.toggleZoom("in", i) : this.maxZoom && this.toggleZoom("out", i);
    },
    instantiatePanzoom() {
      this.$nextTick(() => {
        this.$refs["carousel-image"] && (this.panZoomInstance = Tl(this.$refs["carousel-image"], this.panZoomOptions), this.$refs["carousel-image"].addEventListener("panzoomstart", this.handlePanZoomStart), this.$refs["carousel-image"].addEventListener("panzoompan", this.handlePanZoomMove), this.$refs["carousel-image"].addEventListener("panzoomend", this.handlePanZoomEnd));
      });
    },
    handlePanZoomStart(i) {
      const { x: t, y: e } = i.detail;
      this.panZoomCoords.x = t, this.panZoomCoords.y = e;
    },
    handlePanZoomMove() {
      this.panning = !0, this.imageStyles = {
        ...this.imageStyles,
        cursor: "grabbing"
      };
    },
    handlePanZoomEnd(i) {
      const { x: t, y: e } = i.detail;
      this.panning = !1, this.imageStyles = {
        ...this.imageStyles,
        cursor: "zoom-out"
      }, this.panZoomCoords.x === t && this.panZoomCoords.y === e && (Lt() || this.handleCarouselImageClick(i.detail));
    },
    resetPanzoom() {
      this.panZoomInstance && (this.panZoomInstance.reset(), this.panZoomInstance.resetStyle(), this.zoomFactor = this.panZoomOptions.minScale);
    },
    teardownPanzoom() {
      this.panZoomInstance && (this.panZoomInstance.destroy(), this.panZoomInstance = null);
    },
    resetDefaults() {
      this.viewBeingShown = this.defaultView, this.showingMobileCategoriesMenu = !1, this.wrapperStyles = {}, this.sliderStyles = {}, this.prevImageStyles = {}, this.imageStyles = {}, this.nextImageStyles = {}, this.transitionImage = {}, this.dragging = !1, this.dragCoords = {
        x: 0,
        y: 0,
        lockX: !1,
        lockY: !1
      }, this.panning = !1, this.panZoomOptions = {
        maxScale: 1.5,
        minScale: 1,
        step: 0.5,
        contain: "outside",
        panOnlyWhenZoomed: !0,
        overflow: "visible"
      }, this.zoomFactor = this.panZoomOptions.minScale, this.panZoomCoords = {
        x: 0,
        y: 0
      };
    }
  }
};
var jb = function() {
  var t = this, e = t._self._c;
  return e("transition", { attrs: { name: "fade" } }, [t.isOpen ? e("div", { directives: [{ name: "dragged", rawName: "v-dragged", value: t.onDragged, expression: "onDragged" }], ref: "lightbox", staticClass: "acv-lightbox", style: t.wrapperStyles, on: { wheel: function(n) {
    n.preventDefault();
  }, touchmove: function(n) {
    n.preventDefault();
  } } }, [e("div", { ref: "carousel", staticClass: "acv-lightbox__carousel tw-flexbox-row-align-center-justify-center", class: {
    "acv-lightbox__carousel--thumbs": t.isShowingThumbnails,
    "acv-lightbox__carousel--max-zoom": t.maxZoom,
    "acv-lightbox__carousel--full-screen": t.isInFullScreen,
    "acv-lightbox__carousel--mobile-menu": t.showingMobileCategoriesMenu
  } }, [e("div", { staticClass: "acv-lightbox__carousel__bar", on: { click: function(n) {
    n.stopPropagation();
  } } }, [e("div", { staticClass: "acv-lightbox__carousel__bar--left" }, [t._t("control-bar-left", function() {
    return [t.showingMobileCategoriesMenu ? [e("span", { staticClass: "acv-lightbox__carousel__bar__back", on: { click: function(n) {
      return n.stopPropagation(), t.handleCategoriesMenuClicked.apply(null, arguments);
    }, keypress: function(n) {
      return !n.type.indexOf("key") && t._k(n.keyCode, "space", 32, n.key, [" ", "Spacebar"]) ? null : (n.stopPropagation(), t.handleCategoriesMenuClicked.apply(null, arguments));
    } } }, [e("acv-icon", { staticClass: "acv-lightbox__carousel__control acv-lightbox__carousel__control--back", attrs: { icon: "arrow_back" } }), t._v(" Back to Gallery ")], 1)] : t.showImageCount ? [e("span", [t._v(t._s(t.imagePosition))])] : t._e()];
  })], 2), e("div", { directives: [{ name: "show", rawName: "v-show", value: !t.showingMobileCategoriesMenu, expression: "!showingMobileCategoriesMenu" }], staticClass: "acv-lightbox__carousel__bar--right" }, [t._t("control-bar-right", function() {
    return t._l(t.controlBarButtons, function(n, s) {
      return e("acv-icon-button", { directives: [{ name: "show", rawName: "v-show", value: n.visibility, expression: "controlButton.visibility" }], key: s, ref: `control-button-${n.key}`, refInFor: !0, class: [
        "acv-lightbox__carousel__control",
        `acv-lightbox__carousel__control--${n.key}`
      ], attrs: { "icon-type": n.icon, disabled: n.disabled }, on: { click: function(r) {
        return r.stopPropagation(), n.action(n.params);
      }, keypress: function(r) {
        return !r.type.indexOf("key") && t._k(r.keyCode, "space", 32, r.key, [" ", "Spacebar"]) ? null : (r.stopPropagation(), n.action(n.params));
      } } }, [t._v(" " + t._s(n.message) + " ")]);
    });
  })], 2)]), t.prevImage !== t.index ? e("div", { staticClass: "acv-lightbox__carousel__slider__control acv-lightbox__carousel__slider__control--prev", on: { click: function(n) {
    return n.stopPropagation(), t.prev.apply(null, arguments);
  }, keypress: function(n) {
    return !n.type.indexOf("key") && t._k(n.keyCode, "space", 32, n.key, [" ", "Spacebar"]) ? null : (n.stopPropagation(), t.prev.apply(null, arguments));
  } } }, [t._t("previous", function() {
    return [t.previousCarouselIcon ? e("acv-icon", { staticClass: "acv-lightbox__carousel__control acv-lightbox__carousel__control--prev", attrs: { icon: t.previousCarouselIcon } }) : t._e()];
  })], 2) : t._e(), e("div", { ref: "carousel-slider", staticClass: "acv-lightbox__carousel__slider", class: {
    "has-categories": t.categories && t.showCategories
  }, style: t.sliderStyles }, [t.images[t.prevImage] ? e("img", { ref: "carousel-previous-image", staticClass: "acv-lightbox__carousel__slider__image acv-lightbox__carousel__slider__image--prev", style: t.prevImageStyles, attrs: { src: t.images[t.prevImage].src || t.images[t.prevImage] || "", alt: t.images[t.prevImage].alt || t.images[t.prevImage].caption || "" } }) : t._e(), t.images[t.index] ? e("img", { ref: "carousel-image", staticClass: "acv-lightbox__carousel__slider__image acv-lightbox__carousel__slider__image--current", class: { panning: t.panning }, style: t.imageStyles, attrs: { src: t.images[t.index].src || t.images[t.index] || "", alt: t.images[t.index].alt || t.images[t.index].caption || "", tabindex: "0" } }) : t._e(), t.images[t.nextImage] ? e("img", { ref: "carousel-next-image", staticClass: "acv-lightbox__carousel__slider__image acv-lightbox__carousel__slider__image--next", style: t.nextImageStyles, attrs: { src: t.images[t.nextImage].src || t.images[t.nextImage] || "", alt: t.images[t.nextImage].alt || t.images[t.nextImage].caption || "" } }) : t._e(), t.hasTransitionImage ? e("img", { staticClass: "acv-lightbox__carousel__slider__image acv-lightbox__carousel__slider__image--transition", style: t.transitionImage.style, attrs: { src: t.transitionImage.src, alt: t.transitionImage.alt || t.transitionImage.caption || "" } }) : t._e()]), t.isShowingCategories ? e("acv-scrollbar", { staticClass: "acv-lightbox__carousel__categories", on: { click: function(n) {
    n.stopPropagation();
  } } }, [t._t("categories", function() {
    return t._l(t.categories, function(n, s) {
      return e("p", { key: s, staticClass: "tw-flexbox-row-align-center-justify-between", class: [
        "acv-lightbox__carousel__categories__category",
        s,
        t.isActiveCategory(s) ? "acv-lightbox__carousel__categories__category--active" : ""
      ], on: { click: function(r) {
        return r.stopPropagation(), t.handleCategoryClicked(s);
      }, keypress: function(r) {
        return !r.type.indexOf("key") && t._k(r.keyCode, "space", 32, r.key, [" ", "Spacebar"]) ? null : (r.stopPropagation(), t.handleCategoryClicked(s));
      } } }, [e("span", [t._v(t._s(s))]), t.showCategoryCounts ? e("span", [t._v(" " + t._s(n) + " ")]) : t._e()]);
    });
  })], 2) : t._e(), t.showCaption && !t.maxZoom ? [t._t("caption", function() {
    return [t.images[t.index].caption ? e("span", { staticClass: "acv-lightbox__carousel__caption" }, [t._v(" " + t._s(t.images[t.index].caption) + " ")]) : t._e()];
  })] : t._e(), t.nextImage !== t.index ? e("div", { staticClass: "acv-lightbox__carousel__slider__control acv-lightbox__carousel__slider__control--next", on: { click: function(n) {
    return n.stopPropagation(), t.next.apply(null, arguments);
  }, keypress: function(n) {
    return !n.type.indexOf("key") && t._k(n.keyCode, "space", 32, n.key, [" ", "Spacebar"]) ? null : (n.stopPropagation(), t.next.apply(null, arguments));
  } } }, [t._t("next", function() {
    return [t.nextCarouselIcon ? e("acv-icon", { staticClass: "acv-lightbox__carousel__control acv-lightbox__carousel__control--next", attrs: { icon: t.nextCarouselIcon } }) : t._e()];
  })], 2) : t._e()], 2), e("transition", { attrs: { name: "slide-up" } }, [e("div", { directives: [{ name: "show", rawName: "v-show", value: t.isShowingThumbnails, expression: "isShowingThumbnails" }], ref: "thumbnails", staticClass: "acv-lightbox__thumbs", on: { click: function(n) {
    n.stopPropagation();
  }, touchmove: function(n) {
    n.stopPropagation();
  }, wheel: function(n) {
    n.stopPropagation();
  } } }, [t.images.length > 1 && t.previousThumbnailIcon ? e("acv-icon-button", { staticClass: "acv-lightbox__thumbs__control acv-lightbox__thumbs__control--prev", attrs: { "icon-type": t.previousThumbnailIcon, "show-tooltip": !1 }, on: { click: t.prev, keypress: function(n) {
    return !n.type.indexOf("key") && t._k(n.keyCode, "space", 32, n.key, [" ", "Spacebar"]) ? null : (n.stopPropagation(), t.prev.apply(null, arguments));
  } } }) : t._e(), t._l(t.images, function(n, s) {
    return e("img", { key: s, ref: "thumbnail-item", refInFor: !0, staticClass: "acv-lightbox__thumbs__item", class: { "acv-lightbox__thumbs__item--active": s === t.index }, attrs: { loading: "lazy", src: n.thumbnail || n.src || n || "", alt: t.images[s].alt || t.images[s].caption || "" }, on: { click: function(r) {
      return r.stopPropagation(), t.goto(s);
    }, keypress: function(r) {
      return !r.type.indexOf("key") && t._k(r.keyCode, "space", 32, r.key, [" ", "Spacebar"]) ? null : (r.stopPropagation(), t.goto(s));
    } } });
  }), t.images.length > 1 && t.nextThumbnailIcon ? e("acv-icon-button", { staticClass: "acv-lightbox__thumbs__control acv-lightbox__thumbs__control--next", attrs: { "icon-type": t.nextThumbnailIcon, "show-tooltip": !1 }, on: { click: t.next, keypress: function(n) {
    return !n.type.indexOf("key") && t._k(n.keyCode, "space", 32, n.key, [" ", "Spacebar"]) ? null : (n.stopPropagation(), t.next.apply(null, arguments));
  } } }) : t._e()], 2)])], 1) : t._e()]);
}, Wb = [], Yb = /* @__PURE__ */ U(
  zb,
  jb,
  Wb,
  !1,
  null,
  "809e3414"
);
const jh = Yb.exports, Ub = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: jh
}, Symbol.toStringTag, { value: "Module" })), Zb = {
  name: "AcvListItemIcon",
  mixins: [
    en,
    fe
  ]
};
var Gb = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "acv-list-item-icon", class: t.fontClasses, style: [t.fontStyles, t.sizeStyles] }, [t._t("default")], 2);
}, Kb = [], Xb = /* @__PURE__ */ U(
  Zb,
  Gb,
  Kb,
  !1,
  null,
  "4e71849f"
);
const Qb = Xb.exports, Jb = {
  name: "AcvListItemSubtitle",
  mixins: [
    en,
    fe
  ]
};
var qb = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "acv-list-item-subtitle", class: t.fontClasses, style: [t.fontStyles, t.sizeStyles] }, [t._t("default")], 2);
}, ty = [], ey = /* @__PURE__ */ U(
  Jb,
  qb,
  ty,
  !1,
  null,
  "5734860a"
);
const iy = ey.exports, ny = {
  name: "AcvListItemTitle",
  mixins: [
    en,
    fe
  ]
};
var sy = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "acv-list-item-title", class: t.fontClasses, style: [t.fontStyles, t.sizeStyles] }, [t._t("default")], 2);
}, ry = [], ay = /* @__PURE__ */ U(
  ny,
  sy,
  ry,
  !1,
  null,
  "c555435e"
);
const oy = ay.exports, ly = {
  name: "AcvListButton",
  components: {
    AcvIcon: ie
  },
  props: {
    /**
    * Label shown in the content
    */
    label: {
      type: String,
      default: ""
    },
    /**
    * Subtext shown beneath the label in the content
    */
    subtext: {
      type: String,
      default: ""
    },
    /**
    * Disables the component
    */
    disabled: {
      type: Boolean,
      default: !1
    },
    /**
    * Applies selected classes
    */
    selected: {
      type: Boolean,
      default: !1
    },
    /**
    * Icon shown to the left of the label
    */
    icon: {
      type: String,
      default: ""
    },
    /**
    * Hides right-side content
    */
    hideRight: {
      type: Boolean,
      default: !1
    },
    /**
    * Icon shown on the right side
    */
    rightIcon: {
      type: String,
      default: "chevron_right"
    }
  },
  computed: {
    hasLabel() {
      return !!this.$slots.label || this.label || this.hasIcon;
    },
    hasSubtext() {
      return !!this.$slots.subtext || this.subtext;
    },
    hasIcon() {
      return !!this.$slots.icon || this.icon;
    }
  },
  methods: {
    handleClick() {
      this.disabled || this.$emit("click");
    }
  }
};
var cy = function() {
  var t = this, e = t._self._c;
  return e("li", { staticClass: "acv-list-button", class: {
    selected: t.selected
  }, attrs: { disabled: t.disabled }, on: { click: function(n) {
    return n.preventDefault(), t.handleClick.apply(null, arguments);
  }, keydown: function(n) {
    return !n.type.indexOf("key") && t._k(n.keyCode, "space", 32, n.key, [" ", "Spacebar"]) ? null : (n.preventDefault(), t.handleClick.apply(null, arguments));
  } } }, [e("div", { staticClass: "acv-list-button__content" }, [t.hasLabel ? e("div", { staticClass: "acv-list-button__label" }, [t.hasIcon ? e("div", { staticClass: "acv-list-button__label__icon" }, [t._t("icon", function() {
    return [e("acv-icon", { attrs: { icon: t.icon } })];
  })], 2) : t._e(), t._t("label", function() {
    return [t._v(" " + t._s(t.label) + " ")];
  })], 2) : t._e(), t.hasSubtext ? e("div", { staticClass: "acv-list-button__subtext" }, [t._t("subtext", function() {
    return [e("span", { domProps: { innerHTML: t._s(t.subtext) } })];
  })], 2) : t._e()]), t.hideRight ? t._e() : e("div", { staticClass: "acv-list-button__right" }, [t._t("right", function() {
    return [e("acv-icon", { attrs: { icon: t.rightIcon } })];
  })], 2)]);
}, uy = [], dy = /* @__PURE__ */ U(
  ly,
  cy,
  uy,
  !1,
  null,
  "5a42bb7b"
);
const Wh = dy.exports, hy = {
  name: "AcvListButtonList",
  components: {
    AcvListButton: Wh,
    AcvRadio: Ol,
    AcvCheckbox: ls,
    AcvToggleSwitch: Ph
  },
  model: {
    prop: "modelValue",
    event: "change"
  },
  props: {
    /**
    * Inherited v-model value
    * Multi-select would require this to be an array
    */
    modelValue: {
      type: [String, Number, Boolean, Array, Object],
      default: null
    },
    /**
    * Options to provide to the list button component
    */
    options: {
      type: Array,
      default: () => []
    },
    /**
    * Key for the label on each option
    */
    labelKey: {
      type: String,
      default: "label"
    },
    /**
    * Key for the subtext on each option
    */
    subtextKey: {
      type: String,
      default: "subtext"
    },
    /**
    * Key for the value on each option
    */
    valueKey: {
      type: String,
      default: "value"
    },
    /**
    * Indexes to pre-select options by default
    * Default selections will clear away when existing modelValue
    * Meaning either pre-select options with modelValue or defaultIndexes
    */
    defaultIndexes: {
      type: Array,
      default: () => []
    },
    /**
    * Indexes to disable options by default
    */
    disabledIndexes: {
      type: Array,
      default: () => []
    },
    /**
    * Controls can only be of these types
    * If using radio control, ensure multi-select is false and v-model is not an array
    */
    control: {
      type: String,
      default: "none",
      validator(i) {
        return wt(i, ["none", "radio", "checkbox", "toggle"]);
      }
    },
    /**
    * Allows multi-select when using non-radio controls and an array v-model
    */
    multiSelect: {
      type: Boolean,
      default: !1
    },
    /**
    * Allows the entire option object to be provided within the v-model
    */
    emitOption: {
      type: Boolean,
      default: !1
    }
  },
  data: () => ({
    selections: {}
    // used for control check
  }),
  computed: {
    isRadio() {
      return this.control === "radio";
    },
    hasControl() {
      return !!this.control && this.control !== "none";
    }
  },
  watch: {
    modelValue: {
      immediate: !0,
      handler(i) {
        if (Array.isArray(this.modelValue))
          this.selections = i.reduce((t, e) => {
            const n = t, s = this.emitOption ? e == null ? void 0 : e[this.valueKey] : e;
            return n[s] = this.isRadio ? s : !0, n;
          }, {});
        else {
          const t = this.emitOption ? i == null ? void 0 : i[this.valueKey] : i;
          this.selections = {
            [t]: this.isRadio ? t : !0
          };
        }
      }
    },
    defaultIndexes: {
      immediate: !0,
      handler(i) {
        if (i.length) {
          const t = this.multiSelect && !this.isRadio ? i : [i[0]];
          if (!t.some((e) => !Number.isInteger(e) || e > this.options.length - 1 || e < 0)) {
            const e = [];
            t.forEach((n) => {
              this.isSelected(this.options[n][this.valueKey]) || e.push(this.options[n][this.valueKey]);
            }), e.length && this.emitChange(e);
          }
        }
      }
    }
  },
  methods: {
    isSelected(i) {
      var t;
      return this.emitOption ? Array.isArray(this.modelValue) ? this.modelValue.map((e) => e == null ? void 0 : e[this.valueKey]).includes(i) : ((t = this.modelValue) == null ? void 0 : t[this.valueKey]) === i : Array.isArray(this.modelValue) ? this.modelValue.includes(i) : this.modelValue === i;
    },
    isDisabled(i) {
      return this.disabledIndexes.includes(i);
    },
    determineEmittedValue(i) {
      return this.emitOption ? i.reduce((t, e) => (t.push(this.options.find((n) => n[this.valueKey] === e)), t), []) : i;
    },
    handleSelection(i) {
      var e;
      let t = [];
      if (this.multiSelect && !this.isRadio)
        this.emitOption ? t = Array.isArray(this.modelValue) ? this.modelValue.map((n) => n == null ? void 0 : n[this.valueKey]) : [(e = this.modelValue) == null ? void 0 : e[this.valueKey]] : t = Array.isArray(this.modelValue) ? this.modelValue : [this.modelValue], this.isSelected(i[this.valueKey]) ? t = t.filter((n) => n !== i[this.valueKey]) : t.push(i[this.valueKey]);
      else {
        if (this.isRadio && this.isSelected(i[this.valueKey]))
          return;
        this.isSelected(i[this.valueKey]) ? t = [] : t = [i[this.valueKey]];
      }
      this.emitChange(t);
    },
    emitChange(i) {
      const t = this.determineEmittedValue(i);
      this.multiSelect && Array.isArray(this.modelValue) && !this.isRadio ? this.$emit("change", t) : this.$emit("change", t[0]);
    }
  }
};
var fy = function() {
  var t = this, e = t._self._c;
  return e("ul", { staticClass: "acv-list-button-list" }, t._l(t.options, function(n, s) {
    return e("acv-list-button", t._b({ key: s, class: {
      "has-control": t.hasControl
    }, attrs: { label: n[t.labelKey], subtext: n[t.subtextKey], selected: t.isSelected(n[t.valueKey]), disabled: t.isDisabled(s) }, on: { click: function(r) {
      return t.handleSelection(n);
    } }, scopedSlots: t._u([{ key: "icon", fn: function() {
      return [t._t(`icon-${s}`, null, { option: n })];
    }, proxy: !0 }, { key: "label", fn: function() {
      return [t._t(`label-${s}`, null, { option: n })];
    }, proxy: !0 }, { key: "subtext", fn: function() {
      return [t._t(`subtext-${s}`, null, { option: n })];
    }, proxy: !0 }, { key: "right", fn: function() {
      return [t.control === "radio" ? e("acv-radio", { attrs: { value: n[t.valueKey], label: n[t.labelKey], name: n[t.labelKey], "hide-label": "" }, model: { value: t.selections[n[t.valueKey]], callback: function(r) {
        t.$set(t.selections, n[t.valueKey], r);
      }, expression: "selections[option[valueKey]]" } }) : t.control === "checkbox" ? e("acv-checkbox", { attrs: { value: n[t.valueKey], label: n[t.labelKey], name: n[t.labelKey], "hide-label": "" }, model: { value: t.selections[n[t.valueKey]], callback: function(r) {
        t.$set(t.selections, n[t.valueKey], r);
      }, expression: "selections[option[valueKey]]" } }) : t.control === "toggle" ? e("acv-toggle-switch", { attrs: { value: n[t.valueKey], label: n[t.labelKey], name: n[t.labelKey], "hide-label": "", round: "" }, model: { value: t.selections[n[t.valueKey]], callback: function(r) {
        t.$set(t.selections, n[t.valueKey], r);
      }, expression: "selections[option[valueKey]]" } }) : t._e()];
    }, proxy: !0 }], null, !0) }, "acv-list-button", n, !1));
  }), 1);
}, py = [], gy = /* @__PURE__ */ U(
  hy,
  fy,
  py,
  !1,
  null,
  "d6a974d6"
);
const my = gy.exports, vy = {
  name: "AcvLoadingIndicator",
  props: {
    /**
     * Options: `primary`, `secondary`, `tertiary`, `informational`
     */
    variant: {
      type: String,
      default: "primary",
      validator(i) {
        return wt(i, ["primary", "secondary", "tertiary", "informational"]);
      }
    },
    /**
    * Number of dots to render from 1 to 10;
    */
    dots: {
      type: Number,
      default: 3,
      validator(i) {
        return Number.isInteger(i) && i >= 1 && i <= 10;
      }
    },
    /**
    * Determines size of dots
    */
    size: {
      type: String,
      default: "medium",
      validator(i) {
        return wt(i, ["mini", "small", "medium", "large"]);
      }
    }
  },
  computed: {
    computedDots() {
      let { dots: i } = this;
      return i >= 10 ? i = 10 : i <= 1 && (i = 1), i;
    },
    computedClasses() {
      return [
        `acv-loading-indicator--${this.variant}`,
        `acv-loading-indicator--${this.size}`
      ];
    }
  }
};
var Ay = function() {
  var t = this, e = t._self._c;
  return e("div", { class: ["acv-loading-indicator", t.computedClasses] }, t._l(t.computedDots, function(n) {
    return e("div", { key: `dot-${n}`, staticClass: "acv-loading-indicator__loading-dot" });
  }), 0);
}, by = [], yy = /* @__PURE__ */ U(
  vy,
  Ay,
  by,
  !1,
  null,
  "67102751"
);
const _y = yy.exports, xy = {
  name: "AcvToastMessage",
  components: {
    AcvIcon: ie,
    AcvIconButton: Ee
  },
  mixins: [
    ue
  ],
  props: {
    value: {
      type: Boolean,
      default: !0
    },
    header: {
      type: String,
      default: ""
    },
    message: {
      type: String,
      default: ""
    },
    link: {
      type: String,
      default: ""
    },
    to: {
      type: [String, Object],
      default: ""
    },
    linkText: {
      type: String,
      default: ""
    },
    openLinkInNewTab: {
      type: Boolean,
      default: !1
    },
    severity: {
      type: String,
      default: "info"
    },
    autoDismiss: {
      type: Number,
      default: 10
    },
    dismissible: {
      type: Boolean,
      default: !0
    },
    closeOnLinkClick: {
      type: Boolean,
      default: !0
    },
    sticky: {
      type: Boolean,
      default: !1
    }
  },
  data: () => ({
    icons: {
      info: "info",
      warning: "warning",
      error: "error",
      success: "success-message"
    }
  }),
  computed: {
    closeIcon() {
      return this.sticky ? this.internalValue ? "expand_more" : "expand_less" : "close";
    },
    icon() {
      return this.icons[this.severity];
    },
    autoDismissMilliseconds() {
      return this.autoDismiss * 1e3;
    },
    classBindings() {
      return {
        [`${this.severity}-toast`]: !0,
        sticky: this.sticky,
        visible: this.internalValue,
        "multi-line": this.header && this.message
      };
    }
  },
  watch: {
    value: {
      immediate: !0,
      handler(i) {
        i && this.autoDismiss > 0 && setTimeout(() => {
          this.close();
        }, this.autoDismissMilliseconds);
      }
    }
  },
  methods: {
    handleCloseIconClicked(i) {
      this.sticky ? this.handleToastClicked() : this.close(i);
    },
    close(i) {
      this.internalValue = !1, this.$emit("toastMessageCleared", i);
    },
    handleLinkClicked(i) {
      this.$emit("toastMessageLinkedClicked", i), this.closeOnLinkClick && this.close();
    },
    handleToastClicked() {
      this.sticky && (this.internalValue = !this.internalValue);
    }
  }
};
var Cy = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "acv-toast-message-container", class: t.classBindings, on: { click: t.handleToastClicked, keypress: function(n) {
    return !n.type.indexOf("key") && t._k(n.keyCode, "space", 32, n.key, [" ", "Spacebar"]) ? null : t.handleToastClicked.apply(null, arguments);
  } } }, [e("div", { staticClass: "icon__container" }, [t._t(`${t.id}-icon`, function() {
    return [t.severity ? e("acv-icon", { staticClass: "toast__icon", attrs: { icon: t.icon } }) : t._e()];
  })], 2), e("div", { staticClass: "content__container" }, [t._t(`${t.id}-content`, function() {
    return [t.header ? e("h3", { staticClass: "content__header" }, [t._v(" " + t._s(t.header) + " ")]) : t._e(), t.message ? e("div", { staticClass: "content__message", domProps: { innerHTML: t._s(t.message) } }) : t._e(), t.link || t.to ? e("div", { staticClass: "content__link" }, [t.link ? e("a", { attrs: { href: t.link, target: t.openLinkInNewTab ? "_blank" : "_self" }, on: { click: function(n) {
      return n.stopPropagation(), t.handleLinkClicked.apply(null, arguments);
    } } }, [t._v(" " + t._s(t.linkText ? t.linkText : t.link) + " ")]) : t.to ? e("router-link", { attrs: { to: t.to }, nativeOn: { click: function(n) {
      return n.stopPropagation(), t.handleLinkClicked.apply(null, arguments);
    } } }, [t._v(" " + t._s(t.linkText ? t.linkText : t.to) + " ")]) : t._e()], 1) : t._e()];
  })], 2), t.dismissible || t.sticky ? e("div", { staticClass: "close__container" }, [t._t(`${t.id}-close-icon`, function() {
    return [e("acv-icon-button", { staticClass: "close__icon", attrs: { "icon-type": t.closeIcon, "show-tooltip": !1 }, on: { click: function(n) {
      return n.stopPropagation(), n.preventDefault(), t.handleCloseIconClicked.apply(null, arguments);
    } } })];
  })], 2) : t._e()]);
}, Sy = [], wy = /* @__PURE__ */ U(
  xy,
  Cy,
  Sy,
  !1,
  null,
  "cca411cb"
);
const Yh = wy.exports, ky = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Yh
}, Symbol.toStringTag, { value: "Module" })), Oy = {
  name: "AcvToastMessageList",
  components: {
    AcvToastMessage: () => Promise.resolve().then(() => ky)
  },
  mixins: [
    ue
  ],
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    filteredMessages() {
      const i = [], t = "There was problem processing your request.";
      return this.internalValue.forEach((e) => {
        e.header === "There was a problem." && e.severity === "error" && (e == null ? void 0 : e.message.indexOf(t)) !== -1 && i.push(e.id);
      }), this.internalValue.filter((e) => i.indexOf(e.id) === -1);
    }
  },
  watch: {
    internalValue: {
      immediate: !0,
      deep: !0,
      handler(i) {
        i.forEach((t) => {
          t.id || (t.id = Math.floor(Math.random() * Math.floor(Date.now())).toString()), t.componentName || (t.componentName = "AcvToastMessage");
        });
      }
    }
  },
  methods: {
    handleToastMessageCleared(i) {
      const t = this.internalValue.splice(i, 1);
      this.$emit("toastMessageCleared", t);
    },
    handleToastLinkClicked(i, t) {
      const e = this.internalValue[t];
      this.$emit("toastMessageLinkedClicked", {
        $event: i,
        toastMessage: e
      });
    }
  }
};
var My = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "acv-toast-message-list-container" }, [e("transition-group", { attrs: { name: "toast-show" } }, t._l(t.filteredMessages, function(n, s) {
    return e(n.componentName, { key: n.id, tag: "component", staticClass: "toast-message", attrs: { id: n.id, header: n.header, message: n.message, severity: n.severity, dismissible: n.dismissible, "auto-dismiss": n.autoDismiss, link: n.link, to: n.to, "link-text": n.linkText, "open-link-in-new-tab": n.openLinkInNewTab }, on: { toastMessageLinkedClicked: function(r) {
      return t.handleToastLinkClicked(r, s);
    }, toastMessageCleared: function(r) {
      return t.handleToastMessageCleared(s);
    } }, model: { value: n.value, callback: function(r) {
      t.$set(n, "value", r);
    }, expression: "toastMessage.value" } }, [t._l(Object.keys(t.$slots), function(r) {
      return t._t(r, null, { slot: r });
    })], 2);
  }), 1)], 1);
}, Ty = [], Dy = /* @__PURE__ */ U(
  Oy,
  My,
  Ty,
  !1,
  null,
  "489f0f49"
);
const Py = Dy.exports, Ly = {
  name: "AcvSnackbarList",
  components: {
    AcvSnackbar: () => Promise.resolve().then(() => Vy)
  },
  mixins: [
    ue
  ],
  props: {
    /**
    * An array of Snackbar components {
    *   message: str (required)
    *   autoDismiss: number (optional - defaults to 8)
    *   actionText: str (optional)
    * }
    */
    value: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    currentSnackbar() {
      return this.value[0];
    }
  },
  watch: {
    internalValue: {
      immediate: !0,
      deep: !0,
      handler(i) {
        i.forEach((t) => {
          t.id || (t.id = Math.floor(Math.random() * Math.floor(Date.now())).toString()), t.componentName || (t.componentName = "AcvSnackbar");
        });
      }
    }
  },
  methods: {
    handleSnackbarCleared() {
      const i = this.internalValue.splice(0, 1);
      this.internalValue.length > 0 ? this.snackbarToDisplay = this.internalValue.at(0) : this.snackbarToDisplay = !1, this.$emit("snackbarCleared", i);
    },
    handleActionClicked() {
      this.$emit("actionClicked");
    }
  }
};
var Iy = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "acv-snackbar-list-container" }, [e("transition-group", { attrs: { name: "snackbar-show" } }, [t.currentSnackbar ? e(t.currentSnackbar.componentName, { key: t.currentSnackbar.id, tag: "component", attrs: { id: t.currentSnackbar.id, message: t.currentSnackbar.message, icon: t.currentSnackbar.icon, severity: t.currentSnackbar.severity, "auto-dismiss": t.currentSnackbar.autoDismiss, "action-text": t.currentSnackbar.actionText, sticky: t.currentSnackbar.sticky }, on: { snackBarCleared: t.handleSnackbarCleared, actionClicked: t.handleActionClicked }, model: { value: t.currentSnackbar.value, callback: function(n) {
    t.$set(t.currentSnackbar, "value", n);
  }, expression: "currentSnackbar.value" } }, [t._l(Object.keys(t.$slots), function(n) {
    return t._t(n, null, { slot: n });
  })], 2) : t._e()], 1)], 1);
}, Ey = [], $y = /* @__PURE__ */ U(
  Ly,
  Iy,
  Ey,
  !1,
  null,
  "bd2de904"
);
const By = $y.exports, Ry = {
  name: "AcvSnackbar",
  components: {
    AcvButton: bi,
    AcvIcon: () => Promise.resolve().then(() => Ie)
  },
  mixins: [
    ue
  ],
  props: {
    /**
     * Whether or not to show the snackbar. Use with v-model.
     */
    value: {
      type: Boolean,
      default: !0
    },
    /**
    * Message to be displayed on the snackbar.
    */
    message: {
      type: String,
      default: ""
    },
    /**
    * Time in seconds until the snackbar autodismisses it self
    * Minimum of 4 seconds, Maximum of 10 seconds
    */
    autoDismiss: {
      type: Number,
      default: 8
    },
    /**
    * Text to be displayed in the action button.
    */
    actionText: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: ""
    }
  },
  computed: {
    autoDismissMilliseconds() {
      return this.autoDismiss > 10 || this.autoDismiss < 4 ? 8 * 1e3 : this.autoDismiss * 1e3;
    },
    classBindings() {
      return {
        visible: this.internalValue
      };
    },
    hasIcon() {
      return this.icon || !!this.$slots[`${this.id}-icon`];
    }
  },
  watch: {
    value: {
      immediate: !0,
      handler(i) {
        i && this.autoDismiss > 0 && setTimeout(() => {
          this.close();
        }, this.autoDismissMilliseconds);
      }
    }
  },
  methods: {
    close(i) {
      this.internalValue = !1, this.$emit("snackBarCleared", i);
    },
    handleActionClicked(i) {
      this.$emit("actionClicked", i);
    }
  }
};
var Fy = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "acv-snackbar-container", class: t.classBindings }, [t.hasIcon ? e("div", { staticClass: "icon__container" }, [t._t(`${t.id}-icon`, function() {
    return [t.icon ? e("acv-icon", { staticClass: "snackbar__icon", attrs: { icon: t.icon } }) : t._e()];
  })], 2) : t._e(), e("div", { staticClass: "content__container", class: { content__with_action: t.actionText } }, [t._t(`${t.id}-content`, function() {
    return [t.message ? e("div", { staticClass: "content__message" }, [t._v(" " + t._s(t.message) + " ")]) : t._e(), t.actionText ? e("div", { staticClass: "content__action" }, [e("acv-button", { attrs: { variant: "link" }, on: { click: t.handleActionClicked } }, [t._v(" " + t._s(t.actionText) + " ")])], 1) : t._e()];
  })], 2)]);
}, Ny = [], Hy = /* @__PURE__ */ U(
  Ry,
  Fy,
  Ny,
  !1,
  null,
  "4dd23f83"
);
const Uh = Hy.exports, Vy = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Uh
}, Symbol.toStringTag, { value: "Module" })), zy = {
  name: "AcvMobileOverlay",
  components: {
    AcvButton: bi,
    AcvScrollbar: ka
  },
  props: {
    /**
    * Visibility for the suspended button
    */
    showSuspendedButton: {
      type: Boolean,
      default: !1
    },
    /**
    * Text for the suspended button
    */
    suspendedButtonText: {
      type: String,
      default: ""
    },
    /**
    * Disables the done button
    */
    disableConfirmButton: {
      type: Boolean,
      default: !1
    },
    /**
    * Visibility for the done button
    */
    hideDoneButton: {
      type: Boolean,
      default: !1
    },
    /**
    * Text for the done button
    */
    doneButtonText: {
      type: String,
      default: ""
    },
    /**
    * Accommodate for TopBar component by default
    */
    hasTopSpacing: {
      type: Boolean,
      default: !0
    },
    /**
    * Accommodate for BottomNavigation component by default
    */
    hasBottomSpacing: {
      type: Boolean,
      default: !0
    },
    /**
    * Option to hide the top border to match some Figmas
    */
    hideTopBorder: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    computedClasses() {
      return {
        "acv-mobile-overlay--top-spacing": this.hasTopSpacing,
        "acv-mobile-overlay--bottom-spacing": this.hasBottomSpacing
      };
    },
    hasOverlayText() {
      return this.$slots["overlay-text"];
    },
    hasSuspendedButton() {
      return !!this.$slots["suspended-button"] || this.showSuspendedButton;
    }
  },
  methods: {
    handleDoneButtonClick() {
      this.$emit("confirm-button-clicked");
    },
    handleSuspendedButton() {
      this.$emit("suspended-button-clicked");
    }
  }
};
var jy = function() {
  var t = this, e = t._self._c;
  return e("acv-scrollbar", { staticClass: "acv-mobile-overlay acv-mobile-overlay--scrollable", class: t.computedClasses }, [t._t("default"), t.hasSuspendedButton ? e("div", { staticClass: "acv-mobile-overlay__suspended" }, [t._t("suspended-button", function() {
    return [e("acv-button", { attrs: { variant: "suspended", size: "small" }, on: { click: t.handleSuspendedButton } }, [t._v(" " + t._s(t.suspendedButtonText) + " ")])];
  })], 2) : t._e(), t.hideDoneButton ? t._e() : e("div", { staticClass: "acv-mobile-overlay__done", class: { "hide-top-border": t.hideTopBorder } }, [t.hasOverlayText ? e("div", [t._t("overlay-text")], 2) : t._e(), t.hideDoneButton ? t._e() : t._t("done-button", function() {
    return [e("acv-button", { attrs: { variant: "primary", disabled: t.disableConfirmButton }, on: { click: t.handleDoneButtonClick } }, [t._v(" " + t._s(t.doneButtonText || "Done") + " ")])];
  })], 2)], 2);
}, Wy = [], Yy = /* @__PURE__ */ U(
  zy,
  jy,
  Wy,
  !1,
  null,
  "b29910cd"
);
const Uy = Yy.exports, Zy = {
  name: "AcvNavigationDrawerItem",
  components: {
    AcvIcon: () => Promise.resolve().then(() => Ie),
    AcvBadge: () => Promise.resolve().then(() => Gd),
    AcvCollapse: () => Promise.resolve().then(() => Nm),
    AcvNavigationDrawer: () => Promise.resolve().then(() => e_),
    AcvDivider: () => Promise.resolve().then(() => _0)
  },
  props: {
    /**
    * Vue Router Route object with properties of note being:
    * - `name` - Route Name shown and used to determine if there are active children
    * - `path` - Route path
    * - `children - Route children
    */
    route: {
      type: Object,
      required: !0
    },
    /**
    * Display Name for the route which will shown instead of the name
    */
    displayName: {
      type: String,
      default: ""
    },
    /**
    * Icon to be shown
    */
    icon: {
      type: String,
      default: ""
    },
    /**
    * Determines if the icon should be shown before or after the shown name
    */
    iconPosition: {
      type: String,
      default: "before",
      validator(i) {
        return wt(i, ["before", "after"]);
      }
    },
    /**
    * Shows a badge after the shown name
    */
    badge: {
      type: String,
      default: ""
    },
    /**
    * Renders a divider after the item
    */
    divider: {
      type: Boolean,
      default: !1
    },
    /**
    * Disables the route
    */
    disabled: {
      type: Boolean,
      default: !1
    },
    /**
    * Determines the depth of the item to denote sub drawer nesting within the item
    */
    depth: {
      type: Number,
      default: 0
    }
  },
  data: () => ({
    expanded: !1
  }),
  computed: {
    componentRender() {
      return this.hasMultipleChildren || this.disabled ? "button" : "router-link";
    },
    shownName() {
      return this.displayName || this.route.name;
    },
    children() {
      return (this.route.children || []).filter((i) => !i.hideFromView);
    },
    routingTo() {
      if (this.hasSingleChildren) {
        const [i] = this.children;
        return i;
      }
      return this.route;
    },
    routingClickEvent() {
      return this.hasActiveChild ? "click.native.prevent" : "click";
    },
    computedRouteProps() {
      return this.componentRender === "router-link" ? {
        to: this.routingTo,
        event: this.routingClickEvent,
        activeClass: "active",
        exactActiveClass: "exact",
        class: this.showingAnyChildren && "has-children"
      } : {};
    },
    hasIcon() {
      return !!this.icon;
    },
    computedIconClasses() {
      return {
        [this.iconPosition]: !0
      };
    },
    hasBadge() {
      return !!this.badge;
    },
    subDrawerDepth() {
      return this.depth + 1;
    },
    computedSubDrawerClasses() {
      return {
        [`acv-navigation-drawer-item__sub-drawer-depth-${this.subDrawerDepth}`]: !0,
        expanded: this.expanded
      };
    },
    isParent() {
      return !!(this.children && this.children.length);
    },
    hasSingleChildren() {
      return this.isParent && this.children.length === 1;
    },
    showingSingleChild() {
      return this.hasSingleChildren && this.children[0].alwaysShow;
    },
    hasMultipleChildren() {
      return this.isParent && this.children.length > 1;
    },
    showingAnyChildren() {
      return this.showingSingleChild || this.hasMultipleChildren;
    },
    hasActiveChild() {
      return this.isParent ? !!this.aggregateChildrenRoutes(this.children).find((i) => i.name === this.$route.name) : !1;
    },
    expansionIcon() {
      return this.expanded ? "expand_less" : "expand_more";
    }
  },
  watch: {
    hasActiveChild: {
      handler(i) {
        this.disabled || (this.expanded = i);
      },
      immediate: !0
    }
  },
  methods: {
    slotName(i) {
      return `${this.route.name.toLowerCase().replace(" ", "-")}-${i}`;
    },
    aggregateChildrenRoutes(i) {
      return i.reduce((t, e) => {
        var n;
        return t.push(e), (n = e.children) != null && n.length && t.push(...this.aggregateChildrenRoutes(e.children)), t;
      }, []);
    },
    toggleExpansion() {
      !this.hasActiveChild && !this.disabled && this.showingAnyChildren && (this.expanded = !this.expanded, this.$emit("sub-drawer-expansion-changed", this.expanded));
    }
  }
};
var Gy = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "acv-navigation-drawer-item", attrs: { disabled: t.disabled }, on: { click: function(n) {
    return n.stopPropagation(), t.toggleExpansion.apply(null, arguments);
  }, keypress: function(n) {
    return !n.type.indexOf("key") && t._k(n.keyCode, "space", 32, n.key, [" ", "Spacebar"]) ? null : (n.stopPropagation(), t.toggleExpansion.apply(null, arguments));
  } } }, [e(t.componentRender, t._b({ tag: "component", staticClass: "acv-navigation-drawer-item__container" }, "component", t.computedRouteProps, !1), [e("div", { staticClass: "acv-navigation-drawer-item__container__content" }, [t._t(t.slotName("icon"), function() {
    return [t.hasIcon ? e("acv-icon", { staticClass: "acv-navigation-drawer-item__container__content__icon", class: t.computedIconClasses, attrs: { icon: t.icon } }) : t._e()];
  }), t._t(t.slotName("name"), function() {
    return [e("span", { staticClass: "acv-navigation-drawer-item__container__content__name" }, [t._v(" " + t._s(t.shownName) + " ")])];
  }), t._t(t.slotName("badge"), function() {
    return [t.hasBadge ? e("acv-badge", { attrs: { content: t.badge, disabled: t.disabled } }) : t._e()];
  })], 2), t.isParent && (t.showingSingleChild || t.hasMultipleChildren) ? e("acv-icon", { attrs: { icon: t.expansionIcon } }) : t._e()], 1), t.hasMultipleChildren || t.showingSingleChild ? [e("acv-collapse", [e("acv-navigation-drawer", { directives: [{ name: "show", rawName: "v-show", value: t.expanded, expression: "expanded" }], class: t.computedSubDrawerClasses, attrs: { depth: t.subDrawerDepth, items: t.children } })], 1)] : t._e(), t.divider ? e("acv-divider") : t._e()], 2);
}, Ky = [], Xy = /* @__PURE__ */ U(
  Zy,
  Gy,
  Ky,
  !1,
  null,
  "36eeb687"
);
const Zh = Xy.exports, Qy = {
  name: "AcvNavigationDrawer",
  components: {
    AcvNavigationDrawerItem: Zh
  },
  props: {
    /**
    * Vue Router Route Items to be rendered in the navigation drawer
    * with the expected route properties alongside other defined in NavigationDrawerItem
    */
    items: {
      type: Array,
      default: () => []
    },
    /**
    * Depth at which each navigation drawer is nested
    * NavigationDrawerItem can house children which will nest this component with
    * an additional depth
    */
    depth: {
      type: Number,
      default: 0
    }
  },
  computed: {
    hasSubDrawer() {
      return this.depth > 0;
    }
  },
  methods: {
    slotName(i) {
      return `${i}-drawer-${this.depth}`;
    },
    computedProps(i) {
      return {
        route: i,
        displayName: i.displayName,
        icon: i.icon,
        iconPosition: i.iconPosition,
        badge: i.badge,
        disabled: i.disabled,
        divider: i.divider
      };
    }
  }
};
var Jy = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "acv-navigation-drawer", class: { "sub-drawer": t.hasSubDrawer } }, [t._t(t.slotName("before")), t._l(t.items, function(n, s) {
    return e("acv-navigation-drawer-item", t._b({ key: s, attrs: { depth: t.depth } }, "acv-navigation-drawer-item", t.computedProps(n), !1));
  }), t._t(t.slotName("after"))], 2);
}, qy = [], t_ = /* @__PURE__ */ U(
  Qy,
  Jy,
  qy,
  !1,
  null,
  "cd5dbf95"
);
const Gh = t_.exports, e_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Gh
}, Symbol.toStringTag, { value: "Module" })), i_ = {
  name: "AcvProgressBar",
  mixins: [
    fe
  ],
  props: {
    backgroundOpacity: {
      type: [Number, String],
      default: "0.3"
    },
    height: {
      type: [Number, String],
      default: "20px"
    },
    value: {
      type: Number,
      default: 0
    },
    valueText: {
      type: String,
      default: ""
    }
  },
  computed: {
    backgroundBarStyles() {
      return {
        width: `${100 - this.value}%`,
        left: `${this.value}%`,
        opacity: this.backgroundOpacity
      };
    },
    completedBarStyles() {
      return {
        width: `${this.value}%`
      };
    }
  }
};
var n_ = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "acv-progress-bar tw-flexbox-row-align-center-justify-center", style: [t.sizeStyles], attrs: { role: "progressbar", "aria-valuemax": "100", "aria-valuemin": "0", "aria-valuenow": t.value, "aria-valuetext": t.valueText } }, [e("div", { staticClass: "acv-progress-bar__completed", style: t.completedBarStyles }), e("div", { staticClass: "acv-progress-bar__background", style: t.backgroundBarStyles }), e("div", { staticClass: "acv-progress-bar__content" }, [t._t("default", function() {
    return [t._v(" " + t._s(t.valueText) + " ")];
  })], 2)]);
}, s_ = [], r_ = /* @__PURE__ */ U(
  i_,
  n_,
  s_,
  !1,
  null,
  "6758bad7"
);
const Kh = r_.exports, a_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Kh
}, Symbol.toStringTag, { value: "Module" })), io = { passive: !0, capture: !1 }, o_ = {
  name: "AcvPullToRefresh",
  components: {
    AcvProgressIndicator: Ca,
    AcvIntersectionObserver: Lh
  },
  props: {
    messageWhilePullingDown: {
      type: String,
      default: "Pull to refresh"
    },
    messageWhenThresholdMet: {
      type: String,
      default: "Release"
    },
    messageWhenLoading: {
      type: String,
      default: "Refreshing..."
    },
    pullThreshold: {
      type: Number,
      default: 100
    },
    loading: {
      type: Boolean,
      default: !1
    },
    staticProgressIndicatorOptions: {
      type: Object,
      default: () => ({})
    },
    loadingProgressIndicatorOptions: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    disabled: !1,
    initialY: 0,
    lastY: 0,
    yOffset: 0,
    pullDownContentPercentageComplete: 0,
    active: !1,
    pullThresholdMet: !1,
    staticProgressIndicatorOptionsDefaults: {
      progress: 0.5,
      stroke: 2,
      size: 25,
      indeterminate: !1
    },
    loadingProgressIndicatorOptionsDefaults: {
      stroke: 2,
      size: 25
    }
  }),
  computed: {
    progressIndicatorOptionsComputed() {
      return this.loading ? this.loadingProgressIndicatorOptionsComputed : this.staticProgressIndicatorOptionsComputed;
    },
    staticProgressIndicatorOptionsComputed() {
      return {
        ...this.staticProgressIndicatorOptions,
        ...this.staticProgressIndicatorOptionsDefaults
      };
    },
    loadingProgressIndicatorOptionsComputed() {
      return {
        ...this.loadingProgressIndicatorOptions,
        ...this.loadingProgressIndicatorOptionsDefaults
      };
    },
    refreshMessage() {
      return this.loading ? this.messageWhenLoading : this.pullThresholdMet ? this.messageWhenThresholdMet : this.messageWhilePullingDown;
    },
    contentElement() {
      var i;
      return (i = this.$refs) == null ? void 0 : i.content;
    },
    contentElementStyles() {
      const i = {};
      return !this.disabled && (this.active || this.loading) ? {
        transform: `translate3d(0px, ${this.yOffset}px, 0)`
      } : i;
    },
    pullDownContentStyles() {
      return {
        opacity: this.disabled ? 0 : this.pullDownContentPercentageComplete
      };
    }
  },
  watch: {
    loading: {
      handler() {
        this.disabled || (this.loading ? this.setUpdatedValues(this.pullThreshold, 1, !0) : this.reset());
      },
      immediate: !0
    }
  },
  mounted() {
    this.bindEvents();
  },
  destroyed() {
    this.removeEvents();
  },
  methods: {
    handleIntersection(i) {
      this.disabled = !i;
    },
    bindEvents() {
      this.contentElement && (this.contentElement.addEventListener("touchstart", this.handleTouchStart, io), this.contentElement.addEventListener("touchmove", this.handleTouchMove, io), this.contentElement.addEventListener("touchend", this.handleTouchEnd, io));
    },
    removeEvents() {
      this.contentElement && (this.contentElement.removeEventListener("touchstart", this.handleTouchStart), this.contentElement.removeEventListener("touchmove", this.handleTouchMove), this.contentElement.removeEventListener("touchend", this.handleTouchEnd));
    },
    handleTouchMove(i) {
      if (!this.disabled) {
        let t = 0, e = 0, n = !1;
        if (this.active) {
          let s = 0;
          if (i.type === "touchmove" ? s = i.touches[0].clientY - this.initialY : s = i.clientY - this.initialY, n = s >= this.pullThreshold, s < 0)
            return;
          s <= this.pullThreshold ? (t = s, e = t / this.pullThreshold + 0.25, e = e > 1 ? 1 : e) : n && (t = this.pullThreshold, e = 1), this.setUpdatedValues(t, e, n);
        }
      }
    },
    setUpdatedValues(i, t, e) {
      this.pullThresholdMet = e, this.lastY = i, this.yOffset = i, this.pullDownContentPercentageComplete = t;
    },
    handleTouchEnd() {
      this.disabled || (this.pullThresholdMet && this.$emit("refreshed"), this.reset(!1));
    },
    handleTouchStart(i) {
      this.disabled || (this.reset(!0), i.type === "touchstart" ? this.initialY = i.touches[0].clientY - this.yOffset : this.initialY = i.clientY - this.yOffset);
    },
    reset(i) {
      this.active = i, this.initialY = 0, this.yOffset = 0, this.pullDownContentPercentageComplete = 0, this.pullThresholdMet = !1;
    }
  }
};
var l_ = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "acv-pull-to-refresh tw-flexbox-col-align-center-justify-center" }, [e("acv-intersection-observer", { attrs: { threshold: 1 }, on: { intersection: t.handleIntersection } }, [e("div", { staticClass: "pull-down-content", style: t.pullDownContentStyles }, [t._t("pull-down-content", function() {
    return [e("div", { staticClass: "tw-flexbox-col-align-center-justify-center" }, [e("div", { staticClass: "refresh-message" }, [t._v(" " + t._s(t.refreshMessage) + " ")]), e("acv-progress-indicator", t._b({}, "acv-progress-indicator", t.progressIndicatorOptionsComputed, !1))], 1)];
  })], 2)]), e("div", { ref: "content", staticClass: "content", style: t.contentElementStyles }, [t._t("default")], 2)], 1);
}, c_ = [], u_ = /* @__PURE__ */ U(
  o_,
  l_,
  c_,
  !1,
  null,
  "86fe9ba8"
);
const d_ = u_.exports, h_ = {
  name: "AcvSlideOut",
  components: {
    AcvButton: () => Promise.resolve().then(() => Xd),
    AcvIconButton: Ee
  },
  directives: {
    onClickaway: On
  },
  props: {
    closeIcon: {
      type: String,
      default: "close"
    },
    direction: {
      type: String,
      default: "ltr"
    },
    enableCloseOnClickaway: {
      type: Boolean,
      default: !0
    },
    cancelButtonLabel: {
      type: String,
      default: "Cancel"
    },
    okButtonLabel: {
      type: String,
      default: "Ok"
    },
    closeOnOk: {
      type: Boolean,
      default: !0
    }
  },
  data() {
    return {
      visible: !1,
      clickAwayEnabled: !1
    };
  },
  watch: {
    visible(i, t) {
      this.$emit("visibility-changing", { visible: i, visibleFrom: t, mode: this.mode }), setTimeout(() => {
        this.$emit("visibility-changed", { visible: i, visibleFrom: t, mode: this.mode });
      }, 1e3);
    }
  },
  methods: {
    handleClickAway() {
      this.enableCloseOnClickaway && this.clickAwayEnabled && (this.hide(), this.$emit("canceled"));
    },
    handleCloseClicked() {
      this.hide(), this.$emit("canceled");
    },
    handleOk() {
      this.closeOnOk && this.hide(), this.$emit("ok-clicked");
    },
    handleCancel() {
      this.hide(), this.$emit("canceled");
    },
    show() {
      this.visible = !0, setTimeout(() => {
        this.clickAwayEnabled = !0;
      }, 100), document.body.style.overflow = "hidden";
    },
    hide() {
      this.visible = !1, this.clickAwayEnabled = !1, this.$emit("hidden"), document.body.style.overflow = "";
    }
  }
};
var f_ = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "acv-slide-out", class: {
    "--visible": t.visible
  } }, [e("div", { directives: [{ name: "on-clickaway", rawName: "v-on-clickaway:mousedown", value: t.handleClickAway, expression: "handleClickAway", arg: "mousedown" }], staticClass: "acv-slide-out-container tw-flexbox-col-align-center", class: {
    "--visible": t.visible,
    rtl: t.direction === "rtl",
    ltr: t.direction === "ltr"
  } }, [e("div", { staticClass: "acv-slide-out-header tw-w-full" }, [t._t("header", function() {
    return [e("div", { staticClass: "acv-slide-out-header-text tw-flexbox-col-align-left" }, [t._t("header-text")], 2), t._t("header-close-icon", function() {
      return [e("acv-icon-button", { staticClass: "close-icon", attrs: { "icon-type": t.closeIcon, "show-tooltip": !1 }, on: { click: t.handleCloseClicked } })];
    })];
  })], 2), e("div", { staticClass: "acv-slide-out-body tw-flexbox-row-align-start tw-w-full" }, [t._t("default")], 2), e("div", { staticClass: "acv-slide-out-footer tw-flexbox-row-align-center-justify-between tw-w-full" }, [t._t("footer", function() {
    return [t._t("cancel-button", function() {
      return [e("acv-button", { attrs: { variant: "tertiary" }, on: { click: t.handleCancel } }, [t._v(" " + t._s(t.cancelButtonLabel) + " ")])];
    }), t._t("ok-button", function() {
      return [e("acv-button", { staticClass: "ok-button", on: { click: function(n) {
        return t.handleOk(n, !0);
      } } }, [t._v(" " + t._s(t.okButtonLabel) + " ")])];
    })];
  })], 2)])]);
}, p_ = [], g_ = /* @__PURE__ */ U(
  h_,
  f_,
  p_,
  !1,
  null,
  "0adeaa1c"
);
const m_ = g_.exports, v_ = {
  name: "AcvStatusBadge",
  components: {
    AcvIcon: ie,
    AcvTooltip: os
  },
  props: {
    /**
    * The variant styling for the status badge
    */
    variant: {
      type: String,
      default: "default",
      validator(i) {
        return wt(i, [
          "default",
          "dark",
          "informational",
          "caution",
          "error",
          "success",
          "jewel"
        ]);
      }
    },
    /**
    * Mode for the status badge being either extended or mini to show only the icon
    */
    mode: {
      type: String,
      default: "extended",
      validator(i) {
        return wt(i, ["extended", "mini"]);
      }
    },
    /**
    * Icon shown beside text in extended mode or shown while in mini mode
    */
    iconType: {
      type: String,
      default: ""
    },
    /**
    * Position of the icon in extended mode either being before or after the text
    */
    iconPosition: {
      type: String,
      default: "before",
      validator(i) {
        return wt(i, ["before", "after"]);
      }
    },
    /**
    * Disable styling on the status badge
    */
    disabled: {
      type: Boolean,
      default: !1
    },
    /**
    * Allow status badge to extend from `mini` to `extended` on hover
    */
    extendOnHover: {
      type: Boolean,
      default: !1
    },
    /**
     * Indicates the material ui icons style. Options: round, outlined
     */
    iconStyle: {
      type: String,
      default: "round",
      validator(i) {
        return wt(i, [
          "round",
          "outlined"
        ]);
      }
    },
    /**
     * Flag to trigger condition met and animation
     */
    animateIcon: {
      type: Boolean,
      default: !1
    },
    /**
     * Determines whether a tooltip should be rendered
     */
    showTooltip: {
      type: Boolean,
      default: !1
    },
    /**
     * Props towards the Tooltip component
     */
    tooltipOptions: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    isHovered: !1
  }),
  computed: {
    inputId() {
      return this.$attrs.id || this.id || `${this.$options.name}-${this._uid}`;
    },
    computedMode() {
      return this.extendOnHover && this.mode === "mini" ? this.isHovered ? "extended" : "mini" : this.mode;
    },
    computedClasses() {
      return {
        "acv-status-badge--extended": this.isExtended,
        "acv-status-badge--mini": this.isMini,
        "acv-status-badge--disabled": this.disabled,
        [`acv-status-badge--${this.variant}`]: !0
      };
    },
    computedIconClasses() {
      return {
        "acv-status-badge__icon--before": this.iconPosition === "before",
        "acv-status-badge__icon--after": this.iconPosition === "after"
      };
    },
    inputListeners() {
      return {
        ...this.$listeners,
        mouseover: (i) => {
          this.isHovered = !0, this.$emit("mouseover", i);
        },
        mouseleave: (i) => {
          this.isHovered = !1, this.$emit("mouseleave", i);
        }
      };
    },
    hasIcon() {
      return !!this.$slots.icon || this.iconType;
    },
    isExtended() {
      return this.computedMode === "extended";
    },
    isMini() {
      return this.computedMode === "mini";
    }
  }
};
var A_ = function() {
  var t = this, e = t._self._c;
  return e("div", t._g({ class: ["acv-status-badge", `acv-status-badge--${t.inputId}`, t.computedClasses] }, t.inputListeners), [t.isExtended ? [t._t("prepend")] : t._e(), e("div", { directives: [{ name: "show", rawName: "v-show", value: t.isExtended, expression: "isExtended" }], staticClass: "acv-status-badge__content" }, [t._t("default")], 2), t.hasIcon ? [t._t("icon", function() {
    return [t.iconType ? e("acv-icon", { class: ["acv-status-badge__icon", t.computedIconClasses], attrs: { icon: t.iconType, "icon-style": t.iconStyle, "animate-icon": t.animateIcon } }) : t._e()];
  })] : t._e(), t.isExtended ? [t._t("append")] : t._e(), t.showTooltip ? e("acv-tooltip", t._b({ ref: "tooltip", attrs: { target: `.acv-status-badge--${t.inputId}` } }, "acv-tooltip", t.tooltipOptions, !1), [t._t("tooltip")], 2) : t._e()], 2);
}, b_ = [], y_ = /* @__PURE__ */ U(
  v_,
  A_,
  b_,
  !1,
  null,
  "027f3650"
);
const Xh = y_.exports, Qh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Xh
}, Symbol.toStringTag, { value: "Module" }));
var Jh = { exports: {} };
(function(i, t) {
  (function(e, n) {
    i.exports = n();
  })(hi, function() {
    return function(e, n) {
      var s = n.prototype, r = s.format;
      s.format = function(a) {
        var o = this, l = this.$locale();
        if (!this.isValid()) return r.bind(this)(a);
        var c = this.$utils(), u = (a || "YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g, function(d) {
          switch (d) {
            case "Q":
              return Math.ceil((o.$M + 1) / 3);
            case "Do":
              return l.ordinal(o.$D);
            case "gggg":
              return o.weekYear();
            case "GGGG":
              return o.isoWeekYear();
            case "wo":
              return l.ordinal(o.week(), "W");
            case "w":
            case "ww":
              return c.s(o.week(), d === "w" ? 1 : 2, "0");
            case "W":
            case "WW":
              return c.s(o.isoWeek(), d === "W" ? 1 : 2, "0");
            case "k":
            case "kk":
              return c.s(String(o.$H === 0 ? 24 : o.$H), d === "k" ? 1 : 2, "0");
            case "X":
              return Math.floor(o.$d.getTime() / 1e3);
            case "x":
              return o.$d.getTime();
            case "z":
              return "[" + o.offsetName() + "]";
            case "zzz":
              return "[" + o.offsetName("long") + "]";
            default:
              return d;
          }
        });
        return r.bind(this)(u);
      };
    };
  });
})(Jh);
var __ = Jh.exports;
const x_ = /* @__PURE__ */ as(__);
Oe.extend(x_);
const C_ = {
  name: "AcvEventTimeline",
  components: {
    AcvDivider: Js
  },
  filters: {
    datetimeFormat(i, t) {
      return i ? Oe(i).format(t) : "";
    }
  },
  props: {
    /**
     * dayjs format string for date display
     */
    dateFormat: {
      type: String,
      default: "MMM Do, YYYY"
    },
    /**
     * header text for the date column
     */
    dateHeader: {
      type: String,
      default: "Date"
    },
    /**
     * header text for the event description column
     */
    descriptionHeader: {
      type: String,
      default: "Event"
    },
    /**
     *  Array of event objects
     *
     * properties on the event object:
     * title (string) - the header text for the  event
     * timestamp (datetime) - date and time of the event
     * description (string) - longer description of the event
     * variant (string) - changes variant on the event, ['alert']
     * dividerVariant (string) - changes variant on the divider, ['dashed']
     */
    events: {
      type: Array,
      default: () => []
    },
    /**
     * option to hide first date/time column entirely
     */
    hideDateCol: {
      type: Boolean,
      default: !1
    },
    /**
     * include the time in the display of the date
     */
    showEventTime: {
      type: Boolean,
      default: !1
    },
    /**
     * dayjs format string for time display
     */
    timeFormat: {
      type: String,
      default: "h:mm a"
    },
    /**
     * allows the user to click on a past event for details
     */
    toggleSelectedEvent: {
      type: Boolean,
      default: !1
    },
    /**
     * shows all the descriptions for events
     */
    showAllDescriptions: {
      type: Boolean,
      default: !1
    },
    /**
     * simplified design with timeline in center
     */
    simplified: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      activeIndex: 0
    };
  },
  methods: {
    isActiveEvent(i) {
      return i === this.activeIndex;
    },
    handleEventSelected(i) {
      this.toggleSelectedEvent && (this.changeActiveIndex(i), this.$emit("timeline-index-clicked", i));
    },
    hasAppendSlot(i) {
      return !!this.$slots[`event-status-append-${i}`];
    },
    changeActiveIndex(i) {
      this.activeIndex = i;
    }
  }
};
var S_ = function() {
  var t = this, e = t._self._c;
  return e("div", { class: [
    "acv-event-timeline",
    t.hideDateCol ? "no-date-col" : "",
    t.simplified ? "simplified" : ""
  ] }, [e("div", { staticClass: "header" }, [e("div", { staticClass: "header__timeline overline" }, [t._t("header-timeline", function() {
    return [t._v("   ")];
  })], 2), t.hideDateCol ? t._e() : e("div", { staticClass: "header__date overline" }, [t._t("header-date", function() {
    return [t._v(" " + t._s(t.dateHeader) + " ")];
  })], 2), e("div", { staticClass: "header__description overline" }, [t._t("header-description", function() {
    return [t._v(" " + t._s(t.descriptionHeader) + " ")];
  })], 2)]), t._l(t.events, function(n, s) {
    return e("div", { key: s, class: [
      "event",
      t.isActiveEvent(s) ? "--active" : ""
    ] }, [e("div", { staticClass: "event__timeline" }, [t._t("event-timeline", function() {
      return [e("div", { class: [
        "timeline-marker",
        n.variant ? `--${n.variant}` : "",
        t.toggleSelectedEvent ? "--cursor" : ""
      ], on: { click: function(r) {
        return t.handleEventSelected(s);
      }, keypress: function(r) {
        return !r.type.indexOf("key") && t._k(r.keyCode, "space", 32, r.key, [" ", "Spacebar"]) ? null : t.handleEventSelected(s);
      } } }), s !== t.events.length - 1 ? e("acv-divider", { class: ["timeline-divider", n.dividerVariant ? `timeline-divider--${n.dividerVariant}` : ""], attrs: { vertical: "" } }) : t._e()];
    }, { event: n, index: s })], 2), t.hideDateCol ? t._e() : e("div", { staticClass: "event__datetime" }, [e("div", { staticClass: "event-date" }, [t._t("event-date", function() {
      return [t._v(" " + t._s(t._f("datetimeFormat")(n.timestamp, t.dateFormat)) + " ")];
    }, { event: n, index: s })], 2), t.showEventTime ? e("div", { staticClass: "event-time" }, [t._t("event-time", function() {
      return [t._v(" " + t._s(t._f("datetimeFormat")(n.timestamp, t.timeFormat)) + " ")];
    }, { event: n, index: s })], 2) : t._e()]), e("div", { class: [
      "event__status",
      t.toggleSelectedEvent ? "--cursor" : ""
    ], on: { click: function(r) {
      return t.handleEventSelected(s);
    }, keypress: function(r) {
      return !r.type.indexOf("key") && t._k(r.keyCode, "space", 32, r.key, [" ", "Spacebar"]) ? null : t.handleEventSelected(s);
    } } }, [e("div", { staticClass: "status-title" }, [t._t("event-status-title", function() {
      return [t._v(" " + t._s(n.title) + " ")];
    }, { event: n, index: s })], 2), t.isActiveEvent(s) || t.showAllDescriptions ? e("div", { staticClass: "status-description" }, [t._t("event-status-description", function() {
      return [t._v(" " + t._s(n.description) + " ")];
    }, { event: n, index: s })], 2) : t._e(), t.hasAppendSlot(s) && t.isActiveEvent(s) ? e("div", { staticClass: "status-append" }, [t._t(`event-status-append-${s}`, null, { event: n, index: s })], 2) : t._e()]), t.isActiveEvent(s) ? e("div", { staticClass: "event__after" }, [t._t("event-after", null, { event: n, index: s })], 2) : t._e()]);
  })], 2);
}, w_ = [], k_ = /* @__PURE__ */ U(
  C_,
  S_,
  w_,
  !1,
  null,
  "962bc133"
);
const O_ = k_.exports, M_ = {
  name: "AcvStepper",
  mixins: [
    Mn,
    ue,
    fe
  ],
  provide() {
    return {
      stepper: {
        register: this.register,
        stepClick: this.stepClick,
        unregister: this.unregister
      }
    };
  },
  props: {
    value: {
      type: Number,
      default: void 0
    },
    clickable: {
      type: Boolean,
      default: !0
    }
  },
  data() {
    return {
      steps: [],
      contents: [],
      goingToPreviousStep: !1
    };
  },
  watch: {
    internalValue: {
      handler(i, t) {
        this.goingToPreviousStep = Number(i) < Number(t), this.updateView();
      }
    }
  },
  mounted() {
    this.updateView();
  },
  methods: {
    register(i) {
      i.$options.name === "AcvStepperContent" && this.contents.push(i), i.$options.name === "AcvStepperStep" && this.steps.push(i);
    },
    stepClick(i) {
      this.clickable && (this.internalValue = i);
    },
    unregister(i) {
      i.$options.name === "AcvStepperContent" && (this.contents = this.contents.filter((t) => t !== i)), i.$options.name === "AcvStepperStep" && (this.steps = this.steps.filter((t) => t !== i));
    },
    updateView() {
      this.steps.forEach((i) => i.toggle(this.internalValue)), this.contents.forEach((i) => i.toggle(this.internalValue, this.goingToPreviousStep));
    }
  }
};
var T_ = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "acv-stepper", class: t.borderClasses, style: [t.sizeStyles] }, [t._t("default")], 2);
}, D_ = [], P_ = /* @__PURE__ */ U(
  M_,
  T_,
  D_,
  !1,
  null,
  "255e3896"
);
const L_ = P_.exports, I_ = {
  name: "AcvFlexbox",
  deprecated: "AcvFlexbox is deprecated. Please use CSS to apply flexbox to an element",
  mixins: [
    fe
  ],
  props: {
    tag: {
      type: String,
      default: "div"
    },
    justify: {
      type: String,
      default: "start"
    },
    align: {
      type: String,
      default: "center"
    },
    direction: {
      type: String,
      default: "column"
    },
    wrap: {
      type: Boolean,
      default: !0
    },
    marginBetween: {
      type: [String],
      default: ""
    }
  },
  data() {
    return {
      spacingMap: {
        start: "flex-start",
        end: "flex-end",
        between: "space-between"
      }
    };
  },
  computed: {
    /**
     * Inline style object for the Flexbox.
     */
    styleObject() {
      const i = {
        boxSizing: "border-box",
        justifyContent: this.getSpacing(this.justify),
        alignItems: this.getSpacing(this.align),
        flexDirection: this.direction,
        flexWrap: this.flexWrap,
        ...this.marginObject,
        ...this.paddingObject,
        ...this.sizeObject
      };
      return Object.keys(i).forEach((t) => {
        (i[t] === void 0 || i[t] === "") && delete i[t];
      }), i;
    },
    /**
     * Flex wrap property.
     */
    flexWrap() {
      return this.wrap ? "wrap" : "nowrap";
    },
    /**
     * Suffix of the class of the Flexbox. Handles `marginBetween`.
     */
    classSuffix() {
      let i = "";
      return this.direction && (i += `--${this.direction}`), this.marginBetween && (i = `--margin-between${i}--${this.marginBetween}`), i;
    }
  },
  methods: {
    /**
     * Converts a prop into a spacing CSS property
     */
    getSpacing(i) {
      return i ? i in this.spacingMap ? this.spacingMap[i] : i : "";
    }
  }
};
var E_ = function() {
  var t = this, e = t._self._c;
  return e(t.tag, t._g({ tag: "component", staticClass: "acv-flexbox", class: `acv-flexbox${t.classSuffix}`, style: t.styleObject }, t.$listeners), [t._t("default")], 2);
}, $_ = [], B_ = /* @__PURE__ */ U(
  I_,
  E_,
  $_,
  !1,
  null,
  "37e0abd6"
);
const Oa = B_.exports, R_ = {
  name: "AcvStepperContent",
  components: {
    AcvFlexbox: Oa
  },
  mixins: [
    yi,
    Mn,
    en
  ],
  inject: [
    "stepper"
  ],
  inheritAttrs: !1,
  props: {
    step: {
      type: Number,
      default: void 0
    }
  },
  data() {
    return {
      isActive: !1,
      isMovingToPreviousStep: !1
    };
  },
  computed: {
    classes() {
      return {
        ...this.borderClasses,
        ...this.backgroundClasses,
        ...this.fontClasses
      };
    },
    transition() {
      return this.isMovingToPreviousStep ? "page-previous" : "page-next";
    }
  },
  mounted() {
    this.stepper.register(this);
  },
  beforeDestroy() {
    this.stepper.unregister(this);
  },
  methods: {
    toggle(i, t) {
      this.isActive = i.toString() === this.step.toString(), this.isMovingToPreviousStep = t;
    }
  }
};
var F_ = function() {
  var t = this, e = t._self._c;
  return e("transition", { attrs: { name: t.transition } }, [e("div", { directives: [{ name: "show", rawName: "v-show", value: t.isActive, expression: "isActive" }], staticClass: "acv-stepper__content" }, [e("acv-flexbox", t._g(t._b({ staticClass: "acv-stepper__content__wrapper", class: t.classes, style: [t.fontStyles] }, "acv-flexbox", { ...t.$attrs, ...t.$props }, !1), t.$listeners), [t._t("default")], 2)], 1)]);
}, N_ = [], H_ = /* @__PURE__ */ U(
  R_,
  F_,
  N_,
  !1,
  null,
  "1943d679"
);
const V_ = H_.exports, z_ = {
  name: "AcvStepperHeader",
  components: {
    AcvFlexbox: Oa
  },
  mixins: [
    yi,
    Mn,
    fe
  ],
  inheritAttrs: !1,
  props: {
    justify: {
      type: String,
      default: "space-between"
    },
    direction: {
      type: String,
      default: "row"
    },
    align: {
      type: String,
      default: "stretch"
    }
  },
  computed: {
    classes() {
      return {
        ...this.borderClasses,
        ...this.backgroundClasses
      };
    }
  }
};
var j_ = function() {
  var t = this, e = t._self._c;
  return e("acv-flexbox", t._g(t._b({ staticClass: "acv-stepper__header", class: t.classes, style: [t.sizeStyles], attrs: { wrap: !1 } }, "acv-flexbox", { ...t.$attrs, ...t.$props }, !1), t.$listeners), [t._t("default")], 2);
}, W_ = [], Y_ = /* @__PURE__ */ U(
  z_,
  j_,
  W_,
  !1,
  null,
  null
);
const U_ = Y_.exports, Z_ = {
  name: "AcvStepperItems",
  components: {
    AcvFlexbox: Oa
  },
  mixins: [
    yi,
    Mn,
    fe
  ],
  inheritAttrs: !1,
  computed: {
    classes() {
      return {
        ...this.borderClasses,
        ...this.backgroundClasses
      };
    }
  }
};
var G_ = function() {
  var t = this, e = t._self._c;
  return e("acv-flexbox", t._g(t._b({ staticClass: "acv-stepper__items", class: t.classes, style: [t.sizeStyles] }, "acv-flexbox", { ...t.$attrs, ...t.$props }, !1), t.$listeners), [t._t("default")], 2);
}, K_ = [], X_ = /* @__PURE__ */ U(
  Z_,
  G_,
  K_,
  !1,
  null,
  "9132a352"
);
const Q_ = X_.exports, J_ = {
  name: "AcvStepperStep",
  inject: [
    "stepper"
  ],
  props: {
    step: {
      type: Number,
      default: void 0
    },
    rules: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isActive: !1,
      isCompleted: !1
    };
  },
  computed: {
    hasError() {
      return this.rules.some((i) => i() !== !0);
    },
    computedStep() {
      return this.$slots.default ? void 0 : this.step;
    },
    iconClasses() {
      return {
        "acv-stepper__step__icon--active": this.isActive && !this.hasError,
        "acv-stepper__step__icon--error": this.hasError,
        "acv-stepper__step__icon--completed": this.isCompleted
      };
    }
  },
  mounted() {
    this.stepper.register(this);
  },
  beforeDestroy() {
    this.stepper.unregister(this);
  },
  methods: {
    handleClick(i) {
      i.stopPropagation(), this.hasError || this.stepper.stepClick(this.step), this.$emit("click", i);
    },
    toggle(i) {
      this.isActive = i.toString() === this.step.toString(), this.isCompleted = i.toString() > this.step.toString();
    }
  }
};
var q_ = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "acv-stepper__step tw-flexbox-row", on: { click: t.handleClick, keypress: function(n) {
    return !n.type.indexOf("key") && t._k(n.keyCode, "space", 32, n.key, [" ", "Spacebar"]) ? null : t.handleClick.apply(null, arguments);
  } } }, [e("span", { staticClass: "acv-stepper__step__icon tw-flexbox-col-align-center-justify-center tw-self-center", class: t.iconClasses }, [t._t("default"), t._v(" " + t._s(t.computedStep) + " ")], 2), e("div", { staticClass: "acv-stepper__step__label tw-flexbox-col-justify-center" }, [t._t("title"), e("small", { directives: [{ name: "show", rawName: "v-show", value: t.hasError, expression: "hasError" }], staticClass: "error" }, [t._t("error")], 2)], 2)]);
}, t5 = [], e5 = /* @__PURE__ */ U(
  J_,
  q_,
  t5,
  !1,
  null,
  "fb689da4"
);
const i5 = e5.exports, n5 = {
  name: "AcvTimeCounter",
  props: {
    /**
    * Clock drift to adjust calculated values
    */
    clockOffset: {
      type: Number,
      default: 0
    },
    /**
    * End time the counter matches against
    */
    endTime: {
      type: [Date, Number, String],
      required: !0
    },
    /**
    * Determines if a summarized string should be shown before showing the time countdown
    */
    showCountdownAt: {
      type: String,
      default: "1 days",
      validator(i) {
        const t = i.split(" "), e = parseInt(t[0], 10), n = t[1], s = Number.isInteger(e), r = ["seconds", "minutes", "hours", "days"].includes(n);
        return s && r;
      }
    },
    /**
    * Determines if an event should be emitted when a threshold is truthy and past
    */
    showWarningBelow: {
      type: Number,
      default: 0
    },
    /**
    * Determines if the countdown should be paused
    */
    pauseCountdown: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      animationRef: null,
      days: 0,
      hours: 0,
      lastRenderTime: null,
      minutes: 0,
      paused: !1,
      seconds: 0,
      timeoutRef: null,
      timeRemaining: null,
      warningShown: !1
    };
  },
  computed: {
    endDateObject() {
      return this.isDateObject(this.endTime) ? this.endTime : this.isUnixTime(this.endTime) ? new Date(this.endTime * 1e3) : new Date(this.endTime);
    },
    formattedTime() {
      let i = "";
      if (this.showCountdown) {
        const t = this.pad(this.days), e = this.pad(this.hours), n = this.pad(this.minutes), s = this.pad(this.seconds);
        return this.days > 0 ? i = `${t}:${e}:` : this.hours > 0 && (i = `${e}:`), i = `${i}${n}:${s}`, i;
      }
      return this.days > 0 ? this.days === 1 ? `${this.days} day` : `${this.days} days` : this.hours > 0 ? this.hours === 1 ? `${this.hours} hour` : `${this.hours} hours` : this.minutes > 0 ? this.minutes === 1 ? `${this.minutes} minute` : `${this.minutes} minutes` : this.seconds === 1 ? `${this.seconds} second` : `${this.seconds} seconds`;
    },
    showCountdown() {
      const i = this.showCountdownAt.split(" "), t = parseInt(i[0], 10), e = i[1];
      let n = 0;
      switch (e) {
        case "days":
          n = t * (1e3 * 60 * 60 * 24);
          break;
        case "hours":
          n = t * (1e3 * 60 * 60);
          break;
        case "minutes":
          n = t * (1e3 * 60);
          break;
        case "seconds":
        default:
          n = t * 1e3;
          break;
      }
      return this.timeRemaining < n;
    }
  },
  watch: {
    endTime: {
      handler(i, t) {
        i && i !== t && !this.paused && (clearTimeout(this.timeoutRef), cancelAnimationFrame(this.animationRef), this.animationRef = requestAnimationFrame(this.getTimeRemaining));
      },
      immediate: !0
    },
    pauseCountdown: {
      handler(i) {
        this.paused = i, this.paused ? (clearTimeout(this.timeoutRef), cancelAnimationFrame(this.animationRef)) : this.animationRef = requestAnimationFrame(this.getTimeRemaining);
      },
      immediate: !0
    }
  },
  destroyed() {
    clearTimeout(this.timeoutRef), cancelAnimationFrame(this.animationRef);
  },
  methods: {
    getTimeRemaining(i) {
      this.lastRenderTime = i;
      const t = this.clockOffset * 1e3;
      this.timeRemaining = this.endDateObject - Date.now() + t, this.seconds = Math.floor(this.timeRemaining / 1e3 % 60), this.minutes = Math.floor(this.timeRemaining / 1e3 / 60 % 60), this.hours = Math.floor(this.timeRemaining / (1e3 * 60 * 60) % 24), this.days = Math.floor(this.timeRemaining / (1e3 * 60 * 60 * 24)), cancelAnimationFrame(this.animationRef), this.timeRemaining > 0 ? (this.emitShowWarning(), this.timeoutRef = setTimeout(() => {
        this.animationRef = requestAnimationFrame(this.getTimeRemaining);
      }, 1e3)) : (clearTimeout(this.timeoutRef), this.seconds = 0, this.minutes = 0, this.hours = 0, this.days = 0, this.$emit("counter-ended"));
    },
    emitShowWarning() {
      if (this.showWarningBelow) {
        const i = this.timeRemaining / 1e3 < this.showWarningBelow;
        this.warningShown !== i && (this.warningShown = i, this.$emit("warning-shown", this.warningShown));
      }
    },
    isDateObject(i) {
      return Object.prototype.toString.call(i) === "[object Date]";
    },
    isUnixTime(i) {
      return Number.isInteger(i);
    },
    pad(i) {
      return (i == null ? void 0 : i.toString().length) < 2 ? `0${i}`.slice(-2) : i;
    }
  }
};
var s5 = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "acv-time-counter" }, [t._t("prepend"), t._t("default", function() {
    return [e("span", { staticClass: "formatted-time" }, [t._v(t._s(t.formattedTime))])];
  }, { formattedTime: t.formattedTime, days: t.days, seconds: t.seconds, minutes: t.minutes, hours: t.hours }), t._t("append")], 2);
}, r5 = [], a5 = /* @__PURE__ */ U(
  n5,
  s5,
  r5,
  !1,
  null,
  null
);
const o5 = a5.exports, l5 = {
  name: "AcvTopBar",
  components: {
    AcvButton: bi,
    AcvIcon: ie,
    AcvIconButton: Ee,
    AcvBadge: xa
  },
  props: {
    /**
    * Left Title content
    */
    leftTitle: {
      type: String,
      default: ""
    },
    /**
    * Hides icon beside Left Title
    */
    hideLeftTitleIcon: {
      type: Boolean,
      default: !1
    },
    /**
    * Middle Title content
    */
    middleTitle: {
      type: String,
      default: ""
    },
    /**
    * Shows the middle content which also hides the left title
    */
    showMiddle: {
      type: Boolean,
      default: !1
    },
    /**
    * Shows back button when showing middle content
    */
    showBackButton: {
      type: Boolean,
      default: !0
    },
    /**
    * Shows left link button when showing middle content
    */
    leftLink: {
      type: String,
      default: ""
    },
    /**
     * Badge content to be displayed beside left title
     */
    badgeContent: {
      type: [String, Number],
      default: null
    },
    /**
    * Array of objects representing button or icon props for the default right slot
    */
    toolbarItems: {
      type: Array,
      default: () => [],
      validator(i) {
        return i.length <= 2;
      }
    }
  },
  computed: {
    computedClasses() {
      return {
        "acv-top-bar--three-columns": this.showMiddle
      };
    }
  },
  methods: {
    handleItemClick(i, t) {
      this.$emit("toolbar-item-click", { $event: i, handler: t });
    }
  }
};
var c5 = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "acv-top-bar", class: t.computedClasses }, [e("div", { staticClass: "acv-top-bar__left" }, [t._t("left", function() {
    return [t.showMiddle ? [t.showBackButton ? e("acv-icon-button", { staticClass: "acv-top-bar__icon-button acv-top-bar__icon-button--back", attrs: { "show-tooltip": !1, "icon-type": "arrow-back", "aria-label": "Back" }, on: { click: function(n) {
      return t.$emit("back", n);
    } } }) : t._e(), t.leftLink ? e("acv-button", { staticClass: "acv-top-bar__link", attrs: { variant: "tertiary", size: "small", "aria-label": t.leftLink }, on: { click: function(n) {
      return t.$emit("left-link-click", n);
    } } }, [t._v(" " + t._s(t.leftLink) + " ")]) : t._e()] : [e("div", { staticClass: "acv-top-bar__left-content", on: { click: function(n) {
      return t.$emit("left-title-click", n);
    }, keypress: function(n) {
      return !n.type.indexOf("key") && t._k(n.keyCode, "space", 32, n.key, [" ", "Spacebar"]) ? null : t.$emit("left-title-click", n);
    } } }, [e("h6", [t._v(t._s(t.leftTitle))]), t.hideLeftTitleIcon ? t._e() : e("acv-icon", { staticClass: "acv-top-bar__icon acv-top-bar__icon--left-title-icon", attrs: { icon: "arrow-drop-down" } }), t.badgeContent ? e("div", { staticClass: "acv-top-bar__left__badge" }, [e("acv-badge", { attrs: { content: t.badgeContent } })], 1) : t._e()], 1)]];
  })], 2), t.showMiddle ? [e("div", { staticClass: "acv-top-bar__middle" }, [t._t("middle", function() {
    return [e("div", { staticClass: "acv-top-bar__middle-content", on: { click: function(n) {
      return t.$emit("middle-title-click", n);
    }, keypress: function(n) {
      return !n.type.indexOf("key") && t._k(n.keyCode, "space", 32, n.key, [" ", "Spacebar"]) ? null : t.$emit("middle-title-click", n);
    } } }, [e("h6", [t._v(t._s(t.middleTitle))])])];
  })], 2)] : t._e(), e("div", { staticClass: "acv-top-bar__right" }, [t._t("right", function() {
    return [t._l(t.toolbarItems, function(n, s) {
      return [["button", "icon-button"].includes(n.component) ? e(`acv-${n.component}`, t._b({ key: s, tag: "component", class: {
        "acv-top-bar__toolbar-item": !0,
        "acv-top-bar__icon-button": n.component === "icon-button",
        "acv-top-bar__link": n.component === "button"
      }, attrs: { variant: "tertiary", size: "small", "aria-label": n.content }, on: { click: function(r) {
        return t.handleItemClick(r, n.handler);
      } } }, "component", n, !1), [t._v(" " + t._s(n.content) + " ")]) : t._e()];
    })];
  })], 2)], 2);
}, u5 = [], d5 = /* @__PURE__ */ U(
  l5,
  c5,
  u5,
  !1,
  null,
  "b12b24d1"
);
const h5 = d5.exports;
var qh = { exports: {} };
(function(i, t) {
  (function(n, s) {
    i.exports = s();
  })(typeof self < "u" ? self : hi, function() {
    return (
      /******/
      function(e) {
        var n = {};
        function s(r) {
          if (n[r])
            return n[r].exports;
          var a = n[r] = {
            /******/
            i: r,
            /******/
            l: !1,
            /******/
            exports: {}
            /******/
          };
          return e[r].call(a.exports, a, a.exports, s), a.l = !0, a.exports;
        }
        return s.m = e, s.c = n, s.d = function(r, a, o) {
          s.o(r, a) || Object.defineProperty(r, a, { enumerable: !0, get: o });
        }, s.r = function(r) {
          typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(r, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(r, "__esModule", { value: !0 });
        }, s.t = function(r, a) {
          if (a & 1 && (r = s(r)), a & 8 || a & 4 && typeof r == "object" && r && r.__esModule) return r;
          var o = /* @__PURE__ */ Object.create(null);
          if (s.r(o), Object.defineProperty(o, "default", { enumerable: !0, value: r }), a & 2 && typeof r != "string") for (var l in r) s.d(o, l, (function(c) {
            return r[c];
          }).bind(null, l));
          return o;
        }, s.n = function(r) {
          var a = r && r.__esModule ? (
            /******/
            function() {
              return r.default;
            }
          ) : (
            /******/
            function() {
              return r;
            }
          );
          return s.d(a, "a", a), a;
        }, s.o = function(r, a) {
          return Object.prototype.hasOwnProperty.call(r, a);
        }, s.p = "", s(s.s = "fb15");
      }({
        /***/
        "00ee": (
          /***/
          function(e, n, s) {
            var r = s("b622"), a = r("toStringTag"), o = {};
            o[a] = "z", e.exports = String(o) === "[object z]";
          }
        ),
        /***/
        "057f": (
          /***/
          function(e, n, s) {
            var r = s("fc6a"), a = s("241c").f, o = {}.toString, l = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [], c = function(u) {
              try {
                return a(u);
              } catch {
                return l.slice();
              }
            };
            e.exports.f = function(d) {
              return l && o.call(d) == "[object Window]" ? c(d) : a(r(d));
            };
          }
        ),
        /***/
        "06cf": (
          /***/
          function(e, n, s) {
            var r = s("83ab"), a = s("d1e7"), o = s("5c6c"), l = s("fc6a"), c = s("c04e"), u = s("5135"), d = s("0cfb"), h = Object.getOwnPropertyDescriptor;
            n.f = r ? h : function(p, g) {
              if (p = l(p), g = c(g, !0), d) try {
                return h(p, g);
              } catch {
              }
              if (u(p, g)) return o(!a.f.call(p, g), p[g]);
            };
          }
        ),
        /***/
        "07e8": (
          /***/
          function(e, n, s) {
            var r = s("2f28"), a = /* @__PURE__ */ s.n(r);
            a.a;
          }
        ),
        /***/
        "0cfb": (
          /***/
          function(e, n, s) {
            var r = s("83ab"), a = s("d039"), o = s("cc12");
            e.exports = !r && !a(function() {
              return Object.defineProperty(o("div"), "a", {
                get: function() {
                  return 7;
                }
              }).a != 7;
            });
          }
        ),
        /***/
        "14c3": (
          /***/
          function(e, n, s) {
            var r = s("c6b6"), a = s("9263");
            e.exports = function(o, l) {
              var c = o.exec;
              if (typeof c == "function") {
                var u = c.call(o, l);
                if (typeof u != "object")
                  throw TypeError("RegExp exec method returned something other than an Object or null");
                return u;
              }
              if (r(o) !== "RegExp")
                throw TypeError("RegExp#exec called on incompatible receiver");
              return a.call(o, l);
            };
          }
        ),
        /***/
        "159b": (
          /***/
          function(e, n, s) {
            var r = s("da84"), a = s("fdbc"), o = s("17c2"), l = s("9112");
            for (var c in a) {
              var u = r[c], d = u && u.prototype;
              if (d && d.forEach !== o) try {
                l(d, "forEach", o);
              } catch {
                d.forEach = o;
              }
            }
          }
        ),
        /***/
        "17c2": (
          /***/
          function(e, n, s) {
            var r = s("b727").forEach, a = s("b301");
            e.exports = a("forEach") ? function(l) {
              return r(this, l, arguments.length > 1 ? arguments[1] : void 0);
            } : [].forEach;
          }
        ),
        /***/
        "19aa": (
          /***/
          function(e, n) {
            e.exports = function(s, r, a) {
              if (!(s instanceof r))
                throw TypeError("Incorrect " + (a ? a + " " : "") + "invocation");
              return s;
            };
          }
        ),
        /***/
        "1be4": (
          /***/
          function(e, n, s) {
            var r = s("d066");
            e.exports = r("document", "documentElement");
          }
        ),
        /***/
        "1c0b": (
          /***/
          function(e, n) {
            e.exports = function(s) {
              if (typeof s != "function")
                throw TypeError(String(s) + " is not a function");
              return s;
            };
          }
        ),
        /***/
        "1c7e": (
          /***/
          function(e, n, s) {
            var r = s("b622"), a = r("iterator"), o = !1;
            try {
              var l = 0, c = {
                next: function() {
                  return { done: !!l++ };
                },
                return: function() {
                  o = !0;
                }
              };
              c[a] = function() {
                return this;
              }, Array.from(c, function() {
                throw 2;
              });
            } catch {
            }
            e.exports = function(u, d) {
              if (!d && !o) return !1;
              var h = !1;
              try {
                var f = {};
                f[a] = function() {
                  return {
                    next: function() {
                      return { done: h = !0 };
                    }
                  };
                }, u(f);
              } catch {
              }
              return h;
            };
          }
        ),
        /***/
        "1d80": (
          /***/
          function(e, n) {
            e.exports = function(s) {
              if (s == null) throw TypeError("Can't call method on " + s);
              return s;
            };
          }
        ),
        /***/
        "1dde": (
          /***/
          function(e, n, s) {
            var r = s("d039"), a = s("b622"), o = s("60ae"), l = a("species");
            e.exports = function(c) {
              return o >= 51 || !r(function() {
                var u = [], d = u.constructor = {};
                return d[l] = function() {
                  return { foo: 1 };
                }, u[c](Boolean).foo !== 1;
              });
            };
          }
        ),
        /***/
        2266: (
          /***/
          function(e, n, s) {
            var r = s("825a"), a = s("e95a"), o = s("50c4"), l = s("f8c2"), c = s("35a1"), u = s("9bdd"), d = function(f, p) {
              this.stopped = f, this.result = p;
            }, h = e.exports = function(f, p, g, m, v) {
              var b = l(p, g, m ? 2 : 1), _, S, C, O, k, P, x;
              if (v)
                _ = f;
              else {
                if (S = c(f), typeof S != "function") throw TypeError("Target is not iterable");
                if (a(S)) {
                  for (C = 0, O = o(f.length); O > C; C++)
                    if (k = m ? b(r(x = f[C])[0], x[1]) : b(f[C]), k && k instanceof d) return k;
                  return new d(!1);
                }
                _ = S.call(f);
              }
              for (P = _.next; !(x = P.call(_)).done; )
                if (k = u(_, b, x.value, m), typeof k == "object" && k && k instanceof d) return k;
              return new d(!1);
            };
            h.stop = function(f) {
              return new d(!0, f);
            };
          }
        ),
        /***/
        "23cb": (
          /***/
          function(e, n, s) {
            var r = s("a691"), a = Math.max, o = Math.min;
            e.exports = function(l, c) {
              var u = r(l);
              return u < 0 ? a(u + c, 0) : o(u, c);
            };
          }
        ),
        /***/
        "23e7": (
          /***/
          function(e, n, s) {
            var r = s("da84"), a = s("06cf").f, o = s("9112"), l = s("6eeb"), c = s("ce4e"), u = s("e893"), d = s("94ca");
            e.exports = function(h, f) {
              var p = h.target, g = h.global, m = h.stat, v, b, _, S, C, O;
              if (g ? b = r : m ? b = r[p] || c(p, {}) : b = (r[p] || {}).prototype, b) for (_ in f) {
                if (C = f[_], h.noTargetGet ? (O = a(b, _), S = O && O.value) : S = b[_], v = d(g ? _ : p + (m ? "." : "#") + _, h.forced), !v && S !== void 0) {
                  if (typeof C == typeof S) continue;
                  u(C, S);
                }
                (h.sham || S && S.sham) && o(C, "sham", !0), l(b, _, C, h);
              }
            };
          }
        ),
        /***/
        "241c": (
          /***/
          function(e, n, s) {
            var r = s("ca84"), a = s("7839"), o = a.concat("length", "prototype");
            n.f = Object.getOwnPropertyNames || function(c) {
              return r(c, o);
            };
          }
        ),
        /***/
        2532: (
          /***/
          function(e, n, s) {
            var r = s("23e7"), a = s("5a34"), o = s("1d80"), l = s("ab13");
            r({ target: "String", proto: !0, forced: !l("includes") }, {
              includes: function(u) {
                return !!~String(o(this)).indexOf(a(u), arguments.length > 1 ? arguments[1] : void 0);
              }
            });
          }
        ),
        /***/
        2626: (
          /***/
          function(e, n, s) {
            var r = s("d066"), a = s("9bf2"), o = s("b622"), l = s("83ab"), c = o("species");
            e.exports = function(u) {
              var d = r(u), h = a.f;
              l && d && !d[c] && h(d, c, {
                configurable: !0,
                get: function() {
                  return this;
                }
              });
            };
          }
        ),
        /***/
        "2cf4": (
          /***/
          function(e, n, s) {
            var r = s("da84"), a = s("d039"), o = s("c6b6"), l = s("f8c2"), c = s("1be4"), u = s("cc12"), d = s("b629"), h = r.location, f = r.setImmediate, p = r.clearImmediate, g = r.process, m = r.MessageChannel, v = r.Dispatch, b = 0, _ = {}, S = "onreadystatechange", C, O, k, P = function(L) {
              if (_.hasOwnProperty(L)) {
                var Y = _[L];
                delete _[L], Y();
              }
            }, x = function(L) {
              return function() {
                P(L);
              };
            }, R = function(L) {
              P(L.data);
            }, B = function(L) {
              r.postMessage(L + "", h.protocol + "//" + h.host);
            };
            (!f || !p) && (f = function(Y) {
              for (var j = [], w = 1; arguments.length > w; ) j.push(arguments[w++]);
              return _[++b] = function() {
                (typeof Y == "function" ? Y : Function(Y)).apply(void 0, j);
              }, C(b), b;
            }, p = function(Y) {
              delete _[Y];
            }, o(g) == "process" ? C = function(L) {
              g.nextTick(x(L));
            } : v && v.now ? C = function(L) {
              v.now(x(L));
            } : m && !d ? (O = new m(), k = O.port2, O.port1.onmessage = R, C = l(k.postMessage, k, 1)) : r.addEventListener && typeof postMessage == "function" && !r.importScripts && !a(B) ? (C = B, r.addEventListener("message", R, !1)) : S in u("script") ? C = function(L) {
              c.appendChild(u("script"))[S] = function() {
                c.removeChild(this), P(L);
              };
            } : C = function(L) {
              setTimeout(x(L), 0);
            }), e.exports = {
              set: f,
              clear: p
            };
          }
        ),
        /***/
        "2f28": (
          /***/
          function(e, n, s) {
          }
        ),
        /***/
        "35a1": (
          /***/
          function(e, n, s) {
            var r = s("f5df"), a = s("3f8c"), o = s("b622"), l = o("iterator");
            e.exports = function(c) {
              if (c != null) return c[l] || c["@@iterator"] || a[r(c)];
            };
          }
        ),
        /***/
        "37e8": (
          /***/
          function(e, n, s) {
            var r = s("83ab"), a = s("9bf2"), o = s("825a"), l = s("df75");
            e.exports = r ? Object.defineProperties : function(u, d) {
              o(u);
              for (var h = l(d), f = h.length, p = 0, g; f > p; ) a.f(u, g = h[p++], d[g]);
              return u;
            };
          }
        ),
        /***/
        "3f8c": (
          /***/
          function(e, n) {
            e.exports = {};
          }
        ),
        /***/
        4160: (
          /***/
          function(e, n, s) {
            var r = s("23e7"), a = s("17c2");
            r({ target: "Array", proto: !0, forced: [].forEach != a }, {
              forEach: a
            });
          }
        ),
        /***/
        "428f": (
          /***/
          function(e, n, s) {
            var r = s("da84");
            e.exports = r;
          }
        ),
        /***/
        "44ad": (
          /***/
          function(e, n, s) {
            var r = s("d039"), a = s("c6b6"), o = "".split;
            e.exports = r(function() {
              return !Object("z").propertyIsEnumerable(0);
            }) ? function(l) {
              return a(l) == "String" ? o.call(l, "") : Object(l);
            } : Object;
          }
        ),
        /***/
        "44d2": (
          /***/
          function(e, n, s) {
            var r = s("b622"), a = s("7c73"), o = s("9112"), l = r("unscopables"), c = Array.prototype;
            c[l] == null && o(c, l, a(null)), e.exports = function(u) {
              c[l][u] = !0;
            };
          }
        ),
        /***/
        "44de": (
          /***/
          function(e, n, s) {
            var r = s("da84");
            e.exports = function(a, o) {
              var l = r.console;
              l && l.error && (arguments.length === 1 ? l.error(a) : l.error(a, o));
            };
          }
        ),
        /***/
        "44e7": (
          /***/
          function(e, n, s) {
            var r = s("861d"), a = s("c6b6"), o = s("b622"), l = o("match");
            e.exports = function(c) {
              var u;
              return r(c) && ((u = c[l]) !== void 0 ? !!u : a(c) == "RegExp");
            };
          }
        ),
        /***/
        4840: (
          /***/
          function(e, n, s) {
            var r = s("825a"), a = s("1c0b"), o = s("b622"), l = o("species");
            e.exports = function(c, u) {
              var d = r(c).constructor, h;
              return d === void 0 || (h = r(d)[l]) == null ? u : a(h);
            };
          }
        ),
        /***/
        4930: (
          /***/
          function(e, n, s) {
            var r = s("d039");
            e.exports = !!Object.getOwnPropertySymbols && !r(function() {
              return !String(Symbol());
            });
          }
        ),
        /***/
        "4b09": (
          /***/
          function(e, n, s) {
            var r = s("7029"), a = /* @__PURE__ */ s.n(r);
            a.a;
          }
        ),
        /***/
        "4d64": (
          /***/
          function(e, n, s) {
            var r = s("fc6a"), a = s("50c4"), o = s("23cb"), l = function(c) {
              return function(u, d, h) {
                var f = r(u), p = a(f.length), g = o(h, p), m;
                if (c && d != d) {
                  for (; p > g; )
                    if (m = f[g++], m != m) return !0;
                } else for (; p > g; g++)
                  if ((c || g in f) && f[g] === d) return c || g || 0;
                return !c && -1;
              };
            };
            e.exports = {
              // `Array.prototype.includes` method
              // https://tc39.github.io/ecma262/#sec-array.prototype.includes
              includes: l(!0),
              // `Array.prototype.indexOf` method
              // https://tc39.github.io/ecma262/#sec-array.prototype.indexof
              indexOf: l(!1)
            };
          }
        ),
        /***/
        "4de4": (
          /***/
          function(e, n, s) {
            var r = s("23e7"), a = s("b727").filter, o = s("d039"), l = s("1dde"), c = l("filter"), u = c && !o(function() {
              [].filter.call({ length: -1, 0: 1 }, function(d) {
                throw d;
              });
            });
            r({ target: "Array", proto: !0, forced: !c || !u }, {
              filter: function(h) {
                return a(this, h, arguments.length > 1 ? arguments[1] : void 0);
              }
            });
          }
        ),
        /***/
        "50c4": (
          /***/
          function(e, n, s) {
            var r = s("a691"), a = Math.min;
            e.exports = function(o) {
              return o > 0 ? a(r(o), 9007199254740991) : 0;
            };
          }
        ),
        /***/
        5135: (
          /***/
          function(e, n) {
            var s = {}.hasOwnProperty;
            e.exports = function(r, a) {
              return s.call(r, a);
            };
          }
        ),
        /***/
        5319: (
          /***/
          function(e, n, s) {
            var r = s("d784"), a = s("825a"), o = s("7b0b"), l = s("50c4"), c = s("a691"), u = s("1d80"), d = s("8aa5"), h = s("14c3"), f = Math.max, p = Math.min, g = Math.floor, m = /\$([$&'`]|\d\d?|<[^>]*>)/g, v = /\$([$&'`]|\d\d?)/g, b = function(_) {
              return _ === void 0 ? _ : String(_);
            };
            r("replace", 2, function(_, S, C) {
              return [
                // `String.prototype.replace` method
                // https://tc39.github.io/ecma262/#sec-string.prototype.replace
                function(P, x) {
                  var R = u(this), B = P == null ? void 0 : P[_];
                  return B !== void 0 ? B.call(P, R, x) : S.call(String(R), P, x);
                },
                // `RegExp.prototype[@@replace]` method
                // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
                function(k, P) {
                  var x = C(S, k, this, P);
                  if (x.done) return x.value;
                  var R = a(k), B = String(this), L = typeof P == "function";
                  L || (P = String(P));
                  var Y = R.global;
                  if (Y) {
                    var j = R.unicode;
                    R.lastIndex = 0;
                  }
                  for (var w = []; ; ) {
                    var I = h(R, B);
                    if (I === null || (w.push(I), !Y)) break;
                    var T = String(I[0]);
                    T === "" && (R.lastIndex = d(B, l(R.lastIndex), j));
                  }
                  for (var V = "", N = 0, z = 0; z < w.length; z++) {
                    I = w[z];
                    for (var E = String(I[0]), H = f(p(c(I.index), B.length), 0), y = [], $ = 1; $ < I.length; $++) y.push(b(I[$]));
                    var D = I.groups;
                    if (L) {
                      var Z = [E].concat(y, H, B);
                      D !== void 0 && Z.push(D);
                      var J = String(P.apply(void 0, Z));
                    } else
                      J = O(E, B, H, y, D, P);
                    H >= N && (V += B.slice(N, H) + J, N = H + E.length);
                  }
                  return V + B.slice(N);
                }
              ];
              function O(k, P, x, R, B, L) {
                var Y = x + k.length, j = R.length, w = v;
                return B !== void 0 && (B = o(B), w = m), S.call(L, w, function(I, T) {
                  var V;
                  switch (T.charAt(0)) {
                    case "$":
                      return "$";
                    case "&":
                      return k;
                    case "`":
                      return P.slice(0, x);
                    case "'":
                      return P.slice(Y);
                    case "<":
                      V = B[T.slice(1, -1)];
                      break;
                    default:
                      var N = +T;
                      if (N === 0) return I;
                      if (N > j) {
                        var z = g(N / 10);
                        return z === 0 ? I : z <= j ? R[z - 1] === void 0 ? T.charAt(1) : R[z - 1] + T.charAt(1) : I;
                      }
                      V = R[N - 1];
                  }
                  return V === void 0 ? "" : V;
                });
              }
            });
          }
        ),
        /***/
        5692: (
          /***/
          function(e, n, s) {
            var r = s("c430"), a = s("c6cd");
            (e.exports = function(o, l) {
              return a[o] || (a[o] = l !== void 0 ? l : {});
            })("versions", []).push({
              version: "3.4.7",
              mode: r ? "pure" : "global",
              copyright: "© 2019 Denis Pushkarev (zloirock.ru)"
            });
          }
        ),
        /***/
        "56ef": (
          /***/
          function(e, n, s) {
            var r = s("d066"), a = s("241c"), o = s("7418"), l = s("825a");
            e.exports = r("Reflect", "ownKeys") || function(u) {
              var d = a.f(l(u)), h = o.f;
              return h ? d.concat(h(u)) : d;
            };
          }
        ),
        /***/
        5899: (
          /***/
          function(e, n) {
            e.exports = `	
\v\f\r                　\u2028\u2029\uFEFF`;
          }
        ),
        /***/
        "58a8": (
          /***/
          function(e, n, s) {
            var r = s("1d80"), a = s("5899"), o = "[" + a + "]", l = RegExp("^" + o + o + "*"), c = RegExp(o + o + "*$"), u = function(d) {
              return function(h) {
                var f = String(r(h));
                return d & 1 && (f = f.replace(l, "")), d & 2 && (f = f.replace(c, "")), f;
              };
            };
            e.exports = {
              // `String.prototype.{ trimLeft, trimStart }` methods
              // https://tc39.github.io/ecma262/#sec-string.prototype.trimstart
              start: u(1),
              // `String.prototype.{ trimRight, trimEnd }` methods
              // https://tc39.github.io/ecma262/#sec-string.prototype.trimend
              end: u(2),
              // `String.prototype.trim` method
              // https://tc39.github.io/ecma262/#sec-string.prototype.trim
              trim: u(3)
            };
          }
        ),
        /***/
        "5a34": (
          /***/
          function(e, n, s) {
            var r = s("44e7");
            e.exports = function(a) {
              if (r(a))
                throw TypeError("The method doesn't accept regular expressions");
              return a;
            };
          }
        ),
        /***/
        "5c6c": (
          /***/
          function(e, n) {
            e.exports = function(s, r) {
              return {
                enumerable: !(s & 1),
                configurable: !(s & 2),
                writable: !(s & 4),
                value: r
              };
            };
          }
        ),
        /***/
        "60ae": (
          /***/
          function(e, n, s) {
            var r = s("da84"), a = s("b39a"), o = r.process, l = o && o.versions, c = l && l.v8, u, d;
            c ? (u = c.split("."), d = u[0] + u[1]) : a && (u = a.match(/Edge\/(\d+)/), (!u || u[1] >= 74) && (u = a.match(/Chrome\/(\d+)/), u && (d = u[1]))), e.exports = d && +d;
          }
        ),
        /***/
        "60da": (
          /***/
          function(e, n, s) {
            var r = s("83ab"), a = s("d039"), o = s("df75"), l = s("7418"), c = s("d1e7"), u = s("7b0b"), d = s("44ad"), h = Object.assign, f = Object.defineProperty;
            e.exports = !h || a(function() {
              if (r && h({ b: 1 }, h(f({}, "a", {
                enumerable: !0,
                get: function() {
                  f(this, "b", {
                    value: 3,
                    enumerable: !1
                  });
                }
              }), { b: 2 })).b !== 1) return !0;
              var p = {}, g = {}, m = Symbol(), v = "abcdefghijklmnopqrst";
              return p[m] = 7, v.split("").forEach(function(b) {
                g[b] = b;
              }), h({}, p)[m] != 7 || o(h({}, g)).join("") != v;
            }) ? function(g, m) {
              for (var v = u(g), b = arguments.length, _ = 1, S = l.f, C = c.f; b > _; )
                for (var O = d(arguments[_++]), k = S ? o(O).concat(S(O)) : o(O), P = k.length, x = 0, R; P > x; )
                  R = k[x++], (!r || C.call(O, R)) && (v[R] = O[R]);
              return v;
            } : h;
          }
        ),
        /***/
        6547: (
          /***/
          function(e, n, s) {
            var r = s("a691"), a = s("1d80"), o = function(l) {
              return function(c, u) {
                var d = String(a(c)), h = r(u), f = d.length, p, g;
                return h < 0 || h >= f ? l ? "" : void 0 : (p = d.charCodeAt(h), p < 55296 || p > 56319 || h + 1 === f || (g = d.charCodeAt(h + 1)) < 56320 || g > 57343 ? l ? d.charAt(h) : p : l ? d.slice(h, h + 2) : (p - 55296 << 10) + (g - 56320) + 65536);
              };
            };
            e.exports = {
              // `String.prototype.codePointAt` method
              // https://tc39.github.io/ecma262/#sec-string.prototype.codepointat
              codeAt: o(!1),
              // `String.prototype.at` method
              // https://github.com/mathiasbynens/String.prototype.at
              charAt: o(!0)
            };
          }
        ),
        /***/
        "65f0": (
          /***/
          function(e, n, s) {
            var r = s("861d"), a = s("e8b5"), o = s("b622"), l = o("species");
            e.exports = function(c, u) {
              var d;
              return a(c) && (d = c.constructor, typeof d == "function" && (d === Array || a(d.prototype)) ? d = void 0 : r(d) && (d = d[l], d === null && (d = void 0))), new (d === void 0 ? Array : d)(u === 0 ? 0 : u);
            };
          }
        ),
        /***/
        "69f3": (
          /***/
          function(e, n, s) {
            var r = s("7f9a"), a = s("da84"), o = s("861d"), l = s("9112"), c = s("5135"), u = s("f772"), d = s("d012"), h = a.WeakMap, f, p, g, m = function(k) {
              return g(k) ? p(k) : f(k, {});
            }, v = function(k) {
              return function(P) {
                var x;
                if (!o(P) || (x = p(P)).type !== k)
                  throw TypeError("Incompatible receiver, " + k + " required");
                return x;
              };
            };
            if (r) {
              var b = new h(), _ = b.get, S = b.has, C = b.set;
              f = function(k, P) {
                return C.call(b, k, P), P;
              }, p = function(k) {
                return _.call(b, k) || {};
              }, g = function(k) {
                return S.call(b, k);
              };
            } else {
              var O = u("state");
              d[O] = !0, f = function(k, P) {
                return l(k, O, P), P;
              }, p = function(k) {
                return c(k, O) ? k[O] : {};
              }, g = function(k) {
                return c(k, O);
              };
            }
            e.exports = {
              set: f,
              get: p,
              has: g,
              enforce: m,
              getterFor: v
            };
          }
        ),
        /***/
        "6eeb": (
          /***/
          function(e, n, s) {
            var r = s("da84"), a = s("9112"), o = s("5135"), l = s("ce4e"), c = s("8925"), u = s("69f3"), d = u.get, h = u.enforce, f = String(String).split("String");
            (e.exports = function(p, g, m, v) {
              var b = v ? !!v.unsafe : !1, _ = v ? !!v.enumerable : !1, S = v ? !!v.noTargetGet : !1;
              if (typeof m == "function" && (typeof g == "string" && !o(m, "name") && a(m, "name", g), h(m).source = f.join(typeof g == "string" ? g : "")), p === r) {
                _ ? p[g] = m : l(g, m);
                return;
              } else b ? !S && p[g] && (_ = !0) : delete p[g];
              _ ? p[g] = m : a(p, g, m);
            })(Function.prototype, "toString", function() {
              return typeof this == "function" && d(this).source || c(this);
            });
          }
        ),
        /***/
        7029: (
          /***/
          function(e, n, s) {
          }
        ),
        /***/
        7418: (
          /***/
          function(e, n) {
            n.f = Object.getOwnPropertySymbols;
          }
        ),
        /***/
        "746f": (
          /***/
          function(e, n, s) {
            var r = s("428f"), a = s("5135"), o = s("c032"), l = s("9bf2").f;
            e.exports = function(c) {
              var u = r.Symbol || (r.Symbol = {});
              a(u, c) || l(u, c, {
                value: o.f(c)
              });
            };
          }
        ),
        /***/
        7839: (
          /***/
          function(e, n) {
            e.exports = [
              "constructor",
              "hasOwnProperty",
              "isPrototypeOf",
              "propertyIsEnumerable",
              "toLocaleString",
              "toString",
              "valueOf"
            ];
          }
        ),
        /***/
        "7b0b": (
          /***/
          function(e, n, s) {
            var r = s("1d80");
            e.exports = function(a) {
              return Object(r(a));
            };
          }
        ),
        /***/
        "7c73": (
          /***/
          function(e, n, s) {
            var r = s("825a"), a = s("37e8"), o = s("7839"), l = s("d012"), c = s("1be4"), u = s("cc12"), d = s("f772"), h = d("IE_PROTO"), f = "prototype", p = function() {
            }, g = function() {
              var m = u("iframe"), v = o.length, b = "<", _ = "script", S = ">", C = "java" + _ + ":", O;
              for (m.style.display = "none", c.appendChild(m), m.src = String(C), O = m.contentWindow.document, O.open(), O.write(b + _ + S + "document.F=Object" + b + "/" + _ + S), O.close(), g = O.F; v--; ) delete g[f][o[v]];
              return g();
            };
            e.exports = Object.create || function(v, b) {
              var _;
              return v !== null ? (p[f] = r(v), _ = new p(), p[f] = null, _[h] = v) : _ = g(), b === void 0 ? _ : a(_, b);
            }, l[h] = !0;
          }
        ),
        /***/
        "7f9a": (
          /***/
          function(e, n, s) {
            var r = s("da84"), a = s("8925"), o = r.WeakMap;
            e.exports = typeof o == "function" && /native code/.test(a(o));
          }
        ),
        /***/
        "825a": (
          /***/
          function(e, n, s) {
            var r = s("861d");
            e.exports = function(a) {
              if (!r(a))
                throw TypeError(String(a) + " is not an object");
              return a;
            };
          }
        ),
        /***/
        "83ab": (
          /***/
          function(e, n, s) {
            var r = s("d039");
            e.exports = !r(function() {
              return Object.defineProperty({}, "a", { get: function() {
                return 7;
              } }).a != 7;
            });
          }
        ),
        /***/
        8418: (
          /***/
          function(e, n, s) {
            var r = s("c04e"), a = s("9bf2"), o = s("5c6c");
            e.exports = function(l, c, u) {
              var d = r(c);
              d in l ? a.f(l, d, o(0, u)) : l[d] = u;
            };
          }
        ),
        /***/
        "861d": (
          /***/
          function(e, n) {
            e.exports = function(s) {
              return typeof s == "object" ? s !== null : typeof s == "function";
            };
          }
        ),
        /***/
        8634: (
          /***/
          function(e, n, s) {
            function r(d, h) {
              for (; d.length < h; )
                d = "0" + d;
              return d;
            }
            function a(d, h) {
              var f, p, g;
              if (h.length === 0)
                return d;
              for (f = 0, g = h.length; f < g; f++)
                p = h.charCodeAt(f), d = (d << 5) - d + p, d |= 0;
              return d < 0 ? d * -2 : d;
            }
            function o(d, h, f) {
              return Object.keys(h).sort().reduce(p, d);
              function p(g, m) {
                return l(g, h[m], m, f);
              }
            }
            function l(d, h, f, p) {
              var g = a(a(a(d, f), c(h)), typeof h);
              if (h === null)
                return a(g, "null");
              if (h === void 0)
                return a(g, "undefined");
              if (typeof h == "object" || typeof h == "function") {
                if (p.indexOf(h) !== -1)
                  return a(g, "[Circular]" + f);
                p.push(h);
                var m = o(g, h, p);
                if (!("valueOf" in h) || typeof h.valueOf != "function")
                  return m;
                try {
                  return a(m, String(h.valueOf()));
                } catch (v) {
                  return a(m, "[valueOf exception]" + (v.stack || v.message));
                }
              }
              return a(g, h.toString());
            }
            function c(d) {
              return Object.prototype.toString.call(d);
            }
            function u(d) {
              return r(l(0, d, "", []).toString(16), 8);
            }
            e.exports = u;
          }
        ),
        /***/
        8925: (
          /***/
          function(e, n, s) {
            var r = s("5692"), a = Function.toString;
            e.exports = r("inspectSource", function(o) {
              return a.call(o);
            });
          }
        ),
        /***/
        "8aa5": (
          /***/
          function(e, n, s) {
            var r = s("6547").charAt;
            e.exports = function(a, o, l) {
              return o + (l ? r(a, o).length : 1);
            };
          }
        ),
        /***/
        "90e3": (
          /***/
          function(e, n) {
            var s = 0, r = Math.random();
            e.exports = function(a) {
              return "Symbol(" + String(a === void 0 ? "" : a) + ")_" + (++s + r).toString(36);
            };
          }
        ),
        /***/
        9112: (
          /***/
          function(e, n, s) {
            var r = s("83ab"), a = s("9bf2"), o = s("5c6c");
            e.exports = r ? function(l, c, u) {
              return a.f(l, c, o(1, u));
            } : function(l, c, u) {
              return l[c] = u, l;
            };
          }
        ),
        /***/
        9263: (
          /***/
          function(e, n, s) {
            var r = s("ad6d"), a = RegExp.prototype.exec, o = String.prototype.replace, l = a, c = function() {
              var h = /a/, f = /b*/g;
              return a.call(h, "a"), a.call(f, "a"), h.lastIndex !== 0 || f.lastIndex !== 0;
            }(), u = /()??/.exec("")[1] !== void 0, d = c || u;
            d && (l = function(f) {
              var p = this, g, m, v, b;
              return u && (m = new RegExp("^" + p.source + "$(?!\\s)", r.call(p))), c && (g = p.lastIndex), v = a.call(p, f), c && v && (p.lastIndex = p.global ? v.index + v[0].length : g), u && v && v.length > 1 && o.call(v[0], m, function() {
                for (b = 1; b < arguments.length - 2; b++)
                  arguments[b] === void 0 && (v[b] = void 0);
              }), v;
            }), e.exports = l;
          }
        ),
        /***/
        "94ca": (
          /***/
          function(e, n, s) {
            var r = s("d039"), a = /#|\.prototype\./, o = function(h, f) {
              var p = c[l(h)];
              return p == d ? !0 : p == u ? !1 : typeof f == "function" ? r(f) : !!f;
            }, l = o.normalize = function(h) {
              return String(h).replace(a, ".").toLowerCase();
            }, c = o.data = {}, u = o.NATIVE = "N", d = o.POLYFILL = "P";
            e.exports = o;
          }
        ),
        /***/
        "96cf": (
          /***/
          function(e, n, s) {
            var r = function(a) {
              var o = Object.prototype, l = o.hasOwnProperty, c, u = typeof Symbol == "function" ? Symbol : {}, d = u.iterator || "@@iterator", h = u.asyncIterator || "@@asyncIterator", f = u.toStringTag || "@@toStringTag";
              function p(E, H, y, $) {
                var D = H && H.prototype instanceof C ? H : C, Z = Object.create(D.prototype), J = new V($ || []);
                return Z._invoke = j(E, y, J), Z;
              }
              a.wrap = p;
              function g(E, H, y) {
                try {
                  return { type: "normal", arg: E.call(H, y) };
                } catch ($) {
                  return { type: "throw", arg: $ };
                }
              }
              var m = "suspendedStart", v = "suspendedYield", b = "executing", _ = "completed", S = {};
              function C() {
              }
              function O() {
              }
              function k() {
              }
              var P = {};
              P[d] = function() {
                return this;
              };
              var x = Object.getPrototypeOf, R = x && x(x(N([])));
              R && R !== o && l.call(R, d) && (P = R);
              var B = k.prototype = C.prototype = Object.create(P);
              O.prototype = B.constructor = k, k.constructor = O, k[f] = O.displayName = "GeneratorFunction";
              function L(E) {
                ["next", "throw", "return"].forEach(function(H) {
                  E[H] = function(y) {
                    return this._invoke(H, y);
                  };
                });
              }
              a.isGeneratorFunction = function(E) {
                var H = typeof E == "function" && E.constructor;
                return H ? H === O || // For the native GeneratorFunction constructor, the best we can
                // do is to check its .name property.
                (H.displayName || H.name) === "GeneratorFunction" : !1;
              }, a.mark = function(E) {
                return Object.setPrototypeOf ? Object.setPrototypeOf(E, k) : (E.__proto__ = k, f in E || (E[f] = "GeneratorFunction")), E.prototype = Object.create(B), E;
              }, a.awrap = function(E) {
                return { __await: E };
              };
              function Y(E) {
                function H(D, Z, J, lt) {
                  var Q = g(E[D], E, Z);
                  if (Q.type === "throw")
                    lt(Q.arg);
                  else {
                    var ot = Q.arg, st = ot.value;
                    return st && typeof st == "object" && l.call(st, "__await") ? Promise.resolve(st.__await).then(function(ft) {
                      H("next", ft, J, lt);
                    }, function(ft) {
                      H("throw", ft, J, lt);
                    }) : Promise.resolve(st).then(function(ft) {
                      ot.value = ft, J(ot);
                    }, function(ft) {
                      return H("throw", ft, J, lt);
                    });
                  }
                }
                var y;
                function $(D, Z) {
                  function J() {
                    return new Promise(function(lt, Q) {
                      H(D, Z, lt, Q);
                    });
                  }
                  return y = // If enqueue has been called before, then we want to wait until
                  // all previous Promises have been resolved before calling invoke,
                  // so that results are always delivered in the correct order. If
                  // enqueue has not been called before, then it is important to
                  // call invoke immediately, without waiting on a callback to fire,
                  // so that the async generator function has the opportunity to do
                  // any necessary setup in a predictable way. This predictability
                  // is why the Promise constructor synchronously invokes its
                  // executor callback, and why async functions synchronously
                  // execute code before the first await. Since we implement simple
                  // async functions in terms of async generators, it is especially
                  // important to get this right, even though it requires care.
                  y ? y.then(
                    J,
                    // Avoid propagating failures to Promises returned by later
                    // invocations of the iterator.
                    J
                  ) : J();
                }
                this._invoke = $;
              }
              L(Y.prototype), Y.prototype[h] = function() {
                return this;
              }, a.AsyncIterator = Y, a.async = function(E, H, y, $) {
                var D = new Y(
                  p(E, H, y, $)
                );
                return a.isGeneratorFunction(H) ? D : D.next().then(function(Z) {
                  return Z.done ? Z.value : D.next();
                });
              };
              function j(E, H, y) {
                var $ = m;
                return function(Z, J) {
                  if ($ === b)
                    throw new Error("Generator is already running");
                  if ($ === _) {
                    if (Z === "throw")
                      throw J;
                    return z();
                  }
                  for (y.method = Z, y.arg = J; ; ) {
                    var lt = y.delegate;
                    if (lt) {
                      var Q = w(lt, y);
                      if (Q) {
                        if (Q === S) continue;
                        return Q;
                      }
                    }
                    if (y.method === "next")
                      y.sent = y._sent = y.arg;
                    else if (y.method === "throw") {
                      if ($ === m)
                        throw $ = _, y.arg;
                      y.dispatchException(y.arg);
                    } else y.method === "return" && y.abrupt("return", y.arg);
                    $ = b;
                    var ot = g(E, H, y);
                    if (ot.type === "normal") {
                      if ($ = y.done ? _ : v, ot.arg === S)
                        continue;
                      return {
                        value: ot.arg,
                        done: y.done
                      };
                    } else ot.type === "throw" && ($ = _, y.method = "throw", y.arg = ot.arg);
                  }
                };
              }
              function w(E, H) {
                var y = E.iterator[H.method];
                if (y === c) {
                  if (H.delegate = null, H.method === "throw") {
                    if (E.iterator.return && (H.method = "return", H.arg = c, w(E, H), H.method === "throw"))
                      return S;
                    H.method = "throw", H.arg = new TypeError(
                      "The iterator does not provide a 'throw' method"
                    );
                  }
                  return S;
                }
                var $ = g(y, E.iterator, H.arg);
                if ($.type === "throw")
                  return H.method = "throw", H.arg = $.arg, H.delegate = null, S;
                var D = $.arg;
                if (!D)
                  return H.method = "throw", H.arg = new TypeError("iterator result is not an object"), H.delegate = null, S;
                if (D.done)
                  H[E.resultName] = D.value, H.next = E.nextLoc, H.method !== "return" && (H.method = "next", H.arg = c);
                else
                  return D;
                return H.delegate = null, S;
              }
              L(B), B[f] = "Generator", B[d] = function() {
                return this;
              }, B.toString = function() {
                return "[object Generator]";
              };
              function I(E) {
                var H = { tryLoc: E[0] };
                1 in E && (H.catchLoc = E[1]), 2 in E && (H.finallyLoc = E[2], H.afterLoc = E[3]), this.tryEntries.push(H);
              }
              function T(E) {
                var H = E.completion || {};
                H.type = "normal", delete H.arg, E.completion = H;
              }
              function V(E) {
                this.tryEntries = [{ tryLoc: "root" }], E.forEach(I, this), this.reset(!0);
              }
              a.keys = function(E) {
                var H = [];
                for (var y in E)
                  H.push(y);
                return H.reverse(), function $() {
                  for (; H.length; ) {
                    var D = H.pop();
                    if (D in E)
                      return $.value = D, $.done = !1, $;
                  }
                  return $.done = !0, $;
                };
              };
              function N(E) {
                if (E) {
                  var H = E[d];
                  if (H)
                    return H.call(E);
                  if (typeof E.next == "function")
                    return E;
                  if (!isNaN(E.length)) {
                    var y = -1, $ = function D() {
                      for (; ++y < E.length; )
                        if (l.call(E, y))
                          return D.value = E[y], D.done = !1, D;
                      return D.value = c, D.done = !0, D;
                    };
                    return $.next = $;
                  }
                }
                return { next: z };
              }
              a.values = N;
              function z() {
                return { value: c, done: !0 };
              }
              return V.prototype = {
                constructor: V,
                reset: function(E) {
                  if (this.prev = 0, this.next = 0, this.sent = this._sent = c, this.done = !1, this.delegate = null, this.method = "next", this.arg = c, this.tryEntries.forEach(T), !E)
                    for (var H in this)
                      H.charAt(0) === "t" && l.call(this, H) && !isNaN(+H.slice(1)) && (this[H] = c);
                },
                stop: function() {
                  this.done = !0;
                  var E = this.tryEntries[0], H = E.completion;
                  if (H.type === "throw")
                    throw H.arg;
                  return this.rval;
                },
                dispatchException: function(E) {
                  if (this.done)
                    throw E;
                  var H = this;
                  function y(Q, ot) {
                    return Z.type = "throw", Z.arg = E, H.next = Q, ot && (H.method = "next", H.arg = c), !!ot;
                  }
                  for (var $ = this.tryEntries.length - 1; $ >= 0; --$) {
                    var D = this.tryEntries[$], Z = D.completion;
                    if (D.tryLoc === "root")
                      return y("end");
                    if (D.tryLoc <= this.prev) {
                      var J = l.call(D, "catchLoc"), lt = l.call(D, "finallyLoc");
                      if (J && lt) {
                        if (this.prev < D.catchLoc)
                          return y(D.catchLoc, !0);
                        if (this.prev < D.finallyLoc)
                          return y(D.finallyLoc);
                      } else if (J) {
                        if (this.prev < D.catchLoc)
                          return y(D.catchLoc, !0);
                      } else if (lt) {
                        if (this.prev < D.finallyLoc)
                          return y(D.finallyLoc);
                      } else
                        throw new Error("try statement without catch or finally");
                    }
                  }
                },
                abrupt: function(E, H) {
                  for (var y = this.tryEntries.length - 1; y >= 0; --y) {
                    var $ = this.tryEntries[y];
                    if ($.tryLoc <= this.prev && l.call($, "finallyLoc") && this.prev < $.finallyLoc) {
                      var D = $;
                      break;
                    }
                  }
                  D && (E === "break" || E === "continue") && D.tryLoc <= H && H <= D.finallyLoc && (D = null);
                  var Z = D ? D.completion : {};
                  return Z.type = E, Z.arg = H, D ? (this.method = "next", this.next = D.finallyLoc, S) : this.complete(Z);
                },
                complete: function(E, H) {
                  if (E.type === "throw")
                    throw E.arg;
                  return E.type === "break" || E.type === "continue" ? this.next = E.arg : E.type === "return" ? (this.rval = this.arg = E.arg, this.method = "return", this.next = "end") : E.type === "normal" && H && (this.next = H), S;
                },
                finish: function(E) {
                  for (var H = this.tryEntries.length - 1; H >= 0; --H) {
                    var y = this.tryEntries[H];
                    if (y.finallyLoc === E)
                      return this.complete(y.completion, y.afterLoc), T(y), S;
                  }
                },
                catch: function(E) {
                  for (var H = this.tryEntries.length - 1; H >= 0; --H) {
                    var y = this.tryEntries[H];
                    if (y.tryLoc === E) {
                      var $ = y.completion;
                      if ($.type === "throw") {
                        var D = $.arg;
                        T(y);
                      }
                      return D;
                    }
                  }
                  throw new Error("illegal catch attempt");
                },
                delegateYield: function(E, H, y) {
                  return this.delegate = {
                    iterator: N(E),
                    resultName: H,
                    nextLoc: y
                  }, this.method === "next" && (this.arg = c), S;
                }
              }, a;
            }(
              // If this script is executing as a CommonJS module, use module.exports
              // as the regeneratorRuntime namespace. Otherwise create a new empty
              // object. Either way, the resulting object will be used to initialize
              // the regeneratorRuntime variable at the top of this file.
              e.exports
            );
            try {
              regeneratorRuntime = r;
            } catch {
              Function("r", "regeneratorRuntime = r")(r);
            }
          }
        ),
        /***/
        "99af": (
          /***/
          function(e, n, s) {
            var r = s("23e7"), a = s("d039"), o = s("e8b5"), l = s("861d"), c = s("7b0b"), u = s("50c4"), d = s("8418"), h = s("65f0"), f = s("1dde"), p = s("b622"), g = s("60ae"), m = p("isConcatSpreadable"), v = 9007199254740991, b = "Maximum allowed index exceeded", _ = g >= 51 || !a(function() {
              var k = [];
              return k[m] = !1, k.concat()[0] !== k;
            }), S = f("concat"), C = function(k) {
              if (!l(k)) return !1;
              var P = k[m];
              return P !== void 0 ? !!P : o(k);
            }, O = !_ || !S;
            r({ target: "Array", proto: !0, forced: O }, {
              concat: function(P) {
                var x = c(this), R = h(x, 0), B = 0, L, Y, j, w, I;
                for (L = -1, j = arguments.length; L < j; L++)
                  if (I = L === -1 ? x : arguments[L], C(I)) {
                    if (w = u(I.length), B + w > v) throw TypeError(b);
                    for (Y = 0; Y < w; Y++, B++) Y in I && d(R, B, I[Y]);
                  } else {
                    if (B >= v) throw TypeError(b);
                    d(R, B++, I);
                  }
                return R.length = B, R;
              }
            });
          }
        ),
        /***/
        "9bdd": (
          /***/
          function(e, n, s) {
            var r = s("825a");
            e.exports = function(a, o, l, c) {
              try {
                return c ? o(r(l)[0], l[1]) : o(l);
              } catch (d) {
                var u = a.return;
                throw u !== void 0 && r(u.call(a)), d;
              }
            };
          }
        ),
        /***/
        "9bf2": (
          /***/
          function(e, n, s) {
            var r = s("83ab"), a = s("0cfb"), o = s("825a"), l = s("c04e"), c = Object.defineProperty;
            n.f = r ? c : function(d, h, f) {
              if (o(d), h = l(h, !0), o(f), a) try {
                return c(d, h, f);
              } catch {
              }
              if ("get" in f || "set" in f) throw TypeError("Accessors not supported");
              return "value" in f && (d[h] = f.value), d;
            };
          }
        ),
        /***/
        a4d3: (
          /***/
          function(e, n, s) {
            var r = s("23e7"), a = s("da84"), o = s("d066"), l = s("c430"), c = s("83ab"), u = s("4930"), d = s("fdbf"), h = s("d039"), f = s("5135"), p = s("e8b5"), g = s("861d"), m = s("825a"), v = s("7b0b"), b = s("fc6a"), _ = s("c04e"), S = s("5c6c"), C = s("7c73"), O = s("df75"), k = s("241c"), P = s("057f"), x = s("7418"), R = s("06cf"), B = s("9bf2"), L = s("d1e7"), Y = s("9112"), j = s("6eeb"), w = s("5692"), I = s("f772"), T = s("d012"), V = s("90e3"), N = s("b622"), z = s("c032"), E = s("746f"), H = s("d44e"), y = s("69f3"), $ = s("b727").forEach, D = I("hidden"), Z = "Symbol", J = "prototype", lt = N("toPrimitive"), Q = y.set, ot = y.getterFor(Z), st = Object[J], ft = a.Symbol, Rt = o("JSON", "stringify"), pe = R.f, It = B.f, xi = P.f, Be = L.f, Qt = w("symbols"), we = w("op-symbols"), si = w("string-to-symbol-registry"), Vt = w("symbol-to-string-registry"), ge = w("wks"), ri = a.QObject, Ge = !ri || !ri[J] || !ri[J].findChild, Bi = c && h(function() {
              return C(It({}, "a", {
                get: function() {
                  return It(this, "a", { value: 7 }).a;
                }
              })).a != 7;
            }) ? function(nt, tt, ct) {
              var pt = pe(st, tt);
              pt && delete st[tt], It(nt, tt, ct), pt && nt !== st && It(st, tt, pt);
            } : It, In = function(nt, tt) {
              var ct = Qt[nt] = C(ft[J]);
              return Q(ct, {
                type: Z,
                tag: nt,
                description: tt
              }), c || (ct.description = tt), ct;
            }, Ri = u && typeof ft.iterator == "symbol" ? function(nt) {
              return typeof nt == "symbol";
            } : function(nt) {
              return Object(nt) instanceof ft;
            }, Fi = function(tt, ct, pt) {
              tt === st && Fi(we, ct, pt), m(tt);
              var _t = _(ct, !0);
              return m(pt), f(Qt, _t) ? (pt.enumerable ? (f(tt, D) && tt[D][_t] && (tt[D][_t] = !1), pt = C(pt, { enumerable: S(0, !1) })) : (f(tt, D) || It(tt, D, S(1, {})), tt[D][_t] = !0), Bi(tt, _t, pt)) : It(tt, _t, pt);
            }, Ke = function(tt, ct) {
              m(tt);
              var pt = b(ct), _t = O(pt).concat(ht(pt));
              return $(_t, function(Yt) {
                (!c || oi.call(pt, Yt)) && Fi(tt, Yt, pt[Yt]);
              }), tt;
            }, ai = function(tt, ct) {
              return ct === void 0 ? C(tt) : Ke(C(tt), ct);
            }, oi = function(tt) {
              var ct = _(tt, !0), pt = Be.call(this, ct);
              return this === st && f(Qt, ct) && !f(we, ct) ? !1 : pt || !f(this, ct) || !f(Qt, ct) || f(this, D) && this[D][ct] ? pt : !0;
            }, rt = function(tt, ct) {
              var pt = b(tt), _t = _(ct, !0);
              if (!(pt === st && f(Qt, _t) && !f(we, _t))) {
                var Yt = pe(pt, _t);
                return Yt && f(Qt, _t) && !(f(pt, D) && pt[D][_t]) && (Yt.enumerable = !0), Yt;
              }
            }, et = function(tt) {
              var ct = xi(b(tt)), pt = [];
              return $(ct, function(_t) {
                !f(Qt, _t) && !f(T, _t) && pt.push(_t);
              }), pt;
            }, ht = function(tt) {
              var ct = tt === st, pt = xi(ct ? we : b(tt)), _t = [];
              return $(pt, function(Yt) {
                f(Qt, Yt) && (!ct || f(st, Yt)) && _t.push(Qt[Yt]);
              }), _t;
            };
            if (u || (ft = function() {
              if (this instanceof ft) throw TypeError("Symbol is not a constructor");
              var tt = !arguments.length || arguments[0] === void 0 ? void 0 : String(arguments[0]), ct = V(tt), pt = function(_t) {
                this === st && pt.call(we, _t), f(this, D) && f(this[D], ct) && (this[D][ct] = !1), Bi(this, ct, S(1, _t));
              };
              return c && Ge && Bi(st, ct, { configurable: !0, set: pt }), In(ct, tt);
            }, j(ft[J], "toString", function() {
              return ot(this).tag;
            }), L.f = oi, B.f = Fi, R.f = rt, k.f = P.f = et, x.f = ht, c && (It(ft[J], "description", {
              configurable: !0,
              get: function() {
                return ot(this).description;
              }
            }), l || j(st, "propertyIsEnumerable", oi, { unsafe: !0 }))), d || (z.f = function(nt) {
              return In(N(nt), nt);
            }), r({ global: !0, wrap: !0, forced: !u, sham: !u }, {
              Symbol: ft
            }), $(O(ge), function(nt) {
              E(nt);
            }), r({ target: Z, stat: !0, forced: !u }, {
              // `Symbol.for` method
              // https://tc39.github.io/ecma262/#sec-symbol.for
              for: function(nt) {
                var tt = String(nt);
                if (f(si, tt)) return si[tt];
                var ct = ft(tt);
                return si[tt] = ct, Vt[ct] = tt, ct;
              },
              // `Symbol.keyFor` method
              // https://tc39.github.io/ecma262/#sec-symbol.keyfor
              keyFor: function(tt) {
                if (!Ri(tt)) throw TypeError(tt + " is not a symbol");
                if (f(Vt, tt)) return Vt[tt];
              },
              useSetter: function() {
                Ge = !0;
              },
              useSimple: function() {
                Ge = !1;
              }
            }), r({ target: "Object", stat: !0, forced: !u, sham: !c }, {
              // `Object.create` method
              // https://tc39.github.io/ecma262/#sec-object.create
              create: ai,
              // `Object.defineProperty` method
              // https://tc39.github.io/ecma262/#sec-object.defineproperty
              defineProperty: Fi,
              // `Object.defineProperties` method
              // https://tc39.github.io/ecma262/#sec-object.defineproperties
              defineProperties: Ke,
              // `Object.getOwnPropertyDescriptor` method
              // https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptors
              getOwnPropertyDescriptor: rt
            }), r({ target: "Object", stat: !0, forced: !u }, {
              // `Object.getOwnPropertyNames` method
              // https://tc39.github.io/ecma262/#sec-object.getownpropertynames
              getOwnPropertyNames: et,
              // `Object.getOwnPropertySymbols` method
              // https://tc39.github.io/ecma262/#sec-object.getownpropertysymbols
              getOwnPropertySymbols: ht
            }), r({ target: "Object", stat: !0, forced: h(function() {
              x.f(1);
            }) }, {
              getOwnPropertySymbols: function(tt) {
                return x.f(v(tt));
              }
            }), Rt) {
              var gt = !u || h(function() {
                var nt = ft();
                return Rt([nt]) != "[null]" || Rt({ a: nt }) != "{}" || Rt(Object(nt)) != "{}";
              });
              r({ target: "JSON", stat: !0, forced: gt }, {
                // eslint-disable-next-line no-unused-vars
                stringify: function(tt, ct, pt) {
                  for (var _t = [tt], Yt = 1, me; arguments.length > Yt; ) _t.push(arguments[Yt++]);
                  if (me = ct, !(!g(ct) && tt === void 0 || Ri(tt)))
                    return p(ct) || (ct = function(Re, de) {
                      if (typeof me == "function" && (de = me.call(this, Re, de)), !Ri(de)) return de;
                    }), _t[1] = ct, Rt.apply(null, _t);
                }
              });
            }
            ft[J][lt] || Y(ft[J], lt, ft[J].valueOf), H(ft, Z), T[D] = !0;
          }
        ),
        /***/
        a691: (
          /***/
          function(e, n) {
            var s = Math.ceil, r = Math.floor;
            e.exports = function(a) {
              return isNaN(a = +a) ? 0 : (a > 0 ? r : s)(a);
            };
          }
        ),
        /***/
        ab13: (
          /***/
          function(e, n, s) {
            var r = s("b622"), a = r("match");
            e.exports = function(o) {
              var l = /./;
              try {
                "/./"[o](l);
              } catch {
                try {
                  return l[a] = !1, "/./"[o](l);
                } catch {
                }
              }
              return !1;
            };
          }
        ),
        /***/
        ac1f: (
          /***/
          function(e, n, s) {
            var r = s("23e7"), a = s("9263");
            r({ target: "RegExp", proto: !0, forced: /./.exec !== a }, {
              exec: a
            });
          }
        ),
        /***/
        ad6d: (
          /***/
          function(e, n, s) {
            var r = s("825a");
            e.exports = function() {
              var a = r(this), o = "";
              return a.global && (o += "g"), a.ignoreCase && (o += "i"), a.multiline && (o += "m"), a.dotAll && (o += "s"), a.unicode && (o += "u"), a.sticky && (o += "y"), o;
            };
          }
        ),
        /***/
        b041: (
          /***/
          function(e, n, s) {
            var r = s("00ee"), a = s("f5df");
            e.exports = r ? {}.toString : function() {
              return "[object " + a(this) + "]";
            };
          }
        ),
        /***/
        b0c0: (
          /***/
          function(e, n, s) {
            var r = s("83ab"), a = s("9bf2").f, o = Function.prototype, l = o.toString, c = /^\s*function ([^ (]*)/, u = "name";
            r && !(u in o) && a(o, u, {
              configurable: !0,
              get: function() {
                try {
                  return l.call(this).match(c)[1];
                } catch {
                  return "";
                }
              }
            });
          }
        ),
        /***/
        b301: (
          /***/
          function(e, n, s) {
            var r = s("d039");
            e.exports = function(a, o) {
              var l = [][a];
              return !l || !r(function() {
                l.call(null, o || function() {
                  throw 1;
                }, 1);
              });
            };
          }
        ),
        /***/
        b39a: (
          /***/
          function(e, n, s) {
            var r = s("d066");
            e.exports = r("navigator", "userAgent") || "";
          }
        ),
        /***/
        b575: (
          /***/
          function(e, n, s) {
            var r = s("da84"), a = s("06cf").f, o = s("c6b6"), l = s("2cf4").set, c = s("b629"), u = r.MutationObserver || r.WebKitMutationObserver, d = r.process, h = r.Promise, f = o(d) == "process", p = a(r, "queueMicrotask"), g = p && p.value, m, v, b, _, S, C, O, k;
            g || (m = function() {
              var P, x;
              for (f && (P = d.domain) && P.exit(); v; ) {
                x = v.fn, v = v.next;
                try {
                  x();
                } catch (R) {
                  throw v ? _() : b = void 0, R;
                }
              }
              b = void 0, P && P.enter();
            }, f ? _ = function() {
              d.nextTick(m);
            } : u && !c ? (S = !0, C = document.createTextNode(""), new u(m).observe(C, { characterData: !0 }), _ = function() {
              C.data = S = !S;
            }) : h && h.resolve ? (O = h.resolve(void 0), k = O.then, _ = function() {
              k.call(O, m);
            }) : _ = function() {
              l.call(r, m);
            }), e.exports = g || function(P) {
              var x = { fn: P, next: void 0 };
              b && (b.next = x), v || (v = x, _()), b = x;
            };
          }
        ),
        /***/
        b622: (
          /***/
          function(e, n, s) {
            var r = s("da84"), a = s("5692"), o = s("5135"), l = s("90e3"), c = s("4930"), u = s("fdbf"), d = a("wks"), h = r.Symbol, f = u ? h : l;
            e.exports = function(p) {
              return o(d, p) || (c && o(h, p) ? d[p] = h[p] : d[p] = f("Symbol." + p)), d[p];
            };
          }
        ),
        /***/
        b629: (
          /***/
          function(e, n, s) {
            var r = s("b39a");
            e.exports = /(iphone|ipod|ipad).*applewebkit/i.test(r);
          }
        ),
        /***/
        b64b: (
          /***/
          function(e, n, s) {
            var r = s("23e7"), a = s("7b0b"), o = s("df75"), l = s("d039"), c = l(function() {
              o(1);
            });
            r({ target: "Object", stat: !0, forced: c }, {
              keys: function(d) {
                return o(a(d));
              }
            });
          }
        ),
        /***/
        b727: (
          /***/
          function(e, n, s) {
            var r = s("f8c2"), a = s("44ad"), o = s("7b0b"), l = s("50c4"), c = s("65f0"), u = [].push, d = function(h) {
              var f = h == 1, p = h == 2, g = h == 3, m = h == 4, v = h == 6, b = h == 5 || v;
              return function(_, S, C, O) {
                for (var k = o(_), P = a(k), x = r(S, C, 3), R = l(P.length), B = 0, L = O || c, Y = f ? L(_, R) : p ? L(_, 0) : void 0, j, w; R > B; B++) if ((b || B in P) && (j = P[B], w = x(j, B, k), h)) {
                  if (f) Y[B] = w;
                  else if (w) switch (h) {
                    case 3:
                      return !0;
                    case 5:
                      return j;
                    case 6:
                      return B;
                    case 2:
                      u.call(Y, j);
                  }
                  else if (m) return !1;
                }
                return v ? -1 : g || m ? m : Y;
              };
            };
            e.exports = {
              // `Array.prototype.forEach` method
              // https://tc39.github.io/ecma262/#sec-array.prototype.foreach
              forEach: d(0),
              // `Array.prototype.map` method
              // https://tc39.github.io/ecma262/#sec-array.prototype.map
              map: d(1),
              // `Array.prototype.filter` method
              // https://tc39.github.io/ecma262/#sec-array.prototype.filter
              filter: d(2),
              // `Array.prototype.some` method
              // https://tc39.github.io/ecma262/#sec-array.prototype.some
              some: d(3),
              // `Array.prototype.every` method
              // https://tc39.github.io/ecma262/#sec-array.prototype.every
              every: d(4),
              // `Array.prototype.find` method
              // https://tc39.github.io/ecma262/#sec-array.prototype.find
              find: d(5),
              // `Array.prototype.findIndex` method
              // https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
              findIndex: d(6)
            };
          }
        ),
        /***/
        c032: (
          /***/
          function(e, n, s) {
            var r = s("b622");
            n.f = r;
          }
        ),
        /***/
        c04e: (
          /***/
          function(e, n, s) {
            var r = s("861d");
            e.exports = function(a, o) {
              if (!r(a)) return a;
              var l, c;
              if (o && typeof (l = a.toString) == "function" && !r(c = l.call(a)) || typeof (l = a.valueOf) == "function" && !r(c = l.call(a)) || !o && typeof (l = a.toString) == "function" && !r(c = l.call(a))) return c;
              throw TypeError("Can't convert object to primitive value");
            };
          }
        ),
        /***/
        c430: (
          /***/
          function(e, n) {
            e.exports = !1;
          }
        ),
        /***/
        c6b6: (
          /***/
          function(e, n) {
            var s = {}.toString;
            e.exports = function(r) {
              return s.call(r).slice(8, -1);
            };
          }
        ),
        /***/
        c6cd: (
          /***/
          function(e, n, s) {
            var r = s("da84"), a = s("ce4e"), o = "__core-js_shared__", l = r[o] || a(o, {});
            e.exports = l;
          }
        ),
        /***/
        c8ba: (
          /***/
          function(e, n) {
            var s;
            s = /* @__PURE__ */ function() {
              return this;
            }();
            try {
              s = s || new Function("return this")();
            } catch {
              typeof window == "object" && (s = window);
            }
            e.exports = s;
          }
        ),
        /***/
        ca84: (
          /***/
          function(e, n, s) {
            var r = s("5135"), a = s("fc6a"), o = s("4d64").indexOf, l = s("d012");
            e.exports = function(c, u) {
              var d = a(c), h = 0, f = [], p;
              for (p in d) !r(l, p) && r(d, p) && f.push(p);
              for (; u.length > h; ) r(d, p = u[h++]) && (~o(f, p) || f.push(p));
              return f;
            };
          }
        ),
        /***/
        caad: (
          /***/
          function(e, n, s) {
            var r = s("23e7"), a = s("4d64").includes, o = s("44d2");
            r({ target: "Array", proto: !0 }, {
              includes: function(c) {
                return a(this, c, arguments.length > 1 ? arguments[1] : void 0);
              }
            }), o("includes");
          }
        ),
        /***/
        cc12: (
          /***/
          function(e, n, s) {
            var r = s("da84"), a = s("861d"), o = r.document, l = a(o) && a(o.createElement);
            e.exports = function(c) {
              return l ? o.createElement(c) : {};
            };
          }
        ),
        /***/
        cca6: (
          /***/
          function(e, n, s) {
            var r = s("23e7"), a = s("60da");
            r({ target: "Object", stat: !0, forced: Object.assign !== a }, {
              assign: a
            });
          }
        ),
        /***/
        cdf9: (
          /***/
          function(e, n, s) {
            var r = s("825a"), a = s("861d"), o = s("f069");
            e.exports = function(l, c) {
              if (r(l), a(c) && c.constructor === l) return c;
              var u = o.f(l), d = u.resolve;
              return d(c), u.promise;
            };
          }
        ),
        /***/
        ce4e: (
          /***/
          function(e, n, s) {
            var r = s("da84"), a = s("9112");
            e.exports = function(o, l) {
              try {
                a(r, o, l);
              } catch {
                r[o] = l;
              }
              return l;
            };
          }
        ),
        /***/
        d012: (
          /***/
          function(e, n) {
            e.exports = {};
          }
        ),
        /***/
        d039: (
          /***/
          function(e, n) {
            e.exports = function(s) {
              try {
                return !!s();
              } catch {
                return !0;
              }
            };
          }
        ),
        /***/
        d066: (
          /***/
          function(e, n, s) {
            var r = s("428f"), a = s("da84"), o = function(l) {
              return typeof l == "function" ? l : void 0;
            };
            e.exports = function(l, c) {
              return arguments.length < 2 ? o(r[l]) || o(a[l]) : r[l] && r[l][c] || a[l] && a[l][c];
            };
          }
        ),
        /***/
        d1e7: (
          /***/
          function(e, n, s) {
            var r = {}.propertyIsEnumerable, a = Object.getOwnPropertyDescriptor, o = a && !r.call({ 1: 2 }, 1);
            n.f = o ? function(c) {
              var u = a(this, c);
              return !!u && u.enumerable;
            } : r;
          }
        ),
        /***/
        d3b7: (
          /***/
          function(e, n, s) {
            var r = s("00ee"), a = s("6eeb"), o = s("b041");
            r || a(Object.prototype, "toString", o, { unsafe: !0 });
          }
        ),
        /***/
        d44e: (
          /***/
          function(e, n, s) {
            var r = s("9bf2").f, a = s("5135"), o = s("b622"), l = o("toStringTag");
            e.exports = function(c, u, d) {
              c && !a(c = d ? c : c.prototype, l) && r(c, l, { configurable: !0, value: u });
            };
          }
        ),
        /***/
        d784: (
          /***/
          function(e, n, s) {
            var r = s("9112"), a = s("6eeb"), o = s("d039"), l = s("b622"), c = s("9263"), u = l("species"), d = !o(function() {
              var f = /./;
              return f.exec = function() {
                var p = [];
                return p.groups = { a: "7" }, p;
              }, "".replace(f, "$<a>") !== "7";
            }), h = !o(function() {
              var f = /(?:)/, p = f.exec;
              f.exec = function() {
                return p.apply(this, arguments);
              };
              var g = "ab".split(f);
              return g.length !== 2 || g[0] !== "a" || g[1] !== "b";
            });
            e.exports = function(f, p, g, m) {
              var v = l(f), b = !o(function() {
                var P = {};
                return P[v] = function() {
                  return 7;
                }, ""[f](P) != 7;
              }), _ = b && !o(function() {
                var P = !1, x = /a/;
                return f === "split" && (x = {}, x.constructor = {}, x.constructor[u] = function() {
                  return x;
                }, x.flags = "", x[v] = /./[v]), x.exec = function() {
                  return P = !0, null;
                }, x[v](""), !P;
              });
              if (!b || !_ || f === "replace" && !d || f === "split" && !h) {
                var S = /./[v], C = g(v, ""[f], function(P, x, R, B, L) {
                  return x.exec === c ? b && !L ? { done: !0, value: S.call(x, R, B) } : { done: !0, value: P.call(R, x, B) } : { done: !1 };
                }), O = C[0], k = C[1];
                a(String.prototype, f, O), a(
                  RegExp.prototype,
                  v,
                  p == 2 ? function(P, x) {
                    return k.call(P, this, x);
                  } : function(P) {
                    return k.call(P, this);
                  }
                ), m && r(RegExp.prototype[v], "sham", !0);
              }
            };
          }
        ),
        /***/
        da84: (
          /***/
          function(e, n, s) {
            (function(r) {
              var a = function(o) {
                return o && o.Math == Math && o;
              };
              e.exports = // eslint-disable-next-line no-undef
              a(typeof globalThis == "object" && globalThis) || a(typeof window == "object" && window) || a(typeof self == "object" && self) || a(typeof r == "object" && r) || // eslint-disable-next-line no-new-func
              Function("return this")();
            }).call(this, s("c8ba"));
          }
        ),
        /***/
        dbb4: (
          /***/
          function(e, n, s) {
            var r = s("23e7"), a = s("83ab"), o = s("56ef"), l = s("fc6a"), c = s("06cf"), u = s("8418");
            r({ target: "Object", stat: !0, sham: !a }, {
              getOwnPropertyDescriptors: function(h) {
                for (var f = l(h), p = c.f, g = o(f), m = {}, v = 0, b, _; g.length > v; )
                  _ = p(f, b = g[v++]), _ !== void 0 && u(m, b, _);
                return m;
              }
            });
          }
        ),
        /***/
        df75: (
          /***/
          function(e, n, s) {
            var r = s("ca84"), a = s("7839");
            e.exports = Object.keys || function(l) {
              return r(l, a);
            };
          }
        ),
        /***/
        e25e: (
          /***/
          function(e, n, s) {
            var r = s("23e7"), a = s("e583");
            r({ global: !0, forced: parseInt != a }, {
              parseInt: a
            });
          }
        ),
        /***/
        e2cc: (
          /***/
          function(e, n, s) {
            var r = s("6eeb");
            e.exports = function(a, o, l) {
              for (var c in o) r(a, c, o[c], l);
              return a;
            };
          }
        ),
        /***/
        e439: (
          /***/
          function(e, n, s) {
            var r = s("23e7"), a = s("d039"), o = s("fc6a"), l = s("06cf").f, c = s("83ab"), u = a(function() {
              l(1);
            }), d = !c || u;
            r({ target: "Object", stat: !0, forced: d, sham: !c }, {
              getOwnPropertyDescriptor: function(f, p) {
                return l(o(f), p);
              }
            });
          }
        ),
        /***/
        e583: (
          /***/
          function(e, n, s) {
            var r = s("da84"), a = s("58a8").trim, o = s("5899"), l = r.parseInt, c = /^[+-]?0[Xx]/, u = l(o + "08") !== 8 || l(o + "0x16") !== 22;
            e.exports = u ? function(h, f) {
              var p = a(String(h));
              return l(p, f >>> 0 || (c.test(p) ? 16 : 10));
            } : l;
          }
        ),
        /***/
        e667: (
          /***/
          function(e, n) {
            e.exports = function(s) {
              try {
                return { error: !1, value: s() };
              } catch (r) {
                return { error: !0, value: r };
              }
            };
          }
        ),
        /***/
        e6cf: (
          /***/
          function(e, n, s) {
            var r = s("23e7"), a = s("c430"), o = s("da84"), l = s("d066"), c = s("fea9"), u = s("6eeb"), d = s("e2cc"), h = s("d44e"), f = s("2626"), p = s("861d"), g = s("1c0b"), m = s("19aa"), v = s("c6b6"), b = s("8925"), _ = s("2266"), S = s("1c7e"), C = s("4840"), O = s("2cf4").set, k = s("b575"), P = s("cdf9"), x = s("44de"), R = s("f069"), B = s("e667"), L = s("69f3"), Y = s("94ca"), j = s("b622"), w = s("60ae"), I = j("species"), T = "Promise", V = L.get, N = L.set, z = L.getterFor(T), E = c, H = o.TypeError, y = o.document, $ = o.process, D = l("fetch"), Z = R.f, J = Z, lt = v($) == "process", Q = !!(y && y.createEvent && o.dispatchEvent), ot = "unhandledrejection", st = "rejectionhandled", ft = 0, Rt = 1, pe = 2, It = 1, xi = 2, Be, Qt, we, si, Vt = Y(T, function() {
              var rt = b(E) !== String(E);
              if (!rt && (w === 66 || !lt && typeof PromiseRejectionEvent != "function") || a && !E.prototype.finally) return !0;
              if (w >= 51 && /native code/.test(E)) return !1;
              var et = E.resolve(1), ht = function(nt) {
                nt(function() {
                }, function() {
                });
              }, gt = et.constructor = {};
              return gt[I] = ht, !(et.then(function() {
              }) instanceof ht);
            }), ge = Vt || !S(function(rt) {
              E.all(rt).catch(function() {
              });
            }), ri = function(rt) {
              var et;
              return p(rt) && typeof (et = rt.then) == "function" ? et : !1;
            }, Ge = function(rt, et, ht) {
              if (!et.notified) {
                et.notified = !0;
                var gt = et.reactions;
                k(function() {
                  for (var nt = et.value, tt = et.state == Rt, ct = 0; gt.length > ct; ) {
                    var pt = gt[ct++], _t = tt ? pt.ok : pt.fail, Yt = pt.resolve, me = pt.reject, Re = pt.domain, de, rn, En;
                    try {
                      _t ? (tt || (et.rejection === xi && Fi(rt, et), et.rejection = It), _t === !0 ? de = nt : (Re && Re.enter(), de = _t(nt), Re && (Re.exit(), En = !0)), de === pt.promise ? me(H("Promise-chain cycle")) : (rn = ri(de)) ? rn.call(de, Yt, me) : Yt(de)) : me(nt);
                    } catch (Ga) {
                      Re && !En && Re.exit(), me(Ga);
                    }
                  }
                  et.reactions = [], et.notified = !1, ht && !et.rejection && In(rt, et);
                });
              }
            }, Bi = function(rt, et, ht) {
              var gt, nt;
              Q ? (gt = y.createEvent("Event"), gt.promise = et, gt.reason = ht, gt.initEvent(rt, !1, !0), o.dispatchEvent(gt)) : gt = { promise: et, reason: ht }, (nt = o["on" + rt]) ? nt(gt) : rt === ot && x("Unhandled promise rejection", ht);
            }, In = function(rt, et) {
              O.call(o, function() {
                var ht = et.value, gt = Ri(et), nt;
                if (gt && (nt = B(function() {
                  lt ? $.emit("unhandledRejection", ht, rt) : Bi(ot, rt, ht);
                }), et.rejection = lt || Ri(et) ? xi : It, nt.error))
                  throw nt.value;
              });
            }, Ri = function(rt) {
              return rt.rejection !== It && !rt.parent;
            }, Fi = function(rt, et) {
              O.call(o, function() {
                lt ? $.emit("rejectionHandled", rt) : Bi(st, rt, et.value);
              });
            }, Ke = function(rt, et, ht, gt) {
              return function(nt) {
                rt(et, ht, nt, gt);
              };
            }, ai = function(rt, et, ht, gt) {
              et.done || (et.done = !0, gt && (et = gt), et.value = ht, et.state = pe, Ge(rt, et, !0));
            }, oi = function(rt, et, ht, gt) {
              if (!et.done) {
                et.done = !0, gt && (et = gt);
                try {
                  if (rt === ht) throw H("Promise can't be resolved itself");
                  var nt = ri(ht);
                  nt ? k(function() {
                    var tt = { done: !1 };
                    try {
                      nt.call(
                        ht,
                        Ke(oi, rt, tt, et),
                        Ke(ai, rt, tt, et)
                      );
                    } catch (ct) {
                      ai(rt, tt, ct, et);
                    }
                  }) : (et.value = ht, et.state = Rt, Ge(rt, et, !1));
                } catch (tt) {
                  ai(rt, { done: !1 }, tt, et);
                }
              }
            };
            Vt && (E = function(et) {
              m(this, E, T), g(et), Be.call(this);
              var ht = V(this);
              try {
                et(Ke(oi, this, ht), Ke(ai, this, ht));
              } catch (gt) {
                ai(this, ht, gt);
              }
            }, Be = function(et) {
              N(this, {
                type: T,
                done: !1,
                notified: !1,
                parent: !1,
                reactions: [],
                rejection: !1,
                state: ft,
                value: void 0
              });
            }, Be.prototype = d(E.prototype, {
              // `Promise.prototype.then` method
              // https://tc39.github.io/ecma262/#sec-promise.prototype.then
              then: function(et, ht) {
                var gt = z(this), nt = Z(C(this, E));
                return nt.ok = typeof et == "function" ? et : !0, nt.fail = typeof ht == "function" && ht, nt.domain = lt ? $.domain : void 0, gt.parent = !0, gt.reactions.push(nt), gt.state != ft && Ge(this, gt, !1), nt.promise;
              },
              // `Promise.prototype.catch` method
              // https://tc39.github.io/ecma262/#sec-promise.prototype.catch
              catch: function(rt) {
                return this.then(void 0, rt);
              }
            }), Qt = function() {
              var rt = new Be(), et = V(rt);
              this.promise = rt, this.resolve = Ke(oi, rt, et), this.reject = Ke(ai, rt, et);
            }, R.f = Z = function(rt) {
              return rt === E || rt === we ? new Qt(rt) : J(rt);
            }, !a && typeof c == "function" && (si = c.prototype.then, u(c.prototype, "then", function(et, ht) {
              var gt = this;
              return new E(function(nt, tt) {
                si.call(gt, nt, tt);
              }).then(et, ht);
            }, { unsafe: !0 }), typeof D == "function" && r({ global: !0, enumerable: !0, forced: !0 }, {
              // eslint-disable-next-line no-unused-vars
              fetch: function(et) {
                return P(E, D.apply(o, arguments));
              }
            }))), r({ global: !0, wrap: !0, forced: Vt }, {
              Promise: E
            }), h(E, T, !1, !0), f(T), we = l(T), r({ target: T, stat: !0, forced: Vt }, {
              // `Promise.reject` method
              // https://tc39.github.io/ecma262/#sec-promise.reject
              reject: function(et) {
                var ht = Z(this);
                return ht.reject.call(void 0, et), ht.promise;
              }
            }), r({ target: T, stat: !0, forced: a || Vt }, {
              // `Promise.resolve` method
              // https://tc39.github.io/ecma262/#sec-promise.resolve
              resolve: function(et) {
                return P(a && this === we ? E : this, et);
              }
            }), r({ target: T, stat: !0, forced: ge }, {
              // `Promise.all` method
              // https://tc39.github.io/ecma262/#sec-promise.all
              all: function(et) {
                var ht = this, gt = Z(ht), nt = gt.resolve, tt = gt.reject, ct = B(function() {
                  var pt = g(ht.resolve), _t = [], Yt = 0, me = 1;
                  _(et, function(Re) {
                    var de = Yt++, rn = !1;
                    _t.push(void 0), me++, pt.call(ht, Re).then(function(En) {
                      rn || (rn = !0, _t[de] = En, --me || nt(_t));
                    }, tt);
                  }), --me || nt(_t);
                });
                return ct.error && tt(ct.value), gt.promise;
              },
              // `Promise.race` method
              // https://tc39.github.io/ecma262/#sec-promise.race
              race: function(et) {
                var ht = this, gt = Z(ht), nt = gt.reject, tt = B(function() {
                  var ct = g(ht.resolve);
                  _(et, function(pt) {
                    ct.call(ht, pt).then(gt.resolve, nt);
                  });
                });
                return tt.error && nt(tt.value), gt.promise;
              }
            });
          }
        ),
        /***/
        e893: (
          /***/
          function(e, n, s) {
            var r = s("5135"), a = s("56ef"), o = s("06cf"), l = s("9bf2");
            e.exports = function(c, u) {
              for (var d = a(u), h = l.f, f = o.f, p = 0; p < d.length; p++) {
                var g = d[p];
                r(c, g) || h(c, g, f(u, g));
              }
            };
          }
        ),
        /***/
        e8b5: (
          /***/
          function(e, n, s) {
            var r = s("c6b6");
            e.exports = Array.isArray || function(o) {
              return r(o) == "Array";
            };
          }
        ),
        /***/
        e95a: (
          /***/
          function(e, n, s) {
            var r = s("b622"), a = s("3f8c"), o = r("iterator"), l = Array.prototype;
            e.exports = function(c) {
              return c !== void 0 && (a.Array === c || l[o] === c);
            };
          }
        ),
        /***/
        f069: (
          /***/
          function(e, n, s) {
            var r = s("1c0b"), a = function(o) {
              var l, c;
              this.promise = new o(function(u, d) {
                if (l !== void 0 || c !== void 0) throw TypeError("Bad Promise constructor");
                l = u, c = d;
              }), this.resolve = r(l), this.reject = r(c);
            };
            e.exports.f = function(o) {
              return new a(o);
            };
          }
        ),
        /***/
        f0bd: (
          /***/
          function(e, n, s) {
            (function(r) {
              /**!
              * @fileOverview Kickass library to create and place poppers near their reference elements.
              * @version 1.16.0
              * @license
              * Copyright (c) 2016 Federico Zivolo and contributors
              *
              * Permission is hereby granted, free of charge, to any person obtaining a copy
              * of this software and associated documentation files (the "Software"), to deal
              * in the Software without restriction, including without limitation the rights
              * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
              * copies of the Software, and to permit persons to whom the Software is
              * furnished to do so, subject to the following conditions:
              *
              * The above copyright notice and this permission notice shall be included in all
              * copies or substantial portions of the Software.
              *
              * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
              * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
              * SOFTWARE.
              */
              var a = typeof window < "u" && typeof document < "u" && typeof navigator < "u", o = function() {
                for (var A = ["Edge", "Trident", "Firefox"], M = 0; M < A.length; M += 1)
                  if (a && navigator.userAgent.indexOf(A[M]) >= 0)
                    return 1;
                return 0;
              }();
              function l(A) {
                var M = !1;
                return function() {
                  M || (M = !0, window.Promise.resolve().then(function() {
                    M = !1, A();
                  }));
                };
              }
              function c(A) {
                var M = !1;
                return function() {
                  M || (M = !0, setTimeout(function() {
                    M = !1, A();
                  }, o));
                };
              }
              var u = a && window.Promise, d = u ? l : c;
              function h(A) {
                var M = {};
                return A && M.toString.call(A) === "[object Function]";
              }
              function f(A, M) {
                if (A.nodeType !== 1)
                  return [];
                var F = A.ownerDocument.defaultView, W = F.getComputedStyle(A, null);
                return M ? W[M] : W;
              }
              function p(A) {
                return A.nodeName === "HTML" ? A : A.parentNode || A.host;
              }
              function g(A) {
                if (!A)
                  return document.body;
                switch (A.nodeName) {
                  case "HTML":
                  case "BODY":
                    return A.ownerDocument.body;
                  case "#document":
                    return A.body;
                }
                var M = f(A), F = M.overflow, W = M.overflowX, K = M.overflowY;
                return /(auto|scroll|overlay)/.test(F + K + W) ? A : g(p(A));
              }
              function m(A) {
                return A && A.referenceNode ? A.referenceNode : A;
              }
              var v = a && !!(window.MSInputMethodContext && document.documentMode), b = a && /MSIE 10/.test(navigator.userAgent);
              function _(A) {
                return A === 11 ? v : A === 10 ? b : v || b;
              }
              function S(A) {
                if (!A)
                  return document.documentElement;
                for (var M = _(10) ? document.body : null, F = A.offsetParent || null; F === M && A.nextElementSibling; )
                  F = (A = A.nextElementSibling).offsetParent;
                var W = F && F.nodeName;
                return !W || W === "BODY" || W === "HTML" ? A ? A.ownerDocument.documentElement : document.documentElement : ["TH", "TD", "TABLE"].indexOf(F.nodeName) !== -1 && f(F, "position") === "static" ? S(F) : F;
              }
              function C(A) {
                var M = A.nodeName;
                return M === "BODY" ? !1 : M === "HTML" || S(A.firstElementChild) === A;
              }
              function O(A) {
                return A.parentNode !== null ? O(A.parentNode) : A;
              }
              function k(A, M) {
                if (!A || !A.nodeType || !M || !M.nodeType)
                  return document.documentElement;
                var F = A.compareDocumentPosition(M) & Node.DOCUMENT_POSITION_FOLLOWING, W = F ? A : M, K = F ? M : A, G = document.createRange();
                G.setStart(W, 0), G.setEnd(K, 0);
                var X = G.commonAncestorContainer;
                if (A !== X && M !== X || W.contains(K))
                  return C(X) ? X : S(X);
                var q = O(A);
                return q.host ? k(q.host, M) : k(A, O(M).host);
              }
              function P(A) {
                var M = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "top", F = M === "top" ? "scrollTop" : "scrollLeft", W = A.nodeName;
                if (W === "BODY" || W === "HTML") {
                  var K = A.ownerDocument.documentElement, G = A.ownerDocument.scrollingElement || K;
                  return G[F];
                }
                return A[F];
              }
              function x(A, M) {
                var F = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, W = P(M, "top"), K = P(M, "left"), G = F ? -1 : 1;
                return A.top += W * G, A.bottom += W * G, A.left += K * G, A.right += K * G, A;
              }
              function R(A, M) {
                var F = M === "x" ? "Left" : "Top", W = F === "Left" ? "Right" : "Bottom";
                return parseFloat(A["border" + F + "Width"], 10) + parseFloat(A["border" + W + "Width"], 10);
              }
              function B(A, M, F, W) {
                return Math.max(M["offset" + A], M["scroll" + A], F["client" + A], F["offset" + A], F["scroll" + A], _(10) ? parseInt(F["offset" + A]) + parseInt(W["margin" + (A === "Height" ? "Top" : "Left")]) + parseInt(W["margin" + (A === "Height" ? "Bottom" : "Right")]) : 0);
              }
              function L(A) {
                var M = A.body, F = A.documentElement, W = _(10) && getComputedStyle(F);
                return {
                  height: B("Height", M, F, W),
                  width: B("Width", M, F, W)
                };
              }
              var Y = function(A, M) {
                if (!(A instanceof M))
                  throw new TypeError("Cannot call a class as a function");
              }, j = /* @__PURE__ */ function() {
                function A(M, F) {
                  for (var W = 0; W < F.length; W++) {
                    var K = F[W];
                    K.enumerable = K.enumerable || !1, K.configurable = !0, "value" in K && (K.writable = !0), Object.defineProperty(M, K.key, K);
                  }
                }
                return function(M, F, W) {
                  return F && A(M.prototype, F), W && A(M, W), M;
                };
              }(), w = function(A, M, F) {
                return M in A ? Object.defineProperty(A, M, {
                  value: F,
                  enumerable: !0,
                  configurable: !0,
                  writable: !0
                }) : A[M] = F, A;
              }, I = Object.assign || function(A) {
                for (var M = 1; M < arguments.length; M++) {
                  var F = arguments[M];
                  for (var W in F)
                    Object.prototype.hasOwnProperty.call(F, W) && (A[W] = F[W]);
                }
                return A;
              };
              function T(A) {
                return I({}, A, {
                  right: A.left + A.width,
                  bottom: A.top + A.height
                });
              }
              function V(A) {
                var M = {};
                try {
                  if (_(10)) {
                    M = A.getBoundingClientRect();
                    var F = P(A, "top"), W = P(A, "left");
                    M.top += F, M.left += W, M.bottom += F, M.right += W;
                  } else
                    M = A.getBoundingClientRect();
                } catch {
                }
                var K = {
                  left: M.left,
                  top: M.top,
                  width: M.right - M.left,
                  height: M.bottom - M.top
                }, G = A.nodeName === "HTML" ? L(A.ownerDocument) : {}, X = G.width || A.clientWidth || K.width, q = G.height || A.clientHeight || K.height, it = A.offsetWidth - X, ut = A.offsetHeight - q;
                if (it || ut) {
                  var dt = f(A);
                  it -= R(dt, "x"), ut -= R(dt, "y"), K.width -= it, K.height -= ut;
                }
                return T(K);
              }
              function N(A, M) {
                var F = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, W = _(10), K = M.nodeName === "HTML", G = V(A), X = V(M), q = g(A), it = f(M), ut = parseFloat(it.borderTopWidth, 10), dt = parseFloat(it.borderLeftWidth, 10);
                F && K && (X.top = Math.max(X.top, 0), X.left = Math.max(X.left, 0));
                var at = T({
                  top: G.top - X.top - ut,
                  left: G.left - X.left - dt,
                  width: G.width,
                  height: G.height
                });
                if (at.marginTop = 0, at.marginLeft = 0, !W && K) {
                  var At = parseFloat(it.marginTop, 10), mt = parseFloat(it.marginLeft, 10);
                  at.top -= ut - At, at.bottom -= ut - At, at.left -= dt - mt, at.right -= dt - mt, at.marginTop = At, at.marginLeft = mt;
                }
                return (W && !F ? M.contains(q) : M === q && q.nodeName !== "BODY") && (at = x(at, M)), at;
              }
              function z(A) {
                var M = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, F = A.ownerDocument.documentElement, W = N(A, F), K = Math.max(F.clientWidth, window.innerWidth || 0), G = Math.max(F.clientHeight, window.innerHeight || 0), X = M ? 0 : P(F), q = M ? 0 : P(F, "left"), it = {
                  top: X - W.top + W.marginTop,
                  left: q - W.left + W.marginLeft,
                  width: K,
                  height: G
                };
                return T(it);
              }
              function E(A) {
                var M = A.nodeName;
                if (M === "BODY" || M === "HTML")
                  return !1;
                if (f(A, "position") === "fixed")
                  return !0;
                var F = p(A);
                return F ? E(F) : !1;
              }
              function H(A) {
                if (!A || !A.parentElement || _())
                  return document.documentElement;
                for (var M = A.parentElement; M && f(M, "transform") === "none"; )
                  M = M.parentElement;
                return M || document.documentElement;
              }
              function y(A, M, F, W) {
                var K = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1, G = { top: 0, left: 0 }, X = K ? H(A) : k(A, m(M));
                if (W === "viewport")
                  G = z(X, K);
                else {
                  var q = void 0;
                  W === "scrollParent" ? (q = g(p(M)), q.nodeName === "BODY" && (q = A.ownerDocument.documentElement)) : W === "window" ? q = A.ownerDocument.documentElement : q = W;
                  var it = N(q, X, K);
                  if (q.nodeName === "HTML" && !E(X)) {
                    var ut = L(A.ownerDocument), dt = ut.height, at = ut.width;
                    G.top += it.top - it.marginTop, G.bottom = dt + it.top, G.left += it.left - it.marginLeft, G.right = at + it.left;
                  } else
                    G = it;
                }
                F = F || 0;
                var At = typeof F == "number";
                return G.left += At ? F : F.left || 0, G.top += At ? F : F.top || 0, G.right -= At ? F : F.right || 0, G.bottom -= At ? F : F.bottom || 0, G;
              }
              function $(A) {
                var M = A.width, F = A.height;
                return M * F;
              }
              function D(A, M, F, W, K) {
                var G = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 0;
                if (A.indexOf("auto") === -1)
                  return A;
                var X = y(F, W, G, K), q = {
                  top: {
                    width: X.width,
                    height: M.top - X.top
                  },
                  right: {
                    width: X.right - M.right,
                    height: X.height
                  },
                  bottom: {
                    width: X.width,
                    height: X.bottom - M.bottom
                  },
                  left: {
                    width: M.left - X.left,
                    height: X.height
                  }
                }, it = Object.keys(q).map(function(At) {
                  return I({
                    key: At
                  }, q[At], {
                    area: $(q[At])
                  });
                }).sort(function(At, mt) {
                  return mt.area - At.area;
                }), ut = it.filter(function(At) {
                  var mt = At.width, bt = At.height;
                  return mt >= F.clientWidth && bt >= F.clientHeight;
                }), dt = ut.length > 0 ? ut[0].key : it[0].key, at = A.split("-")[1];
                return dt + (at ? "-" + at : "");
              }
              function Z(A, M, F) {
                var W = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, K = W ? H(M) : k(M, m(F));
                return N(F, K, W);
              }
              function J(A) {
                var M = A.ownerDocument.defaultView, F = M.getComputedStyle(A), W = parseFloat(F.marginTop || 0) + parseFloat(F.marginBottom || 0), K = parseFloat(F.marginLeft || 0) + parseFloat(F.marginRight || 0), G = {
                  width: A.offsetWidth + K,
                  height: A.offsetHeight + W
                };
                return G;
              }
              function lt(A) {
                var M = { left: "right", right: "left", bottom: "top", top: "bottom" };
                return A.replace(/left|right|bottom|top/g, function(F) {
                  return M[F];
                });
              }
              function Q(A, M, F) {
                F = F.split("-")[0];
                var W = J(A), K = {
                  width: W.width,
                  height: W.height
                }, G = ["right", "left"].indexOf(F) !== -1, X = G ? "top" : "left", q = G ? "left" : "top", it = G ? "height" : "width", ut = G ? "width" : "height";
                return K[X] = M[X] + M[it] / 2 - W[it] / 2, F === q ? K[q] = M[q] - W[ut] : K[q] = M[lt(q)], K;
              }
              function ot(A, M) {
                return Array.prototype.find ? A.find(M) : A.filter(M)[0];
              }
              function st(A, M, F) {
                if (Array.prototype.findIndex)
                  return A.findIndex(function(K) {
                    return K[M] === F;
                  });
                var W = ot(A, function(K) {
                  return K[M] === F;
                });
                return A.indexOf(W);
              }
              function ft(A, M, F) {
                var W = F === void 0 ? A : A.slice(0, st(A, "name", F));
                return W.forEach(function(K) {
                  K.function && console.warn("`modifier.function` is deprecated, use `modifier.fn`!");
                  var G = K.function || K.fn;
                  K.enabled && h(G) && (M.offsets.popper = T(M.offsets.popper), M.offsets.reference = T(M.offsets.reference), M = G(M, K));
                }), M;
              }
              function Rt() {
                if (!this.state.isDestroyed) {
                  var A = {
                    instance: this,
                    styles: {},
                    arrowStyles: {},
                    attributes: {},
                    flipped: !1,
                    offsets: {}
                  };
                  A.offsets.reference = Z(this.state, this.popper, this.reference, this.options.positionFixed), A.placement = D(this.options.placement, A.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding), A.originalPlacement = A.placement, A.positionFixed = this.options.positionFixed, A.offsets.popper = Q(this.popper, A.offsets.reference, A.placement), A.offsets.popper.position = this.options.positionFixed ? "fixed" : "absolute", A = ft(this.modifiers, A), this.state.isCreated ? this.options.onUpdate(A) : (this.state.isCreated = !0, this.options.onCreate(A));
                }
              }
              function pe(A, M) {
                return A.some(function(F) {
                  var W = F.name, K = F.enabled;
                  return K && W === M;
                });
              }
              function It(A) {
                for (var M = [!1, "ms", "Webkit", "Moz", "O"], F = A.charAt(0).toUpperCase() + A.slice(1), W = 0; W < M.length; W++) {
                  var K = M[W], G = K ? "" + K + F : A;
                  if (typeof document.body.style[G] < "u")
                    return G;
                }
                return null;
              }
              function xi() {
                return this.state.isDestroyed = !0, pe(this.modifiers, "applyStyle") && (this.popper.removeAttribute("x-placement"), this.popper.style.position = "", this.popper.style.top = "", this.popper.style.left = "", this.popper.style.right = "", this.popper.style.bottom = "", this.popper.style.willChange = "", this.popper.style[It("transform")] = ""), this.disableEventListeners(), this.options.removeOnDestroy && this.popper.parentNode.removeChild(this.popper), this;
              }
              function Be(A) {
                var M = A.ownerDocument;
                return M ? M.defaultView : window;
              }
              function Qt(A, M, F, W) {
                var K = A.nodeName === "BODY", G = K ? A.ownerDocument.defaultView : A;
                G.addEventListener(M, F, { passive: !0 }), K || Qt(g(G.parentNode), M, F, W), W.push(G);
              }
              function we(A, M, F, W) {
                F.updateBound = W, Be(A).addEventListener("resize", F.updateBound, { passive: !0 });
                var K = g(A);
                return Qt(K, "scroll", F.updateBound, F.scrollParents), F.scrollElement = K, F.eventsEnabled = !0, F;
              }
              function si() {
                this.state.eventsEnabled || (this.state = we(this.reference, this.options, this.state, this.scheduleUpdate));
              }
              function Vt(A, M) {
                return Be(A).removeEventListener("resize", M.updateBound), M.scrollParents.forEach(function(F) {
                  F.removeEventListener("scroll", M.updateBound);
                }), M.updateBound = null, M.scrollParents = [], M.scrollElement = null, M.eventsEnabled = !1, M;
              }
              function ge() {
                this.state.eventsEnabled && (cancelAnimationFrame(this.scheduleUpdate), this.state = Vt(this.reference, this.state));
              }
              function ri(A) {
                return A !== "" && !isNaN(parseFloat(A)) && isFinite(A);
              }
              function Ge(A, M) {
                Object.keys(M).forEach(function(F) {
                  var W = "";
                  ["width", "height", "top", "right", "bottom", "left"].indexOf(F) !== -1 && ri(M[F]) && (W = "px"), A.style[F] = M[F] + W;
                });
              }
              function Bi(A, M) {
                Object.keys(M).forEach(function(F) {
                  var W = M[F];
                  W !== !1 ? A.setAttribute(F, M[F]) : A.removeAttribute(F);
                });
              }
              function In(A) {
                return Ge(A.instance.popper, A.styles), Bi(A.instance.popper, A.attributes), A.arrowElement && Object.keys(A.arrowStyles).length && Ge(A.arrowElement, A.arrowStyles), A;
              }
              function Ri(A, M, F, W, K) {
                var G = Z(K, M, A, F.positionFixed), X = D(F.placement, G, M, A, F.modifiers.flip.boundariesElement, F.modifiers.flip.padding);
                return M.setAttribute("x-placement", X), Ge(M, { position: F.positionFixed ? "fixed" : "absolute" }), F;
              }
              function Fi(A, M) {
                var F = A.offsets, W = F.popper, K = F.reference, G = Math.round, X = Math.floor, q = function(Ni) {
                  return Ni;
                }, it = G(K.width), ut = G(W.width), dt = ["left", "right"].indexOf(A.placement) !== -1, at = A.placement.indexOf("-") !== -1, At = it % 2 === ut % 2, mt = it % 2 === 1 && ut % 2 === 1, bt = M ? dt || at || At ? G : X : q, zt = M ? G : q;
                return {
                  left: bt(mt && !at && M ? W.left - 1 : W.left),
                  top: zt(W.top),
                  bottom: zt(W.bottom),
                  right: bt(W.right)
                };
              }
              var Ke = a && /Firefox/i.test(navigator.userAgent);
              function ai(A, M) {
                var F = M.x, W = M.y, K = A.offsets.popper, G = ot(A.instance.modifiers, function(an) {
                  return an.name === "applyStyle";
                }).gpuAcceleration;
                G !== void 0 && console.warn("WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!");
                var X = G !== void 0 ? G : M.gpuAcceleration, q = S(A.instance.popper), it = V(q), ut = {
                  position: K.position
                }, dt = Fi(A, window.devicePixelRatio < 2 || !Ke), at = F === "bottom" ? "top" : "bottom", At = W === "right" ? "left" : "right", mt = It("transform"), bt = void 0, zt = void 0;
                if (at === "bottom" ? q.nodeName === "HTML" ? zt = -q.clientHeight + dt.bottom : zt = -it.height + dt.bottom : zt = dt.top, At === "right" ? q.nodeName === "HTML" ? bt = -q.clientWidth + dt.right : bt = -it.width + dt.right : bt = dt.left, X && mt)
                  ut[mt] = "translate3d(" + bt + "px, " + zt + "px, 0)", ut[at] = 0, ut[At] = 0, ut.willChange = "transform";
                else {
                  var Ci = at === "bottom" ? -1 : 1, Ni = At === "right" ? -1 : 1;
                  ut[at] = zt * Ci, ut[At] = bt * Ni, ut.willChange = at + ", " + At;
                }
                var Fe = {
                  "x-placement": A.placement
                };
                return A.attributes = I({}, Fe, A.attributes), A.styles = I({}, ut, A.styles), A.arrowStyles = I({}, A.offsets.arrow, A.arrowStyles), A;
              }
              function oi(A, M, F) {
                var W = ot(A, function(q) {
                  var it = q.name;
                  return it === M;
                }), K = !!W && A.some(function(q) {
                  return q.name === F && q.enabled && q.order < W.order;
                });
                if (!K) {
                  var G = "`" + M + "`", X = "`" + F + "`";
                  console.warn(X + " modifier is required by " + G + " modifier in order to work, be sure to include it before " + G + "!");
                }
                return K;
              }
              function rt(A, M) {
                var F;
                if (!oi(A.instance.modifiers, "arrow", "keepTogether"))
                  return A;
                var W = M.element;
                if (typeof W == "string") {
                  if (W = A.instance.popper.querySelector(W), !W)
                    return A;
                } else if (!A.instance.popper.contains(W))
                  return console.warn("WARNING: `arrow.element` must be child of its popper element!"), A;
                var K = A.placement.split("-")[0], G = A.offsets, X = G.popper, q = G.reference, it = ["left", "right"].indexOf(K) !== -1, ut = it ? "height" : "width", dt = it ? "Top" : "Left", at = dt.toLowerCase(), At = it ? "left" : "top", mt = it ? "bottom" : "right", bt = J(W)[ut];
                q[mt] - bt < X[at] && (A.offsets.popper[at] -= X[at] - (q[mt] - bt)), q[at] + bt > X[mt] && (A.offsets.popper[at] += q[at] + bt - X[mt]), A.offsets.popper = T(A.offsets.popper);
                var zt = q[at] + q[ut] / 2 - bt / 2, Ci = f(A.instance.popper), Ni = parseFloat(Ci["margin" + dt], 10), Fe = parseFloat(Ci["border" + dt + "Width"], 10), an = zt - A.offsets.popper[at] - Ni - Fe;
                return an = Math.max(Math.min(X[ut] - bt, an), 0), A.arrowElement = W, A.offsets.arrow = (F = {}, w(F, at, Math.round(an)), w(F, At, ""), F), A;
              }
              function et(A) {
                return A === "end" ? "start" : A === "start" ? "end" : A;
              }
              var ht = ["auto-start", "auto", "auto-end", "top-start", "top", "top-end", "right-start", "right", "right-end", "bottom-end", "bottom", "bottom-start", "left-end", "left", "left-start"], gt = ht.slice(3);
              function nt(A) {
                var M = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, F = gt.indexOf(A), W = gt.slice(F + 1).concat(gt.slice(0, F));
                return M ? W.reverse() : W;
              }
              var tt = {
                FLIP: "flip",
                CLOCKWISE: "clockwise",
                COUNTERCLOCKWISE: "counterclockwise"
              };
              function ct(A, M) {
                if (pe(A.instance.modifiers, "inner") || A.flipped && A.placement === A.originalPlacement)
                  return A;
                var F = y(A.instance.popper, A.instance.reference, M.padding, M.boundariesElement, A.positionFixed), W = A.placement.split("-")[0], K = lt(W), G = A.placement.split("-")[1] || "", X = [];
                switch (M.behavior) {
                  case tt.FLIP:
                    X = [W, K];
                    break;
                  case tt.CLOCKWISE:
                    X = nt(W);
                    break;
                  case tt.COUNTERCLOCKWISE:
                    X = nt(W, !0);
                    break;
                  default:
                    X = M.behavior;
                }
                return X.forEach(function(q, it) {
                  if (W !== q || X.length === it + 1)
                    return A;
                  W = A.placement.split("-")[0], K = lt(W);
                  var ut = A.offsets.popper, dt = A.offsets.reference, at = Math.floor, At = W === "left" && at(ut.right) > at(dt.left) || W === "right" && at(ut.left) < at(dt.right) || W === "top" && at(ut.bottom) > at(dt.top) || W === "bottom" && at(ut.top) < at(dt.bottom), mt = at(ut.left) < at(F.left), bt = at(ut.right) > at(F.right), zt = at(ut.top) < at(F.top), Ci = at(ut.bottom) > at(F.bottom), Ni = W === "left" && mt || W === "right" && bt || W === "top" && zt || W === "bottom" && Ci, Fe = ["top", "bottom"].indexOf(W) !== -1, an = !!M.flipVariations && (Fe && G === "start" && mt || Fe && G === "end" && bt || !Fe && G === "start" && zt || !Fe && G === "end" && Ci), qg = !!M.flipVariationsByContent && (Fe && G === "start" && bt || Fe && G === "end" && mt || !Fe && G === "start" && Ci || !Fe && G === "end" && zt), Tc = an || qg;
                  (At || Ni || Tc) && (A.flipped = !0, (At || Ni) && (W = X[it + 1]), Tc && (G = et(G)), A.placement = W + (G ? "-" + G : ""), A.offsets.popper = I({}, A.offsets.popper, Q(A.instance.popper, A.offsets.reference, A.placement)), A = ft(A.instance.modifiers, A, "flip"));
                }), A;
              }
              function pt(A) {
                var M = A.offsets, F = M.popper, W = M.reference, K = A.placement.split("-")[0], G = Math.floor, X = ["top", "bottom"].indexOf(K) !== -1, q = X ? "right" : "bottom", it = X ? "left" : "top", ut = X ? "width" : "height";
                return F[q] < G(W[it]) && (A.offsets.popper[it] = G(W[it]) - F[ut]), F[it] > G(W[q]) && (A.offsets.popper[it] = G(W[q])), A;
              }
              function _t(A, M, F, W) {
                var K = A.match(/((?:\-|\+)?\d*\.?\d*)(.*)/), G = +K[1], X = K[2];
                if (!G)
                  return A;
                if (X.indexOf("%") === 0) {
                  var q = void 0;
                  switch (X) {
                    case "%p":
                      q = F;
                      break;
                    case "%":
                    case "%r":
                    default:
                      q = W;
                  }
                  var it = T(q);
                  return it[M] / 100 * G;
                } else if (X === "vh" || X === "vw") {
                  var ut = void 0;
                  return X === "vh" ? ut = Math.max(document.documentElement.clientHeight, window.innerHeight || 0) : ut = Math.max(document.documentElement.clientWidth, window.innerWidth || 0), ut / 100 * G;
                } else
                  return G;
              }
              function Yt(A, M, F, W) {
                var K = [0, 0], G = ["right", "left"].indexOf(W) !== -1, X = A.split(/(\+|\-)/).map(function(dt) {
                  return dt.trim();
                }), q = X.indexOf(ot(X, function(dt) {
                  return dt.search(/,|\s/) !== -1;
                }));
                X[q] && X[q].indexOf(",") === -1 && console.warn("Offsets separated by white space(s) are deprecated, use a comma (,) instead.");
                var it = /\s*,\s*|\s+/, ut = q !== -1 ? [X.slice(0, q).concat([X[q].split(it)[0]]), [X[q].split(it)[1]].concat(X.slice(q + 1))] : [X];
                return ut = ut.map(function(dt, at) {
                  var At = (at === 1 ? !G : G) ? "height" : "width", mt = !1;
                  return dt.reduce(function(bt, zt) {
                    return bt[bt.length - 1] === "" && ["+", "-"].indexOf(zt) !== -1 ? (bt[bt.length - 1] = zt, mt = !0, bt) : mt ? (bt[bt.length - 1] += zt, mt = !1, bt) : bt.concat(zt);
                  }, []).map(function(bt) {
                    return _t(bt, At, M, F);
                  });
                }), ut.forEach(function(dt, at) {
                  dt.forEach(function(At, mt) {
                    ri(At) && (K[at] += At * (dt[mt - 1] === "-" ? -1 : 1));
                  });
                }), K;
              }
              function me(A, M) {
                var F = M.offset, W = A.placement, K = A.offsets, G = K.popper, X = K.reference, q = W.split("-")[0], it = void 0;
                return ri(+F) ? it = [+F, 0] : it = Yt(F, G, X, q), q === "left" ? (G.top += it[0], G.left -= it[1]) : q === "right" ? (G.top += it[0], G.left += it[1]) : q === "top" ? (G.left += it[0], G.top -= it[1]) : q === "bottom" && (G.left += it[0], G.top += it[1]), A.popper = G, A;
              }
              function Re(A, M) {
                var F = M.boundariesElement || S(A.instance.popper);
                A.instance.reference === F && (F = S(F));
                var W = It("transform"), K = A.instance.popper.style, G = K.top, X = K.left, q = K[W];
                K.top = "", K.left = "", K[W] = "";
                var it = y(A.instance.popper, A.instance.reference, M.padding, F, A.positionFixed);
                K.top = G, K.left = X, K[W] = q, M.boundaries = it;
                var ut = M.priority, dt = A.offsets.popper, at = {
                  primary: function(mt) {
                    var bt = dt[mt];
                    return dt[mt] < it[mt] && !M.escapeWithReference && (bt = Math.max(dt[mt], it[mt])), w({}, mt, bt);
                  },
                  secondary: function(mt) {
                    var bt = mt === "right" ? "left" : "top", zt = dt[bt];
                    return dt[mt] > it[mt] && !M.escapeWithReference && (zt = Math.min(dt[bt], it[mt] - (mt === "right" ? dt.width : dt.height))), w({}, bt, zt);
                  }
                };
                return ut.forEach(function(At) {
                  var mt = ["left", "top"].indexOf(At) !== -1 ? "primary" : "secondary";
                  dt = I({}, dt, at[mt](At));
                }), A.offsets.popper = dt, A;
              }
              function de(A) {
                var M = A.placement, F = M.split("-")[0], W = M.split("-")[1];
                if (W) {
                  var K = A.offsets, G = K.reference, X = K.popper, q = ["bottom", "top"].indexOf(F) !== -1, it = q ? "left" : "top", ut = q ? "width" : "height", dt = {
                    start: w({}, it, G[it]),
                    end: w({}, it, G[it] + G[ut] - X[ut])
                  };
                  A.offsets.popper = I({}, X, dt[W]);
                }
                return A;
              }
              function rn(A) {
                if (!oi(A.instance.modifiers, "hide", "preventOverflow"))
                  return A;
                var M = A.offsets.reference, F = ot(A.instance.modifiers, function(W) {
                  return W.name === "preventOverflow";
                }).boundaries;
                if (M.bottom < F.top || M.left > F.right || M.top > F.bottom || M.right < F.left) {
                  if (A.hide === !0)
                    return A;
                  A.hide = !0, A.attributes["x-out-of-boundaries"] = "";
                } else {
                  if (A.hide === !1)
                    return A;
                  A.hide = !1, A.attributes["x-out-of-boundaries"] = !1;
                }
                return A;
              }
              function En(A) {
                var M = A.placement, F = M.split("-")[0], W = A.offsets, K = W.popper, G = W.reference, X = ["left", "right"].indexOf(F) !== -1, q = ["top", "left"].indexOf(F) === -1;
                return K[X ? "left" : "top"] = G[F] - (q ? K[X ? "width" : "height"] : 0), A.placement = lt(M), A.offsets.popper = T(K), A;
              }
              var Ga = {
                /**
                 * Modifier used to shift the popper on the start or end of its reference
                 * element.<br />
                 * It will read the variation of the `placement` property.<br />
                 * It can be one either `-end` or `-start`.
                 * @memberof modifiers
                 * @inner
                 */
                shift: {
                  /** @prop {number} order=100 - Index used to define the order of execution */
                  order: 100,
                  /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
                  enabled: !0,
                  /** @prop {ModifierFn} */
                  fn: de
                },
                /**
                 * The `offset` modifier can shift your popper on both its axis.
                 *
                 * It accepts the following units:
                 * - `px` or unit-less, interpreted as pixels
                 * - `%` or `%r`, percentage relative to the length of the reference element
                 * - `%p`, percentage relative to the length of the popper element
                 * - `vw`, CSS viewport width unit
                 * - `vh`, CSS viewport height unit
                 *
                 * For length is intended the main axis relative to the placement of the popper.<br />
                 * This means that if the placement is `top` or `bottom`, the length will be the
                 * `width`. In case of `left` or `right`, it will be the `height`.
                 *
                 * You can provide a single value (as `Number` or `String`), or a pair of values
                 * as `String` divided by a comma or one (or more) white spaces.<br />
                 * The latter is a deprecated method because it leads to confusion and will be
                 * removed in v2.<br />
                 * Additionally, it accepts additions and subtractions between different units.
                 * Note that multiplications and divisions aren't supported.
                 *
                 * Valid examples are:
                 * ```
                 * 10
                 * '10%'
                 * '10, 10'
                 * '10%, 10'
                 * '10 + 10%'
                 * '10 - 5vh + 3%'
                 * '-10px + 5vh, 5px - 6%'
                 * ```
                 * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
                 * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
                 * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
                 *
                 * @memberof modifiers
                 * @inner
                 */
                offset: {
                  /** @prop {number} order=200 - Index used to define the order of execution */
                  order: 200,
                  /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
                  enabled: !0,
                  /** @prop {ModifierFn} */
                  fn: me,
                  /** @prop {Number|String} offset=0
                   * The offset value as described in the modifier description
                   */
                  offset: 0
                },
                /**
                 * Modifier used to prevent the popper from being positioned outside the boundary.
                 *
                 * A scenario exists where the reference itself is not within the boundaries.<br />
                 * We can say it has "escaped the boundaries" — or just "escaped".<br />
                 * In this case we need to decide whether the popper should either:
                 *
                 * - detach from the reference and remain "trapped" in the boundaries, or
                 * - if it should ignore the boundary and "escape with its reference"
                 *
                 * When `escapeWithReference` is set to`true` and reference is completely
                 * outside its boundaries, the popper will overflow (or completely leave)
                 * the boundaries in order to remain attached to the edge of the reference.
                 *
                 * @memberof modifiers
                 * @inner
                 */
                preventOverflow: {
                  /** @prop {number} order=300 - Index used to define the order of execution */
                  order: 300,
                  /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
                  enabled: !0,
                  /** @prop {ModifierFn} */
                  fn: Re,
                  /**
                   * @prop {Array} [priority=['left','right','top','bottom']]
                   * Popper will try to prevent overflow following these priorities by default,
                   * then, it could overflow on the left and on top of the `boundariesElement`
                   */
                  priority: ["left", "right", "top", "bottom"],
                  /**
                   * @prop {number} padding=5
                   * Amount of pixel used to define a minimum distance between the boundaries
                   * and the popper. This makes sure the popper always has a little padding
                   * between the edges of its container
                   */
                  padding: 5,
                  /**
                   * @prop {String|HTMLElement} boundariesElement='scrollParent'
                   * Boundaries used by the modifier. Can be `scrollParent`, `window`,
                   * `viewport` or any DOM element.
                   */
                  boundariesElement: "scrollParent"
                },
                /**
                 * Modifier used to make sure the reference and its popper stay near each other
                 * without leaving any gap between the two. Especially useful when the arrow is
                 * enabled and you want to ensure that it points to its reference element.
                 * It cares only about the first axis. You can still have poppers with margin
                 * between the popper and its reference element.
                 * @memberof modifiers
                 * @inner
                 */
                keepTogether: {
                  /** @prop {number} order=400 - Index used to define the order of execution */
                  order: 400,
                  /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
                  enabled: !0,
                  /** @prop {ModifierFn} */
                  fn: pt
                },
                /**
                 * This modifier is used to move the `arrowElement` of the popper to make
                 * sure it is positioned between the reference element and its popper element.
                 * It will read the outer size of the `arrowElement` node to detect how many
                 * pixels of conjunction are needed.
                 *
                 * It has no effect if no `arrowElement` is provided.
                 * @memberof modifiers
                 * @inner
                 */
                arrow: {
                  /** @prop {number} order=500 - Index used to define the order of execution */
                  order: 500,
                  /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
                  enabled: !0,
                  /** @prop {ModifierFn} */
                  fn: rt,
                  /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
                  element: "[x-arrow]"
                },
                /**
                 * Modifier used to flip the popper's placement when it starts to overlap its
                 * reference element.
                 *
                 * Requires the `preventOverflow` modifier before it in order to work.
                 *
                 * **NOTE:** this modifier will interrupt the current update cycle and will
                 * restart it if it detects the need to flip the placement.
                 * @memberof modifiers
                 * @inner
                 */
                flip: {
                  /** @prop {number} order=600 - Index used to define the order of execution */
                  order: 600,
                  /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
                  enabled: !0,
                  /** @prop {ModifierFn} */
                  fn: ct,
                  /**
                   * @prop {String|Array} behavior='flip'
                   * The behavior used to change the popper's placement. It can be one of
                   * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
                   * placements (with optional variations)
                   */
                  behavior: "flip",
                  /**
                   * @prop {number} padding=5
                   * The popper will flip if it hits the edges of the `boundariesElement`
                   */
                  padding: 5,
                  /**
                   * @prop {String|HTMLElement} boundariesElement='viewport'
                   * The element which will define the boundaries of the popper position.
                   * The popper will never be placed outside of the defined boundaries
                   * (except if `keepTogether` is enabled)
                   */
                  boundariesElement: "viewport",
                  /**
                   * @prop {Boolean} flipVariations=false
                   * The popper will switch placement variation between `-start` and `-end` when
                   * the reference element overlaps its boundaries.
                   *
                   * The original placement should have a set variation.
                   */
                  flipVariations: !1,
                  /**
                   * @prop {Boolean} flipVariationsByContent=false
                   * The popper will switch placement variation between `-start` and `-end` when
                   * the popper element overlaps its reference boundaries.
                   *
                   * The original placement should have a set variation.
                   */
                  flipVariationsByContent: !1
                },
                /**
                 * Modifier used to make the popper flow toward the inner of the reference element.
                 * By default, when this modifier is disabled, the popper will be placed outside
                 * the reference element.
                 * @memberof modifiers
                 * @inner
                 */
                inner: {
                  /** @prop {number} order=700 - Index used to define the order of execution */
                  order: 700,
                  /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
                  enabled: !1,
                  /** @prop {ModifierFn} */
                  fn: En
                },
                /**
                 * Modifier used to hide the popper when its reference element is outside of the
                 * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
                 * be used to hide with a CSS selector the popper when its reference is
                 * out of boundaries.
                 *
                 * Requires the `preventOverflow` modifier before it in order to work.
                 * @memberof modifiers
                 * @inner
                 */
                hide: {
                  /** @prop {number} order=800 - Index used to define the order of execution */
                  order: 800,
                  /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
                  enabled: !0,
                  /** @prop {ModifierFn} */
                  fn: rn
                },
                /**
                 * Computes the style that will be applied to the popper element to gets
                 * properly positioned.
                 *
                 * Note that this modifier will not touch the DOM, it just prepares the styles
                 * so that `applyStyle` modifier can apply it. This separation is useful
                 * in case you need to replace `applyStyle` with a custom implementation.
                 *
                 * This modifier has `850` as `order` value to maintain backward compatibility
                 * with previous versions of Popper.js. Expect the modifiers ordering method
                 * to change in future major versions of the library.
                 *
                 * @memberof modifiers
                 * @inner
                 */
                computeStyle: {
                  /** @prop {number} order=850 - Index used to define the order of execution */
                  order: 850,
                  /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
                  enabled: !0,
                  /** @prop {ModifierFn} */
                  fn: ai,
                  /**
                   * @prop {Boolean} gpuAcceleration=true
                   * If true, it uses the CSS 3D transformation to position the popper.
                   * Otherwise, it will use the `top` and `left` properties
                   */
                  gpuAcceleration: !0,
                  /**
                   * @prop {string} [x='bottom']
                   * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
                   * Change this if your popper should grow in a direction different from `bottom`
                   */
                  x: "bottom",
                  /**
                   * @prop {string} [x='left']
                   * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
                   * Change this if your popper should grow in a direction different from `right`
                   */
                  y: "right"
                },
                /**
                 * Applies the computed styles to the popper element.
                 *
                 * All the DOM manipulations are limited to this modifier. This is useful in case
                 * you want to integrate Popper.js inside a framework or view library and you
                 * want to delegate all the DOM manipulations to it.
                 *
                 * Note that if you disable this modifier, you must make sure the popper element
                 * has its position set to `absolute` before Popper.js can do its work!
                 *
                 * Just disable this modifier and define your own to achieve the desired effect.
                 *
                 * @memberof modifiers
                 * @inner
                 */
                applyStyle: {
                  /** @prop {number} order=900 - Index used to define the order of execution */
                  order: 900,
                  /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
                  enabled: !0,
                  /** @prop {ModifierFn} */
                  fn: In,
                  /** @prop {Function} */
                  onLoad: Ri,
                  /**
                   * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
                   * @prop {Boolean} gpuAcceleration=true
                   * If true, it uses the CSS 3D transformation to position the popper.
                   * Otherwise, it will use the `top` and `left` properties
                   */
                  gpuAcceleration: void 0
                }
              }, Jg = {
                /**
                 * Popper's placement.
                 * @prop {Popper.placements} placement='bottom'
                 */
                placement: "bottom",
                /**
                 * Set this to true if you want popper to position it self in 'fixed' mode
                 * @prop {Boolean} positionFixed=false
                 */
                positionFixed: !1,
                /**
                 * Whether events (resize, scroll) are initially enabled.
                 * @prop {Boolean} eventsEnabled=true
                 */
                eventsEnabled: !0,
                /**
                 * Set to true if you want to automatically remove the popper when
                 * you call the `destroy` method.
                 * @prop {Boolean} removeOnDestroy=false
                 */
                removeOnDestroy: !1,
                /**
                 * Callback called when the popper is created.<br />
                 * By default, it is set to no-op.<br />
                 * Access Popper.js instance with `data.instance`.
                 * @prop {onCreate}
                 */
                onCreate: function() {
                },
                /**
                 * Callback called when the popper is updated. This callback is not called
                 * on the initialization/creation of the popper, but only on subsequent
                 * updates.<br />
                 * By default, it is set to no-op.<br />
                 * Access Popper.js instance with `data.instance`.
                 * @prop {onUpdate}
                 */
                onUpdate: function() {
                },
                /**
                 * List of modifiers used to modify the offsets before they are applied to the popper.
                 * They provide most of the functionalities of Popper.js.
                 * @prop {modifiers}
                 */
                modifiers: Ga
              }, gr = function() {
                function A(M, F) {
                  var W = this, K = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                  Y(this, A), this.scheduleUpdate = function() {
                    return requestAnimationFrame(W.update);
                  }, this.update = d(this.update.bind(this)), this.options = I({}, A.Defaults, K), this.state = {
                    isDestroyed: !1,
                    isCreated: !1,
                    scrollParents: []
                  }, this.reference = M && M.jquery ? M[0] : M, this.popper = F && F.jquery ? F[0] : F, this.options.modifiers = {}, Object.keys(I({}, A.Defaults.modifiers, K.modifiers)).forEach(function(X) {
                    W.options.modifiers[X] = I({}, A.Defaults.modifiers[X] || {}, K.modifiers ? K.modifiers[X] : {});
                  }), this.modifiers = Object.keys(this.options.modifiers).map(function(X) {
                    return I({
                      name: X
                    }, W.options.modifiers[X]);
                  }).sort(function(X, q) {
                    return X.order - q.order;
                  }), this.modifiers.forEach(function(X) {
                    X.enabled && h(X.onLoad) && X.onLoad(W.reference, W.popper, W.options, X, W.state);
                  }), this.update();
                  var G = this.options.eventsEnabled;
                  G && this.enableEventListeners(), this.state.eventsEnabled = G;
                }
                return j(A, [{
                  key: "update",
                  value: function() {
                    return Rt.call(this);
                  }
                }, {
                  key: "destroy",
                  value: function() {
                    return xi.call(this);
                  }
                }, {
                  key: "enableEventListeners",
                  value: function() {
                    return si.call(this);
                  }
                }, {
                  key: "disableEventListeners",
                  value: function() {
                    return ge.call(this);
                  }
                  /**
                   * Schedules an update. It will run on the next UI update available.
                   * @method scheduleUpdate
                   * @memberof Popper
                   */
                  /**
                   * Collection of utilities useful when writing custom modifiers.
                   * Starting from version 1.7, this method is available only if you
                   * include `popper-utils.js` before `popper.js`.
                   *
                   * **DEPRECATION**: This way to access PopperUtils is deprecated
                   * and will be removed in v2! Use the PopperUtils module directly instead.
                   * Due to the high instability of the methods contained in Utils, we can't
                   * guarantee them to follow semver. Use them at your own risk!
                   * @static
                   * @private
                   * @type {Object}
                   * @deprecated since version 1.8
                   * @member Utils
                   * @memberof Popper
                   */
                }]), A;
              }();
              gr.Utils = (typeof window < "u" ? window : r).PopperUtils, gr.placements = ht, gr.Defaults = Jg, n.a = gr;
            }).call(this, s("c8ba"));
          }
        ),
        /***/
        f5df: (
          /***/
          function(e, n, s) {
            var r = s("00ee"), a = s("c6b6"), o = s("b622"), l = o("toStringTag"), c = a(/* @__PURE__ */ function() {
              return arguments;
            }()) == "Arguments", u = function(d, h) {
              try {
                return d[h];
              } catch {
              }
            };
            e.exports = r ? a : function(d) {
              var h, f, p;
              return d === void 0 ? "Undefined" : d === null ? "Null" : typeof (f = u(h = Object(d), l)) == "string" ? f : c ? a(h) : (p = a(h)) == "Object" && typeof h.callee == "function" ? "Arguments" : p;
            };
          }
        ),
        /***/
        f6fd: (
          /***/
          function(e, n) {
            (function(s) {
              var r = "currentScript", a = s.getElementsByTagName("script");
              r in s || Object.defineProperty(s, r, {
                get: function() {
                  try {
                    throw new Error();
                  } catch (c) {
                    var o, l = (/.*at [^\(]*\((.*):.+:.+\)$/ig.exec(c.stack) || [!1])[1];
                    for (o in a)
                      if (a[o].src == l || a[o].readyState == "interactive")
                        return a[o];
                    return null;
                  }
                }
              });
            })(document);
          }
        ),
        /***/
        f772: (
          /***/
          function(e, n, s) {
            var r = s("5692"), a = s("90e3"), o = r("keys");
            e.exports = function(l) {
              return o[l] || (o[l] = a(l));
            };
          }
        ),
        /***/
        f8c2: (
          /***/
          function(e, n, s) {
            var r = s("1c0b");
            e.exports = function(a, o, l) {
              if (r(a), o === void 0) return a;
              switch (l) {
                case 0:
                  return function() {
                    return a.call(o);
                  };
                case 1:
                  return function(c) {
                    return a.call(o, c);
                  };
                case 2:
                  return function(c, u) {
                    return a.call(o, c, u);
                  };
                case 3:
                  return function(c, u, d) {
                    return a.call(o, c, u, d);
                  };
              }
              return function() {
                return a.apply(o, arguments);
              };
            };
          }
        ),
        /***/
        fb15: (
          /***/
          function(e, n, s) {
            if (s.r(n), typeof window < "u") {
              s("f6fd");
              var r;
              (r = window.document.currentScript) && (r = r.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)) && (s.p = r[1]);
            }
            s("b0c0");
            var a = function() {
              var y = this, $ = y.$createElement, D = y._self._c || $;
              return D("div", { staticClass: "v-tour" }, [y._t("default", [y.steps[y.currentStep] ? D("v-step", { key: y.currentStep, attrs: { step: y.steps[y.currentStep], "previous-step": y.previousStep, "next-step": y.nextStep, stop: y.stop, skip: y.skip, finish: y.finish, "is-first": y.isFirst, "is-last": y.isLast, labels: y.customOptions.labels, "enabled-buttons": y.customOptions.enabledButtons, highlight: y.customOptions.highlight, "stop-on-fail": y.customOptions.stopOnTargetNotFound, debug: y.customOptions.debug }, on: { targetNotFound: function(Z) {
                return y.$emit("targetNotFound", Z);
              } } }) : y._e()], { currentStep: y.currentStep, steps: y.steps, previousStep: y.previousStep, nextStep: y.nextStep, stop: y.stop, skip: y.skip, finish: y.finish, isFirst: y.isFirst, isLast: y.isLast, labels: y.customOptions.labels, enabledButtons: y.customOptions.enabledButtons, highlight: y.customOptions.highlight, debug: y.customOptions.debug })], 2);
            }, o = [];
            s("a4d3"), s("4de4"), s("4160"), s("e439"), s("dbb4"), s("b64b"), s("d3b7"), s("e25e"), s("e6cf"), s("159b"), s("96cf");
            function l(y, $, D) {
              return $ in y ? Object.defineProperty(y, $, {
                value: D,
                enumerable: !0,
                configurable: !0,
                writable: !0
              }) : y[$] = D, y;
            }
            var c = {
              onStart: function() {
              },
              onPreviousStep: function($) {
              },
              onNextStep: function($) {
              },
              onStop: function() {
              },
              onSkip: function() {
              },
              onFinish: function() {
              }
            }, u = {
              highlight: !1,
              labels: {
                buttonSkip: "Skip tour",
                buttonPrevious: "Previous",
                buttonNext: "Next",
                buttonStop: "Finish"
              },
              enabledButtons: {
                buttonSkip: !0,
                buttonPrevious: !0,
                buttonNext: !0,
                buttonStop: !0
              },
              startTimeout: 0,
              useKeyboardNavigation: !0,
              enabledNavigationKeys: {
                ESCAPE: !0,
                ARROW_RIGHT: !0,
                ARROW_LEFT: !0
              },
              debug: !1
            }, d = {
              CLASSES: {
                ACTIVE: "v-tour--active",
                TARGET_HIGHLIGHTED: "v-tour__target--highlighted",
                TARGET_RELATIVE: "v-tour__target--relative"
              },
              TRANSITION: "box-shadow 0s ease-in-out 0s",
              useKeyboardNavigation: !0,
              startTimeout: 0,
              stopOnTargetNotFound: !0
            }, h = {
              enableScrolling: !0,
              highlight: u.highlight,
              // By default use the global tour setting
              enabledButtons: u.enabledButtons,
              modifiers: {
                arrow: {
                  element: ".v-step__arrow"
                }
              },
              placement: "bottom"
            }, f = {
              ARROW_RIGHT: 39,
              ARROW_LEFT: 37,
              ESCAPE: 27
            };
            function p(y, $) {
              var D = Object.keys(y);
              if (Object.getOwnPropertySymbols) {
                var Z = Object.getOwnPropertySymbols(y);
                $ && (Z = Z.filter(function(J) {
                  return Object.getOwnPropertyDescriptor(y, J).enumerable;
                })), D.push.apply(D, Z);
              }
              return D;
            }
            function g(y) {
              for (var $ = 1; $ < arguments.length; $++) {
                var D = arguments[$] != null ? arguments[$] : {};
                $ % 2 ? p(Object(D), !0).forEach(function(Z) {
                  l(y, Z, D[Z]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(y, Object.getOwnPropertyDescriptors(D)) : p(Object(D)).forEach(function(Z) {
                  Object.defineProperty(y, Z, Object.getOwnPropertyDescriptor(D, Z));
                });
              }
              return y;
            }
            var m = {
              name: "v-tour",
              props: {
                steps: {
                  type: Array,
                  default: function() {
                    return [];
                  }
                },
                name: {
                  type: String
                },
                options: {
                  type: Object,
                  default: function() {
                    return u;
                  }
                },
                callbacks: {
                  type: Object,
                  default: function() {
                    return c;
                  }
                }
              },
              data: function() {
                return {
                  currentStep: -1
                };
              },
              mounted: function() {
                this.$tours[this.name] = this;
              },
              beforeDestroy: function() {
                this.customOptions.useKeyboardNavigation && window.removeEventListener("keyup", this.handleKeyup);
              },
              computed: {
                // Allow us to define custom options and merge them with the default options.
                // Since options is a computed property, it is reactive and can be updated during runtime.
                customOptions: function() {
                  return g({}, u, {}, this.options);
                },
                customCallbacks: function() {
                  return g({}, c, {}, this.callbacks);
                },
                // Return true if the tour is active, which means that there's a VStep displayed
                isRunning: function() {
                  return this.currentStep > -1 && this.currentStep < this.numberOfSteps;
                },
                isFirst: function() {
                  return this.currentStep === 0;
                },
                isLast: function() {
                  return this.currentStep === this.steps.length - 1;
                },
                numberOfSteps: function() {
                  return this.steps.length;
                },
                step: function() {
                  return this.steps[this.currentStep];
                }
              },
              methods: {
                start: function($) {
                  var D = this, Z, J;
                  return regeneratorRuntime.async(function(Q) {
                    for (; ; )
                      switch (Q.prev = Q.next) {
                        case 0:
                          if (this.customOptions.useKeyboardNavigation && window.addEventListener("keyup", this.handleKeyup), $ = typeof $ < "u" ? parseInt($, 10) : 0, Z = this.steps[$], J = function() {
                            return new Promise(function(st, ft) {
                              setTimeout(function() {
                                D.customCallbacks.onStart(), D.currentStep = $, st();
                              }, D.customOptions.startTimeout);
                            });
                          }, !(typeof Z.before < "u")) {
                            Q.next = 13;
                            break;
                          }
                          return Q.prev = 5, Q.next = 8, regeneratorRuntime.awrap(Z.before("start"));
                        case 8:
                          Q.next = 13;
                          break;
                        case 10:
                          return Q.prev = 10, Q.t0 = Q.catch(5), Q.abrupt("return", Promise.reject(Q.t0));
                        case 13:
                          return Q.next = 15, regeneratorRuntime.awrap(J());
                        case 15:
                          return Q.abrupt("return", Promise.resolve());
                        case 16:
                        case "end":
                          return Q.stop();
                      }
                  }, null, this, [[5, 10]]);
                },
                previousStep: function() {
                  var $ = this, D, Z, J;
                  return regeneratorRuntime.async(function(Q) {
                    for (; ; )
                      switch (Q.prev = Q.next) {
                        case 0:
                          if (D = this.currentStep - 1, Z = function() {
                            return new Promise(function(st, ft) {
                              $.customCallbacks.onPreviousStep($.currentStep), $.currentStep = D, st();
                            });
                          }, !(D > -1)) {
                            Q.next = 15;
                            break;
                          }
                          if (J = this.steps[D], !(typeof J.before < "u")) {
                            Q.next = 13;
                            break;
                          }
                          return Q.prev = 5, Q.next = 8, regeneratorRuntime.awrap(J.before("previous"));
                        case 8:
                          Q.next = 13;
                          break;
                        case 10:
                          return Q.prev = 10, Q.t0 = Q.catch(5), Q.abrupt("return", Promise.reject(Q.t0));
                        case 13:
                          return Q.next = 15, regeneratorRuntime.awrap(Z());
                        case 15:
                          return Q.abrupt("return", Promise.resolve());
                        case 16:
                        case "end":
                          return Q.stop();
                      }
                  }, null, this, [[5, 10]]);
                },
                nextStep: function() {
                  var $ = this, D, Z, J;
                  return regeneratorRuntime.async(function(Q) {
                    for (; ; )
                      switch (Q.prev = Q.next) {
                        case 0:
                          if (D = this.currentStep + 1, Z = function() {
                            return new Promise(function(st, ft) {
                              $.customCallbacks.onNextStep($.currentStep), $.currentStep = D, st();
                            });
                          }, !(D < this.numberOfSteps && this.currentStep !== -1)) {
                            Q.next = 15;
                            break;
                          }
                          if (J = this.steps[D], !(typeof J.before < "u")) {
                            Q.next = 13;
                            break;
                          }
                          return Q.prev = 5, Q.next = 8, regeneratorRuntime.awrap(J.before("next"));
                        case 8:
                          Q.next = 13;
                          break;
                        case 10:
                          return Q.prev = 10, Q.t0 = Q.catch(5), Q.abrupt("return", Promise.reject(Q.t0));
                        case 13:
                          return Q.next = 15, regeneratorRuntime.awrap(Z());
                        case 15:
                          return Q.abrupt("return", Promise.resolve());
                        case 16:
                        case "end":
                          return Q.stop();
                      }
                  }, null, this, [[5, 10]]);
                },
                stop: function() {
                  this.customCallbacks.onStop(), document.body.classList.remove("v-tour--active"), this.currentStep = -1;
                },
                skip: function() {
                  this.customCallbacks.onSkip(), this.stop();
                },
                finish: function() {
                  this.customCallbacks.onFinish(), this.stop();
                },
                handleKeyup: function($) {
                  switch (this.customOptions.debug && console.log("[Vue Tour] A keyup event occured:", $), $.keyCode) {
                    case f.ARROW_RIGHT:
                      this.isKeyEnabled("ARROW_RIGHT") && this.nextStep();
                      break;
                    case f.ARROW_LEFT:
                      this.isKeyEnabled("ARROW_LEFT") && this.previousStep();
                      break;
                    case f.ESCAPE:
                      this.isKeyEnabled("ESCAPE") && this.stop();
                      break;
                  }
                },
                isKeyEnabled: function($) {
                  var D = this.customOptions.enabledNavigationKeys;
                  return D.hasOwnProperty($) ? D[$] : !0;
                }
              }
            }, v = m;
            s("07e8");
            function b(y, $, D, Z, J, lt, Q, ot) {
              var st = typeof y == "function" ? y.options : y;
              return $ && (st.render = $, st.staticRenderFns = D, st._compiled = !0), lt && (st._scopeId = "data-v-" + lt), {
                exports: y,
                options: st
              };
            }
            var _ = b(
              v,
              a,
              o,
              !1,
              null,
              null
            ), S = _.exports, C = function() {
              var y = this, $ = y.$createElement, D = y._self._c || $;
              return D("div", { ref: "v-step-" + y.hash, staticClass: "v-step", class: { "v-step--sticky": y.isSticky }, attrs: { id: "v-step-" + y.hash } }, [y._t("header", [y.step.header ? D("div", { staticClass: "v-step__header" }, [y.step.header.title ? D("div", { domProps: { innerHTML: y._s(y.step.header.title) } }) : y._e()]) : y._e()]), y._t("content", [D("div", { staticClass: "v-step__content" }, [y.step.content ? D("div", { domProps: { innerHTML: y._s(y.step.content) } }) : D("div", [y._v("This is a demo step! The id of this step is " + y._s(y.hash) + " and it targets " + y._s(y.step.target) + ".")])])]), y._t("actions", [D("div", { staticClass: "v-step__buttons" }, [!y.isLast && y.isButtonEnabled("buttonSkip") ? D("button", { staticClass: "v-step__button v-step__button-skip", on: { click: function(Z) {
                return Z.preventDefault(), y.skip(Z);
              } } }, [y._v(y._s(y.labels.buttonSkip))]) : y._e(), !y.isFirst && y.isButtonEnabled("buttonPrevious") ? D("button", { staticClass: "v-step__button v-step__button-previous", on: { click: function(Z) {
                return Z.preventDefault(), y.previousStep(Z);
              } } }, [y._v(y._s(y.labels.buttonPrevious))]) : y._e(), !y.isLast && y.isButtonEnabled("buttonNext") ? D("button", { staticClass: "v-step__button v-step__button-next", on: { click: function(Z) {
                return Z.preventDefault(), y.nextStep(Z);
              } } }, [y._v(y._s(y.labels.buttonNext))]) : y._e(), y.isLast && y.isButtonEnabled("buttonStop") ? D("button", { staticClass: "v-step__button v-step__button-stop", on: { click: function(Z) {
                return Z.preventDefault(), y.finish(Z);
              } } }, [y._v(y._s(y.labels.buttonStop))]) : y._e()])]), D("div", { staticClass: "v-step__arrow", class: { "v-step__arrow--dark": y.step.header && y.step.header.title } })], 2);
            }, O = [];
            s("99af"), s("caad"), s("cca6"), s("ac1f"), s("2532"), s("5319");
            var k = s("f0bd"), P = function($, D, Z, J) {
              return $ /= J / 2, $ < 1 ? Z / 2 * $ * $ + D : ($--, -Z / 2 * ($ * ($ - 2) - 1) + D);
            }, x = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(y) {
              return typeof y;
            } : function(y) {
              return y && typeof Symbol == "function" && y.constructor === Symbol && y !== Symbol.prototype ? "symbol" : typeof y;
            }, R = function() {
              var $ = void 0, D = void 0, Z = void 0, J = void 0, lt = void 0, Q = void 0, ot = void 0, st = void 0, ft = void 0, Rt = void 0, pe = void 0, It = void 0;
              function xi() {
                return window.scrollY || window.pageYOffset;
              }
              function Be(Vt) {
                return Vt.getBoundingClientRect().top + D;
              }
              function Qt(Vt) {
                ft || (ft = Vt), Rt = Vt - ft, pe = lt(Rt, D, ot, st), window.scrollTo(0, pe), Rt < st ? window.requestAnimationFrame(Qt) : we();
              }
              function we() {
                window.scrollTo(0, D + ot), $ && Q && ($.setAttribute("tabindex", "-1"), $.focus()), typeof It == "function" && It(), ft = !1;
              }
              function si(Vt) {
                var ge = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                switch (st = ge.duration || 1e3, J = ge.offset || 0, It = ge.callback, lt = ge.easing || P, Q = ge.a11y || !1, D = xi(), typeof Vt > "u" ? "undefined" : x(Vt)) {
                  case "number":
                    $ = void 0, Q = !1, Z = D + Vt;
                    break;
                  case "object":
                    $ = Vt, Z = Be($);
                    break;
                  case "string":
                    $ = document.querySelector(Vt), Z = Be($);
                    break;
                }
                switch (ot = Z - D + J, x(ge.duration)) {
                  case "number":
                    st = ge.duration;
                    break;
                  case "function":
                    st = ge.duration(ot);
                    break;
                }
                window.requestAnimationFrame(Qt);
              }
              return si;
            }, B = R(), L = B, Y = s("8634"), j = /* @__PURE__ */ s.n(Y);
            function w(y, $) {
              var D = Object.keys(y);
              if (Object.getOwnPropertySymbols) {
                var Z = Object.getOwnPropertySymbols(y);
                $ && (Z = Z.filter(function(J) {
                  return Object.getOwnPropertyDescriptor(y, J).enumerable;
                })), D.push.apply(D, Z);
              }
              return D;
            }
            function I(y) {
              for (var $ = 1; $ < arguments.length; $++) {
                var D = arguments[$] != null ? arguments[$] : {};
                $ % 2 ? w(Object(D), !0).forEach(function(Z) {
                  l(y, Z, D[Z]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(y, Object.getOwnPropertyDescriptors(D)) : w(Object(D)).forEach(function(Z) {
                  Object.defineProperty(y, Z, Object.getOwnPropertyDescriptor(D, Z));
                });
              }
              return y;
            }
            var T = {
              name: "v-step",
              props: {
                step: {
                  type: Object
                },
                previousStep: {
                  type: Function
                },
                nextStep: {
                  type: Function
                },
                stop: {
                  type: Function
                },
                skip: {
                  type: Function,
                  default: function() {
                    this.stop();
                  }
                },
                finish: {
                  type: Function,
                  default: function() {
                    this.stop();
                  }
                },
                isFirst: {
                  type: Boolean
                },
                isLast: {
                  type: Boolean
                },
                labels: {
                  type: Object
                },
                enabledButtons: {
                  type: Object
                },
                highlight: {
                  type: Boolean
                },
                stopOnFail: {
                  type: Boolean
                },
                debug: {
                  type: Boolean
                }
              },
              data: function() {
                return {
                  hash: j()(this.step.target),
                  targetElement: document.querySelector(this.step.target)
                };
              },
              computed: {
                params: function() {
                  return I({}, h, {}, {
                    highlight: this.highlight
                  }, {}, {
                    enabledButtons: Object.assign({}, this.enabledButtons)
                  }, {}, this.step.params);
                },
                /**
                 * A step is considered sticky if it has no target.
                 */
                isSticky: function() {
                  return !this.step.target;
                }
              },
              methods: {
                createStep: function() {
                  this.debug && console.log("[Vue Tour] The target element " + this.step.target + ' of .v-step[id="' + this.hash + '"] is:', this.targetElement), this.isSticky ? document.body.appendChild(this.$refs["v-step-" + this.hash]) : this.targetElement ? (this.enableScrolling(), this.createHighlight(), new k.a(this.targetElement, this.$refs["v-step-" + this.hash], this.params)) : (this.debug && console.error("[Vue Tour] The target element " + this.step.target + ' of .v-step[id="' + this.hash + '"] does not exist!'), this.$emit("targetNotFound", this.step), this.stopOnFail && this.stop());
                },
                enableScrolling: function() {
                  if (this.params.enableScrolling)
                    if (this.step.duration || this.step.offset) {
                      var $ = {
                        duration: this.step.duration || 1e3,
                        offset: this.step.offset || 0,
                        callback: void 0,
                        a11y: !1
                      };
                      L(this.targetElement, $);
                    } else
                      this.targetElement.scrollIntoView({
                        behavior: "smooth"
                      });
                },
                isHighlightEnabled: function() {
                  return this.debug && console.log("[Vue Tour] Highlight is ".concat(this.params.highlight ? "enabled" : "disabled", ' for .v-step[id="').concat(this.hash, '"]')), this.params.highlight;
                },
                createHighlight: function() {
                  if (this.isHighlightEnabled()) {
                    document.body.classList.add(d.CLASSES.ACTIVE);
                    var $ = window.getComputedStyle(this.targetElement).getPropertyValue("transition");
                    $ !== "all 0s ease 0s" && (this.targetElement.style.transition = "".concat($, ", ").concat(d.TRANSITION)), this.targetElement.classList.add(d.CLASSES.TARGET_HIGHLIGHTED), this.targetElement.style.position || this.targetElement.classList.add(d.CLASSES.TARGET_RELATIVE);
                  } else
                    document.body.classList.remove(d.CLASSES.ACTIVE);
                },
                removeHighlight: function() {
                  if (this.isHighlightEnabled()) {
                    var $ = this.targetElement, D = this.targetElement.style.transition;
                    this.targetElement.classList.remove(d.CLASSES.TARGET_HIGHLIGHTED), this.targetElement.classList.remove(d.CLASSES.TARGET_RELATIVE), D.includes(d.TRANSITION) && setTimeout(function() {
                      $.style.transition = D.replace(", ".concat(d.TRANSITION), "");
                    }, 0);
                  }
                },
                isButtonEnabled: function($) {
                  return this.params.enabledButtons.hasOwnProperty($) ? this.params.enabledButtons[$] : !0;
                }
              },
              mounted: function() {
                this.createStep();
              },
              destroyed: function() {
                this.removeHighlight();
              }
            }, V = T;
            s("4b09");
            var N = b(
              V,
              C,
              O,
              !1,
              null,
              "0436c460"
            ), z = N.exports, E = {
              install: function($, D) {
                $.component(S.name, S), $.component(z.name, z), $.prototype.$tours = {};
              }
            }, H = E;
            typeof window < "u" && window.Vue && window.Vue.use(E), n.default = H;
          }
        ),
        /***/
        fc6a: (
          /***/
          function(e, n, s) {
            var r = s("44ad"), a = s("1d80");
            e.exports = function(o) {
              return r(a(o));
            };
          }
        ),
        /***/
        fdbc: (
          /***/
          function(e, n) {
            e.exports = {
              CSSRuleList: 0,
              CSSStyleDeclaration: 0,
              CSSValueList: 0,
              ClientRectList: 0,
              DOMRectList: 0,
              DOMStringList: 0,
              DOMTokenList: 1,
              DataTransferItemList: 0,
              FileList: 0,
              HTMLAllCollection: 0,
              HTMLCollection: 0,
              HTMLFormElement: 0,
              HTMLSelectElement: 0,
              MediaList: 0,
              MimeTypeArray: 0,
              NamedNodeMap: 0,
              NodeList: 1,
              PaintRequestList: 0,
              Plugin: 0,
              PluginArray: 0,
              SVGLengthList: 0,
              SVGNumberList: 0,
              SVGPathSegList: 0,
              SVGPointList: 0,
              SVGStringList: 0,
              SVGTransformList: 0,
              SourceBufferList: 0,
              StyleSheetList: 0,
              TextTrackCueList: 0,
              TextTrackList: 0,
              TouchList: 0
            };
          }
        ),
        /***/
        fdbf: (
          /***/
          function(e, n, s) {
            var r = s("4930");
            e.exports = r && !Symbol.sham && typeof Symbol() == "symbol";
          }
        ),
        /***/
        fea9: (
          /***/
          function(e, n, s) {
            var r = s("da84");
            e.exports = r.Promise;
          }
        )
        /******/
      })
    );
  });
})(qh);
var f5 = qh.exports;
const p5 = /* @__PURE__ */ as(f5);
Ti.use(p5);
const g5 = {
  name: "AcvTour",
  components: {
    AcvButton: bi,
    AcvIcon: ie
  },
  mixins: [
    lh
  ],
  props: {
    name: {
      type: String,
      required: !0
    },
    /*
     * Example Step:
     * {
     *  header: 'Header Text',
     *  showDismissIcon: true|false,
     *  target: '#a-selector .class',
     *  content: '<div>Html is Supported</div>',
     *  params: {
     *    enableScrolling: false,
     *  }
     */
    steps: {
      type: Array,
      required: !0
    },
    // See vue-tour docs for configuration options. - ETC
    // https://github.com/pulsardev/vue-tour/wiki/Tour-Configuration
    options: {
      type: Object,
      default: () => ({
        highlight: !0
        // debug: true,
      })
    },
    showDismissIcon: {
      type: Boolean,
      default: !0
    },
    hidePreviousButton: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      callbacks: {
        onStart: () => {
          this.emitCallbackEvent("on-start");
        },
        onStop: () => {
          this.emitCallbackEvent("on-stop");
        },
        onPreviousStep: () => {
          this.emitCallbackEvent("on-previous-step");
        },
        onNextStep: () => {
          this.emitCallbackEvent("on-next-step");
        },
        onSkip: () => {
          this.emitCallbackEvent("on-skip");
        },
        onFinish: () => {
          this.emitCallbackEvent("on-finish");
        }
      },
      isFinished: !1
    };
  },
  methods: {
    getShowDismissIcon(i) {
      const { showDismissIcon: t = this.showDismissIcon } = i;
      return t;
    },
    handleNextButtonClicked(i) {
      i.isLast ? i.finish() : i.nextStep();
    },
    start(i = 0) {
      this.isFinished = !1, this.$tours[this.name].start(i);
    },
    previousStep() {
      this.$tours[this.name].previousStep();
    },
    nextStep() {
      this.$tours[this.name].nextStep();
    },
    skip() {
      this.$tours[this.name].skip();
    },
    stop() {
      this.$tours[this.name].stop();
    },
    finish() {
      this.$tours[this.name].finish();
    },
    emitCallbackEvent(i) {
      if (!this.isFinished) {
        i === "on-finish" && this.$tours[this.name].isLast && (this.isFinished = !0);
        const { currentStep: t } = this.$tours[this.name];
        this.$emit(i, t);
      }
    }
  }
};
var m5 = function() {
  var t = this, e = t._self._c;
  return e("v-tour", { ref: t.name, staticClass: "acv-tour", attrs: { name: t.name, steps: t.steps, options: t.options, callbacks: t.callbacks }, scopedSlots: t._u([{ key: "default", fn: function(n) {
    return [n.steps[n.currentStep] ? e("v-step", { key: n.steps[n.currentStep].key || n.currentStep, attrs: { step: n.steps[n.currentStep], "previous-step": n.previousStep, "next-step": n.nextStep, stop: n.stop, skip: n.skip, "is-first": n.isFirst, "is-last": n.isLast, labels: n.labels, finish: n.finish, "enabled-buttons": n.enabledButtons, highlight: n.highlight, "stop-on-fail": n.stopOnTargetNotFound, debug: n.debug }, scopedSlots: t._u([!t.$slots.header && n.steps[n.currentStep].header ? { key: "header", fn: function() {
      return [e("div", { staticClass: "tw-flexbox-row-align-center-justify-between tw-w-full" }, [e("div", { staticClass: "tw-font-sans tw-font-bold tw-text-text-secondary tw-text-lg" }, [t._v(" " + t._s(n.steps[n.currentStep].header) + " ")]), t.getShowDismissIcon(n.steps[n.currentStep]) ? e("button", { staticClass: "close", attrs: { type: "button", "aria-label": "Close" }, on: { click: t.skip } }, [e("acv-icon", { attrs: { icon: "close" } })], 1) : t._e()])];
    }, proxy: !0 } : null, t.$slots.actions ? null : { key: "actions", fn: function() {
      return [e("div", { staticClass: "tw-flexbox-row-align-center-justify-between tw-w-full" }, [e("div", { staticClass: "subtitle-2" }, [t._v(" " + t._s(n.currentStep + 1) + " / " + t._s(n.steps.length) + " ")]), !n.isFirst && !n.steps[n.currentStep].hidePreviousButton && !t.hidePreviousButton ? e("acv-button", { staticClass: "previous tw-ml-8", attrs: { variant: "tertiary" }, on: { click: n.previousStep } }, [t._v(" " + t._s(n.steps[n.currentStep].buttonPreviousLabel || "Previous") + " ")]) : t._e(), e("acv-button", { staticClass: "next", attrs: { variant: "primary" }, on: { click: function(s) {
        return t.handleNextButtonClicked(n);
      } } }, [t._v(" " + t._s(n.steps[n.currentStep].buttonNextLabel || "Next") + " ")])], 1)];
    }, proxy: !0 }, t._l(t.$scopedSlots, function(s, r) {
      return { key: r, fn: function(a) {
        return [t._t(r, null, { currentStep: n.steps[n.currentStep], currentStepIndex: n.currentStep }, a)];
      } };
    }), t._l(t.$slots, function(s, r) {
      return { key: r, fn: function() {
        return [t._t(r)];
      }, proxy: !0 };
    })], null, !0) }) : t._e()];
  } }]) });
}, v5 = [], A5 = /* @__PURE__ */ U(
  g5,
  m5,
  v5,
  !1,
  null,
  "f9df3956"
);
const b5 = A5.exports;
function Mi(i) {
  if (i === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return i;
}
function tf(i, t) {
  i.prototype = Object.create(t.prototype), i.prototype.constructor = i, i.__proto__ = t;
}
/*!
 * GSAP 3.12.5
 * https://gsap.com
 *
 * @license Copyright 2008-2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/
var De = {
  autoSleep: 120,
  force3D: "auto",
  nullTargetWarn: 1,
  units: {
    lineHeight: ""
  }
}, Jn = {
  duration: 0.5,
  overwrite: !1,
  delay: 0
}, Pl, oe, Et, je = 1e8, Pt = 1 / je, jo = Math.PI * 2, y5 = jo / 4, _5 = 0, ef = Math.sqrt, x5 = Math.cos, C5 = Math.sin, qt = function(t) {
  return typeof t == "string";
}, jt = function(t) {
  return typeof t == "function";
}, Ei = function(t) {
  return typeof t == "number";
}, Ll = function(t) {
  return typeof t > "u";
}, Ai = function(t) {
  return typeof t == "object";
}, be = function(t) {
  return t !== !1;
}, Il = function() {
  return typeof window < "u";
}, Cr = function(t) {
  return jt(t) || qt(t);
}, nf = typeof ArrayBuffer == "function" && ArrayBuffer.isView || function() {
}, le = Array.isArray, Wo = /(?:-?\.?\d|\.)+/gi, sf = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, jn = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, no = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, rf = /[+-]=-?[.\d]+/, af = /[^,'"\[\]\s]+/gi, S5 = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i, Nt, ui, Yo, El, Le = {}, ea = {}, of, lf = function(t) {
  return (ea = Cn(t, Le)) && Se;
}, $l = function(t, e) {
  return console.warn("Invalid property", t, "set to", e, "Missing plugin? gsap.registerPlugin()");
}, Fs = function(t, e) {
  return !e && console.warn(t);
}, cf = function(t, e) {
  return t && (Le[t] = e) && ea && (ea[t] = e) || Le;
}, Ns = function() {
  return 0;
}, w5 = {
  suppressEvents: !0,
  isStart: !0,
  kill: !1
}, Wr = {
  suppressEvents: !0,
  kill: !1
}, k5 = {
  suppressEvents: !0
}, Bl = {}, Gi = [], Uo = {}, uf, ke = {}, so = {}, Yc = 30, Yr = [], Rl = "", Fl = function(t) {
  var e = t[0], n, s;
  if (Ai(e) || jt(e) || (t = [t]), !(n = (e._gsap || {}).harness)) {
    for (s = Yr.length; s-- && !Yr[s].targetTest(e); )
      ;
    n = Yr[s];
  }
  for (s = t.length; s--; )
    t[s] && (t[s]._gsap || (t[s]._gsap = new Ef(t[s], n))) || t.splice(s, 1);
  return t;
}, vn = function(t) {
  return t._gsap || Fl(We(t))[0]._gsap;
}, df = function(t, e, n) {
  return (n = t[e]) && jt(n) ? t[e]() : Ll(n) && t.getAttribute && t.getAttribute(e) || n;
}, ye = function(t, e) {
  return (t = t.split(",")).forEach(e) || t;
}, Ut = function(t) {
  return Math.round(t * 1e5) / 1e5 || 0;
}, Jt = function(t) {
  return Math.round(t * 1e7) / 1e7 || 0;
}, Gn = function(t, e) {
  var n = e.charAt(0), s = parseFloat(e.substr(2));
  return t = parseFloat(t), n === "+" ? t + s : n === "-" ? t - s : n === "*" ? t * s : t / s;
}, O5 = function(t, e) {
  for (var n = e.length, s = 0; t.indexOf(e[s]) < 0 && ++s < n; )
    ;
  return s < n;
}, ia = function() {
  var t = Gi.length, e = Gi.slice(0), n, s;
  for (Uo = {}, Gi.length = 0, n = 0; n < t; n++)
    s = e[n], s && s._lazy && (s.render(s._lazy[0], s._lazy[1], !0)._lazy = 0);
}, hf = function(t, e, n, s) {
  Gi.length && !oe && ia(), t.render(e, n, oe && e < 0 && (t._initted || t._startAt)), Gi.length && !oe && ia();
}, ff = function(t) {
  var e = parseFloat(t);
  return (e || e === 0) && (t + "").match(af).length < 2 ? e : qt(t) ? t.trim() : t;
}, pf = function(t) {
  return t;
}, Ue = function(t, e) {
  for (var n in e)
    n in t || (t[n] = e[n]);
  return t;
}, M5 = function(t) {
  return function(e, n) {
    for (var s in n)
      s in e || s === "duration" && t || s === "ease" || (e[s] = n[s]);
  };
}, Cn = function(t, e) {
  for (var n in e)
    t[n] = e[n];
  return t;
}, Uc = function i(t, e) {
  for (var n in e)
    n !== "__proto__" && n !== "constructor" && n !== "prototype" && (t[n] = Ai(e[n]) ? i(t[n] || (t[n] = {}), e[n]) : e[n]);
  return t;
}, na = function(t, e) {
  var n = {}, s;
  for (s in t)
    s in e || (n[s] = t[s]);
  return n;
}, Ms = function(t) {
  var e = t.parent || Nt, n = t.keyframes ? M5(le(t.keyframes)) : Ue;
  if (be(t.inherit))
    for (; e; )
      n(t, e.vars.defaults), e = e.parent || e._dp;
  return t;
}, T5 = function(t, e) {
  for (var n = t.length, s = n === e.length; s && n-- && t[n] === e[n]; )
    ;
  return n < 0;
}, gf = function(t, e, n, s, r) {
  var a = t[s], o;
  if (r)
    for (o = e[r]; a && a[r] > o; )
      a = a._prev;
  return a ? (e._next = a._next, a._next = e) : (e._next = t[n], t[n] = e), e._next ? e._next._prev = e : t[s] = e, e._prev = a, e.parent = e._dp = t, e;
}, Ma = function(t, e, n, s) {
  n === void 0 && (n = "_first"), s === void 0 && (s = "_last");
  var r = e._prev, a = e._next;
  r ? r._next = a : t[n] === e && (t[n] = a), a ? a._prev = r : t[s] === e && (t[s] = r), e._next = e._prev = e.parent = null;
}, Qi = function(t, e) {
  t.parent && (!e || t.parent.autoRemoveChildren) && t.parent.remove && t.parent.remove(t), t._act = 0;
}, An = function(t, e) {
  if (t && (!e || e._end > t._dur || e._start < 0))
    for (var n = t; n; )
      n._dirty = 1, n = n.parent;
  return t;
}, D5 = function(t) {
  for (var e = t.parent; e && e.parent; )
    e._dirty = 1, e.totalDuration(), e = e.parent;
  return t;
}, Zo = function(t, e, n, s) {
  return t._startAt && (oe ? t._startAt.revert(Wr) : t.vars.immediateRender && !t.vars.autoRevert || t._startAt.render(e, !0, s));
}, P5 = function i(t) {
  return !t || t._ts && i(t.parent);
}, Zc = function(t) {
  return t._repeat ? qn(t._tTime, t = t.duration() + t._rDelay) * t : 0;
}, qn = function(t, e) {
  var n = Math.floor(t /= e);
  return t && n === t ? n - 1 : n;
}, sa = function(t, e) {
  return (t - e._start) * e._ts + (e._ts >= 0 ? 0 : e._dirty ? e.totalDuration() : e._tDur);
}, Ta = function(t) {
  return t._end = Jt(t._start + (t._tDur / Math.abs(t._ts || t._rts || Pt) || 0));
}, Da = function(t, e) {
  var n = t._dp;
  return n && n.smoothChildTiming && t._ts && (t._start = Jt(n._time - (t._ts > 0 ? e / t._ts : ((t._dirty ? t.totalDuration() : t._tDur) - e) / -t._ts)), Ta(t), n._dirty || An(n, t)), t;
}, mf = function(t, e) {
  var n;
  if ((e._time || !e._dur && e._initted || e._start < t._time && (e._dur || !e.add)) && (n = sa(t.rawTime(), e), (!e._dur || nr(0, e.totalDuration(), n) - e._tTime > Pt) && e.render(n, !0)), An(t, e)._dp && t._initted && t._time >= t._dur && t._ts) {
    if (t._dur < t.duration())
      for (n = t; n._dp; )
        n.rawTime() >= 0 && n.totalTime(n._tTime), n = n._dp;
    t._zTime = -Pt;
  }
}, di = function(t, e, n, s) {
  return e.parent && Qi(e), e._start = Jt((Ei(n) ? n : n || t !== Nt ? He(t, n, e) : t._time) + e._delay), e._end = Jt(e._start + (e.totalDuration() / Math.abs(e.timeScale()) || 0)), gf(t, e, "_first", "_last", t._sort ? "_start" : 0), Go(e) || (t._recent = e), s || mf(t, e), t._ts < 0 && Da(t, t._tTime), t;
}, vf = function(t, e) {
  return (Le.ScrollTrigger || $l("scrollTrigger", e)) && Le.ScrollTrigger.create(e, t);
}, Af = function(t, e, n, s, r) {
  if (Hl(t, e, r), !t._initted)
    return 1;
  if (!n && t._pt && !oe && (t._dur && t.vars.lazy !== !1 || !t._dur && t.vars.lazy) && uf !== Me.frame)
    return Gi.push(t), t._lazy = [r, s], 1;
}, L5 = function i(t) {
  var e = t.parent;
  return e && e._ts && e._initted && !e._lock && (e.rawTime() < 0 || i(e));
}, Go = function(t) {
  var e = t.data;
  return e === "isFromStart" || e === "isStart";
}, I5 = function(t, e, n, s) {
  var r = t.ratio, a = e < 0 || !e && (!t._start && L5(t) && !(!t._initted && Go(t)) || (t._ts < 0 || t._dp._ts < 0) && !Go(t)) ? 0 : 1, o = t._rDelay, l = 0, c, u, d;
  if (o && t._repeat && (l = nr(0, t._tDur, e), u = qn(l, o), t._yoyo && u & 1 && (a = 1 - a), u !== qn(t._tTime, o) && (r = 1 - a, t.vars.repeatRefresh && t._initted && t.invalidate())), a !== r || oe || s || t._zTime === Pt || !e && t._zTime) {
    if (!t._initted && Af(t, e, s, n, l))
      return;
    for (d = t._zTime, t._zTime = e || (n ? Pt : 0), n || (n = e && !d), t.ratio = a, t._from && (a = 1 - a), t._time = 0, t._tTime = l, c = t._pt; c; )
      c.r(a, c.d), c = c._next;
    e < 0 && Zo(t, e, n, !0), t._onUpdate && !n && Te(t, "onUpdate"), l && t._repeat && !n && t.parent && Te(t, "onRepeat"), (e >= t._tDur || e < 0) && t.ratio === a && (a && Qi(t, 1), !n && !oe && (Te(t, a ? "onComplete" : "onReverseComplete", !0), t._prom && t._prom()));
  } else t._zTime || (t._zTime = e);
}, E5 = function(t, e, n) {
  var s;
  if (n > e)
    for (s = t._first; s && s._start <= n; ) {
      if (s.data === "isPause" && s._start > e)
        return s;
      s = s._next;
    }
  else
    for (s = t._last; s && s._start >= n; ) {
      if (s.data === "isPause" && s._start < e)
        return s;
      s = s._prev;
    }
}, ts = function(t, e, n, s) {
  var r = t._repeat, a = Jt(e) || 0, o = t._tTime / t._tDur;
  return o && !s && (t._time *= a / t._dur), t._dur = a, t._tDur = r ? r < 0 ? 1e10 : Jt(a * (r + 1) + t._rDelay * r) : a, o > 0 && !s && Da(t, t._tTime = t._tDur * o), t.parent && Ta(t), n || An(t.parent, t), t;
}, Gc = function(t) {
  return t instanceof he ? An(t) : ts(t, t._dur);
}, $5 = {
  _start: 0,
  endTime: Ns,
  totalDuration: Ns
}, He = function i(t, e, n) {
  var s = t.labels, r = t._recent || $5, a = t.duration() >= je ? r.endTime(!1) : t._dur, o, l, c;
  return qt(e) && (isNaN(e) || e in s) ? (l = e.charAt(0), c = e.substr(-1) === "%", o = e.indexOf("="), l === "<" || l === ">" ? (o >= 0 && (e = e.replace(/=/, "")), (l === "<" ? r._start : r.endTime(r._repeat >= 0)) + (parseFloat(e.substr(1)) || 0) * (c ? (o < 0 ? r : n).totalDuration() / 100 : 1)) : o < 0 ? (e in s || (s[e] = a), s[e]) : (l = parseFloat(e.charAt(o - 1) + e.substr(o + 1)), c && n && (l = l / 100 * (le(n) ? n[0] : n).totalDuration()), o > 1 ? i(t, e.substr(0, o - 1), n) + l : a + l)) : e == null ? a : +e;
}, Ts = function(t, e, n) {
  var s = Ei(e[1]), r = (s ? 2 : 1) + (t < 2 ? 0 : 1), a = e[r], o, l;
  if (s && (a.duration = e[1]), a.parent = n, t) {
    for (o = a, l = n; l && !("immediateRender" in o); )
      o = l.vars.defaults || {}, l = be(l.vars.inherit) && l.parent;
    a.immediateRender = be(o.immediateRender), t < 2 ? a.runBackwards = 1 : a.startAt = e[r - 1];
  }
  return new Gt(e[0], a, e[r + 1]);
}, nn = function(t, e) {
  return t || t === 0 ? e(t) : e;
}, nr = function(t, e, n) {
  return n < t ? t : n > e ? e : n;
}, re = function(t, e) {
  return !qt(t) || !(e = S5.exec(t)) ? "" : e[1];
}, B5 = function(t, e, n) {
  return nn(n, function(s) {
    return nr(t, e, s);
  });
}, Ko = [].slice, bf = function(t, e) {
  return t && Ai(t) && "length" in t && (!e && !t.length || t.length - 1 in t && Ai(t[0])) && !t.nodeType && t !== ui;
}, R5 = function(t, e, n) {
  return n === void 0 && (n = []), t.forEach(function(s) {
    var r;
    return qt(s) && !e || bf(s, 1) ? (r = n).push.apply(r, We(s)) : n.push(s);
  }) || n;
}, We = function(t, e, n) {
  return Et && !e && Et.selector ? Et.selector(t) : qt(t) && !n && (Yo || !es()) ? Ko.call((e || El).querySelectorAll(t), 0) : le(t) ? R5(t, n) : bf(t) ? Ko.call(t, 0) : t ? [t] : [];
}, Xo = function(t) {
  return t = We(t)[0] || Fs("Invalid scope") || {}, function(e) {
    var n = t.current || t.nativeElement || t;
    return We(e, n.querySelectorAll ? n : n === t ? Fs("Invalid scope") || El.createElement("div") : t);
  };
}, yf = function(t) {
  return t.sort(function() {
    return 0.5 - Math.random();
  });
}, _f = function(t) {
  if (jt(t))
    return t;
  var e = Ai(t) ? t : {
    each: t
  }, n = bn(e.ease), s = e.from || 0, r = parseFloat(e.base) || 0, a = {}, o = s > 0 && s < 1, l = isNaN(s) || o, c = e.axis, u = s, d = s;
  return qt(s) ? u = d = {
    center: 0.5,
    edges: 0.5,
    end: 1
  }[s] || 0 : !o && l && (u = s[0], d = s[1]), function(h, f, p) {
    var g = (p || e).length, m = a[g], v, b, _, S, C, O, k, P, x;
    if (!m) {
      if (x = e.grid === "auto" ? 0 : (e.grid || [1, je])[1], !x) {
        for (k = -je; k < (k = p[x++].getBoundingClientRect().left) && x < g; )
          ;
        x < g && x--;
      }
      for (m = a[g] = [], v = l ? Math.min(x, g) * u - 0.5 : s % x, b = x === je ? 0 : l ? g * d / x - 0.5 : s / x | 0, k = 0, P = je, O = 0; O < g; O++)
        _ = O % x - v, S = b - (O / x | 0), m[O] = C = c ? Math.abs(c === "y" ? S : _) : ef(_ * _ + S * S), C > k && (k = C), C < P && (P = C);
      s === "random" && yf(m), m.max = k - P, m.min = P, m.v = g = (parseFloat(e.amount) || parseFloat(e.each) * (x > g ? g - 1 : c ? c === "y" ? g / x : x : Math.max(x, g / x)) || 0) * (s === "edges" ? -1 : 1), m.b = g < 0 ? r - g : r, m.u = re(e.amount || e.each) || 0, n = n && g < 0 ? Pf(n) : n;
    }
    return g = (m[h] - m.min) / m.max || 0, Jt(m.b + (n ? n(g) : g) * m.v) + m.u;
  };
}, Qo = function(t) {
  var e = Math.pow(10, ((t + "").split(".")[1] || "").length);
  return function(n) {
    var s = Jt(Math.round(parseFloat(n) / t) * t * e);
    return (s - s % 1) / e + (Ei(n) ? 0 : re(n));
  };
}, xf = function(t, e) {
  var n = le(t), s, r;
  return !n && Ai(t) && (s = n = t.radius || je, t.values ? (t = We(t.values), (r = !Ei(t[0])) && (s *= s)) : t = Qo(t.increment)), nn(e, n ? jt(t) ? function(a) {
    return r = t(a), Math.abs(r - a) <= s ? r : a;
  } : function(a) {
    for (var o = parseFloat(r ? a.x : a), l = parseFloat(r ? a.y : 0), c = je, u = 0, d = t.length, h, f; d--; )
      r ? (h = t[d].x - o, f = t[d].y - l, h = h * h + f * f) : h = Math.abs(t[d] - o), h < c && (c = h, u = d);
    return u = !s || c <= s ? t[u] : a, r || u === a || Ei(a) ? u : u + re(a);
  } : Qo(t));
}, Cf = function(t, e, n, s) {
  return nn(le(t) ? !e : n === !0 ? !!(n = 0) : !s, function() {
    return le(t) ? t[~~(Math.random() * t.length)] : (n = n || 1e-5) && (s = n < 1 ? Math.pow(10, (n + "").length - 2) : 1) && Math.floor(Math.round((t - n / 2 + Math.random() * (e - t + n * 0.99)) / n) * n * s) / s;
  });
}, F5 = function() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  return function(s) {
    return e.reduce(function(r, a) {
      return a(r);
    }, s);
  };
}, N5 = function(t, e) {
  return function(n) {
    return t(parseFloat(n)) + (e || re(n));
  };
}, H5 = function(t, e, n) {
  return wf(t, e, 0, 1, n);
}, Sf = function(t, e, n) {
  return nn(n, function(s) {
    return t[~~e(s)];
  });
}, V5 = function i(t, e, n) {
  var s = e - t;
  return le(t) ? Sf(t, i(0, t.length), e) : nn(n, function(r) {
    return (s + (r - t) % s) % s + t;
  });
}, z5 = function i(t, e, n) {
  var s = e - t, r = s * 2;
  return le(t) ? Sf(t, i(0, t.length - 1), e) : nn(n, function(a) {
    return a = (r + (a - t) % r) % r || 0, t + (a > s ? r - a : a);
  });
}, Hs = function(t) {
  for (var e = 0, n = "", s, r, a, o; ~(s = t.indexOf("random(", e)); )
    a = t.indexOf(")", s), o = t.charAt(s + 7) === "[", r = t.substr(s + 7, a - s - 7).match(o ? af : Wo), n += t.substr(e, s - e) + Cf(o ? r : +r[0], o ? 0 : +r[1], +r[2] || 1e-5), e = a + 1;
  return n + t.substr(e, t.length - e);
}, wf = function(t, e, n, s, r) {
  var a = e - t, o = s - n;
  return nn(r, function(l) {
    return n + ((l - t) / a * o || 0);
  });
}, j5 = function i(t, e, n, s) {
  var r = isNaN(t + e) ? 0 : function(f) {
    return (1 - f) * t + f * e;
  };
  if (!r) {
    var a = qt(t), o = {}, l, c, u, d, h;
    if (n === !0 && (s = 1) && (n = null), a)
      t = {
        p: t
      }, e = {
        p: e
      };
    else if (le(t) && !le(e)) {
      for (u = [], d = t.length, h = d - 2, c = 1; c < d; c++)
        u.push(i(t[c - 1], t[c]));
      d--, r = function(p) {
        p *= d;
        var g = Math.min(h, ~~p);
        return u[g](p - g);
      }, n = e;
    } else s || (t = Cn(le(t) ? [] : {}, t));
    if (!u) {
      for (l in e)
        Nl.call(o, t, l, "get", e[l]);
      r = function(p) {
        return jl(p, o) || (a ? t.p : t);
      };
    }
  }
  return nn(n, r);
}, Kc = function(t, e, n) {
  var s = t.labels, r = je, a, o, l;
  for (a in s)
    o = s[a] - e, o < 0 == !!n && o && r > (o = Math.abs(o)) && (l = a, r = o);
  return l;
}, Te = function(t, e, n) {
  var s = t.vars, r = s[e], a = Et, o = t._ctx, l, c, u;
  if (r)
    return l = s[e + "Params"], c = s.callbackScope || t, n && Gi.length && ia(), o && (Et = o), u = l ? r.apply(c, l) : r.call(c), Et = a, u;
}, Ss = function(t) {
  return Qi(t), t.scrollTrigger && t.scrollTrigger.kill(!!oe), t.progress() < 1 && Te(t, "onInterrupt"), t;
}, Wn, kf = [], Of = function(t) {
  if (t)
    if (t = !t.name && t.default || t, Il() || t.headless) {
      var e = t.name, n = jt(t), s = e && !n && t.init ? function() {
        this._props = [];
      } : t, r = {
        init: Ns,
        render: jl,
        add: Nl,
        kill: r6,
        modifier: s6,
        rawVars: 0
      }, a = {
        targetTest: 0,
        get: 0,
        getSetter: zl,
        aliases: {},
        register: 0
      };
      if (es(), t !== s) {
        if (ke[e])
          return;
        Ue(s, Ue(na(t, r), a)), Cn(s.prototype, Cn(r, na(t, a))), ke[s.prop = e] = s, t.targetTest && (Yr.push(s), Bl[e] = 1), e = (e === "css" ? "CSS" : e.charAt(0).toUpperCase() + e.substr(1)) + "Plugin";
      }
      cf(e, s), t.register && t.register(Se, s, _e);
    } else
      kf.push(t);
}, Mt = 255, ws = {
  aqua: [0, Mt, Mt],
  lime: [0, Mt, 0],
  silver: [192, 192, 192],
  black: [0, 0, 0],
  maroon: [128, 0, 0],
  teal: [0, 128, 128],
  blue: [0, 0, Mt],
  navy: [0, 0, 128],
  white: [Mt, Mt, Mt],
  olive: [128, 128, 0],
  yellow: [Mt, Mt, 0],
  orange: [Mt, 165, 0],
  gray: [128, 128, 128],
  purple: [128, 0, 128],
  green: [0, 128, 0],
  red: [Mt, 0, 0],
  pink: [Mt, 192, 203],
  cyan: [0, Mt, Mt],
  transparent: [Mt, Mt, Mt, 0]
}, ro = function(t, e, n) {
  return t += t < 0 ? 1 : t > 1 ? -1 : 0, (t * 6 < 1 ? e + (n - e) * t * 6 : t < 0.5 ? n : t * 3 < 2 ? e + (n - e) * (2 / 3 - t) * 6 : e) * Mt + 0.5 | 0;
}, Mf = function(t, e, n) {
  var s = t ? Ei(t) ? [t >> 16, t >> 8 & Mt, t & Mt] : 0 : ws.black, r, a, o, l, c, u, d, h, f, p;
  if (!s) {
    if (t.substr(-1) === "," && (t = t.substr(0, t.length - 1)), ws[t])
      s = ws[t];
    else if (t.charAt(0) === "#") {
      if (t.length < 6 && (r = t.charAt(1), a = t.charAt(2), o = t.charAt(3), t = "#" + r + r + a + a + o + o + (t.length === 5 ? t.charAt(4) + t.charAt(4) : "")), t.length === 9)
        return s = parseInt(t.substr(1, 6), 16), [s >> 16, s >> 8 & Mt, s & Mt, parseInt(t.substr(7), 16) / 255];
      t = parseInt(t.substr(1), 16), s = [t >> 16, t >> 8 & Mt, t & Mt];
    } else if (t.substr(0, 3) === "hsl") {
      if (s = p = t.match(Wo), !e)
        l = +s[0] % 360 / 360, c = +s[1] / 100, u = +s[2] / 100, a = u <= 0.5 ? u * (c + 1) : u + c - u * c, r = u * 2 - a, s.length > 3 && (s[3] *= 1), s[0] = ro(l + 1 / 3, r, a), s[1] = ro(l, r, a), s[2] = ro(l - 1 / 3, r, a);
      else if (~t.indexOf("="))
        return s = t.match(sf), n && s.length < 4 && (s[3] = 1), s;
    } else
      s = t.match(Wo) || ws.transparent;
    s = s.map(Number);
  }
  return e && !p && (r = s[0] / Mt, a = s[1] / Mt, o = s[2] / Mt, d = Math.max(r, a, o), h = Math.min(r, a, o), u = (d + h) / 2, d === h ? l = c = 0 : (f = d - h, c = u > 0.5 ? f / (2 - d - h) : f / (d + h), l = d === r ? (a - o) / f + (a < o ? 6 : 0) : d === a ? (o - r) / f + 2 : (r - a) / f + 4, l *= 60), s[0] = ~~(l + 0.5), s[1] = ~~(c * 100 + 0.5), s[2] = ~~(u * 100 + 0.5)), n && s.length < 4 && (s[3] = 1), s;
}, Tf = function(t) {
  var e = [], n = [], s = -1;
  return t.split(Ki).forEach(function(r) {
    var a = r.match(jn) || [];
    e.push.apply(e, a), n.push(s += a.length + 1);
  }), e.c = n, e;
}, Xc = function(t, e, n) {
  var s = "", r = (t + s).match(Ki), a = e ? "hsla(" : "rgba(", o = 0, l, c, u, d;
  if (!r)
    return t;
  if (r = r.map(function(h) {
    return (h = Mf(h, e, 1)) && a + (e ? h[0] + "," + h[1] + "%," + h[2] + "%," + h[3] : h.join(",")) + ")";
  }), n && (u = Tf(t), l = n.c, l.join(s) !== u.c.join(s)))
    for (c = t.replace(Ki, "1").split(jn), d = c.length - 1; o < d; o++)
      s += c[o] + (~l.indexOf(o) ? r.shift() || a + "0,0,0,0)" : (u.length ? u : r.length ? r : n).shift());
  if (!c)
    for (c = t.split(Ki), d = c.length - 1; o < d; o++)
      s += c[o] + r[o];
  return s + c[d];
}, Ki = function() {
  var i = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b", t;
  for (t in ws)
    i += "|" + t + "\\b";
  return new RegExp(i + ")", "gi");
}(), W5 = /hsl[a]?\(/, Df = function(t) {
  var e = t.join(" "), n;
  if (Ki.lastIndex = 0, Ki.test(e))
    return n = W5.test(e), t[1] = Xc(t[1], n), t[0] = Xc(t[0], n, Tf(t[1])), !0;
}, Vs, Me = function() {
  var i = Date.now, t = 500, e = 33, n = i(), s = n, r = 1e3 / 240, a = r, o = [], l, c, u, d, h, f, p = function g(m) {
    var v = i() - s, b = m === !0, _, S, C, O;
    if ((v > t || v < 0) && (n += v - e), s += v, C = s - n, _ = C - a, (_ > 0 || b) && (O = ++d.frame, h = C - d.time * 1e3, d.time = C = C / 1e3, a += _ + (_ >= r ? 4 : r - _), S = 1), b || (l = c(g)), S)
      for (f = 0; f < o.length; f++)
        o[f](C, h, O, m);
  };
  return d = {
    time: 0,
    frame: 0,
    tick: function() {
      p(!0);
    },
    deltaRatio: function(m) {
      return h / (1e3 / (m || 60));
    },
    wake: function() {
      of && (!Yo && Il() && (ui = Yo = window, El = ui.document || {}, Le.gsap = Se, (ui.gsapVersions || (ui.gsapVersions = [])).push(Se.version), lf(ea || ui.GreenSockGlobals || !ui.gsap && ui || {}), kf.forEach(Of)), u = typeof requestAnimationFrame < "u" && requestAnimationFrame, l && d.sleep(), c = u || function(m) {
        return setTimeout(m, a - d.time * 1e3 + 1 | 0);
      }, Vs = 1, p(2));
    },
    sleep: function() {
      (u ? cancelAnimationFrame : clearTimeout)(l), Vs = 0, c = Ns;
    },
    lagSmoothing: function(m, v) {
      t = m || 1 / 0, e = Math.min(v || 33, t);
    },
    fps: function(m) {
      r = 1e3 / (m || 240), a = d.time * 1e3 + r;
    },
    add: function(m, v, b) {
      var _ = v ? function(S, C, O, k) {
        m(S, C, O, k), d.remove(_);
      } : m;
      return d.remove(m), o[b ? "unshift" : "push"](_), es(), _;
    },
    remove: function(m, v) {
      ~(v = o.indexOf(m)) && o.splice(v, 1) && f >= v && f--;
    },
    _listeners: o
  }, d;
}(), es = function() {
  return !Vs && Me.wake();
}, xt = {}, Y5 = /^[\d.\-M][\d.\-,\s]/, U5 = /["']/g, Z5 = function(t) {
  for (var e = {}, n = t.substr(1, t.length - 3).split(":"), s = n[0], r = 1, a = n.length, o, l, c; r < a; r++)
    l = n[r], o = r !== a - 1 ? l.lastIndexOf(",") : l.length, c = l.substr(0, o), e[s] = isNaN(c) ? c.replace(U5, "").trim() : +c, s = l.substr(o + 1).trim();
  return e;
}, G5 = function(t) {
  var e = t.indexOf("(") + 1, n = t.indexOf(")"), s = t.indexOf("(", e);
  return t.substring(e, ~s && s < n ? t.indexOf(")", n + 1) : n);
}, K5 = function(t) {
  var e = (t + "").split("("), n = xt[e[0]];
  return n && e.length > 1 && n.config ? n.config.apply(null, ~t.indexOf("{") ? [Z5(e[1])] : G5(t).split(",").map(ff)) : xt._CE && Y5.test(t) ? xt._CE("", t) : n;
}, Pf = function(t) {
  return function(e) {
    return 1 - t(1 - e);
  };
}, Lf = function i(t, e) {
  for (var n = t._first, s; n; )
    n instanceof he ? i(n, e) : n.vars.yoyoEase && (!n._yoyo || !n._repeat) && n._yoyo !== e && (n.timeline ? i(n.timeline, e) : (s = n._ease, n._ease = n._yEase, n._yEase = s, n._yoyo = e)), n = n._next;
}, bn = function(t, e) {
  return t && (jt(t) ? t : xt[t] || K5(t)) || e;
}, Tn = function(t, e, n, s) {
  n === void 0 && (n = function(l) {
    return 1 - e(1 - l);
  }), s === void 0 && (s = function(l) {
    return l < 0.5 ? e(l * 2) / 2 : 1 - e((1 - l) * 2) / 2;
  });
  var r = {
    easeIn: e,
    easeOut: n,
    easeInOut: s
  }, a;
  return ye(t, function(o) {
    xt[o] = Le[o] = r, xt[a = o.toLowerCase()] = n;
    for (var l in r)
      xt[a + (l === "easeIn" ? ".in" : l === "easeOut" ? ".out" : ".inOut")] = xt[o + "." + l] = r[l];
  }), r;
}, If = function(t) {
  return function(e) {
    return e < 0.5 ? (1 - t(1 - e * 2)) / 2 : 0.5 + t((e - 0.5) * 2) / 2;
  };
}, ao = function i(t, e, n) {
  var s = e >= 1 ? e : 1, r = (n || (t ? 0.3 : 0.45)) / (e < 1 ? e : 1), a = r / jo * (Math.asin(1 / s) || 0), o = function(u) {
    return u === 1 ? 1 : s * Math.pow(2, -10 * u) * C5((u - a) * r) + 1;
  }, l = t === "out" ? o : t === "in" ? function(c) {
    return 1 - o(1 - c);
  } : If(o);
  return r = jo / r, l.config = function(c, u) {
    return i(t, c, u);
  }, l;
}, oo = function i(t, e) {
  e === void 0 && (e = 1.70158);
  var n = function(a) {
    return a ? --a * a * ((e + 1) * a + e) + 1 : 0;
  }, s = t === "out" ? n : t === "in" ? function(r) {
    return 1 - n(1 - r);
  } : If(n);
  return s.config = function(r) {
    return i(t, r);
  }, s;
};
ye("Linear,Quad,Cubic,Quart,Quint,Strong", function(i, t) {
  var e = t < 5 ? t + 1 : t;
  Tn(i + ",Power" + (e - 1), t ? function(n) {
    return Math.pow(n, e);
  } : function(n) {
    return n;
  }, function(n) {
    return 1 - Math.pow(1 - n, e);
  }, function(n) {
    return n < 0.5 ? Math.pow(n * 2, e) / 2 : 1 - Math.pow((1 - n) * 2, e) / 2;
  });
});
xt.Linear.easeNone = xt.none = xt.Linear.easeIn;
Tn("Elastic", ao("in"), ao("out"), ao());
(function(i, t) {
  var e = 1 / t, n = 2 * e, s = 2.5 * e, r = function(o) {
    return o < e ? i * o * o : o < n ? i * Math.pow(o - 1.5 / t, 2) + 0.75 : o < s ? i * (o -= 2.25 / t) * o + 0.9375 : i * Math.pow(o - 2.625 / t, 2) + 0.984375;
  };
  Tn("Bounce", function(a) {
    return 1 - r(1 - a);
  }, r);
})(7.5625, 2.75);
Tn("Expo", function(i) {
  return i ? Math.pow(2, 10 * (i - 1)) : 0;
});
Tn("Circ", function(i) {
  return -(ef(1 - i * i) - 1);
});
Tn("Sine", function(i) {
  return i === 1 ? 1 : -x5(i * y5) + 1;
});
Tn("Back", oo("in"), oo("out"), oo());
xt.SteppedEase = xt.steps = Le.SteppedEase = {
  config: function(t, e) {
    t === void 0 && (t = 1);
    var n = 1 / t, s = t + (e ? 0 : 1), r = e ? 1 : 0, a = 1 - Pt;
    return function(o) {
      return ((s * nr(0, a, o) | 0) + r) * n;
    };
  }
};
Jn.ease = xt["quad.out"];
ye("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(i) {
  return Rl += i + "," + i + "Params,";
});
var Ef = function(t, e) {
  this.id = _5++, t._gsap = this, this.target = t, this.harness = e, this.get = e ? e.get : df, this.set = e ? e.getSetter : zl;
}, zs = /* @__PURE__ */ function() {
  function i(e) {
    this.vars = e, this._delay = +e.delay || 0, (this._repeat = e.repeat === 1 / 0 ? -2 : e.repeat || 0) && (this._rDelay = e.repeatDelay || 0, this._yoyo = !!e.yoyo || !!e.yoyoEase), this._ts = 1, ts(this, +e.duration, 1, 1), this.data = e.data, Et && (this._ctx = Et, Et.data.push(this)), Vs || Me.wake();
  }
  var t = i.prototype;
  return t.delay = function(n) {
    return n || n === 0 ? (this.parent && this.parent.smoothChildTiming && this.startTime(this._start + n - this._delay), this._delay = n, this) : this._delay;
  }, t.duration = function(n) {
    return arguments.length ? this.totalDuration(this._repeat > 0 ? n + (n + this._rDelay) * this._repeat : n) : this.totalDuration() && this._dur;
  }, t.totalDuration = function(n) {
    return arguments.length ? (this._dirty = 0, ts(this, this._repeat < 0 ? n : (n - this._repeat * this._rDelay) / (this._repeat + 1))) : this._tDur;
  }, t.totalTime = function(n, s) {
    if (es(), !arguments.length)
      return this._tTime;
    var r = this._dp;
    if (r && r.smoothChildTiming && this._ts) {
      for (Da(this, n), !r._dp || r.parent || mf(r, this); r && r.parent; )
        r.parent._time !== r._start + (r._ts >= 0 ? r._tTime / r._ts : (r.totalDuration() - r._tTime) / -r._ts) && r.totalTime(r._tTime, !0), r = r.parent;
      !this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && n < this._tDur || this._ts < 0 && n > 0 || !this._tDur && !n) && di(this._dp, this, this._start - this._delay);
    }
    return (this._tTime !== n || !this._dur && !s || this._initted && Math.abs(this._zTime) === Pt || !n && !this._initted && (this.add || this._ptLookup)) && (this._ts || (this._pTime = n), hf(this, n, s)), this;
  }, t.time = function(n, s) {
    return arguments.length ? this.totalTime(Math.min(this.totalDuration(), n + Zc(this)) % (this._dur + this._rDelay) || (n ? this._dur : 0), s) : this._time;
  }, t.totalProgress = function(n, s) {
    return arguments.length ? this.totalTime(this.totalDuration() * n, s) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.rawTime() > 0 ? 1 : 0;
  }, t.progress = function(n, s) {
    return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - n : n) + Zc(this), s) : this.duration() ? Math.min(1, this._time / this._dur) : this.rawTime() > 0 ? 1 : 0;
  }, t.iteration = function(n, s) {
    var r = this.duration() + this._rDelay;
    return arguments.length ? this.totalTime(this._time + (n - 1) * r, s) : this._repeat ? qn(this._tTime, r) + 1 : 1;
  }, t.timeScale = function(n, s) {
    if (!arguments.length)
      return this._rts === -Pt ? 0 : this._rts;
    if (this._rts === n)
      return this;
    var r = this.parent && this._ts ? sa(this.parent._time, this) : this._tTime;
    return this._rts = +n || 0, this._ts = this._ps || n === -Pt ? 0 : this._rts, this.totalTime(nr(-Math.abs(this._delay), this._tDur, r), s !== !1), Ta(this), D5(this);
  }, t.paused = function(n) {
    return arguments.length ? (this._ps !== n && (this._ps = n, n ? (this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()), this._ts = this._act = 0) : (es(), this._ts = this._rts, this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== Pt && (this._tTime -= Pt)))), this) : this._ps;
  }, t.startTime = function(n) {
    if (arguments.length) {
      this._start = n;
      var s = this.parent || this._dp;
      return s && (s._sort || !this.parent) && di(s, this, n - this._delay), this;
    }
    return this._start;
  }, t.endTime = function(n) {
    return this._start + (be(n) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
  }, t.rawTime = function(n) {
    var s = this.parent || this._dp;
    return s ? n && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : this._ts ? sa(s.rawTime(n), this) : this._tTime : this._tTime;
  }, t.revert = function(n) {
    n === void 0 && (n = k5);
    var s = oe;
    return oe = n, (this._initted || this._startAt) && (this.timeline && this.timeline.revert(n), this.totalTime(-0.01, n.suppressEvents)), this.data !== "nested" && n.kill !== !1 && this.kill(), oe = s, this;
  }, t.globalTime = function(n) {
    for (var s = this, r = arguments.length ? n : s.rawTime(); s; )
      r = s._start + r / (Math.abs(s._ts) || 1), s = s._dp;
    return !this.parent && this._sat ? this._sat.globalTime(n) : r;
  }, t.repeat = function(n) {
    return arguments.length ? (this._repeat = n === 1 / 0 ? -2 : n, Gc(this)) : this._repeat === -2 ? 1 / 0 : this._repeat;
  }, t.repeatDelay = function(n) {
    if (arguments.length) {
      var s = this._time;
      return this._rDelay = n, Gc(this), s ? this.time(s) : this;
    }
    return this._rDelay;
  }, t.yoyo = function(n) {
    return arguments.length ? (this._yoyo = n, this) : this._yoyo;
  }, t.seek = function(n, s) {
    return this.totalTime(He(this, n), be(s));
  }, t.restart = function(n, s) {
    return this.play().totalTime(n ? -this._delay : 0, be(s));
  }, t.play = function(n, s) {
    return n != null && this.seek(n, s), this.reversed(!1).paused(!1);
  }, t.reverse = function(n, s) {
    return n != null && this.seek(n || this.totalDuration(), s), this.reversed(!0).paused(!1);
  }, t.pause = function(n, s) {
    return n != null && this.seek(n, s), this.paused(!0);
  }, t.resume = function() {
    return this.paused(!1);
  }, t.reversed = function(n) {
    return arguments.length ? (!!n !== this.reversed() && this.timeScale(-this._rts || (n ? -Pt : 0)), this) : this._rts < 0;
  }, t.invalidate = function() {
    return this._initted = this._act = 0, this._zTime = -Pt, this;
  }, t.isActive = function() {
    var n = this.parent || this._dp, s = this._start, r;
    return !!(!n || this._ts && this._initted && n.isActive() && (r = n.rawTime(!0)) >= s && r < this.endTime(!0) - Pt);
  }, t.eventCallback = function(n, s, r) {
    var a = this.vars;
    return arguments.length > 1 ? (s ? (a[n] = s, r && (a[n + "Params"] = r), n === "onUpdate" && (this._onUpdate = s)) : delete a[n], this) : a[n];
  }, t.then = function(n) {
    var s = this;
    return new Promise(function(r) {
      var a = jt(n) ? n : pf, o = function() {
        var c = s.then;
        s.then = null, jt(a) && (a = a(s)) && (a.then || a === s) && (s.then = c), r(a), s.then = c;
      };
      s._initted && s.totalProgress() === 1 && s._ts >= 0 || !s._tTime && s._ts < 0 ? o() : s._prom = o;
    });
  }, t.kill = function() {
    Ss(this);
  }, i;
}();
Ue(zs.prototype, {
  _time: 0,
  _start: 0,
  _end: 0,
  _tTime: 0,
  _tDur: 0,
  _dirty: 0,
  _repeat: 0,
  _yoyo: !1,
  parent: null,
  _initted: !1,
  _rDelay: 0,
  _ts: 1,
  _dp: 0,
  ratio: 0,
  _zTime: -Pt,
  _prom: 0,
  _ps: !1,
  _rts: 1
});
var he = /* @__PURE__ */ function(i) {
  tf(t, i);
  function t(n, s) {
    var r;
    return n === void 0 && (n = {}), r = i.call(this, n) || this, r.labels = {}, r.smoothChildTiming = !!n.smoothChildTiming, r.autoRemoveChildren = !!n.autoRemoveChildren, r._sort = be(n.sortChildren), Nt && di(n.parent || Nt, Mi(r), s), n.reversed && r.reverse(), n.paused && r.paused(!0), n.scrollTrigger && vf(Mi(r), n.scrollTrigger), r;
  }
  var e = t.prototype;
  return e.to = function(s, r, a) {
    return Ts(0, arguments, this), this;
  }, e.from = function(s, r, a) {
    return Ts(1, arguments, this), this;
  }, e.fromTo = function(s, r, a, o) {
    return Ts(2, arguments, this), this;
  }, e.set = function(s, r, a) {
    return r.duration = 0, r.parent = this, Ms(r).repeatDelay || (r.repeat = 0), r.immediateRender = !!r.immediateRender, new Gt(s, r, He(this, a), 1), this;
  }, e.call = function(s, r, a) {
    return di(this, Gt.delayedCall(0, s, r), a);
  }, e.staggerTo = function(s, r, a, o, l, c, u) {
    return a.duration = r, a.stagger = a.stagger || o, a.onComplete = c, a.onCompleteParams = u, a.parent = this, new Gt(s, a, He(this, l)), this;
  }, e.staggerFrom = function(s, r, a, o, l, c, u) {
    return a.runBackwards = 1, Ms(a).immediateRender = be(a.immediateRender), this.staggerTo(s, r, a, o, l, c, u);
  }, e.staggerFromTo = function(s, r, a, o, l, c, u, d) {
    return o.startAt = a, Ms(o).immediateRender = be(o.immediateRender), this.staggerTo(s, r, o, l, c, u, d);
  }, e.render = function(s, r, a) {
    var o = this._time, l = this._dirty ? this.totalDuration() : this._tDur, c = this._dur, u = s <= 0 ? 0 : Jt(s), d = this._zTime < 0 != s < 0 && (this._initted || !c), h, f, p, g, m, v, b, _, S, C, O, k;
    if (this !== Nt && u > l && s >= 0 && (u = l), u !== this._tTime || a || d) {
      if (o !== this._time && c && (u += this._time - o, s += this._time - o), h = u, S = this._start, _ = this._ts, v = !_, d && (c || (o = this._zTime), (s || !r) && (this._zTime = s)), this._repeat) {
        if (O = this._yoyo, m = c + this._rDelay, this._repeat < -1 && s < 0)
          return this.totalTime(m * 100 + s, r, a);
        if (h = Jt(u % m), u === l ? (g = this._repeat, h = c) : (g = ~~(u / m), g && g === u / m && (h = c, g--), h > c && (h = c)), C = qn(this._tTime, m), !o && this._tTime && C !== g && this._tTime - C * m - this._dur <= 0 && (C = g), O && g & 1 && (h = c - h, k = 1), g !== C && !this._lock) {
          var P = O && C & 1, x = P === (O && g & 1);
          if (g < C && (P = !P), o = P ? 0 : u % c ? c : u, this._lock = 1, this.render(o || (k ? 0 : Jt(g * m)), r, !c)._lock = 0, this._tTime = u, !r && this.parent && Te(this, "onRepeat"), this.vars.repeatRefresh && !k && (this.invalidate()._lock = 1), o && o !== this._time || v !== !this._ts || this.vars.onRepeat && !this.parent && !this._act)
            return this;
          if (c = this._dur, l = this._tDur, x && (this._lock = 2, o = P ? c : -1e-4, this.render(o, !0), this.vars.repeatRefresh && !k && this.invalidate()), this._lock = 0, !this._ts && !v)
            return this;
          Lf(this, k);
        }
      }
      if (this._hasPause && !this._forcing && this._lock < 2 && (b = E5(this, Jt(o), Jt(h)), b && (u -= h - (h = b._start))), this._tTime = u, this._time = h, this._act = !_, this._initted || (this._onUpdate = this.vars.onUpdate, this._initted = 1, this._zTime = s, o = 0), !o && h && !r && !g && (Te(this, "onStart"), this._tTime !== u))
        return this;
      if (h >= o && s >= 0)
        for (f = this._first; f; ) {
          if (p = f._next, (f._act || h >= f._start) && f._ts && b !== f) {
            if (f.parent !== this)
              return this.render(s, r, a);
            if (f.render(f._ts > 0 ? (h - f._start) * f._ts : (f._dirty ? f.totalDuration() : f._tDur) + (h - f._start) * f._ts, r, a), h !== this._time || !this._ts && !v) {
              b = 0, p && (u += this._zTime = -Pt);
              break;
            }
          }
          f = p;
        }
      else {
        f = this._last;
        for (var R = s < 0 ? s : h; f; ) {
          if (p = f._prev, (f._act || R <= f._end) && f._ts && b !== f) {
            if (f.parent !== this)
              return this.render(s, r, a);
            if (f.render(f._ts > 0 ? (R - f._start) * f._ts : (f._dirty ? f.totalDuration() : f._tDur) + (R - f._start) * f._ts, r, a || oe && (f._initted || f._startAt)), h !== this._time || !this._ts && !v) {
              b = 0, p && (u += this._zTime = R ? -Pt : Pt);
              break;
            }
          }
          f = p;
        }
      }
      if (b && !r && (this.pause(), b.render(h >= o ? 0 : -Pt)._zTime = h >= o ? 1 : -1, this._ts))
        return this._start = S, Ta(this), this.render(s, r, a);
      this._onUpdate && !r && Te(this, "onUpdate", !0), (u === l && this._tTime >= this.totalDuration() || !u && o) && (S === this._start || Math.abs(_) !== Math.abs(this._ts)) && (this._lock || ((s || !c) && (u === l && this._ts > 0 || !u && this._ts < 0) && Qi(this, 1), !r && !(s < 0 && !o) && (u || o || !l) && (Te(this, u === l && s >= 0 ? "onComplete" : "onReverseComplete", !0), this._prom && !(u < l && this.timeScale() > 0) && this._prom())));
    }
    return this;
  }, e.add = function(s, r) {
    var a = this;
    if (Ei(r) || (r = He(this, r, s)), !(s instanceof zs)) {
      if (le(s))
        return s.forEach(function(o) {
          return a.add(o, r);
        }), this;
      if (qt(s))
        return this.addLabel(s, r);
      if (jt(s))
        s = Gt.delayedCall(0, s);
      else
        return this;
    }
    return this !== s ? di(this, s, r) : this;
  }, e.getChildren = function(s, r, a, o) {
    s === void 0 && (s = !0), r === void 0 && (r = !0), a === void 0 && (a = !0), o === void 0 && (o = -je);
    for (var l = [], c = this._first; c; )
      c._start >= o && (c instanceof Gt ? r && l.push(c) : (a && l.push(c), s && l.push.apply(l, c.getChildren(!0, r, a)))), c = c._next;
    return l;
  }, e.getById = function(s) {
    for (var r = this.getChildren(1, 1, 1), a = r.length; a--; )
      if (r[a].vars.id === s)
        return r[a];
  }, e.remove = function(s) {
    return qt(s) ? this.removeLabel(s) : jt(s) ? this.killTweensOf(s) : (Ma(this, s), s === this._recent && (this._recent = this._last), An(this));
  }, e.totalTime = function(s, r) {
    return arguments.length ? (this._forcing = 1, !this._dp && this._ts && (this._start = Jt(Me.time - (this._ts > 0 ? s / this._ts : (this.totalDuration() - s) / -this._ts))), i.prototype.totalTime.call(this, s, r), this._forcing = 0, this) : this._tTime;
  }, e.addLabel = function(s, r) {
    return this.labels[s] = He(this, r), this;
  }, e.removeLabel = function(s) {
    return delete this.labels[s], this;
  }, e.addPause = function(s, r, a) {
    var o = Gt.delayedCall(0, r || Ns, a);
    return o.data = "isPause", this._hasPause = 1, di(this, o, He(this, s));
  }, e.removePause = function(s) {
    var r = this._first;
    for (s = He(this, s); r; )
      r._start === s && r.data === "isPause" && Qi(r), r = r._next;
  }, e.killTweensOf = function(s, r, a) {
    for (var o = this.getTweensOf(s, a), l = o.length; l--; )
      zi !== o[l] && o[l].kill(s, r);
    return this;
  }, e.getTweensOf = function(s, r) {
    for (var a = [], o = We(s), l = this._first, c = Ei(r), u; l; )
      l instanceof Gt ? O5(l._targets, o) && (c ? (!zi || l._initted && l._ts) && l.globalTime(0) <= r && l.globalTime(l.totalDuration()) > r : !r || l.isActive()) && a.push(l) : (u = l.getTweensOf(o, r)).length && a.push.apply(a, u), l = l._next;
    return a;
  }, e.tweenTo = function(s, r) {
    r = r || {};
    var a = this, o = He(a, s), l = r, c = l.startAt, u = l.onStart, d = l.onStartParams, h = l.immediateRender, f, p = Gt.to(a, Ue({
      ease: r.ease || "none",
      lazy: !1,
      immediateRender: !1,
      time: o,
      overwrite: "auto",
      duration: r.duration || Math.abs((o - (c && "time" in c ? c.time : a._time)) / a.timeScale()) || Pt,
      onStart: function() {
        if (a.pause(), !f) {
          var m = r.duration || Math.abs((o - (c && "time" in c ? c.time : a._time)) / a.timeScale());
          p._dur !== m && ts(p, m, 0, 1).render(p._time, !0, !0), f = 1;
        }
        u && u.apply(p, d || []);
      }
    }, r));
    return h ? p.render(0) : p;
  }, e.tweenFromTo = function(s, r, a) {
    return this.tweenTo(r, Ue({
      startAt: {
        time: He(this, s)
      }
    }, a));
  }, e.recent = function() {
    return this._recent;
  }, e.nextLabel = function(s) {
    return s === void 0 && (s = this._time), Kc(this, He(this, s));
  }, e.previousLabel = function(s) {
    return s === void 0 && (s = this._time), Kc(this, He(this, s), 1);
  }, e.currentLabel = function(s) {
    return arguments.length ? this.seek(s, !0) : this.previousLabel(this._time + Pt);
  }, e.shiftChildren = function(s, r, a) {
    a === void 0 && (a = 0);
    for (var o = this._first, l = this.labels, c; o; )
      o._start >= a && (o._start += s, o._end += s), o = o._next;
    if (r)
      for (c in l)
        l[c] >= a && (l[c] += s);
    return An(this);
  }, e.invalidate = function(s) {
    var r = this._first;
    for (this._lock = 0; r; )
      r.invalidate(s), r = r._next;
    return i.prototype.invalidate.call(this, s);
  }, e.clear = function(s) {
    s === void 0 && (s = !0);
    for (var r = this._first, a; r; )
      a = r._next, this.remove(r), r = a;
    return this._dp && (this._time = this._tTime = this._pTime = 0), s && (this.labels = {}), An(this);
  }, e.totalDuration = function(s) {
    var r = 0, a = this, o = a._last, l = je, c, u, d;
    if (arguments.length)
      return a.timeScale((a._repeat < 0 ? a.duration() : a.totalDuration()) / (a.reversed() ? -s : s));
    if (a._dirty) {
      for (d = a.parent; o; )
        c = o._prev, o._dirty && o.totalDuration(), u = o._start, u > l && a._sort && o._ts && !a._lock ? (a._lock = 1, di(a, o, u - o._delay, 1)._lock = 0) : l = u, u < 0 && o._ts && (r -= u, (!d && !a._dp || d && d.smoothChildTiming) && (a._start += u / a._ts, a._time -= u, a._tTime -= u), a.shiftChildren(-u, !1, -1 / 0), l = 0), o._end > r && o._ts && (r = o._end), o = c;
      ts(a, a === Nt && a._time > r ? a._time : r, 1, 1), a._dirty = 0;
    }
    return a._tDur;
  }, t.updateRoot = function(s) {
    if (Nt._ts && (hf(Nt, sa(s, Nt)), uf = Me.frame), Me.frame >= Yc) {
      Yc += De.autoSleep || 120;
      var r = Nt._first;
      if ((!r || !r._ts) && De.autoSleep && Me._listeners.length < 2) {
        for (; r && !r._ts; )
          r = r._next;
        r || Me.sleep();
      }
    }
  }, t;
}(zs);
Ue(he.prototype, {
  _lock: 0,
  _hasPause: 0,
  _forcing: 0
});
var X5 = function(t, e, n, s, r, a, o) {
  var l = new _e(this._pt, t, e, 0, 1, Hf, null, r), c = 0, u = 0, d, h, f, p, g, m, v, b;
  for (l.b = n, l.e = s, n += "", s += "", (v = ~s.indexOf("random(")) && (s = Hs(s)), a && (b = [n, s], a(b, t, e), n = b[0], s = b[1]), h = n.match(no) || []; d = no.exec(s); )
    p = d[0], g = s.substring(c, d.index), f ? f = (f + 1) % 5 : g.substr(-5) === "rgba(" && (f = 1), p !== h[u++] && (m = parseFloat(h[u - 1]) || 0, l._pt = {
      _next: l._pt,
      p: g || u === 1 ? g : ",",
      //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
      s: m,
      c: p.charAt(1) === "=" ? Gn(m, p) - m : parseFloat(p) - m,
      m: f && f < 4 ? Math.round : 0
    }, c = no.lastIndex);
  return l.c = c < s.length ? s.substring(c, s.length) : "", l.fp = o, (rf.test(s) || v) && (l.e = 0), this._pt = l, l;
}, Nl = function(t, e, n, s, r, a, o, l, c, u) {
  jt(s) && (s = s(r || 0, t, a));
  var d = t[e], h = n !== "get" ? n : jt(d) ? c ? t[e.indexOf("set") || !jt(t["get" + e.substr(3)]) ? e : "get" + e.substr(3)](c) : t[e]() : d, f = jt(d) ? c ? e6 : Ff : Vl, p;
  if (qt(s) && (~s.indexOf("random(") && (s = Hs(s)), s.charAt(1) === "=" && (p = Gn(h, s) + (re(h) || 0), (p || p === 0) && (s = p))), !u || h !== s || Jo)
    return !isNaN(h * s) && s !== "" ? (p = new _e(this._pt, t, e, +h || 0, s - (h || 0), typeof d == "boolean" ? n6 : Nf, 0, f), c && (p.fp = c), o && p.modifier(o, this, t), this._pt = p) : (!d && !(e in t) && $l(e, s), X5.call(this, t, e, h, s, f, l || De.stringFilter, c));
}, Q5 = function(t, e, n, s, r) {
  if (jt(t) && (t = Ds(t, r, e, n, s)), !Ai(t) || t.style && t.nodeType || le(t) || nf(t))
    return qt(t) ? Ds(t, r, e, n, s) : t;
  var a = {}, o;
  for (o in t)
    a[o] = Ds(t[o], r, e, n, s);
  return a;
}, $f = function(t, e, n, s, r, a) {
  var o, l, c, u;
  if (ke[t] && (o = new ke[t]()).init(r, o.rawVars ? e[t] : Q5(e[t], s, r, a, n), n, s, a) !== !1 && (n._pt = l = new _e(n._pt, r, t, 0, 1, o.render, o, 0, o.priority), n !== Wn))
    for (c = n._ptLookup[n._targets.indexOf(r)], u = o._props.length; u--; )
      c[o._props[u]] = l;
  return o;
}, zi, Jo, Hl = function i(t, e, n) {
  var s = t.vars, r = s.ease, a = s.startAt, o = s.immediateRender, l = s.lazy, c = s.onUpdate, u = s.runBackwards, d = s.yoyoEase, h = s.keyframes, f = s.autoRevert, p = t._dur, g = t._startAt, m = t._targets, v = t.parent, b = v && v.data === "nested" ? v.vars.targets : m, _ = t._overwrite === "auto" && !Pl, S = t.timeline, C, O, k, P, x, R, B, L, Y, j, w, I, T;
  if (S && (!h || !r) && (r = "none"), t._ease = bn(r, Jn.ease), t._yEase = d ? Pf(bn(d === !0 ? r : d, Jn.ease)) : 0, d && t._yoyo && !t._repeat && (d = t._yEase, t._yEase = t._ease, t._ease = d), t._from = !S && !!s.runBackwards, !S || h && !s.stagger) {
    if (L = m[0] ? vn(m[0]).harness : 0, I = L && s[L.prop], C = na(s, Bl), g && (g._zTime < 0 && g.progress(1), e < 0 && u && o && !f ? g.render(-1, !0) : g.revert(u && p ? Wr : w5), g._lazy = 0), a) {
      if (Qi(t._startAt = Gt.set(m, Ue({
        data: "isStart",
        overwrite: !1,
        parent: v,
        immediateRender: !0,
        lazy: !g && be(l),
        startAt: null,
        delay: 0,
        onUpdate: c && function() {
          return Te(t, "onUpdate");
        },
        stagger: 0
      }, a))), t._startAt._dp = 0, t._startAt._sat = t, e < 0 && (oe || !o && !f) && t._startAt.revert(Wr), o && p && e <= 0 && n <= 0) {
        e && (t._zTime = e);
        return;
      }
    } else if (u && p && !g) {
      if (e && (o = !1), k = Ue({
        overwrite: !1,
        data: "isFromStart",
        //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
        lazy: o && !g && be(l),
        immediateRender: o,
        //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
        stagger: 0,
        parent: v
        //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y: gsap.utils.wrap([-100,100]), stagger: 0.5})
      }, C), I && (k[L.prop] = I), Qi(t._startAt = Gt.set(m, k)), t._startAt._dp = 0, t._startAt._sat = t, e < 0 && (oe ? t._startAt.revert(Wr) : t._startAt.render(-1, !0)), t._zTime = e, !o)
        i(t._startAt, Pt, Pt);
      else if (!e)
        return;
    }
    for (t._pt = t._ptCache = 0, l = p && be(l) || l && !p, O = 0; O < m.length; O++) {
      if (x = m[O], B = x._gsap || Fl(m)[O]._gsap, t._ptLookup[O] = j = {}, Uo[B.id] && Gi.length && ia(), w = b === m ? O : b.indexOf(x), L && (Y = new L()).init(x, I || C, t, w, b) !== !1 && (t._pt = P = new _e(t._pt, x, Y.name, 0, 1, Y.render, Y, 0, Y.priority), Y._props.forEach(function(V) {
        j[V] = P;
      }), Y.priority && (R = 1)), !L || I)
        for (k in C)
          ke[k] && (Y = $f(k, C, t, w, x, b)) ? Y.priority && (R = 1) : j[k] = P = Nl.call(t, x, k, "get", C[k], w, b, 0, s.stringFilter);
      t._op && t._op[O] && t.kill(x, t._op[O]), _ && t._pt && (zi = t, Nt.killTweensOf(x, j, t.globalTime(e)), T = !t.parent, zi = 0), t._pt && l && (Uo[B.id] = 1);
    }
    R && Vf(t), t._onInit && t._onInit(t);
  }
  t._onUpdate = c, t._initted = (!t._op || t._pt) && !T, h && e <= 0 && S.render(je, !0, !0);
}, J5 = function(t, e, n, s, r, a, o, l) {
  var c = (t._pt && t._ptCache || (t._ptCache = {}))[e], u, d, h, f;
  if (!c)
    for (c = t._ptCache[e] = [], h = t._ptLookup, f = t._targets.length; f--; ) {
      if (u = h[f][e], u && u.d && u.d._pt)
        for (u = u.d._pt; u && u.p !== e && u.fp !== e; )
          u = u._next;
      if (!u)
        return Jo = 1, t.vars[e] = "+=0", Hl(t, o), Jo = 0, l ? Fs(e + " not eligible for reset") : 1;
      c.push(u);
    }
  for (f = c.length; f--; )
    d = c[f], u = d._pt || d, u.s = (s || s === 0) && !r ? s : u.s + (s || 0) + a * u.c, u.c = n - u.s, d.e && (d.e = Ut(n) + re(d.e)), d.b && (d.b = u.s + re(d.b));
}, q5 = function(t, e) {
  var n = t[0] ? vn(t[0]).harness : 0, s = n && n.aliases, r, a, o, l;
  if (!s)
    return e;
  r = Cn({}, e);
  for (a in s)
    if (a in r)
      for (l = s[a].split(","), o = l.length; o--; )
        r[l[o]] = r[a];
  return r;
}, t6 = function(t, e, n, s) {
  var r = e.ease || s || "power1.inOut", a, o;
  if (le(e))
    o = n[t] || (n[t] = []), e.forEach(function(l, c) {
      return o.push({
        t: c / (e.length - 1) * 100,
        v: l,
        e: r
      });
    });
  else
    for (a in e)
      o = n[a] || (n[a] = []), a === "ease" || o.push({
        t: parseFloat(t),
        v: e[a],
        e: r
      });
}, Ds = function(t, e, n, s, r) {
  return jt(t) ? t.call(e, n, s, r) : qt(t) && ~t.indexOf("random(") ? Hs(t) : t;
}, Bf = Rl + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert", Rf = {};
ye(Bf + ",id,stagger,delay,duration,paused,scrollTrigger", function(i) {
  return Rf[i] = 1;
});
var Gt = /* @__PURE__ */ function(i) {
  tf(t, i);
  function t(n, s, r, a) {
    var o;
    typeof s == "number" && (r.duration = s, s = r, r = null), o = i.call(this, a ? s : Ms(s)) || this;
    var l = o.vars, c = l.duration, u = l.delay, d = l.immediateRender, h = l.stagger, f = l.overwrite, p = l.keyframes, g = l.defaults, m = l.scrollTrigger, v = l.yoyoEase, b = s.parent || Nt, _ = (le(n) || nf(n) ? Ei(n[0]) : "length" in s) ? [n] : We(n), S, C, O, k, P, x, R, B;
    if (o._targets = _.length ? Fl(_) : Fs("GSAP target " + n + " not found. https://gsap.com", !De.nullTargetWarn) || [], o._ptLookup = [], o._overwrite = f, p || h || Cr(c) || Cr(u)) {
      if (s = o.vars, S = o.timeline = new he({
        data: "nested",
        defaults: g || {},
        targets: b && b.data === "nested" ? b.vars.targets : _
      }), S.kill(), S.parent = S._dp = Mi(o), S._start = 0, h || Cr(c) || Cr(u)) {
        if (k = _.length, R = h && _f(h), Ai(h))
          for (P in h)
            ~Bf.indexOf(P) && (B || (B = {}), B[P] = h[P]);
        for (C = 0; C < k; C++)
          O = na(s, Rf), O.stagger = 0, v && (O.yoyoEase = v), B && Cn(O, B), x = _[C], O.duration = +Ds(c, Mi(o), C, x, _), O.delay = (+Ds(u, Mi(o), C, x, _) || 0) - o._delay, !h && k === 1 && O.delay && (o._delay = u = O.delay, o._start += u, O.delay = 0), S.to(x, O, R ? R(C, x, _) : 0), S._ease = xt.none;
        S.duration() ? c = u = 0 : o.timeline = 0;
      } else if (p) {
        Ms(Ue(S.vars.defaults, {
          ease: "none"
        })), S._ease = bn(p.ease || s.ease || "none");
        var L = 0, Y, j, w;
        if (le(p))
          p.forEach(function(I) {
            return S.to(_, I, ">");
          }), S.duration();
        else {
          O = {};
          for (P in p)
            P === "ease" || P === "easeEach" || t6(P, p[P], O, p.easeEach);
          for (P in O)
            for (Y = O[P].sort(function(I, T) {
              return I.t - T.t;
            }), L = 0, C = 0; C < Y.length; C++)
              j = Y[C], w = {
                ease: j.e,
                duration: (j.t - (C ? Y[C - 1].t : 0)) / 100 * c
              }, w[P] = j.v, S.to(_, w, L), L += w.duration;
          S.duration() < c && S.to({}, {
            duration: c - S.duration()
          });
        }
      }
      c || o.duration(c = S.duration());
    } else
      o.timeline = 0;
    return f === !0 && !Pl && (zi = Mi(o), Nt.killTweensOf(_), zi = 0), di(b, Mi(o), r), s.reversed && o.reverse(), s.paused && o.paused(!0), (d || !c && !p && o._start === Jt(b._time) && be(d) && P5(Mi(o)) && b.data !== "nested") && (o._tTime = -Pt, o.render(Math.max(0, -u) || 0)), m && vf(Mi(o), m), o;
  }
  var e = t.prototype;
  return e.render = function(s, r, a) {
    var o = this._time, l = this._tDur, c = this._dur, u = s < 0, d = s > l - Pt && !u ? l : s < Pt ? 0 : s, h, f, p, g, m, v, b, _, S;
    if (!c)
      I5(this, s, r, a);
    else if (d !== this._tTime || !s || a || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== u) {
      if (h = d, _ = this.timeline, this._repeat) {
        if (g = c + this._rDelay, this._repeat < -1 && u)
          return this.totalTime(g * 100 + s, r, a);
        if (h = Jt(d % g), d === l ? (p = this._repeat, h = c) : (p = ~~(d / g), p && p === Jt(d / g) && (h = c, p--), h > c && (h = c)), v = this._yoyo && p & 1, v && (S = this._yEase, h = c - h), m = qn(this._tTime, g), h === o && !a && this._initted && p === m)
          return this._tTime = d, this;
        p !== m && (_ && this._yEase && Lf(_, v), this.vars.repeatRefresh && !v && !this._lock && this._time !== g && this._initted && (this._lock = a = 1, this.render(Jt(g * p), !0).invalidate()._lock = 0));
      }
      if (!this._initted) {
        if (Af(this, u ? s : h, a, r, d))
          return this._tTime = 0, this;
        if (o !== this._time && !(a && this.vars.repeatRefresh && p !== m))
          return this;
        if (c !== this._dur)
          return this.render(s, r, a);
      }
      if (this._tTime = d, this._time = h, !this._act && this._ts && (this._act = 1, this._lazy = 0), this.ratio = b = (S || this._ease)(h / c), this._from && (this.ratio = b = 1 - b), h && !o && !r && !p && (Te(this, "onStart"), this._tTime !== d))
        return this;
      for (f = this._pt; f; )
        f.r(b, f.d), f = f._next;
      _ && _.render(s < 0 ? s : _._dur * _._ease(h / this._dur), r, a) || this._startAt && (this._zTime = s), this._onUpdate && !r && (u && Zo(this, s, r, a), Te(this, "onUpdate")), this._repeat && p !== m && this.vars.onRepeat && !r && this.parent && Te(this, "onRepeat"), (d === this._tDur || !d) && this._tTime === d && (u && !this._onUpdate && Zo(this, s, !0, !0), (s || !c) && (d === this._tDur && this._ts > 0 || !d && this._ts < 0) && Qi(this, 1), !r && !(u && !o) && (d || o || v) && (Te(this, d === l ? "onComplete" : "onReverseComplete", !0), this._prom && !(d < l && this.timeScale() > 0) && this._prom()));
    }
    return this;
  }, e.targets = function() {
    return this._targets;
  }, e.invalidate = function(s) {
    return (!s || !this.vars.runBackwards) && (this._startAt = 0), this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0, this._ptLookup = [], this.timeline && this.timeline.invalidate(s), i.prototype.invalidate.call(this, s);
  }, e.resetTo = function(s, r, a, o, l) {
    Vs || Me.wake(), this._ts || this.play();
    var c = Math.min(this._dur, (this._dp._time - this._start) * this._ts), u;
    return this._initted || Hl(this, c), u = this._ease(c / this._dur), J5(this, s, r, a, o, u, c, l) ? this.resetTo(s, r, a, o, 1) : (Da(this, 0), this.parent || gf(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0), this.render(0));
  }, e.kill = function(s, r) {
    if (r === void 0 && (r = "all"), !s && (!r || r === "all"))
      return this._lazy = this._pt = 0, this.parent ? Ss(this) : this;
    if (this.timeline) {
      var a = this.timeline.totalDuration();
      return this.timeline.killTweensOf(s, r, zi && zi.vars.overwrite !== !0)._first || Ss(this), this.parent && a !== this.timeline.totalDuration() && ts(this, this._dur * this.timeline._tDur / a, 0, 1), this;
    }
    var o = this._targets, l = s ? We(s) : o, c = this._ptLookup, u = this._pt, d, h, f, p, g, m, v;
    if ((!r || r === "all") && T5(o, l))
      return r === "all" && (this._pt = 0), Ss(this);
    for (d = this._op = this._op || [], r !== "all" && (qt(r) && (g = {}, ye(r, function(b) {
      return g[b] = 1;
    }), r = g), r = q5(o, r)), v = o.length; v--; )
      if (~l.indexOf(o[v])) {
        h = c[v], r === "all" ? (d[v] = r, p = h, f = {}) : (f = d[v] = d[v] || {}, p = r);
        for (g in p)
          m = h && h[g], m && ((!("kill" in m.d) || m.d.kill(g) === !0) && Ma(this, m, "_pt"), delete h[g]), f !== "all" && (f[g] = 1);
      }
    return this._initted && !this._pt && u && Ss(this), this;
  }, t.to = function(s, r) {
    return new t(s, r, arguments[2]);
  }, t.from = function(s, r) {
    return Ts(1, arguments);
  }, t.delayedCall = function(s, r, a, o) {
    return new t(r, 0, {
      immediateRender: !1,
      lazy: !1,
      overwrite: !1,
      delay: s,
      onComplete: r,
      onReverseComplete: r,
      onCompleteParams: a,
      onReverseCompleteParams: a,
      callbackScope: o
    });
  }, t.fromTo = function(s, r, a) {
    return Ts(2, arguments);
  }, t.set = function(s, r) {
    return r.duration = 0, r.repeatDelay || (r.repeat = 0), new t(s, r);
  }, t.killTweensOf = function(s, r, a) {
    return Nt.killTweensOf(s, r, a);
  }, t;
}(zs);
Ue(Gt.prototype, {
  _targets: [],
  _lazy: 0,
  _startAt: 0,
  _op: 0,
  _onInit: 0
});
ye("staggerTo,staggerFrom,staggerFromTo", function(i) {
  Gt[i] = function() {
    var t = new he(), e = Ko.call(arguments, 0);
    return e.splice(i === "staggerFromTo" ? 5 : 4, 0, 0), t[i].apply(t, e);
  };
});
var Vl = function(t, e, n) {
  return t[e] = n;
}, Ff = function(t, e, n) {
  return t[e](n);
}, e6 = function(t, e, n, s) {
  return t[e](s.fp, n);
}, i6 = function(t, e, n) {
  return t.setAttribute(e, n);
}, zl = function(t, e) {
  return jt(t[e]) ? Ff : Ll(t[e]) && t.setAttribute ? i6 : Vl;
}, Nf = function(t, e) {
  return e.set(e.t, e.p, Math.round((e.s + e.c * t) * 1e6) / 1e6, e);
}, n6 = function(t, e) {
  return e.set(e.t, e.p, !!(e.s + e.c * t), e);
}, Hf = function(t, e) {
  var n = e._pt, s = "";
  if (!t && e.b)
    s = e.b;
  else if (t === 1 && e.e)
    s = e.e;
  else {
    for (; n; )
      s = n.p + (n.m ? n.m(n.s + n.c * t) : Math.round((n.s + n.c * t) * 1e4) / 1e4) + s, n = n._next;
    s += e.c;
  }
  e.set(e.t, e.p, s, e);
}, jl = function(t, e) {
  for (var n = e._pt; n; )
    n.r(t, n.d), n = n._next;
}, s6 = function(t, e, n, s) {
  for (var r = this._pt, a; r; )
    a = r._next, r.p === s && r.modifier(t, e, n), r = a;
}, r6 = function(t) {
  for (var e = this._pt, n, s; e; )
    s = e._next, e.p === t && !e.op || e.op === t ? Ma(this, e, "_pt") : e.dep || (n = 1), e = s;
  return !n;
}, a6 = function(t, e, n, s) {
  s.mSet(t, e, s.m.call(s.tween, n, s.mt), s);
}, Vf = function(t) {
  for (var e = t._pt, n, s, r, a; e; ) {
    for (n = e._next, s = r; s && s.pr > e.pr; )
      s = s._next;
    (e._prev = s ? s._prev : a) ? e._prev._next = e : r = e, (e._next = s) ? s._prev = e : a = e, e = n;
  }
  t._pt = r;
}, _e = /* @__PURE__ */ function() {
  function i(e, n, s, r, a, o, l, c, u) {
    this.t = n, this.s = r, this.c = a, this.p = s, this.r = o || Nf, this.d = l || this, this.set = c || Vl, this.pr = u || 0, this._next = e, e && (e._prev = this);
  }
  var t = i.prototype;
  return t.modifier = function(n, s, r) {
    this.mSet = this.mSet || this.set, this.set = a6, this.m = n, this.mt = r, this.tween = s;
  }, i;
}();
ye(Rl + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function(i) {
  return Bl[i] = 1;
});
Le.TweenMax = Le.TweenLite = Gt;
Le.TimelineLite = Le.TimelineMax = he;
Nt = new he({
  sortChildren: !1,
  defaults: Jn,
  autoRemoveChildren: !0,
  id: "root",
  smoothChildTiming: !0
});
De.stringFilter = Df;
var yn = [], Ur = {}, o6 = [], Qc = 0, l6 = 0, lo = function(t) {
  return (Ur[t] || o6).map(function(e) {
    return e();
  });
}, qo = function() {
  var t = Date.now(), e = [];
  t - Qc > 2 && (lo("matchMediaInit"), yn.forEach(function(n) {
    var s = n.queries, r = n.conditions, a, o, l, c;
    for (o in s)
      a = ui.matchMedia(s[o]).matches, a && (l = 1), a !== r[o] && (r[o] = a, c = 1);
    c && (n.revert(), l && e.push(n));
  }), lo("matchMediaRevert"), e.forEach(function(n) {
    return n.onMatch(n, function(s) {
      return n.add(null, s);
    });
  }), Qc = t, lo("matchMedia"));
}, zf = /* @__PURE__ */ function() {
  function i(e, n) {
    this.selector = n && Xo(n), this.data = [], this._r = [], this.isReverted = !1, this.id = l6++, e && this.add(e);
  }
  var t = i.prototype;
  return t.add = function(n, s, r) {
    jt(n) && (r = s, s = n, n = jt);
    var a = this, o = function() {
      var c = Et, u = a.selector, d;
      return c && c !== a && c.data.push(a), r && (a.selector = Xo(r)), Et = a, d = s.apply(a, arguments), jt(d) && a._r.push(d), Et = c, a.selector = u, a.isReverted = !1, d;
    };
    return a.last = o, n === jt ? o(a, function(l) {
      return a.add(null, l);
    }) : n ? a[n] = o : o;
  }, t.ignore = function(n) {
    var s = Et;
    Et = null, n(this), Et = s;
  }, t.getTweens = function() {
    var n = [];
    return this.data.forEach(function(s) {
      return s instanceof i ? n.push.apply(n, s.getTweens()) : s instanceof Gt && !(s.parent && s.parent.data === "nested") && n.push(s);
    }), n;
  }, t.clear = function() {
    this._r.length = this.data.length = 0;
  }, t.kill = function(n, s) {
    var r = this;
    if (n ? function() {
      for (var o = r.getTweens(), l = r.data.length, c; l--; )
        c = r.data[l], c.data === "isFlip" && (c.revert(), c.getChildren(!0, !0, !1).forEach(function(u) {
          return o.splice(o.indexOf(u), 1);
        }));
      for (o.map(function(u) {
        return {
          g: u._dur || u._delay || u._sat && !u._sat.vars.immediateRender ? u.globalTime(0) : -1 / 0,
          t: u
        };
      }).sort(function(u, d) {
        return d.g - u.g || -1 / 0;
      }).forEach(function(u) {
        return u.t.revert(n);
      }), l = r.data.length; l--; )
        c = r.data[l], c instanceof he ? c.data !== "nested" && (c.scrollTrigger && c.scrollTrigger.revert(), c.kill()) : !(c instanceof Gt) && c.revert && c.revert(n);
      r._r.forEach(function(u) {
        return u(n, r);
      }), r.isReverted = !0;
    }() : this.data.forEach(function(o) {
      return o.kill && o.kill();
    }), this.clear(), s)
      for (var a = yn.length; a--; )
        yn[a].id === this.id && yn.splice(a, 1);
  }, t.revert = function(n) {
    this.kill(n || {});
  }, i;
}(), c6 = /* @__PURE__ */ function() {
  function i(e) {
    this.contexts = [], this.scope = e, Et && Et.data.push(this);
  }
  var t = i.prototype;
  return t.add = function(n, s, r) {
    Ai(n) || (n = {
      matches: n
    });
    var a = new zf(0, r || this.scope), o = a.conditions = {}, l, c, u;
    Et && !a.selector && (a.selector = Et.selector), this.contexts.push(a), s = a.add("onMatch", s), a.queries = n;
    for (c in n)
      c === "all" ? u = 1 : (l = ui.matchMedia(n[c]), l && (yn.indexOf(a) < 0 && yn.push(a), (o[c] = l.matches) && (u = 1), l.addListener ? l.addListener(qo) : l.addEventListener("change", qo)));
    return u && s(a, function(d) {
      return a.add(null, d);
    }), this;
  }, t.revert = function(n) {
    this.kill(n || {});
  }, t.kill = function(n) {
    this.contexts.forEach(function(s) {
      return s.kill(n, !0);
    });
  }, i;
}(), ra = {
  registerPlugin: function() {
    for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
      e[n] = arguments[n];
    e.forEach(function(s) {
      return Of(s);
    });
  },
  timeline: function(t) {
    return new he(t);
  },
  getTweensOf: function(t, e) {
    return Nt.getTweensOf(t, e);
  },
  getProperty: function(t, e, n, s) {
    qt(t) && (t = We(t)[0]);
    var r = vn(t || {}).get, a = n ? pf : ff;
    return n === "native" && (n = ""), t && (e ? a((ke[e] && ke[e].get || r)(t, e, n, s)) : function(o, l, c) {
      return a((ke[o] && ke[o].get || r)(t, o, l, c));
    });
  },
  quickSetter: function(t, e, n) {
    if (t = We(t), t.length > 1) {
      var s = t.map(function(u) {
        return Se.quickSetter(u, e, n);
      }), r = s.length;
      return function(u) {
        for (var d = r; d--; )
          s[d](u);
      };
    }
    t = t[0] || {};
    var a = ke[e], o = vn(t), l = o.harness && (o.harness.aliases || {})[e] || e, c = a ? function(u) {
      var d = new a();
      Wn._pt = 0, d.init(t, n ? u + n : u, Wn, 0, [t]), d.render(1, d), Wn._pt && jl(1, Wn);
    } : o.set(t, l);
    return a ? c : function(u) {
      return c(t, l, n ? u + n : u, o, 1);
    };
  },
  quickTo: function(t, e, n) {
    var s, r = Se.to(t, Cn((s = {}, s[e] = "+=0.1", s.paused = !0, s), n || {})), a = function(l, c, u) {
      return r.resetTo(e, l, c, u);
    };
    return a.tween = r, a;
  },
  isTweening: function(t) {
    return Nt.getTweensOf(t, !0).length > 0;
  },
  defaults: function(t) {
    return t && t.ease && (t.ease = bn(t.ease, Jn.ease)), Uc(Jn, t || {});
  },
  config: function(t) {
    return Uc(De, t || {});
  },
  registerEffect: function(t) {
    var e = t.name, n = t.effect, s = t.plugins, r = t.defaults, a = t.extendTimeline;
    (s || "").split(",").forEach(function(o) {
      return o && !ke[o] && !Le[o] && Fs(e + " effect requires " + o + " plugin.");
    }), so[e] = function(o, l, c) {
      return n(We(o), Ue(l || {}, r), c);
    }, a && (he.prototype[e] = function(o, l, c) {
      return this.add(so[e](o, Ai(l) ? l : (c = l) && {}, this), c);
    });
  },
  registerEase: function(t, e) {
    xt[t] = bn(e);
  },
  parseEase: function(t, e) {
    return arguments.length ? bn(t, e) : xt;
  },
  getById: function(t) {
    return Nt.getById(t);
  },
  exportRoot: function(t, e) {
    t === void 0 && (t = {});
    var n = new he(t), s, r;
    for (n.smoothChildTiming = be(t.smoothChildTiming), Nt.remove(n), n._dp = 0, n._time = n._tTime = Nt._time, s = Nt._first; s; )
      r = s._next, (e || !(!s._dur && s instanceof Gt && s.vars.onComplete === s._targets[0])) && di(n, s, s._start - s._delay), s = r;
    return di(Nt, n, 0), n;
  },
  context: function(t, e) {
    return t ? new zf(t, e) : Et;
  },
  matchMedia: function(t) {
    return new c6(t);
  },
  matchMediaRefresh: function() {
    return yn.forEach(function(t) {
      var e = t.conditions, n, s;
      for (s in e)
        e[s] && (e[s] = !1, n = 1);
      n && t.revert();
    }) || qo();
  },
  addEventListener: function(t, e) {
    var n = Ur[t] || (Ur[t] = []);
    ~n.indexOf(e) || n.push(e);
  },
  removeEventListener: function(t, e) {
    var n = Ur[t], s = n && n.indexOf(e);
    s >= 0 && n.splice(s, 1);
  },
  utils: {
    wrap: V5,
    wrapYoyo: z5,
    distribute: _f,
    random: Cf,
    snap: xf,
    normalize: H5,
    getUnit: re,
    clamp: B5,
    splitColor: Mf,
    toArray: We,
    selector: Xo,
    mapRange: wf,
    pipe: F5,
    unitize: N5,
    interpolate: j5,
    shuffle: yf
  },
  install: lf,
  effects: so,
  ticker: Me,
  updateRoot: he.updateRoot,
  plugins: ke,
  globalTimeline: Nt,
  core: {
    PropTween: _e,
    globals: cf,
    Tween: Gt,
    Timeline: he,
    Animation: zs,
    getCache: vn,
    _removeLinkedListItem: Ma,
    reverting: function() {
      return oe;
    },
    context: function(t) {
      return t && Et && (Et.data.push(t), t._ctx = Et), Et;
    },
    suppressOverwrites: function(t) {
      return Pl = t;
    }
  }
};
ye("to,from,fromTo,delayedCall,set,killTweensOf", function(i) {
  return ra[i] = Gt[i];
});
Me.add(he.updateRoot);
Wn = ra.to({}, {
  duration: 0
});
var u6 = function(t, e) {
  for (var n = t._pt; n && n.p !== e && n.op !== e && n.fp !== e; )
    n = n._next;
  return n;
}, d6 = function(t, e) {
  var n = t._targets, s, r, a;
  for (s in e)
    for (r = n.length; r--; )
      a = t._ptLookup[r][s], a && (a = a.d) && (a._pt && (a = u6(a, s)), a && a.modifier && a.modifier(e[s], t, n[r], s));
}, co = function(t, e) {
  return {
    name: t,
    rawVars: 1,
    //don't pre-process function-based values or "random()" strings.
    init: function(s, r, a) {
      a._onInit = function(o) {
        var l, c;
        if (qt(r) && (l = {}, ye(r, function(u) {
          return l[u] = 1;
        }), r = l), e) {
          l = {};
          for (c in r)
            l[c] = e(r[c]);
          r = l;
        }
        d6(o, r);
      };
    }
  };
}, Se = ra.registerPlugin({
  name: "attr",
  init: function(t, e, n, s, r) {
    var a, o, l;
    this.tween = n;
    for (a in e)
      l = t.getAttribute(a) || "", o = this.add(t, "setAttribute", (l || 0) + "", e[a], s, r, 0, 0, a), o.op = a, o.b = l, this._props.push(a);
  },
  render: function(t, e) {
    for (var n = e._pt; n; )
      oe ? n.set(n.t, n.p, n.b, n) : n.r(t, n.d), n = n._next;
  }
}, {
  name: "endArray",
  init: function(t, e) {
    for (var n = e.length; n--; )
      this.add(t, n, t[n] || 0, e[n], 0, 0, 0, 0, 0, 1);
  }
}, co("roundProps", Qo), co("modifiers"), co("snap", xf)) || ra;
Gt.version = he.version = Se.version = "3.12.5";
of = 1;
Il() && es();
xt.Power0;
xt.Power1;
xt.Power2;
xt.Power3;
xt.Power4;
xt.Linear;
xt.Quad;
xt.Cubic;
xt.Quart;
xt.Quint;
xt.Strong;
xt.Elastic;
xt.Back;
xt.SteppedEase;
xt.Bounce;
xt.Sine;
xt.Expo;
xt.Circ;
/*!
 * CSSPlugin 3.12.5
 * https://gsap.com
 *
 * Copyright 2008-2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/
var Jc, ji, Kn, Wl, gn, qc, Yl, h6 = function() {
  return typeof window < "u";
}, $i = {}, dn = 180 / Math.PI, Xn = Math.PI / 180, Bn = Math.atan2, tu = 1e8, Ul = /([A-Z])/g, f6 = /(left|right|width|margin|padding|x)/i, p6 = /[\s,\(]\S/, pi = {
  autoAlpha: "opacity,visibility",
  scale: "scaleX,scaleY",
  alpha: "opacity"
}, tl = function(t, e) {
  return e.set(e.t, e.p, Math.round((e.s + e.c * t) * 1e4) / 1e4 + e.u, e);
}, g6 = function(t, e) {
  return e.set(e.t, e.p, t === 1 ? e.e : Math.round((e.s + e.c * t) * 1e4) / 1e4 + e.u, e);
}, m6 = function(t, e) {
  return e.set(e.t, e.p, t ? Math.round((e.s + e.c * t) * 1e4) / 1e4 + e.u : e.b, e);
}, v6 = function(t, e) {
  var n = e.s + e.c * t;
  e.set(e.t, e.p, ~~(n + (n < 0 ? -0.5 : 0.5)) + e.u, e);
}, jf = function(t, e) {
  return e.set(e.t, e.p, t ? e.e : e.b, e);
}, Wf = function(t, e) {
  return e.set(e.t, e.p, t !== 1 ? e.b : e.e, e);
}, A6 = function(t, e, n) {
  return t.style[e] = n;
}, b6 = function(t, e, n) {
  return t.style.setProperty(e, n);
}, y6 = function(t, e, n) {
  return t._gsap[e] = n;
}, _6 = function(t, e, n) {
  return t._gsap.scaleX = t._gsap.scaleY = n;
}, x6 = function(t, e, n, s, r) {
  var a = t._gsap;
  a.scaleX = a.scaleY = n, a.renderTransform(r, a);
}, C6 = function(t, e, n, s, r) {
  var a = t._gsap;
  a[e] = n, a.renderTransform(r, a);
}, Ht = "transform", xe = Ht + "Origin", S6 = function i(t, e) {
  var n = this, s = this.target, r = s.style, a = s._gsap;
  if (t in $i && r) {
    if (this.tfm = this.tfm || {}, t !== "transform")
      t = pi[t] || t, ~t.indexOf(",") ? t.split(",").forEach(function(o) {
        return n.tfm[o] = Pi(s, o);
      }) : this.tfm[t] = a.x ? a[t] : Pi(s, t), t === xe && (this.tfm.zOrigin = a.zOrigin);
    else
      return pi.transform.split(",").forEach(function(o) {
        return i.call(n, o, e);
      });
    if (this.props.indexOf(Ht) >= 0)
      return;
    a.svg && (this.svgo = s.getAttribute("data-svg-origin"), this.props.push(xe, e, "")), t = Ht;
  }
  (r || e) && this.props.push(t, e, r[t]);
}, Yf = function(t) {
  t.translate && (t.removeProperty("translate"), t.removeProperty("scale"), t.removeProperty("rotate"));
}, w6 = function() {
  var t = this.props, e = this.target, n = e.style, s = e._gsap, r, a;
  for (r = 0; r < t.length; r += 3)
    t[r + 1] ? e[t[r]] = t[r + 2] : t[r + 2] ? n[t[r]] = t[r + 2] : n.removeProperty(t[r].substr(0, 2) === "--" ? t[r] : t[r].replace(Ul, "-$1").toLowerCase());
  if (this.tfm) {
    for (a in this.tfm)
      s[a] = this.tfm[a];
    s.svg && (s.renderTransform(), e.setAttribute("data-svg-origin", this.svgo || "")), r = Yl(), (!r || !r.isStart) && !n[Ht] && (Yf(n), s.zOrigin && n[xe] && (n[xe] += " " + s.zOrigin + "px", s.zOrigin = 0, s.renderTransform()), s.uncache = 1);
  }
}, Uf = function(t, e) {
  var n = {
    target: t,
    props: [],
    revert: w6,
    save: S6
  };
  return t._gsap || Se.core.getCache(t), e && e.split(",").forEach(function(s) {
    return n.save(s);
  }), n;
}, Zf, el = function(t, e) {
  var n = ji.createElementNS ? ji.createElementNS((e || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), t) : ji.createElement(t);
  return n && n.style ? n : ji.createElement(t);
}, mi = function i(t, e, n) {
  var s = getComputedStyle(t);
  return s[e] || s.getPropertyValue(e.replace(Ul, "-$1").toLowerCase()) || s.getPropertyValue(e) || !n && i(t, is(e) || e, 1) || "";
}, eu = "O,Moz,ms,Ms,Webkit".split(","), is = function(t, e, n) {
  var s = e || gn, r = s.style, a = 5;
  if (t in r && !n)
    return t;
  for (t = t.charAt(0).toUpperCase() + t.substr(1); a-- && !(eu[a] + t in r); )
    ;
  return a < 0 ? null : (a === 3 ? "ms" : a >= 0 ? eu[a] : "") + t;
}, il = function() {
  h6() && window.document && (Jc = window, ji = Jc.document, Kn = ji.documentElement, gn = el("div") || {
    style: {}
  }, el("div"), Ht = is(Ht), xe = Ht + "Origin", gn.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0", Zf = !!is("perspective"), Yl = Se.core.reverting, Wl = 1);
}, uo = function i(t) {
  var e = el("svg", this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), n = this.parentNode, s = this.nextSibling, r = this.style.cssText, a;
  if (Kn.appendChild(e), e.appendChild(this), this.style.display = "block", t)
    try {
      a = this.getBBox(), this._gsapBBox = this.getBBox, this.getBBox = i;
    } catch {
    }
  else this._gsapBBox && (a = this._gsapBBox());
  return n && (s ? n.insertBefore(this, s) : n.appendChild(this)), Kn.removeChild(e), this.style.cssText = r, a;
}, iu = function(t, e) {
  for (var n = e.length; n--; )
    if (t.hasAttribute(e[n]))
      return t.getAttribute(e[n]);
}, Gf = function(t) {
  var e;
  try {
    e = t.getBBox();
  } catch {
    e = uo.call(t, !0);
  }
  return e && (e.width || e.height) || t.getBBox === uo || (e = uo.call(t, !0)), e && !e.width && !e.x && !e.y ? {
    x: +iu(t, ["x", "cx", "x1"]) || 0,
    y: +iu(t, ["y", "cy", "y1"]) || 0,
    width: 0,
    height: 0
  } : e;
}, Kf = function(t) {
  return !!(t.getCTM && (!t.parentNode || t.ownerSVGElement) && Gf(t));
}, Sn = function(t, e) {
  if (e) {
    var n = t.style, s;
    e in $i && e !== xe && (e = Ht), n.removeProperty ? (s = e.substr(0, 2), (s === "ms" || e.substr(0, 6) === "webkit") && (e = "-" + e), n.removeProperty(s === "--" ? e : e.replace(Ul, "-$1").toLowerCase())) : n.removeAttribute(e);
  }
}, Wi = function(t, e, n, s, r, a) {
  var o = new _e(t._pt, e, n, 0, 1, a ? Wf : jf);
  return t._pt = o, o.b = s, o.e = r, t._props.push(n), o;
}, nu = {
  deg: 1,
  rad: 1,
  turn: 1
}, k6 = {
  grid: 1,
  flex: 1
}, Ji = function i(t, e, n, s) {
  var r = parseFloat(n) || 0, a = (n + "").trim().substr((r + "").length) || "px", o = gn.style, l = f6.test(e), c = t.tagName.toLowerCase() === "svg", u = (c ? "client" : "offset") + (l ? "Width" : "Height"), d = 100, h = s === "px", f = s === "%", p, g, m, v;
  if (s === a || !r || nu[s] || nu[a])
    return r;
  if (a !== "px" && !h && (r = i(t, e, n, "px")), v = t.getCTM && Kf(t), (f || a === "%") && ($i[e] || ~e.indexOf("adius")))
    return p = v ? t.getBBox()[l ? "width" : "height"] : t[u], Ut(f ? r / p * d : r / 100 * p);
  if (o[l ? "width" : "height"] = d + (h ? a : s), g = ~e.indexOf("adius") || s === "em" && t.appendChild && !c ? t : t.parentNode, v && (g = (t.ownerSVGElement || {}).parentNode), (!g || g === ji || !g.appendChild) && (g = ji.body), m = g._gsap, m && f && m.width && l && m.time === Me.time && !m.uncache)
    return Ut(r / m.width * d);
  if (f && (e === "height" || e === "width")) {
    var b = t.style[e];
    t.style[e] = d + s, p = t[u], b ? t.style[e] = b : Sn(t, e);
  } else
    (f || a === "%") && !k6[mi(g, "display")] && (o.position = mi(t, "position")), g === t && (o.position = "static"), g.appendChild(gn), p = gn[u], g.removeChild(gn), o.position = "absolute";
  return l && f && (m = vn(g), m.time = Me.time, m.width = g[u]), Ut(h ? p * r / d : p && r ? d / p * r : 0);
}, Pi = function(t, e, n, s) {
  var r;
  return Wl || il(), e in pi && e !== "transform" && (e = pi[e], ~e.indexOf(",") && (e = e.split(",")[0])), $i[e] && e !== "transform" ? (r = Ws(t, s), r = e !== "transformOrigin" ? r[e] : r.svg ? r.origin : oa(mi(t, xe)) + " " + r.zOrigin + "px") : (r = t.style[e], (!r || r === "auto" || s || ~(r + "").indexOf("calc(")) && (r = aa[e] && aa[e](t, e, n) || mi(t, e) || df(t, e) || (e === "opacity" ? 1 : 0))), n && !~(r + "").trim().indexOf(" ") ? Ji(t, e, r, n) + n : r;
}, O6 = function(t, e, n, s) {
  if (!n || n === "none") {
    var r = is(e, t, 1), a = r && mi(t, r, 1);
    a && a !== n ? (e = r, n = a) : e === "borderColor" && (n = mi(t, "borderTopColor"));
  }
  var o = new _e(this._pt, t.style, e, 0, 1, Hf), l = 0, c = 0, u, d, h, f, p, g, m, v, b, _, S, C;
  if (o.b = n, o.e = s, n += "", s += "", s === "auto" && (g = t.style[e], t.style[e] = s, s = mi(t, e) || s, g ? t.style[e] = g : Sn(t, e)), u = [n, s], Df(u), n = u[0], s = u[1], h = n.match(jn) || [], C = s.match(jn) || [], C.length) {
    for (; d = jn.exec(s); )
      m = d[0], b = s.substring(l, d.index), p ? p = (p + 1) % 5 : (b.substr(-5) === "rgba(" || b.substr(-5) === "hsla(") && (p = 1), m !== (g = h[c++] || "") && (f = parseFloat(g) || 0, S = g.substr((f + "").length), m.charAt(1) === "=" && (m = Gn(f, m) + S), v = parseFloat(m), _ = m.substr((v + "").length), l = jn.lastIndex - _.length, _ || (_ = _ || De.units[e] || S, l === s.length && (s += _, o.e += _)), S !== _ && (f = Ji(t, e, g, _) || 0), o._pt = {
        _next: o._pt,
        p: b || c === 1 ? b : ",",
        //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
        s: f,
        c: v - f,
        m: p && p < 4 || e === "zIndex" ? Math.round : 0
      });
    o.c = l < s.length ? s.substring(l, s.length) : "";
  } else
    o.r = e === "display" && s === "none" ? Wf : jf;
  return rf.test(s) && (o.e = 0), this._pt = o, o;
}, su = {
  top: "0%",
  bottom: "100%",
  left: "0%",
  right: "100%",
  center: "50%"
}, M6 = function(t) {
  var e = t.split(" "), n = e[0], s = e[1] || "50%";
  return (n === "top" || n === "bottom" || s === "left" || s === "right") && (t = n, n = s, s = t), e[0] = su[n] || n, e[1] = su[s] || s, e.join(" ");
}, T6 = function(t, e) {
  if (e.tween && e.tween._time === e.tween._dur) {
    var n = e.t, s = n.style, r = e.u, a = n._gsap, o, l, c;
    if (r === "all" || r === !0)
      s.cssText = "", l = 1;
    else
      for (r = r.split(","), c = r.length; --c > -1; )
        o = r[c], $i[o] && (l = 1, o = o === "transformOrigin" ? xe : Ht), Sn(n, o);
    l && (Sn(n, Ht), a && (a.svg && n.removeAttribute("transform"), Ws(n, 1), a.uncache = 1, Yf(s)));
  }
}, aa = {
  clearProps: function(t, e, n, s, r) {
    if (r.data !== "isFromStart") {
      var a = t._pt = new _e(t._pt, e, n, 0, 0, T6);
      return a.u = s, a.pr = -10, a.tween = r, t._props.push(n), 1;
    }
  }
  /* className feature (about 0.4kb gzipped).
  , className(plugin, target, property, endValue, tween) {
  	let _renderClassName = (ratio, data) => {
  			data.css.render(ratio, data.css);
  			if (!ratio || ratio === 1) {
  				let inline = data.rmv,
  					target = data.t,
  					p;
  				target.setAttribute("class", ratio ? data.e : data.b);
  				for (p in inline) {
  					_removeProperty(target, p);
  				}
  			}
  		},
  		_getAllStyles = (target) => {
  			let styles = {},
  				computed = getComputedStyle(target),
  				p;
  			for (p in computed) {
  				if (isNaN(p) && p !== "cssText" && p !== "length") {
  					styles[p] = computed[p];
  				}
  			}
  			_setDefaults(styles, _parseTransform(target, 1));
  			return styles;
  		},
  		startClassList = target.getAttribute("class"),
  		style = target.style,
  		cssText = style.cssText,
  		cache = target._gsap,
  		classPT = cache.classPT,
  		inlineToRemoveAtEnd = {},
  		data = {t:target, plugin:plugin, rmv:inlineToRemoveAtEnd, b:startClassList, e:(endValue.charAt(1) !== "=") ? endValue : startClassList.replace(new RegExp("(?:\\s|^)" + endValue.substr(2) + "(?![\\w-])"), "") + ((endValue.charAt(0) === "+") ? " " + endValue.substr(2) : "")},
  		changingVars = {},
  		startVars = _getAllStyles(target),
  		transformRelated = /(transform|perspective)/i,
  		endVars, p;
  	if (classPT) {
  		classPT.r(1, classPT.d);
  		_removeLinkedListItem(classPT.d.plugin, classPT, "_pt");
  	}
  	target.setAttribute("class", data.e);
  	endVars = _getAllStyles(target, true);
  	target.setAttribute("class", startClassList);
  	for (p in endVars) {
  		if (endVars[p] !== startVars[p] && !transformRelated.test(p)) {
  			changingVars[p] = endVars[p];
  			if (!style[p] && style[p] !== "0") {
  				inlineToRemoveAtEnd[p] = 1;
  			}
  		}
  	}
  	cache.classPT = plugin._pt = new PropTween(plugin._pt, target, "className", 0, 0, _renderClassName, data, 0, -11);
  	if (style.cssText !== cssText) { //only apply if things change. Otherwise, in cases like a background-image that's pulled dynamically, it could cause a refresh. See https://gsap.com/forums/topic/20368-possible-gsap-bug-switching-classnames-in-chrome/.
  		style.cssText = cssText; //we recorded cssText before we swapped classes and ran _getAllStyles() because in cases when a className tween is overwritten, we remove all the related tweening properties from that class change (otherwise class-specific stuff can't override properties we've directly set on the target's style object due to specificity).
  	}
  	_parseTransform(target, true); //to clear the caching of transforms
  	data.css = new gsap.plugins.css();
  	data.css.init(target, changingVars, tween);
  	plugin._props.push(...data.css._props);
  	return 1;
  }
  */
}, js = [1, 0, 0, 1, 0, 0], Xf = {}, Qf = function(t) {
  return t === "matrix(1, 0, 0, 1, 0, 0)" || t === "none" || !t;
}, ru = function(t) {
  var e = mi(t, Ht);
  return Qf(e) ? js : e.substr(7).match(sf).map(Ut);
}, Zl = function(t, e) {
  var n = t._gsap || vn(t), s = t.style, r = ru(t), a, o, l, c;
  return n.svg && t.getAttribute("transform") ? (l = t.transform.baseVal.consolidate().matrix, r = [l.a, l.b, l.c, l.d, l.e, l.f], r.join(",") === "1,0,0,1,0,0" ? js : r) : (r === js && !t.offsetParent && t !== Kn && !n.svg && (l = s.display, s.display = "block", a = t.parentNode, (!a || !t.offsetParent) && (c = 1, o = t.nextElementSibling, Kn.appendChild(t)), r = ru(t), l ? s.display = l : Sn(t, "display"), c && (o ? a.insertBefore(t, o) : a ? a.appendChild(t) : Kn.removeChild(t))), e && r.length > 6 ? [r[0], r[1], r[4], r[5], r[12], r[13]] : r);
}, nl = function(t, e, n, s, r, a) {
  var o = t._gsap, l = r || Zl(t, !0), c = o.xOrigin || 0, u = o.yOrigin || 0, d = o.xOffset || 0, h = o.yOffset || 0, f = l[0], p = l[1], g = l[2], m = l[3], v = l[4], b = l[5], _ = e.split(" "), S = parseFloat(_[0]) || 0, C = parseFloat(_[1]) || 0, O, k, P, x;
  n ? l !== js && (k = f * m - p * g) && (P = S * (m / k) + C * (-g / k) + (g * b - m * v) / k, x = S * (-p / k) + C * (f / k) - (f * b - p * v) / k, S = P, C = x) : (O = Gf(t), S = O.x + (~_[0].indexOf("%") ? S / 100 * O.width : S), C = O.y + (~(_[1] || _[0]).indexOf("%") ? C / 100 * O.height : C)), s || s !== !1 && o.smooth ? (v = S - c, b = C - u, o.xOffset = d + (v * f + b * g) - v, o.yOffset = h + (v * p + b * m) - b) : o.xOffset = o.yOffset = 0, o.xOrigin = S, o.yOrigin = C, o.smooth = !!s, o.origin = e, o.originIsAbsolute = !!n, t.style[xe] = "0px 0px", a && (Wi(a, o, "xOrigin", c, S), Wi(a, o, "yOrigin", u, C), Wi(a, o, "xOffset", d, o.xOffset), Wi(a, o, "yOffset", h, o.yOffset)), t.setAttribute("data-svg-origin", S + " " + C);
}, Ws = function(t, e) {
  var n = t._gsap || new Ef(t);
  if ("x" in n && !e && !n.uncache)
    return n;
  var s = t.style, r = n.scaleX < 0, a = "px", o = "deg", l = getComputedStyle(t), c = mi(t, xe) || "0", u, d, h, f, p, g, m, v, b, _, S, C, O, k, P, x, R, B, L, Y, j, w, I, T, V, N, z, E, H, y, $, D;
  return u = d = h = g = m = v = b = _ = S = 0, f = p = 1, n.svg = !!(t.getCTM && Kf(t)), l.translate && ((l.translate !== "none" || l.scale !== "none" || l.rotate !== "none") && (s[Ht] = (l.translate !== "none" ? "translate3d(" + (l.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + (l.rotate !== "none" ? "rotate(" + l.rotate + ") " : "") + (l.scale !== "none" ? "scale(" + l.scale.split(" ").join(",") + ") " : "") + (l[Ht] !== "none" ? l[Ht] : "")), s.scale = s.rotate = s.translate = "none"), k = Zl(t, n.svg), n.svg && (n.uncache ? (V = t.getBBox(), c = n.xOrigin - V.x + "px " + (n.yOrigin - V.y) + "px", T = "") : T = !e && t.getAttribute("data-svg-origin"), nl(t, T || c, !!T || n.originIsAbsolute, n.smooth !== !1, k)), C = n.xOrigin || 0, O = n.yOrigin || 0, k !== js && (B = k[0], L = k[1], Y = k[2], j = k[3], u = w = k[4], d = I = k[5], k.length === 6 ? (f = Math.sqrt(B * B + L * L), p = Math.sqrt(j * j + Y * Y), g = B || L ? Bn(L, B) * dn : 0, b = Y || j ? Bn(Y, j) * dn + g : 0, b && (p *= Math.abs(Math.cos(b * Xn))), n.svg && (u -= C - (C * B + O * Y), d -= O - (C * L + O * j))) : (D = k[6], y = k[7], z = k[8], E = k[9], H = k[10], $ = k[11], u = k[12], d = k[13], h = k[14], P = Bn(D, H), m = P * dn, P && (x = Math.cos(-P), R = Math.sin(-P), T = w * x + z * R, V = I * x + E * R, N = D * x + H * R, z = w * -R + z * x, E = I * -R + E * x, H = D * -R + H * x, $ = y * -R + $ * x, w = T, I = V, D = N), P = Bn(-Y, H), v = P * dn, P && (x = Math.cos(-P), R = Math.sin(-P), T = B * x - z * R, V = L * x - E * R, N = Y * x - H * R, $ = j * R + $ * x, B = T, L = V, Y = N), P = Bn(L, B), g = P * dn, P && (x = Math.cos(P), R = Math.sin(P), T = B * x + L * R, V = w * x + I * R, L = L * x - B * R, I = I * x - w * R, B = T, w = V), m && Math.abs(m) + Math.abs(g) > 359.9 && (m = g = 0, v = 180 - v), f = Ut(Math.sqrt(B * B + L * L + Y * Y)), p = Ut(Math.sqrt(I * I + D * D)), P = Bn(w, I), b = Math.abs(P) > 2e-4 ? P * dn : 0, S = $ ? 1 / ($ < 0 ? -$ : $) : 0), n.svg && (T = t.getAttribute("transform"), n.forceCSS = t.setAttribute("transform", "") || !Qf(mi(t, Ht)), T && t.setAttribute("transform", T))), Math.abs(b) > 90 && Math.abs(b) < 270 && (r ? (f *= -1, b += g <= 0 ? 180 : -180, g += g <= 0 ? 180 : -180) : (p *= -1, b += b <= 0 ? 180 : -180)), e = e || n.uncache, n.x = u - ((n.xPercent = u && (!e && n.xPercent || (Math.round(t.offsetWidth / 2) === Math.round(-u) ? -50 : 0))) ? t.offsetWidth * n.xPercent / 100 : 0) + a, n.y = d - ((n.yPercent = d && (!e && n.yPercent || (Math.round(t.offsetHeight / 2) === Math.round(-d) ? -50 : 0))) ? t.offsetHeight * n.yPercent / 100 : 0) + a, n.z = h + a, n.scaleX = Ut(f), n.scaleY = Ut(p), n.rotation = Ut(g) + o, n.rotationX = Ut(m) + o, n.rotationY = Ut(v) + o, n.skewX = b + o, n.skewY = _ + o, n.transformPerspective = S + a, (n.zOrigin = parseFloat(c.split(" ")[2]) || !e && n.zOrigin || 0) && (s[xe] = oa(c)), n.xOffset = n.yOffset = 0, n.force3D = De.force3D, n.renderTransform = n.svg ? P6 : Zf ? Jf : D6, n.uncache = 0, n;
}, oa = function(t) {
  return (t = t.split(" "))[0] + " " + t[1];
}, ho = function(t, e, n) {
  var s = re(e);
  return Ut(parseFloat(e) + parseFloat(Ji(t, "x", n + "px", s))) + s;
}, D6 = function(t, e) {
  e.z = "0px", e.rotationY = e.rotationX = "0deg", e.force3D = 0, Jf(t, e);
}, on = "0deg", gs = "0px", ln = ") ", Jf = function(t, e) {
  var n = e || this, s = n.xPercent, r = n.yPercent, a = n.x, o = n.y, l = n.z, c = n.rotation, u = n.rotationY, d = n.rotationX, h = n.skewX, f = n.skewY, p = n.scaleX, g = n.scaleY, m = n.transformPerspective, v = n.force3D, b = n.target, _ = n.zOrigin, S = "", C = v === "auto" && t && t !== 1 || v === !0;
  if (_ && (d !== on || u !== on)) {
    var O = parseFloat(u) * Xn, k = Math.sin(O), P = Math.cos(O), x;
    O = parseFloat(d) * Xn, x = Math.cos(O), a = ho(b, a, k * x * -_), o = ho(b, o, -Math.sin(O) * -_), l = ho(b, l, P * x * -_ + _);
  }
  m !== gs && (S += "perspective(" + m + ln), (s || r) && (S += "translate(" + s + "%, " + r + "%) "), (C || a !== gs || o !== gs || l !== gs) && (S += l !== gs || C ? "translate3d(" + a + ", " + o + ", " + l + ") " : "translate(" + a + ", " + o + ln), c !== on && (S += "rotate(" + c + ln), u !== on && (S += "rotateY(" + u + ln), d !== on && (S += "rotateX(" + d + ln), (h !== on || f !== on) && (S += "skew(" + h + ", " + f + ln), (p !== 1 || g !== 1) && (S += "scale(" + p + ", " + g + ln), b.style[Ht] = S || "translate(0, 0)";
}, P6 = function(t, e) {
  var n = e || this, s = n.xPercent, r = n.yPercent, a = n.x, o = n.y, l = n.rotation, c = n.skewX, u = n.skewY, d = n.scaleX, h = n.scaleY, f = n.target, p = n.xOrigin, g = n.yOrigin, m = n.xOffset, v = n.yOffset, b = n.forceCSS, _ = parseFloat(a), S = parseFloat(o), C, O, k, P, x;
  l = parseFloat(l), c = parseFloat(c), u = parseFloat(u), u && (u = parseFloat(u), c += u, l += u), l || c ? (l *= Xn, c *= Xn, C = Math.cos(l) * d, O = Math.sin(l) * d, k = Math.sin(l - c) * -h, P = Math.cos(l - c) * h, c && (u *= Xn, x = Math.tan(c - u), x = Math.sqrt(1 + x * x), k *= x, P *= x, u && (x = Math.tan(u), x = Math.sqrt(1 + x * x), C *= x, O *= x)), C = Ut(C), O = Ut(O), k = Ut(k), P = Ut(P)) : (C = d, P = h, O = k = 0), (_ && !~(a + "").indexOf("px") || S && !~(o + "").indexOf("px")) && (_ = Ji(f, "x", a, "px"), S = Ji(f, "y", o, "px")), (p || g || m || v) && (_ = Ut(_ + p - (p * C + g * k) + m), S = Ut(S + g - (p * O + g * P) + v)), (s || r) && (x = f.getBBox(), _ = Ut(_ + s / 100 * x.width), S = Ut(S + r / 100 * x.height)), x = "matrix(" + C + "," + O + "," + k + "," + P + "," + _ + "," + S + ")", f.setAttribute("transform", x), b && (f.style[Ht] = x);
}, L6 = function(t, e, n, s, r) {
  var a = 360, o = qt(r), l = parseFloat(r) * (o && ~r.indexOf("rad") ? dn : 1), c = l - s, u = s + c + "deg", d, h;
  return o && (d = r.split("_")[1], d === "short" && (c %= a, c !== c % (a / 2) && (c += c < 0 ? a : -a)), d === "cw" && c < 0 ? c = (c + a * tu) % a - ~~(c / a) * a : d === "ccw" && c > 0 && (c = (c - a * tu) % a - ~~(c / a) * a)), t._pt = h = new _e(t._pt, e, n, s, c, g6), h.e = u, h.u = "deg", t._props.push(n), h;
}, au = function(t, e) {
  for (var n in e)
    t[n] = e[n];
  return t;
}, I6 = function(t, e, n) {
  var s = au({}, n._gsap), r = "perspective,force3D,transformOrigin,svgOrigin", a = n.style, o, l, c, u, d, h, f, p;
  s.svg ? (c = n.getAttribute("transform"), n.setAttribute("transform", ""), a[Ht] = e, o = Ws(n, 1), Sn(n, Ht), n.setAttribute("transform", c)) : (c = getComputedStyle(n)[Ht], a[Ht] = e, o = Ws(n, 1), a[Ht] = c);
  for (l in $i)
    c = s[l], u = o[l], c !== u && r.indexOf(l) < 0 && (f = re(c), p = re(u), d = f !== p ? Ji(n, l, c, p) : parseFloat(c), h = parseFloat(u), t._pt = new _e(t._pt, o, l, d, h - d, tl), t._pt.u = p || 0, t._props.push(l));
  au(o, s);
};
ye("padding,margin,Width,Radius", function(i, t) {
  var e = "Top", n = "Right", s = "Bottom", r = "Left", a = (t < 3 ? [e, n, s, r] : [e + r, e + n, s + n, s + r]).map(function(o) {
    return t < 2 ? i + o : "border" + o + i;
  });
  aa[t > 1 ? "border" + i : i] = function(o, l, c, u, d) {
    var h, f;
    if (arguments.length < 4)
      return h = a.map(function(p) {
        return Pi(o, p, c);
      }), f = h.join(" "), f.split(h[0]).length === 5 ? h[0] : f;
    h = (u + "").split(" "), f = {}, a.forEach(function(p, g) {
      return f[p] = h[g] = h[g] || h[(g - 1) / 2 | 0];
    }), o.init(l, f, d);
  };
});
var qf = {
  name: "css",
  register: il,
  targetTest: function(t) {
    return t.style && t.nodeType;
  },
  init: function(t, e, n, s, r) {
    var a = this._props, o = t.style, l = n.vars.startAt, c, u, d, h, f, p, g, m, v, b, _, S, C, O, k, P;
    Wl || il(), this.styles = this.styles || Uf(t), P = this.styles.props, this.tween = n;
    for (g in e)
      if (g !== "autoRound" && (u = e[g], !(ke[g] && $f(g, e, n, s, t, r)))) {
        if (f = typeof u, p = aa[g], f === "function" && (u = u.call(n, s, t, r), f = typeof u), f === "string" && ~u.indexOf("random(") && (u = Hs(u)), p)
          p(this, t, g, u, n) && (k = 1);
        else if (g.substr(0, 2) === "--")
          c = (getComputedStyle(t).getPropertyValue(g) + "").trim(), u += "", Ki.lastIndex = 0, Ki.test(c) || (m = re(c), v = re(u)), v ? m !== v && (c = Ji(t, g, c, v) + v) : m && (u += m), this.add(o, "setProperty", c, u, s, r, 0, 0, g), a.push(g), P.push(g, 0, o[g]);
        else if (f !== "undefined") {
          if (l && g in l ? (c = typeof l[g] == "function" ? l[g].call(n, s, t, r) : l[g], qt(c) && ~c.indexOf("random(") && (c = Hs(c)), re(c + "") || c === "auto" || (c += De.units[g] || re(Pi(t, g)) || ""), (c + "").charAt(1) === "=" && (c = Pi(t, g))) : c = Pi(t, g), h = parseFloat(c), b = f === "string" && u.charAt(1) === "=" && u.substr(0, 2), b && (u = u.substr(2)), d = parseFloat(u), g in pi && (g === "autoAlpha" && (h === 1 && Pi(t, "visibility") === "hidden" && d && (h = 0), P.push("visibility", 0, o.visibility), Wi(this, o, "visibility", h ? "inherit" : "hidden", d ? "inherit" : "hidden", !d)), g !== "scale" && g !== "transform" && (g = pi[g], ~g.indexOf(",") && (g = g.split(",")[0]))), _ = g in $i, _) {
            if (this.styles.save(g), S || (C = t._gsap, C.renderTransform && !e.parseTransform || Ws(t, e.parseTransform), O = e.smoothOrigin !== !1 && C.smooth, S = this._pt = new _e(this._pt, o, Ht, 0, 1, C.renderTransform, C, 0, -1), S.dep = 1), g === "scale")
              this._pt = new _e(this._pt, C, "scaleY", C.scaleY, (b ? Gn(C.scaleY, b + d) : d) - C.scaleY || 0, tl), this._pt.u = 0, a.push("scaleY", g), g += "X";
            else if (g === "transformOrigin") {
              P.push(xe, 0, o[xe]), u = M6(u), C.svg ? nl(t, u, 0, O, 0, this) : (v = parseFloat(u.split(" ")[2]) || 0, v !== C.zOrigin && Wi(this, C, "zOrigin", C.zOrigin, v), Wi(this, o, g, oa(c), oa(u)));
              continue;
            } else if (g === "svgOrigin") {
              nl(t, u, 1, O, 0, this);
              continue;
            } else if (g in Xf) {
              L6(this, C, g, h, b ? Gn(h, b + u) : u);
              continue;
            } else if (g === "smoothOrigin") {
              Wi(this, C, "smooth", C.smooth, u);
              continue;
            } else if (g === "force3D") {
              C[g] = u;
              continue;
            } else if (g === "transform") {
              I6(this, u, t);
              continue;
            }
          } else g in o || (g = is(g) || g);
          if (_ || (d || d === 0) && (h || h === 0) && !p6.test(u) && g in o)
            m = (c + "").substr((h + "").length), d || (d = 0), v = re(u) || (g in De.units ? De.units[g] : m), m !== v && (h = Ji(t, g, c, v)), this._pt = new _e(this._pt, _ ? C : o, g, h, (b ? Gn(h, b + d) : d) - h, !_ && (v === "px" || g === "zIndex") && e.autoRound !== !1 ? v6 : tl), this._pt.u = v || 0, m !== v && v !== "%" && (this._pt.b = c, this._pt.r = m6);
          else if (g in o)
            O6.call(this, t, g, c, b ? b + u : u);
          else if (g in t)
            this.add(t, g, c || t[g], b ? b + u : u, s, r);
          else if (g !== "parseTransform") {
            $l(g, u);
            continue;
          }
          _ || (g in o ? P.push(g, 0, o[g]) : P.push(g, 1, c || t[g])), a.push(g);
        }
      }
    k && Vf(this);
  },
  render: function(t, e) {
    if (e.tween._time || !Yl())
      for (var n = e._pt; n; )
        n.r(t, n.d), n = n._next;
    else
      e.styles.revert();
  },
  get: Pi,
  aliases: pi,
  getSetter: function(t, e, n) {
    var s = pi[e];
    return s && s.indexOf(",") < 0 && (e = s), e in $i && e !== xe && (t._gsap.x || Pi(t, "x")) ? n && qc === n ? e === "scale" ? _6 : y6 : (qc = n || {}) && (e === "scale" ? x6 : C6) : t.style && !Ll(t.style[e]) ? A6 : ~e.indexOf("-") ? b6 : zl(t, e);
  },
  core: {
    _removeProperty: Sn,
    _getMatrix: Zl
  }
};
Se.utils.checkPrefix = is;
Se.core.getStyleSaver = Uf;
(function(i, t, e, n) {
  var s = ye(i + "," + t + "," + e, function(r) {
    $i[r] = 1;
  });
  ye(t, function(r) {
    De.units[r] = "deg", Xf[r] = 1;
  }), pi[s[13]] = i + "," + t, ye(n, function(r) {
    var a = r.split(":");
    pi[a[1]] = s[a[0]];
  });
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");
ye("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(i) {
  De.units[i] = "px";
});
Se.registerPlugin(qf);
var la = Se.registerPlugin(qf) || Se;
la.core.Tween;
const E6 = {
  name: "AcvAnimatedInteger",
  props: {
    /**
     * Integer value to animate
     */
    value: {
      type: Number,
      required: !0
    },
    /**
     * Apply a currency filter to animated value
     */
    isCurrency: {
      type: Boolean,
      default: !1
    },
    /**
     * Total time of animation
     */
    duration: {
      type: Number,
      default: 0.5
    }
  },
  data() {
    return { tweeningValue: this.value };
  },
  computed: {
    animatedNumber() {
      return this.tweeningValue;
    }
  },
  watch: {
    value(i) {
      la.to(this.$data, {
        duration: this.duration,
        tweeningValue: i,
        snap: {
          tweeningValue: 1
        }
      });
    }
  }
};
var $6 = function() {
  var t = this, e = t._self._c;
  return e("span", [t.isCurrency ? e("span", [t._v(t._s(t._f("currency")(t.animatedNumber)))]) : e("span", [t._v(t._s(t.animatedNumber))])]);
}, B6 = [], R6 = /* @__PURE__ */ U(
  E6,
  $6,
  B6,
  !1,
  null,
  null
);
const F6 = R6.exports, N6 = {
  name: "AcvFadeIn",
  props: {
    /**
     * A unique key used by Vue to identify which elements are transitioned
     */
    valueKey: {
      type: [Number, String],
      required: !0
    },
    /**
     * Total time of transition
     */
    duration: {
      type: Number,
      default: 0.5
    },
    /**
     * Total time of delay
     */
    delay: {
      type: Number,
      default: 0
    },
    /**
     * For a full list of easing options see:
     * https://greensock.com/docs/v3/Eases
    */
    ease: {
      type: String,
      default: "power4.inOut"
    }
  },
  methods: {
    beforeEnter(i) {
      const t = i;
      t.style.opacity = 0;
    },
    enter(i) {
      la.to(i, {
        duration: this.duration,
        ease: this.ease,
        opacity: 1
      }).delay(this.delay);
    },
    leave(i) {
      la.to(i, {
        duration: this.duration,
        ease: this.ease,
        opacity: 0
      });
    }
  }
};
var H6 = function() {
  var t = this, e = t._self._c;
  return e("transition", { attrs: { mode: "out-in" }, on: { "before-enter": t.beforeEnter, enter: t.enter, leave: t.leave } }, [e("span", { key: t.valueKey }, [t._t("default")], 2)]);
}, V6 = [], z6 = /* @__PURE__ */ U(
  N6,
  H6,
  V6,
  !1,
  null,
  null
);
const j6 = z6.exports, W6 = {
  name: "AcvVisibilityChange",
  data() {
    return {
      visible: !1
    };
  },
  mounted() {
    this.addVisibilityChangeListener();
  },
  beforeDestroy() {
    document.removeEventListener(
      "visibilitychange",
      this.addVisibilityChangeListener
    );
  },
  methods: {
    addVisibilityChangeListener() {
      document.addEventListener("visibilitychange", () => this.handleVisibilityChanged(document.visibilityState));
    },
    handleVisibilityChanged(i) {
      i === "visible" ? this.visible = !0 : this.visible = !1, this.$emit("visibility-changed", this.visible);
    }
  },
  render() {
    return null;
  }
}, Y6 = null, U6 = null;
var Z6 = /* @__PURE__ */ U(
  W6,
  Y6,
  U6,
  !1,
  null,
  null
);
const G6 = Z6.exports, K6 = {
  name: "AcvFlyoutMenu",
  directives: {
    onClickaway: On
  },
  components: {
    AcvIconButton: Ee,
    AcvList: cs,
    AcvListItem: us
  },
  props: {
    /**
     * Menu items for the flyout menu.
     * The items are an array of objects with the following structure:
     *
     * {
     *    label: 'Save'
     *    event: {
     *      name: 'clicked-save',
     *      data: {
     *        auctionId: 9999,
     *        make: 'Ford',
     *      },
     *    }
     * }
     */
    items: {
      type: Array,
      default: () => []
    },
    /**
     * Open the flyout on click or hover
     */
    openOn: {
      type: String,
      default: "click",
      validator(i) {
        return ["click", "hover"].indexOf(i) !== -1;
      }
    }
  },
  data() {
    return {
      hover: !1,
      showFlyout: !1
    };
  },
  computed: {
    openOnClick() {
      return this.openOn === "click";
    },
    openOnHover() {
      return this.openOn === "hover";
    }
  },
  methods: {
    closeFlyout() {
      this.showFlyout = !1;
    },
    handleClick() {
      this.openOnClick && (this.showFlyout = !this.showFlyout, this.$emit("flyout-menu-clicked", { showFlyout: this.showFlyout }));
    },
    handleClickAway() {
      this.showFlyout && this.openOnClick && this.closeFlyout();
    },
    handleMouseEnter() {
      this.openOnHover && this.openFlyout();
    },
    handleMouseLeave() {
      this.openOnHover && this.closeFlyout();
    },
    openFlyout() {
      this.showFlyout = !0;
    }
  }
};
var X6 = function() {
  var t = this, e = t._self._c;
  return e("div", { directives: [{ name: "on-clickaway", rawName: "v-on-clickaway:mousedown", value: t.handleClickAway, expression: "handleClickAway", arg: "mousedown" }], staticClass: "acv-flyout-menu", on: { mouseenter: t.handleMouseEnter, focusin: t.handleMouseEnter, mouseleave: t.handleMouseLeave, focusout: t.handleMouseLeave } }, [e("div", { directives: [{ name: "show", rawName: "v-show", value: t.showFlyout, expression: "showFlyout" }], staticClass: "flyout-wrapper", attrs: { id: `menu-${t._uid}` } }, [t._t("flyout", function() {
    return [e("acv-list", { staticClass: "acv-menu-flyout-items", attrs: { "bg-white": "", elevated: "", role: "menu" } }, t._l(t.items, function(n) {
      return e("acv-list-item", { key: n.name, staticClass: "acv-menu-flyout-items__item", attrs: { role: "menuitem" }, on: { click: function(s) {
        return s.preventDefault(), s.stopPropagation(), t.$emit(n.event.name, n.event.data);
      } } }, [t._v(" " + t._s(n.label) + " ")]);
    }), 1)];
  })], 2), e("acv-icon-button", { attrs: { "show-tooltip": !1, role: "button", "aria-haspopup": "true", "aria-expanded": t.showFlyout, "aria-controls": `menu-${t._uid}`, "icon-type": "more-vert" }, on: { click: function(n) {
    return n.preventDefault(), n.stopPropagation(), t.handleClick.apply(null, arguments);
  } }, scopedSlots: t._u([{ key: "icon", fn: function() {
    return [t._t("icon")];
  }, proxy: !0 }], null, !0) }), t._t("modal")], 2);
}, Q6 = [], J6 = /* @__PURE__ */ U(
  K6,
  X6,
  Q6,
  !1,
  null,
  "da0abd36"
);
const tp = J6.exports, q6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: tp
}, Symbol.toStringTag, { value: "Module" }));
var ms = function(i) {
  return i && i.Math === Math && i;
}, ti = (
  // eslint-disable-next-line es/no-global-this -- safe
  ms(typeof globalThis == "object" && globalThis) || ms(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
  ms(typeof self == "object" && self) || ms(typeof hi == "object" && hi) || ms(typeof hi == "object" && hi) || // eslint-disable-next-line no-new-func -- fallback
  /* @__PURE__ */ function() {
    return this;
  }() || Function("return this")()
), Gl = {}, _i = function(i) {
  try {
    return !!i();
  } catch {
    return !0;
  }
}, t4 = _i, Dn = !t4(function() {
  return Object.defineProperty({}, 1, { get: function() {
    return 7;
  } })[1] !== 7;
}), e4 = _i, Kl = !e4(function() {
  var i = (function() {
  }).bind();
  return typeof i != "function" || i.hasOwnProperty("prototype");
}), i4 = Kl, Sr = Function.prototype.call, hs = i4 ? Sr.bind(Sr) : function() {
  return Sr.apply(Sr, arguments);
}, ep = {}, ip = {}.propertyIsEnumerable, np = Object.getOwnPropertyDescriptor, n4 = np && !ip.call({ 1: 2 }, 1);
ep.f = n4 ? function(t) {
  var e = np(this, t);
  return !!e && e.enumerable;
} : ip;
var sp = function(i, t) {
  return {
    enumerable: !(i & 1),
    configurable: !(i & 2),
    writable: !(i & 4),
    value: t
  };
}, rp = Kl, ap = Function.prototype, sl = ap.call, s4 = rp && ap.bind.bind(sl, sl), $e = rp ? s4 : function(i) {
  return function() {
    return sl.apply(i, arguments);
  };
}, op = $e, r4 = op({}.toString), a4 = op("".slice), Xl = function(i) {
  return a4(r4(i), 8, -1);
}, o4 = $e, l4 = _i, c4 = Xl, fo = Object, u4 = o4("".split), d4 = l4(function() {
  return !fo("z").propertyIsEnumerable(0);
}) ? function(i) {
  return c4(i) === "String" ? u4(i, "") : fo(i);
} : fo, Ql = function(i) {
  return i == null;
}, h4 = Ql, f4 = TypeError, Pa = function(i) {
  if (h4(i)) throw new f4("Can't call method on " + i);
  return i;
}, p4 = d4, g4 = Pa, Jl = function(i) {
  return p4(g4(i));
}, po = typeof document == "object" && document.all, ei = typeof po > "u" && po !== void 0 ? function(i) {
  return typeof i == "function" || i === po;
} : function(i) {
  return typeof i == "function";
}, m4 = ei, sr = function(i) {
  return typeof i == "object" ? i !== null : m4(i);
}, go = ti, v4 = ei, A4 = function(i) {
  return v4(i) ? i : void 0;
}, ql = function(i, t) {
  return arguments.length < 2 ? A4(go[i]) : go[i] && go[i][t];
}, b4 = $e, lp = b4({}.isPrototypeOf), y4 = ti, ou = y4.navigator, lu = ou && ou.userAgent, _4 = lu ? String(lu) : "", cp = ti, mo = _4, cu = cp.process, uu = cp.Deno, du = cu && cu.versions || uu && uu.version, hu = du && du.v8, Je, ca;
hu && (Je = hu.split("."), ca = Je[0] > 0 && Je[0] < 4 ? 1 : +(Je[0] + Je[1]));
!ca && mo && (Je = mo.match(/Edge\/(\d+)/), (!Je || Je[1] >= 74) && (Je = mo.match(/Chrome\/(\d+)/), Je && (ca = +Je[1])));
var x4 = ca, fu = x4, C4 = _i, S4 = ti, w4 = S4.String, up = !!Object.getOwnPropertySymbols && !C4(function() {
  var i = Symbol("symbol detection");
  return !w4(i) || !(Object(i) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
  !Symbol.sham && fu && fu < 41;
}), k4 = up, dp = k4 && !Symbol.sham && typeof Symbol.iterator == "symbol", O4 = ql, M4 = ei, T4 = lp, D4 = dp, P4 = Object, hp = D4 ? function(i) {
  return typeof i == "symbol";
} : function(i) {
  var t = O4("Symbol");
  return M4(t) && T4(t.prototype, P4(i));
}, L4 = String, tc = function(i) {
  try {
    return L4(i);
  } catch {
    return "Object";
  }
}, I4 = ei, E4 = tc, $4 = TypeError, rr = function(i) {
  if (I4(i)) return i;
  throw new $4(E4(i) + " is not a function");
}, B4 = rr, R4 = Ql, ec = function(i, t) {
  var e = i[t];
  return R4(e) ? void 0 : B4(e);
}, vo = hs, Ao = ei, bo = sr, F4 = TypeError, N4 = function(i, t) {
  var e, n;
  if (t === "string" && Ao(e = i.toString) && !bo(n = vo(e, i)) || Ao(e = i.valueOf) && !bo(n = vo(e, i)) || t !== "string" && Ao(e = i.toString) && !bo(n = vo(e, i))) return n;
  throw new F4("Can't convert object to primitive value");
}, fp = { exports: {} }, pu = ti, H4 = Object.defineProperty, ic = function(i, t) {
  try {
    H4(pu, i, { value: t, configurable: !0, writable: !0 });
  } catch {
    pu[i] = t;
  }
  return t;
}, V4 = ti, z4 = ic, gu = "__core-js_shared__", mu = fp.exports = V4[gu] || z4(gu, {});
(mu.versions || (mu.versions = [])).push({
  version: "3.39.0",
  mode: "global",
  copyright: "© 2014-2024 Denis Pushkarev (zloirock.ru)",
  license: "https://github.com/zloirock/core-js/blob/v3.39.0/LICENSE",
  source: "https://github.com/zloirock/core-js"
});
var nc = fp.exports, vu = nc, pp = function(i, t) {
  return vu[i] || (vu[i] = t || {});
}, j4 = Pa, W4 = Object, Y4 = function(i) {
  return W4(j4(i));
}, U4 = $e, Z4 = Y4, G4 = U4({}.hasOwnProperty), Pn = Object.hasOwn || function(t, e) {
  return G4(Z4(t), e);
}, K4 = $e, X4 = 0, Q4 = Math.random(), J4 = K4(1 .toString), gp = function(i) {
  return "Symbol(" + (i === void 0 ? "" : i) + ")_" + J4(++X4 + Q4, 36);
}, q4 = ti, t9 = pp, Au = Pn, e9 = gp, i9 = up, n9 = dp, Yn = q4.Symbol, yo = t9("wks"), s9 = n9 ? Yn.for || Yn : Yn && Yn.withoutSetter || e9, ar = function(i) {
  return Au(yo, i) || (yo[i] = i9 && Au(Yn, i) ? Yn[i] : s9("Symbol." + i)), yo[i];
}, r9 = hs, bu = sr, yu = hp, a9 = ec, o9 = N4, l9 = ar, c9 = TypeError, u9 = l9("toPrimitive"), d9 = function(i, t) {
  if (!bu(i) || yu(i)) return i;
  var e = a9(i, u9), n;
  if (e) {
    if (t === void 0 && (t = "default"), n = r9(e, i, t), !bu(n) || yu(n)) return n;
    throw new c9("Can't convert object to primitive value");
  }
  return t === void 0 && (t = "number"), o9(i, t);
}, h9 = d9, f9 = hp, sc = function(i) {
  var t = h9(i, "string");
  return f9(t) ? t : t + "";
}, p9 = ti, _u = sr, rl = p9.document, g9 = _u(rl) && _u(rl.createElement), m9 = function(i) {
  return g9 ? rl.createElement(i) : {};
}, v9 = Dn, A9 = _i, b9 = m9, mp = !v9 && !A9(function() {
  return Object.defineProperty(b9("div"), "a", {
    get: function() {
      return 7;
    }
  }).a !== 7;
}), y9 = Dn, _9 = hs, x9 = ep, C9 = sp, S9 = Jl, w9 = sc, k9 = Pn, O9 = mp, xu = Object.getOwnPropertyDescriptor;
Gl.f = y9 ? xu : function(t, e) {
  if (t = S9(t), e = w9(e), O9) try {
    return xu(t, e);
  } catch {
  }
  if (k9(t, e)) return C9(!_9(x9.f, t, e), t[e]);
};
var La = {}, M9 = Dn, T9 = _i, D9 = M9 && T9(function() {
  return Object.defineProperty(function() {
  }, "prototype", {
    value: 42,
    writable: !1
  }).prototype !== 42;
}), P9 = sr, L9 = String, I9 = TypeError, or = function(i) {
  if (P9(i)) return i;
  throw new I9(L9(i) + " is not an object");
}, E9 = Dn, $9 = mp, B9 = D9, wr = or, Cu = sc, R9 = TypeError, _o = Object.defineProperty, F9 = Object.getOwnPropertyDescriptor, xo = "enumerable", Co = "configurable", So = "writable";
La.f = E9 ? B9 ? function(t, e, n) {
  if (wr(t), e = Cu(e), wr(n), typeof t == "function" && e === "prototype" && "value" in n && So in n && !n[So]) {
    var s = F9(t, e);
    s && s[So] && (t[e] = n.value, n = {
      configurable: Co in n ? n[Co] : s[Co],
      enumerable: xo in n ? n[xo] : s[xo],
      writable: !1
    });
  }
  return _o(t, e, n);
} : _o : function(t, e, n) {
  if (wr(t), e = Cu(e), wr(n), $9) try {
    return _o(t, e, n);
  } catch {
  }
  if ("get" in n || "set" in n) throw new R9("Accessors not supported");
  return "value" in n && (t[e] = n.value), t;
};
var N9 = Dn, H9 = La, V9 = sp, vp = N9 ? function(i, t, e) {
  return H9.f(i, t, V9(1, e));
} : function(i, t, e) {
  return i[t] = e, i;
}, Ap = { exports: {} }, al = Dn, z9 = Pn, bp = Function.prototype, j9 = al && Object.getOwnPropertyDescriptor, rc = z9(bp, "name"), W9 = rc && (function() {
}).name === "something", Y9 = rc && (!al || al && j9(bp, "name").configurable), U9 = {
  EXISTS: rc,
  PROPER: W9,
  CONFIGURABLE: Y9
}, Z9 = $e, G9 = ei, ol = nc, K9 = Z9(Function.toString);
G9(ol.inspectSource) || (ol.inspectSource = function(i) {
  return K9(i);
});
var X9 = ol.inspectSource, Q9 = ti, J9 = ei, Su = Q9.WeakMap, q9 = J9(Su) && /native code/.test(String(Su)), t8 = pp, e8 = gp, wu = t8("keys"), i8 = function(i) {
  return wu[i] || (wu[i] = e8(i));
}, yp = {}, n8 = q9, _p = ti, s8 = sr, r8 = vp, wo = Pn, ko = nc, a8 = i8, o8 = yp, ku = "Object already initialized", ll = _p.TypeError, l8 = _p.WeakMap, ua, Ys, da, c8 = function(i) {
  return da(i) ? Ys(i) : ua(i, {});
}, u8 = function(i) {
  return function(t) {
    var e;
    if (!s8(t) || (e = Ys(t)).type !== i)
      throw new ll("Incompatible receiver, " + i + " required");
    return e;
  };
};
if (n8 || ko.state) {
  var li = ko.state || (ko.state = new l8());
  li.get = li.get, li.has = li.has, li.set = li.set, ua = function(i, t) {
    if (li.has(i)) throw new ll(ku);
    return t.facade = i, li.set(i, t), t;
  }, Ys = function(i) {
    return li.get(i) || {};
  }, da = function(i) {
    return li.has(i);
  };
} else {
  var Rn = a8("state");
  o8[Rn] = !0, ua = function(i, t) {
    if (wo(i, Rn)) throw new ll(ku);
    return t.facade = i, r8(i, Rn, t), t;
  }, Ys = function(i) {
    return wo(i, Rn) ? i[Rn] : {};
  }, da = function(i) {
    return wo(i, Rn);
  };
}
var d8 = {
  set: ua,
  get: Ys,
  has: da,
  enforce: c8,
  getterFor: u8
}, ac = $e, h8 = _i, f8 = ei, kr = Pn, cl = Dn, p8 = U9.CONFIGURABLE, g8 = X9, xp = d8, m8 = xp.enforce, v8 = xp.get, Ou = String, Zr = Object.defineProperty, A8 = ac("".slice), b8 = ac("".replace), y8 = ac([].join), _8 = cl && !h8(function() {
  return Zr(function() {
  }, "length", { value: 8 }).length !== 8;
}), x8 = String(String).split("String"), C8 = Ap.exports = function(i, t, e) {
  A8(Ou(t), 0, 7) === "Symbol(" && (t = "[" + b8(Ou(t), /^Symbol\(([^)]*)\).*$/, "$1") + "]"), e && e.getter && (t = "get " + t), e && e.setter && (t = "set " + t), (!kr(i, "name") || p8 && i.name !== t) && (cl ? Zr(i, "name", { value: t, configurable: !0 }) : i.name = t), _8 && e && kr(e, "arity") && i.length !== e.arity && Zr(i, "length", { value: e.arity });
  try {
    e && kr(e, "constructor") && e.constructor ? cl && Zr(i, "prototype", { writable: !1 }) : i.prototype && (i.prototype = void 0);
  } catch {
  }
  var n = m8(i);
  return kr(n, "source") || (n.source = y8(x8, typeof t == "string" ? t : "")), i;
};
Function.prototype.toString = C8(function() {
  return f8(this) && v8(this).source || g8(this);
}, "toString");
var S8 = Ap.exports, w8 = ei, k8 = La, O8 = S8, M8 = ic, T8 = function(i, t, e, n) {
  n || (n = {});
  var s = n.enumerable, r = n.name !== void 0 ? n.name : t;
  if (w8(e) && O8(e, r, n), n.global)
    s ? i[t] = e : M8(t, e);
  else {
    try {
      n.unsafe ? i[t] && (s = !0) : delete i[t];
    } catch {
    }
    s ? i[t] = e : k8.f(i, t, {
      value: e,
      enumerable: !1,
      configurable: !n.nonConfigurable,
      writable: !n.nonWritable
    });
  }
  return i;
}, Cp = {}, D8 = Math.ceil, P8 = Math.floor, L8 = Math.trunc || function(t) {
  var e = +t;
  return (e > 0 ? P8 : D8)(e);
}, I8 = L8, Sp = function(i) {
  var t = +i;
  return t !== t || t === 0 ? 0 : I8(t);
}, E8 = Sp, $8 = Math.max, B8 = Math.min, R8 = function(i, t) {
  var e = E8(i);
  return e < 0 ? $8(e + t, 0) : B8(e, t);
}, F8 = Sp, N8 = Math.min, H8 = function(i) {
  var t = F8(i);
  return t > 0 ? N8(t, 9007199254740991) : 0;
}, V8 = H8, wp = function(i) {
  return V8(i.length);
}, z8 = Jl, j8 = R8, W8 = wp, Mu = function(i) {
  return function(t, e, n) {
    var s = z8(t), r = W8(s);
    if (r === 0) return !i && -1;
    var a = j8(n, r), o;
    if (i && e !== e) {
      for (; r > a; )
        if (o = s[a++], o !== o) return !0;
    } else for (; r > a; a++)
      if ((i || a in s) && s[a] === e) return i || a || 0;
    return !i && -1;
  };
}, Y8 = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: Mu(!0),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: Mu(!1)
}, U8 = $e, Oo = Pn, Z8 = Jl, G8 = Y8.indexOf, K8 = yp, Tu = U8([].push), X8 = function(i, t) {
  var e = Z8(i), n = 0, s = [], r;
  for (r in e) !Oo(K8, r) && Oo(e, r) && Tu(s, r);
  for (; t.length > n; ) Oo(e, r = t[n++]) && (~G8(s, r) || Tu(s, r));
  return s;
}, Q8 = [
  "constructor",
  "hasOwnProperty",
  "isPrototypeOf",
  "propertyIsEnumerable",
  "toLocaleString",
  "toString",
  "valueOf"
], J8 = X8, q8 = Q8, t7 = q8.concat("length", "prototype");
Cp.f = Object.getOwnPropertyNames || function(t) {
  return J8(t, t7);
};
var kp = {};
kp.f = Object.getOwnPropertySymbols;
var e7 = ql, i7 = $e, n7 = Cp, s7 = kp, r7 = or, a7 = i7([].concat), o7 = e7("Reflect", "ownKeys") || function(t) {
  var e = n7.f(r7(t)), n = s7.f;
  return n ? a7(e, n(t)) : e;
}, Du = Pn, l7 = o7, c7 = Gl, u7 = La, d7 = function(i, t, e) {
  for (var n = l7(t), s = u7.f, r = c7.f, a = 0; a < n.length; a++) {
    var o = n[a];
    !Du(i, o) && !(e && Du(e, o)) && s(i, o, r(t, o));
  }
}, h7 = _i, f7 = ei, p7 = /#|\.prototype\./, lr = function(i, t) {
  var e = m7[g7(i)];
  return e === A7 ? !0 : e === v7 ? !1 : f7(t) ? h7(t) : !!t;
}, g7 = lr.normalize = function(i) {
  return String(i).replace(p7, ".").toLowerCase();
}, m7 = lr.data = {}, v7 = lr.NATIVE = "N", A7 = lr.POLYFILL = "P", b7 = lr, Or = ti, y7 = Gl.f, _7 = vp, x7 = T8, C7 = ic, S7 = d7, w7 = b7, Op = function(i, t) {
  var e = i.target, n = i.global, s = i.stat, r, a, o, l, c, u;
  if (n ? a = Or : s ? a = Or[e] || C7(e, {}) : a = Or[e] && Or[e].prototype, a) for (o in t) {
    if (c = t[o], i.dontCallGetSet ? (u = y7(a, o), l = u && u.value) : l = a[o], r = w7(n ? o : e + (s ? "." : "#") + o, i.forced), !r && l !== void 0) {
      if (typeof c == typeof l) continue;
      S7(c, l);
    }
    (i.sham || l && l.sham) && _7(c, "sham", !0), x7(a, o, c, i);
  }
}, k7 = Xl, O7 = $e, M7 = function(i) {
  if (k7(i) === "Function") return O7(i);
}, Pu = M7, T7 = rr, D7 = Kl, P7 = Pu(Pu.bind), L7 = function(i, t) {
  return T7(i), t === void 0 ? i : D7 ? P7(i, t) : function() {
    return i.apply(t, arguments);
  };
}, Mp = {}, I7 = ar, E7 = Mp, $7 = I7("iterator"), B7 = Array.prototype, R7 = function(i) {
  return i !== void 0 && (E7.Array === i || B7[$7] === i);
}, F7 = ar, N7 = F7("toStringTag"), Tp = {};
Tp[N7] = "z";
var H7 = String(Tp) === "[object z]", V7 = H7, z7 = ei, Gr = Xl, j7 = ar, W7 = j7("toStringTag"), Y7 = Object, U7 = Gr(/* @__PURE__ */ function() {
  return arguments;
}()) === "Arguments", Z7 = function(i, t) {
  try {
    return i[t];
  } catch {
  }
}, G7 = V7 ? Gr : function(i) {
  var t, e, n;
  return i === void 0 ? "Undefined" : i === null ? "Null" : typeof (e = Z7(t = Y7(i), W7)) == "string" ? e : U7 ? Gr(t) : (n = Gr(t)) === "Object" && z7(t.callee) ? "Arguments" : n;
}, K7 = G7, Lu = ec, X7 = Ql, Q7 = Mp, J7 = ar, q7 = J7("iterator"), Dp = function(i) {
  if (!X7(i)) return Lu(i, q7) || Lu(i, "@@iterator") || Q7[K7(i)];
}, tx = hs, ex = rr, ix = or, nx = tc, sx = Dp, rx = TypeError, ax = function(i, t) {
  var e = arguments.length < 2 ? sx(i) : t;
  if (ex(e)) return ix(tx(e, i));
  throw new rx(nx(i) + " is not iterable");
}, ox = hs, Iu = or, lx = ec, cx = function(i, t, e) {
  var n, s;
  Iu(i);
  try {
    if (n = lx(i, "return"), !n) {
      if (t === "throw") throw e;
      return e;
    }
    n = ox(n, i);
  } catch (r) {
    s = !0, n = r;
  }
  if (t === "throw") throw e;
  if (s) throw n;
  return Iu(n), e;
}, ux = L7, dx = hs, hx = or, fx = tc, px = R7, gx = wp, Eu = lp, mx = ax, vx = Dp, $u = cx, Ax = TypeError, Kr = function(i, t) {
  this.stopped = i, this.result = t;
}, Bu = Kr.prototype, Pp = function(i, t, e) {
  var n = e && e.that, s = !!(e && e.AS_ENTRIES), r = !!(e && e.IS_RECORD), a = !!(e && e.IS_ITERATOR), o = !!(e && e.INTERRUPTED), l = ux(t, n), c, u, d, h, f, p, g, m = function(b) {
    return c && $u(c, "normal", b), new Kr(!0, b);
  }, v = function(b) {
    return s ? (hx(b), o ? l(b[0], b[1], m) : l(b[0], b[1])) : o ? l(b, m) : l(b);
  };
  if (r)
    c = i.iterator;
  else if (a)
    c = i;
  else {
    if (u = vx(i), !u) throw new Ax(fx(i) + " is not iterable");
    if (px(u)) {
      for (d = 0, h = gx(i); h > d; d++)
        if (f = v(i[d]), f && Eu(Bu, f)) return f;
      return new Kr(!1);
    }
    c = mx(i, u);
  }
  for (p = r ? i.next : c.next; !(g = dx(p, c)).done; ) {
    try {
      f = v(g.value);
    } catch (b) {
      $u(c, "throw", b);
    }
    if (typeof f == "object" && f && Eu(Bu, f)) return f;
  }
  return new Kr(!1);
}, Mr = $e, vs = Map.prototype, bx = {
  // eslint-disable-next-line es/no-map -- safe
  Map,
  set: Mr(vs.set),
  get: Mr(vs.get),
  has: Mr(vs.has),
  remove: Mr(vs.delete),
  proto: vs
}, yx = Op, _x = $e, xx = rr, Cx = Pa, Sx = Pp, Ia = bx, wx = _i, Lp = Ia.Map, kx = Ia.has, Ox = Ia.get, Mx = Ia.set, Tx = _x([].push), Dx = wx(function() {
  return Lp.groupBy("ab", function(i) {
    return i;
  }).get("a").length !== 1;
});
yx({ target: "Map", stat: !0, forced: Dx }, {
  groupBy: function(t, e) {
    Cx(t), xx(e);
    var n = new Lp(), s = 0;
    return Sx(t, function(r) {
      var a = e(r, s++);
      kx(n, a) ? Tx(Ox(n, a), r) : Mx(n, a, [r]);
    }), n;
  }
});
var Px = Op, Lx = ql, Ix = $e, Ex = rr, $x = Pa, Bx = sc, Rx = Pp, Fx = _i, Ru = Object.groupBy, Nx = Lx("Object", "create"), Hx = Ix([].push), Vx = !Ru || Fx(function() {
  return Ru("ab", function(i) {
    return i;
  }).a.length !== 1;
});
Px({ target: "Object", stat: !0, forced: Vx }, {
  groupBy: function(t, e) {
    $x(t), Ex(e);
    var n = Nx(null), s = 0;
    return Rx(t, function(r) {
      var a = Bx(e(r, s++));
      a in n ? Hx(n[a], r) : n[a] = [r];
    }), n;
  }
});
const Fu = "data:image/png;base64,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", zx = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAHYYAAB2GAV2iE4EAAAMSSURBVGhD7ZftTxpBEMaHt0PCq5GI0NjQRFq1NqYfbCr++RVIqqbWKvQbH6SpRixwQMrr0X2WO6KNbXTuPmyb/SUbjtvZYZ7bmbnFd3x8NKP/AL/9+c+jhaiGFqIaWohqaCGqoYWohhaiGlqIangqZDab0XQ6pclkQuPx+MGBOdjA1ks8+2OF4AKBAK2tZSkajVIwGJTffT6fnL8rst/v09XV98UaL/BEiGVZMvjt7dfU63ZpMBwunr5lTaWN3x+Q4kKhEIXDYYrH41StXkhRfr/7xGAJwdNFoPhEcAi4WDyg8/Mv1BVCnMCc3XBw0gnCIWRn5w2Vy6WFD9hD6O/rHsOTH4WTIvv7RRn8cmqZcrmcfLKmacqgIAQDAd0dzn3YwLbf64m1zyglfMAXfHLrh7WnCGoo0gcYIk3y+RfU6bTFtSHTJhKJyFSLxWL3Bu5hDjZhYdvudMTavLwG8AnfHNiphVQYDge0u/tWPNGUPcMDD+H09JMQtCR3iyOGvSMYhcJL1yJAMpkSvl4t/HJgtwsULPK7dPiBzs4+U6PRsGceT+NbQ649FD5QZ/DJhd1+kc8o0KOjjzQajWQQ6XSatra2qVIpkWGEbcv7jEZDUdQHVKtVqdlsyuI3DIP29t7JDoZrzq64ar/oMgCdpic60GQyppWVNF1eXsq89/nub/hsZok0StL6+nO6vW2KegiJJhAVL8WgnK9Uyuz2yy92IeS9LcQr3Ajh1wjN9dfrdTo5OZbXACl3fX1NNzc3Dw7MOa0bYC18zGFluYTftezrbDZLGxsF+5t4r4gcb7db1Gr9eHBgDjYOWAsfDtyuxS521Mjm5pYn7Rd02m2qfa3J1OLgSggOiabZkUWNQh/8HJDZNeXc30CwiXiCliJ4AYbmTSCRpAtxiOQKYdcIUgAtd3U1Q5lMBneoJdIG9+dHkD8P2MAWYC18WEIMN60Ae0cAjinOAQ/vg6f+t0Dbdl6CEIHjCRf2jgD8MFIBg/MHCWuc9W5EAFdCVEILUQ0tRDW0ENXQQlRDC1ENLUQ1tBC1IPoFoDegYO3Cxz8AAAAASUVORK5CYII=", jx = {
  name: "AcvCallToActionTable",
  components: {
    AcvProgressIndicator: Ca,
    AcvCheckbox: ls,
    AcvPagination: oh,
    AcvFlyoutMenu: () => Promise.resolve().then(() => q6),
    AcvButton: () => Promise.resolve().then(() => Xd),
    AcvIcon: () => Promise.resolve().then(() => Ie),
    AcvIconButton: () => Promise.resolve().then(() => xl),
    AcvStatusBadge: () => Promise.resolve().then(() => Qh),
    AcvTextField: () => Promise.resolve().then(() => Hv),
    AcvLazyImage: () => Promise.resolve().then(() => bb),
    AcvLightbox: () => Promise.resolve().then(() => Ub),
    AcvTooltip: () => Promise.resolve().then(() => j1)
  },
  directives: {
    toggle: uh
  },
  extends: Cl,
  model: {
    prop: "value",
    event: "selection-change"
  },
  props: {
    callToActionOnHover: {
      type: Boolean,
      default: !1
    },
    dataSource: {
      type: String,
      default: "frontend",
      validator(i) {
        return wt(i, [
          "frontend",
          "api"
        ]);
      }
    },
    enableLightbox: {
      type: Boolean,
      default: !1
    },
    alwaysShowBadges: {
      type: Boolean,
      default: !1
    },
    groupBy: {
      type: String,
      default: ""
    },
    groupOrder: {
      type: Array,
      default: () => []
    },
    lightboxProps: {
      type: Object,
      default: () => ({})
    },
    multiselect: {
      type: Boolean,
      default: !1
    },
    rows: {
      type: Array,
      default: () => []
    },
    // an array of strings with values for grid-template-columns.
    // The first element refers to checkbox column. The image column doesn't get a column style,
    // will always default to 'auto'.
    // Example:
    // ["50px", "auto", "1fr"]
    columnStyle: {
      type: Array,
      default: () => []
    },
    responsive: {
      type: Boolean,
      default: !0
    },
    totalRowCount: {
      type: Number,
      default: 0
    },
    maxSelectableRows: {
      type: Number,
      default: null
    },
    multiselectDefaultDisabledLabel: {
      type: String,
      default: ""
    },
    showSelectAllCheckbox: {
      type: Boolean,
      default: !0
    },
    defaultRowIdsToExpand: {
      type: Array,
      default: () => []
    },
    entireRowToggle: {
      type: Boolean,
      default: !1
    },
    loading: {
      type: Boolean,
      default: !1
    },
    initSelections: {
      type: Object,
      default: () => ({})
    },
    showEveryBadge: {
      type: Boolean,
      default: !1
    },
    shouldResetSelections: {
      type: Boolean,
      default: !1
    },
    searchInputLabel: {
      type: String,
      default: null
    },
    searchInputPlaceholder: {
      type: String,
      default: null
    },
    // safety net just in case
    enableSortAsTimestamp: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      currentBreakpoint: this.$tailwindHelper.getCurrentBreakpoint(),
      lightboxPhotos: [],
      mediaQueryList: null,
      pagination: { pageSize: 10, currentPage: 1 },
      photosIndex: null,
      placeholderImage: Fu,
      rowDataPath: "data",
      selections: {},
      rowsAlreadyExpanded: [],
      selectionsInitialized: !1
    };
  },
  computed: {
    searchInputLabelText() {
      return this.searchInputLabel && this.searchInputLabel.length > 0 ? this.searchInputLabel : this.filterTextInputPlaceholder;
    },
    searchInputPlaceholderText() {
      return this.searchInputPlaceholder && this.searchInputPlaceholder.length > 0 ? this.searchInputPlaceholder : this.filterTextInputPlaceholder;
    },
    allRowsSelected() {
      const i = Object.values(this.selections);
      return i.length === this.visibleRows.length && i.every((t) => t === !0);
    },
    applyMobileStyles() {
      const i = ["tw-sm", "tw-md"];
      return this.responsive && i.includes(this.currentBreakpoint.key);
    },
    gridId() {
      return `cta-grid-${this._uid}`;
    },
    gridStyles() {
      let i = "";
      this.multiselect && !this.applyMobileStyles && (this.columnStyle.length !== 0 ? i = `[checkbox] ${this.columnStyle[0] ? this.columnStyle[0] : "auto"}` : i = "[checkbox] auto"), this.hasImages && (i = `${i} [image] auto`), this.columns.forEach((n, s) => {
        if (this.multiselect && this.columnStyle.length !== 0) {
          const r = this.multiselect ? 1 : 0;
          i = `${i} [${n.key}] ${this.columnStyle[s] ? this.columnStyle[s + r] : "auto"}`;
        } else
          i = `${i} [${n.key}] auto`;
      }), this.hasBadges && (i = `${i} [badges] auto`), this.hasCallToAction && !this.callToActionOnHover && (i = `${i} [cta] auto`), this.hasExpandableRows && (i = `${i} [collapsible] auto`), this.hasMenu && (i = `${i} [menu] auto`), i = `${i} [col-end]`;
      let t = 0, e = "[header] auto";
      return this.visibleGroupedRows.forEach((n, s) => {
        s !== "ungrouped" && (e += ` [group-${t}] auto`, t += 1), n.forEach((r) => {
          e += ` [top-${r.id}] auto [bottom-${r.id}] auto`, this.rowHasCollapsibleContent(r.id) && (e += ` [collapsible-${r.id}] auto`);
        });
      }), {
        "grid-template-columns": i,
        "grid-template-rows": e
      };
    },
    groupedRows() {
      return this.groupBy ? Map.groupBy(this.rows, (i) => i[this.rowDataPath][this.groupBy]) : /* @__PURE__ */ new Map([
        ["ungrouped", this.rows]
      ]);
    },
    groupedRowsKeys() {
      return Array.from(this.groupedRows.keys());
    },
    orderedGroupKeys() {
      const i = this.groupOrder.filter((e) => this.groupedRowsKeys.includes(e)), t = this.groupedRowsKeys.filter((e) => !i.includes(e));
      return i.concat(t);
    },
    sortedFilteredGroupedRows() {
      const i = /* @__PURE__ */ new Map();
      return this.orderedGroupKeys.forEach((t) => {
        let e = this.groupedRows.get(t);
        this.internalFilterText && (e = this.filterRows(e)), this.sortedColumn && (e = this.sortRows(e)), i.set(t, e);
      }), i;
    },
    sortedFilteredRows() {
      return Array.from(this.sortedFilteredGroupedRows.values()).flat();
    },
    visibleGroupedRows() {
      return this.groupBy ? Map.groupBy(this.visibleRows, (i) => i[this.rowDataPath][this.groupBy]) : /* @__PURE__ */ new Map([
        ["ungrouped", this.visibleRows]
      ]);
    },
    visibleGroupedRowsKeys() {
      return Array.from(this.visibleGroupedRows.keys());
    },
    hasMenu() {
      return this.rows.some((i) => {
        var t;
        return (t = i.menuItems) == null ? void 0 : t.length;
      });
    },
    hasBadges() {
      return this.alwaysShowBadges || this.rows.some((i) => {
        var t;
        return (t = i.badges) == null ? void 0 : t.length;
      });
    },
    hasCallToAction() {
      return this.rows.some((i) => {
        var t;
        return (t = i.actions) == null ? void 0 : t.length;
      });
    },
    hasImages() {
      return this.rows.some((i) => this.rowHasImages(i));
    },
    hasExpandableRows() {
      return this.rows.some((i) => this.rowHasCollapsibleContent(i.id));
    },
    isFrontendDriven() {
      return this.dataSource === "frontend";
    },
    selectAll() {
      return this.allRowsSelected || this.someRowsSelected;
    },
    showBottomPagination() {
      return this.paging === "bottom" || this.paging === "both";
    },
    showTopPagination() {
      return this.paging === "top" || this.paging === "both";
    },
    someRowsSelected() {
      return Object.values(this.selections).some((t) => t === !0) && !this.allRowsSelected;
    },
    totalAvailableRows() {
      return this.dataSource === "api" ? this.totalRowCount : this.totalSortedFilteredRows;
    },
    totalSelectedRows() {
      return Object.values(this.selections).filter((i) => i).length;
    },
    maxSelectableRowsReached() {
      return this.maxSelectableRows > 0 && this.totalSelectedRows >= this.maxSelectableRows;
    }
  },
  watch: {
    selections: {
      handler() {
        this.$emit("selection-change", this.selections);
      },
      deep: !0
    },
    loading(i, t) {
      this.defaultRowIdsToExpand.length && !i && t && this.resetRowsAlreadyExpanded();
    },
    totalAvailableRows: {
      handler() {
        this.isFrontendDriven && this.resetPagination();
      }
    }
  },
  async created() {
    this.mediaQueryList = window.matchMedia("(max-width: 991px)"), this.mediaQueryList.addListener(this.handleResize), this.handleResize(this.mediaQueryList);
  },
  beforeUpdate() {
    (this.shouldResetSelections || !this.selectionsInitialized) && this.initSelections && this.initializeSelection(), this.selectionsInitialized = !0;
  },
  destroyed() {
    this.mediaQueryList.removeListener(this.handleResize);
  },
  methods: {
    showCheckboxTooltip(i) {
      var t, e;
      return (((t = i.data.action) == null ? void 0 : t.multiselectDisabledLabel) || this.multiselectDefaultDisabledLabel) && (this.maxSelectableRowsReached && !this.selections[i.id] || ((e = i.data.action) == null ? void 0 : e.disableForMultiSelect) === !0);
    },
    /**
     * We can't guarantee that group will not have special characters that will break slot name
     * so we need to sanitize it.
     *
     * @param {*} group
     */
    getSanitizedGroupName(i) {
      let t = i;
      return typeof t == "string" && (t = i.replace(/[^0-9a-zA-Z-_]/g, "_")), `group-${t}`;
    },
    getClassForCTAButton(i) {
      var e;
      const t = ((e = i == null ? void 0 : i.event) == null ? void 0 : e.name) || `cta-${i == null ? void 0 : i.label}`;
      return {
        [t]: !!t
      };
    },
    getGridAreaForBottomSection(i) {
      if (this.applyMobileStyles)
        return {
          "grid-area": "3 / 1 / 3 / col-end"
        };
      let t = "1";
      return this.hasImages && this.multiselect ? t = "3" : (this.hasImages || this.multiselect) && (t = "2"), {
        "grid-row": `bottom-${i} / span 1`,
        "grid-column": `${t} / span ${this.columns.length}`
      };
    },
    getGridAreaForGrouping(i) {
      return {
        "grid-row": `group-${i} / span 1`,
        "grid-column": "1 / col-end"
      };
    },
    getGridAreaForBadges(i) {
      return this.applyMobileStyles ? {
        "grid-area": "2 / 1 / span 1 / col-end"
      } : {
        "grid-row": `top-${i.id} / span 2`,
        "grid-column": "badges"
      };
    },
    getGridAreaForCheckbox(i) {
      return this.applyMobileStyles ? {
        "grid-area": "1 / 1 / span 1 / span 1"
      } : {
        "grid-row": `top-${i.id} / span 2`,
        "grid-column": "checkbox"
      };
    },
    getGridAreaForCTA(i) {
      if (this.applyMobileStyles)
        return {
          "grid-area": "4 / 1 / span 1 / col-end"
        };
      if (this.callToActionOnHover) {
        if (this.hasBadges)
          return this.getGridAreaForBadges(i);
        const t = this.hasImages ? 2 : 1;
        return {
          "grid-row": `top-${i.id} / span 2`,
          "grid-column": `${t} / span ${this.visibleColumns.length}`
        };
      }
      return {
        "grid-row": `top-${i.id} / span 2`,
        "grid-column": "cta"
      };
    },
    getGridAreaForDataCell(i, t) {
      if (this.applyMobileStyles)
        return "";
      let e = "span 2";
      return this.rowHasBottomSection(t) && (e = "span 1"), {
        "grid-row": `top-${t.id} / ${e}`,
        "grid-column": i
      };
    },
    getGridAreaForDataWrapper(i) {
      const t = this.rowHasBottomSection(i) || this.applyMobileStyles ? "span 1" : "span 2";
      return this.applyMobileStyles ? {
        "grid-area": `1 / data / ${t} / col-end`
      } : {
        "grid-area": `1  /  data / ${t} / span 1`
      };
    },
    getGridAreaForExpandableRow(i) {
      return this.applyMobileStyles ? {
        "grid-area": "2 / collapsible / span 1 / span 1"
      } : {
        "grid-row": `top-${i.id} / span 2`,
        "grid-column": "collapsible"
      };
    },
    getGridAreaForImage(i) {
      return this.applyMobileStyles ? {
        "grid-area": "1 / image/ span 1 / span 1"
      } : {
        "grid-row": `top-${i.id} / span 2`,
        "grid-column": "image"
      };
    },
    getGridAreaForMenu(i) {
      return this.applyMobileStyles ? {
        "grid-area": "2 / menu / span 1 / span 1"
      } : {
        "grid-row": `top-${i.id} / span 2`,
        "grid-column": "menu"
      };
    },
    getImageAltText() {
      return "";
    },
    getImagePlaceholder() {
      return zx;
    },
    getImageSrc(i) {
      const t = i.images || i.image;
      return Array.isArray(t) && t.length ? t[0] : typeof t == "string" && t.length ? t : Fu;
    },
    handleHeaderClick(i) {
      this.$emit("header-cell-click", i), this.setSort(i.key);
    },
    handlePageChange() {
      this.currentPageNumber !== this.pagination.currentPage && this.multiselect && this.resetSelections(), this.isFrontendDriven && (this.internalSelectedPageSize.value = this.pagination.pageSize, this.currentPageNumber = this.pagination.currentPage), this.$emit("pagination-change", this.pagination);
    },
    resetPagination() {
      this.currentPageNumber = 1, this.pagination.currentPage = 1;
    },
    resetRowsAlreadyExpanded() {
      this.rowsAlreadyExpanded = [];
    },
    handleResize() {
      this.currentBreakpoint = this.$tailwindHelper.getCurrentBreakpoint();
    },
    handleRowExpand(i) {
      this.$emit("row-expanded", i);
    },
    handleRowCollapse(i) {
      this.$emit("row-collapse", i);
    },
    handleSelectAllChange(i) {
      const t = {};
      i === !0 ? (this.visibleRows.forEach((e) => {
        var n;
        t[e.id] = !((n = e.data.action) != null && n.disableForMultiSelect);
      }), this.selections = { ...this.selections, ...t }) : i === !1 && (this.visibleRows.forEach((e) => {
        t[e.id] = !1;
      }), this.selections = { ...this.selections, ...t });
    },
    resetSelections() {
      this.selections = {};
    },
    rowHasBadges(i) {
      var t;
      return (t = i.badges) == null ? void 0 : t.length;
    },
    rowHasBottomSection(i) {
      return !!this.$slots[`${i.id}-bottom-section`];
    },
    rowHasCollapsibleContent(i) {
      return !!this.$slots[`${i}-collapse`];
    },
    rowHasImages(i) {
      var t, e;
      return !!((t = i.images) != null && t.length) || !!((e = i.image) != null && e.length);
    },
    rowHasMenuItems(i) {
      var t;
      return (t = i.menuItems) == null ? void 0 : t.length;
    },
    rowHasActions(i) {
      var t;
      return (t = i.actions) == null ? void 0 : t.length;
    },
    openPhotoLightbox(i) {
      if (this.enableLightbox && this.rowHasImages(i)) {
        let t = i.images || i.image;
        Array.isArray(t) || (t = [t]), this.lightboxPhotos = t, this.photosIndex = 0, this.$emit("lightbox-opened", i.id);
      }
    },
    closePhotoLightbox() {
      this.enableLightbox && (this.lightboxPhotos = [], this.photosIndex = null, this.$emit("lightbox-closed"));
    },
    expandDefaultRows(i) {
      return this.defaultRowIdsToExpand.includes(i) && !this.rowsAlreadyExpanded.includes(i) ? (this.handleRowExpand(i), this.rowsAlreadyExpanded.push(i), "shown") : "";
    },
    initializeSelection() {
      if (this.maxSelectableRows) {
        const i = Object.fromEntries(Object.entries({ ...this.initSelections }).slice(0, this.maxSelectableRows));
        Object.keys(i).forEach((t) => {
          this.$set(this.selections, t, i[t]);
        });
      } else
        Object.keys(this.initSelections).forEach((i) => {
          this.$set(this.selections, i, this.initSelections[i]);
        });
    }
  }
};
var Wx = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "acv-cta-table" }, [e("div", { staticClass: "top-container" }, [e("div", { staticClass: "acv-cta-table__filter" }, [t._t("filter-input", function() {
    return [t.filterable ? e("acv-text-field", { attrs: { id: "cta-table-search-input", name: "cta-table-filter__input", label: t.searchInputLabelText, placeholder: t.searchInputPlaceholderText }, model: { value: t.internalFilterText, callback: function(n) {
      t.internalFilterText = n;
    }, expression: "internalFilterText" } }) : t._e()];
  })], 2), t.showTopPagination ? e("acv-pagination", { staticClass: "acv-cta-table__pagination top", attrs: { "total-row-count": t.totalAvailableRows }, on: { change: t.handlePageChange }, scopedSlots: t._u([{ key: "before", fn: function() {
    return [t._t("pagination-top-before")];
  }, proxy: !0 }, { key: "pager-text", fn: function() {
    return [t._t("pager-text")];
  }, proxy: !0 }, { key: "after", fn: function() {
    return [t._t("pagination-top-after")];
  }, proxy: !0 }], null, !0), model: { value: t.pagination, callback: function(n) {
    t.pagination = n;
  }, expression: "pagination" } }) : t._e()], 1), e("div", { staticClass: "acv-cta-table__records", class: { responsive: t.responsive }, style: t.gridStyles, attrs: { id: t.gridId } }, [e("div", { staticClass: "table-header" }, [t.multiselect && !t.applyMobileStyles ? e("div", { staticClass: "header-cell select-all" }, [t.showSelectAllCheckbox ? e("acv-checkbox", { attrs: { "model-value": t.selectAll, indeterminate: t.someRowsSelected, label: "select all rows", "hide-label": "", disabled: t.maxSelectableRows && !t.someRowsSelected }, on: { change: t.handleSelectAllChange } }) : t._e()], 1) : t._e(), t.hasImages ? e("div", { staticClass: "header-cell image" }, [t._t("image-header-label", function() {
    return [t._v(" Image ")];
  })], 2) : t._e(), t._l(t.columns, function(n) {
    return e("div", { key: n.key, staticClass: "header-cell", class: [
      n.key,
      t.sortable && n.sortable ? "--hover" : ""
    ], on: { click: function(s) {
      return t.handleHeaderClick(n);
    }, keypress: function(s) {
      return !s.type.indexOf("key") && t._k(s.keyCode, "space", 32, s.key, [" ", "Spacebar"]) ? null : t.handleHeaderClick(n);
    } } }, [t._t(`${n.key}-header-label`, function() {
      return [e("span", { staticClass: "header-label" }, [t._v(t._s(n.label))])];
    }, { column: n }), n.sortable && t.getSortIconForColumn(n) ? e("acv-icon", { staticClass: "header-sort-icon", attrs: { icon: t.getSortIconForColumn(n) } }) : t._e()], 2);
  }), t.hasBadges ? e("div", { staticClass: "header-cell badges" }, [t._t("badges-header-label", function() {
    return [t._v(" Status ")];
  })], 2) : t._e(), t.hasCallToAction && !t.callToActionOnHover ? e("div", { staticClass: "header-cell cta" }, [t._t("cta-header-label", function() {
    return [t._v("   ")];
  })], 2) : t._e(), t.hasExpandableRows ? e("div", { staticClass: "header-cell expandable-rows" }, [t._v("   ")]) : t._e(), t.hasMenu ? e("div", { staticClass: "header-cell menu" }, [t._t("menu-header", function() {
    return [t._v("   ")];
  })], 2) : t._e()], 2), !t.visibleRows.length && !t.loading ? e("div", { staticClass: "no-results-wrapper" }, [t._t("no-results", function() {
    return [e("div", { staticClass: "no-results" }, [t._v(" No results found. ")])];
  }, { filterText: t.internalFilterText })], 2) : t._e(), t.loading ? e("div", { staticClass: "loading-wrapper" }, [t._t("loading", function() {
    return [e("acv-progress-indicator", { staticClass: "loading", attrs: { size: 50 } })];
  })], 2) : t._e(), t._l(t.visibleGroupedRowsKeys, function(n, s) {
    return [t.visibleGroupedRows.has(n) && !t.loading ? [n !== "ungrouped" ? e("div", { key: s, staticClass: "group-header", class: t.getSanitizedGroupName(n), style: t.getGridAreaForGrouping(s) }, [t._t(t.getSanitizedGroupName(n), function() {
      return [t._v(" " + t._s(n) + " ")];
    }, { group: n })], 2) : t._e(), t._l(t.visibleGroupedRows.get(n), function(r) {
      return [e("div", { directives: [{ name: "toggle", rawName: "v-toggle:[expandDefaultRows(row.id)]", value: t.entireRowToggle ? `${r.id}-collapse` : !1, expression: "entireRowToggle\n              ? `${row.id}-collapse`\n              : false", arg: t.expandDefaultRows(r.id) }], key: `row-top-${r.id}`, staticClass: "table-row", class: { "checked-row": t.selections[r.id] }, on: { click: function(a) {
        return t.$emit("row-click", { row: r });
      }, keypress: function(a) {
        return !a.type.indexOf("key") && t._k(a.keyCode, "space", 32, a.key, [" ", "Spacebar"]) ? null : t.$emit("row-click", { row: r });
      } } }, [t.multiselect ? e("div", { staticClass: "row-cell checkbox", style: t.getGridAreaForCheckbox(r) }, [e("acv-checkbox", { staticClass: "row-checkbox", attrs: { id: `row-${r.id}-checkbox`, label: `Select row ${r.id}`, "hide-label": "", disabled: t.maxSelectableRowsReached && !t.selections[r.id] || r.data.action && r.data.action.disableForMultiSelect === !0 }, model: { value: t.selections[r.id], callback: function(a) {
        t.$set(t.selections, r.id, a);
      }, expression: "selections[row.id]" } }), t.showCheckboxTooltip(r) ? e("acv-tooltip", { attrs: { target: `label[for=row-${r.id}-checkbox] > div`, position: "right" } }, [t._v(" " + t._s(r.data.action && r.data.action.multiselectDisabledLabel || t.multiselectDefaultDisabledLabel) + " ")]) : t._e()], 1) : t._e(), t.hasImages ? e("div", { staticClass: "row-cell image", style: t.getGridAreaForImage(r) }, [e("div", { staticClass: "image-wrapper", class: { "image-pointer": t.rowHasImages(r) && t.enableLightbox }, on: { click: function(a) {
        return a.stopPropagation(), t.openPhotoLightbox(r);
      }, keypress: function(a) {
        return !a.type.indexOf("key") && t._k(a.keyCode, "space", 32, a.key, [" ", "Spacebar"]) ? null : (a.stopPropagation(), t.openPhotoLightbox(r));
      } } }, [t._t("image-cell", function() {
        return [e("acv-lazy-image", { attrs: { alt: t.getImageAltText(r), src: t.getImageSrc(r), "src-placeholder": t.getImagePlaceholder(), "error-placeholder": t.placeholderImage, lazy: "" } })];
      }, { row: r })], 2)]) : t._e(), e("div", { staticClass: "data-wrapper", style: t.getGridAreaForDataWrapper(r) }, t._l(t.columns, function(a) {
        return e("div", { key: a.key, staticClass: "row-cell", class: {
          [a.key]: !0
        }, style: t.getGridAreaForDataCell(a.key, r), attrs: { "data-label": a.label || a.key } }, [t._t(`${a.key}-cell`, function() {
          return [t._v(" " + t._s(r.data[a.key]) + " ")];
        }, { data: r.data[a.key], row: r, index: a.key })], 2);
      }), 0), t.hasBadges ? e("div", { staticClass: "row-cell badges", class: { "cta-on-hover": t.callToActionOnHover && !t.applyMobileStyles && t.rowHasActions(r) }, style: t.getGridAreaForBadges(r) }, [t._t("badges-cell", function() {
        return [t.applyMobileStyles || t.showEveryBadge ? t._l(r.badges, function(a, o) {
          return e("acv-status-badge", { key: o, attrs: { variant: a.variant, "icon-type": a.icon } }, [t._v(" " + t._s(a.text) + " ")]);
        }) : [t.rowHasBadges(r) ? e("acv-status-badge", { attrs: { variant: r.badges[0].variant, "icon-type": r.badges[0].icon } }, [t._v(" " + t._s(r.badges[0].text) + " ")]) : t._e(), t.rowHasBadges(r) && r.badges.length > 1 ? e("acv-status-badge", [t._v(" " + t._s(`+${r.badges.length - 1}`) + " ")]) : t._e()]];
      }, { row: r })], 2) : t._e(), t.hasCallToAction ? e("div", { staticClass: "row-cell cta-buttons", class: { "cta-on-hover": t.callToActionOnHover && !t.applyMobileStyles }, style: t.getGridAreaForCTA(r) }, t._l(r.actions, function(a, o) {
        return e("acv-button", t._b({ key: o, class: t.getClassForCTAButton(a), on: { click: function(l) {
          return l.preventDefault(), l.stopPropagation(), t.$emit(a.event.name, a.event.data);
        } } }, "acv-button", a.buttonProps, !1), [t._v(" " + t._s(a.label) + " ")]);
      }), 1) : t._e(), t.hasExpandableRows ? e("div", { staticClass: "row-cell expand-icon", style: t.getGridAreaForExpandableRow(r) }, [t.rowHasCollapsibleContent(r.id) ? e("acv-icon-button", { directives: [{ name: "toggle", rawName: "v-toggle:[expandDefaultRows(row.id)]", value: t.entireRowToggle ? !1 : `${r.id}-collapse`, expression: "!entireRowToggle\n                  ? `${row.id}-collapse`\n                  : false", arg: t.expandDefaultRows(r.id) }], staticClass: "collapse-chevron", attrs: { "icon-type": "expand-more", "show-tooltip": !1 } }) : t._e()], 1) : t._e(), t.hasMenu ? e("div", { staticClass: "row-cell menu-button", style: t.getGridAreaForMenu(r) }, [t.rowHasMenuItems(r) ? e("acv-flyout-menu", t._g({ attrs: { vin: r.data.vin, items: r.menuItems }, on: { "flyout-menu-clicked": function(a) {
        return t.$emit("row-menu-clicked", { ...a, row: r });
      } } }, t.$listeners)) : t._e()], 1) : t._e(), t.rowHasBottomSection(r) ? e("div", { staticClass: "bottom-section", style: t.getGridAreaForBottomSection(r.id) }, [t._t(`${r.id}-bottom-section`)], 2) : t._e(), t.rowHasCollapsibleContent(r.id) ? e("div", { staticClass: "table-row-collapsible", style: { "grid-row": `collapsible-${r.id} / span 1` }, attrs: { id: `${r.id}-collapse` }, on: { shown: function(a) {
        return t.handleRowExpand(r.id);
      }, hidden: function(a) {
        return t.handleRowCollapse(r.id);
      }, click: function(a) {
        a.stopPropagation();
      } } }, [t._t(`${r.id}-collapse`)], 2) : t._e()])];
    })] : t._e()];
  })], 2), t.showBottomPagination ? e("acv-pagination", { staticClass: "acv-cta-table__pagination bottom", attrs: { "total-row-count": t.totalAvailableRows }, on: { change: t.handlePageChange }, scopedSlots: t._u([{ key: "before", fn: function() {
    return [t._t("pagination-bottom-before")];
  }, proxy: !0 }, { key: "pager-text", fn: function() {
    return [t._t("pager-text")];
  }, proxy: !0 }, { key: "after", fn: function() {
    return [t._t("pagination-bottom-after")];
  }, proxy: !0 }], null, !0), model: { value: t.pagination, callback: function(n) {
    t.pagination = n;
  }, expression: "pagination" } }) : t._e(), t.enableLightbox ? e("acv-lightbox", t._b({ attrs: { images: t.lightboxPhotos }, on: { close: t.closePhotoLightbox }, model: { value: t.photosIndex, callback: function(n) {
    t.photosIndex = n;
  }, expression: "photosIndex" } }, "acv-lightbox", t.lightboxProps, !1)) : t._e()], 1);
}, Yx = [], Ux = /* @__PURE__ */ U(
  jx,
  Wx,
  Yx,
  !1,
  null,
  "eb32b43e"
);
const Zx = Ux.exports;
class Gx {
  constructor(t) {
    this.file = t, this.id = `${t.name}-${t.size}-${t.lastModified}-${t.type}`, this.name = t.name, this.size = t.size, this.type = t.type, this.loading = !1, this.loadingProgress = 0, this.status = "";
  }
}
var Kx = function() {
  var i = this, t = i.$createElement, e = i._self._c || t;
  return e("svg", i._g({ attrs: { xmlns: "http://www.w3.org/2000/svg", width: "50", height: "50", fill: "none" } }, i.$listeners), [e("path", { attrs: { fill: "#757575", "fill-rule": "evenodd", d: "M29.714 3.135a.515.515 0 0 0-.516.516v7.206c0 .285.231.516.516.516h7.207a.516.516 0 0 0 .364-.88l-7.206-7.207a.52.52 0 0 0-.365-.151M3 49.627A2.63 2.63 0 0 1 .373 47V3A2.63 2.63 0 0 1 3 .373h26.714c.282 0 .547.11.746.309l9.429 9.43c.2.198.31.463.31.745v11a1.057 1.057 0 0 1-2.111 0V14a.516.516 0 0 0-.516-.516h-8.12a2.367 2.367 0 0 1-2.365-2.365V3a.516.516 0 0 0-.515-.515H3A.516.516 0 0 0 2.484 3v44c0 .284.232.516.516.516h23.572a1.057 1.057 0 0 1 0 2.11z", "clip-rule": "evenodd" } }), e("path", { attrs: { fill: "#757575", "fill-rule": "evenodd", d: "M15.572 19.77a1.057 1.057 0 0 1 0-2.111H25a1.057 1.057 0 0 1 0 2.111zM12.428 26.056A1.057 1.057 0 0 1 11.373 25c0-.582.474-1.056 1.055-1.056h15.714c.582 0 1.056.474 1.056 1.056s-.474 1.056-1.056 1.056zM12.428 32.34a1.057 1.057 0 0 1 0-2.11h9.43c.58 0 1.055.473 1.055 1.055 0 .583-.474 1.056-1.056 1.056zM12.428 38.627a1.057 1.057 0 0 1-1.055-1.055c0-.583.474-1.056 1.055-1.056h9.43c.58 0 1.055.474 1.055 1.056 0 .58-.474 1.055-1.056 1.055zM37.572 27.627c-5.484 0-9.945 4.461-9.945 9.945 0 5.482 4.461 9.944 9.945 9.944 5.482 0 9.944-4.462 9.944-9.944 0-5.484-4.462-9.945-9.944-9.945m0 22c-6.648 0-12.056-5.408-12.056-12.055 0-6.648 5.408-12.056 12.056-12.056s12.055 5.408 12.055 12.056-5.408 12.055-12.055 12.055", "clip-rule": "evenodd" } }), e("path", { attrs: { fill: "#757575", "fill-rule": "evenodd", d: "M37.572 43.341a1.057 1.057 0 0 1-1.056-1.055V36.65a.515.515 0 0 0-.88-.365l-.461.46c-.2.2-.464.31-.746.31a1.057 1.057 0 0 1-.746-1.801l3.14-3.142a1.05 1.05 0 0 1 .749-.31 1.05 1.05 0 0 1 .749.31l3.14 3.14a1.057 1.057 0 0 1-.746 1.802c-.283 0-.548-.11-.747-.309l-.46-.46a.516.516 0 0 0-.88.365v5.635c0 .581-.475 1.055-1.056 1.055", "clip-rule": "evenodd" } })]);
};
const Xx = {
  render: Kx
}, Qx = {
  name: "AcvFileUpload",
  components: {
    AcvIcon: ie,
    AcvIconButton: () => Promise.resolve().then(() => xl),
    UploadFileSvg: Xx,
    AcvBaseInput: Ce,
    AcvBanner: () => Promise.resolve().then(() => D1),
    AcvProgressBar: () => Promise.resolve().then(() => a_),
    AcvStatusBadge: () => Promise.resolve().then(() => Qh)
  },
  model: {
    prop: "modelValue",
    event: "change"
  },
  props: {
    /**
    * The inherited v-model value
    */
    modelValue: {
      type: [Array, FileList],
      default: () => []
    },
    /**
    * Show icon in the drag drop area
    */
    showIcon: {
      type: Boolean,
      default: !0
    },
    /**
    * Icon in the drag drop area
    */
    icon: {
      type: String,
      default: ""
    },
    /**
    * Header text for the drag drop area
    */
    headerText: {
      type: String,
      default: "Upload File"
    },
    /**
    * Body text for the drag drop area
    */
    bodyText: {
      type: String,
      default: ""
    },
    /**
    * Sub text for the drag drop area
    */
    subText: {
      type: String,
      default: ""
    },
    /**
    * Informational text shown beneath the drag drop area
    */
    informationalText: {
      type: String,
      default: "Check if the documents were properly filled out and signed before uploading."
    },
    /**
    * File size for the files to be uploaded in the format of size and unit, for example 1MB<br/>
    * If the file size is provided, files will not be uploaded and an error banner will be shown
    */
    fileSize: {
      type: String,
      default: ""
    },
    /**
    * Allows for multiple files to be uploaded. If false and multiple files are selected,
    * the error banner will be shown
    */
    multiple: {
      type: Boolean,
      default: !1
    },
    /**
    * Accept string for the file types in a comma separated format
    */
    accept: {
      type: String,
      default: ""
    },
    /**
    * Header for the file list
    */
    fileListHeader: {
      type: String,
      default: "Files"
    },
    /**
    * Delete icon for the files
    */
    fileDeleteIcon: {
      type: String,
      default: "delete"
    },
    /**
    * Upload function provided for a callback to be carried out.<br/>
    * If provided, this component will call the callback function while mimicking
    * the upload progress bar. Else, the component will only mimick the upload progress bar
    * and the usage of the component will have to handle the subsequent file handling
    */
    uploadFn: {
      type: Function,
      default: null
    },
    /**
    * Allow duplicate files of the same id defined by UploadableFile for the same
    * name, size, last modified and type
    */
    preventDuplicates: {
      type: Boolean,
      default: !0
    },
    /**
    * Error shown when there are duplicate files
    */
    duplicateFileErrorMessage: {
      type: String,
      default: ""
    },
    /**
    * Error shown when there are invalid file types based on the accept prop
    */
    fileTypeErrorMessage: {
      type: String,
      default: ""
    },
    /**
    * Error shown when multiple files are chosen while the multiple prop is false
    */
    multipleFileErrorMessage: {
      type: String,
      default: ""
    },
    /**
    * Error shown when the file size is provided and files to be uploaded exceed the limit
    */
    fileSizeErrorMessage: {
      type: String,
      default: ""
    },
    /**
    * Text shown in the status badge on file upload success
    */
    fileSuccessText: {
      type: String,
      default: "Success"
    },
    /**
    * File upload error message
    */
    fileUploadErrorText: {
      type: String,
      default: ""
    }
  },
  data: () => ({
    isActive: !1,
    fileAreaTimeout: null,
    fileUploadTimers: [],
    errorMessages: [],
    byteConversion: 1024
  }),
  computed: {
    fileList: {
      /*
      * Computed for the file list shown and emitted on change events
      * This will trigger whenever the file list objects are modified
      */
      get() {
        return this.modelValue;
      },
      set(i) {
        this.$emit("change", i);
      }
    },
    hasHeader() {
      return this.$slots["upload-header"] || this.headerText;
    },
    hasBodyText() {
      return this.$slots["upload-body"] || this.bodyText;
    },
    hasSubtext() {
      return this.$slots["upload-subtext"] || this.subText;
    },
    hasInformationalText() {
      return this.$slots["informational-text"] || this.informationalText;
    },
    hasErrorMessages() {
      return this.errorMessages.length;
    },
    computedContainerClasses() {
      return {
        active: this.isActive
      };
    },
    dropZoneListeners() {
      return {
        dragenter: (i) => {
          i.preventDefault(), this.setActive();
        },
        dragover: (i) => {
          i.preventDefault(), this.setActive();
        },
        dragleave: (i) => {
          i.preventDefault(), this.setInactive();
        },
        drop: (i) => {
          var e;
          i.preventDefault();
          const t = (e = i == null ? void 0 : i.dataTransfer) == null ? void 0 : e.files;
          this.onAddFile(t);
        }
      };
    },
    inputListeners() {
      return {
        change: (i) => {
          var e;
          const t = i;
          if (t.preventDefault(), t != null && t.target) {
            const n = (e = t == null ? void 0 : t.target) == null ? void 0 : e.files;
            this.onAddFile(n), this.preventDuplicates || (t.target.value = "");
          }
        }
      };
    },
    canShowFileList() {
      return this.fileList.length;
    }
  },
  watch: {
    fileList(i) {
      this.hasErrorMessages && !i.length && (this.errorMessages = []);
    }
  },
  methods: {
    setActive() {
      this.isActive = !0, clearTimeout(this.fileAreaTimeout);
    },
    setInactive() {
      this.fileAreaTimeout = setTimeout(() => {
        this.isActive = !1;
      }, 50);
    },
    onAddFile(i) {
      if (this.setInactive(), this.hasErrorMessages && (this.errorMessages = this.errorMessages.filter((t) => t.type === "size")), i.length > 1 && !this.multiple) {
        this.errorMessages.push({
          message: this.multipleFileErrorMessage || "Please drag and drop only one file.",
          type: "multiple"
        });
        return;
      }
      i.forEach(async (t) => {
        const e = new Gx(t);
        !this.isDuplicateFile(e.id) && this.isValidFileType(e.type, e.name) && (this.fileList.push(e), this.isValidFileSize(e.id, e.size) && (this.uploadFn ? await this.handleCallbackUpload(e) : this.handleClientUpload(e)));
      });
    },
    async handleCallbackUpload(i) {
      this.$emit("file-upload-loading", i.file), this.$set(i, "status", "pending");
      try {
        this.$set(i, "loading", !0), this.$set(i, "status", "uploading");
        const t = (e) => {
          i && (e != null && e.progress) && this.$set(i, "loadingProgress", Math.trunc(e.progress * 100));
        };
        await this.uploadFn({
          file: i.file,
          fileList: this.fileList,
          progressCallback: t
        }), this.$set(i, "status", "success"), this.$emit("file-upload-success", i.file);
      } catch (t) {
        this.errorMessages.push({
          message: this.fileUploadErrorText || "Please try uploading the file again.",
          type: "upload",
          fileId: i.id
        }), this.$set(i, "status", "error"), this.$emit("file-upload-error", { error: t, file: i.file });
      } finally {
        this.$set(i, "loadingProgress", 100), this.$set(i, "loading", !1);
      }
    },
    handleClientUpload(i) {
      this.$emit("file-loading", i.file), this.$set(i, "loading", !0), this.$set(i, "status", "pending");
      const t = setInterval(() => {
        if (this.$set(i, "loadingProgress", i.loadingProgress + 20), this.$set(i, "status", "loading"), i.loadingProgress === 100 && (this.$set(i, "loading", !1), this.$set(i, "status", "success"), this.$emit("file-loaded", i.file), clearInterval(t), this.fileUploadTimers.length)) {
          const e = this.fileUploadTimers.indexOf(t);
          e > -1 && this.fileUploadTimers.splice(e, 1);
        }
      }, 250);
      this.fileUploadTimers.push(t);
    },
    handleFileRemove(i, t, e) {
      this.hasErrorMessages && (this.errorMessages = this.errorMessages.filter((n) => n.fileId !== t)), this.fileList.splice(e, 1), this.$emit("file-removed", i), this.fileUploadTimers[e] && (clearInterval(this.fileUploadTimers[e]), this.fileUploadTimers.splice(e, 1));
    },
    isDuplicateFile(i) {
      return this.preventDuplicates && this.fileList.some((t) => t.id === i) ? (this.errorMessages.push({
        message: this.duplicateFileErrorMessage || "This file is already uploaded. Please upload a different file.",
        type: "duplicate"
      }), !0) : !1;
    },
    isValidFileType(i, t) {
      if (this.accept) {
        const e = t.toLowerCase().split("."), n = `.${e[e.length - 1]}`, s = this.accept.toLowerCase().split(",");
        if (!s.includes(i.toLowerCase()) && !s.includes(n))
          return this.errorMessages.push({
            message: this.fileTypeErrorMessage || "This file is not the expected type. Please upload a different file.",
            type: "extension"
          }), !1;
      }
      return !0;
    },
    isValidFileSize(i, t) {
      if (this.fileSize && t) {
        const e = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"], [n, s] = this.fileSize.match(/\D+|\d+/g), r = e.indexOf(s.toUpperCase());
        if (typeof r != "boolean") {
          const a = n * this.byteConversion ** r;
          if (t > a)
            return this.errorMessages.push({
              message: this.fileSizeErrorMessage || `File size exceeds ${n}${s.toUpperCase()}. Please try uploading the file again.`,
              type: "size",
              fileId: i
            }), !1;
        }
      }
      return !0;
    },
    determineFileSize(i) {
      if (i === 0) return "0B";
      const t = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"], e = Math.floor(Math.log(i) / Math.log(this.byteConversion));
      return `${parseFloat((i / this.byteConversion ** e).toFixed(1))} ${t[e]}`;
    }
  }
};
var Jx = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "acv-file-upload" }, [e("div", t._g({ staticClass: "acv-file-upload__container", class: [t.computedContainerClasses] }, t.dropZoneListeners), [e("div", { staticClass: "acv-file-upload__container__content" }, [t.showIcon ? e("div", { staticClass: "acv-file-upload__container__content__icon" }, [t._t("upload-icon", function() {
    return [t.icon ? e("acv-icon", { attrs: { icon: t.icon } }) : e("UploadFileSvg")];
  })], 2) : t._e(), e("div", { staticClass: "acv-file-upload__container__content__body" }, [t.hasHeader ? [e("div", { staticClass: "acv-file-upload__container__content__body__header" }, [t._t("upload-header", function() {
    return [t._v(" " + t._s(t.headerText) + " ")];
  })], 2)] : t._e(), e("div", { staticClass: "acv-file-upload__container__content__body__text" }, [t.hasBodyText ? [t._t("upload-body", function() {
    return [t._v(" " + t._s(t.bodyText) + " ")];
  })] : [t._v(" Drag and drop your file or "), e("span", { staticClass: "tw-text-text-link-on-light" }, [t._v("browse")]), t._v(" from your computer ")]], 2), t.hasSubtext ? [e("div", { staticClass: "acv-file-upload__container__content__body__subtext" }, [t._t("upload-subtext", function() {
    return [t._v(" " + t._s(t.subText) + " ")];
  })], 2)] : t._e()], 2)]), e("acv-base-input", t._g({ attrs: { type: "file", label: "File Upload", title: "", multiple: t.multiple, accept: t.accept, "hide-label": "" } }, t.inputListeners))], 1), t.hasInformationalText ? [e("div", { staticClass: "acv-file-upload__informational" }, [t._t("informational-text", function() {
    return [e("acv-icon", { staticClass: "acv-file-upload__informational__icon", attrs: { icon: "md-info" } }), t._v(" " + t._s(t.informationalText) + " ")];
  })], 2)] : t._e(), t.canShowFileList ? e("div", { staticClass: "acv-file-upload__file-list" }, [t._t("file-list", function() {
    return [e("p", { staticClass: "acv-file-upload__file-list__header" }, [t._v(" " + t._s(t.fileListHeader) + " ")]), e("div", { staticClass: "acv-file-upload__file-list__listings" }, t._l(t.fileList, function({
      id: n,
      status: s,
      loading: r,
      loadingProgress: a,
      file: o
    }, l) {
      return e("div", { key: l, staticClass: "acv-file-upload__file-list__listings__file" }, [e("div", { staticClass: "acv-file-upload__file-list__listings__file__details" }, [e("div", { staticClass: "acv-file-upload__file-list__listings__file__details__name" }, [t._v(" " + t._s(o.name) + " "), s === "success" ? e("acv-status-badge", { attrs: { variant: "success", "icon-type": "check" } }, [t._v(" " + t._s(t.fileSuccessText) + " ")]) : t._e()], 1), r ? [e("div", { staticClass: "acv-file-upload__file-list__listings__file__details__progress" }, [e("acv-progress-bar", { attrs: { "background-opacity": 1, height: 8, "margin-top": 4, value: a } })], 1)] : [e("div", { staticClass: "acv-file-upload__file-list__listings__file__details__size" }, [t._v(" " + t._s(t.determineFileSize(o.size)) + " ")])]], 2), e("div", { staticClass: "acv-file-upload__file-list__listings__file__delete" }, [e("acv-icon-button", { attrs: { "icon-type": t.fileDeleteIcon, "show-tooltip": !1 }, on: { click: function(c) {
        return t.handleFileRemove(o, n, l);
      } } })], 1)]);
    }), 0)];
  }, { fileList: t.fileList })], 2) : t._e(), t.hasErrorMessages ? e("div", { staticClass: "acv-file-upload__error-container" }, [t._t("error", function() {
    return [e("acv-banner", { attrs: { variant: "error" } }, [e("ul", { staticClass: "error-list" }, t._l(t.errorMessages, function(n, s) {
      return e("li", { key: s, staticClass: "error-list__error" }, [t._v(" " + t._s(n.message) + " ")]);
    }), 0)])];
  }, { fileList: t.fileList, errors: t.errorMessages })], 2) : t._e()], 2);
}, qx = [], tC = /* @__PURE__ */ U(
  Qx,
  Jx,
  qx,
  !1,
  null,
  "60dccab5"
);
const eC = tC.exports;
/*!
 * Chart.js v3.9.1
 * https://www.chartjs.org
 * (c) 2022 Chart.js Contributors
 * Released under the MIT License
 */
function Si() {
}
const iC = /* @__PURE__ */ function() {
  let i = 0;
  return function() {
    return i++;
  };
}();
function kt(i) {
  return i === null || typeof i > "u";
}
function $t(i) {
  if (Array.isArray && Array.isArray(i))
    return !0;
  const t = Object.prototype.toString.call(i);
  return t.slice(0, 7) === "[object" && t.slice(-6) === "Array]";
}
function St(i) {
  return i !== null && Object.prototype.toString.call(i) === "[object Object]";
}
const ee = (i) => (typeof i == "number" || i instanceof Number) && isFinite(+i);
function Ve(i, t) {
  return ee(i) ? i : t;
}
function yt(i, t) {
  return typeof i > "u" ? t : i;
}
const nC = (i, t) => typeof i == "string" && i.endsWith("%") ? parseFloat(i) / 100 : i / t, Ip = (i, t) => typeof i == "string" && i.endsWith("%") ? parseFloat(i) / 100 * t : +i;
function Dt(i, t, e) {
  if (i && typeof i.call == "function")
    return i.apply(e, t);
}
function Ot(i, t, e, n) {
  let s, r, a;
  if ($t(i))
    for (r = i.length, s = 0; s < r; s++)
      t.call(e, i[s], s);
  else if (St(i))
    for (a = Object.keys(i), r = a.length, s = 0; s < r; s++)
      t.call(e, i[a[s]], a[s]);
}
function ha(i, t) {
  let e, n, s, r;
  if (!i || !t || i.length !== t.length)
    return !1;
  for (e = 0, n = i.length; e < n; ++e)
    if (s = i[e], r = t[e], s.datasetIndex !== r.datasetIndex || s.index !== r.index)
      return !1;
  return !0;
}
function fa(i) {
  if ($t(i))
    return i.map(fa);
  if (St(i)) {
    const t = /* @__PURE__ */ Object.create(null), e = Object.keys(i), n = e.length;
    let s = 0;
    for (; s < n; ++s)
      t[e[s]] = fa(i[e[s]]);
    return t;
  }
  return i;
}
function Ep(i) {
  return ["__proto__", "prototype", "constructor"].indexOf(i) === -1;
}
function sC(i, t, e, n) {
  if (!Ep(i))
    return;
  const s = t[i], r = e[i];
  St(s) && St(r) ? Us(s, r, n) : t[i] = fa(r);
}
function Us(i, t, e) {
  const n = $t(t) ? t : [t], s = n.length;
  if (!St(i))
    return i;
  e = e || {};
  const r = e.merger || sC;
  for (let a = 0; a < s; ++a) {
    if (t = n[a], !St(t))
      continue;
    const o = Object.keys(t);
    for (let l = 0, c = o.length; l < c; ++l)
      r(o[l], i, t, e);
  }
  return i;
}
function Ps(i, t) {
  return Us(i, t, { merger: rC });
}
function rC(i, t, e) {
  if (!Ep(i))
    return;
  const n = t[i], s = e[i];
  St(n) && St(s) ? Ps(n, s) : Object.prototype.hasOwnProperty.call(t, i) || (t[i] = fa(s));
}
const Nu = {
  "": (i) => i,
  x: (i) => i.x,
  y: (i) => i.y
};
function qi(i, t) {
  return (Nu[t] || (Nu[t] = aC(t)))(i);
}
function aC(i) {
  const t = oC(i);
  return (e) => {
    for (const n of t) {
      if (n === "")
        break;
      e = e && e[n];
    }
    return e;
  };
}
function oC(i) {
  const t = i.split("."), e = [];
  let n = "";
  for (const s of t)
    n += s, n.endsWith("\\") ? n = n.slice(0, -1) + "." : (e.push(n), n = "");
  return e;
}
function oc(i) {
  return i.charAt(0).toUpperCase() + i.slice(1);
}
const Ze = (i) => typeof i < "u", tn = (i) => typeof i == "function", Hu = (i, t) => {
  if (i.size !== t.size)
    return !1;
  for (const e of i)
    if (!t.has(e))
      return !1;
  return !0;
};
function lC(i) {
  return i.type === "mouseup" || i.type === "click" || i.type === "contextmenu";
}
const Bt = Math.PI, Tt = 2 * Bt, cC = Tt + Bt, pa = Number.POSITIVE_INFINITY, uC = Bt / 180, Wt = Bt / 2, As = Bt / 4, Vu = Bt * 2 / 3, ze = Math.log10, vi = Math.sign;
function zu(i) {
  const t = Math.round(i);
  i = Ls(i, t, i / 1e3) ? t : i;
  const e = Math.pow(10, Math.floor(ze(i))), n = i / e;
  return (n <= 1 ? 1 : n <= 2 ? 2 : n <= 5 ? 5 : 10) * e;
}
function dC(i) {
  const t = [], e = Math.sqrt(i);
  let n;
  for (n = 1; n < e; n++)
    i % n === 0 && (t.push(n), t.push(i / n));
  return e === (e | 0) && t.push(e), t.sort((s, r) => s - r).pop(), t;
}
function ns(i) {
  return !isNaN(parseFloat(i)) && isFinite(i);
}
function Ls(i, t, e) {
  return Math.abs(i - t) < e;
}
function hC(i, t) {
  const e = Math.round(i);
  return e - t <= i && e + t >= i;
}
function $p(i, t, e) {
  let n, s, r;
  for (n = 0, s = i.length; n < s; n++)
    r = i[n][e], isNaN(r) || (t.min = Math.min(t.min, r), t.max = Math.max(t.max, r));
}
function qe(i) {
  return i * (Bt / 180);
}
function lc(i) {
  return i * (180 / Bt);
}
function ju(i) {
  if (!ee(i))
    return;
  let t = 1, e = 0;
  for (; Math.round(i * t) / t !== i; )
    t *= 10, e++;
  return e;
}
function Bp(i, t) {
  const e = t.x - i.x, n = t.y - i.y, s = Math.sqrt(e * e + n * n);
  let r = Math.atan2(n, e);
  return r < -0.5 * Bt && (r += Tt), {
    angle: r,
    distance: s
  };
}
function ul(i, t) {
  return Math.sqrt(Math.pow(t.x - i.x, 2) + Math.pow(t.y - i.y, 2));
}
function fC(i, t) {
  return (i - t + cC) % Tt - Bt;
}
function Qe(i) {
  return (i % Tt + Tt) % Tt;
}
function Zs(i, t, e, n) {
  const s = Qe(i), r = Qe(t), a = Qe(e), o = Qe(r - s), l = Qe(a - s), c = Qe(s - r), u = Qe(s - a);
  return s === r || s === a || n && r === a || o > l && c < u;
}
function ae(i, t, e) {
  return Math.max(t, Math.min(e, i));
}
function pC(i) {
  return ae(i, -32768, 32767);
}
function Yi(i, t, e, n = 1e-6) {
  return i >= Math.min(t, e) - n && i <= Math.max(t, e) + n;
}
function cc(i, t, e) {
  e = e || ((a) => i[a] < t);
  let n = i.length - 1, s = 0, r;
  for (; n - s > 1; )
    r = s + n >> 1, e(r) ? s = r : n = r;
  return { lo: s, hi: n };
}
const mn = (i, t, e, n) => cc(i, e, n ? (s) => i[s][t] <= e : (s) => i[s][t] < e), gC = (i, t, e) => cc(i, e, (n) => i[n][t] >= e);
function mC(i, t, e) {
  let n = 0, s = i.length;
  for (; n < s && i[n] < t; )
    n++;
  for (; s > n && i[s - 1] > e; )
    s--;
  return n > 0 || s < i.length ? i.slice(n, s) : i;
}
const Rp = ["push", "pop", "shift", "splice", "unshift"];
function vC(i, t) {
  if (i._chartjs) {
    i._chartjs.listeners.push(t);
    return;
  }
  Object.defineProperty(i, "_chartjs", {
    configurable: !0,
    enumerable: !1,
    value: {
      listeners: [t]
    }
  }), Rp.forEach((e) => {
    const n = "_onData" + oc(e), s = i[e];
    Object.defineProperty(i, e, {
      configurable: !0,
      enumerable: !1,
      value(...r) {
        const a = s.apply(this, r);
        return i._chartjs.listeners.forEach((o) => {
          typeof o[n] == "function" && o[n](...r);
        }), a;
      }
    });
  });
}
function Wu(i, t) {
  const e = i._chartjs;
  if (!e)
    return;
  const n = e.listeners, s = n.indexOf(t);
  s !== -1 && n.splice(s, 1), !(n.length > 0) && (Rp.forEach((r) => {
    delete i[r];
  }), delete i._chartjs);
}
function Fp(i) {
  const t = /* @__PURE__ */ new Set();
  let e, n;
  for (e = 0, n = i.length; e < n; ++e)
    t.add(i[e]);
  return t.size === n ? i : Array.from(t);
}
const Np = function() {
  return typeof window > "u" ? function(i) {
    return i();
  } : window.requestAnimationFrame;
}();
function Hp(i, t, e) {
  const n = e || ((a) => Array.prototype.slice.call(a));
  let s = !1, r = [];
  return function(...a) {
    r = n(a), s || (s = !0, Np.call(window, () => {
      s = !1, i.apply(t, r);
    }));
  };
}
function AC(i, t) {
  let e;
  return function(...n) {
    return t ? (clearTimeout(e), e = setTimeout(i, t, n)) : i.apply(this, n), t;
  };
}
const uc = (i) => i === "start" ? "left" : i === "end" ? "right" : "center", se = (i, t, e) => i === "start" ? t : i === "end" ? e : (t + e) / 2, bC = (i, t, e, n) => i === (n ? "left" : "right") ? e : i === "center" ? (t + e) / 2 : t;
function Vp(i, t, e) {
  const n = t.length;
  let s = 0, r = n;
  if (i._sorted) {
    const { iScale: a, _parsed: o } = i, l = a.axis, { min: c, max: u, minDefined: d, maxDefined: h } = a.getUserBounds();
    d && (s = ae(
      Math.min(
        mn(o, a.axis, c).lo,
        e ? n : mn(t, l, a.getPixelForValue(c)).lo
      ),
      0,
      n - 1
    )), h ? r = ae(
      Math.max(
        mn(o, a.axis, u, !0).hi + 1,
        e ? 0 : mn(t, l, a.getPixelForValue(u), !0).hi + 1
      ),
      s,
      n
    ) - s : r = n - s;
  }
  return { start: s, count: r };
}
function zp(i) {
  const { xScale: t, yScale: e, _scaleRanges: n } = i, s = {
    xmin: t.min,
    xmax: t.max,
    ymin: e.min,
    ymax: e.max
  };
  if (!n)
    return i._scaleRanges = s, !0;
  const r = n.xmin !== t.min || n.xmax !== t.max || n.ymin !== e.min || n.ymax !== e.max;
  return Object.assign(n, s), r;
}
const Tr = (i) => i === 0 || i === 1, Yu = (i, t, e) => -(Math.pow(2, 10 * (i -= 1)) * Math.sin((i - t) * Tt / e)), Uu = (i, t, e) => Math.pow(2, -10 * i) * Math.sin((i - t) * Tt / e) + 1, Is = {
  linear: (i) => i,
  easeInQuad: (i) => i * i,
  easeOutQuad: (i) => -i * (i - 2),
  easeInOutQuad: (i) => (i /= 0.5) < 1 ? 0.5 * i * i : -0.5 * (--i * (i - 2) - 1),
  easeInCubic: (i) => i * i * i,
  easeOutCubic: (i) => (i -= 1) * i * i + 1,
  easeInOutCubic: (i) => (i /= 0.5) < 1 ? 0.5 * i * i * i : 0.5 * ((i -= 2) * i * i + 2),
  easeInQuart: (i) => i * i * i * i,
  easeOutQuart: (i) => -((i -= 1) * i * i * i - 1),
  easeInOutQuart: (i) => (i /= 0.5) < 1 ? 0.5 * i * i * i * i : -0.5 * ((i -= 2) * i * i * i - 2),
  easeInQuint: (i) => i * i * i * i * i,
  easeOutQuint: (i) => (i -= 1) * i * i * i * i + 1,
  easeInOutQuint: (i) => (i /= 0.5) < 1 ? 0.5 * i * i * i * i * i : 0.5 * ((i -= 2) * i * i * i * i + 2),
  easeInSine: (i) => -Math.cos(i * Wt) + 1,
  easeOutSine: (i) => Math.sin(i * Wt),
  easeInOutSine: (i) => -0.5 * (Math.cos(Bt * i) - 1),
  easeInExpo: (i) => i === 0 ? 0 : Math.pow(2, 10 * (i - 1)),
  easeOutExpo: (i) => i === 1 ? 1 : -Math.pow(2, -10 * i) + 1,
  easeInOutExpo: (i) => Tr(i) ? i : i < 0.5 ? 0.5 * Math.pow(2, 10 * (i * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (i * 2 - 1)) + 2),
  easeInCirc: (i) => i >= 1 ? i : -(Math.sqrt(1 - i * i) - 1),
  easeOutCirc: (i) => Math.sqrt(1 - (i -= 1) * i),
  easeInOutCirc: (i) => (i /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - i * i) - 1) : 0.5 * (Math.sqrt(1 - (i -= 2) * i) + 1),
  easeInElastic: (i) => Tr(i) ? i : Yu(i, 0.075, 0.3),
  easeOutElastic: (i) => Tr(i) ? i : Uu(i, 0.075, 0.3),
  easeInOutElastic(i) {
    return Tr(i) ? i : i < 0.5 ? 0.5 * Yu(i * 2, 0.1125, 0.45) : 0.5 + 0.5 * Uu(i * 2 - 1, 0.1125, 0.45);
  },
  easeInBack(i) {
    return i * i * ((1.70158 + 1) * i - 1.70158);
  },
  easeOutBack(i) {
    return (i -= 1) * i * ((1.70158 + 1) * i + 1.70158) + 1;
  },
  easeInOutBack(i) {
    let t = 1.70158;
    return (i /= 0.5) < 1 ? 0.5 * (i * i * (((t *= 1.525) + 1) * i - t)) : 0.5 * ((i -= 2) * i * (((t *= 1.525) + 1) * i + t) + 2);
  },
  easeInBounce: (i) => 1 - Is.easeOutBounce(1 - i),
  easeOutBounce(i) {
    return i < 1 / 2.75 ? 7.5625 * i * i : i < 2 / 2.75 ? 7.5625 * (i -= 1.5 / 2.75) * i + 0.75 : i < 2.5 / 2.75 ? 7.5625 * (i -= 2.25 / 2.75) * i + 0.9375 : 7.5625 * (i -= 2.625 / 2.75) * i + 0.984375;
  },
  easeInOutBounce: (i) => i < 0.5 ? Is.easeInBounce(i * 2) * 0.5 : Is.easeOutBounce(i * 2 - 1) * 0.5 + 0.5
};
/*!
 * @kurkle/color v0.2.1
 * https://github.com/kurkle/color#readme
 * (c) 2022 Jukka Kurkela
 * Released under the MIT License
 */
function cr(i) {
  return i + 0.5 | 0;
}
const Ui = (i, t, e) => Math.max(Math.min(i, e), t);
function ks(i) {
  return Ui(cr(i * 2.55), 0, 255);
}
function Xi(i) {
  return Ui(cr(i * 255), 0, 255);
}
function Li(i) {
  return Ui(cr(i / 2.55) / 100, 0, 1);
}
function Zu(i) {
  return Ui(cr(i * 100), 0, 100);
}
const Ne = { 0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9, A: 10, B: 11, C: 12, D: 13, E: 14, F: 15, a: 10, b: 11, c: 12, d: 13, e: 14, f: 15 }, dl = [..."0123456789ABCDEF"], yC = (i) => dl[i & 15], _C = (i) => dl[(i & 240) >> 4] + dl[i & 15], Dr = (i) => (i & 240) >> 4 === (i & 15), xC = (i) => Dr(i.r) && Dr(i.g) && Dr(i.b) && Dr(i.a);
function CC(i) {
  var t = i.length, e;
  return i[0] === "#" && (t === 4 || t === 5 ? e = {
    r: 255 & Ne[i[1]] * 17,
    g: 255 & Ne[i[2]] * 17,
    b: 255 & Ne[i[3]] * 17,
    a: t === 5 ? Ne[i[4]] * 17 : 255
  } : (t === 7 || t === 9) && (e = {
    r: Ne[i[1]] << 4 | Ne[i[2]],
    g: Ne[i[3]] << 4 | Ne[i[4]],
    b: Ne[i[5]] << 4 | Ne[i[6]],
    a: t === 9 ? Ne[i[7]] << 4 | Ne[i[8]] : 255
  })), e;
}
const SC = (i, t) => i < 255 ? t(i) : "";
function wC(i) {
  var t = xC(i) ? yC : _C;
  return i ? "#" + t(i.r) + t(i.g) + t(i.b) + SC(i.a, t) : void 0;
}
const kC = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function jp(i, t, e) {
  const n = t * Math.min(e, 1 - e), s = (r, a = (r + i / 30) % 12) => e - n * Math.max(Math.min(a - 3, 9 - a, 1), -1);
  return [s(0), s(8), s(4)];
}
function OC(i, t, e) {
  const n = (s, r = (s + i / 60) % 6) => e - e * t * Math.max(Math.min(r, 4 - r, 1), 0);
  return [n(5), n(3), n(1)];
}
function MC(i, t, e) {
  const n = jp(i, 1, 0.5);
  let s;
  for (t + e > 1 && (s = 1 / (t + e), t *= s, e *= s), s = 0; s < 3; s++)
    n[s] *= 1 - t - e, n[s] += t;
  return n;
}
function TC(i, t, e, n, s) {
  return i === s ? (t - e) / n + (t < e ? 6 : 0) : t === s ? (e - i) / n + 2 : (i - t) / n + 4;
}
function dc(i) {
  const e = i.r / 255, n = i.g / 255, s = i.b / 255, r = Math.max(e, n, s), a = Math.min(e, n, s), o = (r + a) / 2;
  let l, c, u;
  return r !== a && (u = r - a, c = o > 0.5 ? u / (2 - r - a) : u / (r + a), l = TC(e, n, s, u, r), l = l * 60 + 0.5), [l | 0, c || 0, o];
}
function hc(i, t, e, n) {
  return (Array.isArray(t) ? i(t[0], t[1], t[2]) : i(t, e, n)).map(Xi);
}
function fc(i, t, e) {
  return hc(jp, i, t, e);
}
function DC(i, t, e) {
  return hc(MC, i, t, e);
}
function PC(i, t, e) {
  return hc(OC, i, t, e);
}
function Wp(i) {
  return (i % 360 + 360) % 360;
}
function LC(i) {
  const t = kC.exec(i);
  let e = 255, n;
  if (!t)
    return;
  t[5] !== n && (e = t[6] ? ks(+t[5]) : Xi(+t[5]));
  const s = Wp(+t[2]), r = +t[3] / 100, a = +t[4] / 100;
  return t[1] === "hwb" ? n = DC(s, r, a) : t[1] === "hsv" ? n = PC(s, r, a) : n = fc(s, r, a), {
    r: n[0],
    g: n[1],
    b: n[2],
    a: e
  };
}
function IC(i, t) {
  var e = dc(i);
  e[0] = Wp(e[0] + t), e = fc(e), i.r = e[0], i.g = e[1], i.b = e[2];
}
function EC(i) {
  if (!i)
    return;
  const t = dc(i), e = t[0], n = Zu(t[1]), s = Zu(t[2]);
  return i.a < 255 ? `hsla(${e}, ${n}%, ${s}%, ${Li(i.a)})` : `hsl(${e}, ${n}%, ${s}%)`;
}
const Gu = {
  x: "dark",
  Z: "light",
  Y: "re",
  X: "blu",
  W: "gr",
  V: "medium",
  U: "slate",
  A: "ee",
  T: "ol",
  S: "or",
  B: "ra",
  C: "lateg",
  D: "ights",
  R: "in",
  Q: "turquois",
  E: "hi",
  P: "ro",
  O: "al",
  N: "le",
  M: "de",
  L: "yello",
  F: "en",
  K: "ch",
  G: "arks",
  H: "ea",
  I: "ightg",
  J: "wh"
}, Ku = {
  OiceXe: "f0f8ff",
  antiquewEte: "faebd7",
  aqua: "ffff",
  aquamarRe: "7fffd4",
  azuY: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "0",
  blanKedOmond: "ffebcd",
  Xe: "ff",
  XeviTet: "8a2be2",
  bPwn: "a52a2a",
  burlywood: "deb887",
  caMtXe: "5f9ea0",
  KartYuse: "7fff00",
  KocTate: "d2691e",
  cSO: "ff7f50",
  cSnflowerXe: "6495ed",
  cSnsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "ffff",
  xXe: "8b",
  xcyan: "8b8b",
  xgTMnPd: "b8860b",
  xWay: "a9a9a9",
  xgYF: "6400",
  xgYy: "a9a9a9",
  xkhaki: "bdb76b",
  xmagFta: "8b008b",
  xTivegYF: "556b2f",
  xSange: "ff8c00",
  xScEd: "9932cc",
  xYd: "8b0000",
  xsOmon: "e9967a",
  xsHgYF: "8fbc8f",
  xUXe: "483d8b",
  xUWay: "2f4f4f",
  xUgYy: "2f4f4f",
  xQe: "ced1",
  xviTet: "9400d3",
  dAppRk: "ff1493",
  dApskyXe: "bfff",
  dimWay: "696969",
  dimgYy: "696969",
  dodgerXe: "1e90ff",
  fiYbrick: "b22222",
  flSOwEte: "fffaf0",
  foYstWAn: "228b22",
  fuKsia: "ff00ff",
  gaRsbSo: "dcdcdc",
  ghostwEte: "f8f8ff",
  gTd: "ffd700",
  gTMnPd: "daa520",
  Way: "808080",
  gYF: "8000",
  gYFLw: "adff2f",
  gYy: "808080",
  honeyMw: "f0fff0",
  hotpRk: "ff69b4",
  RdianYd: "cd5c5c",
  Rdigo: "4b0082",
  ivSy: "fffff0",
  khaki: "f0e68c",
  lavFMr: "e6e6fa",
  lavFMrXsh: "fff0f5",
  lawngYF: "7cfc00",
  NmoncEffon: "fffacd",
  ZXe: "add8e6",
  ZcSO: "f08080",
  Zcyan: "e0ffff",
  ZgTMnPdLw: "fafad2",
  ZWay: "d3d3d3",
  ZgYF: "90ee90",
  ZgYy: "d3d3d3",
  ZpRk: "ffb6c1",
  ZsOmon: "ffa07a",
  ZsHgYF: "20b2aa",
  ZskyXe: "87cefa",
  ZUWay: "778899",
  ZUgYy: "778899",
  ZstAlXe: "b0c4de",
  ZLw: "ffffe0",
  lime: "ff00",
  limegYF: "32cd32",
  lRF: "faf0e6",
  magFta: "ff00ff",
  maPon: "800000",
  VaquamarRe: "66cdaa",
  VXe: "cd",
  VScEd: "ba55d3",
  VpurpN: "9370db",
  VsHgYF: "3cb371",
  VUXe: "7b68ee",
  VsprRggYF: "fa9a",
  VQe: "48d1cc",
  VviTetYd: "c71585",
  midnightXe: "191970",
  mRtcYam: "f5fffa",
  mistyPse: "ffe4e1",
  moccasR: "ffe4b5",
  navajowEte: "ffdead",
  navy: "80",
  Tdlace: "fdf5e6",
  Tive: "808000",
  TivedBb: "6b8e23",
  Sange: "ffa500",
  SangeYd: "ff4500",
  ScEd: "da70d6",
  pOegTMnPd: "eee8aa",
  pOegYF: "98fb98",
  pOeQe: "afeeee",
  pOeviTetYd: "db7093",
  papayawEp: "ffefd5",
  pHKpuff: "ffdab9",
  peru: "cd853f",
  pRk: "ffc0cb",
  plum: "dda0dd",
  powMrXe: "b0e0e6",
  purpN: "800080",
  YbeccapurpN: "663399",
  Yd: "ff0000",
  Psybrown: "bc8f8f",
  PyOXe: "4169e1",
  saddNbPwn: "8b4513",
  sOmon: "fa8072",
  sandybPwn: "f4a460",
  sHgYF: "2e8b57",
  sHshell: "fff5ee",
  siFna: "a0522d",
  silver: "c0c0c0",
  skyXe: "87ceeb",
  UXe: "6a5acd",
  UWay: "708090",
  UgYy: "708090",
  snow: "fffafa",
  sprRggYF: "ff7f",
  stAlXe: "4682b4",
  tan: "d2b48c",
  teO: "8080",
  tEstN: "d8bfd8",
  tomato: "ff6347",
  Qe: "40e0d0",
  viTet: "ee82ee",
  JHt: "f5deb3",
  wEte: "ffffff",
  wEtesmoke: "f5f5f5",
  Lw: "ffff00",
  LwgYF: "9acd32"
};
function $C() {
  const i = {}, t = Object.keys(Ku), e = Object.keys(Gu);
  let n, s, r, a, o;
  for (n = 0; n < t.length; n++) {
    for (a = o = t[n], s = 0; s < e.length; s++)
      r = e[s], o = o.replace(r, Gu[r]);
    r = parseInt(Ku[a], 16), i[o] = [r >> 16 & 255, r >> 8 & 255, r & 255];
  }
  return i;
}
let Pr;
function BC(i) {
  Pr || (Pr = $C(), Pr.transparent = [0, 0, 0, 0]);
  const t = Pr[i.toLowerCase()];
  return t && {
    r: t[0],
    g: t[1],
    b: t[2],
    a: t.length === 4 ? t[3] : 255
  };
}
const RC = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function FC(i) {
  const t = RC.exec(i);
  let e = 255, n, s, r;
  if (t) {
    if (t[7] !== n) {
      const a = +t[7];
      e = t[8] ? ks(a) : Ui(a * 255, 0, 255);
    }
    return n = +t[1], s = +t[3], r = +t[5], n = 255 & (t[2] ? ks(n) : Ui(n, 0, 255)), s = 255 & (t[4] ? ks(s) : Ui(s, 0, 255)), r = 255 & (t[6] ? ks(r) : Ui(r, 0, 255)), {
      r: n,
      g: s,
      b: r,
      a: e
    };
  }
}
function NC(i) {
  return i && (i.a < 255 ? `rgba(${i.r}, ${i.g}, ${i.b}, ${Li(i.a)})` : `rgb(${i.r}, ${i.g}, ${i.b})`);
}
const Mo = (i) => i <= 31308e-7 ? i * 12.92 : Math.pow(i, 1 / 2.4) * 1.055 - 0.055, Fn = (i) => i <= 0.04045 ? i / 12.92 : Math.pow((i + 0.055) / 1.055, 2.4);
function HC(i, t, e) {
  const n = Fn(Li(i.r)), s = Fn(Li(i.g)), r = Fn(Li(i.b));
  return {
    r: Xi(Mo(n + e * (Fn(Li(t.r)) - n))),
    g: Xi(Mo(s + e * (Fn(Li(t.g)) - s))),
    b: Xi(Mo(r + e * (Fn(Li(t.b)) - r))),
    a: i.a + e * (t.a - i.a)
  };
}
function Lr(i, t, e) {
  if (i) {
    let n = dc(i);
    n[t] = Math.max(0, Math.min(n[t] + n[t] * e, t === 0 ? 360 : 1)), n = fc(n), i.r = n[0], i.g = n[1], i.b = n[2];
  }
}
function Yp(i, t) {
  return i && Object.assign(t || {}, i);
}
function Xu(i) {
  var t = { r: 0, g: 0, b: 0, a: 255 };
  return Array.isArray(i) ? i.length >= 3 && (t = { r: i[0], g: i[1], b: i[2], a: 255 }, i.length > 3 && (t.a = Xi(i[3]))) : (t = Yp(i, { r: 0, g: 0, b: 0, a: 1 }), t.a = Xi(t.a)), t;
}
function VC(i) {
  return i.charAt(0) === "r" ? FC(i) : LC(i);
}
class ga {
  constructor(t) {
    if (t instanceof ga)
      return t;
    const e = typeof t;
    let n;
    e === "object" ? n = Xu(t) : e === "string" && (n = CC(t) || BC(t) || VC(t)), this._rgb = n, this._valid = !!n;
  }
  get valid() {
    return this._valid;
  }
  get rgb() {
    var t = Yp(this._rgb);
    return t && (t.a = Li(t.a)), t;
  }
  set rgb(t) {
    this._rgb = Xu(t);
  }
  rgbString() {
    return this._valid ? NC(this._rgb) : void 0;
  }
  hexString() {
    return this._valid ? wC(this._rgb) : void 0;
  }
  hslString() {
    return this._valid ? EC(this._rgb) : void 0;
  }
  mix(t, e) {
    if (t) {
      const n = this.rgb, s = t.rgb;
      let r;
      const a = e === r ? 0.5 : e, o = 2 * a - 1, l = n.a - s.a, c = ((o * l === -1 ? o : (o + l) / (1 + o * l)) + 1) / 2;
      r = 1 - c, n.r = 255 & c * n.r + r * s.r + 0.5, n.g = 255 & c * n.g + r * s.g + 0.5, n.b = 255 & c * n.b + r * s.b + 0.5, n.a = a * n.a + (1 - a) * s.a, this.rgb = n;
    }
    return this;
  }
  interpolate(t, e) {
    return t && (this._rgb = HC(this._rgb, t._rgb, e)), this;
  }
  clone() {
    return new ga(this.rgb);
  }
  alpha(t) {
    return this._rgb.a = Xi(t), this;
  }
  clearer(t) {
    const e = this._rgb;
    return e.a *= 1 - t, this;
  }
  greyscale() {
    const t = this._rgb, e = cr(t.r * 0.3 + t.g * 0.59 + t.b * 0.11);
    return t.r = t.g = t.b = e, this;
  }
  opaquer(t) {
    const e = this._rgb;
    return e.a *= 1 + t, this;
  }
  negate() {
    const t = this._rgb;
    return t.r = 255 - t.r, t.g = 255 - t.g, t.b = 255 - t.b, this;
  }
  lighten(t) {
    return Lr(this._rgb, 2, t), this;
  }
  darken(t) {
    return Lr(this._rgb, 2, -t), this;
  }
  saturate(t) {
    return Lr(this._rgb, 1, t), this;
  }
  desaturate(t) {
    return Lr(this._rgb, 1, -t), this;
  }
  rotate(t) {
    return IC(this._rgb, t), this;
  }
}
function Up(i) {
  return new ga(i);
}
function Zp(i) {
  if (i && typeof i == "object") {
    const t = i.toString();
    return t === "[object CanvasPattern]" || t === "[object CanvasGradient]";
  }
  return !1;
}
function Qu(i) {
  return Zp(i) ? i : Up(i);
}
function To(i) {
  return Zp(i) ? i : Up(i).saturate(0.5).darken(0.1).hexString();
}
const wn = /* @__PURE__ */ Object.create(null), hl = /* @__PURE__ */ Object.create(null);
function Es(i, t) {
  if (!t)
    return i;
  const e = t.split(".");
  for (let n = 0, s = e.length; n < s; ++n) {
    const r = e[n];
    i = i[r] || (i[r] = /* @__PURE__ */ Object.create(null));
  }
  return i;
}
function Do(i, t, e) {
  return typeof t == "string" ? Us(Es(i, t), e) : Us(Es(i, ""), t);
}
class zC {
  constructor(t) {
    this.animation = void 0, this.backgroundColor = "rgba(0,0,0,0.1)", this.borderColor = "rgba(0,0,0,0.1)", this.color = "#666", this.datasets = {}, this.devicePixelRatio = (e) => e.chart.platform.getDevicePixelRatio(), this.elements = {}, this.events = [
      "mousemove",
      "mouseout",
      "click",
      "touchstart",
      "touchmove"
    ], this.font = {
      family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
      size: 12,
      style: "normal",
      lineHeight: 1.2,
      weight: null
    }, this.hover = {}, this.hoverBackgroundColor = (e, n) => To(n.backgroundColor), this.hoverBorderColor = (e, n) => To(n.borderColor), this.hoverColor = (e, n) => To(n.color), this.indexAxis = "x", this.interaction = {
      mode: "nearest",
      intersect: !0,
      includeInvisible: !1
    }, this.maintainAspectRatio = !0, this.onHover = null, this.onClick = null, this.parsing = !0, this.plugins = {}, this.responsive = !0, this.scale = void 0, this.scales = {}, this.showLine = !0, this.drawActiveElementsOnTop = !0, this.describe(t);
  }
  set(t, e) {
    return Do(this, t, e);
  }
  get(t) {
    return Es(this, t);
  }
  describe(t, e) {
    return Do(hl, t, e);
  }
  override(t, e) {
    return Do(wn, t, e);
  }
  route(t, e, n, s) {
    const r = Es(this, t), a = Es(this, n), o = "_" + e;
    Object.defineProperties(r, {
      [o]: {
        value: r[e],
        writable: !0
      },
      [e]: {
        enumerable: !0,
        get() {
          const l = this[o], c = a[s];
          return St(l) ? Object.assign({}, c, l) : yt(l, c);
        },
        set(l) {
          this[o] = l;
        }
      }
    });
  }
}
var Ct = new zC({
  _scriptable: (i) => !i.startsWith("on"),
  _indexable: (i) => i !== "events",
  hover: {
    _fallback: "interaction"
  },
  interaction: {
    _scriptable: !1,
    _indexable: !1
  }
});
function jC(i) {
  return !i || kt(i.size) || kt(i.family) ? null : (i.style ? i.style + " " : "") + (i.weight ? i.weight + " " : "") + i.size + "px " + i.family;
}
function ma(i, t, e, n, s) {
  let r = t[s];
  return r || (r = t[s] = i.measureText(s).width, e.push(s)), r > n && (n = r), n;
}
function WC(i, t, e, n) {
  n = n || {};
  let s = n.data = n.data || {}, r = n.garbageCollect = n.garbageCollect || [];
  n.font !== t && (s = n.data = {}, r = n.garbageCollect = [], n.font = t), i.save(), i.font = t;
  let a = 0;
  const o = e.length;
  let l, c, u, d, h;
  for (l = 0; l < o; l++)
    if (d = e[l], d != null && $t(d) !== !0)
      a = ma(i, s, r, a, d);
    else if ($t(d))
      for (c = 0, u = d.length; c < u; c++)
        h = d[c], h != null && !$t(h) && (a = ma(i, s, r, a, h));
  i.restore();
  const f = r.length / 2;
  if (f > e.length) {
    for (l = 0; l < f; l++)
      delete s[r[l]];
    r.splice(0, f);
  }
  return a;
}
function cn(i, t, e) {
  const n = i.currentDevicePixelRatio, s = e !== 0 ? Math.max(e / 2, 0.5) : 0;
  return Math.round((t - s) * n) / n + s;
}
function Ju(i, t) {
  t = t || i.getContext("2d"), t.save(), t.resetTransform(), t.clearRect(0, 0, i.width, i.height), t.restore();
}
function fl(i, t, e, n) {
  Gp(i, t, e, n, null);
}
function Gp(i, t, e, n, s) {
  let r, a, o, l, c, u;
  const d = t.pointStyle, h = t.rotation, f = t.radius;
  let p = (h || 0) * uC;
  if (d && typeof d == "object" && (r = d.toString(), r === "[object HTMLImageElement]" || r === "[object HTMLCanvasElement]")) {
    i.save(), i.translate(e, n), i.rotate(p), i.drawImage(d, -d.width / 2, -d.height / 2, d.width, d.height), i.restore();
    return;
  }
  if (!(isNaN(f) || f <= 0)) {
    switch (i.beginPath(), d) {
      default:
        s ? i.ellipse(e, n, s / 2, f, 0, 0, Tt) : i.arc(e, n, f, 0, Tt), i.closePath();
        break;
      case "triangle":
        i.moveTo(e + Math.sin(p) * f, n - Math.cos(p) * f), p += Vu, i.lineTo(e + Math.sin(p) * f, n - Math.cos(p) * f), p += Vu, i.lineTo(e + Math.sin(p) * f, n - Math.cos(p) * f), i.closePath();
        break;
      case "rectRounded":
        c = f * 0.516, l = f - c, a = Math.cos(p + As) * l, o = Math.sin(p + As) * l, i.arc(e - a, n - o, c, p - Bt, p - Wt), i.arc(e + o, n - a, c, p - Wt, p), i.arc(e + a, n + o, c, p, p + Wt), i.arc(e - o, n + a, c, p + Wt, p + Bt), i.closePath();
        break;
      case "rect":
        if (!h) {
          l = Math.SQRT1_2 * f, u = s ? s / 2 : l, i.rect(e - u, n - l, 2 * u, 2 * l);
          break;
        }
        p += As;
      case "rectRot":
        a = Math.cos(p) * f, o = Math.sin(p) * f, i.moveTo(e - a, n - o), i.lineTo(e + o, n - a), i.lineTo(e + a, n + o), i.lineTo(e - o, n + a), i.closePath();
        break;
      case "crossRot":
        p += As;
      case "cross":
        a = Math.cos(p) * f, o = Math.sin(p) * f, i.moveTo(e - a, n - o), i.lineTo(e + a, n + o), i.moveTo(e + o, n - a), i.lineTo(e - o, n + a);
        break;
      case "star":
        a = Math.cos(p) * f, o = Math.sin(p) * f, i.moveTo(e - a, n - o), i.lineTo(e + a, n + o), i.moveTo(e + o, n - a), i.lineTo(e - o, n + a), p += As, a = Math.cos(p) * f, o = Math.sin(p) * f, i.moveTo(e - a, n - o), i.lineTo(e + a, n + o), i.moveTo(e + o, n - a), i.lineTo(e - o, n + a);
        break;
      case "line":
        a = s ? s / 2 : Math.cos(p) * f, o = Math.sin(p) * f, i.moveTo(e - a, n - o), i.lineTo(e + a, n + o);
        break;
      case "dash":
        i.moveTo(e, n), i.lineTo(e + Math.cos(p) * f, n + Math.sin(p) * f);
        break;
    }
    i.fill(), t.borderWidth > 0 && i.stroke();
  }
}
function Gs(i, t, e) {
  return e = e || 0.5, !t || i && i.x > t.left - e && i.x < t.right + e && i.y > t.top - e && i.y < t.bottom + e;
}
function pc(i, t) {
  i.save(), i.beginPath(), i.rect(t.left, t.top, t.right - t.left, t.bottom - t.top), i.clip();
}
function gc(i) {
  i.restore();
}
function YC(i, t, e, n, s) {
  if (!t)
    return i.lineTo(e.x, e.y);
  if (s === "middle") {
    const r = (t.x + e.x) / 2;
    i.lineTo(r, t.y), i.lineTo(r, e.y);
  } else s === "after" != !!n ? i.lineTo(t.x, e.y) : i.lineTo(e.x, t.y);
  i.lineTo(e.x, e.y);
}
function UC(i, t, e, n) {
  if (!t)
    return i.lineTo(e.x, e.y);
  i.bezierCurveTo(
    n ? t.cp1x : t.cp2x,
    n ? t.cp1y : t.cp2y,
    n ? e.cp2x : e.cp1x,
    n ? e.cp2y : e.cp1y,
    e.x,
    e.y
  );
}
function kn(i, t, e, n, s, r = {}) {
  const a = $t(t) ? t : [t], o = r.strokeWidth > 0 && r.strokeColor !== "";
  let l, c;
  for (i.save(), i.font = s.string, ZC(i, r), l = 0; l < a.length; ++l)
    c = a[l], o && (r.strokeColor && (i.strokeStyle = r.strokeColor), kt(r.strokeWidth) || (i.lineWidth = r.strokeWidth), i.strokeText(c, e, n, r.maxWidth)), i.fillText(c, e, n, r.maxWidth), GC(i, e, n, c, r), n += s.lineHeight;
  i.restore();
}
function ZC(i, t) {
  t.translation && i.translate(t.translation[0], t.translation[1]), kt(t.rotation) || i.rotate(t.rotation), t.color && (i.fillStyle = t.color), t.textAlign && (i.textAlign = t.textAlign), t.textBaseline && (i.textBaseline = t.textBaseline);
}
function GC(i, t, e, n, s) {
  if (s.strikethrough || s.underline) {
    const r = i.measureText(n), a = t - r.actualBoundingBoxLeft, o = t + r.actualBoundingBoxRight, l = e - r.actualBoundingBoxAscent, c = e + r.actualBoundingBoxDescent, u = s.strikethrough ? (l + c) / 2 : c;
    i.strokeStyle = i.fillStyle, i.beginPath(), i.lineWidth = s.decorationWidth || 2, i.moveTo(a, u), i.lineTo(o, u), i.stroke();
  }
}
function Ks(i, t) {
  const { x: e, y: n, w: s, h: r, radius: a } = t;
  i.arc(e + a.topLeft, n + a.topLeft, a.topLeft, -Wt, Bt, !0), i.lineTo(e, n + r - a.bottomLeft), i.arc(e + a.bottomLeft, n + r - a.bottomLeft, a.bottomLeft, Bt, Wt, !0), i.lineTo(e + s - a.bottomRight, n + r), i.arc(e + s - a.bottomRight, n + r - a.bottomRight, a.bottomRight, Wt, 0, !0), i.lineTo(e + s, n + a.topRight), i.arc(e + s - a.topRight, n + a.topRight, a.topRight, 0, -Wt, !0), i.lineTo(e + a.topLeft, n);
}
const KC = new RegExp(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/), XC = new RegExp(/^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/);
function QC(i, t) {
  const e = ("" + i).match(KC);
  if (!e || e[1] === "normal")
    return t * 1.2;
  switch (i = +e[2], e[3]) {
    case "px":
      return i;
    case "%":
      i /= 100;
      break;
  }
  return t * i;
}
const JC = (i) => +i || 0;
function mc(i, t) {
  const e = {}, n = St(t), s = n ? Object.keys(t) : t, r = St(i) ? n ? (a) => yt(i[a], i[t[a]]) : (a) => i[a] : () => i;
  for (const a of s)
    e[a] = JC(r(a));
  return e;
}
function Kp(i) {
  return mc(i, { top: "y", right: "x", bottom: "y", left: "x" });
}
function _n(i) {
  return mc(i, ["topLeft", "topRight", "bottomLeft", "bottomRight"]);
}
function ce(i) {
  const t = Kp(i);
  return t.width = t.left + t.right, t.height = t.top + t.bottom, t;
}
function Xt(i, t) {
  i = i || {}, t = t || Ct.font;
  let e = yt(i.size, t.size);
  typeof e == "string" && (e = parseInt(e, 10));
  let n = yt(i.style, t.style);
  n && !("" + n).match(XC) && (console.warn('Invalid font style specified: "' + n + '"'), n = "");
  const s = {
    family: yt(i.family, t.family),
    lineHeight: QC(yt(i.lineHeight, t.lineHeight), e),
    size: e,
    style: n,
    weight: yt(i.weight, t.weight),
    string: ""
  };
  return s.string = jC(s), s;
}
function Ir(i, t, e, n) {
  let s, r, a;
  for (s = 0, r = i.length; s < r; ++s)
    if (a = i[s], a !== void 0 && a !== void 0)
      return a;
}
function qC(i, t, e) {
  const { min: n, max: s } = i, r = Ip(t, (s - n) / 2), a = (o, l) => e && o === 0 ? 0 : o + l;
  return {
    min: a(n, -Math.abs(r)),
    max: a(s, r)
  };
}
function sn(i, t) {
  return Object.assign(Object.create(i), t);
}
function vc(i, t = [""], e = i, n, s = () => i[0]) {
  Ze(n) || (n = qp("_fallback", i));
  const r = {
    [Symbol.toStringTag]: "Object",
    _cacheable: !0,
    _scopes: i,
    _rootScopes: e,
    _fallback: n,
    _getTarget: s,
    override: (a) => vc([a, ...i], t, e, n)
  };
  return new Proxy(r, {
    deleteProperty(a, o) {
      return delete a[o], delete a._keys, delete i[0][o], !0;
    },
    get(a, o) {
      return Qp(
        a,
        o,
        () => oS(o, t, i, a)
      );
    },
    getOwnPropertyDescriptor(a, o) {
      return Reflect.getOwnPropertyDescriptor(a._scopes[0], o);
    },
    getPrototypeOf() {
      return Reflect.getPrototypeOf(i[0]);
    },
    has(a, o) {
      return td(a).includes(o);
    },
    ownKeys(a) {
      return td(a);
    },
    set(a, o, l) {
      const c = a._storage || (a._storage = s());
      return a[o] = c[o] = l, delete a._keys, !0;
    }
  });
}
function ss(i, t, e, n) {
  const s = {
    _cacheable: !1,
    _proxy: i,
    _context: t,
    _subProxy: e,
    _stack: /* @__PURE__ */ new Set(),
    _descriptors: Xp(i, n),
    setContext: (r) => ss(i, r, e, n),
    override: (r) => ss(i.override(r), t, e, n)
  };
  return new Proxy(s, {
    deleteProperty(r, a) {
      return delete r[a], delete i[a], !0;
    },
    get(r, a, o) {
      return Qp(
        r,
        a,
        () => eS(r, a, o)
      );
    },
    getOwnPropertyDescriptor(r, a) {
      return r._descriptors.allKeys ? Reflect.has(i, a) ? { enumerable: !0, configurable: !0 } : void 0 : Reflect.getOwnPropertyDescriptor(i, a);
    },
    getPrototypeOf() {
      return Reflect.getPrototypeOf(i);
    },
    has(r, a) {
      return Reflect.has(i, a);
    },
    ownKeys() {
      return Reflect.ownKeys(i);
    },
    set(r, a, o) {
      return i[a] = o, delete r[a], !0;
    }
  });
}
function Xp(i, t = { scriptable: !0, indexable: !0 }) {
  const { _scriptable: e = t.scriptable, _indexable: n = t.indexable, _allKeys: s = t.allKeys } = i;
  return {
    allKeys: s,
    scriptable: e,
    indexable: n,
    isScriptable: tn(e) ? e : () => e,
    isIndexable: tn(n) ? n : () => n
  };
}
const tS = (i, t) => i ? i + oc(t) : t, Ac = (i, t) => St(t) && i !== "adapters" && (Object.getPrototypeOf(t) === null || t.constructor === Object);
function Qp(i, t, e) {
  if (Object.prototype.hasOwnProperty.call(i, t))
    return i[t];
  const n = e();
  return i[t] = n, n;
}
function eS(i, t, e) {
  const { _proxy: n, _context: s, _subProxy: r, _descriptors: a } = i;
  let o = n[t];
  return tn(o) && a.isScriptable(t) && (o = iS(t, o, i, e)), $t(o) && o.length && (o = nS(t, o, i, a.isIndexable)), Ac(t, o) && (o = ss(o, s, r && r[t], a)), o;
}
function iS(i, t, e, n) {
  const { _proxy: s, _context: r, _subProxy: a, _stack: o } = e;
  if (o.has(i))
    throw new Error("Recursion detected: " + Array.from(o).join("->") + "->" + i);
  return o.add(i), t = t(r, a || n), o.delete(i), Ac(i, t) && (t = bc(s._scopes, s, i, t)), t;
}
function nS(i, t, e, n) {
  const { _proxy: s, _context: r, _subProxy: a, _descriptors: o } = e;
  if (Ze(r.index) && n(i))
    t = t[r.index % t.length];
  else if (St(t[0])) {
    const l = t, c = s._scopes.filter((u) => u !== l);
    t = [];
    for (const u of l) {
      const d = bc(c, s, i, u);
      t.push(ss(d, r, a && a[i], o));
    }
  }
  return t;
}
function Jp(i, t, e) {
  return tn(i) ? i(t, e) : i;
}
const sS = (i, t) => i === !0 ? t : typeof i == "string" ? qi(t, i) : void 0;
function rS(i, t, e, n, s) {
  for (const r of t) {
    const a = sS(e, r);
    if (a) {
      i.add(a);
      const o = Jp(a._fallback, e, s);
      if (Ze(o) && o !== e && o !== n)
        return o;
    } else if (a === !1 && Ze(n) && e !== n)
      return null;
  }
  return !1;
}
function bc(i, t, e, n) {
  const s = t._rootScopes, r = Jp(t._fallback, e, n), a = [...i, ...s], o = /* @__PURE__ */ new Set();
  o.add(n);
  let l = qu(o, a, e, r || e, n);
  return l === null || Ze(r) && r !== e && (l = qu(o, a, r, l, n), l === null) ? !1 : vc(
    Array.from(o),
    [""],
    s,
    r,
    () => aS(t, e, n)
  );
}
function qu(i, t, e, n, s) {
  for (; e; )
    e = rS(i, t, e, n, s);
  return e;
}
function aS(i, t, e) {
  const n = i._getTarget();
  t in n || (n[t] = {});
  const s = n[t];
  return $t(s) && St(e) ? e : s;
}
function oS(i, t, e, n) {
  let s;
  for (const r of t)
    if (s = qp(tS(r, i), e), Ze(s))
      return Ac(i, s) ? bc(e, n, i, s) : s;
}
function qp(i, t) {
  for (const e of t) {
    if (!e)
      continue;
    const n = e[i];
    if (Ze(n))
      return n;
  }
}
function td(i) {
  let t = i._keys;
  return t || (t = i._keys = lS(i._scopes)), t;
}
function lS(i) {
  const t = /* @__PURE__ */ new Set();
  for (const e of i)
    for (const n of Object.keys(e).filter((s) => !s.startsWith("_")))
      t.add(n);
  return Array.from(t);
}
function tg(i, t, e, n) {
  const { iScale: s } = i, { key: r = "r" } = this._parsing, a = new Array(n);
  let o, l, c, u;
  for (o = 0, l = n; o < l; ++o)
    c = o + e, u = t[c], a[o] = {
      r: s.parse(qi(u, r), c)
    };
  return a;
}
const cS = Number.EPSILON || 1e-14, rs = (i, t) => t < i.length && !i[t].skip && i[t], eg = (i) => i === "x" ? "y" : "x";
function uS(i, t, e, n) {
  const s = i.skip ? t : i, r = t, a = e.skip ? t : e, o = ul(r, s), l = ul(a, r);
  let c = o / (o + l), u = l / (o + l);
  c = isNaN(c) ? 0 : c, u = isNaN(u) ? 0 : u;
  const d = n * c, h = n * u;
  return {
    previous: {
      x: r.x - d * (a.x - s.x),
      y: r.y - d * (a.y - s.y)
    },
    next: {
      x: r.x + h * (a.x - s.x),
      y: r.y + h * (a.y - s.y)
    }
  };
}
function dS(i, t, e) {
  const n = i.length;
  let s, r, a, o, l, c = rs(i, 0);
  for (let u = 0; u < n - 1; ++u)
    if (l = c, c = rs(i, u + 1), !(!l || !c)) {
      if (Ls(t[u], 0, cS)) {
        e[u] = e[u + 1] = 0;
        continue;
      }
      s = e[u] / t[u], r = e[u + 1] / t[u], o = Math.pow(s, 2) + Math.pow(r, 2), !(o <= 9) && (a = 3 / Math.sqrt(o), e[u] = s * a * t[u], e[u + 1] = r * a * t[u]);
    }
}
function hS(i, t, e = "x") {
  const n = eg(e), s = i.length;
  let r, a, o, l = rs(i, 0);
  for (let c = 0; c < s; ++c) {
    if (a = o, o = l, l = rs(i, c + 1), !o)
      continue;
    const u = o[e], d = o[n];
    a && (r = (u - a[e]) / 3, o[`cp1${e}`] = u - r, o[`cp1${n}`] = d - r * t[c]), l && (r = (l[e] - u) / 3, o[`cp2${e}`] = u + r, o[`cp2${n}`] = d + r * t[c]);
  }
}
function fS(i, t = "x") {
  const e = eg(t), n = i.length, s = Array(n).fill(0), r = Array(n);
  let a, o, l, c = rs(i, 0);
  for (a = 0; a < n; ++a)
    if (o = l, l = c, c = rs(i, a + 1), !!l) {
      if (c) {
        const u = c[t] - l[t];
        s[a] = u !== 0 ? (c[e] - l[e]) / u : 0;
      }
      r[a] = o ? c ? vi(s[a - 1]) !== vi(s[a]) ? 0 : (s[a - 1] + s[a]) / 2 : s[a - 1] : s[a];
    }
  dS(i, s, r), hS(i, r, t);
}
function Er(i, t, e) {
  return Math.max(Math.min(i, e), t);
}
function pS(i, t) {
  let e, n, s, r, a, o = Gs(i[0], t);
  for (e = 0, n = i.length; e < n; ++e)
    a = r, r = o, o = e < n - 1 && Gs(i[e + 1], t), r && (s = i[e], a && (s.cp1x = Er(s.cp1x, t.left, t.right), s.cp1y = Er(s.cp1y, t.top, t.bottom)), o && (s.cp2x = Er(s.cp2x, t.left, t.right), s.cp2y = Er(s.cp2y, t.top, t.bottom)));
}
function gS(i, t, e, n, s) {
  let r, a, o, l;
  if (t.spanGaps && (i = i.filter((c) => !c.skip)), t.cubicInterpolationMode === "monotone")
    fS(i, s);
  else {
    let c = n ? i[i.length - 1] : i[0];
    for (r = 0, a = i.length; r < a; ++r)
      o = i[r], l = uS(
        c,
        o,
        i[Math.min(r + 1, a - (n ? 0 : 1)) % a],
        t.tension
      ), o.cp1x = l.previous.x, o.cp1y = l.previous.y, o.cp2x = l.next.x, o.cp2y = l.next.y, c = o;
  }
  t.capBezierPoints && pS(i, e);
}
function ig() {
  return typeof window < "u" && typeof document < "u";
}
function yc(i) {
  let t = i.parentNode;
  return t && t.toString() === "[object ShadowRoot]" && (t = t.host), t;
}
function va(i, t, e) {
  let n;
  return typeof i == "string" ? (n = parseInt(i, 10), i.indexOf("%") !== -1 && (n = n / 100 * t.parentNode[e])) : n = i, n;
}
const Ea = (i) => window.getComputedStyle(i, null);
function mS(i, t) {
  return Ea(i).getPropertyValue(t);
}
const vS = ["top", "right", "bottom", "left"];
function xn(i, t, e) {
  const n = {};
  e = e ? "-" + e : "";
  for (let s = 0; s < 4; s++) {
    const r = vS[s];
    n[r] = parseFloat(i[t + "-" + r + e]) || 0;
  }
  return n.width = n.left + n.right, n.height = n.top + n.bottom, n;
}
const AS = (i, t, e) => (i > 0 || t > 0) && (!e || !e.shadowRoot);
function bS(i, t) {
  const e = i.touches, n = e && e.length ? e[0] : i, { offsetX: s, offsetY: r } = n;
  let a = !1, o, l;
  if (AS(s, r, i.target))
    o = s, l = r;
  else {
    const c = t.getBoundingClientRect();
    o = n.clientX - c.left, l = n.clientY - c.top, a = !0;
  }
  return { x: o, y: l, box: a };
}
function hn(i, t) {
  if ("native" in i)
    return i;
  const { canvas: e, currentDevicePixelRatio: n } = t, s = Ea(e), r = s.boxSizing === "border-box", a = xn(s, "padding"), o = xn(s, "border", "width"), { x: l, y: c, box: u } = bS(i, e), d = a.left + (u && o.left), h = a.top + (u && o.top);
  let { width: f, height: p } = t;
  return r && (f -= a.width + o.width, p -= a.height + o.height), {
    x: Math.round((l - d) / f * e.width / n),
    y: Math.round((c - h) / p * e.height / n)
  };
}
function yS(i, t, e) {
  let n, s;
  if (t === void 0 || e === void 0) {
    const r = yc(i);
    if (!r)
      t = i.clientWidth, e = i.clientHeight;
    else {
      const a = r.getBoundingClientRect(), o = Ea(r), l = xn(o, "border", "width"), c = xn(o, "padding");
      t = a.width - c.width - l.width, e = a.height - c.height - l.height, n = va(o.maxWidth, r, "clientWidth"), s = va(o.maxHeight, r, "clientHeight");
    }
  }
  return {
    width: t,
    height: e,
    maxWidth: n || pa,
    maxHeight: s || pa
  };
}
const Po = (i) => Math.round(i * 10) / 10;
function _S(i, t, e, n) {
  const s = Ea(i), r = xn(s, "margin"), a = va(s.maxWidth, i, "clientWidth") || pa, o = va(s.maxHeight, i, "clientHeight") || pa, l = yS(i, t, e);
  let { width: c, height: u } = l;
  if (s.boxSizing === "content-box") {
    const d = xn(s, "border", "width"), h = xn(s, "padding");
    c -= h.width + d.width, u -= h.height + d.height;
  }
  return c = Math.max(0, c - r.width), u = Math.max(0, n ? Math.floor(c / n) : u - r.height), c = Po(Math.min(c, a, l.maxWidth)), u = Po(Math.min(u, o, l.maxHeight)), c && !u && (u = Po(c / 2)), {
    width: c,
    height: u
  };
}
function ed(i, t, e) {
  const n = t || 1, s = Math.floor(i.height * n), r = Math.floor(i.width * n);
  i.height = s / n, i.width = r / n;
  const a = i.canvas;
  return a.style && (e || !a.style.height && !a.style.width) && (a.style.height = `${i.height}px`, a.style.width = `${i.width}px`), i.currentDevicePixelRatio !== n || a.height !== s || a.width !== r ? (i.currentDevicePixelRatio = n, a.height = s, a.width = r, i.ctx.setTransform(n, 0, 0, n, 0, 0), !0) : !1;
}
const xS = function() {
  let i = !1;
  try {
    const t = {
      get passive() {
        return i = !0, !1;
      }
    };
    window.addEventListener("test", null, t), window.removeEventListener("test", null, t);
  } catch {
  }
  return i;
}();
function id(i, t) {
  const e = mS(i, t), n = e && e.match(/^(\d+)(\.\d+)?px$/);
  return n ? +n[1] : void 0;
}
function fn(i, t, e, n) {
  return {
    x: i.x + e * (t.x - i.x),
    y: i.y + e * (t.y - i.y)
  };
}
function CS(i, t, e, n) {
  return {
    x: i.x + e * (t.x - i.x),
    y: n === "middle" ? e < 0.5 ? i.y : t.y : n === "after" ? e < 1 ? i.y : t.y : e > 0 ? t.y : i.y
  };
}
function SS(i, t, e, n) {
  const s = { x: i.cp2x, y: i.cp2y }, r = { x: t.cp1x, y: t.cp1y }, a = fn(i, s, e), o = fn(s, r, e), l = fn(r, t, e), c = fn(a, o, e), u = fn(o, l, e);
  return fn(c, u, e);
}
const nd = /* @__PURE__ */ new Map();
function wS(i, t) {
  t = t || {};
  const e = i + JSON.stringify(t);
  let n = nd.get(e);
  return n || (n = new Intl.NumberFormat(i, t), nd.set(e, n)), n;
}
function ur(i, t, e) {
  return wS(t, e).format(i);
}
const kS = function(i, t) {
  return {
    x(e) {
      return i + i + t - e;
    },
    setWidth(e) {
      t = e;
    },
    textAlign(e) {
      return e === "center" ? e : e === "right" ? "left" : "right";
    },
    xPlus(e, n) {
      return e - n;
    },
    leftForLtr(e, n) {
      return e - n;
    }
  };
}, OS = function() {
  return {
    x(i) {
      return i;
    },
    setWidth(i) {
    },
    textAlign(i) {
      return i;
    },
    xPlus(i, t) {
      return i + t;
    },
    leftForLtr(i, t) {
      return i;
    }
  };
};
function Qn(i, t, e) {
  return i ? kS(t, e) : OS();
}
function ng(i, t) {
  let e, n;
  (t === "ltr" || t === "rtl") && (e = i.canvas.style, n = [
    e.getPropertyValue("direction"),
    e.getPropertyPriority("direction")
  ], e.setProperty("direction", t, "important"), i.prevTextDirection = n);
}
function sg(i, t) {
  t !== void 0 && (delete i.prevTextDirection, i.canvas.style.setProperty("direction", t[0], t[1]));
}
function rg(i) {
  return i === "angle" ? {
    between: Zs,
    compare: fC,
    normalize: Qe
  } : {
    between: Yi,
    compare: (t, e) => t - e,
    normalize: (t) => t
  };
}
function sd({ start: i, end: t, count: e, loop: n, style: s }) {
  return {
    start: i % e,
    end: t % e,
    loop: n && (t - i + 1) % e === 0,
    style: s
  };
}
function MS(i, t, e) {
  const { property: n, start: s, end: r } = e, { between: a, normalize: o } = rg(n), l = t.length;
  let { start: c, end: u, loop: d } = i, h, f;
  if (d) {
    for (c += l, u += l, h = 0, f = l; h < f && a(o(t[c % l][n]), s, r); ++h)
      c--, u--;
    c %= l, u %= l;
  }
  return u < c && (u += l), { start: c, end: u, loop: d, style: i.style };
}
function TS(i, t, e) {
  if (!e)
    return [i];
  const { property: n, start: s, end: r } = e, a = t.length, { compare: o, between: l, normalize: c } = rg(n), { start: u, end: d, loop: h, style: f } = MS(i, t, e), p = [];
  let g = !1, m = null, v, b, _;
  const S = () => l(s, _, v) && o(s, _) !== 0, C = () => o(r, v) === 0 || l(r, _, v), O = () => g || S(), k = () => !g || C();
  for (let P = u, x = u; P <= d; ++P)
    b = t[P % a], !b.skip && (v = c(b[n]), v !== _ && (g = l(v, s, r), m === null && O() && (m = o(v, s) === 0 ? P : x), m !== null && k() && (p.push(sd({ start: m, end: P, loop: h, count: a, style: f })), m = null), x = P, _ = v));
  return m !== null && p.push(sd({ start: m, end: d, loop: h, count: a, style: f })), p;
}
function DS(i, t) {
  const e = [], n = i.segments;
  for (let s = 0; s < n.length; s++) {
    const r = TS(n[s], i.points, t);
    r.length && e.push(...r);
  }
  return e;
}
function PS(i, t, e, n) {
  let s = 0, r = t - 1;
  if (e && !n)
    for (; s < t && !i[s].skip; )
      s++;
  for (; s < t && i[s].skip; )
    s++;
  for (s %= t, e && (r += s); r > s && i[r % t].skip; )
    r--;
  return r %= t, { start: s, end: r };
}
function LS(i, t, e, n) {
  const s = i.length, r = [];
  let a = t, o = i[t], l;
  for (l = t + 1; l <= e; ++l) {
    const c = i[l % s];
    c.skip || c.stop ? o.skip || (n = !1, r.push({ start: t % s, end: (l - 1) % s, loop: n }), t = a = c.stop ? l : null) : (a = l, o.skip && (t = l)), o = c;
  }
  return a !== null && r.push({ start: t % s, end: a % s, loop: n }), r;
}
function IS(i, t) {
  const e = i.points, n = i.options.spanGaps, s = e.length;
  if (!s)
    return [];
  const r = !!i._loop, { start: a, end: o } = PS(e, s, r, n);
  if (n === !0)
    return rd(i, [{ start: a, end: o, loop: r }], e, t);
  const l = o < a ? o + s : o, c = !!i._fullLoop && a === 0 && o === s - 1;
  return rd(i, LS(e, a, l, c), e, t);
}
function rd(i, t, e, n) {
  return !n || !n.setContext || !e ? t : ES(i, t, e, n);
}
function ES(i, t, e, n) {
  const s = i._chart.getContext(), r = ad(i.options), { _datasetIndex: a, options: { spanGaps: o } } = i, l = e.length, c = [];
  let u = r, d = t[0].start, h = d;
  function f(p, g, m, v) {
    const b = o ? -1 : 1;
    if (p !== g) {
      for (p += l; e[p % l].skip; )
        p -= b;
      for (; e[g % l].skip; )
        g += b;
      p % l !== g % l && (c.push({ start: p % l, end: g % l, loop: m, style: v }), u = v, d = g % l);
    }
  }
  for (const p of t) {
    d = o ? d : p.start;
    let g = e[d % l], m;
    for (h = d + 1; h <= p.end; h++) {
      const v = e[h % l];
      m = ad(n.setContext(sn(s, {
        type: "segment",
        p0: g,
        p1: v,
        p0DataIndex: (h - 1) % l,
        p1DataIndex: h % l,
        datasetIndex: a
      }))), $S(m, u) && f(d, h - 1, p.loop, u), g = v, u = m;
    }
    d < h - 1 && f(d, h - 1, p.loop, u);
  }
  return c;
}
function ad(i) {
  return {
    backgroundColor: i.backgroundColor,
    borderCapStyle: i.borderCapStyle,
    borderDash: i.borderDash,
    borderDashOffset: i.borderDashOffset,
    borderJoinStyle: i.borderJoinStyle,
    borderWidth: i.borderWidth,
    borderColor: i.borderColor
  };
}
function $S(i, t) {
  return t && JSON.stringify(i) !== JSON.stringify(t);
}
/*!
 * Chart.js v3.9.1
 * https://www.chartjs.org
 * (c) 2022 Chart.js Contributors
 * Released under the MIT License
 */
class BS {
  constructor() {
    this._request = null, this._charts = /* @__PURE__ */ new Map(), this._running = !1, this._lastDate = void 0;
  }
  _notify(t, e, n, s) {
    const r = e.listeners[s], a = e.duration;
    r.forEach((o) => o({
      chart: t,
      initial: e.initial,
      numSteps: a,
      currentStep: Math.min(n - e.start, a)
    }));
  }
  _refresh() {
    this._request || (this._running = !0, this._request = Np.call(window, () => {
      this._update(), this._request = null, this._running && this._refresh();
    }));
  }
  _update(t = Date.now()) {
    let e = 0;
    this._charts.forEach((n, s) => {
      if (!n.running || !n.items.length)
        return;
      const r = n.items;
      let a = r.length - 1, o = !1, l;
      for (; a >= 0; --a)
        l = r[a], l._active ? (l._total > n.duration && (n.duration = l._total), l.tick(t), o = !0) : (r[a] = r[r.length - 1], r.pop());
      o && (s.draw(), this._notify(s, n, t, "progress")), r.length || (n.running = !1, this._notify(s, n, t, "complete"), n.initial = !1), e += r.length;
    }), this._lastDate = t, e === 0 && (this._running = !1);
  }
  _getAnims(t) {
    const e = this._charts;
    let n = e.get(t);
    return n || (n = {
      running: !1,
      initial: !0,
      items: [],
      listeners: {
        complete: [],
        progress: []
      }
    }, e.set(t, n)), n;
  }
  listen(t, e, n) {
    this._getAnims(t).listeners[e].push(n);
  }
  add(t, e) {
    !e || !e.length || this._getAnims(t).items.push(...e);
  }
  has(t) {
    return this._getAnims(t).items.length > 0;
  }
  start(t) {
    const e = this._charts.get(t);
    e && (e.running = !0, e.start = Date.now(), e.duration = e.items.reduce((n, s) => Math.max(n, s._duration), 0), this._refresh());
  }
  running(t) {
    if (!this._running)
      return !1;
    const e = this._charts.get(t);
    return !(!e || !e.running || !e.items.length);
  }
  stop(t) {
    const e = this._charts.get(t);
    if (!e || !e.items.length)
      return;
    const n = e.items;
    let s = n.length - 1;
    for (; s >= 0; --s)
      n[s].cancel();
    e.items = [], this._notify(t, e, Date.now(), "complete");
  }
  remove(t) {
    return this._charts.delete(t);
  }
}
var ki = new BS();
const od = "transparent", RS = {
  boolean(i, t, e) {
    return e > 0.5 ? t : i;
  },
  color(i, t, e) {
    const n = Qu(i || od), s = n.valid && Qu(t || od);
    return s && s.valid ? s.mix(n, e).hexString() : t;
  },
  number(i, t, e) {
    return i + (t - i) * e;
  }
};
class FS {
  constructor(t, e, n, s) {
    const r = e[n];
    s = Ir([t.to, s, r, t.from]);
    const a = Ir([t.from, r, s]);
    this._active = !0, this._fn = t.fn || RS[t.type || typeof a], this._easing = Is[t.easing] || Is.linear, this._start = Math.floor(Date.now() + (t.delay || 0)), this._duration = this._total = Math.floor(t.duration), this._loop = !!t.loop, this._target = e, this._prop = n, this._from = a, this._to = s, this._promises = void 0;
  }
  active() {
    return this._active;
  }
  update(t, e, n) {
    if (this._active) {
      this._notify(!1);
      const s = this._target[this._prop], r = n - this._start, a = this._duration - r;
      this._start = n, this._duration = Math.floor(Math.max(a, t.duration)), this._total += r, this._loop = !!t.loop, this._to = Ir([t.to, e, s, t.from]), this._from = Ir([t.from, s, e]);
    }
  }
  cancel() {
    this._active && (this.tick(Date.now()), this._active = !1, this._notify(!1));
  }
  tick(t) {
    const e = t - this._start, n = this._duration, s = this._prop, r = this._from, a = this._loop, o = this._to;
    let l;
    if (this._active = r !== o && (a || e < n), !this._active) {
      this._target[s] = o, this._notify(!0);
      return;
    }
    if (e < 0) {
      this._target[s] = r;
      return;
    }
    l = e / n % 2, l = a && l > 1 ? 2 - l : l, l = this._easing(Math.min(1, Math.max(0, l))), this._target[s] = this._fn(r, o, l);
  }
  wait() {
    const t = this._promises || (this._promises = []);
    return new Promise((e, n) => {
      t.push({ res: e, rej: n });
    });
  }
  _notify(t) {
    const e = t ? "res" : "rej", n = this._promises || [];
    for (let s = 0; s < n.length; s++)
      n[s][e]();
  }
}
const NS = ["x", "y", "borderWidth", "radius", "tension"], HS = ["color", "borderColor", "backgroundColor"];
Ct.set("animation", {
  delay: void 0,
  duration: 1e3,
  easing: "easeOutQuart",
  fn: void 0,
  from: void 0,
  loop: void 0,
  to: void 0,
  type: void 0
});
const VS = Object.keys(Ct.animation);
Ct.describe("animation", {
  _fallback: !1,
  _indexable: !1,
  _scriptable: (i) => i !== "onProgress" && i !== "onComplete" && i !== "fn"
});
Ct.set("animations", {
  colors: {
    type: "color",
    properties: HS
  },
  numbers: {
    type: "number",
    properties: NS
  }
});
Ct.describe("animations", {
  _fallback: "animation"
});
Ct.set("transitions", {
  active: {
    animation: {
      duration: 400
    }
  },
  resize: {
    animation: {
      duration: 0
    }
  },
  show: {
    animations: {
      colors: {
        from: "transparent"
      },
      visible: {
        type: "boolean",
        duration: 0
      }
    }
  },
  hide: {
    animations: {
      colors: {
        to: "transparent"
      },
      visible: {
        type: "boolean",
        easing: "linear",
        fn: (i) => i | 0
      }
    }
  }
});
class ag {
  constructor(t, e) {
    this._chart = t, this._properties = /* @__PURE__ */ new Map(), this.configure(e);
  }
  configure(t) {
    if (!St(t))
      return;
    const e = this._properties;
    Object.getOwnPropertyNames(t).forEach((n) => {
      const s = t[n];
      if (!St(s))
        return;
      const r = {};
      for (const a of VS)
        r[a] = s[a];
      ($t(s.properties) && s.properties || [n]).forEach((a) => {
        (a === n || !e.has(a)) && e.set(a, r);
      });
    });
  }
  _animateOptions(t, e) {
    const n = e.options, s = jS(t, n);
    if (!s)
      return [];
    const r = this._createAnimations(s, n);
    return n.$shared && zS(t.options.$animations, n).then(() => {
      t.options = n;
    }, () => {
    }), r;
  }
  _createAnimations(t, e) {
    const n = this._properties, s = [], r = t.$animations || (t.$animations = {}), a = Object.keys(e), o = Date.now();
    let l;
    for (l = a.length - 1; l >= 0; --l) {
      const c = a[l];
      if (c.charAt(0) === "$")
        continue;
      if (c === "options") {
        s.push(...this._animateOptions(t, e));
        continue;
      }
      const u = e[c];
      let d = r[c];
      const h = n.get(c);
      if (d)
        if (h && d.active()) {
          d.update(h, u, o);
          continue;
        } else
          d.cancel();
      if (!h || !h.duration) {
        t[c] = u;
        continue;
      }
      r[c] = d = new FS(h, t, c, u), s.push(d);
    }
    return s;
  }
  update(t, e) {
    if (this._properties.size === 0) {
      Object.assign(t, e);
      return;
    }
    const n = this._createAnimations(t, e);
    if (n.length)
      return ki.add(this._chart, n), !0;
  }
}
function zS(i, t) {
  const e = [], n = Object.keys(t);
  for (let s = 0; s < n.length; s++) {
    const r = i[n[s]];
    r && r.active() && e.push(r.wait());
  }
  return Promise.all(e);
}
function jS(i, t) {
  if (!t)
    return;
  let e = i.options;
  if (!e) {
    i.options = t;
    return;
  }
  return e.$shared && (i.options = e = Object.assign({}, e, { $shared: !1, $animations: {} })), e;
}
function ld(i, t) {
  const e = i && i.options || {}, n = e.reverse, s = e.min === void 0 ? t : 0, r = e.max === void 0 ? t : 0;
  return {
    start: n ? r : s,
    end: n ? s : r
  };
}
function WS(i, t, e) {
  if (e === !1)
    return !1;
  const n = ld(i, e), s = ld(t, e);
  return {
    top: s.end,
    right: n.end,
    bottom: s.start,
    left: n.start
  };
}
function YS(i) {
  let t, e, n, s;
  return St(i) ? (t = i.top, e = i.right, n = i.bottom, s = i.left) : t = e = n = s = i, {
    top: t,
    right: e,
    bottom: n,
    left: s,
    disabled: i === !1
  };
}
function og(i, t) {
  const e = [], n = i._getSortedDatasetMetas(t);
  let s, r;
  for (s = 0, r = n.length; s < r; ++s)
    e.push(n[s].index);
  return e;
}
function cd(i, t, e, n = {}) {
  const s = i.keys, r = n.mode === "single";
  let a, o, l, c;
  if (t !== null) {
    for (a = 0, o = s.length; a < o; ++a) {
      if (l = +s[a], l === e) {
        if (n.all)
          continue;
        break;
      }
      c = i.values[l], ee(c) && (r || t === 0 || vi(t) === vi(c)) && (t += c);
    }
    return t;
  }
}
function US(i) {
  const t = Object.keys(i), e = new Array(t.length);
  let n, s, r;
  for (n = 0, s = t.length; n < s; ++n)
    r = t[n], e[n] = {
      x: r,
      y: i[r]
    };
  return e;
}
function ud(i, t) {
  const e = i && i.options.stacked;
  return e || e === void 0 && t.stack !== void 0;
}
function ZS(i, t, e) {
  return `${i.id}.${t.id}.${e.stack || e.type}`;
}
function GS(i) {
  const { min: t, max: e, minDefined: n, maxDefined: s } = i.getUserBounds();
  return {
    min: n ? t : Number.NEGATIVE_INFINITY,
    max: s ? e : Number.POSITIVE_INFINITY
  };
}
function KS(i, t, e) {
  const n = i[t] || (i[t] = {});
  return n[e] || (n[e] = {});
}
function dd(i, t, e, n) {
  for (const s of t.getMatchingVisibleMetas(n).reverse()) {
    const r = i[s.index];
    if (e && r > 0 || !e && r < 0)
      return s.index;
  }
  return null;
}
function hd(i, t) {
  const { chart: e, _cachedMeta: n } = i, s = e._stacks || (e._stacks = {}), { iScale: r, vScale: a, index: o } = n, l = r.axis, c = a.axis, u = ZS(r, a, n), d = t.length;
  let h;
  for (let f = 0; f < d; ++f) {
    const p = t[f], { [l]: g, [c]: m } = p, v = p._stacks || (p._stacks = {});
    h = v[c] = KS(s, u, g), h[o] = m, h._top = dd(h, a, !0, n.type), h._bottom = dd(h, a, !1, n.type);
  }
}
function Lo(i, t) {
  const e = i.scales;
  return Object.keys(e).filter((n) => e[n].axis === t).shift();
}
function XS(i, t) {
  return sn(
    i,
    {
      active: !1,
      dataset: void 0,
      datasetIndex: t,
      index: t,
      mode: "default",
      type: "dataset"
    }
  );
}
function QS(i, t, e) {
  return sn(i, {
    active: !1,
    dataIndex: t,
    parsed: void 0,
    raw: void 0,
    element: e,
    index: t,
    mode: "default",
    type: "data"
  });
}
function bs(i, t) {
  const e = i.controller.index, n = i.vScale && i.vScale.axis;
  if (n) {
    t = t || i._parsed;
    for (const s of t) {
      const r = s._stacks;
      if (!r || r[n] === void 0 || r[n][e] === void 0)
        return;
      delete r[n][e];
    }
  }
}
const Io = (i) => i === "reset" || i === "none", fd = (i, t) => t ? i : Object.assign({}, i), JS = (i, t, e) => i && !t.hidden && t._stacked && { keys: og(e, !0), values: null };
class ii {
  constructor(t, e) {
    this.chart = t, this._ctx = t.ctx, this.index = e, this._cachedDataOpts = {}, this._cachedMeta = this.getMeta(), this._type = this._cachedMeta.type, this.options = void 0, this._parsing = !1, this._data = void 0, this._objectData = void 0, this._sharedOptions = void 0, this._drawStart = void 0, this._drawCount = void 0, this.enableOptionSharing = !1, this.supportsDecimation = !1, this.$context = void 0, this._syncList = [], this.initialize();
  }
  initialize() {
    const t = this._cachedMeta;
    this.configure(), this.linkScales(), t._stacked = ud(t.vScale, t), this.addElements();
  }
  updateIndex(t) {
    this.index !== t && bs(this._cachedMeta), this.index = t;
  }
  linkScales() {
    const t = this.chart, e = this._cachedMeta, n = this.getDataset(), s = (d, h, f, p) => d === "x" ? h : d === "r" ? p : f, r = e.xAxisID = yt(n.xAxisID, Lo(t, "x")), a = e.yAxisID = yt(n.yAxisID, Lo(t, "y")), o = e.rAxisID = yt(n.rAxisID, Lo(t, "r")), l = e.indexAxis, c = e.iAxisID = s(l, r, a, o), u = e.vAxisID = s(l, a, r, o);
    e.xScale = this.getScaleForId(r), e.yScale = this.getScaleForId(a), e.rScale = this.getScaleForId(o), e.iScale = this.getScaleForId(c), e.vScale = this.getScaleForId(u);
  }
  getDataset() {
    return this.chart.data.datasets[this.index];
  }
  getMeta() {
    return this.chart.getDatasetMeta(this.index);
  }
  getScaleForId(t) {
    return this.chart.scales[t];
  }
  _getOtherScale(t) {
    const e = this._cachedMeta;
    return t === e.iScale ? e.vScale : e.iScale;
  }
  reset() {
    this._update("reset");
  }
  _destroy() {
    const t = this._cachedMeta;
    this._data && Wu(this._data, this), t._stacked && bs(t);
  }
  _dataCheck() {
    const t = this.getDataset(), e = t.data || (t.data = []), n = this._data;
    if (St(e))
      this._data = US(e);
    else if (n !== e) {
      if (n) {
        Wu(n, this);
        const s = this._cachedMeta;
        bs(s), s._parsed = [];
      }
      e && Object.isExtensible(e) && vC(e, this), this._syncList = [], this._data = e;
    }
  }
  addElements() {
    const t = this._cachedMeta;
    this._dataCheck(), this.datasetElementType && (t.dataset = new this.datasetElementType());
  }
  buildOrUpdateElements(t) {
    const e = this._cachedMeta, n = this.getDataset();
    let s = !1;
    this._dataCheck();
    const r = e._stacked;
    e._stacked = ud(e.vScale, e), e.stack !== n.stack && (s = !0, bs(e), e.stack = n.stack), this._resyncElements(t), (s || r !== e._stacked) && hd(this, e._parsed);
  }
  configure() {
    const t = this.chart.config, e = t.datasetScopeKeys(this._type), n = t.getOptionScopes(this.getDataset(), e, !0);
    this.options = t.createResolver(n, this.getContext()), this._parsing = this.options.parsing, this._cachedDataOpts = {};
  }
  parse(t, e) {
    const { _cachedMeta: n, _data: s } = this, { iScale: r, _stacked: a } = n, o = r.axis;
    let l = t === 0 && e === s.length ? !0 : n._sorted, c = t > 0 && n._parsed[t - 1], u, d, h;
    if (this._parsing === !1)
      n._parsed = s, n._sorted = !0, h = s;
    else {
      $t(s[t]) ? h = this.parseArrayData(n, s, t, e) : St(s[t]) ? h = this.parseObjectData(n, s, t, e) : h = this.parsePrimitiveData(n, s, t, e);
      const f = () => d[o] === null || c && d[o] < c[o];
      for (u = 0; u < e; ++u)
        n._parsed[u + t] = d = h[u], l && (f() && (l = !1), c = d);
      n._sorted = l;
    }
    a && hd(this, h);
  }
  parsePrimitiveData(t, e, n, s) {
    const { iScale: r, vScale: a } = t, o = r.axis, l = a.axis, c = r.getLabels(), u = r === a, d = new Array(s);
    let h, f, p;
    for (h = 0, f = s; h < f; ++h)
      p = h + n, d[h] = {
        [o]: u || r.parse(c[p], p),
        [l]: a.parse(e[p], p)
      };
    return d;
  }
  parseArrayData(t, e, n, s) {
    const { xScale: r, yScale: a } = t, o = new Array(s);
    let l, c, u, d;
    for (l = 0, c = s; l < c; ++l)
      u = l + n, d = e[u], o[l] = {
        x: r.parse(d[0], u),
        y: a.parse(d[1], u)
      };
    return o;
  }
  parseObjectData(t, e, n, s) {
    const { xScale: r, yScale: a } = t, { xAxisKey: o = "x", yAxisKey: l = "y" } = this._parsing, c = new Array(s);
    let u, d, h, f;
    for (u = 0, d = s; u < d; ++u)
      h = u + n, f = e[h], c[u] = {
        x: r.parse(qi(f, o), h),
        y: a.parse(qi(f, l), h)
      };
    return c;
  }
  getParsed(t) {
    return this._cachedMeta._parsed[t];
  }
  getDataElement(t) {
    return this._cachedMeta.data[t];
  }
  applyStack(t, e, n) {
    const s = this.chart, r = this._cachedMeta, a = e[t.axis], o = {
      keys: og(s, !0),
      values: e._stacks[t.axis]
    };
    return cd(o, a, r.index, { mode: n });
  }
  updateRangeFromParsed(t, e, n, s) {
    const r = n[e.axis];
    let a = r === null ? NaN : r;
    const o = s && n._stacks[e.axis];
    s && o && (s.values = o, a = cd(s, r, this._cachedMeta.index)), t.min = Math.min(t.min, a), t.max = Math.max(t.max, a);
  }
  getMinMax(t, e) {
    const n = this._cachedMeta, s = n._parsed, r = n._sorted && t === n.iScale, a = s.length, o = this._getOtherScale(t), l = JS(e, n, this.chart), c = { min: Number.POSITIVE_INFINITY, max: Number.NEGATIVE_INFINITY }, { min: u, max: d } = GS(o);
    let h, f;
    function p() {
      f = s[h];
      const g = f[o.axis];
      return !ee(f[t.axis]) || u > g || d < g;
    }
    for (h = 0; h < a && !(!p() && (this.updateRangeFromParsed(c, t, f, l), r)); ++h)
      ;
    if (r) {
      for (h = a - 1; h >= 0; --h)
        if (!p()) {
          this.updateRangeFromParsed(c, t, f, l);
          break;
        }
    }
    return c;
  }
  getAllParsedValues(t) {
    const e = this._cachedMeta._parsed, n = [];
    let s, r, a;
    for (s = 0, r = e.length; s < r; ++s)
      a = e[s][t.axis], ee(a) && n.push(a);
    return n;
  }
  getMaxOverflow() {
    return !1;
  }
  getLabelAndValue(t) {
    const e = this._cachedMeta, n = e.iScale, s = e.vScale, r = this.getParsed(t);
    return {
      label: n ? "" + n.getLabelForValue(r[n.axis]) : "",
      value: s ? "" + s.getLabelForValue(r[s.axis]) : ""
    };
  }
  _update(t) {
    const e = this._cachedMeta;
    this.update(t || "default"), e._clip = YS(yt(this.options.clip, WS(e.xScale, e.yScale, this.getMaxOverflow())));
  }
  update(t) {
  }
  draw() {
    const t = this._ctx, e = this.chart, n = this._cachedMeta, s = n.data || [], r = e.chartArea, a = [], o = this._drawStart || 0, l = this._drawCount || s.length - o, c = this.options.drawActiveElementsOnTop;
    let u;
    for (n.dataset && n.dataset.draw(t, r, o, l), u = o; u < o + l; ++u) {
      const d = s[u];
      d.hidden || (d.active && c ? a.push(d) : d.draw(t, r));
    }
    for (u = 0; u < a.length; ++u)
      a[u].draw(t, r);
  }
  getStyle(t, e) {
    const n = e ? "active" : "default";
    return t === void 0 && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(n) : this.resolveDataElementOptions(t || 0, n);
  }
  getContext(t, e, n) {
    const s = this.getDataset();
    let r;
    if (t >= 0 && t < this._cachedMeta.data.length) {
      const a = this._cachedMeta.data[t];
      r = a.$context || (a.$context = QS(this.getContext(), t, a)), r.parsed = this.getParsed(t), r.raw = s.data[t], r.index = r.dataIndex = t;
    } else
      r = this.$context || (this.$context = XS(this.chart.getContext(), this.index)), r.dataset = s, r.index = r.datasetIndex = this.index;
    return r.active = !!e, r.mode = n, r;
  }
  resolveDatasetElementOptions(t) {
    return this._resolveElementOptions(this.datasetElementType.id, t);
  }
  resolveDataElementOptions(t, e) {
    return this._resolveElementOptions(this.dataElementType.id, e, t);
  }
  _resolveElementOptions(t, e = "default", n) {
    const s = e === "active", r = this._cachedDataOpts, a = t + "-" + e, o = r[a], l = this.enableOptionSharing && Ze(n);
    if (o)
      return fd(o, l);
    const c = this.chart.config, u = c.datasetElementScopeKeys(this._type, t), d = s ? [`${t}Hover`, "hover", t, ""] : [t, ""], h = c.getOptionScopes(this.getDataset(), u), f = Object.keys(Ct.elements[t]), p = () => this.getContext(n, s), g = c.resolveNamedOptions(h, f, p, d);
    return g.$shared && (g.$shared = l, r[a] = Object.freeze(fd(g, l))), g;
  }
  _resolveAnimations(t, e, n) {
    const s = this.chart, r = this._cachedDataOpts, a = `animation-${e}`, o = r[a];
    if (o)
      return o;
    let l;
    if (s.options.animation !== !1) {
      const u = this.chart.config, d = u.datasetAnimationScopeKeys(this._type, e), h = u.getOptionScopes(this.getDataset(), d);
      l = u.createResolver(h, this.getContext(t, n, e));
    }
    const c = new ag(s, l && l.animations);
    return l && l._cacheable && (r[a] = Object.freeze(c)), c;
  }
  getSharedOptions(t) {
    if (t.$shared)
      return this._sharedOptions || (this._sharedOptions = Object.assign({}, t));
  }
  includeOptions(t, e) {
    return !e || Io(t) || this.chart._animationsDisabled;
  }
  _getSharedOptions(t, e) {
    const n = this.resolveDataElementOptions(t, e), s = this._sharedOptions, r = this.getSharedOptions(n), a = this.includeOptions(e, r) || r !== s;
    return this.updateSharedOptions(r, e, n), { sharedOptions: r, includeOptions: a };
  }
  updateElement(t, e, n, s) {
    Io(s) ? Object.assign(t, n) : this._resolveAnimations(e, s).update(t, n);
  }
  updateSharedOptions(t, e, n) {
    t && !Io(e) && this._resolveAnimations(void 0, e).update(t, n);
  }
  _setStyle(t, e, n, s) {
    t.active = s;
    const r = this.getStyle(e, s);
    this._resolveAnimations(e, n, s).update(t, {
      options: !s && this.getSharedOptions(r) || r
    });
  }
  removeHoverStyle(t, e, n) {
    this._setStyle(t, n, "active", !1);
  }
  setHoverStyle(t, e, n) {
    this._setStyle(t, n, "active", !0);
  }
  _removeDatasetHoverStyle() {
    const t = this._cachedMeta.dataset;
    t && this._setStyle(t, void 0, "active", !1);
  }
  _setDatasetHoverStyle() {
    const t = this._cachedMeta.dataset;
    t && this._setStyle(t, void 0, "active", !0);
  }
  _resyncElements(t) {
    const e = this._data, n = this._cachedMeta.data;
    for (const [o, l, c] of this._syncList)
      this[o](l, c);
    this._syncList = [];
    const s = n.length, r = e.length, a = Math.min(r, s);
    a && this.parse(0, a), r > s ? this._insertElements(s, r - s, t) : r < s && this._removeElements(r, s - r);
  }
  _insertElements(t, e, n = !0) {
    const s = this._cachedMeta, r = s.data, a = t + e;
    let o;
    const l = (c) => {
      for (c.length += e, o = c.length - 1; o >= a; o--)
        c[o] = c[o - e];
    };
    for (l(r), o = t; o < a; ++o)
      r[o] = new this.dataElementType();
    this._parsing && l(s._parsed), this.parse(t, e), n && this.updateElements(r, t, e, "reset");
  }
  updateElements(t, e, n, s) {
  }
  _removeElements(t, e) {
    const n = this._cachedMeta;
    if (this._parsing) {
      const s = n._parsed.splice(t, e);
      n._stacked && bs(n, s);
    }
    n.data.splice(t, e);
  }
  _sync(t) {
    if (this._parsing)
      this._syncList.push(t);
    else {
      const [e, n, s] = t;
      this[e](n, s);
    }
    this.chart._dataChanges.push([this.index, ...t]);
  }
  _onDataPush() {
    const t = arguments.length;
    this._sync(["_insertElements", this.getDataset().data.length - t, t]);
  }
  _onDataPop() {
    this._sync(["_removeElements", this._cachedMeta.data.length - 1, 1]);
  }
  _onDataShift() {
    this._sync(["_removeElements", 0, 1]);
  }
  _onDataSplice(t, e) {
    e && this._sync(["_removeElements", t, e]);
    const n = arguments.length - 2;
    n && this._sync(["_insertElements", t, n]);
  }
  _onDataUnshift() {
    this._sync(["_insertElements", 0, arguments.length]);
  }
}
ii.defaults = {};
ii.prototype.datasetElementType = null;
ii.prototype.dataElementType = null;
function qS(i, t) {
  if (!i._cache.$bar) {
    const e = i.getMatchingVisibleMetas(t);
    let n = [];
    for (let s = 0, r = e.length; s < r; s++)
      n = n.concat(e[s].controller.getAllParsedValues(i));
    i._cache.$bar = Fp(n.sort((s, r) => s - r));
  }
  return i._cache.$bar;
}
function tw(i) {
  const t = i.iScale, e = qS(t, i.type);
  let n = t._length, s, r, a, o;
  const l = () => {
    a === 32767 || a === -32768 || (Ze(o) && (n = Math.min(n, Math.abs(a - o) || n)), o = a);
  };
  for (s = 0, r = e.length; s < r; ++s)
    a = t.getPixelForValue(e[s]), l();
  for (o = void 0, s = 0, r = t.ticks.length; s < r; ++s)
    a = t.getPixelForTick(s), l();
  return n;
}
function ew(i, t, e, n) {
  const s = e.barThickness;
  let r, a;
  return kt(s) ? (r = t.min * e.categoryPercentage, a = e.barPercentage) : (r = s * n, a = 1), {
    chunk: r / n,
    ratio: a,
    start: t.pixels[i] - r / 2
  };
}
function iw(i, t, e, n) {
  const s = t.pixels, r = s[i];
  let a = i > 0 ? s[i - 1] : null, o = i < s.length - 1 ? s[i + 1] : null;
  const l = e.categoryPercentage;
  a === null && (a = r - (o === null ? t.end - t.start : o - r)), o === null && (o = r + r - a);
  const c = r - (r - Math.min(a, o)) / 2 * l;
  return {
    chunk: Math.abs(o - a) / 2 * l / n,
    ratio: e.barPercentage,
    start: c
  };
}
function nw(i, t, e, n) {
  const s = e.parse(i[0], n), r = e.parse(i[1], n), a = Math.min(s, r), o = Math.max(s, r);
  let l = a, c = o;
  Math.abs(a) > Math.abs(o) && (l = o, c = a), t[e.axis] = c, t._custom = {
    barStart: l,
    barEnd: c,
    start: s,
    end: r,
    min: a,
    max: o
  };
}
function lg(i, t, e, n) {
  return $t(i) ? nw(i, t, e, n) : t[e.axis] = e.parse(i, n), t;
}
function pd(i, t, e, n) {
  const s = i.iScale, r = i.vScale, a = s.getLabels(), o = s === r, l = [];
  let c, u, d, h;
  for (c = e, u = e + n; c < u; ++c)
    h = t[c], d = {}, d[s.axis] = o || s.parse(a[c], c), l.push(lg(h, d, r, c));
  return l;
}
function Eo(i) {
  return i && i.barStart !== void 0 && i.barEnd !== void 0;
}
function sw(i, t, e) {
  return i !== 0 ? vi(i) : (t.isHorizontal() ? 1 : -1) * (t.min >= e ? 1 : -1);
}
function rw(i) {
  let t, e, n, s, r;
  return i.horizontal ? (t = i.base > i.x, e = "left", n = "right") : (t = i.base < i.y, e = "bottom", n = "top"), t ? (s = "end", r = "start") : (s = "start", r = "end"), { start: e, end: n, reverse: t, top: s, bottom: r };
}
function aw(i, t, e, n) {
  let s = t.borderSkipped;
  const r = {};
  if (!s) {
    i.borderSkipped = r;
    return;
  }
  if (s === !0) {
    i.borderSkipped = { top: !0, right: !0, bottom: !0, left: !0 };
    return;
  }
  const { start: a, end: o, reverse: l, top: c, bottom: u } = rw(i);
  s === "middle" && e && (i.enableBorderRadius = !0, (e._top || 0) === n ? s = c : (e._bottom || 0) === n ? s = u : (r[gd(u, a, o, l)] = !0, s = c)), r[gd(s, a, o, l)] = !0, i.borderSkipped = r;
}
function gd(i, t, e, n) {
  return n ? (i = ow(i, t, e), i = md(i, e, t)) : i = md(i, t, e), i;
}
function ow(i, t, e) {
  return i === t ? e : i === e ? t : i;
}
function md(i, t, e) {
  return i === "start" ? t : i === "end" ? e : i;
}
function lw(i, { inflateAmount: t }, e) {
  i.inflateAmount = t === "auto" ? e === 1 ? 0.33 : 0 : t;
}
class dr extends ii {
  parsePrimitiveData(t, e, n, s) {
    return pd(t, e, n, s);
  }
  parseArrayData(t, e, n, s) {
    return pd(t, e, n, s);
  }
  parseObjectData(t, e, n, s) {
    const { iScale: r, vScale: a } = t, { xAxisKey: o = "x", yAxisKey: l = "y" } = this._parsing, c = r.axis === "x" ? o : l, u = a.axis === "x" ? o : l, d = [];
    let h, f, p, g;
    for (h = n, f = n + s; h < f; ++h)
      g = e[h], p = {}, p[r.axis] = r.parse(qi(g, c), h), d.push(lg(qi(g, u), p, a, h));
    return d;
  }
  updateRangeFromParsed(t, e, n, s) {
    super.updateRangeFromParsed(t, e, n, s);
    const r = n._custom;
    r && e === this._cachedMeta.vScale && (t.min = Math.min(t.min, r.min), t.max = Math.max(t.max, r.max));
  }
  getMaxOverflow() {
    return 0;
  }
  getLabelAndValue(t) {
    const e = this._cachedMeta, { iScale: n, vScale: s } = e, r = this.getParsed(t), a = r._custom, o = Eo(a) ? "[" + a.start + ", " + a.end + "]" : "" + s.getLabelForValue(r[s.axis]);
    return {
      label: "" + n.getLabelForValue(r[n.axis]),
      value: o
    };
  }
  initialize() {
    this.enableOptionSharing = !0, super.initialize();
    const t = this._cachedMeta;
    t.stack = this.getDataset().stack;
  }
  update(t) {
    const e = this._cachedMeta;
    this.updateElements(e.data, 0, e.data.length, t);
  }
  updateElements(t, e, n, s) {
    const r = s === "reset", { index: a, _cachedMeta: { vScale: o } } = this, l = o.getBasePixel(), c = o.isHorizontal(), u = this._getRuler(), { sharedOptions: d, includeOptions: h } = this._getSharedOptions(e, s);
    for (let f = e; f < e + n; f++) {
      const p = this.getParsed(f), g = r || kt(p[o.axis]) ? { base: l, head: l } : this._calculateBarValuePixels(f), m = this._calculateBarIndexPixels(f, u), v = (p._stacks || {})[o.axis], b = {
        horizontal: c,
        base: g.base,
        enableBorderRadius: !v || Eo(p._custom) || a === v._top || a === v._bottom,
        x: c ? g.head : m.center,
        y: c ? m.center : g.head,
        height: c ? m.size : Math.abs(g.size),
        width: c ? Math.abs(g.size) : m.size
      };
      h && (b.options = d || this.resolveDataElementOptions(f, t[f].active ? "active" : s));
      const _ = b.options || t[f].options;
      aw(b, _, v, a), lw(b, _, u.ratio), this.updateElement(t[f], f, b, s);
    }
  }
  _getStacks(t, e) {
    const { iScale: n } = this._cachedMeta, s = n.getMatchingVisibleMetas(this._type).filter((l) => l.controller.options.grouped), r = n.options.stacked, a = [], o = (l) => {
      const c = l.controller.getParsed(e), u = c && c[l.vScale.axis];
      if (kt(u) || isNaN(u))
        return !0;
    };
    for (const l of s)
      if (!(e !== void 0 && o(l)) && ((r === !1 || a.indexOf(l.stack) === -1 || r === void 0 && l.stack === void 0) && a.push(l.stack), l.index === t))
        break;
    return a.length || a.push(void 0), a;
  }
  _getStackCount(t) {
    return this._getStacks(void 0, t).length;
  }
  _getStackIndex(t, e, n) {
    const s = this._getStacks(t, n), r = e !== void 0 ? s.indexOf(e) : -1;
    return r === -1 ? s.length - 1 : r;
  }
  _getRuler() {
    const t = this.options, e = this._cachedMeta, n = e.iScale, s = [];
    let r, a;
    for (r = 0, a = e.data.length; r < a; ++r)
      s.push(n.getPixelForValue(this.getParsed(r)[n.axis], r));
    const o = t.barThickness;
    return {
      min: o || tw(e),
      pixels: s,
      start: n._startPixel,
      end: n._endPixel,
      stackCount: this._getStackCount(),
      scale: n,
      grouped: t.grouped,
      ratio: o ? 1 : t.categoryPercentage * t.barPercentage
    };
  }
  _calculateBarValuePixels(t) {
    const { _cachedMeta: { vScale: e, _stacked: n }, options: { base: s, minBarLength: r } } = this, a = s || 0, o = this.getParsed(t), l = o._custom, c = Eo(l);
    let u = o[e.axis], d = 0, h = n ? this.applyStack(e, o, n) : u, f, p;
    h !== u && (d = h - u, h = u), c && (u = l.barStart, h = l.barEnd - l.barStart, u !== 0 && vi(u) !== vi(l.barEnd) && (d = 0), d += u);
    const g = !kt(s) && !c ? s : d;
    let m = e.getPixelForValue(g);
    if (this.chart.getDataVisibility(t) ? f = e.getPixelForValue(d + h) : f = m, p = f - m, Math.abs(p) < r) {
      p = sw(p, e, a) * r, u === a && (m -= p / 2);
      const v = e.getPixelForDecimal(0), b = e.getPixelForDecimal(1), _ = Math.min(v, b), S = Math.max(v, b);
      m = Math.max(Math.min(m, S), _), f = m + p;
    }
    if (m === e.getPixelForValue(a)) {
      const v = vi(p) * e.getLineWidthForValue(a) / 2;
      m += v, p -= v;
    }
    return {
      size: p,
      base: m,
      head: f,
      center: f + p / 2
    };
  }
  _calculateBarIndexPixels(t, e) {
    const n = e.scale, s = this.options, r = s.skipNull, a = yt(s.maxBarThickness, 1 / 0);
    let o, l;
    if (e.grouped) {
      const c = r ? this._getStackCount(t) : e.stackCount, u = s.barThickness === "flex" ? iw(t, e, s, c) : ew(t, e, s, c), d = this._getStackIndex(this.index, this._cachedMeta.stack, r ? t : void 0);
      o = u.start + u.chunk * d + u.chunk / 2, l = Math.min(a, u.chunk * u.ratio);
    } else
      o = n.getPixelForValue(this.getParsed(t)[n.axis], t), l = Math.min(a, e.min * e.ratio);
    return {
      base: o - l / 2,
      head: o + l / 2,
      center: o,
      size: l
    };
  }
  draw() {
    const t = this._cachedMeta, e = t.vScale, n = t.data, s = n.length;
    let r = 0;
    for (; r < s; ++r)
      this.getParsed(r)[e.axis] !== null && n[r].draw(this._ctx);
  }
}
dr.id = "bar";
dr.defaults = {
  datasetElementType: !1,
  dataElementType: "bar",
  categoryPercentage: 0.8,
  barPercentage: 0.9,
  grouped: !0,
  animations: {
    numbers: {
      type: "number",
      properties: ["x", "y", "base", "width", "height"]
    }
  }
};
dr.overrides = {
  scales: {
    _index_: {
      type: "category",
      offset: !0,
      grid: {
        offset: !0
      }
    },
    _value_: {
      type: "linear",
      beginAtZero: !0
    }
  }
};
class $a extends ii {
  initialize() {
    this.enableOptionSharing = !0, super.initialize();
  }
  parsePrimitiveData(t, e, n, s) {
    const r = super.parsePrimitiveData(t, e, n, s);
    for (let a = 0; a < r.length; a++)
      r[a]._custom = this.resolveDataElementOptions(a + n).radius;
    return r;
  }
  parseArrayData(t, e, n, s) {
    const r = super.parseArrayData(t, e, n, s);
    for (let a = 0; a < r.length; a++) {
      const o = e[n + a];
      r[a]._custom = yt(o[2], this.resolveDataElementOptions(a + n).radius);
    }
    return r;
  }
  parseObjectData(t, e, n, s) {
    const r = super.parseObjectData(t, e, n, s);
    for (let a = 0; a < r.length; a++) {
      const o = e[n + a];
      r[a]._custom = yt(o && o.r && +o.r, this.resolveDataElementOptions(a + n).radius);
    }
    return r;
  }
  getMaxOverflow() {
    const t = this._cachedMeta.data;
    let e = 0;
    for (let n = t.length - 1; n >= 0; --n)
      e = Math.max(e, t[n].size(this.resolveDataElementOptions(n)) / 2);
    return e > 0 && e;
  }
  getLabelAndValue(t) {
    const e = this._cachedMeta, { xScale: n, yScale: s } = e, r = this.getParsed(t), a = n.getLabelForValue(r.x), o = s.getLabelForValue(r.y), l = r._custom;
    return {
      label: e.label,
      value: "(" + a + ", " + o + (l ? ", " + l : "") + ")"
    };
  }
  update(t) {
    const e = this._cachedMeta.data;
    this.updateElements(e, 0, e.length, t);
  }
  updateElements(t, e, n, s) {
    const r = s === "reset", { iScale: a, vScale: o } = this._cachedMeta, { sharedOptions: l, includeOptions: c } = this._getSharedOptions(e, s), u = a.axis, d = o.axis;
    for (let h = e; h < e + n; h++) {
      const f = t[h], p = !r && this.getParsed(h), g = {}, m = g[u] = r ? a.getPixelForDecimal(0.5) : a.getPixelForValue(p[u]), v = g[d] = r ? o.getBasePixel() : o.getPixelForValue(p[d]);
      g.skip = isNaN(m) || isNaN(v), c && (g.options = l || this.resolveDataElementOptions(h, f.active ? "active" : s), r && (g.options.radius = 0)), this.updateElement(f, h, g, s);
    }
  }
  resolveDataElementOptions(t, e) {
    const n = this.getParsed(t);
    let s = super.resolveDataElementOptions(t, e);
    s.$shared && (s = Object.assign({}, s, { $shared: !1 }));
    const r = s.radius;
    return e !== "active" && (s.radius = 0), s.radius += yt(n && n._custom, r), s;
  }
}
$a.id = "bubble";
$a.defaults = {
  datasetElementType: !1,
  dataElementType: "point",
  animations: {
    numbers: {
      type: "number",
      properties: ["x", "y", "borderWidth", "radius"]
    }
  }
};
$a.overrides = {
  scales: {
    x: {
      type: "linear"
    },
    y: {
      type: "linear"
    }
  },
  plugins: {
    tooltip: {
      callbacks: {
        title() {
          return "";
        }
      }
    }
  }
};
function cw(i, t, e) {
  let n = 1, s = 1, r = 0, a = 0;
  if (t < Tt) {
    const o = i, l = o + t, c = Math.cos(o), u = Math.sin(o), d = Math.cos(l), h = Math.sin(l), f = (_, S, C) => Zs(_, o, l, !0) ? 1 : Math.max(S, S * e, C, C * e), p = (_, S, C) => Zs(_, o, l, !0) ? -1 : Math.min(S, S * e, C, C * e), g = f(0, c, d), m = f(Wt, u, h), v = p(Bt, c, d), b = p(Bt + Wt, u, h);
    n = (g - v) / 2, s = (m - b) / 2, r = -(g + v) / 2, a = -(m + b) / 2;
  }
  return { ratioX: n, ratioY: s, offsetX: r, offsetY: a };
}
class fs extends ii {
  constructor(t, e) {
    super(t, e), this.enableOptionSharing = !0, this.innerRadius = void 0, this.outerRadius = void 0, this.offsetX = void 0, this.offsetY = void 0;
  }
  linkScales() {
  }
  parse(t, e) {
    const n = this.getDataset().data, s = this._cachedMeta;
    if (this._parsing === !1)
      s._parsed = n;
    else {
      let r = (l) => +n[l];
      if (St(n[t])) {
        const { key: l = "value" } = this._parsing;
        r = (c) => +qi(n[c], l);
      }
      let a, o;
      for (a = t, o = t + e; a < o; ++a)
        s._parsed[a] = r(a);
    }
  }
  _getRotation() {
    return qe(this.options.rotation - 90);
  }
  _getCircumference() {
    return qe(this.options.circumference);
  }
  _getRotationExtents() {
    let t = Tt, e = -Tt;
    for (let n = 0; n < this.chart.data.datasets.length; ++n)
      if (this.chart.isDatasetVisible(n)) {
        const s = this.chart.getDatasetMeta(n).controller, r = s._getRotation(), a = s._getCircumference();
        t = Math.min(t, r), e = Math.max(e, r + a);
      }
    return {
      rotation: t,
      circumference: e - t
    };
  }
  update(t) {
    const e = this.chart, { chartArea: n } = e, s = this._cachedMeta, r = s.data, a = this.getMaxBorderWidth() + this.getMaxOffset(r) + this.options.spacing, o = Math.max((Math.min(n.width, n.height) - a) / 2, 0), l = Math.min(nC(this.options.cutout, o), 1), c = this._getRingWeight(this.index), { circumference: u, rotation: d } = this._getRotationExtents(), { ratioX: h, ratioY: f, offsetX: p, offsetY: g } = cw(d, u, l), m = (n.width - a) / h, v = (n.height - a) / f, b = Math.max(Math.min(m, v) / 2, 0), _ = Ip(this.options.radius, b), S = Math.max(_ * l, 0), C = (_ - S) / this._getVisibleDatasetWeightTotal();
    this.offsetX = p * _, this.offsetY = g * _, s.total = this.calculateTotal(), this.outerRadius = _ - C * this._getRingWeightOffset(this.index), this.innerRadius = Math.max(this.outerRadius - C * c, 0), this.updateElements(r, 0, r.length, t);
  }
  _circumference(t, e) {
    const n = this.options, s = this._cachedMeta, r = this._getCircumference();
    return e && n.animation.animateRotate || !this.chart.getDataVisibility(t) || s._parsed[t] === null || s.data[t].hidden ? 0 : this.calculateCircumference(s._parsed[t] * r / Tt);
  }
  updateElements(t, e, n, s) {
    const r = s === "reset", a = this.chart, o = a.chartArea, c = a.options.animation, u = (o.left + o.right) / 2, d = (o.top + o.bottom) / 2, h = r && c.animateScale, f = h ? 0 : this.innerRadius, p = h ? 0 : this.outerRadius, { sharedOptions: g, includeOptions: m } = this._getSharedOptions(e, s);
    let v = this._getRotation(), b;
    for (b = 0; b < e; ++b)
      v += this._circumference(b, r);
    for (b = e; b < e + n; ++b) {
      const _ = this._circumference(b, r), S = t[b], C = {
        x: u + this.offsetX,
        y: d + this.offsetY,
        startAngle: v,
        endAngle: v + _,
        circumference: _,
        outerRadius: p,
        innerRadius: f
      };
      m && (C.options = g || this.resolveDataElementOptions(b, S.active ? "active" : s)), v += _, this.updateElement(S, b, C, s);
    }
  }
  calculateTotal() {
    const t = this._cachedMeta, e = t.data;
    let n = 0, s;
    for (s = 0; s < e.length; s++) {
      const r = t._parsed[s];
      r !== null && !isNaN(r) && this.chart.getDataVisibility(s) && !e[s].hidden && (n += Math.abs(r));
    }
    return n;
  }
  calculateCircumference(t) {
    const e = this._cachedMeta.total;
    return e > 0 && !isNaN(t) ? Tt * (Math.abs(t) / e) : 0;
  }
  getLabelAndValue(t) {
    const e = this._cachedMeta, n = this.chart, s = n.data.labels || [], r = ur(e._parsed[t], n.options.locale);
    return {
      label: s[t] || "",
      value: r
    };
  }
  getMaxBorderWidth(t) {
    let e = 0;
    const n = this.chart;
    let s, r, a, o, l;
    if (!t) {
      for (s = 0, r = n.data.datasets.length; s < r; ++s)
        if (n.isDatasetVisible(s)) {
          a = n.getDatasetMeta(s), t = a.data, o = a.controller;
          break;
        }
    }
    if (!t)
      return 0;
    for (s = 0, r = t.length; s < r; ++s)
      l = o.resolveDataElementOptions(s), l.borderAlign !== "inner" && (e = Math.max(e, l.borderWidth || 0, l.hoverBorderWidth || 0));
    return e;
  }
  getMaxOffset(t) {
    let e = 0;
    for (let n = 0, s = t.length; n < s; ++n) {
      const r = this.resolveDataElementOptions(n);
      e = Math.max(e, r.offset || 0, r.hoverOffset || 0);
    }
    return e;
  }
  _getRingWeightOffset(t) {
    let e = 0;
    for (let n = 0; n < t; ++n)
      this.chart.isDatasetVisible(n) && (e += this._getRingWeight(n));
    return e;
  }
  _getRingWeight(t) {
    return Math.max(yt(this.chart.data.datasets[t].weight, 1), 0);
  }
  _getVisibleDatasetWeightTotal() {
    return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
  }
}
fs.id = "doughnut";
fs.defaults = {
  datasetElementType: !1,
  dataElementType: "arc",
  animation: {
    animateRotate: !0,
    animateScale: !1
  },
  animations: {
    numbers: {
      type: "number",
      properties: ["circumference", "endAngle", "innerRadius", "outerRadius", "startAngle", "x", "y", "offset", "borderWidth", "spacing"]
    }
  },
  cutout: "50%",
  rotation: 0,
  circumference: 360,
  radius: "100%",
  spacing: 0,
  indexAxis: "r"
};
fs.descriptors = {
  _scriptable: (i) => i !== "spacing",
  _indexable: (i) => i !== "spacing"
};
fs.overrides = {
  aspectRatio: 1,
  plugins: {
    legend: {
      labels: {
        generateLabels(i) {
          const t = i.data;
          if (t.labels.length && t.datasets.length) {
            const { labels: { pointStyle: e } } = i.legend.options;
            return t.labels.map((n, s) => {
              const a = i.getDatasetMeta(0).controller.getStyle(s);
              return {
                text: n,
                fillStyle: a.backgroundColor,
                strokeStyle: a.borderColor,
                lineWidth: a.borderWidth,
                pointStyle: e,
                hidden: !i.getDataVisibility(s),
                index: s
              };
            });
          }
          return [];
        }
      },
      onClick(i, t, e) {
        e.chart.toggleDataVisibility(t.index), e.chart.update();
      }
    },
    tooltip: {
      callbacks: {
        title() {
          return "";
        },
        label(i) {
          let t = i.label;
          const e = ": " + i.formattedValue;
          return $t(t) ? (t = t.slice(), t[0] += e) : t += e, t;
        }
      }
    }
  }
};
class Ba extends ii {
  initialize() {
    this.enableOptionSharing = !0, this.supportsDecimation = !0, super.initialize();
  }
  update(t) {
    const e = this._cachedMeta, { dataset: n, data: s = [], _dataset: r } = e, a = this.chart._animationsDisabled;
    let { start: o, count: l } = Vp(e, s, a);
    this._drawStart = o, this._drawCount = l, zp(e) && (o = 0, l = s.length), n._chart = this.chart, n._datasetIndex = this.index, n._decimated = !!r._decimated, n.points = s;
    const c = this.resolveDatasetElementOptions(t);
    this.options.showLine || (c.borderWidth = 0), c.segment = this.options.segment, this.updateElement(n, void 0, {
      animated: !a,
      options: c
    }, t), this.updateElements(s, o, l, t);
  }
  updateElements(t, e, n, s) {
    const r = s === "reset", { iScale: a, vScale: o, _stacked: l, _dataset: c } = this._cachedMeta, { sharedOptions: u, includeOptions: d } = this._getSharedOptions(e, s), h = a.axis, f = o.axis, { spanGaps: p, segment: g } = this.options, m = ns(p) ? p : Number.POSITIVE_INFINITY, v = this.chart._animationsDisabled || r || s === "none";
    let b = e > 0 && this.getParsed(e - 1);
    for (let _ = e; _ < e + n; ++_) {
      const S = t[_], C = this.getParsed(_), O = v ? S : {}, k = kt(C[f]), P = O[h] = a.getPixelForValue(C[h], _), x = O[f] = r || k ? o.getBasePixel() : o.getPixelForValue(l ? this.applyStack(o, C, l) : C[f], _);
      O.skip = isNaN(P) || isNaN(x) || k, O.stop = _ > 0 && Math.abs(C[h] - b[h]) > m, g && (O.parsed = C, O.raw = c.data[_]), d && (O.options = u || this.resolveDataElementOptions(_, S.active ? "active" : s)), v || this.updateElement(S, _, O, s), b = C;
    }
  }
  getMaxOverflow() {
    const t = this._cachedMeta, e = t.dataset, n = e.options && e.options.borderWidth || 0, s = t.data || [];
    if (!s.length)
      return n;
    const r = s[0].size(this.resolveDataElementOptions(0)), a = s[s.length - 1].size(this.resolveDataElementOptions(s.length - 1));
    return Math.max(n, r, a) / 2;
  }
  draw() {
    const t = this._cachedMeta;
    t.dataset.updateControlPoints(this.chart.chartArea, t.iScale.axis), super.draw();
  }
}
Ba.id = "line";
Ba.defaults = {
  datasetElementType: "line",
  dataElementType: "point",
  showLine: !0,
  spanGaps: !1
};
Ba.overrides = {
  scales: {
    _index_: {
      type: "category"
    },
    _value_: {
      type: "linear"
    }
  }
};
class _c extends ii {
  constructor(t, e) {
    super(t, e), this.innerRadius = void 0, this.outerRadius = void 0;
  }
  getLabelAndValue(t) {
    const e = this._cachedMeta, n = this.chart, s = n.data.labels || [], r = ur(e._parsed[t].r, n.options.locale);
    return {
      label: s[t] || "",
      value: r
    };
  }
  parseObjectData(t, e, n, s) {
    return tg.bind(this)(t, e, n, s);
  }
  update(t) {
    const e = this._cachedMeta.data;
    this._updateRadius(), this.updateElements(e, 0, e.length, t);
  }
  getMinMax() {
    const t = this._cachedMeta, e = { min: Number.POSITIVE_INFINITY, max: Number.NEGATIVE_INFINITY };
    return t.data.forEach((n, s) => {
      const r = this.getParsed(s).r;
      !isNaN(r) && this.chart.getDataVisibility(s) && (r < e.min && (e.min = r), r > e.max && (e.max = r));
    }), e;
  }
  _updateRadius() {
    const t = this.chart, e = t.chartArea, n = t.options, s = Math.min(e.right - e.left, e.bottom - e.top), r = Math.max(s / 2, 0), a = Math.max(n.cutoutPercentage ? r / 100 * n.cutoutPercentage : 1, 0), o = (r - a) / t.getVisibleDatasetCount();
    this.outerRadius = r - o * this.index, this.innerRadius = this.outerRadius - o;
  }
  updateElements(t, e, n, s) {
    const r = s === "reset", a = this.chart, l = a.options.animation, c = this._cachedMeta.rScale, u = c.xCenter, d = c.yCenter, h = c.getIndexAngle(0) - 0.5 * Bt;
    let f = h, p;
    const g = 360 / this.countVisibleElements();
    for (p = 0; p < e; ++p)
      f += this._computeAngle(p, s, g);
    for (p = e; p < e + n; p++) {
      const m = t[p];
      let v = f, b = f + this._computeAngle(p, s, g), _ = a.getDataVisibility(p) ? c.getDistanceFromCenterForValue(this.getParsed(p).r) : 0;
      f = b, r && (l.animateScale && (_ = 0), l.animateRotate && (v = b = h));
      const S = {
        x: u,
        y: d,
        innerRadius: 0,
        outerRadius: _,
        startAngle: v,
        endAngle: b,
        options: this.resolveDataElementOptions(p, m.active ? "active" : s)
      };
      this.updateElement(m, p, S, s);
    }
  }
  countVisibleElements() {
    const t = this._cachedMeta;
    let e = 0;
    return t.data.forEach((n, s) => {
      !isNaN(this.getParsed(s).r) && this.chart.getDataVisibility(s) && e++;
    }), e;
  }
  _computeAngle(t, e, n) {
    return this.chart.getDataVisibility(t) ? qe(this.resolveDataElementOptions(t, e).angle || n) : 0;
  }
}
_c.id = "polarArea";
_c.defaults = {
  dataElementType: "arc",
  animation: {
    animateRotate: !0,
    animateScale: !0
  },
  animations: {
    numbers: {
      type: "number",
      properties: ["x", "y", "startAngle", "endAngle", "innerRadius", "outerRadius"]
    }
  },
  indexAxis: "r",
  startAngle: 0
};
_c.overrides = {
  aspectRatio: 1,
  plugins: {
    legend: {
      labels: {
        generateLabels(i) {
          const t = i.data;
          if (t.labels.length && t.datasets.length) {
            const { labels: { pointStyle: e } } = i.legend.options;
            return t.labels.map((n, s) => {
              const a = i.getDatasetMeta(0).controller.getStyle(s);
              return {
                text: n,
                fillStyle: a.backgroundColor,
                strokeStyle: a.borderColor,
                lineWidth: a.borderWidth,
                pointStyle: e,
                hidden: !i.getDataVisibility(s),
                index: s
              };
            });
          }
          return [];
        }
      },
      onClick(i, t, e) {
        e.chart.toggleDataVisibility(t.index), e.chart.update();
      }
    },
    tooltip: {
      callbacks: {
        title() {
          return "";
        },
        label(i) {
          return i.chart.data.labels[i.dataIndex] + ": " + i.formattedValue;
        }
      }
    }
  },
  scales: {
    r: {
      type: "radialLinear",
      angleLines: {
        display: !1
      },
      beginAtZero: !0,
      grid: {
        circular: !0
      },
      pointLabels: {
        display: !1
      },
      startAngle: 0
    }
  }
};
class cg extends fs {
}
cg.id = "pie";
cg.defaults = {
  cutout: 0,
  rotation: 0,
  circumference: 360,
  radius: "100%"
};
class xc extends ii {
  getLabelAndValue(t) {
    const e = this._cachedMeta.vScale, n = this.getParsed(t);
    return {
      label: e.getLabels()[t],
      value: "" + e.getLabelForValue(n[e.axis])
    };
  }
  parseObjectData(t, e, n, s) {
    return tg.bind(this)(t, e, n, s);
  }
  update(t) {
    const e = this._cachedMeta, n = e.dataset, s = e.data || [], r = e.iScale.getLabels();
    if (n.points = s, t !== "resize") {
      const a = this.resolveDatasetElementOptions(t);
      this.options.showLine || (a.borderWidth = 0);
      const o = {
        _loop: !0,
        _fullLoop: r.length === s.length,
        options: a
      };
      this.updateElement(n, void 0, o, t);
    }
    this.updateElements(s, 0, s.length, t);
  }
  updateElements(t, e, n, s) {
    const r = this._cachedMeta.rScale, a = s === "reset";
    for (let o = e; o < e + n; o++) {
      const l = t[o], c = this.resolveDataElementOptions(o, l.active ? "active" : s), u = r.getPointPositionForValue(o, this.getParsed(o).r), d = a ? r.xCenter : u.x, h = a ? r.yCenter : u.y, f = {
        x: d,
        y: h,
        angle: u.angle,
        skip: isNaN(d) || isNaN(h),
        options: c
      };
      this.updateElement(l, o, f, s);
    }
  }
}
xc.id = "radar";
xc.defaults = {
  datasetElementType: "line",
  dataElementType: "point",
  indexAxis: "r",
  showLine: !0,
  elements: {
    line: {
      fill: "start"
    }
  }
};
xc.overrides = {
  aspectRatio: 1,
  scales: {
    r: {
      type: "radialLinear"
    }
  }
};
let ni = class {
  constructor() {
    this.x = void 0, this.y = void 0, this.active = !1, this.options = void 0, this.$animations = void 0;
  }
  tooltipPosition(t) {
    const { x: e, y: n } = this.getProps(["x", "y"], t);
    return { x: e, y: n };
  }
  hasValue() {
    return ns(this.x) && ns(this.y);
  }
  getProps(t, e) {
    const n = this.$animations;
    if (!e || !n)
      return this;
    const s = {};
    return t.forEach((r) => {
      s[r] = n[r] && n[r].active() ? n[r]._to : this[r];
    }), s;
  }
};
ni.defaults = {};
ni.defaultRoutes = void 0;
const ug = {
  values(i) {
    return $t(i) ? i : "" + i;
  },
  numeric(i, t, e) {
    if (i === 0)
      return "0";
    const n = this.chart.options.locale;
    let s, r = i;
    if (e.length > 1) {
      const c = Math.max(Math.abs(e[0].value), Math.abs(e[e.length - 1].value));
      (c < 1e-4 || c > 1e15) && (s = "scientific"), r = uw(i, e);
    }
    const a = ze(Math.abs(r)), o = Math.max(Math.min(-1 * Math.floor(a), 20), 0), l = { notation: s, minimumFractionDigits: o, maximumFractionDigits: o };
    return Object.assign(l, this.options.ticks.format), ur(i, n, l);
  },
  logarithmic(i, t, e) {
    if (i === 0)
      return "0";
    const n = i / Math.pow(10, Math.floor(ze(i)));
    return n === 1 || n === 2 || n === 5 ? ug.numeric.call(this, i, t, e) : "";
  }
};
function uw(i, t) {
  let e = t.length > 3 ? t[2].value - t[1].value : t[1].value - t[0].value;
  return Math.abs(e) >= 1 && i !== Math.floor(i) && (e = i - Math.floor(i)), e;
}
var Ra = { formatters: ug };
Ct.set("scale", {
  display: !0,
  offset: !1,
  reverse: !1,
  beginAtZero: !1,
  bounds: "ticks",
  grace: 0,
  grid: {
    display: !0,
    lineWidth: 1,
    drawBorder: !0,
    drawOnChartArea: !0,
    drawTicks: !0,
    tickLength: 8,
    tickWidth: (i, t) => t.lineWidth,
    tickColor: (i, t) => t.color,
    offset: !1,
    borderDash: [],
    borderDashOffset: 0,
    borderWidth: 1
  },
  title: {
    display: !1,
    text: "",
    padding: {
      top: 4,
      bottom: 4
    }
  },
  ticks: {
    minRotation: 0,
    maxRotation: 50,
    mirror: !1,
    textStrokeWidth: 0,
    textStrokeColor: "",
    padding: 3,
    display: !0,
    autoSkip: !0,
    autoSkipPadding: 3,
    labelOffset: 0,
    callback: Ra.formatters.values,
    minor: {},
    major: {},
    align: "center",
    crossAlign: "near",
    showLabelBackdrop: !1,
    backdropColor: "rgba(255, 255, 255, 0.75)",
    backdropPadding: 2
  }
});
Ct.route("scale.ticks", "color", "", "color");
Ct.route("scale.grid", "color", "", "borderColor");
Ct.route("scale.grid", "borderColor", "", "borderColor");
Ct.route("scale.title", "color", "", "color");
Ct.describe("scale", {
  _fallback: !1,
  _scriptable: (i) => !i.startsWith("before") && !i.startsWith("after") && i !== "callback" && i !== "parser",
  _indexable: (i) => i !== "borderDash" && i !== "tickBorderDash"
});
Ct.describe("scales", {
  _fallback: "scale"
});
Ct.describe("scale.ticks", {
  _scriptable: (i) => i !== "backdropPadding" && i !== "callback",
  _indexable: (i) => i !== "backdropPadding"
});
function dw(i, t) {
  const e = i.options.ticks, n = e.maxTicksLimit || hw(i), s = e.major.enabled ? pw(t) : [], r = s.length, a = s[0], o = s[r - 1], l = [];
  if (r > n)
    return gw(t, l, s, r / n), l;
  const c = fw(s, t, n);
  if (r > 0) {
    let u, d;
    const h = r > 1 ? Math.round((o - a) / (r - 1)) : null;
    for ($r(t, l, c, kt(h) ? 0 : a - h, a), u = 0, d = r - 1; u < d; u++)
      $r(t, l, c, s[u], s[u + 1]);
    return $r(t, l, c, o, kt(h) ? t.length : o + h), l;
  }
  return $r(t, l, c), l;
}
function hw(i) {
  const t = i.options.offset, e = i._tickSize(), n = i._length / e + (t ? 0 : 1), s = i._maxLength / e;
  return Math.floor(Math.min(n, s));
}
function fw(i, t, e) {
  const n = mw(i), s = t.length / e;
  if (!n)
    return Math.max(s, 1);
  const r = dC(n);
  for (let a = 0, o = r.length - 1; a < o; a++) {
    const l = r[a];
    if (l > s)
      return l;
  }
  return Math.max(s, 1);
}
function pw(i) {
  const t = [];
  let e, n;
  for (e = 0, n = i.length; e < n; e++)
    i[e].major && t.push(e);
  return t;
}
function gw(i, t, e, n) {
  let s = 0, r = e[0], a;
  for (n = Math.ceil(n), a = 0; a < i.length; a++)
    a === r && (t.push(i[a]), s++, r = e[s * n]);
}
function $r(i, t, e, n, s) {
  const r = yt(n, 0), a = Math.min(yt(s, i.length), i.length);
  let o = 0, l, c, u;
  for (e = Math.ceil(e), s && (l = s - n, e = l / Math.floor(l / e)), u = r; u < 0; )
    o++, u = Math.round(r + o * e);
  for (c = Math.max(r, 0); c < a; c++)
    c === u && (t.push(i[c]), o++, u = Math.round(r + o * e));
}
function mw(i) {
  const t = i.length;
  let e, n;
  if (t < 2)
    return !1;
  for (n = i[0], e = 1; e < t; ++e)
    if (i[e] - i[e - 1] !== n)
      return !1;
  return n;
}
const vw = (i) => i === "left" ? "right" : i === "right" ? "left" : i, vd = (i, t, e) => t === "top" || t === "left" ? i[t] + e : i[t] - e;
function Ad(i, t) {
  const e = [], n = i.length / t, s = i.length;
  let r = 0;
  for (; r < s; r += n)
    e.push(i[Math.floor(r)]);
  return e;
}
function Aw(i, t, e) {
  const n = i.ticks.length, s = Math.min(t, n - 1), r = i._startPixel, a = i._endPixel, o = 1e-6;
  let l = i.getPixelForTick(s), c;
  if (!(e && (n === 1 ? c = Math.max(l - r, a - l) : t === 0 ? c = (i.getPixelForTick(1) - l) / 2 : c = (l - i.getPixelForTick(s - 1)) / 2, l += s < t ? c : -c, l < r - o || l > a + o)))
    return l;
}
function bw(i, t) {
  Ot(i, (e) => {
    const n = e.gc, s = n.length / 2;
    let r;
    if (s > t) {
      for (r = 0; r < s; ++r)
        delete e.data[n[r]];
      n.splice(0, s);
    }
  });
}
function ys(i) {
  return i.drawTicks ? i.tickLength : 0;
}
function bd(i, t) {
  if (!i.display)
    return 0;
  const e = Xt(i.font, t), n = ce(i.padding);
  return ($t(i.text) ? i.text.length : 1) * e.lineHeight + n.height;
}
function yw(i, t) {
  return sn(i, {
    scale: t,
    type: "scale"
  });
}
function _w(i, t, e) {
  return sn(i, {
    tick: e,
    index: t,
    type: "tick"
  });
}
function xw(i, t, e) {
  let n = uc(i);
  return (e && t !== "right" || !e && t === "right") && (n = vw(n)), n;
}
function Cw(i, t, e, n) {
  const { top: s, left: r, bottom: a, right: o, chart: l } = i, { chartArea: c, scales: u } = l;
  let d = 0, h, f, p;
  const g = a - s, m = o - r;
  if (i.isHorizontal()) {
    if (f = se(n, r, o), St(e)) {
      const v = Object.keys(e)[0], b = e[v];
      p = u[v].getPixelForValue(b) + g - t;
    } else e === "center" ? p = (c.bottom + c.top) / 2 + g - t : p = vd(i, e, t);
    h = o - r;
  } else {
    if (St(e)) {
      const v = Object.keys(e)[0], b = e[v];
      f = u[v].getPixelForValue(b) - m + t;
    } else e === "center" ? f = (c.left + c.right) / 2 - m + t : f = vd(i, e, t);
    p = se(n, a, s), d = e === "left" ? -Wt : Wt;
  }
  return { titleX: f, titleY: p, maxWidth: h, rotation: d };
}
class Ln extends ni {
  constructor(t) {
    super(), this.id = t.id, this.type = t.type, this.options = void 0, this.ctx = t.ctx, this.chart = t.chart, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this._margins = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, this.maxWidth = void 0, this.maxHeight = void 0, this.paddingTop = void 0, this.paddingBottom = void 0, this.paddingLeft = void 0, this.paddingRight = void 0, this.axis = void 0, this.labelRotation = void 0, this.min = void 0, this.max = void 0, this._range = void 0, this.ticks = [], this._gridLineItems = null, this._labelItems = null, this._labelSizes = null, this._length = 0, this._maxLength = 0, this._longestTextCache = {}, this._startPixel = void 0, this._endPixel = void 0, this._reversePixels = !1, this._userMax = void 0, this._userMin = void 0, this._suggestedMax = void 0, this._suggestedMin = void 0, this._ticksLength = 0, this._borderValue = 0, this._cache = {}, this._dataLimitsCached = !1, this.$context = void 0;
  }
  init(t) {
    this.options = t.setContext(this.getContext()), this.axis = t.axis, this._userMin = this.parse(t.min), this._userMax = this.parse(t.max), this._suggestedMin = this.parse(t.suggestedMin), this._suggestedMax = this.parse(t.suggestedMax);
  }
  parse(t, e) {
    return t;
  }
  getUserBounds() {
    let { _userMin: t, _userMax: e, _suggestedMin: n, _suggestedMax: s } = this;
    return t = Ve(t, Number.POSITIVE_INFINITY), e = Ve(e, Number.NEGATIVE_INFINITY), n = Ve(n, Number.POSITIVE_INFINITY), s = Ve(s, Number.NEGATIVE_INFINITY), {
      min: Ve(t, n),
      max: Ve(e, s),
      minDefined: ee(t),
      maxDefined: ee(e)
    };
  }
  getMinMax(t) {
    let { min: e, max: n, minDefined: s, maxDefined: r } = this.getUserBounds(), a;
    if (s && r)
      return { min: e, max: n };
    const o = this.getMatchingVisibleMetas();
    for (let l = 0, c = o.length; l < c; ++l)
      a = o[l].controller.getMinMax(this, t), s || (e = Math.min(e, a.min)), r || (n = Math.max(n, a.max));
    return e = r && e > n ? n : e, n = s && e > n ? e : n, {
      min: Ve(e, Ve(n, e)),
      max: Ve(n, Ve(e, n))
    };
  }
  getPadding() {
    return {
      left: this.paddingLeft || 0,
      top: this.paddingTop || 0,
      right: this.paddingRight || 0,
      bottom: this.paddingBottom || 0
    };
  }
  getTicks() {
    return this.ticks;
  }
  getLabels() {
    const t = this.chart.data;
    return this.options.labels || (this.isHorizontal() ? t.xLabels : t.yLabels) || t.labels || [];
  }
  beforeLayout() {
    this._cache = {}, this._dataLimitsCached = !1;
  }
  beforeUpdate() {
    Dt(this.options.beforeUpdate, [this]);
  }
  update(t, e, n) {
    const { beginAtZero: s, grace: r, ticks: a } = this.options, o = a.sampleSize;
    this.beforeUpdate(), this.maxWidth = t, this.maxHeight = e, this._margins = n = Object.assign({
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, n), this.ticks = null, this._labelSizes = null, this._gridLineItems = null, this._labelItems = null, this.beforeSetDimensions(), this.setDimensions(), this.afterSetDimensions(), this._maxLength = this.isHorizontal() ? this.width + n.left + n.right : this.height + n.top + n.bottom, this._dataLimitsCached || (this.beforeDataLimits(), this.determineDataLimits(), this.afterDataLimits(), this._range = qC(this, r, s), this._dataLimitsCached = !0), this.beforeBuildTicks(), this.ticks = this.buildTicks() || [], this.afterBuildTicks();
    const l = o < this.ticks.length;
    this._convertTicksToLabels(l ? Ad(this.ticks, o) : this.ticks), this.configure(), this.beforeCalculateLabelRotation(), this.calculateLabelRotation(), this.afterCalculateLabelRotation(), a.display && (a.autoSkip || a.source === "auto") && (this.ticks = dw(this, this.ticks), this._labelSizes = null, this.afterAutoSkip()), l && this._convertTicksToLabels(this.ticks), this.beforeFit(), this.fit(), this.afterFit(), this.afterUpdate();
  }
  configure() {
    let t = this.options.reverse, e, n;
    this.isHorizontal() ? (e = this.left, n = this.right) : (e = this.top, n = this.bottom, t = !t), this._startPixel = e, this._endPixel = n, this._reversePixels = t, this._length = n - e, this._alignToPixels = this.options.alignToPixels;
  }
  afterUpdate() {
    Dt(this.options.afterUpdate, [this]);
  }
  beforeSetDimensions() {
    Dt(this.options.beforeSetDimensions, [this]);
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = 0, this.right = this.width) : (this.height = this.maxHeight, this.top = 0, this.bottom = this.height), this.paddingLeft = 0, this.paddingTop = 0, this.paddingRight = 0, this.paddingBottom = 0;
  }
  afterSetDimensions() {
    Dt(this.options.afterSetDimensions, [this]);
  }
  _callHooks(t) {
    this.chart.notifyPlugins(t, this.getContext()), Dt(this.options[t], [this]);
  }
  beforeDataLimits() {
    this._callHooks("beforeDataLimits");
  }
  determineDataLimits() {
  }
  afterDataLimits() {
    this._callHooks("afterDataLimits");
  }
  beforeBuildTicks() {
    this._callHooks("beforeBuildTicks");
  }
  buildTicks() {
    return [];
  }
  afterBuildTicks() {
    this._callHooks("afterBuildTicks");
  }
  beforeTickToLabelConversion() {
    Dt(this.options.beforeTickToLabelConversion, [this]);
  }
  generateTickLabels(t) {
    const e = this.options.ticks;
    let n, s, r;
    for (n = 0, s = t.length; n < s; n++)
      r = t[n], r.label = Dt(e.callback, [r.value, n, t], this);
  }
  afterTickToLabelConversion() {
    Dt(this.options.afterTickToLabelConversion, [this]);
  }
  beforeCalculateLabelRotation() {
    Dt(this.options.beforeCalculateLabelRotation, [this]);
  }
  calculateLabelRotation() {
    const t = this.options, e = t.ticks, n = this.ticks.length, s = e.minRotation || 0, r = e.maxRotation;
    let a = s, o, l, c;
    if (!this._isVisible() || !e.display || s >= r || n <= 1 || !this.isHorizontal()) {
      this.labelRotation = s;
      return;
    }
    const u = this._getLabelSizes(), d = u.widest.width, h = u.highest.height, f = ae(this.chart.width - d, 0, this.maxWidth);
    o = t.offset ? this.maxWidth / n : f / (n - 1), d + 6 > o && (o = f / (n - (t.offset ? 0.5 : 1)), l = this.maxHeight - ys(t.grid) - e.padding - bd(t.title, this.chart.options.font), c = Math.sqrt(d * d + h * h), a = lc(Math.min(
      Math.asin(ae((u.highest.height + 6) / o, -1, 1)),
      Math.asin(ae(l / c, -1, 1)) - Math.asin(ae(h / c, -1, 1))
    )), a = Math.max(s, Math.min(r, a))), this.labelRotation = a;
  }
  afterCalculateLabelRotation() {
    Dt(this.options.afterCalculateLabelRotation, [this]);
  }
  afterAutoSkip() {
  }
  beforeFit() {
    Dt(this.options.beforeFit, [this]);
  }
  fit() {
    const t = {
      width: 0,
      height: 0
    }, { chart: e, options: { ticks: n, title: s, grid: r } } = this, a = this._isVisible(), o = this.isHorizontal();
    if (a) {
      const l = bd(s, e.options.font);
      if (o ? (t.width = this.maxWidth, t.height = ys(r) + l) : (t.height = this.maxHeight, t.width = ys(r) + l), n.display && this.ticks.length) {
        const { first: c, last: u, widest: d, highest: h } = this._getLabelSizes(), f = n.padding * 2, p = qe(this.labelRotation), g = Math.cos(p), m = Math.sin(p);
        if (o) {
          const v = n.mirror ? 0 : m * d.width + g * h.height;
          t.height = Math.min(this.maxHeight, t.height + v + f);
        } else {
          const v = n.mirror ? 0 : g * d.width + m * h.height;
          t.width = Math.min(this.maxWidth, t.width + v + f);
        }
        this._calculatePadding(c, u, m, g);
      }
    }
    this._handleMargins(), o ? (this.width = this._length = e.width - this._margins.left - this._margins.right, this.height = t.height) : (this.width = t.width, this.height = this._length = e.height - this._margins.top - this._margins.bottom);
  }
  _calculatePadding(t, e, n, s) {
    const { ticks: { align: r, padding: a }, position: o } = this.options, l = this.labelRotation !== 0, c = o !== "top" && this.axis === "x";
    if (this.isHorizontal()) {
      const u = this.getPixelForTick(0) - this.left, d = this.right - this.getPixelForTick(this.ticks.length - 1);
      let h = 0, f = 0;
      l ? c ? (h = s * t.width, f = n * e.height) : (h = n * t.height, f = s * e.width) : r === "start" ? f = e.width : r === "end" ? h = t.width : r !== "inner" && (h = t.width / 2, f = e.width / 2), this.paddingLeft = Math.max((h - u + a) * this.width / (this.width - u), 0), this.paddingRight = Math.max((f - d + a) * this.width / (this.width - d), 0);
    } else {
      let u = e.height / 2, d = t.height / 2;
      r === "start" ? (u = 0, d = t.height) : r === "end" && (u = e.height, d = 0), this.paddingTop = u + a, this.paddingBottom = d + a;
    }
  }
  _handleMargins() {
    this._margins && (this._margins.left = Math.max(this.paddingLeft, this._margins.left), this._margins.top = Math.max(this.paddingTop, this._margins.top), this._margins.right = Math.max(this.paddingRight, this._margins.right), this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom));
  }
  afterFit() {
    Dt(this.options.afterFit, [this]);
  }
  isHorizontal() {
    const { axis: t, position: e } = this.options;
    return e === "top" || e === "bottom" || t === "x";
  }
  isFullSize() {
    return this.options.fullSize;
  }
  _convertTicksToLabels(t) {
    this.beforeTickToLabelConversion(), this.generateTickLabels(t);
    let e, n;
    for (e = 0, n = t.length; e < n; e++)
      kt(t[e].label) && (t.splice(e, 1), n--, e--);
    this.afterTickToLabelConversion();
  }
  _getLabelSizes() {
    let t = this._labelSizes;
    if (!t) {
      const e = this.options.ticks.sampleSize;
      let n = this.ticks;
      e < n.length && (n = Ad(n, e)), this._labelSizes = t = this._computeLabelSizes(n, n.length);
    }
    return t;
  }
  _computeLabelSizes(t, e) {
    const { ctx: n, _longestTextCache: s } = this, r = [], a = [];
    let o = 0, l = 0, c, u, d, h, f, p, g, m, v, b, _;
    for (c = 0; c < e; ++c) {
      if (h = t[c].label, f = this._resolveTickFontOptions(c), n.font = p = f.string, g = s[p] = s[p] || { data: {}, gc: [] }, m = f.lineHeight, v = b = 0, !kt(h) && !$t(h))
        v = ma(n, g.data, g.gc, v, h), b = m;
      else if ($t(h))
        for (u = 0, d = h.length; u < d; ++u)
          _ = h[u], !kt(_) && !$t(_) && (v = ma(n, g.data, g.gc, v, _), b += m);
      r.push(v), a.push(b), o = Math.max(v, o), l = Math.max(b, l);
    }
    bw(s, e);
    const S = r.indexOf(o), C = a.indexOf(l), O = (k) => ({ width: r[k] || 0, height: a[k] || 0 });
    return {
      first: O(0),
      last: O(e - 1),
      widest: O(S),
      highest: O(C),
      widths: r,
      heights: a
    };
  }
  getLabelForValue(t) {
    return t;
  }
  getPixelForValue(t, e) {
    return NaN;
  }
  getValueForPixel(t) {
  }
  getPixelForTick(t) {
    const e = this.ticks;
    return t < 0 || t > e.length - 1 ? null : this.getPixelForValue(e[t].value);
  }
  getPixelForDecimal(t) {
    this._reversePixels && (t = 1 - t);
    const e = this._startPixel + t * this._length;
    return pC(this._alignToPixels ? cn(this.chart, e, 0) : e);
  }
  getDecimalForPixel(t) {
    const e = (t - this._startPixel) / this._length;
    return this._reversePixels ? 1 - e : e;
  }
  getBasePixel() {
    return this.getPixelForValue(this.getBaseValue());
  }
  getBaseValue() {
    const { min: t, max: e } = this;
    return t < 0 && e < 0 ? e : t > 0 && e > 0 ? t : 0;
  }
  getContext(t) {
    const e = this.ticks || [];
    if (t >= 0 && t < e.length) {
      const n = e[t];
      return n.$context || (n.$context = _w(this.getContext(), t, n));
    }
    return this.$context || (this.$context = yw(this.chart.getContext(), this));
  }
  _tickSize() {
    const t = this.options.ticks, e = qe(this.labelRotation), n = Math.abs(Math.cos(e)), s = Math.abs(Math.sin(e)), r = this._getLabelSizes(), a = t.autoSkipPadding || 0, o = r ? r.widest.width + a : 0, l = r ? r.highest.height + a : 0;
    return this.isHorizontal() ? l * n > o * s ? o / n : l / s : l * s < o * n ? l / n : o / s;
  }
  _isVisible() {
    const t = this.options.display;
    return t !== "auto" ? !!t : this.getMatchingVisibleMetas().length > 0;
  }
  _computeGridLineItems(t) {
    const e = this.axis, n = this.chart, s = this.options, { grid: r, position: a } = s, o = r.offset, l = this.isHorizontal(), u = this.ticks.length + (o ? 1 : 0), d = ys(r), h = [], f = r.setContext(this.getContext()), p = f.drawBorder ? f.borderWidth : 0, g = p / 2, m = function(w) {
      return cn(n, w, p);
    };
    let v, b, _, S, C, O, k, P, x, R, B, L;
    if (a === "top")
      v = m(this.bottom), O = this.bottom - d, P = v - g, R = m(t.top) + g, L = t.bottom;
    else if (a === "bottom")
      v = m(this.top), R = t.top, L = m(t.bottom) - g, O = v + g, P = this.top + d;
    else if (a === "left")
      v = m(this.right), C = this.right - d, k = v - g, x = m(t.left) + g, B = t.right;
    else if (a === "right")
      v = m(this.left), x = t.left, B = m(t.right) - g, C = v + g, k = this.left + d;
    else if (e === "x") {
      if (a === "center")
        v = m((t.top + t.bottom) / 2 + 0.5);
      else if (St(a)) {
        const w = Object.keys(a)[0], I = a[w];
        v = m(this.chart.scales[w].getPixelForValue(I));
      }
      R = t.top, L = t.bottom, O = v + g, P = O + d;
    } else if (e === "y") {
      if (a === "center")
        v = m((t.left + t.right) / 2);
      else if (St(a)) {
        const w = Object.keys(a)[0], I = a[w];
        v = m(this.chart.scales[w].getPixelForValue(I));
      }
      C = v - g, k = C - d, x = t.left, B = t.right;
    }
    const Y = yt(s.ticks.maxTicksLimit, u), j = Math.max(1, Math.ceil(u / Y));
    for (b = 0; b < u; b += j) {
      const w = r.setContext(this.getContext(b)), I = w.lineWidth, T = w.color, V = w.borderDash || [], N = w.borderDashOffset, z = w.tickWidth, E = w.tickColor, H = w.tickBorderDash || [], y = w.tickBorderDashOffset;
      _ = Aw(this, b, o), _ !== void 0 && (S = cn(n, _, I), l ? C = k = x = B = S : O = P = R = L = S, h.push({
        tx1: C,
        ty1: O,
        tx2: k,
        ty2: P,
        x1: x,
        y1: R,
        x2: B,
        y2: L,
        width: I,
        color: T,
        borderDash: V,
        borderDashOffset: N,
        tickWidth: z,
        tickColor: E,
        tickBorderDash: H,
        tickBorderDashOffset: y
      }));
    }
    return this._ticksLength = u, this._borderValue = v, h;
  }
  _computeLabelItems(t) {
    const e = this.axis, n = this.options, { position: s, ticks: r } = n, a = this.isHorizontal(), o = this.ticks, { align: l, crossAlign: c, padding: u, mirror: d } = r, h = ys(n.grid), f = h + u, p = d ? -u : f, g = -qe(this.labelRotation), m = [];
    let v, b, _, S, C, O, k, P, x, R, B, L, Y = "middle";
    if (s === "top")
      O = this.bottom - p, k = this._getXAxisLabelAlignment();
    else if (s === "bottom")
      O = this.top + p, k = this._getXAxisLabelAlignment();
    else if (s === "left") {
      const w = this._getYAxisLabelAlignment(h);
      k = w.textAlign, C = w.x;
    } else if (s === "right") {
      const w = this._getYAxisLabelAlignment(h);
      k = w.textAlign, C = w.x;
    } else if (e === "x") {
      if (s === "center")
        O = (t.top + t.bottom) / 2 + f;
      else if (St(s)) {
        const w = Object.keys(s)[0], I = s[w];
        O = this.chart.scales[w].getPixelForValue(I) + f;
      }
      k = this._getXAxisLabelAlignment();
    } else if (e === "y") {
      if (s === "center")
        C = (t.left + t.right) / 2 - f;
      else if (St(s)) {
        const w = Object.keys(s)[0], I = s[w];
        C = this.chart.scales[w].getPixelForValue(I);
      }
      k = this._getYAxisLabelAlignment(h).textAlign;
    }
    e === "y" && (l === "start" ? Y = "top" : l === "end" && (Y = "bottom"));
    const j = this._getLabelSizes();
    for (v = 0, b = o.length; v < b; ++v) {
      _ = o[v], S = _.label;
      const w = r.setContext(this.getContext(v));
      P = this.getPixelForTick(v) + r.labelOffset, x = this._resolveTickFontOptions(v), R = x.lineHeight, B = $t(S) ? S.length : 1;
      const I = B / 2, T = w.color, V = w.textStrokeColor, N = w.textStrokeWidth;
      let z = k;
      a ? (C = P, k === "inner" && (v === b - 1 ? z = this.options.reverse ? "left" : "right" : v === 0 ? z = this.options.reverse ? "right" : "left" : z = "center"), s === "top" ? c === "near" || g !== 0 ? L = -B * R + R / 2 : c === "center" ? L = -j.highest.height / 2 - I * R + R : L = -j.highest.height + R / 2 : c === "near" || g !== 0 ? L = R / 2 : c === "center" ? L = j.highest.height / 2 - I * R : L = j.highest.height - B * R, d && (L *= -1)) : (O = P, L = (1 - B) * R / 2);
      let E;
      if (w.showLabelBackdrop) {
        const H = ce(w.backdropPadding), y = j.heights[v], $ = j.widths[v];
        let D = O + L - H.top, Z = C - H.left;
        switch (Y) {
          case "middle":
            D -= y / 2;
            break;
          case "bottom":
            D -= y;
            break;
        }
        switch (k) {
          case "center":
            Z -= $ / 2;
            break;
          case "right":
            Z -= $;
            break;
        }
        E = {
          left: Z,
          top: D,
          width: $ + H.width,
          height: y + H.height,
          color: w.backdropColor
        };
      }
      m.push({
        rotation: g,
        label: S,
        font: x,
        color: T,
        strokeColor: V,
        strokeWidth: N,
        textOffset: L,
        textAlign: z,
        textBaseline: Y,
        translation: [C, O],
        backdrop: E
      });
    }
    return m;
  }
  _getXAxisLabelAlignment() {
    const { position: t, ticks: e } = this.options;
    if (-qe(this.labelRotation))
      return t === "top" ? "left" : "right";
    let s = "center";
    return e.align === "start" ? s = "left" : e.align === "end" ? s = "right" : e.align === "inner" && (s = "inner"), s;
  }
  _getYAxisLabelAlignment(t) {
    const { position: e, ticks: { crossAlign: n, mirror: s, padding: r } } = this.options, a = this._getLabelSizes(), o = t + r, l = a.widest.width;
    let c, u;
    return e === "left" ? s ? (u = this.right + r, n === "near" ? c = "left" : n === "center" ? (c = "center", u += l / 2) : (c = "right", u += l)) : (u = this.right - o, n === "near" ? c = "right" : n === "center" ? (c = "center", u -= l / 2) : (c = "left", u = this.left)) : e === "right" ? s ? (u = this.left + r, n === "near" ? c = "right" : n === "center" ? (c = "center", u -= l / 2) : (c = "left", u -= l)) : (u = this.left + o, n === "near" ? c = "left" : n === "center" ? (c = "center", u += l / 2) : (c = "right", u = this.right)) : c = "right", { textAlign: c, x: u };
  }
  _computeLabelArea() {
    if (this.options.ticks.mirror)
      return;
    const t = this.chart, e = this.options.position;
    if (e === "left" || e === "right")
      return { top: 0, left: this.left, bottom: t.height, right: this.right };
    if (e === "top" || e === "bottom")
      return { top: this.top, left: 0, bottom: this.bottom, right: t.width };
  }
  drawBackground() {
    const { ctx: t, options: { backgroundColor: e }, left: n, top: s, width: r, height: a } = this;
    e && (t.save(), t.fillStyle = e, t.fillRect(n, s, r, a), t.restore());
  }
  getLineWidthForValue(t) {
    const e = this.options.grid;
    if (!this._isVisible() || !e.display)
      return 0;
    const s = this.ticks.findIndex((r) => r.value === t);
    return s >= 0 ? e.setContext(this.getContext(s)).lineWidth : 0;
  }
  drawGrid(t) {
    const e = this.options.grid, n = this.ctx, s = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(t));
    let r, a;
    const o = (l, c, u) => {
      !u.width || !u.color || (n.save(), n.lineWidth = u.width, n.strokeStyle = u.color, n.setLineDash(u.borderDash || []), n.lineDashOffset = u.borderDashOffset, n.beginPath(), n.moveTo(l.x, l.y), n.lineTo(c.x, c.y), n.stroke(), n.restore());
    };
    if (e.display)
      for (r = 0, a = s.length; r < a; ++r) {
        const l = s[r];
        e.drawOnChartArea && o(
          { x: l.x1, y: l.y1 },
          { x: l.x2, y: l.y2 },
          l
        ), e.drawTicks && o(
          { x: l.tx1, y: l.ty1 },
          { x: l.tx2, y: l.ty2 },
          {
            color: l.tickColor,
            width: l.tickWidth,
            borderDash: l.tickBorderDash,
            borderDashOffset: l.tickBorderDashOffset
          }
        );
      }
  }
  drawBorder() {
    const { chart: t, ctx: e, options: { grid: n } } = this, s = n.setContext(this.getContext()), r = n.drawBorder ? s.borderWidth : 0;
    if (!r)
      return;
    const a = n.setContext(this.getContext(0)).lineWidth, o = this._borderValue;
    let l, c, u, d;
    this.isHorizontal() ? (l = cn(t, this.left, r) - r / 2, c = cn(t, this.right, a) + a / 2, u = d = o) : (u = cn(t, this.top, r) - r / 2, d = cn(t, this.bottom, a) + a / 2, l = c = o), e.save(), e.lineWidth = s.borderWidth, e.strokeStyle = s.borderColor, e.beginPath(), e.moveTo(l, u), e.lineTo(c, d), e.stroke(), e.restore();
  }
  drawLabels(t) {
    if (!this.options.ticks.display)
      return;
    const n = this.ctx, s = this._computeLabelArea();
    s && pc(n, s);
    const r = this._labelItems || (this._labelItems = this._computeLabelItems(t));
    let a, o;
    for (a = 0, o = r.length; a < o; ++a) {
      const l = r[a], c = l.font, u = l.label;
      l.backdrop && (n.fillStyle = l.backdrop.color, n.fillRect(l.backdrop.left, l.backdrop.top, l.backdrop.width, l.backdrop.height));
      let d = l.textOffset;
      kn(n, u, 0, d, c, l);
    }
    s && gc(n);
  }
  drawTitle() {
    const { ctx: t, options: { position: e, title: n, reverse: s } } = this;
    if (!n.display)
      return;
    const r = Xt(n.font), a = ce(n.padding), o = n.align;
    let l = r.lineHeight / 2;
    e === "bottom" || e === "center" || St(e) ? (l += a.bottom, $t(n.text) && (l += r.lineHeight * (n.text.length - 1))) : l += a.top;
    const { titleX: c, titleY: u, maxWidth: d, rotation: h } = Cw(this, l, e, o);
    kn(t, n.text, 0, 0, r, {
      color: n.color,
      maxWidth: d,
      rotation: h,
      textAlign: xw(o, e, s),
      textBaseline: "middle",
      translation: [c, u]
    });
  }
  draw(t) {
    this._isVisible() && (this.drawBackground(), this.drawGrid(t), this.drawBorder(), this.drawTitle(), this.drawLabels(t));
  }
  _layers() {
    const t = this.options, e = t.ticks && t.ticks.z || 0, n = yt(t.grid && t.grid.z, -1);
    return !this._isVisible() || this.draw !== Ln.prototype.draw ? [{
      z: e,
      draw: (s) => {
        this.draw(s);
      }
    }] : [{
      z: n,
      draw: (s) => {
        this.drawBackground(), this.drawGrid(s), this.drawTitle();
      }
    }, {
      z: n + 1,
      draw: () => {
        this.drawBorder();
      }
    }, {
      z: e,
      draw: (s) => {
        this.drawLabels(s);
      }
    }];
  }
  getMatchingVisibleMetas(t) {
    const e = this.chart.getSortedVisibleDatasetMetas(), n = this.axis + "AxisID", s = [];
    let r, a;
    for (r = 0, a = e.length; r < a; ++r) {
      const o = e[r];
      o[n] === this.id && (!t || o.type === t) && s.push(o);
    }
    return s;
  }
  _resolveTickFontOptions(t) {
    const e = this.options.ticks.setContext(this.getContext(t));
    return Xt(e.font);
  }
  _maxDigits() {
    const t = this._resolveTickFontOptions(0).lineHeight;
    return (this.isHorizontal() ? this.width : this.height) / t;
  }
}
class Br {
  constructor(t, e, n) {
    this.type = t, this.scope = e, this.override = n, this.items = /* @__PURE__ */ Object.create(null);
  }
  isForType(t) {
    return Object.prototype.isPrototypeOf.call(this.type.prototype, t.prototype);
  }
  register(t) {
    const e = Object.getPrototypeOf(t);
    let n;
    kw(e) && (n = this.register(e));
    const s = this.items, r = t.id, a = this.scope + "." + r;
    if (!r)
      throw new Error("class does not have id: " + t);
    return r in s || (s[r] = t, Sw(t, a, n), this.override && Ct.override(t.id, t.overrides)), a;
  }
  get(t) {
    return this.items[t];
  }
  unregister(t) {
    const e = this.items, n = t.id, s = this.scope;
    n in e && delete e[n], s && n in Ct[s] && (delete Ct[s][n], this.override && delete wn[n]);
  }
}
function Sw(i, t, e) {
  const n = Us(/* @__PURE__ */ Object.create(null), [
    e ? Ct.get(e) : {},
    Ct.get(t),
    i.defaults
  ]);
  Ct.set(t, n), i.defaultRoutes && ww(t, i.defaultRoutes), i.descriptors && Ct.describe(t, i.descriptors);
}
function ww(i, t) {
  Object.keys(t).forEach((e) => {
    const n = e.split("."), s = n.pop(), r = [i].concat(n).join("."), a = t[e].split("."), o = a.pop(), l = a.join(".");
    Ct.route(r, s, l, o);
  });
}
function kw(i) {
  return "id" in i && "defaults" in i;
}
class Ow {
  constructor() {
    this.controllers = new Br(ii, "datasets", !0), this.elements = new Br(ni, "elements"), this.plugins = new Br(Object, "plugins"), this.scales = new Br(Ln, "scales"), this._typedRegistries = [this.controllers, this.scales, this.elements];
  }
  add(...t) {
    this._each("register", t);
  }
  remove(...t) {
    this._each("unregister", t);
  }
  addControllers(...t) {
    this._each("register", t, this.controllers);
  }
  addElements(...t) {
    this._each("register", t, this.elements);
  }
  addPlugins(...t) {
    this._each("register", t, this.plugins);
  }
  addScales(...t) {
    this._each("register", t, this.scales);
  }
  getController(t) {
    return this._get(t, this.controllers, "controller");
  }
  getElement(t) {
    return this._get(t, this.elements, "element");
  }
  getPlugin(t) {
    return this._get(t, this.plugins, "plugin");
  }
  getScale(t) {
    return this._get(t, this.scales, "scale");
  }
  removeControllers(...t) {
    this._each("unregister", t, this.controllers);
  }
  removeElements(...t) {
    this._each("unregister", t, this.elements);
  }
  removePlugins(...t) {
    this._each("unregister", t, this.plugins);
  }
  removeScales(...t) {
    this._each("unregister", t, this.scales);
  }
  _each(t, e, n) {
    [...e].forEach((s) => {
      const r = n || this._getRegistryForType(s);
      n || r.isForType(s) || r === this.plugins && s.id ? this._exec(t, r, s) : Ot(s, (a) => {
        const o = n || this._getRegistryForType(a);
        this._exec(t, o, a);
      });
    });
  }
  _exec(t, e, n) {
    const s = oc(t);
    Dt(n["before" + s], [], n), e[t](n), Dt(n["after" + s], [], n);
  }
  _getRegistryForType(t) {
    for (let e = 0; e < this._typedRegistries.length; e++) {
      const n = this._typedRegistries[e];
      if (n.isForType(t))
        return n;
    }
    return this.plugins;
  }
  _get(t, e, n) {
    const s = e.get(t);
    if (s === void 0)
      throw new Error('"' + t + '" is not a registered ' + n + ".");
    return s;
  }
}
var gi = new Ow();
class Fa extends ii {
  update(t) {
    const e = this._cachedMeta, { data: n = [] } = e, s = this.chart._animationsDisabled;
    let { start: r, count: a } = Vp(e, n, s);
    if (this._drawStart = r, this._drawCount = a, zp(e) && (r = 0, a = n.length), this.options.showLine) {
      const { dataset: o, _dataset: l } = e;
      o._chart = this.chart, o._datasetIndex = this.index, o._decimated = !!l._decimated, o.points = n;
      const c = this.resolveDatasetElementOptions(t);
      c.segment = this.options.segment, this.updateElement(o, void 0, {
        animated: !s,
        options: c
      }, t);
    }
    this.updateElements(n, r, a, t);
  }
  addElements() {
    const { showLine: t } = this.options;
    !this.datasetElementType && t && (this.datasetElementType = gi.getElement("line")), super.addElements();
  }
  updateElements(t, e, n, s) {
    const r = s === "reset", { iScale: a, vScale: o, _stacked: l, _dataset: c } = this._cachedMeta, u = this.resolveDataElementOptions(e, s), d = this.getSharedOptions(u), h = this.includeOptions(s, d), f = a.axis, p = o.axis, { spanGaps: g, segment: m } = this.options, v = ns(g) ? g : Number.POSITIVE_INFINITY, b = this.chart._animationsDisabled || r || s === "none";
    let _ = e > 0 && this.getParsed(e - 1);
    for (let S = e; S < e + n; ++S) {
      const C = t[S], O = this.getParsed(S), k = b ? C : {}, P = kt(O[p]), x = k[f] = a.getPixelForValue(O[f], S), R = k[p] = r || P ? o.getBasePixel() : o.getPixelForValue(l ? this.applyStack(o, O, l) : O[p], S);
      k.skip = isNaN(x) || isNaN(R) || P, k.stop = S > 0 && Math.abs(O[f] - _[f]) > v, m && (k.parsed = O, k.raw = c.data[S]), h && (k.options = d || this.resolveDataElementOptions(S, C.active ? "active" : s)), b || this.updateElement(C, S, k, s), _ = O;
    }
    this.updateSharedOptions(d, s, u);
  }
  getMaxOverflow() {
    const t = this._cachedMeta, e = t.data || [];
    if (!this.options.showLine) {
      let o = 0;
      for (let l = e.length - 1; l >= 0; --l)
        o = Math.max(o, e[l].size(this.resolveDataElementOptions(l)) / 2);
      return o > 0 && o;
    }
    const n = t.dataset, s = n.options && n.options.borderWidth || 0;
    if (!e.length)
      return s;
    const r = e[0].size(this.resolveDataElementOptions(0)), a = e[e.length - 1].size(this.resolveDataElementOptions(e.length - 1));
    return Math.max(s, r, a) / 2;
  }
}
Fa.id = "scatter";
Fa.defaults = {
  datasetElementType: !1,
  dataElementType: "point",
  showLine: !1,
  fill: !1
};
Fa.overrides = {
  interaction: {
    mode: "point"
  },
  plugins: {
    tooltip: {
      callbacks: {
        title() {
          return "";
        },
        label(i) {
          return "(" + i.label + ", " + i.formattedValue + ")";
        }
      }
    }
  },
  scales: {
    x: {
      type: "linear"
    },
    y: {
      type: "linear"
    }
  }
};
function un() {
  throw new Error("This method is not implemented: Check that a complete date adapter is provided.");
}
class pl {
  constructor(t) {
    this.options = t || {};
  }
  init(t) {
  }
  formats() {
    return un();
  }
  parse(t, e) {
    return un();
  }
  format(t, e) {
    return un();
  }
  add(t, e, n) {
    return un();
  }
  diff(t, e, n) {
    return un();
  }
  startOf(t, e, n) {
    return un();
  }
  endOf(t, e) {
    return un();
  }
}
pl.override = function(i) {
  Object.assign(pl.prototype, i);
};
var Mw = {
  _date: pl
};
function Tw(i, t, e, n) {
  const { controller: s, data: r, _sorted: a } = i, o = s._cachedMeta.iScale;
  if (o && t === o.axis && t !== "r" && a && r.length) {
    const l = o._reversePixels ? gC : mn;
    if (n) {
      if (s._sharedOptions) {
        const c = r[0], u = typeof c.getRange == "function" && c.getRange(t);
        if (u) {
          const d = l(r, t, e - u), h = l(r, t, e + u);
          return { lo: d.lo, hi: h.hi };
        }
      }
    } else return l(r, t, e);
  }
  return { lo: 0, hi: r.length - 1 };
}
function hr(i, t, e, n, s) {
  const r = i.getSortedVisibleDatasetMetas(), a = e[t];
  for (let o = 0, l = r.length; o < l; ++o) {
    const { index: c, data: u } = r[o], { lo: d, hi: h } = Tw(r[o], t, a, s);
    for (let f = d; f <= h; ++f) {
      const p = u[f];
      p.skip || n(p, c, f);
    }
  }
}
function Dw(i) {
  const t = i.indexOf("x") !== -1, e = i.indexOf("y") !== -1;
  return function(n, s) {
    const r = t ? Math.abs(n.x - s.x) : 0, a = e ? Math.abs(n.y - s.y) : 0;
    return Math.sqrt(Math.pow(r, 2) + Math.pow(a, 2));
  };
}
function $o(i, t, e, n, s) {
  const r = [];
  return !s && !i.isPointInArea(t) || hr(i, e, t, function(o, l, c) {
    !s && !Gs(o, i.chartArea, 0) || o.inRange(t.x, t.y, n) && r.push({ element: o, datasetIndex: l, index: c });
  }, !0), r;
}
function Pw(i, t, e, n) {
  let s = [];
  function r(a, o, l) {
    const { startAngle: c, endAngle: u } = a.getProps(["startAngle", "endAngle"], n), { angle: d } = Bp(a, { x: t.x, y: t.y });
    Zs(d, c, u) && s.push({ element: a, datasetIndex: o, index: l });
  }
  return hr(i, e, t, r), s;
}
function Lw(i, t, e, n, s, r) {
  let a = [];
  const o = Dw(e);
  let l = Number.POSITIVE_INFINITY;
  function c(u, d, h) {
    const f = u.inRange(t.x, t.y, s);
    if (n && !f)
      return;
    const p = u.getCenterPoint(s);
    if (!(!!r || i.isPointInArea(p)) && !f)
      return;
    const m = o(t, p);
    m < l ? (a = [{ element: u, datasetIndex: d, index: h }], l = m) : m === l && a.push({ element: u, datasetIndex: d, index: h });
  }
  return hr(i, e, t, c), a;
}
function Bo(i, t, e, n, s, r) {
  return !r && !i.isPointInArea(t) ? [] : e === "r" && !n ? Pw(i, t, e, s) : Lw(i, t, e, n, s, r);
}
function yd(i, t, e, n, s) {
  const r = [], a = e === "x" ? "inXRange" : "inYRange";
  let o = !1;
  return hr(i, e, t, (l, c, u) => {
    l[a](t[e], s) && (r.push({ element: l, datasetIndex: c, index: u }), o = o || l.inRange(t.x, t.y, s));
  }), n && !o ? [] : r;
}
var Iw = {
  evaluateInteractionItems: hr,
  modes: {
    index(i, t, e, n) {
      const s = hn(t, i), r = e.axis || "x", a = e.includeInvisible || !1, o = e.intersect ? $o(i, s, r, n, a) : Bo(i, s, r, !1, n, a), l = [];
      return o.length ? (i.getSortedVisibleDatasetMetas().forEach((c) => {
        const u = o[0].index, d = c.data[u];
        d && !d.skip && l.push({ element: d, datasetIndex: c.index, index: u });
      }), l) : [];
    },
    dataset(i, t, e, n) {
      const s = hn(t, i), r = e.axis || "xy", a = e.includeInvisible || !1;
      let o = e.intersect ? $o(i, s, r, n, a) : Bo(i, s, r, !1, n, a);
      if (o.length > 0) {
        const l = o[0].datasetIndex, c = i.getDatasetMeta(l).data;
        o = [];
        for (let u = 0; u < c.length; ++u)
          o.push({ element: c[u], datasetIndex: l, index: u });
      }
      return o;
    },
    point(i, t, e, n) {
      const s = hn(t, i), r = e.axis || "xy", a = e.includeInvisible || !1;
      return $o(i, s, r, n, a);
    },
    nearest(i, t, e, n) {
      const s = hn(t, i), r = e.axis || "xy", a = e.includeInvisible || !1;
      return Bo(i, s, r, e.intersect, n, a);
    },
    x(i, t, e, n) {
      const s = hn(t, i);
      return yd(i, s, "x", e.intersect, n);
    },
    y(i, t, e, n) {
      const s = hn(t, i);
      return yd(i, s, "y", e.intersect, n);
    }
  }
};
const dg = ["left", "top", "right", "bottom"];
function _s(i, t) {
  return i.filter((e) => e.pos === t);
}
function _d(i, t) {
  return i.filter((e) => dg.indexOf(e.pos) === -1 && e.box.axis === t);
}
function xs(i, t) {
  return i.sort((e, n) => {
    const s = t ? n : e, r = t ? e : n;
    return s.weight === r.weight ? s.index - r.index : s.weight - r.weight;
  });
}
function Ew(i) {
  const t = [];
  let e, n, s, r, a, o;
  for (e = 0, n = (i || []).length; e < n; ++e)
    s = i[e], { position: r, options: { stack: a, stackWeight: o = 1 } } = s, t.push({
      index: e,
      box: s,
      pos: r,
      horizontal: s.isHorizontal(),
      weight: s.weight,
      stack: a && r + a,
      stackWeight: o
    });
  return t;
}
function $w(i) {
  const t = {};
  for (const e of i) {
    const { stack: n, pos: s, stackWeight: r } = e;
    if (!n || !dg.includes(s))
      continue;
    const a = t[n] || (t[n] = { count: 0, placed: 0, weight: 0, size: 0 });
    a.count++, a.weight += r;
  }
  return t;
}
function Bw(i, t) {
  const e = $w(i), { vBoxMaxWidth: n, hBoxMaxHeight: s } = t;
  let r, a, o;
  for (r = 0, a = i.length; r < a; ++r) {
    o = i[r];
    const { fullSize: l } = o.box, c = e[o.stack], u = c && o.stackWeight / c.weight;
    o.horizontal ? (o.width = u ? u * n : l && t.availableWidth, o.height = s) : (o.width = n, o.height = u ? u * s : l && t.availableHeight);
  }
  return e;
}
function Rw(i) {
  const t = Ew(i), e = xs(t.filter((c) => c.box.fullSize), !0), n = xs(_s(t, "left"), !0), s = xs(_s(t, "right")), r = xs(_s(t, "top"), !0), a = xs(_s(t, "bottom")), o = _d(t, "x"), l = _d(t, "y");
  return {
    fullSize: e,
    leftAndTop: n.concat(r),
    rightAndBottom: s.concat(l).concat(a).concat(o),
    chartArea: _s(t, "chartArea"),
    vertical: n.concat(s).concat(l),
    horizontal: r.concat(a).concat(o)
  };
}
function xd(i, t, e, n) {
  return Math.max(i[e], t[e]) + Math.max(i[n], t[n]);
}
function hg(i, t) {
  i.top = Math.max(i.top, t.top), i.left = Math.max(i.left, t.left), i.bottom = Math.max(i.bottom, t.bottom), i.right = Math.max(i.right, t.right);
}
function Fw(i, t, e, n) {
  const { pos: s, box: r } = e, a = i.maxPadding;
  if (!St(s)) {
    e.size && (i[s] -= e.size);
    const d = n[e.stack] || { size: 0, count: 1 };
    d.size = Math.max(d.size, e.horizontal ? r.height : r.width), e.size = d.size / d.count, i[s] += e.size;
  }
  r.getPadding && hg(a, r.getPadding());
  const o = Math.max(0, t.outerWidth - xd(a, i, "left", "right")), l = Math.max(0, t.outerHeight - xd(a, i, "top", "bottom")), c = o !== i.w, u = l !== i.h;
  return i.w = o, i.h = l, e.horizontal ? { same: c, other: u } : { same: u, other: c };
}
function Nw(i) {
  const t = i.maxPadding;
  function e(n) {
    const s = Math.max(t[n] - i[n], 0);
    return i[n] += s, s;
  }
  i.y += e("top"), i.x += e("left"), e("right"), e("bottom");
}
function Hw(i, t) {
  const e = t.maxPadding;
  function n(s) {
    const r = { left: 0, top: 0, right: 0, bottom: 0 };
    return s.forEach((a) => {
      r[a] = Math.max(t[a], e[a]);
    }), r;
  }
  return n(i ? ["left", "right"] : ["top", "bottom"]);
}
function Os(i, t, e, n) {
  const s = [];
  let r, a, o, l, c, u;
  for (r = 0, a = i.length, c = 0; r < a; ++r) {
    o = i[r], l = o.box, l.update(
      o.width || t.w,
      o.height || t.h,
      Hw(o.horizontal, t)
    );
    const { same: d, other: h } = Fw(t, e, o, n);
    c |= d && s.length, u = u || h, l.fullSize || s.push(o);
  }
  return c && Os(s, t, e, n) || u;
}
function Rr(i, t, e, n, s) {
  i.top = e, i.left = t, i.right = t + n, i.bottom = e + s, i.width = n, i.height = s;
}
function Cd(i, t, e, n) {
  const s = e.padding;
  let { x: r, y: a } = t;
  for (const o of i) {
    const l = o.box, c = n[o.stack] || { count: 1, placed: 0, weight: 1 }, u = o.stackWeight / c.weight || 1;
    if (o.horizontal) {
      const d = t.w * u, h = c.size || l.height;
      Ze(c.start) && (a = c.start), l.fullSize ? Rr(l, s.left, a, e.outerWidth - s.right - s.left, h) : Rr(l, t.left + c.placed, a, d, h), c.start = a, c.placed += d, a = l.bottom;
    } else {
      const d = t.h * u, h = c.size || l.width;
      Ze(c.start) && (r = c.start), l.fullSize ? Rr(l, r, s.top, h, e.outerHeight - s.bottom - s.top) : Rr(l, r, t.top + c.placed, h, d), c.start = r, c.placed += d, r = l.right;
    }
  }
  t.x = r, t.y = a;
}
Ct.set("layout", {
  autoPadding: !0,
  padding: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  }
});
var Ye = {
  addBox(i, t) {
    i.boxes || (i.boxes = []), t.fullSize = t.fullSize || !1, t.position = t.position || "top", t.weight = t.weight || 0, t._layers = t._layers || function() {
      return [{
        z: 0,
        draw(e) {
          t.draw(e);
        }
      }];
    }, i.boxes.push(t);
  },
  removeBox(i, t) {
    const e = i.boxes ? i.boxes.indexOf(t) : -1;
    e !== -1 && i.boxes.splice(e, 1);
  },
  configure(i, t, e) {
    t.fullSize = e.fullSize, t.position = e.position, t.weight = e.weight;
  },
  update(i, t, e, n) {
    if (!i)
      return;
    const s = ce(i.options.layout.padding), r = Math.max(t - s.width, 0), a = Math.max(e - s.height, 0), o = Rw(i.boxes), l = o.vertical, c = o.horizontal;
    Ot(i.boxes, (g) => {
      typeof g.beforeLayout == "function" && g.beforeLayout();
    });
    const u = l.reduce((g, m) => m.box.options && m.box.options.display === !1 ? g : g + 1, 0) || 1, d = Object.freeze({
      outerWidth: t,
      outerHeight: e,
      padding: s,
      availableWidth: r,
      availableHeight: a,
      vBoxMaxWidth: r / 2 / u,
      hBoxMaxHeight: a / 2
    }), h = Object.assign({}, s);
    hg(h, ce(n));
    const f = Object.assign({
      maxPadding: h,
      w: r,
      h: a,
      x: s.left,
      y: s.top
    }, s), p = Bw(l.concat(c), d);
    Os(o.fullSize, f, d, p), Os(l, f, d, p), Os(c, f, d, p) && Os(l, f, d, p), Nw(f), Cd(o.leftAndTop, f, d, p), f.x += f.w, f.y += f.h, Cd(o.rightAndBottom, f, d, p), i.chartArea = {
      left: f.left,
      top: f.top,
      right: f.left + f.w,
      bottom: f.top + f.h,
      height: f.h,
      width: f.w
    }, Ot(o.chartArea, (g) => {
      const m = g.box;
      Object.assign(m, i.chartArea), m.update(f.w, f.h, { left: 0, top: 0, right: 0, bottom: 0 });
    });
  }
};
class fg {
  acquireContext(t, e) {
  }
  releaseContext(t) {
    return !1;
  }
  addEventListener(t, e, n) {
  }
  removeEventListener(t, e, n) {
  }
  getDevicePixelRatio() {
    return 1;
  }
  getMaximumSize(t, e, n, s) {
    return e = Math.max(0, e || t.width), n = n || t.height, {
      width: e,
      height: Math.max(0, s ? Math.floor(e / s) : n)
    };
  }
  isAttached(t) {
    return !0;
  }
  updateConfig(t) {
  }
}
class Vw extends fg {
  acquireContext(t) {
    return t && t.getContext && t.getContext("2d") || null;
  }
  updateConfig(t) {
    t.options.animation = !1;
  }
}
const Xr = "$chartjs", zw = {
  touchstart: "mousedown",
  touchmove: "mousemove",
  touchend: "mouseup",
  pointerenter: "mouseenter",
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointerleave: "mouseout",
  pointerout: "mouseout"
}, Sd = (i) => i === null || i === "";
function jw(i, t) {
  const e = i.style, n = i.getAttribute("height"), s = i.getAttribute("width");
  if (i[Xr] = {
    initial: {
      height: n,
      width: s,
      style: {
        display: e.display,
        height: e.height,
        width: e.width
      }
    }
  }, e.display = e.display || "block", e.boxSizing = e.boxSizing || "border-box", Sd(s)) {
    const r = id(i, "width");
    r !== void 0 && (i.width = r);
  }
  if (Sd(n))
    if (i.style.height === "")
      i.height = i.width / (t || 2);
    else {
      const r = id(i, "height");
      r !== void 0 && (i.height = r);
    }
  return i;
}
const pg = xS ? { passive: !0 } : !1;
function Ww(i, t, e) {
  i.addEventListener(t, e, pg);
}
function Yw(i, t, e) {
  i.canvas.removeEventListener(t, e, pg);
}
function Uw(i, t) {
  const e = zw[i.type] || i.type, { x: n, y: s } = hn(i, t);
  return {
    type: e,
    chart: t,
    native: i,
    x: n !== void 0 ? n : null,
    y: s !== void 0 ? s : null
  };
}
function Aa(i, t) {
  for (const e of i)
    if (e === t || e.contains(t))
      return !0;
}
function Zw(i, t, e) {
  const n = i.canvas, s = new MutationObserver((r) => {
    let a = !1;
    for (const o of r)
      a = a || Aa(o.addedNodes, n), a = a && !Aa(o.removedNodes, n);
    a && e();
  });
  return s.observe(document, { childList: !0, subtree: !0 }), s;
}
function Gw(i, t, e) {
  const n = i.canvas, s = new MutationObserver((r) => {
    let a = !1;
    for (const o of r)
      a = a || Aa(o.removedNodes, n), a = a && !Aa(o.addedNodes, n);
    a && e();
  });
  return s.observe(document, { childList: !0, subtree: !0 }), s;
}
const Xs = /* @__PURE__ */ new Map();
let wd = 0;
function gg() {
  const i = window.devicePixelRatio;
  i !== wd && (wd = i, Xs.forEach((t, e) => {
    e.currentDevicePixelRatio !== i && t();
  }));
}
function Kw(i, t) {
  Xs.size || window.addEventListener("resize", gg), Xs.set(i, t);
}
function Xw(i) {
  Xs.delete(i), Xs.size || window.removeEventListener("resize", gg);
}
function Qw(i, t, e) {
  const n = i.canvas, s = n && yc(n);
  if (!s)
    return;
  const r = Hp((o, l) => {
    const c = s.clientWidth;
    e(o, l), c < s.clientWidth && e();
  }, window), a = new ResizeObserver((o) => {
    const l = o[0], c = l.contentRect.width, u = l.contentRect.height;
    c === 0 && u === 0 || r(c, u);
  });
  return a.observe(s), Kw(i, r), a;
}
function Ro(i, t, e) {
  e && e.disconnect(), t === "resize" && Xw(i);
}
function Jw(i, t, e) {
  const n = i.canvas, s = Hp((r) => {
    i.ctx !== null && e(Uw(r, i));
  }, i, (r) => {
    const a = r[0];
    return [a, a.offsetX, a.offsetY];
  });
  return Ww(n, t, s), s;
}
class qw extends fg {
  acquireContext(t, e) {
    const n = t && t.getContext && t.getContext("2d");
    return n && n.canvas === t ? (jw(t, e), n) : null;
  }
  releaseContext(t) {
    const e = t.canvas;
    if (!e[Xr])
      return !1;
    const n = e[Xr].initial;
    ["height", "width"].forEach((r) => {
      const a = n[r];
      kt(a) ? e.removeAttribute(r) : e.setAttribute(r, a);
    });
    const s = n.style || {};
    return Object.keys(s).forEach((r) => {
      e.style[r] = s[r];
    }), e.width = e.width, delete e[Xr], !0;
  }
  addEventListener(t, e, n) {
    this.removeEventListener(t, e);
    const s = t.$proxies || (t.$proxies = {}), a = {
      attach: Zw,
      detach: Gw,
      resize: Qw
    }[e] || Jw;
    s[e] = a(t, e, n);
  }
  removeEventListener(t, e) {
    const n = t.$proxies || (t.$proxies = {}), s = n[e];
    if (!s)
      return;
    ({
      attach: Ro,
      detach: Ro,
      resize: Ro
    }[e] || Yw)(t, e, s), n[e] = void 0;
  }
  getDevicePixelRatio() {
    return window.devicePixelRatio;
  }
  getMaximumSize(t, e, n, s) {
    return _S(t, e, n, s);
  }
  isAttached(t) {
    const e = yc(t);
    return !!(e && e.isConnected);
  }
}
function tk(i) {
  return !ig() || typeof OffscreenCanvas < "u" && i instanceof OffscreenCanvas ? Vw : qw;
}
class ek {
  constructor() {
    this._init = [];
  }
  notify(t, e, n, s) {
    e === "beforeInit" && (this._init = this._createDescriptors(t, !0), this._notify(this._init, t, "install"));
    const r = s ? this._descriptors(t).filter(s) : this._descriptors(t), a = this._notify(r, t, e, n);
    return e === "afterDestroy" && (this._notify(r, t, "stop"), this._notify(this._init, t, "uninstall")), a;
  }
  _notify(t, e, n, s) {
    s = s || {};
    for (const r of t) {
      const a = r.plugin, o = a[n], l = [e, s, r.options];
      if (Dt(o, l, a) === !1 && s.cancelable)
        return !1;
    }
    return !0;
  }
  invalidate() {
    kt(this._cache) || (this._oldCache = this._cache, this._cache = void 0);
  }
  _descriptors(t) {
    if (this._cache)
      return this._cache;
    const e = this._cache = this._createDescriptors(t);
    return this._notifyStateChanges(t), e;
  }
  _createDescriptors(t, e) {
    const n = t && t.config, s = yt(n.options && n.options.plugins, {}), r = ik(n);
    return s === !1 && !e ? [] : sk(t, r, s, e);
  }
  _notifyStateChanges(t) {
    const e = this._oldCache || [], n = this._cache, s = (r, a) => r.filter((o) => !a.some((l) => o.plugin.id === l.plugin.id));
    this._notify(s(e, n), t, "stop"), this._notify(s(n, e), t, "start");
  }
}
function ik(i) {
  const t = {}, e = [], n = Object.keys(gi.plugins.items);
  for (let r = 0; r < n.length; r++)
    e.push(gi.getPlugin(n[r]));
  const s = i.plugins || [];
  for (let r = 0; r < s.length; r++) {
    const a = s[r];
    e.indexOf(a) === -1 && (e.push(a), t[a.id] = !0);
  }
  return { plugins: e, localIds: t };
}
function nk(i, t) {
  return !t && i === !1 ? null : i === !0 ? {} : i;
}
function sk(i, { plugins: t, localIds: e }, n, s) {
  const r = [], a = i.getContext();
  for (const o of t) {
    const l = o.id, c = nk(n[l], s);
    c !== null && r.push({
      plugin: o,
      options: rk(i.config, { plugin: o, local: e[l] }, c, a)
    });
  }
  return r;
}
function rk(i, { plugin: t, local: e }, n, s) {
  const r = i.pluginScopeKeys(t), a = i.getOptionScopes(n, r);
  return e && t.defaults && a.push(t.defaults), i.createResolver(a, s, [""], {
    scriptable: !1,
    indexable: !1,
    allKeys: !0
  });
}
function gl(i, t) {
  const e = Ct.datasets[i] || {};
  return ((t.datasets || {})[i] || {}).indexAxis || t.indexAxis || e.indexAxis || "x";
}
function ak(i, t) {
  let e = i;
  return i === "_index_" ? e = t : i === "_value_" && (e = t === "x" ? "y" : "x"), e;
}
function ok(i, t) {
  return i === t ? "_index_" : "_value_";
}
function lk(i) {
  if (i === "top" || i === "bottom")
    return "x";
  if (i === "left" || i === "right")
    return "y";
}
function ml(i, t) {
  return i === "x" || i === "y" ? i : t.axis || lk(t.position) || i.charAt(0).toLowerCase();
}
function ck(i, t) {
  const e = wn[i.type] || { scales: {} }, n = t.scales || {}, s = gl(i.type, t), r = /* @__PURE__ */ Object.create(null), a = /* @__PURE__ */ Object.create(null);
  return Object.keys(n).forEach((o) => {
    const l = n[o];
    if (!St(l))
      return console.error(`Invalid scale configuration for scale: ${o}`);
    if (l._proxy)
      return console.warn(`Ignoring resolver passed as options for scale: ${o}`);
    const c = ml(o, l), u = ok(c, s), d = e.scales || {};
    r[c] = r[c] || o, a[o] = Ps(/* @__PURE__ */ Object.create(null), [{ axis: c }, l, d[c], d[u]]);
  }), i.data.datasets.forEach((o) => {
    const l = o.type || i.type, c = o.indexAxis || gl(l, t), d = (wn[l] || {}).scales || {};
    Object.keys(d).forEach((h) => {
      const f = ak(h, c), p = o[f + "AxisID"] || r[f] || f;
      a[p] = a[p] || /* @__PURE__ */ Object.create(null), Ps(a[p], [{ axis: f }, n[p], d[h]]);
    });
  }), Object.keys(a).forEach((o) => {
    const l = a[o];
    Ps(l, [Ct.scales[l.type], Ct.scale]);
  }), a;
}
function mg(i) {
  const t = i.options || (i.options = {});
  t.plugins = yt(t.plugins, {}), t.scales = ck(i, t);
}
function vg(i) {
  return i = i || {}, i.datasets = i.datasets || [], i.labels = i.labels || [], i;
}
function uk(i) {
  return i = i || {}, i.data = vg(i.data), mg(i), i;
}
const kd = /* @__PURE__ */ new Map(), Ag = /* @__PURE__ */ new Set();
function Fr(i, t) {
  let e = kd.get(i);
  return e || (e = t(), kd.set(i, e), Ag.add(e)), e;
}
const Cs = (i, t, e) => {
  const n = qi(t, e);
  n !== void 0 && i.add(n);
};
class dk {
  constructor(t) {
    this._config = uk(t), this._scopeCache = /* @__PURE__ */ new Map(), this._resolverCache = /* @__PURE__ */ new Map();
  }
  get platform() {
    return this._config.platform;
  }
  get type() {
    return this._config.type;
  }
  set type(t) {
    this._config.type = t;
  }
  get data() {
    return this._config.data;
  }
  set data(t) {
    this._config.data = vg(t);
  }
  get options() {
    return this._config.options;
  }
  set options(t) {
    this._config.options = t;
  }
  get plugins() {
    return this._config.plugins;
  }
  update() {
    const t = this._config;
    this.clearCache(), mg(t);
  }
  clearCache() {
    this._scopeCache.clear(), this._resolverCache.clear();
  }
  datasetScopeKeys(t) {
    return Fr(
      t,
      () => [[
        `datasets.${t}`,
        ""
      ]]
    );
  }
  datasetAnimationScopeKeys(t, e) {
    return Fr(
      `${t}.transition.${e}`,
      () => [
        [
          `datasets.${t}.transitions.${e}`,
          `transitions.${e}`
        ],
        [
          `datasets.${t}`,
          ""
        ]
      ]
    );
  }
  datasetElementScopeKeys(t, e) {
    return Fr(
      `${t}-${e}`,
      () => [[
        `datasets.${t}.elements.${e}`,
        `datasets.${t}`,
        `elements.${e}`,
        ""
      ]]
    );
  }
  pluginScopeKeys(t) {
    const e = t.id, n = this.type;
    return Fr(
      `${n}-plugin-${e}`,
      () => [[
        `plugins.${e}`,
        ...t.additionalOptionScopes || []
      ]]
    );
  }
  _cachedScopes(t, e) {
    const n = this._scopeCache;
    let s = n.get(t);
    return (!s || e) && (s = /* @__PURE__ */ new Map(), n.set(t, s)), s;
  }
  getOptionScopes(t, e, n) {
    const { options: s, type: r } = this, a = this._cachedScopes(t, n), o = a.get(e);
    if (o)
      return o;
    const l = /* @__PURE__ */ new Set();
    e.forEach((u) => {
      t && (l.add(t), u.forEach((d) => Cs(l, t, d))), u.forEach((d) => Cs(l, s, d)), u.forEach((d) => Cs(l, wn[r] || {}, d)), u.forEach((d) => Cs(l, Ct, d)), u.forEach((d) => Cs(l, hl, d));
    });
    const c = Array.from(l);
    return c.length === 0 && c.push(/* @__PURE__ */ Object.create(null)), Ag.has(e) && a.set(e, c), c;
  }
  chartOptionScopes() {
    const { options: t, type: e } = this;
    return [
      t,
      wn[e] || {},
      Ct.datasets[e] || {},
      { type: e },
      Ct,
      hl
    ];
  }
  resolveNamedOptions(t, e, n, s = [""]) {
    const r = { $shared: !0 }, { resolver: a, subPrefixes: o } = Od(this._resolverCache, t, s);
    let l = a;
    if (fk(a, e)) {
      r.$shared = !1, n = tn(n) ? n() : n;
      const c = this.createResolver(t, n, o);
      l = ss(a, n, c);
    }
    for (const c of e)
      r[c] = l[c];
    return r;
  }
  createResolver(t, e, n = [""], s) {
    const { resolver: r } = Od(this._resolverCache, t, n);
    return St(e) ? ss(r, e, void 0, s) : r;
  }
}
function Od(i, t, e) {
  let n = i.get(t);
  n || (n = /* @__PURE__ */ new Map(), i.set(t, n));
  const s = e.join();
  let r = n.get(s);
  return r || (r = {
    resolver: vc(t, e),
    subPrefixes: e.filter((o) => !o.toLowerCase().includes("hover"))
  }, n.set(s, r)), r;
}
const hk = (i) => St(i) && Object.getOwnPropertyNames(i).reduce((t, e) => t || tn(i[e]), !1);
function fk(i, t) {
  const { isScriptable: e, isIndexable: n } = Xp(i);
  for (const s of t) {
    const r = e(s), a = n(s), o = (a || r) && i[s];
    if (r && (tn(o) || hk(o)) || a && $t(o))
      return !0;
  }
  return !1;
}
var pk = "3.9.1";
const gk = ["top", "bottom", "left", "right", "chartArea"];
function Md(i, t) {
  return i === "top" || i === "bottom" || gk.indexOf(i) === -1 && t === "x";
}
function Td(i, t) {
  return function(e, n) {
    return e[i] === n[i] ? e[t] - n[t] : e[i] - n[i];
  };
}
function Dd(i) {
  const t = i.chart, e = t.options.animation;
  t.notifyPlugins("afterRender"), Dt(e && e.onComplete, [i], t);
}
function mk(i) {
  const t = i.chart, e = t.options.animation;
  Dt(e && e.onProgress, [i], t);
}
function bg(i) {
  return ig() && typeof i == "string" ? i = document.getElementById(i) : i && i.length && (i = i[0]), i && i.canvas && (i = i.canvas), i;
}
const ba = {}, yg = (i) => {
  const t = bg(i);
  return Object.values(ba).filter((e) => e.canvas === t).pop();
};
function vk(i, t, e) {
  const n = Object.keys(i);
  for (const s of n) {
    const r = +s;
    if (r >= t) {
      const a = i[s];
      delete i[s], (e > 0 || r > t) && (i[r + e] = a);
    }
  }
}
function Ak(i, t, e, n) {
  return !e || i.type === "mouseout" ? null : n ? t : i;
}
class Qs {
  constructor(t, e) {
    const n = this.config = new dk(e), s = bg(t), r = yg(s);
    if (r)
      throw new Error(
        "Canvas is already in use. Chart with ID '" + r.id + "' must be destroyed before the canvas with ID '" + r.canvas.id + "' can be reused."
      );
    const a = n.createResolver(n.chartOptionScopes(), this.getContext());
    this.platform = new (n.platform || tk(s))(), this.platform.updateConfig(n);
    const o = this.platform.acquireContext(s, a.aspectRatio), l = o && o.canvas, c = l && l.height, u = l && l.width;
    if (this.id = iC(), this.ctx = o, this.canvas = l, this.width = u, this.height = c, this._options = a, this._aspectRatio = this.aspectRatio, this._layers = [], this._metasets = [], this._stacks = void 0, this.boxes = [], this.currentDevicePixelRatio = void 0, this.chartArea = void 0, this._active = [], this._lastEvent = void 0, this._listeners = {}, this._responsiveListeners = void 0, this._sortedMetasets = [], this.scales = {}, this._plugins = new ek(), this.$proxies = {}, this._hiddenIndices = {}, this.attached = !1, this._animationsDisabled = void 0, this.$context = void 0, this._doResize = AC((d) => this.update(d), a.resizeDelay || 0), this._dataChanges = [], ba[this.id] = this, !o || !l) {
      console.error("Failed to create chart: can't acquire context from the given item");
      return;
    }
    ki.listen(this, "complete", Dd), ki.listen(this, "progress", mk), this._initialize(), this.attached && this.update();
  }
  get aspectRatio() {
    const { options: { aspectRatio: t, maintainAspectRatio: e }, width: n, height: s, _aspectRatio: r } = this;
    return kt(t) ? e && r ? r : s ? n / s : null : t;
  }
  get data() {
    return this.config.data;
  }
  set data(t) {
    this.config.data = t;
  }
  get options() {
    return this._options;
  }
  set options(t) {
    this.config.options = t;
  }
  _initialize() {
    return this.notifyPlugins("beforeInit"), this.options.responsive ? this.resize() : ed(this, this.options.devicePixelRatio), this.bindEvents(), this.notifyPlugins("afterInit"), this;
  }
  clear() {
    return Ju(this.canvas, this.ctx), this;
  }
  stop() {
    return ki.stop(this), this;
  }
  resize(t, e) {
    ki.running(this) ? this._resizeBeforeDraw = { width: t, height: e } : this._resize(t, e);
  }
  _resize(t, e) {
    const n = this.options, s = this.canvas, r = n.maintainAspectRatio && this.aspectRatio, a = this.platform.getMaximumSize(s, t, e, r), o = n.devicePixelRatio || this.platform.getDevicePixelRatio(), l = this.width ? "resize" : "attach";
    this.width = a.width, this.height = a.height, this._aspectRatio = this.aspectRatio, ed(this, o, !0) && (this.notifyPlugins("resize", { size: a }), Dt(n.onResize, [this, a], this), this.attached && this._doResize(l) && this.render());
  }
  ensureScalesHaveIDs() {
    const e = this.options.scales || {};
    Ot(e, (n, s) => {
      n.id = s;
    });
  }
  buildOrUpdateScales() {
    const t = this.options, e = t.scales, n = this.scales, s = Object.keys(n).reduce((a, o) => (a[o] = !1, a), {});
    let r = [];
    e && (r = r.concat(
      Object.keys(e).map((a) => {
        const o = e[a], l = ml(a, o), c = l === "r", u = l === "x";
        return {
          options: o,
          dposition: c ? "chartArea" : u ? "bottom" : "left",
          dtype: c ? "radialLinear" : u ? "category" : "linear"
        };
      })
    )), Ot(r, (a) => {
      const o = a.options, l = o.id, c = ml(l, o), u = yt(o.type, a.dtype);
      (o.position === void 0 || Md(o.position, c) !== Md(a.dposition)) && (o.position = a.dposition), s[l] = !0;
      let d = null;
      if (l in n && n[l].type === u)
        d = n[l];
      else {
        const h = gi.getScale(u);
        d = new h({
          id: l,
          type: u,
          ctx: this.ctx,
          chart: this
        }), n[d.id] = d;
      }
      d.init(o, t);
    }), Ot(s, (a, o) => {
      a || delete n[o];
    }), Ot(n, (a) => {
      Ye.configure(this, a, a.options), Ye.addBox(this, a);
    });
  }
  _updateMetasets() {
    const t = this._metasets, e = this.data.datasets.length, n = t.length;
    if (t.sort((s, r) => s.index - r.index), n > e) {
      for (let s = e; s < n; ++s)
        this._destroyDatasetMeta(s);
      t.splice(e, n - e);
    }
    this._sortedMetasets = t.slice(0).sort(Td("order", "index"));
  }
  _removeUnreferencedMetasets() {
    const { _metasets: t, data: { datasets: e } } = this;
    t.length > e.length && delete this._stacks, t.forEach((n, s) => {
      e.filter((r) => r === n._dataset).length === 0 && this._destroyDatasetMeta(s);
    });
  }
  buildOrUpdateControllers() {
    const t = [], e = this.data.datasets;
    let n, s;
    for (this._removeUnreferencedMetasets(), n = 0, s = e.length; n < s; n++) {
      const r = e[n];
      let a = this.getDatasetMeta(n);
      const o = r.type || this.config.type;
      if (a.type && a.type !== o && (this._destroyDatasetMeta(n), a = this.getDatasetMeta(n)), a.type = o, a.indexAxis = r.indexAxis || gl(o, this.options), a.order = r.order || 0, a.index = n, a.label = "" + r.label, a.visible = this.isDatasetVisible(n), a.controller)
        a.controller.updateIndex(n), a.controller.linkScales();
      else {
        const l = gi.getController(o), { datasetElementType: c, dataElementType: u } = Ct.datasets[o];
        Object.assign(l.prototype, {
          dataElementType: gi.getElement(u),
          datasetElementType: c && gi.getElement(c)
        }), a.controller = new l(this, n), t.push(a.controller);
      }
    }
    return this._updateMetasets(), t;
  }
  _resetElements() {
    Ot(this.data.datasets, (t, e) => {
      this.getDatasetMeta(e).controller.reset();
    }, this);
  }
  reset() {
    this._resetElements(), this.notifyPlugins("reset");
  }
  update(t) {
    const e = this.config;
    e.update();
    const n = this._options = e.createResolver(e.chartOptionScopes(), this.getContext()), s = this._animationsDisabled = !n.animation;
    if (this._updateScales(), this._checkEventBindings(), this._updateHiddenIndices(), this._plugins.invalidate(), this.notifyPlugins("beforeUpdate", { mode: t, cancelable: !0 }) === !1)
      return;
    const r = this.buildOrUpdateControllers();
    this.notifyPlugins("beforeElementsUpdate");
    let a = 0;
    for (let c = 0, u = this.data.datasets.length; c < u; c++) {
      const { controller: d } = this.getDatasetMeta(c), h = !s && r.indexOf(d) === -1;
      d.buildOrUpdateElements(h), a = Math.max(+d.getMaxOverflow(), a);
    }
    a = this._minPadding = n.layout.autoPadding ? a : 0, this._updateLayout(a), s || Ot(r, (c) => {
      c.reset();
    }), this._updateDatasets(t), this.notifyPlugins("afterUpdate", { mode: t }), this._layers.sort(Td("z", "_idx"));
    const { _active: o, _lastEvent: l } = this;
    l ? this._eventHandler(l, !0) : o.length && this._updateHoverStyles(o, o, !0), this.render();
  }
  _updateScales() {
    Ot(this.scales, (t) => {
      Ye.removeBox(this, t);
    }), this.ensureScalesHaveIDs(), this.buildOrUpdateScales();
  }
  _checkEventBindings() {
    const t = this.options, e = new Set(Object.keys(this._listeners)), n = new Set(t.events);
    (!Hu(e, n) || !!this._responsiveListeners !== t.responsive) && (this.unbindEvents(), this.bindEvents());
  }
  _updateHiddenIndices() {
    const { _hiddenIndices: t } = this, e = this._getUniformDataChanges() || [];
    for (const { method: n, start: s, count: r } of e) {
      const a = n === "_removeElements" ? -r : r;
      vk(t, s, a);
    }
  }
  _getUniformDataChanges() {
    const t = this._dataChanges;
    if (!t || !t.length)
      return;
    this._dataChanges = [];
    const e = this.data.datasets.length, n = (r) => new Set(
      t.filter((a) => a[0] === r).map((a, o) => o + "," + a.splice(1).join(","))
    ), s = n(0);
    for (let r = 1; r < e; r++)
      if (!Hu(s, n(r)))
        return;
    return Array.from(s).map((r) => r.split(",")).map((r) => ({ method: r[1], start: +r[2], count: +r[3] }));
  }
  _updateLayout(t) {
    if (this.notifyPlugins("beforeLayout", { cancelable: !0 }) === !1)
      return;
    Ye.update(this, this.width, this.height, t);
    const e = this.chartArea, n = e.width <= 0 || e.height <= 0;
    this._layers = [], Ot(this.boxes, (s) => {
      n && s.position === "chartArea" || (s.configure && s.configure(), this._layers.push(...s._layers()));
    }, this), this._layers.forEach((s, r) => {
      s._idx = r;
    }), this.notifyPlugins("afterLayout");
  }
  _updateDatasets(t) {
    if (this.notifyPlugins("beforeDatasetsUpdate", { mode: t, cancelable: !0 }) !== !1) {
      for (let e = 0, n = this.data.datasets.length; e < n; ++e)
        this.getDatasetMeta(e).controller.configure();
      for (let e = 0, n = this.data.datasets.length; e < n; ++e)
        this._updateDataset(e, tn(t) ? t({ datasetIndex: e }) : t);
      this.notifyPlugins("afterDatasetsUpdate", { mode: t });
    }
  }
  _updateDataset(t, e) {
    const n = this.getDatasetMeta(t), s = { meta: n, index: t, mode: e, cancelable: !0 };
    this.notifyPlugins("beforeDatasetUpdate", s) !== !1 && (n.controller._update(e), s.cancelable = !1, this.notifyPlugins("afterDatasetUpdate", s));
  }
  render() {
    this.notifyPlugins("beforeRender", { cancelable: !0 }) !== !1 && (ki.has(this) ? this.attached && !ki.running(this) && ki.start(this) : (this.draw(), Dd({ chart: this })));
  }
  draw() {
    let t;
    if (this._resizeBeforeDraw) {
      const { width: n, height: s } = this._resizeBeforeDraw;
      this._resize(n, s), this._resizeBeforeDraw = null;
    }
    if (this.clear(), this.width <= 0 || this.height <= 0 || this.notifyPlugins("beforeDraw", { cancelable: !0 }) === !1)
      return;
    const e = this._layers;
    for (t = 0; t < e.length && e[t].z <= 0; ++t)
      e[t].draw(this.chartArea);
    for (this._drawDatasets(); t < e.length; ++t)
      e[t].draw(this.chartArea);
    this.notifyPlugins("afterDraw");
  }
  _getSortedDatasetMetas(t) {
    const e = this._sortedMetasets, n = [];
    let s, r;
    for (s = 0, r = e.length; s < r; ++s) {
      const a = e[s];
      (!t || a.visible) && n.push(a);
    }
    return n;
  }
  getSortedVisibleDatasetMetas() {
    return this._getSortedDatasetMetas(!0);
  }
  _drawDatasets() {
    if (this.notifyPlugins("beforeDatasetsDraw", { cancelable: !0 }) === !1)
      return;
    const t = this.getSortedVisibleDatasetMetas();
    for (let e = t.length - 1; e >= 0; --e)
      this._drawDataset(t[e]);
    this.notifyPlugins("afterDatasetsDraw");
  }
  _drawDataset(t) {
    const e = this.ctx, n = t._clip, s = !n.disabled, r = this.chartArea, a = {
      meta: t,
      index: t.index,
      cancelable: !0
    };
    this.notifyPlugins("beforeDatasetDraw", a) !== !1 && (s && pc(e, {
      left: n.left === !1 ? 0 : r.left - n.left,
      right: n.right === !1 ? this.width : r.right + n.right,
      top: n.top === !1 ? 0 : r.top - n.top,
      bottom: n.bottom === !1 ? this.height : r.bottom + n.bottom
    }), t.controller.draw(), s && gc(e), a.cancelable = !1, this.notifyPlugins("afterDatasetDraw", a));
  }
  isPointInArea(t) {
    return Gs(t, this.chartArea, this._minPadding);
  }
  getElementsAtEventForMode(t, e, n, s) {
    const r = Iw.modes[e];
    return typeof r == "function" ? r(this, t, n, s) : [];
  }
  getDatasetMeta(t) {
    const e = this.data.datasets[t], n = this._metasets;
    let s = n.filter((r) => r && r._dataset === e).pop();
    return s || (s = {
      type: null,
      data: [],
      dataset: null,
      controller: null,
      hidden: null,
      xAxisID: null,
      yAxisID: null,
      order: e && e.order || 0,
      index: t,
      _dataset: e,
      _parsed: [],
      _sorted: !1
    }, n.push(s)), s;
  }
  getContext() {
    return this.$context || (this.$context = sn(null, { chart: this, type: "chart" }));
  }
  getVisibleDatasetCount() {
    return this.getSortedVisibleDatasetMetas().length;
  }
  isDatasetVisible(t) {
    const e = this.data.datasets[t];
    if (!e)
      return !1;
    const n = this.getDatasetMeta(t);
    return typeof n.hidden == "boolean" ? !n.hidden : !e.hidden;
  }
  setDatasetVisibility(t, e) {
    const n = this.getDatasetMeta(t);
    n.hidden = !e;
  }
  toggleDataVisibility(t) {
    this._hiddenIndices[t] = !this._hiddenIndices[t];
  }
  getDataVisibility(t) {
    return !this._hiddenIndices[t];
  }
  _updateVisibility(t, e, n) {
    const s = n ? "show" : "hide", r = this.getDatasetMeta(t), a = r.controller._resolveAnimations(void 0, s);
    Ze(e) ? (r.data[e].hidden = !n, this.update()) : (this.setDatasetVisibility(t, n), a.update(r, { visible: n }), this.update((o) => o.datasetIndex === t ? s : void 0));
  }
  hide(t, e) {
    this._updateVisibility(t, e, !1);
  }
  show(t, e) {
    this._updateVisibility(t, e, !0);
  }
  _destroyDatasetMeta(t) {
    const e = this._metasets[t];
    e && e.controller && e.controller._destroy(), delete this._metasets[t];
  }
  _stop() {
    let t, e;
    for (this.stop(), ki.remove(this), t = 0, e = this.data.datasets.length; t < e; ++t)
      this._destroyDatasetMeta(t);
  }
  destroy() {
    this.notifyPlugins("beforeDestroy");
    const { canvas: t, ctx: e } = this;
    this._stop(), this.config.clearCache(), t && (this.unbindEvents(), Ju(t, e), this.platform.releaseContext(e), this.canvas = null, this.ctx = null), this.notifyPlugins("destroy"), delete ba[this.id], this.notifyPlugins("afterDestroy");
  }
  toBase64Image(...t) {
    return this.canvas.toDataURL(...t);
  }
  bindEvents() {
    this.bindUserEvents(), this.options.responsive ? this.bindResponsiveEvents() : this.attached = !0;
  }
  bindUserEvents() {
    const t = this._listeners, e = this.platform, n = (r, a) => {
      e.addEventListener(this, r, a), t[r] = a;
    }, s = (r, a, o) => {
      r.offsetX = a, r.offsetY = o, this._eventHandler(r);
    };
    Ot(this.options.events, (r) => n(r, s));
  }
  bindResponsiveEvents() {
    this._responsiveListeners || (this._responsiveListeners = {});
    const t = this._responsiveListeners, e = this.platform, n = (l, c) => {
      e.addEventListener(this, l, c), t[l] = c;
    }, s = (l, c) => {
      t[l] && (e.removeEventListener(this, l, c), delete t[l]);
    }, r = (l, c) => {
      this.canvas && this.resize(l, c);
    };
    let a;
    const o = () => {
      s("attach", o), this.attached = !0, this.resize(), n("resize", r), n("detach", a);
    };
    a = () => {
      this.attached = !1, s("resize", r), this._stop(), this._resize(0, 0), n("attach", o);
    }, e.isAttached(this.canvas) ? o() : a();
  }
  unbindEvents() {
    Ot(this._listeners, (t, e) => {
      this.platform.removeEventListener(this, e, t);
    }), this._listeners = {}, Ot(this._responsiveListeners, (t, e) => {
      this.platform.removeEventListener(this, e, t);
    }), this._responsiveListeners = void 0;
  }
  updateHoverStyle(t, e, n) {
    const s = n ? "set" : "remove";
    let r, a, o, l;
    for (e === "dataset" && (r = this.getDatasetMeta(t[0].datasetIndex), r.controller["_" + s + "DatasetHoverStyle"]()), o = 0, l = t.length; o < l; ++o) {
      a = t[o];
      const c = a && this.getDatasetMeta(a.datasetIndex).controller;
      c && c[s + "HoverStyle"](a.element, a.datasetIndex, a.index);
    }
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(t) {
    const e = this._active || [], n = t.map(({ datasetIndex: r, index: a }) => {
      const o = this.getDatasetMeta(r);
      if (!o)
        throw new Error("No dataset found at index " + r);
      return {
        datasetIndex: r,
        element: o.data[a],
        index: a
      };
    });
    !ha(n, e) && (this._active = n, this._lastEvent = null, this._updateHoverStyles(n, e));
  }
  notifyPlugins(t, e, n) {
    return this._plugins.notify(this, t, e, n);
  }
  _updateHoverStyles(t, e, n) {
    const s = this.options.hover, r = (l, c) => l.filter((u) => !c.some((d) => u.datasetIndex === d.datasetIndex && u.index === d.index)), a = r(e, t), o = n ? t : r(t, e);
    a.length && this.updateHoverStyle(a, s.mode, !1), o.length && s.mode && this.updateHoverStyle(o, s.mode, !0);
  }
  _eventHandler(t, e) {
    const n = {
      event: t,
      replay: e,
      cancelable: !0,
      inChartArea: this.isPointInArea(t)
    }, s = (a) => (a.options.events || this.options.events).includes(t.native.type);
    if (this.notifyPlugins("beforeEvent", n, s) === !1)
      return;
    const r = this._handleEvent(t, e, n.inChartArea);
    return n.cancelable = !1, this.notifyPlugins("afterEvent", n, s), (r || n.changed) && this.render(), this;
  }
  _handleEvent(t, e, n) {
    const { _active: s = [], options: r } = this, a = e, o = this._getActiveElements(t, s, n, a), l = lC(t), c = Ak(t, this._lastEvent, n, l);
    n && (this._lastEvent = null, Dt(r.onHover, [t, o, this], this), l && Dt(r.onClick, [t, o, this], this));
    const u = !ha(o, s);
    return (u || e) && (this._active = o, this._updateHoverStyles(o, s, e)), this._lastEvent = c, u;
  }
  _getActiveElements(t, e, n, s) {
    if (t.type === "mouseout")
      return [];
    if (!n)
      return e;
    const r = this.options.hover;
    return this.getElementsAtEventForMode(t, r.mode, r, s);
  }
}
const Pd = () => Ot(Qs.instances, (i) => i._plugins.invalidate()), Hi = !0;
Object.defineProperties(Qs, {
  defaults: {
    enumerable: Hi,
    value: Ct
  },
  instances: {
    enumerable: Hi,
    value: ba
  },
  overrides: {
    enumerable: Hi,
    value: wn
  },
  registry: {
    enumerable: Hi,
    value: gi
  },
  version: {
    enumerable: Hi,
    value: pk
  },
  getChart: {
    enumerable: Hi,
    value: yg
  },
  register: {
    enumerable: Hi,
    value: (...i) => {
      gi.add(...i), Pd();
    }
  },
  unregister: {
    enumerable: Hi,
    value: (...i) => {
      gi.remove(...i), Pd();
    }
  }
});
function _g(i, t, e) {
  const { startAngle: n, pixelMargin: s, x: r, y: a, outerRadius: o, innerRadius: l } = t;
  let c = s / o;
  i.beginPath(), i.arc(r, a, o, n - c, e + c), l > s ? (c = s / l, i.arc(r, a, l, e + c, n - c, !0)) : i.arc(r, a, s, e + Wt, n - Wt), i.closePath(), i.clip();
}
function bk(i) {
  return mc(i, ["outerStart", "outerEnd", "innerStart", "innerEnd"]);
}
function yk(i, t, e, n) {
  const s = bk(i.options.borderRadius), r = (e - t) / 2, a = Math.min(r, n * t / 2), o = (l) => {
    const c = (e - Math.min(r, l)) * n / 2;
    return ae(l, 0, Math.min(r, c));
  };
  return {
    outerStart: o(s.outerStart),
    outerEnd: o(s.outerEnd),
    innerStart: ae(s.innerStart, 0, a),
    innerEnd: ae(s.innerEnd, 0, a)
  };
}
function Nn(i, t, e, n) {
  return {
    x: e + i * Math.cos(t),
    y: n + i * Math.sin(t)
  };
}
function vl(i, t, e, n, s, r) {
  const { x: a, y: o, startAngle: l, pixelMargin: c, innerRadius: u } = t, d = Math.max(t.outerRadius + n + e - c, 0), h = u > 0 ? u + n + e + c : 0;
  let f = 0;
  const p = s - l;
  if (n) {
    const w = u > 0 ? u - n : 0, I = d > 0 ? d - n : 0, T = (w + I) / 2, V = T !== 0 ? p * T / (T + n) : p;
    f = (p - V) / 2;
  }
  const g = Math.max(1e-3, p * d - e / Bt) / d, m = (p - g) / 2, v = l + m + f, b = s - m - f, { outerStart: _, outerEnd: S, innerStart: C, innerEnd: O } = yk(t, h, d, b - v), k = d - _, P = d - S, x = v + _ / k, R = b - S / P, B = h + C, L = h + O, Y = v + C / B, j = b - O / L;
  if (i.beginPath(), r) {
    if (i.arc(a, o, d, x, R), S > 0) {
      const T = Nn(P, R, a, o);
      i.arc(T.x, T.y, S, R, b + Wt);
    }
    const w = Nn(L, b, a, o);
    if (i.lineTo(w.x, w.y), O > 0) {
      const T = Nn(L, j, a, o);
      i.arc(T.x, T.y, O, b + Wt, j + Math.PI);
    }
    if (i.arc(a, o, h, b - O / h, v + C / h, !0), C > 0) {
      const T = Nn(B, Y, a, o);
      i.arc(T.x, T.y, C, Y + Math.PI, v - Wt);
    }
    const I = Nn(k, v, a, o);
    if (i.lineTo(I.x, I.y), _ > 0) {
      const T = Nn(k, x, a, o);
      i.arc(T.x, T.y, _, v - Wt, x);
    }
  } else {
    i.moveTo(a, o);
    const w = Math.cos(x) * d + a, I = Math.sin(x) * d + o;
    i.lineTo(w, I);
    const T = Math.cos(R) * d + a, V = Math.sin(R) * d + o;
    i.lineTo(T, V);
  }
  i.closePath();
}
function _k(i, t, e, n, s) {
  const { fullCircles: r, startAngle: a, circumference: o } = t;
  let l = t.endAngle;
  if (r) {
    vl(i, t, e, n, a + Tt, s);
    for (let c = 0; c < r; ++c)
      i.fill();
    isNaN(o) || (l = a + o % Tt, o % Tt === 0 && (l += Tt));
  }
  return vl(i, t, e, n, l, s), i.fill(), l;
}
function xk(i, t, e) {
  const { x: n, y: s, startAngle: r, pixelMargin: a, fullCircles: o } = t, l = Math.max(t.outerRadius - a, 0), c = t.innerRadius + a;
  let u;
  for (e && _g(i, t, r + Tt), i.beginPath(), i.arc(n, s, c, r + Tt, r, !0), u = 0; u < o; ++u)
    i.stroke();
  for (i.beginPath(), i.arc(n, s, l, r, r + Tt), u = 0; u < o; ++u)
    i.stroke();
}
function Ck(i, t, e, n, s, r) {
  const { options: a } = t, { borderWidth: o, borderJoinStyle: l } = a, c = a.borderAlign === "inner";
  o && (c ? (i.lineWidth = o * 2, i.lineJoin = l || "round") : (i.lineWidth = o, i.lineJoin = l || "bevel"), t.fullCircles && xk(i, t, c), c && _g(i, t, s), vl(i, t, e, n, s, r), i.stroke());
}
class Na extends ni {
  constructor(t) {
    super(), this.options = void 0, this.circumference = void 0, this.startAngle = void 0, this.endAngle = void 0, this.innerRadius = void 0, this.outerRadius = void 0, this.pixelMargin = 0, this.fullCircles = 0, t && Object.assign(this, t);
  }
  inRange(t, e, n) {
    const s = this.getProps(["x", "y"], n), { angle: r, distance: a } = Bp(s, { x: t, y: e }), { startAngle: o, endAngle: l, innerRadius: c, outerRadius: u, circumference: d } = this.getProps([
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius",
      "circumference"
    ], n), h = this.options.spacing / 2, p = yt(d, l - o) >= Tt || Zs(r, o, l), g = Yi(a, c + h, u + h);
    return p && g;
  }
  getCenterPoint(t) {
    const { x: e, y: n, startAngle: s, endAngle: r, innerRadius: a, outerRadius: o } = this.getProps([
      "x",
      "y",
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius",
      "circumference"
    ], t), { offset: l, spacing: c } = this.options, u = (s + r) / 2, d = (a + o + c + l) / 2;
    return {
      x: e + Math.cos(u) * d,
      y: n + Math.sin(u) * d
    };
  }
  tooltipPosition(t) {
    return this.getCenterPoint(t);
  }
  draw(t) {
    const { options: e, circumference: n } = this, s = (e.offset || 0) / 2, r = (e.spacing || 0) / 2, a = e.circular;
    if (this.pixelMargin = e.borderAlign === "inner" ? 0.33 : 0, this.fullCircles = n > Tt ? Math.floor(n / Tt) : 0, n === 0 || this.innerRadius < 0 || this.outerRadius < 0)
      return;
    t.save();
    let o = 0;
    if (s) {
      o = s / 2;
      const c = (this.startAngle + this.endAngle) / 2;
      t.translate(Math.cos(c) * o, Math.sin(c) * o), this.circumference >= Bt && (o = s);
    }
    t.fillStyle = e.backgroundColor, t.strokeStyle = e.borderColor;
    const l = _k(t, this, o, r, a);
    Ck(t, this, o, r, l, a), t.restore();
  }
}
Na.id = "arc";
Na.defaults = {
  borderAlign: "center",
  borderColor: "#fff",
  borderJoinStyle: void 0,
  borderRadius: 0,
  borderWidth: 2,
  offset: 0,
  spacing: 0,
  angle: void 0,
  circular: !0
};
Na.defaultRoutes = {
  backgroundColor: "backgroundColor"
};
function xg(i, t, e = t) {
  i.lineCap = yt(e.borderCapStyle, t.borderCapStyle), i.setLineDash(yt(e.borderDash, t.borderDash)), i.lineDashOffset = yt(e.borderDashOffset, t.borderDashOffset), i.lineJoin = yt(e.borderJoinStyle, t.borderJoinStyle), i.lineWidth = yt(e.borderWidth, t.borderWidth), i.strokeStyle = yt(e.borderColor, t.borderColor);
}
function Sk(i, t, e) {
  i.lineTo(e.x, e.y);
}
function wk(i) {
  return i.stepped ? YC : i.tension || i.cubicInterpolationMode === "monotone" ? UC : Sk;
}
function Cg(i, t, e = {}) {
  const n = i.length, { start: s = 0, end: r = n - 1 } = e, { start: a, end: o } = t, l = Math.max(s, a), c = Math.min(r, o), u = s < a && r < a || s > o && r > o;
  return {
    count: n,
    start: l,
    loop: t.loop,
    ilen: c < l && !u ? n + c - l : c - l
  };
}
function kk(i, t, e, n) {
  const { points: s, options: r } = t, { count: a, start: o, loop: l, ilen: c } = Cg(s, e, n), u = wk(r);
  let { move: d = !0, reverse: h } = n || {}, f, p, g;
  for (f = 0; f <= c; ++f)
    p = s[(o + (h ? c - f : f)) % a], !p.skip && (d ? (i.moveTo(p.x, p.y), d = !1) : u(i, g, p, h, r.stepped), g = p);
  return l && (p = s[(o + (h ? c : 0)) % a], u(i, g, p, h, r.stepped)), !!l;
}
function Ok(i, t, e, n) {
  const s = t.points, { count: r, start: a, ilen: o } = Cg(s, e, n), { move: l = !0, reverse: c } = n || {};
  let u = 0, d = 0, h, f, p, g, m, v;
  const b = (S) => (a + (c ? o - S : S)) % r, _ = () => {
    g !== m && (i.lineTo(u, m), i.lineTo(u, g), i.lineTo(u, v));
  };
  for (l && (f = s[b(0)], i.moveTo(f.x, f.y)), h = 0; h <= o; ++h) {
    if (f = s[b(h)], f.skip)
      continue;
    const S = f.x, C = f.y, O = S | 0;
    O === p ? (C < g ? g = C : C > m && (m = C), u = (d * u + S) / ++d) : (_(), i.lineTo(S, C), p = O, d = 0, g = m = C), v = C;
  }
  _();
}
function Al(i) {
  const t = i.options, e = t.borderDash && t.borderDash.length;
  return !i._decimated && !i._loop && !t.tension && t.cubicInterpolationMode !== "monotone" && !t.stepped && !e ? Ok : kk;
}
function Mk(i) {
  return i.stepped ? CS : i.tension || i.cubicInterpolationMode === "monotone" ? SS : fn;
}
function Tk(i, t, e, n) {
  let s = t._path;
  s || (s = t._path = new Path2D(), t.path(s, e, n) && s.closePath()), xg(i, t.options), i.stroke(s);
}
function Dk(i, t, e, n) {
  const { segments: s, options: r } = t, a = Al(t);
  for (const o of s)
    xg(i, r, o.style), i.beginPath(), a(i, t, o, { start: e, end: e + n - 1 }) && i.closePath(), i.stroke();
}
const Pk = typeof Path2D == "function";
function Lk(i, t, e, n) {
  Pk && !t.options.segment ? Tk(i, t, e, n) : Dk(i, t, e, n);
}
class fr extends ni {
  constructor(t) {
    super(), this.animated = !0, this.options = void 0, this._chart = void 0, this._loop = void 0, this._fullLoop = void 0, this._path = void 0, this._points = void 0, this._segments = void 0, this._decimated = !1, this._pointsUpdated = !1, this._datasetIndex = void 0, t && Object.assign(this, t);
  }
  updateControlPoints(t, e) {
    const n = this.options;
    if ((n.tension || n.cubicInterpolationMode === "monotone") && !n.stepped && !this._pointsUpdated) {
      const s = n.spanGaps ? this._loop : this._fullLoop;
      gS(this._points, n, t, s, e), this._pointsUpdated = !0;
    }
  }
  set points(t) {
    this._points = t, delete this._segments, delete this._path, this._pointsUpdated = !1;
  }
  get points() {
    return this._points;
  }
  get segments() {
    return this._segments || (this._segments = IS(this, this.options.segment));
  }
  first() {
    const t = this.segments, e = this.points;
    return t.length && e[t[0].start];
  }
  last() {
    const t = this.segments, e = this.points, n = t.length;
    return n && e[t[n - 1].end];
  }
  interpolate(t, e) {
    const n = this.options, s = t[e], r = this.points, a = DS(this, { property: e, start: s, end: s });
    if (!a.length)
      return;
    const o = [], l = Mk(n);
    let c, u;
    for (c = 0, u = a.length; c < u; ++c) {
      const { start: d, end: h } = a[c], f = r[d], p = r[h];
      if (f === p) {
        o.push(f);
        continue;
      }
      const g = Math.abs((s - f[e]) / (p[e] - f[e])), m = l(f, p, g, n.stepped);
      m[e] = t[e], o.push(m);
    }
    return o.length === 1 ? o[0] : o;
  }
  pathSegment(t, e, n) {
    return Al(this)(t, this, e, n);
  }
  path(t, e, n) {
    const s = this.segments, r = Al(this);
    let a = this._loop;
    e = e || 0, n = n || this.points.length - e;
    for (const o of s)
      a &= r(t, this, o, { start: e, end: e + n - 1 });
    return !!a;
  }
  draw(t, e, n, s) {
    const r = this.options || {};
    (this.points || []).length && r.borderWidth && (t.save(), Lk(t, this, n, s), t.restore()), this.animated && (this._pointsUpdated = !1, this._path = void 0);
  }
}
fr.id = "line";
fr.defaults = {
  borderCapStyle: "butt",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: "miter",
  borderWidth: 3,
  capBezierPoints: !0,
  cubicInterpolationMode: "default",
  fill: !1,
  spanGaps: !1,
  stepped: !1,
  tension: 0
};
fr.defaultRoutes = {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
};
fr.descriptors = {
  _scriptable: !0,
  _indexable: (i) => i !== "borderDash" && i !== "fill"
};
function Ld(i, t, e, n) {
  const s = i.options, { [e]: r } = i.getProps([e], n);
  return Math.abs(t - r) < s.radius + s.hitRadius;
}
class Ha extends ni {
  constructor(t) {
    super(), this.options = void 0, this.parsed = void 0, this.skip = void 0, this.stop = void 0, t && Object.assign(this, t);
  }
  inRange(t, e, n) {
    const s = this.options, { x: r, y: a } = this.getProps(["x", "y"], n);
    return Math.pow(t - r, 2) + Math.pow(e - a, 2) < Math.pow(s.hitRadius + s.radius, 2);
  }
  inXRange(t, e) {
    return Ld(this, t, "x", e);
  }
  inYRange(t, e) {
    return Ld(this, t, "y", e);
  }
  getCenterPoint(t) {
    const { x: e, y: n } = this.getProps(["x", "y"], t);
    return { x: e, y: n };
  }
  size(t) {
    t = t || this.options || {};
    let e = t.radius || 0;
    e = Math.max(e, e && t.hoverRadius || 0);
    const n = e && t.borderWidth || 0;
    return (e + n) * 2;
  }
  draw(t, e) {
    const n = this.options;
    this.skip || n.radius < 0.1 || !Gs(this, e, this.size(n) / 2) || (t.strokeStyle = n.borderColor, t.lineWidth = n.borderWidth, t.fillStyle = n.backgroundColor, fl(t, n, this.x, this.y));
  }
  getRange() {
    const t = this.options || {};
    return t.radius + t.hitRadius;
  }
}
Ha.id = "point";
Ha.defaults = {
  borderWidth: 1,
  hitRadius: 1,
  hoverBorderWidth: 1,
  hoverRadius: 4,
  pointStyle: "circle",
  radius: 3,
  rotation: 0
};
Ha.defaultRoutes = {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
};
function Sg(i, t) {
  const { x: e, y: n, base: s, width: r, height: a } = i.getProps(["x", "y", "base", "width", "height"], t);
  let o, l, c, u, d;
  return i.horizontal ? (d = a / 2, o = Math.min(e, s), l = Math.max(e, s), c = n - d, u = n + d) : (d = r / 2, o = e - d, l = e + d, c = Math.min(n, s), u = Math.max(n, s)), { left: o, top: c, right: l, bottom: u };
}
function Zi(i, t, e, n) {
  return i ? 0 : ae(t, e, n);
}
function Ik(i, t, e) {
  const n = i.options.borderWidth, s = i.borderSkipped, r = Kp(n);
  return {
    t: Zi(s.top, r.top, 0, e),
    r: Zi(s.right, r.right, 0, t),
    b: Zi(s.bottom, r.bottom, 0, e),
    l: Zi(s.left, r.left, 0, t)
  };
}
function Ek(i, t, e) {
  const { enableBorderRadius: n } = i.getProps(["enableBorderRadius"]), s = i.options.borderRadius, r = _n(s), a = Math.min(t, e), o = i.borderSkipped, l = n || St(s);
  return {
    topLeft: Zi(!l || o.top || o.left, r.topLeft, 0, a),
    topRight: Zi(!l || o.top || o.right, r.topRight, 0, a),
    bottomLeft: Zi(!l || o.bottom || o.left, r.bottomLeft, 0, a),
    bottomRight: Zi(!l || o.bottom || o.right, r.bottomRight, 0, a)
  };
}
function $k(i) {
  const t = Sg(i), e = t.right - t.left, n = t.bottom - t.top, s = Ik(i, e / 2, n / 2), r = Ek(i, e / 2, n / 2);
  return {
    outer: {
      x: t.left,
      y: t.top,
      w: e,
      h: n,
      radius: r
    },
    inner: {
      x: t.left + s.l,
      y: t.top + s.t,
      w: e - s.l - s.r,
      h: n - s.t - s.b,
      radius: {
        topLeft: Math.max(0, r.topLeft - Math.max(s.t, s.l)),
        topRight: Math.max(0, r.topRight - Math.max(s.t, s.r)),
        bottomLeft: Math.max(0, r.bottomLeft - Math.max(s.b, s.l)),
        bottomRight: Math.max(0, r.bottomRight - Math.max(s.b, s.r))
      }
    }
  };
}
function Fo(i, t, e, n) {
  const s = t === null, r = e === null, o = i && !(s && r) && Sg(i, n);
  return o && (s || Yi(t, o.left, o.right)) && (r || Yi(e, o.top, o.bottom));
}
function Bk(i) {
  return i.topLeft || i.topRight || i.bottomLeft || i.bottomRight;
}
function Rk(i, t) {
  i.rect(t.x, t.y, t.w, t.h);
}
function No(i, t, e = {}) {
  const n = i.x !== e.x ? -t : 0, s = i.y !== e.y ? -t : 0, r = (i.x + i.w !== e.x + e.w ? t : 0) - n, a = (i.y + i.h !== e.y + e.h ? t : 0) - s;
  return {
    x: i.x + n,
    y: i.y + s,
    w: i.w + r,
    h: i.h + a,
    radius: i.radius
  };
}
class Va extends ni {
  constructor(t) {
    super(), this.options = void 0, this.horizontal = void 0, this.base = void 0, this.width = void 0, this.height = void 0, this.inflateAmount = void 0, t && Object.assign(this, t);
  }
  draw(t) {
    const { inflateAmount: e, options: { borderColor: n, backgroundColor: s } } = this, { inner: r, outer: a } = $k(this), o = Bk(a.radius) ? Ks : Rk;
    t.save(), (a.w !== r.w || a.h !== r.h) && (t.beginPath(), o(t, No(a, e, r)), t.clip(), o(t, No(r, -e, a)), t.fillStyle = n, t.fill("evenodd")), t.beginPath(), o(t, No(r, e)), t.fillStyle = s, t.fill(), t.restore();
  }
  inRange(t, e, n) {
    return Fo(this, t, e, n);
  }
  inXRange(t, e) {
    return Fo(this, t, null, e);
  }
  inYRange(t, e) {
    return Fo(this, null, t, e);
  }
  getCenterPoint(t) {
    const { x: e, y: n, base: s, horizontal: r } = this.getProps(["x", "y", "base", "horizontal"], t);
    return {
      x: r ? (e + s) / 2 : e,
      y: r ? n : (n + s) / 2
    };
  }
  getRange(t) {
    return t === "x" ? this.width / 2 : this.height / 2;
  }
}
Va.id = "bar";
Va.defaults = {
  borderSkipped: "start",
  borderWidth: 0,
  borderRadius: 0,
  inflateAmount: "auto",
  pointStyle: void 0
};
Va.defaultRoutes = {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
};
const Id = (i, t) => {
  let { boxHeight: e = t, boxWidth: n = t } = i;
  return i.usePointStyle && (e = Math.min(e, t), n = i.pointStyleWidth || Math.min(n, t)), {
    boxWidth: n,
    boxHeight: e,
    itemHeight: Math.max(t, e)
  };
}, Fk = (i, t) => i !== null && t !== null && i.datasetIndex === t.datasetIndex && i.index === t.index;
class Ed extends ni {
  constructor(t) {
    super(), this._added = !1, this.legendHitBoxes = [], this._hoveredItem = null, this.doughnutMode = !1, this.chart = t.chart, this.options = t.options, this.ctx = t.ctx, this.legendItems = void 0, this.columnSizes = void 0, this.lineWidths = void 0, this.maxHeight = void 0, this.maxWidth = void 0, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.height = void 0, this.width = void 0, this._margins = void 0, this.position = void 0, this.weight = void 0, this.fullSize = void 0;
  }
  update(t, e, n) {
    this.maxWidth = t, this.maxHeight = e, this._margins = n, this.setDimensions(), this.buildLabels(), this.fit();
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = this._margins.left, this.right = this.width) : (this.height = this.maxHeight, this.top = this._margins.top, this.bottom = this.height);
  }
  buildLabels() {
    const t = this.options.labels || {};
    let e = Dt(t.generateLabels, [this.chart], this) || [];
    t.filter && (e = e.filter((n) => t.filter(n, this.chart.data))), t.sort && (e = e.sort((n, s) => t.sort(n, s, this.chart.data))), this.options.reverse && e.reverse(), this.legendItems = e;
  }
  fit() {
    const { options: t, ctx: e } = this;
    if (!t.display) {
      this.width = this.height = 0;
      return;
    }
    const n = t.labels, s = Xt(n.font), r = s.size, a = this._computeTitleHeight(), { boxWidth: o, itemHeight: l } = Id(n, r);
    let c, u;
    e.font = s.string, this.isHorizontal() ? (c = this.maxWidth, u = this._fitRows(a, r, o, l) + 10) : (u = this.maxHeight, c = this._fitCols(a, r, o, l) + 10), this.width = Math.min(c, t.maxWidth || this.maxWidth), this.height = Math.min(u, t.maxHeight || this.maxHeight);
  }
  _fitRows(t, e, n, s) {
    const { ctx: r, maxWidth: a, options: { labels: { padding: o } } } = this, l = this.legendHitBoxes = [], c = this.lineWidths = [0], u = s + o;
    let d = t;
    r.textAlign = "left", r.textBaseline = "middle";
    let h = -1, f = -u;
    return this.legendItems.forEach((p, g) => {
      const m = n + e / 2 + r.measureText(p.text).width;
      (g === 0 || c[c.length - 1] + m + 2 * o > a) && (d += u, c[c.length - (g > 0 ? 0 : 1)] = 0, f += u, h++), l[g] = { left: 0, top: f, row: h, width: m, height: s }, c[c.length - 1] += m + o;
    }), d;
  }
  _fitCols(t, e, n, s) {
    const { ctx: r, maxHeight: a, options: { labels: { padding: o } } } = this, l = this.legendHitBoxes = [], c = this.columnSizes = [], u = a - t;
    let d = o, h = 0, f = 0, p = 0, g = 0;
    return this.legendItems.forEach((m, v) => {
      const b = n + e / 2 + r.measureText(m.text).width;
      v > 0 && f + s + 2 * o > u && (d += h + o, c.push({ width: h, height: f }), p += h + o, g++, h = f = 0), l[v] = { left: p, top: f, col: g, width: b, height: s }, h = Math.max(h, b), f += s + o;
    }), d += h, c.push({ width: h, height: f }), d;
  }
  adjustHitBoxes() {
    if (!this.options.display)
      return;
    const t = this._computeTitleHeight(), { legendHitBoxes: e, options: { align: n, labels: { padding: s }, rtl: r } } = this, a = Qn(r, this.left, this.width);
    if (this.isHorizontal()) {
      let o = 0, l = se(n, this.left + s, this.right - this.lineWidths[o]);
      for (const c of e)
        o !== c.row && (o = c.row, l = se(n, this.left + s, this.right - this.lineWidths[o])), c.top += this.top + t + s, c.left = a.leftForLtr(a.x(l), c.width), l += c.width + s;
    } else {
      let o = 0, l = se(n, this.top + t + s, this.bottom - this.columnSizes[o].height);
      for (const c of e)
        c.col !== o && (o = c.col, l = se(n, this.top + t + s, this.bottom - this.columnSizes[o].height)), c.top = l, c.left += this.left + s, c.left = a.leftForLtr(a.x(c.left), c.width), l += c.height + s;
    }
  }
  isHorizontal() {
    return this.options.position === "top" || this.options.position === "bottom";
  }
  draw() {
    if (this.options.display) {
      const t = this.ctx;
      pc(t, this), this._draw(), gc(t);
    }
  }
  _draw() {
    const { options: t, columnSizes: e, lineWidths: n, ctx: s } = this, { align: r, labels: a } = t, o = Ct.color, l = Qn(t.rtl, this.left, this.width), c = Xt(a.font), { color: u, padding: d } = a, h = c.size, f = h / 2;
    let p;
    this.drawTitle(), s.textAlign = l.textAlign("left"), s.textBaseline = "middle", s.lineWidth = 0.5, s.font = c.string;
    const { boxWidth: g, boxHeight: m, itemHeight: v } = Id(a, h), b = function(k, P, x) {
      if (isNaN(g) || g <= 0 || isNaN(m) || m < 0)
        return;
      s.save();
      const R = yt(x.lineWidth, 1);
      if (s.fillStyle = yt(x.fillStyle, o), s.lineCap = yt(x.lineCap, "butt"), s.lineDashOffset = yt(x.lineDashOffset, 0), s.lineJoin = yt(x.lineJoin, "miter"), s.lineWidth = R, s.strokeStyle = yt(x.strokeStyle, o), s.setLineDash(yt(x.lineDash, [])), a.usePointStyle) {
        const B = {
          radius: m * Math.SQRT2 / 2,
          pointStyle: x.pointStyle,
          rotation: x.rotation,
          borderWidth: R
        }, L = l.xPlus(k, g / 2), Y = P + f;
        Gp(s, B, L, Y, a.pointStyleWidth && g);
      } else {
        const B = P + Math.max((h - m) / 2, 0), L = l.leftForLtr(k, g), Y = _n(x.borderRadius);
        s.beginPath(), Object.values(Y).some((j) => j !== 0) ? Ks(s, {
          x: L,
          y: B,
          w: g,
          h: m,
          radius: Y
        }) : s.rect(L, B, g, m), s.fill(), R !== 0 && s.stroke();
      }
      s.restore();
    }, _ = function(k, P, x) {
      kn(s, x.text, k, P + v / 2, c, {
        strikethrough: x.hidden,
        textAlign: l.textAlign(x.textAlign)
      });
    }, S = this.isHorizontal(), C = this._computeTitleHeight();
    S ? p = {
      x: se(r, this.left + d, this.right - n[0]),
      y: this.top + d + C,
      line: 0
    } : p = {
      x: this.left + d,
      y: se(r, this.top + C + d, this.bottom - e[0].height),
      line: 0
    }, ng(this.ctx, t.textDirection);
    const O = v + d;
    this.legendItems.forEach((k, P) => {
      s.strokeStyle = k.fontColor || u, s.fillStyle = k.fontColor || u;
      const x = s.measureText(k.text).width, R = l.textAlign(k.textAlign || (k.textAlign = a.textAlign)), B = g + f + x;
      let L = p.x, Y = p.y;
      l.setWidth(this.width), S ? P > 0 && L + B + d > this.right && (Y = p.y += O, p.line++, L = p.x = se(r, this.left + d, this.right - n[p.line])) : P > 0 && Y + O > this.bottom && (L = p.x = L + e[p.line].width + d, p.line++, Y = p.y = se(r, this.top + C + d, this.bottom - e[p.line].height));
      const j = l.x(L);
      b(j, Y, k), L = bC(R, L + g + f, S ? L + B : this.right, t.rtl), _(l.x(L), Y, k), S ? p.x += B + d : p.y += O;
    }), sg(this.ctx, t.textDirection);
  }
  drawTitle() {
    const t = this.options, e = t.title, n = Xt(e.font), s = ce(e.padding);
    if (!e.display)
      return;
    const r = Qn(t.rtl, this.left, this.width), a = this.ctx, o = e.position, l = n.size / 2, c = s.top + l;
    let u, d = this.left, h = this.width;
    if (this.isHorizontal())
      h = Math.max(...this.lineWidths), u = this.top + c, d = se(t.align, d, this.right - h);
    else {
      const p = this.columnSizes.reduce((g, m) => Math.max(g, m.height), 0);
      u = c + se(t.align, this.top, this.bottom - p - t.labels.padding - this._computeTitleHeight());
    }
    const f = se(o, d, d + h);
    a.textAlign = r.textAlign(uc(o)), a.textBaseline = "middle", a.strokeStyle = e.color, a.fillStyle = e.color, a.font = n.string, kn(a, e.text, f, u, n);
  }
  _computeTitleHeight() {
    const t = this.options.title, e = Xt(t.font), n = ce(t.padding);
    return t.display ? e.lineHeight + n.height : 0;
  }
  _getLegendItemAt(t, e) {
    let n, s, r;
    if (Yi(t, this.left, this.right) && Yi(e, this.top, this.bottom)) {
      for (r = this.legendHitBoxes, n = 0; n < r.length; ++n)
        if (s = r[n], Yi(t, s.left, s.left + s.width) && Yi(e, s.top, s.top + s.height))
          return this.legendItems[n];
    }
    return null;
  }
  handleEvent(t) {
    const e = this.options;
    if (!Nk(t.type, e))
      return;
    const n = this._getLegendItemAt(t.x, t.y);
    if (t.type === "mousemove" || t.type === "mouseout") {
      const s = this._hoveredItem, r = Fk(s, n);
      s && !r && Dt(e.onLeave, [t, s, this], this), this._hoveredItem = n, n && !r && Dt(e.onHover, [t, n, this], this);
    } else n && Dt(e.onClick, [t, n, this], this);
  }
}
function Nk(i, t) {
  return !!((i === "mousemove" || i === "mouseout") && (t.onHover || t.onLeave) || t.onClick && (i === "click" || i === "mouseup"));
}
var Hk = {
  id: "legend",
  _element: Ed,
  start(i, t, e) {
    const n = i.legend = new Ed({ ctx: i.ctx, options: e, chart: i });
    Ye.configure(i, n, e), Ye.addBox(i, n);
  },
  stop(i) {
    Ye.removeBox(i, i.legend), delete i.legend;
  },
  beforeUpdate(i, t, e) {
    const n = i.legend;
    Ye.configure(i, n, e), n.options = e;
  },
  afterUpdate(i) {
    const t = i.legend;
    t.buildLabels(), t.adjustHitBoxes();
  },
  afterEvent(i, t) {
    t.replay || i.legend.handleEvent(t.event);
  },
  defaults: {
    display: !0,
    position: "top",
    align: "center",
    fullSize: !0,
    reverse: !1,
    weight: 1e3,
    onClick(i, t, e) {
      const n = t.datasetIndex, s = e.chart;
      s.isDatasetVisible(n) ? (s.hide(n), t.hidden = !0) : (s.show(n), t.hidden = !1);
    },
    onHover: null,
    onLeave: null,
    labels: {
      color: (i) => i.chart.options.color,
      boxWidth: 40,
      padding: 10,
      generateLabels(i) {
        const t = i.data.datasets, { labels: { usePointStyle: e, pointStyle: n, textAlign: s, color: r } } = i.legend.options;
        return i._getSortedDatasetMetas().map((a) => {
          const o = a.controller.getStyle(e ? 0 : void 0), l = ce(o.borderWidth);
          return {
            text: t[a.index].label,
            fillStyle: o.backgroundColor,
            fontColor: r,
            hidden: !a.visible,
            lineCap: o.borderCapStyle,
            lineDash: o.borderDash,
            lineDashOffset: o.borderDashOffset,
            lineJoin: o.borderJoinStyle,
            lineWidth: (l.width + l.height) / 4,
            strokeStyle: o.borderColor,
            pointStyle: n || o.pointStyle,
            rotation: o.rotation,
            textAlign: s || o.textAlign,
            borderRadius: 0,
            datasetIndex: a.index
          };
        }, this);
      }
    },
    title: {
      color: (i) => i.chart.options.color,
      display: !1,
      position: "center",
      text: ""
    }
  },
  descriptors: {
    _scriptable: (i) => !i.startsWith("on"),
    labels: {
      _scriptable: (i) => !["generateLabels", "filter", "sort"].includes(i)
    }
  }
};
class wg extends ni {
  constructor(t) {
    super(), this.chart = t.chart, this.options = t.options, this.ctx = t.ctx, this._padding = void 0, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this.position = void 0, this.weight = void 0, this.fullSize = void 0;
  }
  update(t, e) {
    const n = this.options;
    if (this.left = 0, this.top = 0, !n.display) {
      this.width = this.height = this.right = this.bottom = 0;
      return;
    }
    this.width = this.right = t, this.height = this.bottom = e;
    const s = $t(n.text) ? n.text.length : 1;
    this._padding = ce(n.padding);
    const r = s * Xt(n.font).lineHeight + this._padding.height;
    this.isHorizontal() ? this.height = r : this.width = r;
  }
  isHorizontal() {
    const t = this.options.position;
    return t === "top" || t === "bottom";
  }
  _drawArgs(t) {
    const { top: e, left: n, bottom: s, right: r, options: a } = this, o = a.align;
    let l = 0, c, u, d;
    return this.isHorizontal() ? (u = se(o, n, r), d = e + t, c = r - n) : (a.position === "left" ? (u = n + t, d = se(o, s, e), l = Bt * -0.5) : (u = r - t, d = se(o, e, s), l = Bt * 0.5), c = s - e), { titleX: u, titleY: d, maxWidth: c, rotation: l };
  }
  draw() {
    const t = this.ctx, e = this.options;
    if (!e.display)
      return;
    const n = Xt(e.font), r = n.lineHeight / 2 + this._padding.top, { titleX: a, titleY: o, maxWidth: l, rotation: c } = this._drawArgs(r);
    kn(t, e.text, 0, 0, n, {
      color: e.color,
      maxWidth: l,
      rotation: c,
      textAlign: uc(e.align),
      textBaseline: "middle",
      translation: [a, o]
    });
  }
}
function Vk(i, t) {
  const e = new wg({
    ctx: i.ctx,
    options: t,
    chart: i
  });
  Ye.configure(i, e, t), Ye.addBox(i, e), i.titleBlock = e;
}
var zk = {
  id: "title",
  _element: wg,
  start(i, t, e) {
    Vk(i, e);
  },
  stop(i) {
    const t = i.titleBlock;
    Ye.removeBox(i, t), delete i.titleBlock;
  },
  beforeUpdate(i, t, e) {
    const n = i.titleBlock;
    Ye.configure(i, n, e), n.options = e;
  },
  defaults: {
    align: "center",
    display: !1,
    font: {
      weight: "bold"
    },
    fullSize: !0,
    padding: 10,
    position: "top",
    text: "",
    weight: 2e3
  },
  defaultRoutes: {
    color: "color"
  },
  descriptors: {
    _scriptable: !0,
    _indexable: !1
  }
};
const $s = {
  average(i) {
    if (!i.length)
      return !1;
    let t, e, n = 0, s = 0, r = 0;
    for (t = 0, e = i.length; t < e; ++t) {
      const a = i[t].element;
      if (a && a.hasValue()) {
        const o = a.tooltipPosition();
        n += o.x, s += o.y, ++r;
      }
    }
    return {
      x: n / r,
      y: s / r
    };
  },
  nearest(i, t) {
    if (!i.length)
      return !1;
    let e = t.x, n = t.y, s = Number.POSITIVE_INFINITY, r, a, o;
    for (r = 0, a = i.length; r < a; ++r) {
      const l = i[r].element;
      if (l && l.hasValue()) {
        const c = l.getCenterPoint(), u = ul(t, c);
        u < s && (s = u, o = l);
      }
    }
    if (o) {
      const l = o.tooltipPosition();
      e = l.x, n = l.y;
    }
    return {
      x: e,
      y: n
    };
  }
};
function ci(i, t) {
  return t && ($t(t) ? Array.prototype.push.apply(i, t) : i.push(t)), i;
}
function Oi(i) {
  return (typeof i == "string" || i instanceof String) && i.indexOf(`
`) > -1 ? i.split(`
`) : i;
}
function jk(i, t) {
  const { element: e, datasetIndex: n, index: s } = t, r = i.getDatasetMeta(n).controller, { label: a, value: o } = r.getLabelAndValue(s);
  return {
    chart: i,
    label: a,
    parsed: r.getParsed(s),
    raw: i.data.datasets[n].data[s],
    formattedValue: o,
    dataset: r.getDataset(),
    dataIndex: s,
    datasetIndex: n,
    element: e
  };
}
function $d(i, t) {
  const e = i.chart.ctx, { body: n, footer: s, title: r } = i, { boxWidth: a, boxHeight: o } = t, l = Xt(t.bodyFont), c = Xt(t.titleFont), u = Xt(t.footerFont), d = r.length, h = s.length, f = n.length, p = ce(t.padding);
  let g = p.height, m = 0, v = n.reduce((S, C) => S + C.before.length + C.lines.length + C.after.length, 0);
  if (v += i.beforeBody.length + i.afterBody.length, d && (g += d * c.lineHeight + (d - 1) * t.titleSpacing + t.titleMarginBottom), v) {
    const S = t.displayColors ? Math.max(o, l.lineHeight) : l.lineHeight;
    g += f * S + (v - f) * l.lineHeight + (v - 1) * t.bodySpacing;
  }
  h && (g += t.footerMarginTop + h * u.lineHeight + (h - 1) * t.footerSpacing);
  let b = 0;
  const _ = function(S) {
    m = Math.max(m, e.measureText(S).width + b);
  };
  return e.save(), e.font = c.string, Ot(i.title, _), e.font = l.string, Ot(i.beforeBody.concat(i.afterBody), _), b = t.displayColors ? a + 2 + t.boxPadding : 0, Ot(n, (S) => {
    Ot(S.before, _), Ot(S.lines, _), Ot(S.after, _);
  }), b = 0, e.font = u.string, Ot(i.footer, _), e.restore(), m += p.width, { width: m, height: g };
}
function Wk(i, t) {
  const { y: e, height: n } = t;
  return e < n / 2 ? "top" : e > i.height - n / 2 ? "bottom" : "center";
}
function Yk(i, t, e, n) {
  const { x: s, width: r } = n, a = e.caretSize + e.caretPadding;
  if (i === "left" && s + r + a > t.width || i === "right" && s - r - a < 0)
    return !0;
}
function Uk(i, t, e, n) {
  const { x: s, width: r } = e, { width: a, chartArea: { left: o, right: l } } = i;
  let c = "center";
  return n === "center" ? c = s <= (o + l) / 2 ? "left" : "right" : s <= r / 2 ? c = "left" : s >= a - r / 2 && (c = "right"), Yk(c, i, t, e) && (c = "center"), c;
}
function Bd(i, t, e) {
  const n = e.yAlign || t.yAlign || Wk(i, e);
  return {
    xAlign: e.xAlign || t.xAlign || Uk(i, t, e, n),
    yAlign: n
  };
}
function Zk(i, t) {
  let { x: e, width: n } = i;
  return t === "right" ? e -= n : t === "center" && (e -= n / 2), e;
}
function Gk(i, t, e) {
  let { y: n, height: s } = i;
  return t === "top" ? n += e : t === "bottom" ? n -= s + e : n -= s / 2, n;
}
function Rd(i, t, e, n) {
  const { caretSize: s, caretPadding: r, cornerRadius: a } = i, { xAlign: o, yAlign: l } = e, c = s + r, { topLeft: u, topRight: d, bottomLeft: h, bottomRight: f } = _n(a);
  let p = Zk(t, o);
  const g = Gk(t, l, c);
  return l === "center" ? o === "left" ? p += c : o === "right" && (p -= c) : o === "left" ? p -= Math.max(u, h) + s : o === "right" && (p += Math.max(d, f) + s), {
    x: ae(p, 0, n.width - t.width),
    y: ae(g, 0, n.height - t.height)
  };
}
function Nr(i, t, e) {
  const n = ce(e.padding);
  return t === "center" ? i.x + i.width / 2 : t === "right" ? i.x + i.width - n.right : i.x + n.left;
}
function Fd(i) {
  return ci([], Oi(i));
}
function Kk(i, t, e) {
  return sn(i, {
    tooltip: t,
    tooltipItems: e,
    type: "tooltip"
  });
}
function Nd(i, t) {
  const e = t && t.dataset && t.dataset.tooltip && t.dataset.tooltip.callbacks;
  return e ? i.override(e) : i;
}
class bl extends ni {
  constructor(t) {
    super(), this.opacity = 0, this._active = [], this._eventPosition = void 0, this._size = void 0, this._cachedAnimations = void 0, this._tooltipItems = [], this.$animations = void 0, this.$context = void 0, this.chart = t.chart || t._chart, this._chart = this.chart, this.options = t.options, this.dataPoints = void 0, this.title = void 0, this.beforeBody = void 0, this.body = void 0, this.afterBody = void 0, this.footer = void 0, this.xAlign = void 0, this.yAlign = void 0, this.x = void 0, this.y = void 0, this.height = void 0, this.width = void 0, this.caretX = void 0, this.caretY = void 0, this.labelColors = void 0, this.labelPointStyles = void 0, this.labelTextColors = void 0;
  }
  initialize(t) {
    this.options = t, this._cachedAnimations = void 0, this.$context = void 0;
  }
  _resolveAnimations() {
    const t = this._cachedAnimations;
    if (t)
      return t;
    const e = this.chart, n = this.options.setContext(this.getContext()), s = n.enabled && e.options.animation && n.animations, r = new ag(this.chart, s);
    return s._cacheable && (this._cachedAnimations = Object.freeze(r)), r;
  }
  getContext() {
    return this.$context || (this.$context = Kk(this.chart.getContext(), this, this._tooltipItems));
  }
  getTitle(t, e) {
    const { callbacks: n } = e, s = n.beforeTitle.apply(this, [t]), r = n.title.apply(this, [t]), a = n.afterTitle.apply(this, [t]);
    let o = [];
    return o = ci(o, Oi(s)), o = ci(o, Oi(r)), o = ci(o, Oi(a)), o;
  }
  getBeforeBody(t, e) {
    return Fd(e.callbacks.beforeBody.apply(this, [t]));
  }
  getBody(t, e) {
    const { callbacks: n } = e, s = [];
    return Ot(t, (r) => {
      const a = {
        before: [],
        lines: [],
        after: []
      }, o = Nd(n, r);
      ci(a.before, Oi(o.beforeLabel.call(this, r))), ci(a.lines, o.label.call(this, r)), ci(a.after, Oi(o.afterLabel.call(this, r))), s.push(a);
    }), s;
  }
  getAfterBody(t, e) {
    return Fd(e.callbacks.afterBody.apply(this, [t]));
  }
  getFooter(t, e) {
    const { callbacks: n } = e, s = n.beforeFooter.apply(this, [t]), r = n.footer.apply(this, [t]), a = n.afterFooter.apply(this, [t]);
    let o = [];
    return o = ci(o, Oi(s)), o = ci(o, Oi(r)), o = ci(o, Oi(a)), o;
  }
  _createItems(t) {
    const e = this._active, n = this.chart.data, s = [], r = [], a = [];
    let o = [], l, c;
    for (l = 0, c = e.length; l < c; ++l)
      o.push(jk(this.chart, e[l]));
    return t.filter && (o = o.filter((u, d, h) => t.filter(u, d, h, n))), t.itemSort && (o = o.sort((u, d) => t.itemSort(u, d, n))), Ot(o, (u) => {
      const d = Nd(t.callbacks, u);
      s.push(d.labelColor.call(this, u)), r.push(d.labelPointStyle.call(this, u)), a.push(d.labelTextColor.call(this, u));
    }), this.labelColors = s, this.labelPointStyles = r, this.labelTextColors = a, this.dataPoints = o, o;
  }
  update(t, e) {
    const n = this.options.setContext(this.getContext()), s = this._active;
    let r, a = [];
    if (!s.length)
      this.opacity !== 0 && (r = {
        opacity: 0
      });
    else {
      const o = $s[n.position].call(this, s, this._eventPosition);
      a = this._createItems(n), this.title = this.getTitle(a, n), this.beforeBody = this.getBeforeBody(a, n), this.body = this.getBody(a, n), this.afterBody = this.getAfterBody(a, n), this.footer = this.getFooter(a, n);
      const l = this._size = $d(this, n), c = Object.assign({}, o, l), u = Bd(this.chart, n, c), d = Rd(n, c, u, this.chart);
      this.xAlign = u.xAlign, this.yAlign = u.yAlign, r = {
        opacity: 1,
        x: d.x,
        y: d.y,
        width: l.width,
        height: l.height,
        caretX: o.x,
        caretY: o.y
      };
    }
    this._tooltipItems = a, this.$context = void 0, r && this._resolveAnimations().update(this, r), t && n.external && n.external.call(this, { chart: this.chart, tooltip: this, replay: e });
  }
  drawCaret(t, e, n, s) {
    const r = this.getCaretPosition(t, n, s);
    e.lineTo(r.x1, r.y1), e.lineTo(r.x2, r.y2), e.lineTo(r.x3, r.y3);
  }
  getCaretPosition(t, e, n) {
    const { xAlign: s, yAlign: r } = this, { caretSize: a, cornerRadius: o } = n, { topLeft: l, topRight: c, bottomLeft: u, bottomRight: d } = _n(o), { x: h, y: f } = t, { width: p, height: g } = e;
    let m, v, b, _, S, C;
    return r === "center" ? (S = f + g / 2, s === "left" ? (m = h, v = m - a, _ = S + a, C = S - a) : (m = h + p, v = m + a, _ = S - a, C = S + a), b = m) : (s === "left" ? v = h + Math.max(l, u) + a : s === "right" ? v = h + p - Math.max(c, d) - a : v = this.caretX, r === "top" ? (_ = f, S = _ - a, m = v - a, b = v + a) : (_ = f + g, S = _ + a, m = v + a, b = v - a), C = _), { x1: m, x2: v, x3: b, y1: _, y2: S, y3: C };
  }
  drawTitle(t, e, n) {
    const s = this.title, r = s.length;
    let a, o, l;
    if (r) {
      const c = Qn(n.rtl, this.x, this.width);
      for (t.x = Nr(this, n.titleAlign, n), e.textAlign = c.textAlign(n.titleAlign), e.textBaseline = "middle", a = Xt(n.titleFont), o = n.titleSpacing, e.fillStyle = n.titleColor, e.font = a.string, l = 0; l < r; ++l)
        e.fillText(s[l], c.x(t.x), t.y + a.lineHeight / 2), t.y += a.lineHeight + o, l + 1 === r && (t.y += n.titleMarginBottom - o);
    }
  }
  _drawColorBox(t, e, n, s, r) {
    const a = this.labelColors[n], o = this.labelPointStyles[n], { boxHeight: l, boxWidth: c, boxPadding: u } = r, d = Xt(r.bodyFont), h = Nr(this, "left", r), f = s.x(h), p = l < d.lineHeight ? (d.lineHeight - l) / 2 : 0, g = e.y + p;
    if (r.usePointStyle) {
      const m = {
        radius: Math.min(c, l) / 2,
        pointStyle: o.pointStyle,
        rotation: o.rotation,
        borderWidth: 1
      }, v = s.leftForLtr(f, c) + c / 2, b = g + l / 2;
      t.strokeStyle = r.multiKeyBackground, t.fillStyle = r.multiKeyBackground, fl(t, m, v, b), t.strokeStyle = a.borderColor, t.fillStyle = a.backgroundColor, fl(t, m, v, b);
    } else {
      t.lineWidth = St(a.borderWidth) ? Math.max(...Object.values(a.borderWidth)) : a.borderWidth || 1, t.strokeStyle = a.borderColor, t.setLineDash(a.borderDash || []), t.lineDashOffset = a.borderDashOffset || 0;
      const m = s.leftForLtr(f, c - u), v = s.leftForLtr(s.xPlus(f, 1), c - u - 2), b = _n(a.borderRadius);
      Object.values(b).some((_) => _ !== 0) ? (t.beginPath(), t.fillStyle = r.multiKeyBackground, Ks(t, {
        x: m,
        y: g,
        w: c,
        h: l,
        radius: b
      }), t.fill(), t.stroke(), t.fillStyle = a.backgroundColor, t.beginPath(), Ks(t, {
        x: v,
        y: g + 1,
        w: c - 2,
        h: l - 2,
        radius: b
      }), t.fill()) : (t.fillStyle = r.multiKeyBackground, t.fillRect(m, g, c, l), t.strokeRect(m, g, c, l), t.fillStyle = a.backgroundColor, t.fillRect(v, g + 1, c - 2, l - 2));
    }
    t.fillStyle = this.labelTextColors[n];
  }
  drawBody(t, e, n) {
    const { body: s } = this, { bodySpacing: r, bodyAlign: a, displayColors: o, boxHeight: l, boxWidth: c, boxPadding: u } = n, d = Xt(n.bodyFont);
    let h = d.lineHeight, f = 0;
    const p = Qn(n.rtl, this.x, this.width), g = function(P) {
      e.fillText(P, p.x(t.x + f), t.y + h / 2), t.y += h + r;
    }, m = p.textAlign(a);
    let v, b, _, S, C, O, k;
    for (e.textAlign = a, e.textBaseline = "middle", e.font = d.string, t.x = Nr(this, m, n), e.fillStyle = n.bodyColor, Ot(this.beforeBody, g), f = o && m !== "right" ? a === "center" ? c / 2 + u : c + 2 + u : 0, S = 0, O = s.length; S < O; ++S) {
      for (v = s[S], b = this.labelTextColors[S], e.fillStyle = b, Ot(v.before, g), _ = v.lines, o && _.length && (this._drawColorBox(e, t, S, p, n), h = Math.max(d.lineHeight, l)), C = 0, k = _.length; C < k; ++C)
        g(_[C]), h = d.lineHeight;
      Ot(v.after, g);
    }
    f = 0, h = d.lineHeight, Ot(this.afterBody, g), t.y -= r;
  }
  drawFooter(t, e, n) {
    const s = this.footer, r = s.length;
    let a, o;
    if (r) {
      const l = Qn(n.rtl, this.x, this.width);
      for (t.x = Nr(this, n.footerAlign, n), t.y += n.footerMarginTop, e.textAlign = l.textAlign(n.footerAlign), e.textBaseline = "middle", a = Xt(n.footerFont), e.fillStyle = n.footerColor, e.font = a.string, o = 0; o < r; ++o)
        e.fillText(s[o], l.x(t.x), t.y + a.lineHeight / 2), t.y += a.lineHeight + n.footerSpacing;
    }
  }
  drawBackground(t, e, n, s) {
    const { xAlign: r, yAlign: a } = this, { x: o, y: l } = t, { width: c, height: u } = n, { topLeft: d, topRight: h, bottomLeft: f, bottomRight: p } = _n(s.cornerRadius);
    e.fillStyle = s.backgroundColor, e.strokeStyle = s.borderColor, e.lineWidth = s.borderWidth, e.beginPath(), e.moveTo(o + d, l), a === "top" && this.drawCaret(t, e, n, s), e.lineTo(o + c - h, l), e.quadraticCurveTo(o + c, l, o + c, l + h), a === "center" && r === "right" && this.drawCaret(t, e, n, s), e.lineTo(o + c, l + u - p), e.quadraticCurveTo(o + c, l + u, o + c - p, l + u), a === "bottom" && this.drawCaret(t, e, n, s), e.lineTo(o + f, l + u), e.quadraticCurveTo(o, l + u, o, l + u - f), a === "center" && r === "left" && this.drawCaret(t, e, n, s), e.lineTo(o, l + d), e.quadraticCurveTo(o, l, o + d, l), e.closePath(), e.fill(), s.borderWidth > 0 && e.stroke();
  }
  _updateAnimationTarget(t) {
    const e = this.chart, n = this.$animations, s = n && n.x, r = n && n.y;
    if (s || r) {
      const a = $s[t.position].call(this, this._active, this._eventPosition);
      if (!a)
        return;
      const o = this._size = $d(this, t), l = Object.assign({}, a, this._size), c = Bd(e, t, l), u = Rd(t, l, c, e);
      (s._to !== u.x || r._to !== u.y) && (this.xAlign = c.xAlign, this.yAlign = c.yAlign, this.width = o.width, this.height = o.height, this.caretX = a.x, this.caretY = a.y, this._resolveAnimations().update(this, u));
    }
  }
  _willRender() {
    return !!this.opacity;
  }
  draw(t) {
    const e = this.options.setContext(this.getContext());
    let n = this.opacity;
    if (!n)
      return;
    this._updateAnimationTarget(e);
    const s = {
      width: this.width,
      height: this.height
    }, r = {
      x: this.x,
      y: this.y
    };
    n = Math.abs(n) < 1e-3 ? 0 : n;
    const a = ce(e.padding), o = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
    e.enabled && o && (t.save(), t.globalAlpha = n, this.drawBackground(r, t, s, e), ng(t, e.textDirection), r.y += a.top, this.drawTitle(r, t, e), this.drawBody(r, t, e), this.drawFooter(r, t, e), sg(t, e.textDirection), t.restore());
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(t, e) {
    const n = this._active, s = t.map(({ datasetIndex: o, index: l }) => {
      const c = this.chart.getDatasetMeta(o);
      if (!c)
        throw new Error("Cannot find a dataset at index " + o);
      return {
        datasetIndex: o,
        element: c.data[l],
        index: l
      };
    }), r = !ha(n, s), a = this._positionChanged(s, e);
    (r || a) && (this._active = s, this._eventPosition = e, this._ignoreReplayEvents = !0, this.update(!0));
  }
  handleEvent(t, e, n = !0) {
    if (e && this._ignoreReplayEvents)
      return !1;
    this._ignoreReplayEvents = !1;
    const s = this.options, r = this._active || [], a = this._getActiveElements(t, r, e, n), o = this._positionChanged(a, t), l = e || !ha(a, r) || o;
    return l && (this._active = a, (s.enabled || s.external) && (this._eventPosition = {
      x: t.x,
      y: t.y
    }, this.update(!0, e))), l;
  }
  _getActiveElements(t, e, n, s) {
    const r = this.options;
    if (t.type === "mouseout")
      return [];
    if (!s)
      return e;
    const a = this.chart.getElementsAtEventForMode(t, r.mode, r, n);
    return r.reverse && a.reverse(), a;
  }
  _positionChanged(t, e) {
    const { caretX: n, caretY: s, options: r } = this, a = $s[r.position].call(this, t, e);
    return a !== !1 && (n !== a.x || s !== a.y);
  }
}
bl.positioners = $s;
var Xk = {
  id: "tooltip",
  _element: bl,
  positioners: $s,
  afterInit(i, t, e) {
    e && (i.tooltip = new bl({ chart: i, options: e }));
  },
  beforeUpdate(i, t, e) {
    i.tooltip && i.tooltip.initialize(e);
  },
  reset(i, t, e) {
    i.tooltip && i.tooltip.initialize(e);
  },
  afterDraw(i) {
    const t = i.tooltip;
    if (t && t._willRender()) {
      const e = {
        tooltip: t
      };
      if (i.notifyPlugins("beforeTooltipDraw", e) === !1)
        return;
      t.draw(i.ctx), i.notifyPlugins("afterTooltipDraw", e);
    }
  },
  afterEvent(i, t) {
    if (i.tooltip) {
      const e = t.replay;
      i.tooltip.handleEvent(t.event, e, t.inChartArea) && (t.changed = !0);
    }
  },
  defaults: {
    enabled: !0,
    external: null,
    position: "average",
    backgroundColor: "rgba(0,0,0,0.8)",
    titleColor: "#fff",
    titleFont: {
      weight: "bold"
    },
    titleSpacing: 2,
    titleMarginBottom: 6,
    titleAlign: "left",
    bodyColor: "#fff",
    bodySpacing: 2,
    bodyFont: {},
    bodyAlign: "left",
    footerColor: "#fff",
    footerSpacing: 2,
    footerMarginTop: 6,
    footerFont: {
      weight: "bold"
    },
    footerAlign: "left",
    padding: 6,
    caretPadding: 2,
    caretSize: 5,
    cornerRadius: 6,
    boxHeight: (i, t) => t.bodyFont.size,
    boxWidth: (i, t) => t.bodyFont.size,
    multiKeyBackground: "#fff",
    displayColors: !0,
    boxPadding: 0,
    borderColor: "rgba(0,0,0,0)",
    borderWidth: 0,
    animation: {
      duration: 400,
      easing: "easeOutQuart"
    },
    animations: {
      numbers: {
        type: "number",
        properties: ["x", "y", "width", "height", "caretX", "caretY"]
      },
      opacity: {
        easing: "linear",
        duration: 200
      }
    },
    callbacks: {
      beforeTitle: Si,
      title(i) {
        if (i.length > 0) {
          const t = i[0], e = t.chart.data.labels, n = e ? e.length : 0;
          if (this && this.options && this.options.mode === "dataset")
            return t.dataset.label || "";
          if (t.label)
            return t.label;
          if (n > 0 && t.dataIndex < n)
            return e[t.dataIndex];
        }
        return "";
      },
      afterTitle: Si,
      beforeBody: Si,
      beforeLabel: Si,
      label(i) {
        if (this && this.options && this.options.mode === "dataset")
          return i.label + ": " + i.formattedValue || i.formattedValue;
        let t = i.dataset.label || "";
        t && (t += ": ");
        const e = i.formattedValue;
        return kt(e) || (t += e), t;
      },
      labelColor(i) {
        const e = i.chart.getDatasetMeta(i.datasetIndex).controller.getStyle(i.dataIndex);
        return {
          borderColor: e.borderColor,
          backgroundColor: e.backgroundColor,
          borderWidth: e.borderWidth,
          borderDash: e.borderDash,
          borderDashOffset: e.borderDashOffset,
          borderRadius: 0
        };
      },
      labelTextColor() {
        return this.options.bodyColor;
      },
      labelPointStyle(i) {
        const e = i.chart.getDatasetMeta(i.datasetIndex).controller.getStyle(i.dataIndex);
        return {
          pointStyle: e.pointStyle,
          rotation: e.rotation
        };
      },
      afterLabel: Si,
      afterBody: Si,
      beforeFooter: Si,
      footer: Si,
      afterFooter: Si
    }
  },
  defaultRoutes: {
    bodyFont: "font",
    footerFont: "font",
    titleFont: "font"
  },
  descriptors: {
    _scriptable: (i) => i !== "filter" && i !== "itemSort" && i !== "external",
    _indexable: !1,
    callbacks: {
      _scriptable: !1,
      _indexable: !1
    },
    animation: {
      _fallback: !1
    },
    animations: {
      _fallback: "animation"
    }
  },
  additionalOptionScopes: ["interaction"]
};
const Qk = (i, t, e, n) => (typeof t == "string" ? (e = i.push(t) - 1, n.unshift({ index: e, label: t })) : isNaN(t) && (e = null), e);
function Jk(i, t, e, n) {
  const s = i.indexOf(t);
  if (s === -1)
    return Qk(i, t, e, n);
  const r = i.lastIndexOf(t);
  return s !== r ? e : s;
}
const qk = (i, t) => i === null ? null : ae(Math.round(i), 0, t);
class ya extends Ln {
  constructor(t) {
    super(t), this._startValue = void 0, this._valueRange = 0, this._addedLabels = [];
  }
  init(t) {
    const e = this._addedLabels;
    if (e.length) {
      const n = this.getLabels();
      for (const { index: s, label: r } of e)
        n[s] === r && n.splice(s, 1);
      this._addedLabels = [];
    }
    super.init(t);
  }
  parse(t, e) {
    if (kt(t))
      return null;
    const n = this.getLabels();
    return e = isFinite(e) && n[e] === t ? e : Jk(n, t, yt(e, t), this._addedLabels), qk(e, n.length - 1);
  }
  determineDataLimits() {
    const { minDefined: t, maxDefined: e } = this.getUserBounds();
    let { min: n, max: s } = this.getMinMax(!0);
    this.options.bounds === "ticks" && (t || (n = 0), e || (s = this.getLabels().length - 1)), this.min = n, this.max = s;
  }
  buildTicks() {
    const t = this.min, e = this.max, n = this.options.offset, s = [];
    let r = this.getLabels();
    r = t === 0 && e === r.length - 1 ? r : r.slice(t, e + 1), this._valueRange = Math.max(r.length - (n ? 0 : 1), 1), this._startValue = this.min - (n ? 0.5 : 0);
    for (let a = t; a <= e; a++)
      s.push({ value: a });
    return s;
  }
  getLabelForValue(t) {
    const e = this.getLabels();
    return t >= 0 && t < e.length ? e[t] : t;
  }
  configure() {
    super.configure(), this.isHorizontal() || (this._reversePixels = !this._reversePixels);
  }
  getPixelForValue(t) {
    return typeof t != "number" && (t = this.parse(t)), t === null ? NaN : this.getPixelForDecimal((t - this._startValue) / this._valueRange);
  }
  getPixelForTick(t) {
    const e = this.ticks;
    return t < 0 || t > e.length - 1 ? null : this.getPixelForValue(e[t].value);
  }
  getValueForPixel(t) {
    return Math.round(this._startValue + this.getDecimalForPixel(t) * this._valueRange);
  }
  getBasePixel() {
    return this.bottom;
  }
}
ya.id = "category";
ya.defaults = {
  ticks: {
    callback: ya.prototype.getLabelForValue
  }
};
function tO(i, t) {
  const e = [], { bounds: s, step: r, min: a, max: o, precision: l, count: c, maxTicks: u, maxDigits: d, includeBounds: h } = i, f = r || 1, p = u - 1, { min: g, max: m } = t, v = !kt(a), b = !kt(o), _ = !kt(c), S = (m - g) / (d + 1);
  let C = zu((m - g) / p / f) * f, O, k, P, x;
  if (C < 1e-14 && !v && !b)
    return [{ value: g }, { value: m }];
  x = Math.ceil(m / C) - Math.floor(g / C), x > p && (C = zu(x * C / p / f) * f), kt(l) || (O = Math.pow(10, l), C = Math.ceil(C * O) / O), s === "ticks" ? (k = Math.floor(g / C) * C, P = Math.ceil(m / C) * C) : (k = g, P = m), v && b && r && hC((o - a) / r, C / 1e3) ? (x = Math.round(Math.min((o - a) / C, u)), C = (o - a) / x, k = a, P = o) : _ ? (k = v ? a : k, P = b ? o : P, x = c - 1, C = (P - k) / x) : (x = (P - k) / C, Ls(x, Math.round(x), C / 1e3) ? x = Math.round(x) : x = Math.ceil(x));
  const R = Math.max(
    ju(C),
    ju(k)
  );
  O = Math.pow(10, kt(l) ? R : l), k = Math.round(k * O) / O, P = Math.round(P * O) / O;
  let B = 0;
  for (v && (h && k !== a ? (e.push({ value: a }), k < a && B++, Ls(Math.round((k + B * C) * O) / O, a, Hd(a, S, i)) && B++) : k < a && B++); B < x; ++B)
    e.push({ value: Math.round((k + B * C) * O) / O });
  return b && h && P !== o ? e.length && Ls(e[e.length - 1].value, o, Hd(o, S, i)) ? e[e.length - 1].value = o : e.push({ value: o }) : (!b || P === o) && e.push({ value: P }), e;
}
function Hd(i, t, { horizontal: e, minRotation: n }) {
  const s = qe(n), r = (e ? Math.sin(s) : Math.cos(s)) || 1e-3, a = 0.75 * t * ("" + i).length;
  return Math.min(t / r, a);
}
class _a extends Ln {
  constructor(t) {
    super(t), this.start = void 0, this.end = void 0, this._startValue = void 0, this._endValue = void 0, this._valueRange = 0;
  }
  parse(t, e) {
    return kt(t) || (typeof t == "number" || t instanceof Number) && !isFinite(+t) ? null : +t;
  }
  handleTickRangeOptions() {
    const { beginAtZero: t } = this.options, { minDefined: e, maxDefined: n } = this.getUserBounds();
    let { min: s, max: r } = this;
    const a = (l) => s = e ? s : l, o = (l) => r = n ? r : l;
    if (t) {
      const l = vi(s), c = vi(r);
      l < 0 && c < 0 ? o(0) : l > 0 && c > 0 && a(0);
    }
    if (s === r) {
      let l = 1;
      (r >= Number.MAX_SAFE_INTEGER || s <= Number.MIN_SAFE_INTEGER) && (l = Math.abs(r * 0.05)), o(r + l), t || a(s - l);
    }
    this.min = s, this.max = r;
  }
  getTickLimit() {
    const t = this.options.ticks;
    let { maxTicksLimit: e, stepSize: n } = t, s;
    return n ? (s = Math.ceil(this.max / n) - Math.floor(this.min / n) + 1, s > 1e3 && (console.warn(`scales.${this.id}.ticks.stepSize: ${n} would result generating up to ${s} ticks. Limiting to 1000.`), s = 1e3)) : (s = this.computeTickLimit(), e = e || 11), e && (s = Math.min(e, s)), s;
  }
  computeTickLimit() {
    return Number.POSITIVE_INFINITY;
  }
  buildTicks() {
    const t = this.options, e = t.ticks;
    let n = this.getTickLimit();
    n = Math.max(2, n);
    const s = {
      maxTicks: n,
      bounds: t.bounds,
      min: t.min,
      max: t.max,
      precision: e.precision,
      step: e.stepSize,
      count: e.count,
      maxDigits: this._maxDigits(),
      horizontal: this.isHorizontal(),
      minRotation: e.minRotation || 0,
      includeBounds: e.includeBounds !== !1
    }, r = this._range || this, a = tO(s, r);
    return t.bounds === "ticks" && $p(a, this, "value"), t.reverse ? (a.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), a;
  }
  configure() {
    const t = this.ticks;
    let e = this.min, n = this.max;
    if (super.configure(), this.options.offset && t.length) {
      const s = (n - e) / Math.max(t.length - 1, 1) / 2;
      e -= s, n += s;
    }
    this._startValue = e, this._endValue = n, this._valueRange = n - e;
  }
  getLabelForValue(t) {
    return ur(t, this.chart.options.locale, this.options.ticks.format);
  }
}
class Cc extends _a {
  determineDataLimits() {
    const { min: t, max: e } = this.getMinMax(!0);
    this.min = ee(t) ? t : 0, this.max = ee(e) ? e : 1, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    const t = this.isHorizontal(), e = t ? this.width : this.height, n = qe(this.options.ticks.minRotation), s = (t ? Math.sin(n) : Math.cos(n)) || 1e-3, r = this._resolveTickFontOptions(0);
    return Math.ceil(e / Math.min(40, r.lineHeight / s));
  }
  getPixelForValue(t) {
    return t === null ? NaN : this.getPixelForDecimal((t - this._startValue) / this._valueRange);
  }
  getValueForPixel(t) {
    return this._startValue + this.getDecimalForPixel(t) * this._valueRange;
  }
}
Cc.id = "linear";
Cc.defaults = {
  ticks: {
    callback: Ra.formatters.numeric
  }
};
function Vd(i) {
  return i / Math.pow(10, Math.floor(ze(i))) === 1;
}
function eO(i, t) {
  const e = Math.floor(ze(t.max)), n = Math.ceil(t.max / Math.pow(10, e)), s = [];
  let r = Ve(i.min, Math.pow(10, Math.floor(ze(t.min)))), a = Math.floor(ze(r)), o = Math.floor(r / Math.pow(10, a)), l = a < 0 ? Math.pow(10, Math.abs(a)) : 1;
  do
    s.push({ value: r, major: Vd(r) }), ++o, o === 10 && (o = 1, ++a, l = a >= 0 ? 1 : l), r = Math.round(o * Math.pow(10, a) * l) / l;
  while (a < e || a === e && o < n);
  const c = Ve(i.max, r);
  return s.push({ value: c, major: Vd(r) }), s;
}
class kg extends Ln {
  constructor(t) {
    super(t), this.start = void 0, this.end = void 0, this._startValue = void 0, this._valueRange = 0;
  }
  parse(t, e) {
    const n = _a.prototype.parse.apply(this, [t, e]);
    if (n === 0) {
      this._zero = !0;
      return;
    }
    return ee(n) && n > 0 ? n : null;
  }
  determineDataLimits() {
    const { min: t, max: e } = this.getMinMax(!0);
    this.min = ee(t) ? Math.max(0, t) : null, this.max = ee(e) ? Math.max(0, e) : null, this.options.beginAtZero && (this._zero = !0), this.handleTickRangeOptions();
  }
  handleTickRangeOptions() {
    const { minDefined: t, maxDefined: e } = this.getUserBounds();
    let n = this.min, s = this.max;
    const r = (l) => n = t ? n : l, a = (l) => s = e ? s : l, o = (l, c) => Math.pow(10, Math.floor(ze(l)) + c);
    n === s && (n <= 0 ? (r(1), a(10)) : (r(o(n, -1)), a(o(s, 1)))), n <= 0 && r(o(s, -1)), s <= 0 && a(o(n, 1)), this._zero && this.min !== this._suggestedMin && n === o(this.min, 0) && r(o(n, -1)), this.min = n, this.max = s;
  }
  buildTicks() {
    const t = this.options, e = {
      min: this._userMin,
      max: this._userMax
    }, n = eO(e, this);
    return t.bounds === "ticks" && $p(n, this, "value"), t.reverse ? (n.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), n;
  }
  getLabelForValue(t) {
    return t === void 0 ? "0" : ur(t, this.chart.options.locale, this.options.ticks.format);
  }
  configure() {
    const t = this.min;
    super.configure(), this._startValue = ze(t), this._valueRange = ze(this.max) - ze(t);
  }
  getPixelForValue(t) {
    return (t === void 0 || t === 0) && (t = this.min), t === null || isNaN(t) ? NaN : this.getPixelForDecimal(t === this.min ? 0 : (ze(t) - this._startValue) / this._valueRange);
  }
  getValueForPixel(t) {
    const e = this.getDecimalForPixel(t);
    return Math.pow(10, this._startValue + e * this._valueRange);
  }
}
kg.id = "logarithmic";
kg.defaults = {
  ticks: {
    callback: Ra.formatters.logarithmic,
    major: {
      enabled: !0
    }
  }
};
function yl(i) {
  const t = i.ticks;
  if (t.display && i.display) {
    const e = ce(t.backdropPadding);
    return yt(t.font && t.font.size, Ct.font.size) + e.height;
  }
  return 0;
}
function iO(i, t, e) {
  return e = $t(e) ? e : [e], {
    w: WC(i, t.string, e),
    h: e.length * t.lineHeight
  };
}
function zd(i, t, e, n, s) {
  return i === n || i === s ? {
    start: t - e / 2,
    end: t + e / 2
  } : i < n || i > s ? {
    start: t - e,
    end: t
  } : {
    start: t,
    end: t + e
  };
}
function nO(i) {
  const t = {
    l: i.left + i._padding.left,
    r: i.right - i._padding.right,
    t: i.top + i._padding.top,
    b: i.bottom - i._padding.bottom
  }, e = Object.assign({}, t), n = [], s = [], r = i._pointLabels.length, a = i.options.pointLabels, o = a.centerPointLabels ? Bt / r : 0;
  for (let l = 0; l < r; l++) {
    const c = a.setContext(i.getPointLabelContext(l));
    s[l] = c.padding;
    const u = i.getPointPosition(l, i.drawingArea + s[l], o), d = Xt(c.font), h = iO(i.ctx, d, i._pointLabels[l]);
    n[l] = h;
    const f = Qe(i.getIndexAngle(l) + o), p = Math.round(lc(f)), g = zd(p, u.x, h.w, 0, 180), m = zd(p, u.y, h.h, 90, 270);
    sO(e, t, f, g, m);
  }
  i.setCenterPoint(
    t.l - e.l,
    e.r - t.r,
    t.t - e.t,
    e.b - t.b
  ), i._pointLabelItems = rO(i, n, s);
}
function sO(i, t, e, n, s) {
  const r = Math.abs(Math.sin(e)), a = Math.abs(Math.cos(e));
  let o = 0, l = 0;
  n.start < t.l ? (o = (t.l - n.start) / r, i.l = Math.min(i.l, t.l - o)) : n.end > t.r && (o = (n.end - t.r) / r, i.r = Math.max(i.r, t.r + o)), s.start < t.t ? (l = (t.t - s.start) / a, i.t = Math.min(i.t, t.t - l)) : s.end > t.b && (l = (s.end - t.b) / a, i.b = Math.max(i.b, t.b + l));
}
function rO(i, t, e) {
  const n = [], s = i._pointLabels.length, r = i.options, a = yl(r) / 2, o = i.drawingArea, l = r.pointLabels.centerPointLabels ? Bt / s : 0;
  for (let c = 0; c < s; c++) {
    const u = i.getPointPosition(c, o + a + e[c], l), d = Math.round(lc(Qe(u.angle + Wt))), h = t[c], f = lO(u.y, h.h, d), p = aO(d), g = oO(u.x, h.w, p);
    n.push({
      x: u.x,
      y: f,
      textAlign: p,
      left: g,
      top: f,
      right: g + h.w,
      bottom: f + h.h
    });
  }
  return n;
}
function aO(i) {
  return i === 0 || i === 180 ? "center" : i < 180 ? "left" : "right";
}
function oO(i, t, e) {
  return e === "right" ? i -= t : e === "center" && (i -= t / 2), i;
}
function lO(i, t, e) {
  return e === 90 || e === 270 ? i -= t / 2 : (e > 270 || e < 90) && (i -= t), i;
}
function cO(i, t) {
  const { ctx: e, options: { pointLabels: n } } = i;
  for (let s = t - 1; s >= 0; s--) {
    const r = n.setContext(i.getPointLabelContext(s)), a = Xt(r.font), { x: o, y: l, textAlign: c, left: u, top: d, right: h, bottom: f } = i._pointLabelItems[s], { backdropColor: p } = r;
    if (!kt(p)) {
      const g = _n(r.borderRadius), m = ce(r.backdropPadding);
      e.fillStyle = p;
      const v = u - m.left, b = d - m.top, _ = h - u + m.width, S = f - d + m.height;
      Object.values(g).some((C) => C !== 0) ? (e.beginPath(), Ks(e, {
        x: v,
        y: b,
        w: _,
        h: S,
        radius: g
      }), e.fill()) : e.fillRect(v, b, _, S);
    }
    kn(
      e,
      i._pointLabels[s],
      o,
      l + a.lineHeight / 2,
      a,
      {
        color: r.color,
        textAlign: c,
        textBaseline: "middle"
      }
    );
  }
}
function Og(i, t, e, n) {
  const { ctx: s } = i;
  if (e)
    s.arc(i.xCenter, i.yCenter, t, 0, Tt);
  else {
    let r = i.getPointPosition(0, t);
    s.moveTo(r.x, r.y);
    for (let a = 1; a < n; a++)
      r = i.getPointPosition(a, t), s.lineTo(r.x, r.y);
  }
}
function uO(i, t, e, n) {
  const s = i.ctx, r = t.circular, { color: a, lineWidth: o } = t;
  !r && !n || !a || !o || e < 0 || (s.save(), s.strokeStyle = a, s.lineWidth = o, s.setLineDash(t.borderDash), s.lineDashOffset = t.borderDashOffset, s.beginPath(), Og(i, e, r, n), s.closePath(), s.stroke(), s.restore());
}
function dO(i, t, e) {
  return sn(i, {
    label: e,
    index: t,
    type: "pointLabel"
  });
}
class za extends _a {
  constructor(t) {
    super(t), this.xCenter = void 0, this.yCenter = void 0, this.drawingArea = void 0, this._pointLabels = [], this._pointLabelItems = [];
  }
  setDimensions() {
    const t = this._padding = ce(yl(this.options) / 2), e = this.width = this.maxWidth - t.width, n = this.height = this.maxHeight - t.height;
    this.xCenter = Math.floor(this.left + e / 2 + t.left), this.yCenter = Math.floor(this.top + n / 2 + t.top), this.drawingArea = Math.floor(Math.min(e, n) / 2);
  }
  determineDataLimits() {
    const { min: t, max: e } = this.getMinMax(!1);
    this.min = ee(t) && !isNaN(t) ? t : 0, this.max = ee(e) && !isNaN(e) ? e : 0, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    return Math.ceil(this.drawingArea / yl(this.options));
  }
  generateTickLabels(t) {
    _a.prototype.generateTickLabels.call(this, t), this._pointLabels = this.getLabels().map((e, n) => {
      const s = Dt(this.options.pointLabels.callback, [e, n], this);
      return s || s === 0 ? s : "";
    }).filter((e, n) => this.chart.getDataVisibility(n));
  }
  fit() {
    const t = this.options;
    t.display && t.pointLabels.display ? nO(this) : this.setCenterPoint(0, 0, 0, 0);
  }
  setCenterPoint(t, e, n, s) {
    this.xCenter += Math.floor((t - e) / 2), this.yCenter += Math.floor((n - s) / 2), this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(t, e, n, s));
  }
  getIndexAngle(t) {
    const e = Tt / (this._pointLabels.length || 1), n = this.options.startAngle || 0;
    return Qe(t * e + qe(n));
  }
  getDistanceFromCenterForValue(t) {
    if (kt(t))
      return NaN;
    const e = this.drawingArea / (this.max - this.min);
    return this.options.reverse ? (this.max - t) * e : (t - this.min) * e;
  }
  getValueForDistanceFromCenter(t) {
    if (kt(t))
      return NaN;
    const e = t / (this.drawingArea / (this.max - this.min));
    return this.options.reverse ? this.max - e : this.min + e;
  }
  getPointLabelContext(t) {
    const e = this._pointLabels || [];
    if (t >= 0 && t < e.length) {
      const n = e[t];
      return dO(this.getContext(), t, n);
    }
  }
  getPointPosition(t, e, n = 0) {
    const s = this.getIndexAngle(t) - Wt + n;
    return {
      x: Math.cos(s) * e + this.xCenter,
      y: Math.sin(s) * e + this.yCenter,
      angle: s
    };
  }
  getPointPositionForValue(t, e) {
    return this.getPointPosition(t, this.getDistanceFromCenterForValue(e));
  }
  getBasePosition(t) {
    return this.getPointPositionForValue(t || 0, this.getBaseValue());
  }
  getPointLabelPosition(t) {
    const { left: e, top: n, right: s, bottom: r } = this._pointLabelItems[t];
    return {
      left: e,
      top: n,
      right: s,
      bottom: r
    };
  }
  drawBackground() {
    const { backgroundColor: t, grid: { circular: e } } = this.options;
    if (t) {
      const n = this.ctx;
      n.save(), n.beginPath(), Og(this, this.getDistanceFromCenterForValue(this._endValue), e, this._pointLabels.length), n.closePath(), n.fillStyle = t, n.fill(), n.restore();
    }
  }
  drawGrid() {
    const t = this.ctx, e = this.options, { angleLines: n, grid: s } = e, r = this._pointLabels.length;
    let a, o, l;
    if (e.pointLabels.display && cO(this, r), s.display && this.ticks.forEach((c, u) => {
      if (u !== 0) {
        o = this.getDistanceFromCenterForValue(c.value);
        const d = s.setContext(this.getContext(u - 1));
        uO(this, d, o, r);
      }
    }), n.display) {
      for (t.save(), a = r - 1; a >= 0; a--) {
        const c = n.setContext(this.getPointLabelContext(a)), { color: u, lineWidth: d } = c;
        !d || !u || (t.lineWidth = d, t.strokeStyle = u, t.setLineDash(c.borderDash), t.lineDashOffset = c.borderDashOffset, o = this.getDistanceFromCenterForValue(e.ticks.reverse ? this.min : this.max), l = this.getPointPosition(a, o), t.beginPath(), t.moveTo(this.xCenter, this.yCenter), t.lineTo(l.x, l.y), t.stroke());
      }
      t.restore();
    }
  }
  drawBorder() {
  }
  drawLabels() {
    const t = this.ctx, e = this.options, n = e.ticks;
    if (!n.display)
      return;
    const s = this.getIndexAngle(0);
    let r, a;
    t.save(), t.translate(this.xCenter, this.yCenter), t.rotate(s), t.textAlign = "center", t.textBaseline = "middle", this.ticks.forEach((o, l) => {
      if (l === 0 && !e.reverse)
        return;
      const c = n.setContext(this.getContext(l)), u = Xt(c.font);
      if (r = this.getDistanceFromCenterForValue(this.ticks[l].value), c.showLabelBackdrop) {
        t.font = u.string, a = t.measureText(o.label).width, t.fillStyle = c.backdropColor;
        const d = ce(c.backdropPadding);
        t.fillRect(
          -a / 2 - d.left,
          -r - u.size / 2 - d.top,
          a + d.width,
          u.size + d.height
        );
      }
      kn(t, o.label, 0, -r, u, {
        color: c.color
      });
    }), t.restore();
  }
  drawTitle() {
  }
}
za.id = "radialLinear";
za.defaults = {
  display: !0,
  animate: !0,
  position: "chartArea",
  angleLines: {
    display: !0,
    lineWidth: 1,
    borderDash: [],
    borderDashOffset: 0
  },
  grid: {
    circular: !1
  },
  startAngle: 0,
  ticks: {
    showLabelBackdrop: !0,
    callback: Ra.formatters.numeric
  },
  pointLabels: {
    backdropColor: void 0,
    backdropPadding: 2,
    display: !0,
    font: {
      size: 10
    },
    callback(i) {
      return i;
    },
    padding: 5,
    centerPointLabels: !1
  }
};
za.defaultRoutes = {
  "angleLines.color": "borderColor",
  "pointLabels.color": "color",
  "ticks.color": "color"
};
za.descriptors = {
  angleLines: {
    _fallback: "grid"
  }
};
const ja = {
  millisecond: { common: !0, size: 1, steps: 1e3 },
  second: { common: !0, size: 1e3, steps: 60 },
  minute: { common: !0, size: 6e4, steps: 60 },
  hour: { common: !0, size: 36e5, steps: 24 },
  day: { common: !0, size: 864e5, steps: 30 },
  week: { common: !1, size: 6048e5, steps: 4 },
  month: { common: !0, size: 2628e6, steps: 12 },
  quarter: { common: !1, size: 7884e6, steps: 4 },
  year: { common: !0, size: 3154e7 }
}, Ae = Object.keys(ja);
function hO(i, t) {
  return i - t;
}
function jd(i, t) {
  if (kt(t))
    return null;
  const e = i._adapter, { parser: n, round: s, isoWeekday: r } = i._parseOpts;
  let a = t;
  return typeof n == "function" && (a = n(a)), ee(a) || (a = typeof n == "string" ? e.parse(a, n) : e.parse(a)), a === null ? null : (s && (a = s === "week" && (ns(r) || r === !0) ? e.startOf(a, "isoWeek", r) : e.startOf(a, s)), +a);
}
function Wd(i, t, e, n) {
  const s = Ae.length;
  for (let r = Ae.indexOf(i); r < s - 1; ++r) {
    const a = ja[Ae[r]], o = a.steps ? a.steps : Number.MAX_SAFE_INTEGER;
    if (a.common && Math.ceil((e - t) / (o * a.size)) <= n)
      return Ae[r];
  }
  return Ae[s - 1];
}
function fO(i, t, e, n, s) {
  for (let r = Ae.length - 1; r >= Ae.indexOf(e); r--) {
    const a = Ae[r];
    if (ja[a].common && i._adapter.diff(s, n, a) >= t - 1)
      return a;
  }
  return Ae[e ? Ae.indexOf(e) : 0];
}
function pO(i) {
  for (let t = Ae.indexOf(i) + 1, e = Ae.length; t < e; ++t)
    if (ja[Ae[t]].common)
      return Ae[t];
}
function Yd(i, t, e) {
  if (!e)
    i[t] = !0;
  else if (e.length) {
    const { lo: n, hi: s } = cc(e, t), r = e[n] >= t ? e[n] : e[s];
    i[r] = !0;
  }
}
function gO(i, t, e, n) {
  const s = i._adapter, r = +s.startOf(t[0].value, n), a = t[t.length - 1].value;
  let o, l;
  for (o = r; o <= a; o = +s.add(o, 1, n))
    l = e[o], l >= 0 && (t[l].major = !0);
  return t;
}
function Ud(i, t, e) {
  const n = [], s = {}, r = t.length;
  let a, o;
  for (a = 0; a < r; ++a)
    o = t[a], s[o] = a, n.push({
      value: o,
      major: !1
    });
  return r === 0 || !e ? n : gO(i, n, s, e);
}
class Wa extends Ln {
  constructor(t) {
    super(t), this._cache = {
      data: [],
      labels: [],
      all: []
    }, this._unit = "day", this._majorUnit = void 0, this._offsets = {}, this._normalized = !1, this._parseOpts = void 0;
  }
  init(t, e) {
    const n = t.time || (t.time = {}), s = this._adapter = new Mw._date(t.adapters.date);
    s.init(e), Ps(n.displayFormats, s.formats()), this._parseOpts = {
      parser: n.parser,
      round: n.round,
      isoWeekday: n.isoWeekday
    }, super.init(t), this._normalized = e.normalized;
  }
  parse(t, e) {
    return t === void 0 ? null : jd(this, t);
  }
  beforeLayout() {
    super.beforeLayout(), this._cache = {
      data: [],
      labels: [],
      all: []
    };
  }
  determineDataLimits() {
    const t = this.options, e = this._adapter, n = t.time.unit || "day";
    let { min: s, max: r, minDefined: a, maxDefined: o } = this.getUserBounds();
    function l(c) {
      !a && !isNaN(c.min) && (s = Math.min(s, c.min)), !o && !isNaN(c.max) && (r = Math.max(r, c.max));
    }
    (!a || !o) && (l(this._getLabelBounds()), (t.bounds !== "ticks" || t.ticks.source !== "labels") && l(this.getMinMax(!1))), s = ee(s) && !isNaN(s) ? s : +e.startOf(Date.now(), n), r = ee(r) && !isNaN(r) ? r : +e.endOf(Date.now(), n) + 1, this.min = Math.min(s, r - 1), this.max = Math.max(s + 1, r);
  }
  _getLabelBounds() {
    const t = this.getLabelTimestamps();
    let e = Number.POSITIVE_INFINITY, n = Number.NEGATIVE_INFINITY;
    return t.length && (e = t[0], n = t[t.length - 1]), { min: e, max: n };
  }
  buildTicks() {
    const t = this.options, e = t.time, n = t.ticks, s = n.source === "labels" ? this.getLabelTimestamps() : this._generate();
    t.bounds === "ticks" && s.length && (this.min = this._userMin || s[0], this.max = this._userMax || s[s.length - 1]);
    const r = this.min, a = this.max, o = mC(s, r, a);
    return this._unit = e.unit || (n.autoSkip ? Wd(e.minUnit, this.min, this.max, this._getLabelCapacity(r)) : fO(this, o.length, e.minUnit, this.min, this.max)), this._majorUnit = !n.major.enabled || this._unit === "year" ? void 0 : pO(this._unit), this.initOffsets(s), t.reverse && o.reverse(), Ud(this, o, this._majorUnit);
  }
  afterAutoSkip() {
    this.options.offsetAfterAutoskip && this.initOffsets(this.ticks.map((t) => +t.value));
  }
  initOffsets(t) {
    let e = 0, n = 0, s, r;
    this.options.offset && t.length && (s = this.getDecimalForValue(t[0]), t.length === 1 ? e = 1 - s : e = (this.getDecimalForValue(t[1]) - s) / 2, r = this.getDecimalForValue(t[t.length - 1]), t.length === 1 ? n = r : n = (r - this.getDecimalForValue(t[t.length - 2])) / 2);
    const a = t.length < 3 ? 0.5 : 0.25;
    e = ae(e, 0, a), n = ae(n, 0, a), this._offsets = { start: e, end: n, factor: 1 / (e + 1 + n) };
  }
  _generate() {
    const t = this._adapter, e = this.min, n = this.max, s = this.options, r = s.time, a = r.unit || Wd(r.minUnit, e, n, this._getLabelCapacity(e)), o = yt(r.stepSize, 1), l = a === "week" ? r.isoWeekday : !1, c = ns(l) || l === !0, u = {};
    let d = e, h, f;
    if (c && (d = +t.startOf(d, "isoWeek", l)), d = +t.startOf(d, c ? "day" : a), t.diff(n, e, a) > 1e5 * o)
      throw new Error(e + " and " + n + " are too far apart with stepSize of " + o + " " + a);
    const p = s.ticks.source === "data" && this.getDataTimestamps();
    for (h = d, f = 0; h < n; h = +t.add(h, o, a), f++)
      Yd(u, h, p);
    return (h === n || s.bounds === "ticks" || f === 1) && Yd(u, h, p), Object.keys(u).sort((g, m) => g - m).map((g) => +g);
  }
  getLabelForValue(t) {
    const e = this._adapter, n = this.options.time;
    return n.tooltipFormat ? e.format(t, n.tooltipFormat) : e.format(t, n.displayFormats.datetime);
  }
  _tickFormatFunction(t, e, n, s) {
    const r = this.options, a = r.time.displayFormats, o = this._unit, l = this._majorUnit, c = o && a[o], u = l && a[l], d = n[e], h = l && u && d && d.major, f = this._adapter.format(t, s || (h ? u : c)), p = r.ticks.callback;
    return p ? Dt(p, [f, e, n], this) : f;
  }
  generateTickLabels(t) {
    let e, n, s;
    for (e = 0, n = t.length; e < n; ++e)
      s = t[e], s.label = this._tickFormatFunction(s.value, e, t);
  }
  getDecimalForValue(t) {
    return t === null ? NaN : (t - this.min) / (this.max - this.min);
  }
  getPixelForValue(t) {
    const e = this._offsets, n = this.getDecimalForValue(t);
    return this.getPixelForDecimal((e.start + n) * e.factor);
  }
  getValueForPixel(t) {
    const e = this._offsets, n = this.getDecimalForPixel(t) / e.factor - e.end;
    return this.min + n * (this.max - this.min);
  }
  _getLabelSize(t) {
    const e = this.options.ticks, n = this.ctx.measureText(t).width, s = qe(this.isHorizontal() ? e.maxRotation : e.minRotation), r = Math.cos(s), a = Math.sin(s), o = this._resolveTickFontOptions(0).size;
    return {
      w: n * r + o * a,
      h: n * a + o * r
    };
  }
  _getLabelCapacity(t) {
    const e = this.options.time, n = e.displayFormats, s = n[e.unit] || n.millisecond, r = this._tickFormatFunction(t, 0, Ud(this, [t], this._majorUnit), s), a = this._getLabelSize(r), o = Math.floor(this.isHorizontal() ? this.width / a.w : this.height / a.h) - 1;
    return o > 0 ? o : 1;
  }
  getDataTimestamps() {
    let t = this._cache.data || [], e, n;
    if (t.length)
      return t;
    const s = this.getMatchingVisibleMetas();
    if (this._normalized && s.length)
      return this._cache.data = s[0].controller.getAllParsedValues(this);
    for (e = 0, n = s.length; e < n; ++e)
      t = t.concat(s[e].controller.getAllParsedValues(this));
    return this._cache.data = this.normalize(t);
  }
  getLabelTimestamps() {
    const t = this._cache.labels || [];
    let e, n;
    if (t.length)
      return t;
    const s = this.getLabels();
    for (e = 0, n = s.length; e < n; ++e)
      t.push(jd(this, s[e]));
    return this._cache.labels = this._normalized ? t : this.normalize(t);
  }
  normalize(t) {
    return Fp(t.sort(hO));
  }
}
Wa.id = "time";
Wa.defaults = {
  bounds: "data",
  adapters: {},
  time: {
    parser: !1,
    unit: !1,
    round: !1,
    isoWeekday: !1,
    minUnit: "millisecond",
    displayFormats: {}
  },
  ticks: {
    source: "auto",
    major: {
      enabled: !1
    }
  }
};
function Hr(i, t, e) {
  let n = 0, s = i.length - 1, r, a, o, l;
  e ? (t >= i[n].pos && t <= i[s].pos && ({ lo: n, hi: s } = mn(i, "pos", t)), { pos: r, time: o } = i[n], { pos: a, time: l } = i[s]) : (t >= i[n].time && t <= i[s].time && ({ lo: n, hi: s } = mn(i, "time", t)), { time: r, pos: o } = i[n], { time: a, pos: l } = i[s]);
  const c = a - r;
  return c ? o + (l - o) * (t - r) / c : o;
}
class Mg extends Wa {
  constructor(t) {
    super(t), this._table = [], this._minPos = void 0, this._tableRange = void 0;
  }
  initOffsets() {
    const t = this._getTimestampsForTable(), e = this._table = this.buildLookupTable(t);
    this._minPos = Hr(e, this.min), this._tableRange = Hr(e, this.max) - this._minPos, super.initOffsets(t);
  }
  buildLookupTable(t) {
    const { min: e, max: n } = this, s = [], r = [];
    let a, o, l, c, u;
    for (a = 0, o = t.length; a < o; ++a)
      c = t[a], c >= e && c <= n && s.push(c);
    if (s.length < 2)
      return [
        { time: e, pos: 0 },
        { time: n, pos: 1 }
      ];
    for (a = 0, o = s.length; a < o; ++a)
      u = s[a + 1], l = s[a - 1], c = s[a], Math.round((u + l) / 2) !== c && r.push({ time: c, pos: a / (o - 1) });
    return r;
  }
  _getTimestampsForTable() {
    let t = this._cache.all || [];
    if (t.length)
      return t;
    const e = this.getDataTimestamps(), n = this.getLabelTimestamps();
    return e.length && n.length ? t = this.normalize(e.concat(n)) : t = e.length ? e : n, t = this._cache.all = t, t;
  }
  getDecimalForValue(t) {
    return (Hr(this._table, t) - this._minPos) / this._tableRange;
  }
  getValueForPixel(t) {
    const e = this._offsets, n = this.getDecimalForPixel(t) / e.factor - e.end;
    return Hr(this._table, n * this._tableRange + this._minPos, !0);
  }
}
Mg.id = "timeseries";
Mg.defaults = Wa.defaults;
var Xe;
(function(i) {
  i.ChartRendered = "chart:rendered", i.ChartUpdated = "chart:updated", i.ChartDestroyed = "chart:destroyed", i.LabelsUpdated = "labels:updated";
})(Xe || (Xe = {}));
function Vr(i, t, e, n) {
  i(t, e);
}
function mO(i, t) {
  i.update();
}
function zr(i, t) {
  i.destroy();
}
function vO(i, t) {
  const e = {
    labels: typeof i.labels > "u" ? [] : [
      ...i.labels
    ],
    datasets: []
  };
  return Tg(e, {
    ...i
  }, t), e;
}
function Tg(i, t, e) {
  const n = [];
  i.datasets = t.datasets.map((s) => {
    const r = i.datasets.find((a) => a[e] === s[e]);
    return !r || !s.data || n.includes(r) ? {
      ...s
    } : (n.push(r), Object.assign(r, s), r);
  });
}
function AO(i, t, e) {
  i.data.labels = t;
}
function bO(i, t) {
  i.options = {
    ...t
  };
}
function yO(i, t) {
  const e = i.datasets.map((s) => s.label), n = t.datasets.map((s) => s.label);
  return t.datasets.length === i.datasets.length && e.every((s, r) => s === n[r]);
}
const _O = "Please remove the <template></template> tags from your chart component. See https://vue-chartjs.org/guide/#vue-single-file-components", xO = "annotation";
function pr(i, t, e) {
  let n = {};
  return {
    props: {
      chartData: {
        type: Object,
        required: !0
      },
      chartOptions: {
        type: Object,
        default: () => {
        }
      },
      datasetIdKey: {
        type: String,
        default: "label"
      },
      chartId: {
        type: String,
        default: i
      },
      width: {
        type: Number,
        default: 400
      },
      height: {
        type: Number,
        default: 400
      },
      cssClasses: {
        type: String,
        default: ""
      },
      styles: {
        type: Object,
        default: () => {
        }
      },
      plugins: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        _chart: null,
        _id: Math.random().toString(36).substring(2)
      };
    },
    computed: {
      hasAnnotationPlugin() {
        var s, r;
        return typeof ((s = this.chartOptions) === null || s === void 0 || (r = s.plugins) === null || r === void 0 ? void 0 : r[xO]) < "u";
      }
    },
    created() {
      Qs.register(e);
    },
    mounted() {
      n[this.$data._id] = null, "datasets" in this.chartData && this.chartData.datasets.length > 0 && (Vr(this.renderChart, this.chartData, this.chartOptions), this.$emit(Xe.ChartRendered));
    },
    watch: {
      chartData: {
        handler: function(s, r) {
          this.chartDataHandler(s, r);
        },
        deep: !0
      },
      chartOptions: {
        handler: function(s) {
          this.chartOptionsHandler(s);
        },
        deep: !0
      }
    },
    methods: {
      renderChart(s, r) {
        const a = this.getCurrentChart();
        if (a !== null && (zr(a), this.$emit(Xe.ChartDestroyed)), this.$refs.canvas) {
          const o = vO(s, this.datasetIdKey), l = this.$refs.canvas.getContext("2d");
          l !== null && this.setCurrentChart(new Qs(l, {
            type: t,
            data: o,
            options: r,
            plugins: this.plugins
          }));
        } else
          throw new Error(_O);
      },
      chartDataHandler(s, r) {
        const a = {
          ...s
        }, o = {
          ...r
        }, l = this.getCurrentChart();
        Object.keys(o).length > 0 ? yO(a, o) && l !== null ? (Tg(l.data, a, this.datasetIdKey), a.labels !== void 0 && (AO(l, a.labels), this.$emit(Xe.LabelsUpdated)), this.updateChart(), this.$emit(Xe.ChartUpdated)) : (l !== null && (zr(l), this.$emit(Xe.ChartDestroyed)), Vr(this.renderChart, this.chartData, this.chartOptions), this.$emit(Xe.ChartRendered)) : (l !== null && (zr(l), this.$emit(Xe.ChartDestroyed)), Vr(this.renderChart, this.chartData, this.chartOptions), this.$emit(Xe.ChartRendered));
      },
      chartOptionsHandler(s) {
        const r = this.getCurrentChart();
        r !== null ? (bO(r, s), this.updateChart()) : Vr(this.renderChart, this.chartData, this.chartOptions);
      },
      updateChart() {
        const s = this.getCurrentChart();
        mO(s);
      },
      getCurrentChart() {
        return this.hasAnnotationPlugin ? n[this.$data._id] : this.$data._chart;
      },
      setCurrentChart(s) {
        this.hasAnnotationPlugin ? n[this.$data._id] = s : this.$data._chart = s;
      }
    },
    beforeDestroy() {
      const s = this.getCurrentChart();
      s !== null && (zr(s), this.$emit(Xe.ChartDestroyed));
    },
    render: function(s) {
      return s("div", {
        style: this.styles,
        class: this.cssClasses
      }, [
        s("canvas", {
          attrs: {
            id: this.chartId,
            width: this.width,
            height: this.height
          },
          ref: "canvas"
        })
      ]);
    }
  };
}
const CO = /* @__PURE__ */ pr("bar-chart", "bar", dr), SO = /* @__PURE__ */ pr("doughnut-chart", "doughnut", fs), wO = /* @__PURE__ */ pr("line-chart", "line", Ba), kO = /* @__PURE__ */ pr("bubble-chart", "bubble", $a), OO = /* @__PURE__ */ pr("scatter-chart", "scatter", Fa);
Qs.register(
  zk,
  Xk,
  Hk,
  fr,
  Cc,
  dr,
  Na,
  Va,
  Ha,
  ya
);
const MO = {
  name: "AcvGraph",
  components: {
    LineGraph: wO,
    BarGraph: CO,
    ScatterGraph: OO,
    BubbleGraph: kO,
    DoughnutGraph: SO,
    AcvTooltip: os,
    AcvIcon: ie,
    AcvSegmentedControl: Dh
  },
  props: {
    /**
     * Defines the type of chart being used
     */
    type: {
      type: String,
      default: "line",
      validator(i) {
        return wt(i, [
          "line",
          "bar",
          "scatter",
          "bubble",
          "doughnut"
        ]);
      }
    },
    /**
     * Defines the labels/values for the x-axis
     */
    xValues: {
      type: Array,
      default: () => []
    },
    /**
     * Defines an Array of Objects with only the labels and data (for y-axis).
     * Note: this is specifically if you wish to use default styling.
     * Use chartDataOverride to use custom dataset.
     */
    chartDataObject: {
      type: Array,
      default: () => [{}]
    },
    /**
     * Defines the dataset ID key
     */
    datasetIdKey: {
      type: String,
      default: "label"
    },
    /**
     * Width of the graph (the canvas as a whole including legend)
     */
    width: {
      type: Number,
      default: 444
    },
    /**
     * Height of the graph (the canvas as a whole including legend)
     */
    height: {
      type: Number,
      default: 250
    },
    /**
     * custom css styling for the canvas
     */
    cssClasses: {
      type: String,
      default: ""
    },
    /**
     * custom styling for the canvas
     */
    styles: {
      type: Object,
      default: () => {
      }
    },
    /**
     * custom plugin for the canvas
     */
    plugins: {
      type: Array,
      default: () => {
      }
    },
    /**
     * Defines the title of the graph component
     */
    title: {
      type: String,
      default: ""
    },
    /**
     * Defines the subtitle of the  graph component
     */
    subTitle: {
      type: String,
      default: ""
    },
    /**
     * Defines the tooltip information
     */
    tooltipDetails: {
      type: String,
      default: ""
    },
    /**
     * Used for when you wish to switch between 2 datasets.
     * Note: this functionality is not available for Doughnut chart type
     */
    segmentedControlItems: {
      type: Array,
      default: () => []
    },
    /**
     * Custom Chart options that override the defaults defined within this class
     */
    customChartOptions: {
      type: Object,
      default: () => {
      }
    },
    /**
     * Overrides the entire chartData variable. Must be done for Doughnut charts and
     * optional for other types of charts
     */
    chartDataOverride: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    var i, t, e, n;
    return {
      selection: [this.segmentedControlItems[0]],
      // Must be defined as data since we swap on info on the fly here (see inputListeners)
      chartData: this.chartDataOverride ? this.chartDataOverride : {
        labels: this.xValues,
        datasets: [
          {
            label: (i = this.chartDataObject[0]) == null ? void 0 : i.label,
            fill: !1,
            lineTension: 0.15,
            backgroundColor: "rgba(0,97,165,1)",
            borderColor: "rgba(0,97,165,1)",
            data: (t = this.chartDataObject[0]) == null ? void 0 : t.data,
            order: 0
          },
          {
            label: (e = this.chartDataObject[1]) == null ? void 0 : e.label,
            fill: !1,
            lineTension: 0.15,
            backgroundColor: "rgba(0,165,118,1)",
            borderColor: "rgba(0,165,118,1)",
            data: (n = this.chartDataObject[1]) == null ? void 0 : n.data
          }
        ]
      },
      chartOptionsDefault: {
        responsive: !0,
        maintainAspectRatio: !1
      },
      chartOptions: {
        responsive: !0,
        maintainAspectRatio: !1,
        scales: {
          x: {
            grid: {
              drawOnChartArea: !1
            },
            ticks: {
              display: !0,
              padding: 10
            },
            offset: !0
          },
          y: {
            grid: {
              display: !1
            },
            ticks: {
              // eslint-disable func-names object-shorthand prefer-template
              callback(s) {
                return `${s}%`;
              },
              autoSkip: !0,
              maxTicksLimit: 7
            },
            beginAtZero: !0,
            grace: "50%"
          }
        },
        elements: {
          point: {
            hoverRadius: 11,
            hoverBackgroundColor: "#FFFFFF",
            hoverBorderColor: "rgba(0,97,165,1)",
            hoverBorderWidth: 3,
            radius: 0,
            hitRadius: 5
          }
        },
        plugins: {
          legend: {
            display: !0,
            labels: {
              boxHeight: 1,
              boxWidth: 15,
              padding: 16
            },
            position: "bottom",
            align: "start",
            boxHeight: 10
          },
          tooltip: {
            position: "nearest",
            yAlign: "bottom",
            caretPadding: 12,
            displayColors: !1,
            backgroundColor: "rgb(255,255,255)",
            bodyColor: "#545454",
            cornerRadius: 3,
            caretSize: 10,
            borderColor: "rgba(0,0,0, 0.1)",
            borderWidth: 2,
            bodyFont: {
              size: 18,
              weight: 500
            },
            callbacks: {
              label(s) {
                let r = s.dataset.label || "";
                return r && (r = `${r}: `), s.parsed.y !== null && (r = `${r}${s.parsed.y}%`), r;
              },
              title() {
                return "";
              }
            }
          }
        }
      }
    };
  },
  computed: {
    inputListeners() {
      return {
        ...this.$listeners,
        change: (i) => {
          this.type !== "doughnut" && this.datasetsToUse(), this.$emit("change", i);
        }
      };
    },
    inputId() {
      return this.$attrs.id || this.id || `${this.$options.name}-${this._uid}`;
    },
    componentRender() {
      const i = /* @__PURE__ */ new Map();
      return i.set("line", "LineGraph"), i.set("bar", "BarGraph"), i.set("scatter", "ScatterGraph"), i.set("bubble", "BubbleGraph"), i.set("doughnut", "DoughnutGraph"), i.get(this.type);
    },
    computeChartId() {
      const i = /* @__PURE__ */ new Map();
      return i.set("line", `line-chart-${this.inputId}`), i.set("bar", `bar-chart-${this.inputId}`), i.set("scatter", `scatter-chart-${this.inputId}`), i.set("bubble", `bubble-chart-${this.inputId}`), i.set("doughnut", `doughnut-chart-${this.inputId}`), i.get(this.type);
    },
    computeChartOptions() {
      return this.customChartOptions ? this.customChartOptions : this.type === "line" ? this.chartOptions : this.type === "bar" || this.type === "scatter" || this.type === "bubble" || this.type === "doughnut" ? this.chartOptionsDefault : this.chartOptions;
    }
  },
  methods: {
    datasetsToUse() {
      if (this.segmentedControlItems.length > 1 && this.chartDataObject.length === 4) {
        const i = this.segmentedControlItems.indexOf(this.selection[0]);
        i === 0 ? (this.chartData.datasets[0].label = this.chartDataObject[0].label, this.chartData.datasets[0].data = this.chartDataObject[0].data, this.chartData.datasets[1].label = this.chartDataObject[1].label, this.chartData.datasets[1].data = this.chartDataObject[1].data) : i === 1 ? (this.chartData.datasets[0].label = this.chartDataObject[2].label, this.chartData.datasets[0].data = this.chartDataObject[2].data, this.chartData.datasets[1].label = this.chartDataObject[3].label, this.chartData.datasets[1].data = this.chartDataObject[3].data) : (this.chartData.datasets[0].label = this.chartDataObject[0].label, this.chartData.datasets[0].data = this.chartDataObject[0].data, this.chartData.datasets[1].label = this.chartDataObject[1].label, this.chartData.datasets[1].data = this.chartDataObject[1].data);
      } else
        this.chartData.datasets[0].label = this.chartDataObject[0].label, this.chartData.datasets[0].data = this.chartDataObject[0].data, this.chartData.datasets[1].label = this.chartDataObject[1].label, this.chartData.datasets[1].data = this.chartDataObject[1].data;
    },
    onHoverInfoIcon(i, t) {
      this.$emit(t, i);
    }
  }
};
var TO = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "acv-graph" }, [e("div", { staticClass: "heading" }, [e("div", { staticClass: "title-component" }, [e("div", { staticClass: "title" }, [t._v(" " + t._s(t.title) + " "), t.tooltipDetails ? e("acv-icon", { staticClass: "title-tooltip", attrs: { id: `acv-graph-icon-${t.inputId}`, icon: "info" }, nativeOn: { mouseover: function(n) {
    return t.onHoverInfoIcon(n, "mouseoverInfo");
  }, focusin: function(n) {
    return t.onHoverInfoIcon(n, "focusinInfo");
  } } }) : t._e(), t.tooltipDetails ? e("acv-tooltip", { attrs: { target: `#acv-graph-icon-${t.inputId}`, position: "top" } }, [t._v(" " + t._s(t.tooltipDetails) + " ")]) : t._e()], 1), e("div", { staticClass: "sub-title" }, [t._v(" " + t._s(t.subTitle) + " ")])]), e("div", { directives: [{ name: "show", rawName: "v-show", value: t.segmentedControlItems.length > 1, expression: "segmentedControlItems.length > 1" }], staticClass: "segmented-control" }, [e("acv-segmented-control", t._g({ attrs: { items: t.segmentedControlItems }, model: { value: t.selection, callback: function(n) {
    t.selection = n;
  }, expression: "selection" } }, t.inputListeners))], 1)]), e(t.componentRender, { tag: "component", attrs: { "chart-options": t.computeChartOptions, "chart-data": t.chartData, "chart-id": t.computeChartId, "dataset-id-key": t.datasetIdKey, plugins: t.plugins, "css-classes": t.cssClasses, styles: t.styles, width: t.width, height: t.height } })], 1);
}, DO = [], PO = /* @__PURE__ */ U(
  MO,
  TO,
  DO,
  !1,
  null,
  "7a982205"
);
const LO = PO.exports, IO = {
  name: "AcvMenuListItem",
  components: {
    AcvIcon: ie
  },
  props: {
    iconType: {
      type: String,
      default: ""
    },
    label: {
      type: [String, Number],
      default: ""
    },
    defaultSelection: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    id: {
      type: String,
      default: ""
    },
    event: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      selected: this.defaultSelection
    };
  },
  computed: {
    menuListItemClasses() {
      return {
        "acv-menu-list-item--selected": this.selected,
        "acv-menu-list-item--disabled": this.disabled
      };
    }
  },
  watch: {
    defaultSelection(i) {
      this.selected = i;
      const t = {
        event: this.event,
        id: this.id,
        selected: this.selected
      };
      this.$emit("selected", t);
    }
  },
  created() {
    if (this.defaultSelection) {
      const i = {
        event: this.event,
        id: this.id,
        selected: this.selected
      };
      this.$emit("selected", i);
    }
  },
  methods: {
    handleSelected() {
      if (this.disabled) return;
      this.selected = !this.selected;
      const i = {
        event: this.event,
        id: this.id,
        selected: this.selected
      };
      this.$emit("selected", i), this.$refs[this.id].blur();
    }
  }
};
var EO = function() {
  var t = this, e = t._self._c;
  return e("li", { ref: t.id, staticClass: "acv-menu-list-item", class: [t.menuListItemClasses], attrs: { id: t.id, role: "menuitem", tabindex: "0" }, on: { click: function(n) {
    return n.stopPropagation(), n.preventDefault(), t.handleSelected.apply(null, arguments);
  }, keydown: [function(n) {
    return !n.type.indexOf("key") && t._k(n.keyCode, "enter", 13, n.key, "Enter") ? null : t.handleSelected.apply(null, arguments);
  }, function(n) {
    return !n.type.indexOf("key") && t._k(n.keyCode, "space", 32, n.key, [" ", "Spacebar"]) ? null : t.handleSelected.apply(null, arguments);
  }] } }, [e("div", { staticClass: "acv-menu-list-item__left" }, [t._t("icon", function() {
    return [t.iconType ? e("acv-icon", { attrs: { icon: t.iconType } }) : t._e()];
  }), t._t("default", function() {
    return [e("span", { staticClass: "acv-menu-list-item__left__content" }, [t._v(" " + t._s(t.label) + " ")])];
  })], 2)]);
}, $O = [], BO = /* @__PURE__ */ U(
  IO,
  EO,
  $O,
  !1,
  null,
  "b3012047"
);
const Dg = BO.exports, RO = {
  name: "AcvMenuList",
  components: {
    AcvMenuListItem: Dg,
    AcvDivider: Js
  },
  props: {
    disabled: {
      type: Boolean,
      default: !1
    },
    items: {
      type: Array,
      default: () => []
    },
    isMultiSelect: {
      type: Boolean,
      default: !1
    },
    mustAlwaysHaveOneSelected: {
      type: Boolean,
      default: !0
    }
  },
  data() {
    return {
      currentSelection: null
    };
  },
  computed: {
    menuListId() {
      return this.$attrs.id || this.id || `${this.$options.name}-${this._uid}`;
    }
  },
  methods: {
    handleCurrentSelection(i, t) {
      var e;
      if (!this.isMultiSelect && t !== ((e = this.currentSelection) == null ? void 0 : e.id)) {
        const n = this.$refs[`menuListRef-${t}`];
        n != null && n.length && (n[0].selected = !1);
      }
      return i.defaultSelection ?? !1;
    },
    retainCurrentSelection(i) {
      const [t] = this.$refs[`menuListRef-${i}`];
      t && (t.selected = !0);
    },
    handleSelected(i) {
      var n, s, r, a, o;
      if (this.disabled) return;
      if (this.isMultiSelect) {
        if (this.mustAlwaysHaveOneSelected) {
          const l = (a = this.$refs[`menu-list-${this.menuListId}`]) == null ? void 0 : a.querySelectorAll(".acv-menu-list-item--selected");
          (l == null ? void 0 : l.length) === 1 && this.retainCurrentSelection(i.id);
        }
      } else if (this.mustAlwaysHaveOneSelected) {
        if (((n = this.currentSelection) == null ? void 0 : n.id) === i.id && !i.selected) {
          this.retainCurrentSelection(i.id), this.$emit("same-item-selected", i);
          return;
        }
        if (!i.selected) {
          this.retainCurrentSelection((s = this.currentSelection) == null ? void 0 : s.id);
          return;
        }
        ((r = this.currentSelection) == null ? void 0 : r.id) !== i.id && i.selected && (this.currentSelection = i);
      } else
        this.currentSelection = i;
      const t = (o = i.id) == null ? void 0 : o.split("-").pop(), e = {
        ...i,
        itemIndex: t
      };
      this.$emit("item-selected", e);
    },
    setToProvidedItem(i, t) {
      if (this.mustAlwaysHaveOneSelected && !this.isMultiSelect) {
        this.currentSelection = t;
        const [e] = this.$refs[`menuListRef-${i.id}`], [n] = this.$refs[`menuListRef-${t.id}`];
        e && (e.selected = !1), n && (n.selected = !0);
      }
    }
  }
};
var FO = function() {
  var t = this, e = t._self._c;
  return e("ul", { ref: `menu-list-${t.menuListId}`, staticClass: "acv-menu-list", attrs: { id: `menu-list-${t.menuListId}`, role: "menu" } }, [t._t("before"), t._t("default", function() {
    return t._l(t.items, function(n, s) {
      return e("div", { key: s }, [e("acv-menu-list-item", t._b({ ref: `menuListRef-menu-list-item-${s}`, refInFor: !0, attrs: { id: `menu-list-item-${s}`, "default-selection": t.handleCurrentSelection(n, `menu-list-item-${s}`), disabled: t.disabled || n.disabled }, on: { selected: function(r) {
        return t.handleSelected(r);
      } } }, "acv-menu-list-item", n, !1)), n.divider ? e("acv-divider") : t._e()], 1);
    });
  }), t._t("after")], 2);
}, NO = [], HO = /* @__PURE__ */ U(
  RO,
  FO,
  NO,
  !1,
  null,
  "f30ab88c"
);
const Pg = HO.exports;
var VO = { npm_config_user_agent: "npm/10.9.2 node/v22.14.0 linux x64 workspaces/false", NODE_VERSION: "22.14.0", HOSTNAME: "804d0c43b6a1", YARN_VERSION: "1.22.22", npm_node_execpath: "/usr/local/bin/node", SHLVL: "2", npm_config_noproxy: "", HOME: "/root", npm_package_json: "/app/package.json", npm_config_userconfig: "/root/.npmrc", npm_config_local_prefix: "/app", COLOR: "0", npm_config_prefix: "/usr/local", npm_config_npm_version: "10.9.2", npm_config_registry: "https://nexus.infra.acvauctions.com/repository/npm-public/", npm_config_cache: "/root/.npm", npm_config_node_gyp: "/usr/local/lib/node_modules/npm/node_modules/node-gyp/bin/node-gyp.js", PATH: "/app/node_modules/.bin:/node_modules/.bin:/usr/local/lib/node_modules/npm/node_modules/@npmcli/run-script/lib/node-gyp-bin:/usr/local/sbin:/usr/local/bin:/usr/sbin:/usr/bin:/sbin:/bin", NODE: "/usr/local/bin/node", npm_package_name: "@acv/shared-vuejs", npm_lifecycle_script: "vite build", npm_package_version: "3.45.0", npm_lifecycle_event: "build", npm_config_globalconfig: "/usr/local/etc/npmrc", npm_config_init_module: "/root/.npm-init.js", PWD: "/app", npm_execpath: "/usr/local/lib/node_modules/npm/bin/npm-cli.js", npm_config_global_prefix: "/usr/local", npm_command: "run-script", INIT_CWD: "/app", EDITOR: "vi", NODE_ENV: "production" };
const zO = {
  name: "AcvMenu",
  directives: {
    onClickaway: On
  },
  components: {
    AcvMenuList: Pg
  },
  props: {
    target: {
      type: String,
      default: ""
    },
    items: {
      type: Array,
      default: () => []
    },
    position: {
      type: String,
      default: "right"
    },
    shouldCloseOnSelected: {
      type: Boolean,
      default: !0
    },
    isMultiSelect: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    mustAlwaysHaveOneSelected: {
      type: Boolean,
      default: !0
    }
  },
  data() {
    return {
      visible: !1,
      showMenu: !1,
      menuPlacementStyles: "",
      resizeTimer: null
    };
  },
  computed: {
    menuId() {
      return this.$attrs.id || this.id || `${this.$options.name}-${this._uid}`;
    },
    menuClasses() {
      return {
        visible: this.visible
      };
    }
  },
  watch: {
    target: {
      handler: "initialize",
      // Call the initialize method when target changes
      immediate: !0,
      deep: !0,
      targetElement: null
    },
    position: {
      handler() {
        this.determineMenuPlacementWithTarget();
      }
    },
    visible(i) {
      i ? this.$emit("opened") : this.$emit("closed");
    }
  },
  mounted() {
    this.initialize();
  },
  destroyed() {
    this.removeListeners();
  },
  methods: {
    initialize() {
      this.$nextTick(() => {
        const i = this.target;
        i && (this.targetElement = document.querySelector(i)), !this.targetElement && VO.NODE_ENV === "development" ? window.console.warn(`[ACV Warn]: Could not find target element: ${i}`) : (this.removeListeners(), this.addListeners());
      });
    },
    addListeners() {
      this.targetElement && (this.targetElement.addEventListener("click", this.toggleVisible), window.addEventListener("resize", this.handleResize));
    },
    removeListeners() {
      this.targetElement && (this.targetElement.removeEventListener("click", this.setNotVisible), window.removeEventListener("resize", this.handleResize), this.resizeTimer && (clearTimeout(this.resizeTimer), this.resizeTimer = null));
    },
    toggleVisible() {
      this.visible = !this.visible, this.visible && this.determineMenuPlacementWithTarget();
    },
    setNotVisible() {
      this.visible = !1;
    },
    handleResize() {
      clearTimeout(this.resizeTimer), this.resizeTimer = setTimeout(() => {
        this.determineMenuPlacementWithTarget();
      }, 250);
    },
    handleClickAway({ target: i }) {
      !this.visible || Array.from(this.targetElement.getElementsByTagName("*")).includes(i) || i === this.targetElement || (this.setNotVisible(), this.$emit("clicked-away"));
    },
    determineMenuPlacementWithTarget() {
      if (this.targetElement) {
        const { width: i } = this.targetElement.getBoundingClientRect(), { width: t } = document.querySelector(`#${this.menuId} .acv-menu-list`).getBoundingClientRect();
        let e;
        this.position === "right" ? e = i / 2 - t : this.position === "left" ? e = -i / 2 : this.position === "center" && (e = -(i / 2) + (i - t) / 2), this.menuPlacementStyles = `left: ${e}px`;
      }
    },
    emitSelection(i) {
      this.$emit("selected", i), this.shouldCloseOnSelected && this.setNotVisible();
    }
  }
};
var jO = function() {
  var t = this, e = t._self._c;
  return e("div", { directives: [{ name: "on-clickaway", rawName: "v-on-clickaway:mousedown", value: t.handleClickAway, expression: "handleClickAway", arg: "mousedown" }], ref: "menuRef", staticClass: "acv-menu", class: t.menuClasses, style: t.menuPlacementStyles, attrs: { id: t.menuId } }, [t._t("before"), e("AcvMenuList", { ref: "menuListRef", staticClass: "flyout-wrapper", attrs: { items: t.items, "is-multi-select": t.isMultiSelect, disabled: t.disabled, "must-always-have-one-selected": t.mustAlwaysHaveOneSelected }, on: { "item-selected": t.emitSelection, "same-item-selected": function(n) {
    t.visible = !1;
  } } }), t._t("after")], 2);
}, WO = [], YO = /* @__PURE__ */ U(
  zO,
  jO,
  WO,
  !1,
  null,
  "5abf00ed"
);
const UO = YO.exports, ZO = {
  name: "AcvBaseSvg",
  computed: {
    baseId() {
      return this._uid;
    }
  }
}, GO = null, KO = null;
var XO = /* @__PURE__ */ U(
  ZO,
  GO,
  KO,
  !1,
  null,
  null
);
const ne = XO.exports, QO = {
  name: "AcvSvgGradient",
  extends: ne
};
var JO = function() {
  var t = this, e = t._self._c;
  return e("svg", { attrs: { "aria-hidden": "true", focusable: "false", width: "0", height: "0", xmlns: "http://www.w3.org/2000/svg", "xmlns:xlink": "http://www.w3.org/1999/xlink" } }, [e("linearGradient", { attrs: { id: `${t.baseId}-primary-gradient`, x1: "0%", x2: "90.72%" } }, [e("stop", { attrs: { offset: "0.15%", "stop-color": "#F26522" } }), e("stop", { attrs: { offset: "87.52%", "stop-color": "#FC4243" } })], 1)], 1);
}, qO = [], tM = /* @__PURE__ */ U(
  QO,
  JO,
  qO,
  !1,
  null,
  null
);
const eM = tM.exports, iM = {
  name: "AcvAuctionsPrimaryDarkSvg",
  extends: ne
};
var nM = function() {
  var t = this, e = t._self._c;
  return e("svg", { attrs: { viewBox: "0 0 91 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" } }, [e("title", [t._v("ACV Auctions")]), e("desc", [t._v("The stylized logo of ACV Auctions")]), e("g", { attrs: { "clip-path": `url(#${t.baseId}-clip0)` } }, [e("path", { attrs: { d: "M16.4296 39.0993H14.4801L14.0448 39.8279H12.978L15.6087 35.6021H16.7732L17.5128 39.8279H16.5445L16.4296 39.0993ZM14.9077 38.3203H16.3534L16.056 36.3751L14.9077 38.3203Z", fill: "white" } }), e("path", { attrs: { d: "M18.0826 38.4281C18.0826 38.3459 18.1006 38.143 18.1332 37.9906L18.6653 35.6021H19.608L19.0758 37.9966C19.0441 38.1362 19.0312 38.2372 19.0312 38.3391C19.0398 38.7766 19.3423 39.1122 19.9379 39.1122C20.6114 39.1122 20.9302 38.7064 21.0587 38.1174L21.6226 35.6021H22.5652L22.0013 38.1362C21.7708 39.1627 21.231 39.9041 19.8899 39.9041C18.7108 39.9041 18.0861 39.3082 18.0826 38.4281Z", fill: "white" } }), e("path", { attrs: { d: "M25.411 35.5327C26.4779 35.5327 27.0948 36.0901 27.3536 36.7304L26.459 37.0215C26.2868 36.578 25.8737 36.3306 25.3699 36.3306C24.5455 36.3306 23.8488 37.0275 23.8531 37.953C23.8566 38.6122 24.3364 39.1062 25.0888 39.1062C25.4616 39.1062 25.8669 38.9161 26.1137 38.6182L26.8292 39.0874C26.3348 39.708 25.6098 39.9041 25.04 39.9041C23.836 39.9041 22.8908 39.1627 22.8848 38.0095C22.8762 36.5147 24.0562 35.5327 25.411 35.5327Z", fill: "white" } }), e("path", { attrs: { d: "M29.0794 36.394H27.8035L27.9826 35.6021H31.4634L31.2903 36.394H30.0143L29.2517 39.8279H28.3159L29.0794 36.394Z", fill: "white" } }), e("path", { attrs: { d: "M32.2886 35.6021H33.2175L32.2748 39.8279H31.3459L32.2886 35.6021Z", fill: "white" } }), e("path", { attrs: { d: "M36.0307 35.5327C37.2347 35.5327 38.1739 36.2673 38.179 37.4205C38.185 38.8014 37.0976 39.9041 35.658 39.9041C34.4472 39.9041 33.5088 39.1695 33.5028 38.0095C33.4968 36.6286 34.5911 35.5327 36.0307 35.5327ZM35.975 36.3306C35.131 36.3306 34.4669 37.0463 34.4711 37.953C34.4746 38.6687 35.0067 39.1062 35.7068 39.1062C36.544 39.1062 37.215 38.3905 37.2107 37.4838C37.2073 36.7741 36.6751 36.3306 35.975 36.3306Z", fill: "white" } }), e("path", { attrs: { d: "M40.0676 36.8315L39.4009 39.8279H38.472L39.4147 35.6021H40.3701L41.7446 38.4975L42.3924 35.6021H43.3213L42.3787 39.8279H41.4824L40.0676 36.8315Z", fill: "white" } }), e("path", { attrs: { d: "M43.8509 38.4662C44.1603 38.8591 44.731 39.1185 45.3325 39.1185C45.797 39.1185 45.9855 38.8583 45.9846 38.6305C45.9838 38.3771 45.6487 38.2444 45.2366 38.098C44.6273 37.8891 43.8672 37.61 43.8629 36.8566C43.8603 36.2171 44.4782 35.5391 45.5579 35.5391C46.2511 35.5391 46.9067 35.7865 47.2949 36.2231L46.7216 36.8506C46.4122 36.4894 45.875 36.3121 45.4431 36.3121C45.0832 36.3121 44.8355 36.521 44.8364 36.7556C44.8372 36.9833 45.1714 37.1101 45.5845 37.2565C46.1937 37.4722 46.9675 37.7573 46.971 38.4918C46.9744 39.2392 46.3428 39.9045 45.2631 39.9045C44.4062 39.9045 43.6521 39.5817 43.2836 39.1194L43.8509 38.4662Z", fill: "white" } }), e("path", { attrs: { d: "M47.4432 26.3727C44.0446 26.3727 41.635 23.5655 42.0609 20.1024C42.4868 16.6394 45.5879 13.8321 48.9865 13.8321C50.9437 13.8321 52.5718 14.7636 53.5204 16.2139L59.7313 9.83745C57.4562 7.06531 53.9909 5.33936 49.9179 5.33936C41.9752 5.33936 34.73 11.8999 33.7342 19.9937C32.7385 28.0867 38.3701 34.648 46.312 34.648C50.4021 34.648 54.3053 32.9067 57.2677 30.1131L51.7646 24.7538C50.5486 25.758 49.0293 26.3727 47.4432 26.3727Z", fill: `url(#${t.baseId}-paint0_linear)` } }), e("path", { attrs: { d: "M79.365 0H90.5263L69.765 33.3633H58.6045L79.365 0Z", fill: `url(#${t.baseId}-paint1_linear)` } }), e("path", { attrs: { d: "M32.6759 21.9512C32.6717 21.2731 32.7111 20.5848 32.7968 19.8888C32.9073 18.9881 33.0915 18.1003 33.3461 17.2314L32.1009 8.00488L24.9945 19.4282L25.567 23.6463H22.3552L18.6799 29.5682H26.3639L26.8746 33.3642L35.5218 33.3634L35.0616 29.9603C33.4814 27.659 32.6597 24.9006 32.6759 21.9512Z", fill: `url(#${t.baseId}-paint2_linear)` } }), e("path", { attrs: { d: "M20.7605 6.63574H31.9218L11.1613 39.9999H0L20.7605 6.63574Z", fill: `url(#${t.baseId}-paint3_linear)` } }), e("path", { attrs: { d: "M63.5909 6.63574H57.2428C58.6105 7.43108 59.8393 8.52778 60.979 9.8368L56.0449 14.8922L58.3714 32.1269L65.4769 20.7096L63.5909 6.63574Z", fill: `url(#${t.baseId}-paint4_linear)` } })]), e("defs", [e("linearGradient", { attrs: { id: `${t.baseId}-paint0_linear`, x1: "49.8154", y1: "34.2544", x2: "44.8396", y2: "6.00919", gradientUnits: "userSpaceOnUse" } }, [e("stop", { attrs: { "stop-color": "#F26723" } }), e("stop", { attrs: { offset: "0.3315", "stop-color": "#E35323" } }), e("stop", { attrs: { offset: "0.9971", "stop-color": "#C61621" } }), e("stop", { attrs: { offset: "1", "stop-color": "#C61521" } })], 1), e("linearGradient", { attrs: { id: `${t.baseId}-paint1_linear`, x1: "74.5653", y1: "33.3636", x2: "74.5653", y2: "0", gradientUnits: "userSpaceOnUse" } }, [e("stop", { attrs: { "stop-color": "#F26723" } }), e("stop", { attrs: { offset: "0.3315", "stop-color": "#E35323" } }), e("stop", { attrs: { offset: "0.9971", "stop-color": "#C61621" } }), e("stop", { attrs: { offset: "1", "stop-color": "#C61521" } })], 1), e("linearGradient", { attrs: { id: `${t.baseId}-paint2_linear`, x1: "25.8187", y1: "33.6855", x2: "38.502", y2: "11.6972", gradientUnits: "userSpaceOnUse" } }, [e("stop", { attrs: { "stop-color": "#F26723" } }), e("stop", { attrs: { offset: "0.3315", "stop-color": "#E35323" } }), e("stop", { attrs: { offset: "0.9971", "stop-color": "#C61621" } }), e("stop", { attrs: { offset: "1", "stop-color": "#C61521" } })], 1), e("linearGradient", { attrs: { id: `${t.baseId}-paint3_linear`, x1: "15.961", y1: "39.9996", x2: "15.961", y2: "6.636", gradientUnits: "userSpaceOnUse" } }, [e("stop", { attrs: { "stop-color": "#F26723" } }), e("stop", { attrs: { offset: "0.3315", "stop-color": "#E35323" } }), e("stop", { attrs: { offset: "0.9971", "stop-color": "#C61621" } }), e("stop", { attrs: { offset: "1", "stop-color": "#C61521" } })], 1), e("linearGradient", { attrs: { id: `${t.baseId}-paint4_linear`, x1: "52.6144", y1: "28.8068", x2: "64.9505", y2: "7.42042", gradientUnits: "userSpaceOnUse" } }, [e("stop", { attrs: { "stop-color": "#F26723" } }), e("stop", { attrs: { offset: "0.3315", "stop-color": "#E35323" } }), e("stop", { attrs: { offset: "0.9971", "stop-color": "#C61621" } }), e("stop", { attrs: { offset: "1", "stop-color": "#C61521" } })], 1), e("clipPath", { attrs: { id: `${t.baseId}-clip0` } }, [e("rect", { attrs: { width: "90.5263", height: "40", fill: "white" } })])], 1)]);
}, sM = [], rM = /* @__PURE__ */ U(
  iM,
  nM,
  sM,
  !1,
  null,
  null
);
const aM = rM.exports, oM = {
  name: "AcvAuctionsPrimaryLightSvg",
  extends: ne
};
var lM = function() {
  var t = this, e = t._self._c;
  return e("svg", { attrs: { viewBox: "0 0 91 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" } }, [e("title", [t._v("ACV Auctions")]), e("desc", [t._v("The stylized logo of ACV Auctions")]), e("g", { attrs: { "clip-path": `url(#${t.baseId}-clip0)` } }, [e("path", { attrs: { d: "M16.4296 39.0993H14.4801L14.0448 39.8279H12.978L15.6087 35.6021H16.7732L17.5128 39.8279H16.5445L16.4296 39.0993ZM14.9077 38.3203H16.3534L16.056 36.3751L14.9077 38.3203Z", fill: "black" } }), e("path", { attrs: { d: "M18.0826 38.4281C18.0826 38.3459 18.1006 38.143 18.1332 37.9906L18.6653 35.6021H19.608L19.0758 37.9966C19.0441 38.1362 19.0312 38.2372 19.0312 38.3391C19.0398 38.7766 19.3423 39.1122 19.9379 39.1122C20.6114 39.1122 20.9302 38.7064 21.0587 38.1174L21.6226 35.6021H22.5652L22.0013 38.1362C21.7708 39.1627 21.231 39.9041 19.8899 39.9041C18.7108 39.9041 18.0861 39.3082 18.0826 38.4281Z", fill: "black" } }), e("path", { attrs: { d: "M25.411 35.5327C26.4779 35.5327 27.0948 36.0901 27.3536 36.7304L26.459 37.0215C26.2868 36.578 25.8737 36.3306 25.3699 36.3306C24.5455 36.3306 23.8488 37.0275 23.8531 37.953C23.8566 38.6122 24.3364 39.1062 25.0888 39.1062C25.4616 39.1062 25.8669 38.9161 26.1137 38.6182L26.8292 39.0874C26.3348 39.708 25.6098 39.9041 25.04 39.9041C23.836 39.9041 22.8908 39.1627 22.8848 38.0095C22.8762 36.5147 24.0562 35.5327 25.411 35.5327Z", fill: "black" } }), e("path", { attrs: { d: "M29.0794 36.394H27.8035L27.9826 35.6021H31.4634L31.2903 36.394H30.0143L29.2517 39.8279H28.3159L29.0794 36.394Z", fill: "black" } }), e("path", { attrs: { d: "M32.2886 35.6021H33.2175L32.2748 39.8279H31.3459L32.2886 35.6021Z", fill: "black" } }), e("path", { attrs: { d: "M36.0307 35.5327C37.2347 35.5327 38.1739 36.2673 38.179 37.4205C38.185 38.8014 37.0976 39.9041 35.658 39.9041C34.4472 39.9041 33.5088 39.1695 33.5028 38.0095C33.4968 36.6286 34.5911 35.5327 36.0307 35.5327ZM35.975 36.3306C35.131 36.3306 34.4669 37.0463 34.4711 37.953C34.4746 38.6687 35.0067 39.1062 35.7068 39.1062C36.544 39.1062 37.215 38.3905 37.2107 37.4838C37.2073 36.7741 36.6751 36.3306 35.975 36.3306Z", fill: "black" } }), e("path", { attrs: { d: "M40.0676 36.8315L39.4009 39.8279H38.472L39.4147 35.6021H40.3701L41.7446 38.4975L42.3924 35.6021H43.3213L42.3787 39.8279H41.4824L40.0676 36.8315Z", fill: "black" } }), e("path", { attrs: { d: "M43.8509 38.4662C44.1603 38.8591 44.731 39.1185 45.3325 39.1185C45.797 39.1185 45.9855 38.8583 45.9846 38.6305C45.9838 38.3771 45.6487 38.2444 45.2366 38.098C44.6273 37.8891 43.8672 37.61 43.8629 36.8566C43.8603 36.2171 44.4782 35.5391 45.5579 35.5391C46.2511 35.5391 46.9067 35.7865 47.2949 36.2231L46.7216 36.8506C46.4122 36.4894 45.875 36.3121 45.4431 36.3121C45.0832 36.3121 44.8355 36.521 44.8364 36.7556C44.8372 36.9833 45.1714 37.1101 45.5845 37.2565C46.1937 37.4722 46.9675 37.7573 46.971 38.4918C46.9744 39.2392 46.3428 39.9045 45.2631 39.9045C44.4062 39.9045 43.6521 39.5817 43.2836 39.1194L43.8509 38.4662Z", fill: "black" } }), e("path", { attrs: { d: "M47.4432 26.3727C44.0446 26.3727 41.635 23.5655 42.0609 20.1024C42.4868 16.6394 45.5879 13.8321 48.9865 13.8321C50.9437 13.8321 52.5718 14.7636 53.5204 16.2139L59.7313 9.83745C57.4562 7.06531 53.9909 5.33936 49.9179 5.33936C41.9752 5.33936 34.73 11.8999 33.7342 19.9937C32.7385 28.0867 38.3701 34.648 46.312 34.648C50.4021 34.648 54.3053 32.9067 57.2677 30.1131L51.7646 24.7538C50.5486 25.758 49.0293 26.3727 47.4432 26.3727Z", fill: `url(#${t.baseId}-paint0_linear)` } }), e("path", { attrs: { d: "M79.365 0H90.5263L69.765 33.3633H58.6045L79.365 0Z", fill: `url(#${t.baseId}-paint1_linear)` } }), e("path", { attrs: { d: "M32.6759 21.9512C32.6717 21.2731 32.7111 20.5848 32.7968 19.8888C32.9073 18.9881 33.0915 18.1003 33.3461 17.2314L32.1009 8.00488L24.9945 19.4282L25.567 23.6463H22.3552L18.6799 29.5682H26.3639L26.8746 33.3642L35.5218 33.3634L35.0616 29.9603C33.4814 27.659 32.6597 24.9006 32.6759 21.9512Z", fill: `url(#${t.baseId}-paint2_linear)` } }), e("path", { attrs: { d: "M20.7605 6.63574H31.9218L11.1613 39.9999H0L20.7605 6.63574Z", fill: `url(#${t.baseId}-paint3_linear)` } }), e("path", { attrs: { d: "M63.5909 6.63574H57.2428C58.6105 7.43108 59.8393 8.52778 60.979 9.8368L56.0449 14.8922L58.3714 32.1269L65.4769 20.7096L63.5909 6.63574Z", fill: `url(#${t.baseId}-paint4_linear)` } })]), e("defs", [e("linearGradient", { attrs: { id: `${t.baseId}-paint0_linear`, x1: "49.8154", y1: "34.2544", x2: "44.8396", y2: "6.00919", gradientUnits: "userSpaceOnUse" } }, [e("stop", { attrs: { "stop-color": "#F26723" } }), e("stop", { attrs: { offset: "0.3315", "stop-color": "#E35323" } }), e("stop", { attrs: { offset: "0.9971", "stop-color": "#C61621" } }), e("stop", { attrs: { offset: "1", "stop-color": "#C61521" } })], 1), e("linearGradient", { attrs: { id: `${t.baseId}-paint1_linear`, x1: "74.5653", y1: "33.3636", x2: "74.5653", y2: "0", gradientUnits: "userSpaceOnUse" } }, [e("stop", { attrs: { "stop-color": "#F26723" } }), e("stop", { attrs: { offset: "0.3315", "stop-color": "#E35323" } }), e("stop", { attrs: { offset: "0.9971", "stop-color": "#C61621" } }), e("stop", { attrs: { offset: "1", "stop-color": "#C61521" } })], 1), e("linearGradient", { attrs: { id: `${t.baseId}-paint2_linear`, x1: "25.8187", y1: "33.6855", x2: "38.502", y2: "11.6972", gradientUnits: "userSpaceOnUse" } }, [e("stop", { attrs: { "stop-color": "#F26723" } }), e("stop", { attrs: { offset: "0.3315", "stop-color": "#E35323" } }), e("stop", { attrs: { offset: "0.9971", "stop-color": "#C61621" } }), e("stop", { attrs: { offset: "1", "stop-color": "#C61521" } })], 1), e("linearGradient", { attrs: { id: `${t.baseId}-paint3_linear`, x1: "15.961", y1: "39.9996", x2: "15.961", y2: "6.636", gradientUnits: "userSpaceOnUse" } }, [e("stop", { attrs: { "stop-color": "#F26723" } }), e("stop", { attrs: { offset: "0.3315", "stop-color": "#E35323" } }), e("stop", { attrs: { offset: "0.9971", "stop-color": "#C61621" } }), e("stop", { attrs: { offset: "1", "stop-color": "#C61521" } })], 1), e("linearGradient", { attrs: { id: `${t.baseId}-paint4_linear`, x1: "52.6144", y1: "28.8068", x2: "64.9505", y2: "7.42042", gradientUnits: "userSpaceOnUse" } }, [e("stop", { attrs: { "stop-color": "#F26723" } }), e("stop", { attrs: { offset: "0.3315", "stop-color": "#E35323" } }), e("stop", { attrs: { offset: "0.9971", "stop-color": "#C61621" } }), e("stop", { attrs: { offset: "1", "stop-color": "#C61521" } })], 1), e("clipPath", { attrs: { id: `${t.baseId}-clip0` } }, [e("rect", { attrs: { width: "90.5263", height: "40", fill: "white" } })])], 1)]);
}, cM = [], uM = /* @__PURE__ */ U(
  oM,
  lM,
  cM,
  !1,
  null,
  null
);
const dM = uM.exports, hM = {
  name: "AcvAuctionsSecondaryBlackSvg",
  extends: ne
};
var fM = function() {
  var t = this, e = t._self._c;
  return e("svg", { attrs: { viewBox: "0 0 91 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" } }, [e("title", [t._v("ACV Auctions")]), e("desc", [t._v("The stylized logo of ACV Auctions")]), e("path", { attrs: { d: "M16.4296 39.0993H14.4801L14.0448 39.8279H12.978L15.6087 35.6021H16.7732L17.5128 39.8279H16.5445L16.4296 39.0993ZM14.9077 38.3203H16.3534L16.056 36.3751L14.9077 38.3203Z", fill: "black" } }), e("path", { attrs: { d: "M18.0826 38.4281C18.0826 38.3459 18.1006 38.143 18.1332 37.9906L18.6653 35.6021H19.608L19.0758 37.9966C19.0441 38.1362 19.0312 38.2372 19.0312 38.3391C19.0398 38.7766 19.3423 39.1122 19.9379 39.1122C20.6114 39.1122 20.9302 38.7064 21.0587 38.1174L21.6226 35.6021H22.5652L22.0013 38.1362C21.7708 39.1627 21.231 39.9041 19.8899 39.9041C18.7108 39.9041 18.0861 39.3082 18.0826 38.4281Z", fill: "black" } }), e("path", { attrs: { d: "M25.411 35.5327C26.4779 35.5327 27.0948 36.0901 27.3536 36.7304L26.459 37.0215C26.2868 36.578 25.8737 36.3306 25.3699 36.3306C24.5455 36.3306 23.8488 37.0275 23.8531 37.953C23.8566 38.6122 24.3364 39.1062 25.0888 39.1062C25.4616 39.1062 25.8669 38.9161 26.1137 38.6182L26.8292 39.0874C26.3348 39.708 25.6098 39.9041 25.04 39.9041C23.836 39.9041 22.8908 39.1627 22.8848 38.0095C22.8762 36.5147 24.0562 35.5327 25.411 35.5327Z", fill: "black" } }), e("path", { attrs: { d: "M29.0794 36.394H27.8035L27.9826 35.6021H31.4634L31.2903 36.394H30.0143L29.2517 39.8279H28.3159L29.0794 36.394Z", fill: "black" } }), e("path", { attrs: { d: "M32.2886 35.6021H33.2175L32.2748 39.8279H31.3459L32.2886 35.6021Z", fill: "black" } }), e("path", { attrs: { d: "M36.0307 35.5327C37.2347 35.5327 38.1739 36.2673 38.179 37.4205C38.185 38.8014 37.0976 39.9041 35.658 39.9041C34.4472 39.9041 33.5088 39.1695 33.5028 38.0095C33.4968 36.6286 34.5911 35.5327 36.0307 35.5327ZM35.975 36.3306C35.131 36.3306 34.4669 37.0463 34.4711 37.953C34.4746 38.6687 35.0067 39.1062 35.7068 39.1062C36.544 39.1062 37.215 38.3905 37.2107 37.4838C37.2073 36.7741 36.6751 36.3306 35.975 36.3306Z", fill: "black" } }), e("path", { attrs: { d: "M40.0676 36.8315L39.4009 39.8279H38.472L39.4147 35.6021H40.3701L41.7446 38.4975L42.3924 35.6021H43.3213L42.3787 39.8279H41.4824L40.0676 36.8315Z", fill: "black" } }), e("path", { attrs: { d: "M43.8509 38.4662C44.1603 38.8591 44.731 39.1185 45.3325 39.1185C45.797 39.1185 45.9855 38.8583 45.9846 38.6305C45.9838 38.3771 45.6487 38.2444 45.2366 38.098C44.6273 37.8891 43.8672 37.61 43.8629 36.8566C43.8603 36.2171 44.4782 35.5391 45.5579 35.5391C46.2511 35.5391 46.9067 35.7865 47.2949 36.2231L46.7216 36.8506C46.4122 36.4894 45.875 36.3121 45.4431 36.3121C45.0832 36.3121 44.8355 36.521 44.8364 36.7556C44.8372 36.9833 45.1714 37.1101 45.5845 37.2565C46.1937 37.4722 46.9675 37.7573 46.971 38.4918C46.9744 39.2392 46.3428 39.9045 45.2631 39.9045C44.4062 39.9045 43.6521 39.5817 43.2836 39.1194L43.8509 38.4662Z", fill: "black" } }), e("path", { attrs: { d: "M47.4432 26.3727C44.0446 26.3727 41.635 23.5655 42.0609 20.1024C42.4868 16.6394 45.5879 13.8321 48.9865 13.8321C50.9437 13.8321 52.5718 14.7636 53.5204 16.2139L59.7313 9.83745C57.4562 7.06531 53.9909 5.33936 49.9179 5.33936C41.9752 5.33936 34.73 11.8999 33.7342 19.9937C32.7385 28.0867 38.3701 34.648 46.312 34.648C50.4021 34.648 54.3053 32.9067 57.2677 30.1131L51.7646 24.7538C50.5486 25.758 49.0293 26.3727 47.4432 26.3727Z", fill: "black" } }), e("path", { attrs: { d: "M79.365 0H90.5263L69.765 33.3633H58.6045L79.365 0Z", fill: "black" } }), e("path", { attrs: { d: "M32.6759 21.9512C32.6717 21.2731 32.7111 20.5848 32.7968 19.8888C32.9073 18.9881 33.0915 18.1003 33.3461 17.2314L32.1009 8.00488L24.9945 19.4282L25.567 23.6463H22.3552L18.6799 29.5682H26.3639L26.8746 33.3642L35.5218 33.3634L35.0616 29.9603C33.4814 27.659 32.6597 24.9006 32.6759 21.9512Z", fill: "black" } }), e("path", { attrs: { d: "M20.7605 6.63574H31.9218L11.1613 39.9999H0L20.7605 6.63574Z", fill: "black" } }), e("path", { attrs: { d: "M63.5909 6.63574H57.2429C58.6105 7.43108 59.8393 8.52778 60.979 9.8368L56.0449 14.8922L58.3714 32.1269L65.477 20.7096L63.5909 6.63574Z", fill: "black" } })]);
}, pM = [], gM = /* @__PURE__ */ U(
  hM,
  fM,
  pM,
  !1,
  null,
  null
);
const mM = gM.exports, vM = {
  name: "AcvAuctionsSecondaryGraySvg",
  extends: ne
};
var AM = function() {
  var t = this, e = t._self._c;
  return e("svg", { attrs: { viewBox: "0 0 91 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" } }, [e("title", [t._v("ACV Auctions")]), e("desc", [t._v("The stylized logo of ACV Auctions")]), e("path", { attrs: { d: "M16.4296 39.0993H14.4801L14.0448 39.8279H12.978L15.6087 35.6021H16.7732L17.5128 39.8279H16.5445L16.4296 39.0993ZM14.9077 38.3203H16.3534L16.056 36.3751L14.9077 38.3203Z", fill: "#AAAAAA" } }), e("path", { attrs: { d: "M18.0826 38.4281C18.0826 38.3459 18.1006 38.143 18.1332 37.9906L18.6653 35.6021H19.608L19.0758 37.9966C19.0441 38.1362 19.0312 38.2372 19.0312 38.3391C19.0398 38.7766 19.3423 39.1122 19.9379 39.1122C20.6114 39.1122 20.9302 38.7064 21.0587 38.1174L21.6226 35.6021H22.5652L22.0013 38.1362C21.7708 39.1627 21.231 39.9041 19.8899 39.9041C18.7108 39.9041 18.0861 39.3082 18.0826 38.4281Z", fill: "#AAAAAA" } }), e("path", { attrs: { d: "M25.411 35.5327C26.4779 35.5327 27.0948 36.0901 27.3536 36.7304L26.459 37.0215C26.2868 36.578 25.8737 36.3306 25.3699 36.3306C24.5455 36.3306 23.8488 37.0275 23.8531 37.953C23.8566 38.6122 24.3364 39.1062 25.0888 39.1062C25.4616 39.1062 25.8669 38.9161 26.1137 38.6182L26.8292 39.0874C26.3348 39.708 25.6098 39.9041 25.04 39.9041C23.836 39.9041 22.8908 39.1627 22.8848 38.0095C22.8762 36.5147 24.0562 35.5327 25.411 35.5327Z", fill: "#AAAAAA" } }), e("path", { attrs: { d: "M29.0794 36.394H27.8035L27.9826 35.6021H31.4634L31.2903 36.394H30.0143L29.2517 39.8279H28.3159L29.0794 36.394Z", fill: "#AAAAAA" } }), e("path", { attrs: { d: "M32.2886 35.6021H33.2175L32.2748 39.8279H31.3459L32.2886 35.6021Z", fill: "#AAAAAA" } }), e("path", { attrs: { d: "M36.0307 35.5327C37.2347 35.5327 38.1739 36.2673 38.179 37.4205C38.185 38.8014 37.0976 39.9041 35.658 39.9041C34.4472 39.9041 33.5088 39.1695 33.5028 38.0095C33.4968 36.6286 34.5911 35.5327 36.0307 35.5327ZM35.975 36.3306C35.131 36.3306 34.4669 37.0463 34.4711 37.953C34.4746 38.6687 35.0067 39.1062 35.7068 39.1062C36.544 39.1062 37.215 38.3905 37.2107 37.4838C37.2073 36.7741 36.6751 36.3306 35.975 36.3306Z", fill: "#AAAAAA" } }), e("path", { attrs: { d: "M40.0676 36.8315L39.4009 39.8279H38.472L39.4147 35.6021H40.3701L41.7446 38.4975L42.3924 35.6021H43.3213L42.3787 39.8279H41.4824L40.0676 36.8315Z", fill: "#AAAAAA" } }), e("path", { attrs: { d: "M43.8509 38.4659C44.1603 38.8589 44.731 39.1183 45.3325 39.1183C45.797 39.1183 45.9855 38.858 45.9846 38.6303C45.9838 38.3769 45.6487 38.2442 45.2366 38.0978C44.6273 37.8889 43.8672 37.6098 43.8629 36.8564C43.8603 36.2169 44.4782 35.5388 45.5579 35.5388C46.2511 35.5388 46.9067 35.7862 47.2949 36.2229L46.7216 36.8504C46.4122 36.4891 45.875 36.3119 45.4431 36.3119C45.0832 36.3119 44.8355 36.5208 44.8364 36.7554C44.8372 36.9831 45.1714 37.1098 45.5845 37.2562C46.1937 37.472 46.9675 37.757 46.971 38.4916C46.9744 39.239 46.3428 39.9042 45.2631 39.9042C44.4062 39.9042 43.6521 39.5814 43.2836 39.1191L43.8509 38.4659Z", fill: "#AAAAAA" } }), e("path", { attrs: { d: "M47.4432 26.3727C44.0446 26.3727 41.635 23.5655 42.0609 20.1024C42.4868 16.6394 45.5879 13.8321 48.9865 13.8321C50.9437 13.8321 52.5718 14.7636 53.5204 16.2139L59.7313 9.83745C57.4562 7.06531 53.9909 5.33936 49.9179 5.33936C41.9752 5.33936 34.73 11.8999 33.7342 19.9937C32.7385 28.0867 38.3701 34.648 46.312 34.648C50.4021 34.648 54.3053 32.9067 57.2677 30.1131L51.7646 24.7538C50.5486 25.758 49.0293 26.3727 47.4432 26.3727Z", fill: "#AAAAAA" } }), e("path", { attrs: { d: "M79.365 0H90.5263L69.765 33.3633H58.6045L79.365 0Z", fill: "#AAAAAA" } }), e("path", { attrs: { d: "M32.6759 21.9512C32.6717 21.2731 32.7111 20.5848 32.7968 19.8888C32.9073 18.9881 33.0915 18.1003 33.3461 17.2314L32.1009 8.00488L24.9945 19.4282L25.567 23.6463H22.3552L18.6799 29.5682H26.3639L26.8746 33.3642L35.5218 33.3634L35.0616 29.9603C33.4814 27.659 32.6597 24.9006 32.6759 21.9512Z", fill: "#AAAAAA" } }), e("path", { attrs: { d: "M20.7605 6.63574H31.9218L11.1613 39.9999H0L20.7605 6.63574Z", fill: "#AAAAAA" } }), e("path", { attrs: { d: "M63.5909 6.63574H57.2428C58.6105 7.43108 59.8393 8.52778 60.979 9.8368L56.0449 14.8922L58.3714 32.1269L65.4769 20.7096L63.5909 6.63574Z", fill: "#AAAAAA" } })]);
}, bM = [], yM = /* @__PURE__ */ U(
  vM,
  AM,
  bM,
  !1,
  null,
  null
);
const _M = yM.exports, xM = {
  name: "AcvAuctionsSecondaryWhiteSvg",
  extends: ne
};
var CM = function() {
  var t = this, e = t._self._c;
  return e("svg", { attrs: { viewBox: "0 0 91 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" } }, [e("title", [t._v("ACV Auctions")]), e("desc", [t._v("The stylized logo of ACV Auctions")]), e("path", { attrs: { d: "M16.4296 39.0993H14.4801L14.0448 39.8279H12.978L15.6087 35.6021H16.7732L17.5128 39.8279H16.5445L16.4296 39.0993ZM14.9077 38.3203H16.3534L16.056 36.3751L14.9077 38.3203Z", fill: "white" } }), e("path", { attrs: { d: "M18.0826 38.4281C18.0826 38.3459 18.1006 38.143 18.1332 37.9906L18.6653 35.6021H19.608L19.0758 37.9966C19.0441 38.1362 19.0312 38.2372 19.0312 38.3391C19.0398 38.7766 19.3423 39.1122 19.9379 39.1122C20.6114 39.1122 20.9302 38.7064 21.0587 38.1174L21.6226 35.6021H22.5652L22.0013 38.1362C21.7708 39.1627 21.231 39.9041 19.8899 39.9041C18.7108 39.9041 18.0861 39.3082 18.0826 38.4281Z", fill: "white" } }), e("path", { attrs: { d: "M25.411 35.5327C26.4779 35.5327 27.0948 36.0901 27.3536 36.7304L26.459 37.0215C26.2868 36.578 25.8737 36.3306 25.3699 36.3306C24.5455 36.3306 23.8488 37.0275 23.8531 37.953C23.8566 38.6122 24.3364 39.1062 25.0888 39.1062C25.4616 39.1062 25.8669 38.9161 26.1137 38.6182L26.8292 39.0874C26.3348 39.708 25.6098 39.9041 25.04 39.9041C23.836 39.9041 22.8908 39.1627 22.8848 38.0095C22.8762 36.5147 24.0562 35.5327 25.411 35.5327Z", fill: "white" } }), e("path", { attrs: { d: "M29.0794 36.394H27.8035L27.9826 35.6021H31.4634L31.2903 36.394H30.0143L29.2517 39.8279H28.3159L29.0794 36.394Z", fill: "white" } }), e("path", { attrs: { d: "M32.2886 35.6021H33.2175L32.2748 39.8279H31.3459L32.2886 35.6021Z", fill: "white" } }), e("path", { attrs: { d: "M36.0307 35.5327C37.2347 35.5327 38.1739 36.2673 38.179 37.4205C38.185 38.8014 37.0976 39.9041 35.658 39.9041C34.4472 39.9041 33.5088 39.1695 33.5028 38.0095C33.4968 36.6286 34.5911 35.5327 36.0307 35.5327ZM35.975 36.3306C35.131 36.3306 34.4669 37.0463 34.4711 37.953C34.4746 38.6687 35.0067 39.1062 35.7068 39.1062C36.544 39.1062 37.215 38.3905 37.2107 37.4838C37.2073 36.7741 36.6751 36.3306 35.975 36.3306Z", fill: "white" } }), e("path", { attrs: { d: "M40.0676 36.8315L39.4009 39.8279H38.472L39.4147 35.6021H40.3701L41.7446 38.4975L42.3924 35.6021H43.3213L42.3787 39.8279H41.4824L40.0676 36.8315Z", fill: "white" } }), e("path", { attrs: { d: "M43.8509 38.4662C44.1603 38.8591 44.731 39.1185 45.3325 39.1185C45.797 39.1185 45.9855 38.8583 45.9846 38.6305C45.9838 38.3771 45.6487 38.2444 45.2366 38.098C44.6273 37.8891 43.8672 37.61 43.8629 36.8566C43.8603 36.2171 44.4782 35.5391 45.5579 35.5391C46.2511 35.5391 46.9067 35.7865 47.2949 36.2231L46.7216 36.8506C46.4122 36.4894 45.875 36.3121 45.4431 36.3121C45.0832 36.3121 44.8355 36.521 44.8364 36.7556C44.8372 36.9833 45.1714 37.1101 45.5845 37.2565C46.1937 37.4722 46.9675 37.7573 46.971 38.4918C46.9744 39.2392 46.3428 39.9045 45.2631 39.9045C44.4062 39.9045 43.6521 39.5817 43.2836 39.1194L43.8509 38.4662Z", fill: "white" } }), e("path", { attrs: { d: "M47.4432 26.3727C44.0446 26.3727 41.635 23.5655 42.0609 20.1024C42.4868 16.6394 45.5879 13.8321 48.9865 13.8321C50.9437 13.8321 52.5718 14.7636 53.5204 16.2139L59.7313 9.83745C57.4562 7.06531 53.9909 5.33936 49.9179 5.33936C41.9752 5.33936 34.73 11.8999 33.7342 19.9937C32.7385 28.0867 38.3701 34.648 46.312 34.648C50.4021 34.648 54.3053 32.9067 57.2677 30.1131L51.7646 24.7538C50.5486 25.758 49.0293 26.3727 47.4432 26.3727Z", fill: "white" } }), e("path", { attrs: { d: "M79.365 0H90.5263L69.765 33.3633H58.6045L79.365 0Z", fill: "white" } }), e("path", { attrs: { d: "M32.6759 21.9512C32.6717 21.2731 32.7111 20.5848 32.7968 19.8888C32.9073 18.9881 33.0915 18.1003 33.3461 17.2314L32.1009 8.00488L24.9945 19.4282L25.567 23.6463H22.3552L18.6799 29.5682H26.3639L26.8746 33.3642L35.5218 33.3634L35.0616 29.9603C33.4814 27.659 32.6597 24.9006 32.6759 21.9512Z", fill: "white" } }), e("path", { attrs: { d: "M20.7605 6.63574H31.9218L11.1613 39.9999H0L20.7605 6.63574Z", fill: "white" } }), e("path", { attrs: { d: "M63.5909 6.63574H57.2428C58.6105 7.43108 59.8393 8.52778 60.979 9.8368L56.0449 14.8922L58.3714 32.1269L65.4769 20.7096L63.5909 6.63574Z", fill: "white" } })]);
}, SM = [], wM = /* @__PURE__ */ U(
  xM,
  CM,
  SM,
  !1,
  null,
  null
);
const kM = wM.exports, OM = {
  name: "AcvCapitalPrimaryDarkSvg",
  extends: ne
};
var MM = function() {
  var t = this, e = t._self._c;
  return e("svg", { attrs: { viewBox: "0 0 91 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" } }, [e("title", [t._v("ACV Capital")]), e("desc", [t._v("The stylized logo of ACV Capital")]), e("g", { attrs: { "clip-path": `url(#${t.baseId}-clip0)` } }, [e("path", { attrs: { d: "M16.5481 35.5098C17.614 35.5098 18.2304 36.0671 18.4889 36.7075L17.5951 36.9986C17.423 36.5551 17.0104 36.3077 16.507 36.3077C15.6834 36.3077 14.9874 37.0046 14.9916 37.93C14.9951 38.5893 15.4745 39.0832 16.2262 39.0832C16.5986 39.0832 17.0035 38.8932 17.2501 38.5952L17.965 39.0644C17.471 39.6851 16.7467 39.8811 16.1774 39.8811C14.9745 39.8811 14.0302 39.1397 14.0242 37.9865C14.0165 36.4917 15.1945 35.5098 16.5481 35.5098Z", fill: "white" } }), e("path", { attrs: { d: "M21.4288 39.0774H19.4811L19.0462 39.8059H17.9803L20.6087 35.5801H21.7721L22.511 39.8059H21.5436L21.4288 39.0774ZM19.9083 38.2983H21.3526L21.0556 36.3532L19.9083 38.2983Z", fill: "white" } }), e("path", { attrs: { d: "M23.9878 35.5801H25.8704C26.7068 35.5801 27.1999 36.1126 27.2025 36.7521C27.2051 37.3797 26.7719 38.3111 25.4055 38.3111H24.3071L23.9741 39.8059H23.0469L23.9878 35.5801ZM26.2299 36.8403C26.2282 36.5612 26.0116 36.3523 25.6786 36.3523H24.7437L24.4877 37.5184H25.4483C25.9449 37.5184 26.2317 37.2204 26.2299 36.8403Z", fill: "white" } }), e("path", { attrs: { d: "M28.1983 35.5801H29.1264L28.1846 39.8059H27.2566L28.1983 35.5801Z", fill: "white" } }), e("path", { attrs: { d: "M30.9473 36.372H29.6733L29.8523 35.5801H33.3299L33.1569 36.372H31.8821L31.1202 39.8059H30.1853L30.9473 36.372Z", fill: "white" } }), e("path", { attrs: { d: "M36.0986 39.0774H34.1509L33.716 39.8059H32.6501L35.2785 35.5801H36.4419L37.1808 39.8059H36.2133L36.0986 39.0774ZM34.5781 38.2983H36.0224L35.7254 36.3532L34.5781 38.2983Z", fill: "white" } }), e("path", { attrs: { d: "M38.6584 35.5801H39.5865L38.8245 39.014H40.6618L40.4888 39.8059H37.7167L38.6584 35.5801Z", fill: "white" } }), e("path", { attrs: { d: "M47.3996 26.3732C44.0042 26.3732 41.5967 23.5659 42.0222 20.1029C42.4477 16.6399 45.546 13.8326 48.9414 13.8326C50.8968 13.8326 52.5235 14.7641 53.4712 16.2144L59.6764 9.83794C57.4034 7.0658 53.9412 5.33984 49.8721 5.33984C41.9366 5.33984 34.6981 11.9003 33.7032 19.9942C32.7084 28.0872 38.3349 34.6485 46.2695 34.6485C50.3558 34.6485 54.2554 32.9072 57.2151 30.1136L51.717 24.7543C50.5022 25.7585 48.9843 26.3732 47.3996 26.3732Z", fill: `url(#${t.baseId}-paint0_linear)` } }), e("path", { attrs: { d: "M79.2919 0H90.443L69.7007 33.3633H58.5505L79.2919 0Z", fill: `url(#${t.baseId}-paint1_linear)` } }), e("path", { attrs: { d: "M32.6459 21.9512C32.6416 21.2732 32.681 20.5848 32.7666 19.8888C32.877 18.9881 33.0611 18.1003 33.3153 17.2314L32.0714 8.00488L24.9715 19.4282L25.5434 23.6463H22.3347L18.6627 29.5682H26.3396L26.8499 33.3642L35.4891 33.3634L35.0293 29.9603C33.4506 27.659 32.6296 24.9006 32.6459 21.9512Z", fill: `url(#${t.baseId}-paint2_linear)` } }), e("path", { attrs: { d: "M20.7414 6.63623H31.8925L11.1511 40.0004H0L20.7414 6.63623Z", fill: `url(#${t.baseId}-paint3_linear)` } }), e("path", { attrs: { d: "M63.5323 6.63623H57.1902C58.5565 7.43157 59.7842 8.52827 60.9229 9.83729L55.9933 14.8927L58.3177 32.1274L65.4167 20.7101L63.5323 6.63623Z", fill: `url(#${t.baseId}-paint4_linear)` } })]), e("defs", [e("linearGradient", { attrs: { id: `${t.baseId}-paint0_linear`, x1: "49.7696", y1: "34.2549", x2: "44.7895", y2: "6.01125", gradientUnits: "userSpaceOnUse" } }, [e("stop", { attrs: { "stop-color": "#F26723" } }), e("stop", { attrs: { offset: "0.3315", "stop-color": "#E35323" } }), e("stop", { attrs: { offset: "0.9971", "stop-color": "#C61621" } }), e("stop", { attrs: { offset: "1", "stop-color": "#C61521" } })], 1), e("linearGradient", { attrs: { id: `${t.baseId}-paint1_linear`, x1: "74.4966", y1: "33.3636", x2: "74.4966", y2: "0", gradientUnits: "userSpaceOnUse" } }, [e("stop", { attrs: { "stop-color": "#F26723" } }), e("stop", { attrs: { offset: "0.3315", "stop-color": "#E35323" } }), e("stop", { attrs: { offset: "0.9971", "stop-color": "#C61621" } }), e("stop", { attrs: { offset: "1", "stop-color": "#C61521" } })], 1), e("linearGradient", { attrs: { id: `${t.baseId}-paint2_linear`, x1: "25.7949", y1: "33.6855", x2: "38.484", y2: "11.7073", gradientUnits: "userSpaceOnUse" } }, [e("stop", { attrs: { "stop-color": "#F26723" } }), e("stop", { attrs: { offset: "0.3315", "stop-color": "#E35323" } }), e("stop", { attrs: { offset: "0.9971", "stop-color": "#C61621" } }), e("stop", { attrs: { offset: "1", "stop-color": "#C61521" } })], 1), e("linearGradient", { attrs: { id: `${t.baseId}-paint3_linear`, x1: "15.9464", y1: "40.0001", x2: "15.9464", y2: "6.63649", gradientUnits: "userSpaceOnUse" } }, [e("stop", { attrs: { "stop-color": "#F26723" } }), e("stop", { attrs: { offset: "0.3315", "stop-color": "#E35323" } }), e("stop", { attrs: { offset: "0.9971", "stop-color": "#C61621" } }), e("stop", { attrs: { offset: "1", "stop-color": "#C61521" } })], 1), e("linearGradient", { attrs: { id: `${t.baseId}-paint4_linear`, x1: "52.566", y1: "28.8073", x2: "64.9078", y2: "7.43073", gradientUnits: "userSpaceOnUse" } }, [e("stop", { attrs: { "stop-color": "#F26723" } }), e("stop", { attrs: { offset: "0.3315", "stop-color": "#E35323" } }), e("stop", { attrs: { offset: "0.9971", "stop-color": "#C61621" } }), e("stop", { attrs: { offset: "1", "stop-color": "#C61521" } })], 1), e("clipPath", { attrs: { id: `${t.baseId}-clip0` } }, [e("rect", { attrs: { width: "90.443", height: "40", fill: "white" } })])], 1)]);
}, TM = [], DM = /* @__PURE__ */ U(
  OM,
  MM,
  TM,
  !1,
  null,
  null
);
const PM = DM.exports, LM = {
  name: "AcvCapitalPrimaryLightSvg",
  extends: ne
};
var IM = function() {
  var t = this, e = t._self._c;
  return e("svg", { attrs: { viewBox: "0 0 91 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" } }, [e("title", [t._v("ACV Capital")]), e("desc", [t._v("The stylized logo of ACV Capital")]), e("g", { attrs: { "clip-path": `url(#${t.baseId}-clip0)` } }, [e("path", { attrs: { d: "M16.5481 35.5098C17.614 35.5098 18.2304 36.0671 18.4889 36.7075L17.5951 36.9986C17.423 36.5551 17.0104 36.3077 16.507 36.3077C15.6834 36.3077 14.9874 37.0046 14.9916 37.93C14.9951 38.5893 15.4745 39.0832 16.2262 39.0832C16.5986 39.0832 17.0035 38.8932 17.2501 38.5952L17.965 39.0644C17.471 39.6851 16.7467 39.8811 16.1774 39.8811C14.9745 39.8811 14.0302 39.1397 14.0242 37.9865C14.0165 36.4917 15.1945 35.5098 16.5481 35.5098Z", fill: "black" } }), e("path", { attrs: { d: "M21.4288 39.0774H19.4811L19.0462 39.8059H17.9803L20.6087 35.5801H21.7721L22.511 39.8059H21.5436L21.4288 39.0774ZM19.9083 38.2983H21.3526L21.0556 36.3532L19.9083 38.2983Z", fill: "black" } }), e("path", { attrs: { d: "M23.9878 35.5801H25.8704C26.7068 35.5801 27.1999 36.1126 27.2025 36.7521C27.2051 37.3797 26.7719 38.3111 25.4055 38.3111H24.3071L23.9741 39.8059H23.0469L23.9878 35.5801ZM26.2299 36.8403C26.2282 36.5612 26.0116 36.3523 25.6786 36.3523H24.7437L24.4877 37.5184H25.4483C25.9449 37.5184 26.2317 37.2204 26.2299 36.8403Z", fill: "black" } }), e("path", { attrs: { d: "M28.1983 35.5801H29.1264L28.1846 39.8059H27.2566L28.1983 35.5801Z", fill: "black" } }), e("path", { attrs: { d: "M30.9473 36.372H29.6733L29.8523 35.5801H33.3299L33.1569 36.372H31.8821L31.1202 39.8059H30.1853L30.9473 36.372Z", fill: "black" } }), e("path", { attrs: { d: "M36.0986 39.0774H34.1509L33.716 39.8059H32.6501L35.2785 35.5801H36.4419L37.1808 39.8059H36.2133L36.0986 39.0774ZM34.5781 38.2983H36.0224L35.7254 36.3532L34.5781 38.2983Z", fill: "black" } }), e("path", { attrs: { d: "M38.6584 35.5801H39.5865L38.8245 39.014H40.6618L40.4888 39.8059H37.7167L38.6584 35.5801Z", fill: "black" } }), e("path", { attrs: { d: "M47.3996 26.3732C44.0042 26.3732 41.5967 23.5659 42.0222 20.1029C42.4477 16.6399 45.546 13.8326 48.9414 13.8326C50.8968 13.8326 52.5235 14.7641 53.4712 16.2144L59.6764 9.83794C57.4034 7.0658 53.9412 5.33984 49.8721 5.33984C41.9366 5.33984 34.6981 11.9003 33.7032 19.9942C32.7084 28.0872 38.3349 34.6485 46.2695 34.6485C50.3558 34.6485 54.2554 32.9072 57.2151 30.1136L51.717 24.7543C50.5022 25.7585 48.9843 26.3732 47.3996 26.3732Z", fill: `url(#${t.baseId}-paint0_linear)` } }), e("path", { attrs: { d: "M79.2919 0H90.443L69.7007 33.3633H58.5505L79.2919 0Z", fill: `url(#${t.baseId}-paint1_linear)` } }), e("path", { attrs: { d: "M32.6459 21.9512C32.6416 21.2732 32.681 20.5848 32.7666 19.8888C32.877 18.9881 33.0611 18.1003 33.3153 17.2314L32.0714 8.00488L24.9715 19.4282L25.5434 23.6463H22.3347L18.6627 29.5682H26.3396L26.8499 33.3642L35.4891 33.3634L35.0293 29.9603C33.4506 27.659 32.6296 24.9006 32.6459 21.9512Z", fill: `url(#${t.baseId}-paint2_linear)` } }), e("path", { attrs: { d: "M20.7414 6.63623H31.8925L11.1511 40.0004H0L20.7414 6.63623Z", fill: `url(#${t.baseId}-paint3_linear)` } }), e("path", { attrs: { d: "M63.5323 6.63623H57.1902C58.5565 7.43157 59.7842 8.52827 60.9229 9.83729L55.9933 14.8927L58.3177 32.1274L65.4167 20.7101L63.5323 6.63623Z", fill: `url(#${t.baseId}-paint4_linear)` } })]), e("defs", [e("linearGradient", { attrs: { id: `${t.baseId}-paint0_linear`, x1: "49.7696", y1: "34.2549", x2: "44.7895", y2: "6.01125", gradientUnits: "userSpaceOnUse" } }, [e("stop", { attrs: { "stop-color": "#F26723" } }), e("stop", { attrs: { offset: "0.3315", "stop-color": "#E35323" } }), e("stop", { attrs: { offset: "0.9971", "stop-color": "#C61621" } }), e("stop", { attrs: { offset: "1", "stop-color": "#C61521" } })], 1), e("linearGradient", { attrs: { id: `${t.baseId}-paint1_linear`, x1: "74.4966", y1: "33.3636", x2: "74.4966", y2: "0", gradientUnits: "userSpaceOnUse" } }, [e("stop", { attrs: { "stop-color": "#F26723" } }), e("stop", { attrs: { offset: "0.3315", "stop-color": "#E35323" } }), e("stop", { attrs: { offset: "0.9971", "stop-color": "#C61621" } }), e("stop", { attrs: { offset: "1", "stop-color": "#C61521" } })], 1), e("linearGradient", { attrs: { id: `${t.baseId}-paint2_linear`, x1: "25.7949", y1: "33.6855", x2: "38.484", y2: "11.7073", gradientUnits: "userSpaceOnUse" } }, [e("stop", { attrs: { "stop-color": "#F26723" } }), e("stop", { attrs: { offset: "0.3315", "stop-color": "#E35323" } }), e("stop", { attrs: { offset: "0.9971", "stop-color": "#C61621" } }), e("stop", { attrs: { offset: "1", "stop-color": "#C61521" } })], 1), e("linearGradient", { attrs: { id: `${t.baseId}-paint3_linear`, x1: "15.9464", y1: "40.0001", x2: "15.9464", y2: "6.63649", gradientUnits: "userSpaceOnUse" } }, [e("stop", { attrs: { "stop-color": "#F26723" } }), e("stop", { attrs: { offset: "0.3315", "stop-color": "#E35323" } }), e("stop", { attrs: { offset: "0.9971", "stop-color": "#C61621" } }), e("stop", { attrs: { offset: "1", "stop-color": "#C61521" } })], 1), e("linearGradient", { attrs: { id: `${t.baseId}-paint4_linear`, x1: "52.566", y1: "28.8073", x2: "64.9078", y2: "7.43073", gradientUnits: "userSpaceOnUse" } }, [e("stop", { attrs: { "stop-color": "#F26723" } }), e("stop", { attrs: { offset: "0.3315", "stop-color": "#E35323" } }), e("stop", { attrs: { offset: "0.9971", "stop-color": "#C61621" } }), e("stop", { attrs: { offset: "1", "stop-color": "#C61521" } })], 1), e("clipPath", { attrs: { id: `${t.baseId}-clip0` } }, [e("rect", { attrs: { width: "90.443", height: "40", fill: "white" } })])], 1)]);
}, EM = [], $M = /* @__PURE__ */ U(
  LM,
  IM,
  EM,
  !1,
  null,
  null
);
const BM = $M.exports, RM = {
  name: "AcvCapitalSecondaryDarkSvg",
  extends: ne
};
var FM = function() {
  var t = this, e = t._self._c;
  return e("svg", { attrs: { viewBox: "0 0 91 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" } }, [e("title", [t._v("ACV Capital")]), e("desc", [t._v("The stylized logo of ACV Capital")]), e("g", { attrs: { "clip-path": `url(#${t.baseId}-clip0)` } }, [e("path", { attrs: { d: "M16.5481 35.5098C17.614 35.5098 18.2304 36.0671 18.4889 36.7075L17.5951 36.9986C17.423 36.5551 17.0104 36.3077 16.507 36.3077C15.6834 36.3077 14.9874 37.0046 14.9916 37.93C14.9951 38.5893 15.4745 39.0832 16.2262 39.0832C16.5986 39.0832 17.0035 38.8932 17.2501 38.5952L17.965 39.0644C17.471 39.6851 16.7467 39.8811 16.1774 39.8811C14.9745 39.8811 14.0302 39.1397 14.0242 37.9865C14.0165 36.4917 15.1945 35.5098 16.5481 35.5098Z", fill: "white" } }), e("path", { attrs: { d: "M21.4288 39.0774H19.4811L19.0462 39.8059H17.9803L20.6087 35.5801H21.7721L22.511 39.8059H21.5436L21.4288 39.0774ZM19.9083 38.2983H21.3526L21.0556 36.3532L19.9083 38.2983Z", fill: "white" } }), e("path", { attrs: { d: "M23.9878 35.5801H25.8704C26.7068 35.5801 27.1999 36.1126 27.2025 36.7521C27.2051 37.3797 26.7719 38.3111 25.4055 38.3111H24.3071L23.9741 39.8059H23.0469L23.9878 35.5801ZM26.2299 36.8403C26.2282 36.5612 26.0116 36.3523 25.6786 36.3523H24.7437L24.4877 37.5184H25.4483C25.9449 37.5184 26.2317 37.2204 26.2299 36.8403Z", fill: "white" } }), e("path", { attrs: { d: "M28.1983 35.5801H29.1264L28.1846 39.8059H27.2566L28.1983 35.5801Z", fill: "white" } }), e("path", { attrs: { d: "M30.9473 36.372H29.6733L29.8523 35.5801H33.3299L33.1569 36.372H31.8821L31.1202 39.8059H30.1853L30.9473 36.372Z", fill: "white" } }), e("path", { attrs: { d: "M36.0986 39.0774H34.1509L33.716 39.8059H32.6501L35.2785 35.5801H36.4419L37.1808 39.8059H36.2133L36.0986 39.0774ZM34.5781 38.2983H36.0224L35.7254 36.3532L34.5781 38.2983Z", fill: "white" } }), e("path", { attrs: { d: "M38.6584 35.5801H39.5865L38.8245 39.014H40.6618L40.4888 39.8059H37.7167L38.6584 35.5801Z", fill: "white" } }), e("path", { attrs: { d: "M47.3996 26.3732C44.0042 26.3732 41.5967 23.5659 42.0222 20.1029C42.4477 16.6399 45.546 13.8326 48.9414 13.8326C50.8968 13.8326 52.5235 14.7641 53.4712 16.2144L59.6764 9.83794C57.4034 7.0658 53.9412 5.33984 49.8721 5.33984C41.9366 5.33984 34.6981 11.9003 33.7032 19.9942C32.7084 28.0872 38.3349 34.6485 46.2695 34.6485C50.3558 34.6485 54.2554 32.9072 57.2151 30.1136L51.717 24.7543C50.5022 25.7585 48.9843 26.3732 47.3996 26.3732Z", fill: "white" } }), e("path", { attrs: { d: "M79.2919 0H90.443L69.7007 33.3633H58.5505L79.2919 0Z", fill: "white" } }), e("path", { attrs: { d: "M32.6459 21.9512C32.6416 21.2732 32.681 20.5848 32.7666 19.8888C32.877 18.9881 33.0611 18.1003 33.3153 17.2314L32.0714 8.00488L24.9715 19.4282L25.5434 23.6463H22.3347L18.6627 29.5682H26.3396L26.8499 33.3642L35.4891 33.3634L35.0293 29.9603C33.4506 27.659 32.6296 24.9006 32.6459 21.9512Z", fill: "white" } }), e("path", { attrs: { d: "M20.7414 6.63623H31.8925L11.1511 40.0004H0L20.7414 6.63623Z", fill: "white" } }), e("path", { attrs: { d: "M63.5323 6.63623H57.1902C58.5565 7.43157 59.7842 8.52827 60.9229 9.83729L55.9933 14.8927L58.3177 32.1274L65.4167 20.7101L63.5323 6.63623Z", fill: "white" } })])]);
}, NM = [], HM = /* @__PURE__ */ U(
  RM,
  FM,
  NM,
  !1,
  null,
  null
);
const VM = HM.exports, zM = {
  name: "AcvTransportationPrimaryDarkSvg",
  extends: ne
};
var jM = function() {
  var t = this, e = t._self._c;
  return e("svg", { attrs: { viewBox: "0 0 91 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" } }, [e("title", [t._v("ACV Transportation")]), e("desc", [t._v("The stylized logo of ACV Transportation")]), e("g", { attrs: { "clip-path": `url(#${t.baseId}-clip0)` } }, [e("path", { attrs: { d: "M15.7844 36.4292H14.5875L14.7562 35.6621H18.0215L17.8596 36.4292H16.6628L15.9479 39.7561H15.0704L15.7844 36.4292Z", fill: "white" } }), e("path", { attrs: { d: "M19.5933 38.2892H18.9118L18.5993 39.7566H17.7278L18.6113 35.6626H20.3612C21.0239 35.6626 21.6274 36.1044 21.6309 36.8167C21.6343 37.5598 21.1335 38.118 20.4708 38.2404L21.0427 39.7566H20.0787L19.5933 38.2892ZM20.7165 36.9014C20.7148 36.6129 20.4751 36.41 20.1926 36.41H19.321L19.0805 37.5392H19.9888C20.4494 37.5401 20.7182 37.2695 20.7165 36.9014Z", fill: "white" } }), e("path", { attrs: { d: "M24.6607 39.0503H22.8312L22.4228 39.7566H21.422L23.8894 35.6626H24.9818L25.6761 39.7566H24.7677L24.6607 39.0503ZM23.2327 38.2952H24.5897L24.3106 36.4109L23.2327 38.2952Z", fill: "white" } }), e("path", { attrs: { d: "M27.6152 36.8526L26.9902 39.7566H26.1187L27.0022 35.6626H27.8985L29.1887 38.4681L29.7957 35.6626H30.6673L29.7837 39.7566H28.943L27.6152 36.8526Z", fill: "white" } }), e("path", { attrs: { d: "M31.0414 38.4367C31.3316 38.8177 31.8667 39.0694 32.4318 39.0694C32.8675 39.0694 33.0448 38.8177 33.043 38.5968C33.0422 38.3511 32.728 38.2227 32.341 38.0814C31.7691 37.8785 31.056 37.6088 31.0526 36.8785C31.05 36.2587 31.6296 35.6021 32.6424 35.6021C33.293 35.6021 33.9077 35.8418 34.2724 36.2647L33.7348 36.8725C33.4446 36.5224 32.9403 36.3512 32.5354 36.3512C32.198 36.3512 31.9652 36.5541 31.966 36.7809C31.9669 37.0018 32.2811 37.1251 32.6681 37.2664C33.24 37.4753 33.966 37.7509 33.9685 38.4632C33.9719 39.1875 33.3795 39.8322 32.3667 39.8322C31.5628 39.8322 30.8548 39.5188 30.5098 39.0711L31.0414 38.4367Z", fill: "white" } }), e("path", { attrs: { d: "M35.2211 35.6621H36.989C37.7749 35.6621 38.2372 36.1775 38.2406 36.7973C38.2432 37.4052 37.8365 38.3075 36.5532 38.3075H35.5216L35.2091 39.7561H34.3375L35.2211 35.6621ZM37.3263 36.8838C37.3254 36.6133 37.1217 36.4112 36.8083 36.4112H35.9308L35.6902 37.5405H36.5926C37.0592 37.5405 37.328 37.2519 37.3263 36.8838Z", fill: "white" } }), e("path", { attrs: { d: "M40.8501 35.5942C41.9794 35.5942 42.8603 36.3065 42.8655 37.4238C42.8715 38.7619 41.8518 39.8304 40.5008 39.8304C39.3656 39.8304 38.4838 39.1181 38.4787 37.9948C38.4735 36.6558 39.4992 35.5942 40.8501 35.5942ZM40.7988 36.3673C40.0068 36.3673 39.3836 37.0608 39.3879 37.9392C39.3913 38.6326 39.8904 39.0564 40.5471 39.0564C41.333 39.0564 41.9622 38.363 41.958 37.4846C41.9545 36.7971 41.4554 36.3673 40.7988 36.3673Z", fill: "white" } }), e("path", { attrs: { d: "M44.8217 38.2892H44.1402L43.8277 39.7566H42.9562L43.8397 35.6626H45.5896C46.2523 35.6626 46.8558 36.1044 46.8593 36.8167C46.8627 37.5598 46.3618 38.118 45.6992 38.2404L46.2711 39.7566H45.3071L44.8217 38.2892ZM45.9449 36.9014C45.9432 36.6129 45.7035 36.41 45.421 36.41H44.5494L44.3089 37.5392H45.2172C45.6778 37.5401 45.9466 37.2695 45.9449 36.9014Z", fill: "white" } }), e("path", { attrs: { d: "M48.4714 36.4292H47.2745L47.4432 35.6621H50.7085L50.5466 36.4292H49.3498L48.6349 39.7561H47.7574L48.4714 36.4292Z", fill: "white" } }), e("path", { attrs: { d: "M52.7802 39.0503H50.9507L50.5423 39.7566H49.5415L52.0089 35.6626H53.1013L53.7956 39.7566H52.8873L52.7802 39.0503ZM51.3531 38.2952H52.71L52.4309 36.4109L51.3531 38.2952Z", fill: "white" } }), e("path", { attrs: { d: "M55.3957 36.4292H54.1989L54.3675 35.6621H57.6328L57.471 36.4292H56.2732L55.5584 39.7561H54.6809L55.3957 36.4292Z", fill: "white" } }), e("path", { attrs: { d: "M58.2527 35.6621H59.1242L58.2407 39.7561H57.3691L58.2527 35.6621Z", fill: "white" } }), e("path", { attrs: { d: "M61.6403 35.5942C62.7695 35.5942 63.6505 36.3065 63.6565 37.4238C63.6625 38.7619 62.6428 39.8304 61.2919 39.8304C60.1566 39.8304 59.2748 39.1181 59.2697 37.9948C59.2637 36.6558 60.2902 35.5942 61.6403 35.5942ZM61.5889 36.3673C60.797 36.3673 60.1738 37.0608 60.178 37.9392C60.1815 38.6326 60.6806 39.0564 61.3372 39.0564C62.1232 39.0564 62.7524 38.363 62.7481 37.4846C62.7447 36.7971 62.2456 36.3673 61.5889 36.3673Z", fill: "white" } }), e("path", { attrs: { d: "M65.3045 36.8526L64.6795 39.7566H63.808L64.6915 35.6626H65.5879L66.8781 38.4681L67.485 35.6626H68.3566L67.4731 39.7566H66.6323L65.3045 36.8526Z", fill: "white" } }), e("path", { attrs: { d: "M47.3996 26.3732C44.0042 26.3732 41.5967 23.5659 42.0222 20.1029C42.4477 16.6399 45.546 13.8326 48.9414 13.8326C50.8968 13.8326 52.5235 14.7641 53.4712 16.2144L59.6764 9.83794C57.4034 7.0658 53.9412 5.33984 49.8721 5.33984C41.9366 5.33984 34.6981 11.9003 33.7032 19.9942C32.7084 28.0872 38.3349 34.6485 46.2695 34.6485C50.3558 34.6485 54.2554 32.9072 57.2151 30.1136L51.717 24.7543C50.5022 25.7585 48.9843 26.3732 47.3996 26.3732Z", fill: `url(#${t.baseId}-paint0_linear)` } }), e("path", { attrs: { d: "M79.2919 0H90.443L69.7007 33.3633H58.5505L79.2919 0Z", fill: `url(#${t.baseId}-paint1_linear)` } }), e("path", { attrs: { d: "M32.6458 21.9512C32.6416 21.2732 32.6809 20.5848 32.7666 19.8888C32.877 18.9881 33.0611 18.1003 33.3153 17.2314L32.0714 8.00488L24.9715 19.4282L25.5434 23.6463H22.3346L18.6627 29.5682H26.3396L26.8499 33.3642L35.489 33.3634L35.0293 29.9603C33.4506 27.659 32.6296 24.9006 32.6458 21.9512Z", fill: `url(#${t.baseId}-paint2_linear)` } }), e("path", { attrs: { d: "M20.7414 6.63623H31.8925L11.1511 40.0004H0L20.7414 6.63623Z", fill: `url(#${t.baseId}-paint3_linear)` } }), e("path", { attrs: { d: "M63.5323 6.63623H57.1902C58.5565 7.43157 59.7842 8.52827 60.9229 9.83729L55.9933 14.8927L58.3177 32.1274L65.4167 20.7101L63.5323 6.63623Z", fill: `url(#${t.baseId}-paint4_linear)` } })]), e("defs", [e("linearGradient", { attrs: { id: `${t.baseId}-paint0_linear`, x1: "49.7696", y1: "34.2549", x2: "44.7895", y2: "6.01125", gradientUnits: "userSpaceOnUse" } }, [e("stop", { attrs: { "stop-color": "#F26723" } }), e("stop", { attrs: { offset: "0.3315", "stop-color": "#E35323" } }), e("stop", { attrs: { offset: "0.9971", "stop-color": "#C61621" } }), e("stop", { attrs: { offset: "1", "stop-color": "#C61521" } })], 1), e("linearGradient", { attrs: { id: `${t.baseId}-paint1_linear`, x1: "74.4966", y1: "33.3636", x2: "74.4966", y2: "0", gradientUnits: "userSpaceOnUse" } }, [e("stop", { attrs: { "stop-color": "#F26723" } }), e("stop", { attrs: { offset: "0.3315", "stop-color": "#E35323" } }), e("stop", { attrs: { offset: "0.9971", "stop-color": "#C61621" } }), e("stop", { attrs: { offset: "1", "stop-color": "#C61521" } })], 1), e("linearGradient", { attrs: { id: `${t.baseId}-paint2_linear`, x1: "25.7949", y1: "33.6855", x2: "38.484", y2: "11.7074", gradientUnits: "userSpaceOnUse" } }, [e("stop", { attrs: { "stop-color": "#F26723" } }), e("stop", { attrs: { offset: "0.3315", "stop-color": "#E35323" } }), e("stop", { attrs: { offset: "0.9971", "stop-color": "#C61621" } }), e("stop", { attrs: { offset: "1", "stop-color": "#C61521" } })], 1), e("linearGradient", { attrs: { id: `${t.baseId}-paint3_linear`, x1: "15.9464", y1: "40.0001", x2: "15.9464", y2: "6.63649", gradientUnits: "userSpaceOnUse" } }, [e("stop", { attrs: { "stop-color": "#F26723" } }), e("stop", { attrs: { offset: "0.3315", "stop-color": "#E35323" } }), e("stop", { attrs: { offset: "0.9971", "stop-color": "#C61621" } }), e("stop", { attrs: { offset: "1", "stop-color": "#C61521" } })], 1), e("linearGradient", { attrs: { id: `${t.baseId}-paint4_linear`, x1: "52.566", y1: "28.8073", x2: "64.9078", y2: "7.43073", gradientUnits: "userSpaceOnUse" } }, [e("stop", { attrs: { "stop-color": "#F26723" } }), e("stop", { attrs: { offset: "0.3315", "stop-color": "#E35323" } }), e("stop", { attrs: { offset: "0.9971", "stop-color": "#C61621" } }), e("stop", { attrs: { offset: "1", "stop-color": "#C61521" } })], 1), e("clipPath", { attrs: { id: `${t.baseId}-clip0` } }, [e("rect", { attrs: { width: "90.443", height: "40", fill: "white" } })])], 1)]);
}, WM = [], YM = /* @__PURE__ */ U(
  zM,
  jM,
  WM,
  !1,
  null,
  null
);
const UM = YM.exports, ZM = {
  name: "AcvTransportationSecondaryDarkSvg",
  extends: ne
};
var GM = function() {
  var t = this, e = t._self._c;
  return e("svg", { attrs: { viewBox: "0 0 91 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" } }, [e("title", [t._v("ACV Transportation")]), e("desc", [t._v("The stylized logo of ACV Transportation")]), e("g", { attrs: { "clip-path": `url(#${t.baseId}-clip0)` } }, [e("path", { attrs: { d: "M15.7844 36.4292H14.5875L14.7562 35.6621H18.0215L17.8596 36.4292H16.6628L15.9479 39.7561H15.0704L15.7844 36.4292Z", fill: "black" } }), e("path", { attrs: { d: "M19.5933 38.2892H18.9118L18.5993 39.7566H17.7278L18.6113 35.6626H20.3612C21.0239 35.6626 21.6274 36.1044 21.6309 36.8167C21.6343 37.5598 21.1335 38.118 20.4708 38.2404L21.0427 39.7566H20.0787L19.5933 38.2892ZM20.7165 36.9014C20.7148 36.6129 20.4751 36.41 20.1926 36.41H19.321L19.0805 37.5392H19.9888C20.4494 37.5401 20.7182 37.2695 20.7165 36.9014Z", fill: "black" } }), e("path", { attrs: { d: "M24.6607 39.0503H22.8312L22.4228 39.7566H21.422L23.8894 35.6626H24.9818L25.6761 39.7566H24.7677L24.6607 39.0503ZM23.2327 38.2952H24.5897L24.3106 36.4109L23.2327 38.2952Z", fill: "black" } }), e("path", { attrs: { d: "M27.6152 36.8526L26.9902 39.7566H26.1187L27.0022 35.6626H27.8985L29.1887 38.4681L29.7957 35.6626H30.6673L29.7837 39.7566H28.943L27.6152 36.8526Z", fill: "black" } }), e("path", { attrs: { d: "M31.0414 38.4367C31.3316 38.8177 31.8667 39.0694 32.4318 39.0694C32.8675 39.0694 33.0448 38.8177 33.043 38.5968C33.0422 38.3511 32.728 38.2227 32.341 38.0814C31.7691 37.8785 31.056 37.6088 31.0526 36.8785C31.05 36.2587 31.6296 35.6021 32.6424 35.6021C33.293 35.6021 33.9077 35.8418 34.2724 36.2647L33.7348 36.8725C33.4446 36.5224 32.9403 36.3512 32.5354 36.3512C32.198 36.3512 31.9652 36.5541 31.966 36.7809C31.9669 37.0018 32.2811 37.1251 32.6681 37.2664C33.24 37.4753 33.966 37.7509 33.9685 38.4632C33.9719 39.1875 33.3795 39.8322 32.3667 39.8322C31.5628 39.8322 30.8548 39.5188 30.5098 39.0711L31.0414 38.4367Z", fill: "black" } }), e("path", { attrs: { d: "M35.2211 35.6621H36.989C37.7749 35.6621 38.2372 36.1775 38.2406 36.7973C38.2432 37.4052 37.8365 38.3075 36.5532 38.3075H35.5216L35.2091 39.7561H34.3375L35.2211 35.6621ZM37.3263 36.8838C37.3254 36.6133 37.1217 36.4112 36.8083 36.4112H35.9308L35.6902 37.5405H36.5926C37.0592 37.5405 37.328 37.2519 37.3263 36.8838Z", fill: "black" } }), e("path", { attrs: { d: "M40.8501 35.5942C41.9794 35.5942 42.8603 36.3065 42.8655 37.4238C42.8715 38.7619 41.8518 39.8304 40.5008 39.8304C39.3656 39.8304 38.4838 39.1181 38.4787 37.9948C38.4735 36.6558 39.4992 35.5942 40.8501 35.5942ZM40.7988 36.3673C40.0068 36.3673 39.3836 37.0608 39.3879 37.9392C39.3913 38.6326 39.8904 39.0564 40.5471 39.0564C41.333 39.0564 41.9622 38.363 41.958 37.4846C41.9545 36.7971 41.4554 36.3673 40.7988 36.3673Z", fill: "black" } }), e("path", { attrs: { d: "M44.8217 38.2892H44.1402L43.8277 39.7566H42.9562L43.8397 35.6626H45.5896C46.2523 35.6626 46.8558 36.1044 46.8593 36.8167C46.8627 37.5598 46.3618 38.118 45.6992 38.2404L46.2711 39.7566H45.3071L44.8217 38.2892ZM45.9449 36.9014C45.9432 36.6129 45.7035 36.41 45.421 36.41H44.5494L44.3089 37.5392H45.2172C45.6778 37.5401 45.9466 37.2695 45.9449 36.9014Z", fill: "black" } }), e("path", { attrs: { d: "M48.4714 36.4292H47.2745L47.4432 35.6621H50.7085L50.5466 36.4292H49.3498L48.6349 39.7561H47.7574L48.4714 36.4292Z", fill: "black" } }), e("path", { attrs: { d: "M52.7802 39.0503H50.9507L50.5423 39.7566H49.5415L52.0089 35.6626H53.1013L53.7956 39.7566H52.8873L52.7802 39.0503ZM51.3531 38.2952H52.71L52.4309 36.4109L51.3531 38.2952Z", fill: "black" } }), e("path", { attrs: { d: "M55.3957 36.4292H54.1989L54.3675 35.6621H57.6328L57.471 36.4292H56.2732L55.5584 39.7561H54.6809L55.3957 36.4292Z", fill: "black" } }), e("path", { attrs: { d: "M58.2527 35.6621H59.1242L58.2407 39.7561H57.3691L58.2527 35.6621Z", fill: "black" } }), e("path", { attrs: { d: "M61.6403 35.5942C62.7695 35.5942 63.6505 36.3065 63.6565 37.4238C63.6625 38.7619 62.6428 39.8304 61.2919 39.8304C60.1566 39.8304 59.2748 39.1181 59.2697 37.9948C59.2637 36.6558 60.2902 35.5942 61.6403 35.5942ZM61.5889 36.3673C60.797 36.3673 60.1738 37.0608 60.178 37.9392C60.1815 38.6326 60.6806 39.0564 61.3372 39.0564C62.1232 39.0564 62.7524 38.363 62.7481 37.4846C62.7447 36.7971 62.2456 36.3673 61.5889 36.3673Z", fill: "black" } }), e("path", { attrs: { d: "M65.3045 36.8526L64.6795 39.7566H63.808L64.6915 35.6626H65.5879L66.8781 38.4681L67.485 35.6626H68.3566L67.4731 39.7566H66.6323L65.3045 36.8526Z", fill: "black" } }), e("path", { attrs: { d: "M47.3996 26.3732C44.0042 26.3732 41.5967 23.5659 42.0222 20.1029C42.4477 16.6399 45.546 13.8326 48.9414 13.8326C50.8968 13.8326 52.5235 14.7641 53.4712 16.2144L59.6764 9.83794C57.4034 7.0658 53.9412 5.33984 49.8721 5.33984C41.9366 5.33984 34.6981 11.9003 33.7032 19.9942C32.7084 28.0872 38.3349 34.6485 46.2695 34.6485C50.3558 34.6485 54.2554 32.9072 57.2151 30.1136L51.717 24.7543C50.5022 25.7585 48.9843 26.3732 47.3996 26.3732Z", fill: `url(#${t.baseId}-paint0_linear)` } }), e("path", { attrs: { d: "M79.2919 0H90.443L69.7007 33.3633H58.5505L79.2919 0Z", fill: `url(#${t.baseId}-paint1_linear)` } }), e("path", { attrs: { d: "M32.6458 21.9512C32.6416 21.2732 32.6809 20.5848 32.7666 19.8888C32.877 18.9881 33.0611 18.1003 33.3153 17.2314L32.0714 8.00488L24.9715 19.4282L25.5434 23.6463H22.3346L18.6627 29.5682H26.3396L26.8499 33.3642L35.489 33.3634L35.0293 29.9603C33.4506 27.659 32.6296 24.9006 32.6458 21.9512Z", fill: `url(#${t.baseId}-paint2_linear)` } }), e("path", { attrs: { d: "M20.7414 6.63623H31.8925L11.1511 40.0004H0L20.7414 6.63623Z", fill: `url(#${t.baseId}-paint3_linear)` } }), e("path", { attrs: { d: "M63.5323 6.63623H57.1902C58.5565 7.43157 59.7842 8.52827 60.9229 9.83729L55.9933 14.8927L58.3177 32.1274L65.4167 20.7101L63.5323 6.63623Z", fill: `url(#${t.baseId}-paint4_linear)` } })]), e("defs", [e("linearGradient", { attrs: { id: `${t.baseId}-paint0_linear`, x1: "49.7696", y1: "34.2549", x2: "44.7895", y2: "6.01125", gradientUnits: "userSpaceOnUse" } }, [e("stop", { attrs: { "stop-color": "#F26723" } }), e("stop", { attrs: { offset: "0.3315", "stop-color": "#E35323" } }), e("stop", { attrs: { offset: "0.9971", "stop-color": "#C61621" } }), e("stop", { attrs: { offset: "1", "stop-color": "#C61521" } })], 1), e("linearGradient", { attrs: { id: `${t.baseId}-paint1_linear`, x1: "74.4966", y1: "33.3636", x2: "74.4966", y2: "0", gradientUnits: "userSpaceOnUse" } }, [e("stop", { attrs: { "stop-color": "#F26723" } }), e("stop", { attrs: { offset: "0.3315", "stop-color": "#E35323" } }), e("stop", { attrs: { offset: "0.9971", "stop-color": "#C61621" } }), e("stop", { attrs: { offset: "1", "stop-color": "#C61521" } })], 1), e("linearGradient", { attrs: { id: `${t.baseId}-paint2_linear`, x1: "25.7949", y1: "33.6855", x2: "38.484", y2: "11.7074", gradientUnits: "userSpaceOnUse" } }, [e("stop", { attrs: { "stop-color": "#F26723" } }), e("stop", { attrs: { offset: "0.3315", "stop-color": "#E35323" } }), e("stop", { attrs: { offset: "0.9971", "stop-color": "#C61621" } }), e("stop", { attrs: { offset: "1", "stop-color": "#C61521" } })], 1), e("linearGradient", { attrs: { id: `${t.baseId}-paint3_linear`, x1: "15.9464", y1: "40.0001", x2: "15.9464", y2: "6.63649", gradientUnits: "userSpaceOnUse" } }, [e("stop", { attrs: { "stop-color": "#F26723" } }), e("stop", { attrs: { offset: "0.3315", "stop-color": "#E35323" } }), e("stop", { attrs: { offset: "0.9971", "stop-color": "#C61621" } }), e("stop", { attrs: { offset: "1", "stop-color": "#C61521" } })], 1), e("linearGradient", { attrs: { id: `${t.baseId}-paint4_linear`, x1: "52.566", y1: "28.8073", x2: "64.9078", y2: "7.43073", gradientUnits: "userSpaceOnUse" } }, [e("stop", { attrs: { "stop-color": "#F26723" } }), e("stop", { attrs: { offset: "0.3315", "stop-color": "#E35323" } }), e("stop", { attrs: { offset: "0.9971", "stop-color": "#C61621" } }), e("stop", { attrs: { offset: "1", "stop-color": "#C61521" } })], 1), e("clipPath", { attrs: { id: `${t.baseId}-clip0` } }, [e("rect", { attrs: { width: "90.443", height: "40", fill: "white" } })])], 1)]);
}, KM = [], XM = /* @__PURE__ */ U(
  ZM,
  GM,
  KM,
  !1,
  null,
  null
);
const QM = XM.exports, JM = {
  name: "True360PrimaryDarkSvg",
  extends: ne
};
var qM = function() {
  var t = this, e = t._self._c;
  return e("svg", { attrs: { viewBox: "0 0 222 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" } }, [e("title", [t._v("True 360")]), e("desc", [t._v("The stylized logo of True 360")]), e("path", { attrs: { d: "M159.702 24.5757C159.366 23.5371 158.881 22.5967 158.245 21.7802C157.61 20.9586 156.824 20.261 155.915 19.703C155.569 19.4911 155.202 19.3103 154.815 19.1552C156.049 18.6023 157.062 17.7962 157.842 16.7421C158.994 15.1816 159.578 13.2852 159.578 11.1098C159.578 9.24438 159.211 7.60635 158.488 6.23702C157.77 4.87802 156.788 3.72571 155.574 2.82661C154.37 1.93266 152.96 1.27125 151.384 0.852701C149.829 0.444485 148.196 0.237793 146.528 0.237793C144.931 0.237793 143.386 0.408314 141.945 0.749355C140.483 1.0904 139.139 1.63296 137.941 2.35638C136.732 3.09014 135.673 4.06676 134.794 5.25007C133.921 6.43854 133.255 7.88538 132.821 9.54408L132.64 10.2313L142.513 12.2672L142.673 11.6368C142.88 10.8049 143.314 10.128 144.001 9.55959C144.678 9.00152 145.52 8.72765 146.574 8.72765C147.7 8.72765 148.62 9.03252 149.379 9.66293C150.103 10.2572 150.454 10.9858 150.454 11.89C150.454 12.6186 150.315 13.2025 150.046 13.6211C149.762 14.0603 149.395 14.391 148.93 14.6287C148.429 14.8871 147.866 15.0628 147.251 15.1558C146.595 15.2539 145.918 15.3056 145.226 15.3056H142.012V23.3924H144.502C145.35 23.3924 146.207 23.4183 147.049 23.4699C147.835 23.5164 148.548 23.6663 149.168 23.9143C149.746 24.1468 150.206 24.4931 150.563 24.9633C150.898 25.4077 151.074 26.0846 151.074 26.963C151.074 28.1773 150.733 29.1385 150.036 29.898C149.364 30.6318 148.263 31.0038 146.776 31.0038C145.298 31.0038 144.182 30.6783 143.469 30.0376C142.725 29.371 142.244 28.4719 141.997 27.2937L141.857 26.6168L132.345 28.8439L132.495 29.5002C133.291 32.9416 134.97 35.5046 137.476 37.1168C139.94 38.7031 142.911 39.504 146.311 39.504C148.155 39.504 149.932 39.2663 151.596 38.8065C153.28 38.3362 154.768 37.6076 156.024 36.6465C157.289 35.6751 158.312 34.4401 159.062 32.9726C159.816 31.4999 160.198 29.774 160.198 27.8466C160.203 26.6995 160.033 25.604 159.702 24.5757Z", fill: "#F26522" } }), e("path", { attrs: { d: "M186.935 21.3047C186.356 19.7597 185.524 18.4059 184.465 17.2742C183.406 16.1426 182.109 15.2383 180.616 14.5769C179.118 13.9207 177.444 13.59 175.631 13.59C175.259 13.59 174.892 13.6106 174.535 13.6571L182.941 0.847412H171.843L163.613 13.6985C163.024 14.6337 162.461 15.5432 161.924 16.4268C161.376 17.3311 160.885 18.2922 160.477 19.2946C160.064 20.2971 159.733 21.3719 159.485 22.488C159.232 23.6145 159.108 24.8753 159.108 26.2343C159.108 28.2237 159.485 30.0529 160.229 31.6703C160.973 33.2825 162.001 34.688 163.288 35.8506C164.574 37.0081 166.098 37.9176 167.834 38.548C169.56 39.1784 171.451 39.4936 173.45 39.4936C175.419 39.4936 177.299 39.1784 179.04 38.548C180.787 37.9176 182.326 37.0081 183.613 35.8506C184.899 34.688 185.933 33.2825 186.677 31.6703C187.421 30.0529 187.803 28.2237 187.803 26.2343C187.808 24.5033 187.513 22.8446 186.935 21.3047ZM178.689 25.9191C178.689 27.4021 178.219 28.5958 177.258 29.562C176.292 30.5283 175.052 30.9986 173.461 30.9986C171.869 30.9986 170.629 30.5283 169.663 29.562C168.697 28.5958 168.232 27.4073 168.232 25.9191C168.232 24.4361 168.702 23.2425 169.663 22.2762C170.629 21.3099 171.869 20.8397 173.461 20.8397C175.052 20.8397 176.292 21.3099 177.258 22.2762C178.219 23.2425 178.689 24.4361 178.689 25.9191Z", fill: "#F26522" } }), e("path", { attrs: { d: "M215.847 13.192C214.989 13.192 214.188 13.0318 213.449 12.7114C212.711 12.3911 212.06 11.9467 211.502 11.3886C210.939 10.8305 210.499 10.1795 210.179 9.43537C209.859 8.69645 209.699 7.89552 209.699 7.03775C209.699 6.17998 209.859 5.37905 210.179 4.64012C210.499 3.9012 210.944 3.25012 211.502 2.69206C212.06 2.13399 212.711 1.6896 213.449 1.36923C214.188 1.04886 214.989 0.888672 215.847 0.888672C216.704 0.888672 217.505 1.04886 218.244 1.36923C218.983 1.6896 219.634 2.13399 220.192 2.69206C220.75 3.25529 221.194 3.9012 221.514 4.64012C221.835 5.37905 221.995 6.17998 221.995 7.03775C221.995 7.89552 221.835 8.69645 221.514 9.43537C221.194 10.1743 220.75 10.8254 220.192 11.3886C219.629 11.9518 218.983 12.3911 218.244 12.7114C217.505 13.0318 216.704 13.192 215.847 13.192ZM215.847 10.8202C216.906 10.8202 217.805 10.4533 218.533 9.72474C219.267 8.99098 219.629 8.09704 219.629 7.03775C219.629 5.97845 219.262 5.07934 218.533 4.35076C217.805 3.617 216.906 3.25529 215.847 3.25529C214.788 3.25529 213.889 3.62217 213.16 4.35076C212.432 5.07934 212.065 5.97845 212.065 7.03775C212.065 8.09704 212.432 8.99098 213.16 9.72474C213.889 10.4533 214.788 10.8202 215.847 10.8202Z", fill: "white" } }), e("path", { attrs: { d: "M212.85 14.1222C212.147 13.8173 211.512 13.4246 210.938 12.9441L205.219 18.6694L205.224 18.7676C205.235 19.1551 205.245 19.522 205.245 19.8579C205.245 20.8035 205.204 21.9507 205.116 23.2735C205.033 24.5446 204.811 25.7848 204.455 26.9526C204.114 28.0636 203.592 29.0092 202.894 29.7688C202.274 30.4457 201.422 30.7712 200.295 30.7712C199.138 30.7712 198.281 30.4457 197.676 29.7739C196.989 29.0143 196.472 28.0636 196.131 26.9526C195.775 25.7796 195.553 24.5446 195.47 23.2735C195.382 21.9662 195.341 20.819 195.341 19.8631C195.341 18.9071 195.382 17.76 195.47 16.4527C195.547 15.1815 195.775 13.9465 196.131 12.7735C196.467 11.6626 196.989 10.717 197.676 9.9522C198.281 9.28045 199.138 8.95491 200.295 8.95491C201.422 8.95491 202.274 9.28562 202.894 9.95737C203.592 10.717 204.119 11.6626 204.455 12.7684C204.656 13.4298 204.821 14.148 204.94 14.9025L205.007 15.3365L209.301 11.0425C209.099 10.7221 208.918 10.3863 208.763 10.0297C208.36 9.10477 208.159 8.10748 208.159 7.03268C208.159 5.95789 208.36 4.9606 208.763 4.03565C208.893 3.74112 209.042 3.45692 209.203 3.18305C208.67 2.70249 208.107 2.26327 207.518 1.87573C205.612 0.635577 203.184 0 200.29 0C197.397 0 194.964 0.635577 193.062 1.88089C191.187 3.11588 189.683 4.72807 188.598 6.67614C187.534 8.58804 186.785 10.7376 186.377 13.0681C185.974 15.352 185.767 17.636 185.767 19.8527C185.767 22.0747 185.974 24.3586 186.377 26.6426C186.79 28.973 187.534 31.1278 188.598 33.0345C189.683 34.9826 191.182 36.5947 193.062 37.8297C194.964 39.0802 197.397 39.7106 200.29 39.7106C203.184 39.7106 205.617 39.0751 207.518 37.8297C209.394 36.5947 210.892 34.9826 211.977 33.0345C213.041 31.1226 213.79 28.973 214.204 26.6426C214.607 24.3534 214.813 22.0695 214.813 19.8527C214.813 18.163 214.679 16.3958 214.426 14.5924C213.878 14.4943 213.351 14.3444 212.85 14.1222Z", fill: "#F26522" } }), e("path", { attrs: { d: "M0 0.883545V4.21645H13.3348V39.3592H16.9255V4.21645H30.2654V0.883545H0Z", fill: "white" } }), e("path", { attrs: { d: "M38.1547 4.02526V19.5426H48.6686C54.8219 19.5426 58.5418 16.8505 58.5418 11.7194C58.5418 6.71742 56.1703 4.02526 48.6014 4.02526H38.1547ZM47.9659 22.6843H38.1547V39.3592H34.564V0.883545H48.9889C58.3506 0.883545 62.1325 5.11556 62.1325 11.7194C62.1325 17.6204 58.5418 21.6612 51.6806 22.4932L64.3128 38.6513V39.354H60.3397L47.9659 22.6843Z", fill: "white" } }), e("path", { attrs: { d: "M93.8445 24.927V0.883545H97.4353V25.0613C97.4353 34.874 92.3049 40.0051 82.69 40.0051C73.008 40.0051 67.175 35.0032 67.175 25.0613V0.883545H70.7657V24.5446C70.7657 31.5979 73.6486 36.791 82.69 36.791C91.2768 36.791 93.8445 32.0475 93.8445 24.927Z", fill: "white" } }), e("path", { attrs: { d: "M102.571 0.883545H127.768V4.15444H106.162V18.07H125.334V21.3357H106.162V36.0883H127.706V39.3592H102.571V0.883545Z", fill: "white" } })]);
}, tT = [], eT = /* @__PURE__ */ U(
  JM,
  qM,
  tT,
  !1,
  null,
  null
);
const iT = eT.exports, nT = {
  name: "True360PrimaryLightSvg",
  extends: ne
};
var sT = function() {
  var t = this, e = t._self._c;
  return e("svg", { attrs: { viewBox: "0 0 222 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" } }, [e("title", [t._v("True 360")]), e("desc", [t._v("The stylized logo of True 360")]), e("path", { attrs: { d: "M159.702 24.5757C159.366 23.5371 158.881 22.5967 158.245 21.7802C157.61 20.9586 156.824 20.261 155.915 19.703C155.569 19.4911 155.202 19.3103 154.815 19.1552C156.049 18.6023 157.062 17.7962 157.842 16.7421C158.994 15.1816 159.578 13.2852 159.578 11.1098C159.578 9.24438 159.211 7.60635 158.488 6.23702C157.77 4.87802 156.788 3.72571 155.574 2.82661C154.37 1.93266 152.96 1.27125 151.384 0.852701C149.829 0.444485 148.196 0.237793 146.528 0.237793C144.931 0.237793 143.386 0.408314 141.945 0.749355C140.483 1.0904 139.139 1.63296 137.941 2.35638C136.732 3.09014 135.673 4.06676 134.794 5.25007C133.921 6.43854 133.255 7.88538 132.821 9.54408L132.64 10.2313L142.513 12.2672L142.673 11.6368C142.88 10.8049 143.314 10.128 144.001 9.55959C144.678 9.00152 145.52 8.72765 146.574 8.72765C147.7 8.72765 148.62 9.03252 149.379 9.66293C150.103 10.2572 150.454 10.9858 150.454 11.89C150.454 12.6186 150.315 13.2025 150.046 13.6211C149.762 14.0603 149.395 14.391 148.93 14.6287C148.429 14.8871 147.866 15.0628 147.251 15.1558C146.595 15.2539 145.918 15.3056 145.226 15.3056H142.012V23.3924H144.502C145.35 23.3924 146.207 23.4183 147.049 23.4699C147.835 23.5164 148.548 23.6663 149.168 23.9143C149.746 24.1468 150.206 24.4931 150.563 24.9633C150.898 25.4077 151.074 26.0846 151.074 26.963C151.074 28.1773 150.733 29.1385 150.036 29.898C149.364 30.6318 148.263 31.0038 146.776 31.0038C145.298 31.0038 144.182 30.6783 143.469 30.0376C142.725 29.371 142.244 28.4719 141.997 27.2937L141.857 26.6168L132.345 28.8439L132.495 29.5002C133.291 32.9416 134.97 35.5046 137.476 37.1168C139.94 38.7031 142.911 39.504 146.311 39.504C148.155 39.504 149.932 39.2663 151.596 38.8065C153.28 38.3362 154.768 37.6076 156.024 36.6465C157.289 35.6751 158.312 34.4401 159.062 32.9726C159.816 31.4999 160.198 29.774 160.198 27.8466C160.203 26.6995 160.033 25.604 159.702 24.5757Z", fill: "#F26522" } }), e("path", { attrs: { d: "M186.935 21.3047C186.356 19.7597 185.524 18.4059 184.465 17.2742C183.406 16.1426 182.109 15.2383 180.616 14.5769C179.118 13.9207 177.444 13.59 175.631 13.59C175.259 13.59 174.892 13.6106 174.535 13.6571L182.941 0.847412H171.843L163.613 13.6985C163.024 14.6337 162.461 15.5432 161.924 16.4268C161.376 17.3311 160.885 18.2922 160.477 19.2946C160.064 20.2971 159.733 21.3719 159.485 22.488C159.232 23.6145 159.108 24.8753 159.108 26.2343C159.108 28.2237 159.485 30.0529 160.229 31.6703C160.973 33.2825 162.001 34.688 163.288 35.8506C164.574 37.0081 166.098 37.9176 167.834 38.548C169.56 39.1784 171.451 39.4936 173.45 39.4936C175.419 39.4936 177.299 39.1784 179.04 38.548C180.787 37.9176 182.326 37.0081 183.613 35.8506C184.899 34.688 185.933 33.2825 186.677 31.6703C187.421 30.0529 187.803 28.2237 187.803 26.2343C187.808 24.5033 187.513 22.8446 186.935 21.3047ZM178.689 25.9191C178.689 27.4021 178.219 28.5958 177.258 29.562C176.292 30.5283 175.052 30.9986 173.461 30.9986C171.869 30.9986 170.629 30.5283 169.663 29.562C168.697 28.5958 168.232 27.4073 168.232 25.9191C168.232 24.4361 168.702 23.2425 169.663 22.2762C170.629 21.3099 171.869 20.8397 173.461 20.8397C175.052 20.8397 176.292 21.3099 177.258 22.2762C178.219 23.2425 178.689 24.4361 178.689 25.9191Z", fill: "#F26522" } }), e("path", { attrs: { d: "M215.847 13.192C214.989 13.192 214.188 13.0318 213.449 12.7114C212.711 12.3911 212.06 11.9467 211.502 11.3886C210.939 10.8305 210.499 10.1795 210.179 9.43537C209.859 8.69645 209.699 7.89552 209.699 7.03775C209.699 6.17998 209.859 5.37905 210.179 4.64012C210.499 3.9012 210.944 3.25012 211.502 2.69206C212.06 2.13399 212.711 1.6896 213.449 1.36923C214.188 1.04886 214.989 0.888672 215.847 0.888672C216.704 0.888672 217.505 1.04886 218.244 1.36923C218.983 1.6896 219.634 2.13399 220.192 2.69206C220.75 3.25529 221.194 3.9012 221.514 4.64012C221.835 5.37905 221.995 6.17998 221.995 7.03775C221.995 7.89552 221.835 8.69645 221.514 9.43537C221.194 10.1743 220.75 10.8254 220.192 11.3886C219.629 11.9518 218.983 12.3911 218.244 12.7114C217.505 13.0318 216.704 13.192 215.847 13.192ZM215.847 10.8202C216.906 10.8202 217.805 10.4533 218.533 9.72474C219.267 8.99098 219.629 8.09704 219.629 7.03775C219.629 5.97845 219.262 5.07934 218.533 4.35076C217.805 3.617 216.906 3.25529 215.847 3.25529C214.788 3.25529 213.889 3.62217 213.16 4.35076C212.432 5.07934 212.065 5.97845 212.065 7.03775C212.065 8.09704 212.432 8.99098 213.16 9.72474C213.889 10.4533 214.788 10.8202 215.847 10.8202Z", fill: "#004E7D" } }), e("path", { attrs: { d: "M212.85 14.1222C212.147 13.8173 211.512 13.4246 210.938 12.9441L205.219 18.6694L205.224 18.7676C205.235 19.1551 205.245 19.522 205.245 19.8579C205.245 20.8035 205.204 21.9507 205.116 23.2735C205.033 24.5446 204.811 25.7848 204.455 26.9526C204.114 28.0636 203.592 29.0092 202.894 29.7688C202.274 30.4457 201.422 30.7712 200.295 30.7712C199.138 30.7712 198.281 30.4457 197.676 29.7739C196.989 29.0143 196.472 28.0636 196.131 26.9526C195.775 25.7796 195.553 24.5446 195.47 23.2735C195.382 21.9662 195.341 20.819 195.341 19.8631C195.341 18.9071 195.382 17.76 195.47 16.4527C195.547 15.1815 195.775 13.9465 196.131 12.7735C196.467 11.6626 196.989 10.717 197.676 9.9522C198.281 9.28045 199.138 8.95491 200.295 8.95491C201.422 8.95491 202.274 9.28562 202.894 9.95737C203.592 10.717 204.119 11.6626 204.455 12.7684C204.656 13.4298 204.821 14.148 204.94 14.9025L205.007 15.3365L209.301 11.0425C209.099 10.7221 208.918 10.3863 208.763 10.0297C208.36 9.10477 208.159 8.10748 208.159 7.03268C208.159 5.95789 208.36 4.9606 208.763 4.03565C208.893 3.74112 209.042 3.45692 209.203 3.18305C208.67 2.70249 208.107 2.26327 207.518 1.87573C205.612 0.635577 203.184 0 200.29 0C197.397 0 194.964 0.635577 193.062 1.88089C191.187 3.11588 189.683 4.72807 188.598 6.67614C187.534 8.58804 186.785 10.7376 186.377 13.0681C185.974 15.352 185.767 17.636 185.767 19.8527C185.767 22.0747 185.974 24.3586 186.377 26.6426C186.79 28.973 187.534 31.1278 188.598 33.0345C189.683 34.9826 191.182 36.5947 193.062 37.8297C194.964 39.0802 197.397 39.7106 200.29 39.7106C203.184 39.7106 205.617 39.0751 207.518 37.8297C209.394 36.5947 210.892 34.9826 211.977 33.0345C213.041 31.1226 213.79 28.973 214.204 26.6426C214.607 24.3534 214.813 22.0695 214.813 19.8527C214.813 18.163 214.679 16.3958 214.426 14.5924C213.878 14.4943 213.351 14.3444 212.85 14.1222Z", fill: "#F26522" } }), e("path", { attrs: { d: "M0 0.883545V4.21645H13.3348V39.3592H16.9255V4.21645H30.2654V0.883545H0Z", fill: "#004E7D" } }), e("path", { attrs: { d: "M38.1547 4.02526V19.5426H48.6686C54.8219 19.5426 58.5418 16.8505 58.5418 11.7194C58.5418 6.71742 56.1703 4.02526 48.6014 4.02526H38.1547ZM47.9659 22.6843H38.1547V39.3592H34.564V0.883545H48.9889C58.3506 0.883545 62.1325 5.11556 62.1325 11.7194C62.1325 17.6204 58.5418 21.6612 51.6806 22.4932L64.3128 38.6513V39.354H60.3397L47.9659 22.6843Z", fill: "#004E7D" } }), e("path", { attrs: { d: "M93.8445 24.927V0.883545H97.4353V25.0613C97.4353 34.874 92.3049 40.0051 82.69 40.0051C73.008 40.0051 67.175 35.0032 67.175 25.0613V0.883545H70.7657V24.5446C70.7657 31.5979 73.6486 36.791 82.69 36.791C91.2768 36.791 93.8445 32.0475 93.8445 24.927Z", fill: "#004E7D" } }), e("path", { attrs: { d: "M102.571 0.883545H127.768V4.15444H106.162V18.07H125.334V21.3357H106.162V36.0883H127.706V39.3592H102.571V0.883545Z", fill: "#004E7D" } })]);
}, rT = [], aT = /* @__PURE__ */ U(
  nT,
  sT,
  rT,
  !1,
  null,
  null
);
const oT = aT.exports, lT = {
  name: "True360SecondaryBlackSvg",
  extends: ne
};
var cT = function() {
  var t = this, e = t._self._c;
  return e("svg", { attrs: { viewBox: "0 0 222 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" } }, [e("title", [t._v("True 360")]), e("desc", [t._v("The stylized logo of True 360")]), e("path", { attrs: { d: "M159.702 24.5757C159.366 23.5371 158.881 22.5967 158.245 21.7802C157.61 20.9586 156.824 20.261 155.915 19.703C155.569 19.4911 155.202 19.3103 154.815 19.1552C156.049 18.6023 157.062 17.7962 157.842 16.7421C158.994 15.1816 159.578 13.2852 159.578 11.1098C159.578 9.24438 159.211 7.60635 158.488 6.23702C157.77 4.87802 156.788 3.72571 155.574 2.82661C154.37 1.93266 152.96 1.27125 151.384 0.852701C149.829 0.444485 148.196 0.237793 146.528 0.237793C144.931 0.237793 143.386 0.408314 141.945 0.749355C140.483 1.0904 139.139 1.63296 137.941 2.35638C136.732 3.09014 135.673 4.06676 134.794 5.25007C133.921 6.43854 133.255 7.88538 132.821 9.54408L132.64 10.2313L142.513 12.2672L142.673 11.6368C142.88 10.8049 143.314 10.128 144.001 9.55959C144.678 9.00152 145.52 8.72765 146.574 8.72765C147.7 8.72765 148.62 9.03252 149.379 9.66293C150.103 10.2572 150.454 10.9858 150.454 11.89C150.454 12.6186 150.315 13.2025 150.046 13.6211C149.762 14.0603 149.395 14.391 148.93 14.6287C148.429 14.8871 147.866 15.0628 147.251 15.1558C146.595 15.2539 145.918 15.3056 145.226 15.3056H142.012V23.3924H144.502C145.35 23.3924 146.207 23.4183 147.049 23.4699C147.835 23.5164 148.548 23.6663 149.168 23.9143C149.746 24.1468 150.206 24.4931 150.563 24.9633C150.898 25.4077 151.074 26.0846 151.074 26.963C151.074 28.1773 150.733 29.1385 150.036 29.898C149.364 30.6318 148.263 31.0038 146.776 31.0038C145.298 31.0038 144.182 30.6783 143.469 30.0376C142.725 29.371 142.244 28.4719 141.997 27.2937L141.857 26.6168L132.345 28.8439L132.495 29.5002C133.291 32.9416 134.97 35.5046 137.476 37.1168C139.94 38.7031 142.911 39.504 146.311 39.504C148.155 39.504 149.932 39.2663 151.596 38.8065C153.28 38.3362 154.768 37.6076 156.024 36.6465C157.289 35.6751 158.312 34.4401 159.062 32.9726C159.816 31.4999 160.198 29.774 160.198 27.8466C160.203 26.6995 160.033 25.604 159.702 24.5757Z", fill: "black" } }), e("path", { attrs: { d: "M186.935 21.3047C186.356 19.7597 185.524 18.4059 184.465 17.2742C183.406 16.1426 182.109 15.2383 180.616 14.5769C179.118 13.9207 177.444 13.59 175.631 13.59C175.259 13.59 174.892 13.6106 174.535 13.6571L182.941 0.847412H171.843L163.613 13.6985C163.024 14.6337 162.461 15.5432 161.924 16.4268C161.376 17.3311 160.885 18.2922 160.477 19.2946C160.064 20.2971 159.733 21.3719 159.485 22.488C159.232 23.6145 159.108 24.8753 159.108 26.2343C159.108 28.2237 159.485 30.0529 160.229 31.6703C160.973 33.2825 162.001 34.688 163.288 35.8506C164.574 37.0081 166.098 37.9176 167.834 38.548C169.56 39.1784 171.451 39.4936 173.45 39.4936C175.419 39.4936 177.299 39.1784 179.04 38.548C180.787 37.9176 182.326 37.0081 183.613 35.8506C184.899 34.688 185.933 33.2825 186.677 31.6703C187.421 30.0529 187.803 28.2237 187.803 26.2343C187.808 24.5033 187.514 22.8446 186.935 21.3047ZM178.689 25.9191C178.689 27.4021 178.219 28.5958 177.258 29.562C176.292 30.5283 175.052 30.9986 173.461 30.9986C171.869 30.9986 170.629 30.5283 169.663 29.562C168.697 28.5958 168.232 27.4073 168.232 25.9191C168.232 24.4361 168.702 23.2425 169.663 22.2762C170.629 21.3099 171.869 20.8397 173.461 20.8397C175.052 20.8397 176.292 21.3099 177.258 22.2762C178.219 23.2425 178.689 24.4361 178.689 25.9191Z", fill: "black" } }), e("path", { attrs: { d: "M215.847 13.192C214.989 13.192 214.188 13.0318 213.449 12.7114C212.711 12.3911 212.06 11.9467 211.502 11.3886C210.938 10.8305 210.499 10.1795 210.179 9.43537C209.859 8.69645 209.698 7.89552 209.698 7.03775C209.698 6.17998 209.859 5.37905 210.179 4.64012C210.499 3.9012 210.944 3.25012 211.502 2.69206C212.06 2.13399 212.711 1.6896 213.449 1.36923C214.188 1.04886 214.989 0.888672 215.847 0.888672C216.704 0.888672 217.505 1.04886 218.244 1.36923C218.983 1.6896 219.634 2.13399 220.192 2.69206C220.75 3.25529 221.194 3.9012 221.514 4.64012C221.835 5.37905 221.995 6.17998 221.995 7.03775C221.995 7.89552 221.835 8.69645 221.514 9.43537C221.194 10.1743 220.75 10.8254 220.192 11.3886C219.629 11.9518 218.983 12.3911 218.244 12.7114C217.505 13.0318 216.704 13.192 215.847 13.192ZM215.847 10.8202C216.906 10.8202 217.805 10.4533 218.533 9.72474C219.267 8.99098 219.629 8.09704 219.629 7.03775C219.629 5.97845 219.262 5.07934 218.533 4.35076C217.805 3.617 216.906 3.25529 215.847 3.25529C214.788 3.25529 213.889 3.62217 213.16 4.35076C212.432 5.07934 212.065 5.97845 212.065 7.03775C212.065 8.09704 212.432 8.99098 213.16 9.72474C213.889 10.4533 214.788 10.8202 215.847 10.8202Z", fill: "black" } }), e("path", { attrs: { d: "M212.85 14.1222C212.147 13.8173 211.512 13.4246 210.938 12.9441L205.219 18.6694L205.224 18.7676C205.235 19.1551 205.245 19.522 205.245 19.8579C205.245 20.8035 205.204 21.9507 205.116 23.2735C205.033 24.5446 204.811 25.7848 204.455 26.9526C204.114 28.0636 203.592 29.0092 202.894 29.7688C202.274 30.4457 201.422 30.7712 200.295 30.7712C199.138 30.7712 198.281 30.4457 197.676 29.7739C196.989 29.0143 196.472 28.0636 196.131 26.9526C195.775 25.7796 195.553 24.5446 195.47 23.2735C195.382 21.9662 195.341 20.819 195.341 19.8631C195.341 18.9071 195.382 17.76 195.47 16.4527C195.547 15.1815 195.775 13.9465 196.131 12.7735C196.467 11.6626 196.989 10.717 197.676 9.9522C198.281 9.28045 199.138 8.95491 200.295 8.95491C201.422 8.95491 202.274 9.28562 202.894 9.95737C203.592 10.717 204.119 11.6626 204.455 12.7684C204.656 13.4298 204.821 14.148 204.94 14.9025L205.007 15.3365L209.301 11.0425C209.099 10.7221 208.918 10.3863 208.763 10.0297C208.36 9.10477 208.159 8.10748 208.159 7.03268C208.159 5.95789 208.36 4.9606 208.763 4.03565C208.893 3.74112 209.042 3.45692 209.203 3.18305C208.67 2.70249 208.107 2.26327 207.518 1.87573C205.612 0.635577 203.184 0 200.29 0C197.397 0 194.964 0.635577 193.062 1.88089C191.187 3.11588 189.683 4.72807 188.598 6.67614C187.534 8.58804 186.785 10.7376 186.377 13.0681C185.974 15.352 185.767 17.636 185.767 19.8527C185.767 22.0747 185.974 24.3586 186.377 26.6426C186.79 28.973 187.534 31.1278 188.598 33.0345C189.683 34.9826 191.182 36.5947 193.062 37.8297C194.964 39.0802 197.397 39.7106 200.29 39.7106C203.184 39.7106 205.617 39.0751 207.518 37.8297C209.394 36.5947 210.892 34.9826 211.977 33.0345C213.041 31.1226 213.79 28.973 214.204 26.6426C214.607 24.3534 214.813 22.0695 214.813 19.8527C214.813 18.163 214.679 16.3958 214.426 14.5924C213.878 14.4943 213.351 14.3444 212.85 14.1222Z", fill: "black" } }), e("path", { attrs: { d: "M0 0.883545V4.21645H13.3348V39.3592H16.9255V4.21645H30.2654V0.883545H0Z", fill: "black" } }), e("path", { attrs: { d: "M38.1547 4.02526V19.5426H48.6686C54.8219 19.5426 58.5418 16.8505 58.5418 11.7194C58.5418 6.71742 56.1703 4.02526 48.6014 4.02526H38.1547ZM47.9659 22.6843H38.1547V39.3592H34.564V0.883545H48.9889C58.3506 0.883545 62.1325 5.11556 62.1325 11.7194C62.1325 17.6204 58.5418 21.6612 51.6806 22.4932L64.3128 38.6513V39.354H60.3397L47.9659 22.6843Z", fill: "black" } }), e("path", { attrs: { d: "M93.8445 24.927V0.883545H97.4353V25.0613C97.4353 34.874 92.3049 40.0051 82.69 40.0051C73.008 40.0051 67.175 35.0032 67.175 25.0613V0.883545H70.7657V24.5446C70.7657 31.5979 73.6486 36.791 82.69 36.791C91.2768 36.791 93.8445 32.0475 93.8445 24.927Z", fill: "black" } }), e("path", { attrs: { d: "M102.571 0.883545H127.768V4.15444H106.162V18.07H125.334V21.3357H106.162V36.0883H127.706V39.3592H102.571V0.883545Z", fill: "black" } })]);
}, uT = [], dT = /* @__PURE__ */ U(
  lT,
  cT,
  uT,
  !1,
  null,
  null
);
const hT = dT.exports, fT = {
  name: "True360SecondaryGraySvg",
  extends: ne
};
var pT = function() {
  var t = this, e = t._self._c;
  return e("svg", { attrs: { viewBox: "0 0 222 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" } }, [e("title", [t._v("True 360")]), e("desc", [t._v("The stylized logo of True 360")]), e("path", { attrs: { d: "M159.702 24.5757C159.366 23.5371 158.881 22.5967 158.245 21.7802C157.61 20.9586 156.824 20.261 155.915 19.703C155.569 19.4911 155.202 19.3103 154.815 19.1552C156.049 18.6023 157.062 17.7962 157.842 16.7421C158.994 15.1816 159.578 13.2852 159.578 11.1098C159.578 9.24438 159.211 7.60635 158.488 6.23702C157.77 4.87802 156.788 3.72571 155.574 2.82661C154.37 1.93266 152.96 1.27125 151.384 0.852701C149.829 0.444485 148.196 0.237793 146.528 0.237793C144.931 0.237793 143.386 0.408314 141.945 0.749355C140.483 1.0904 139.139 1.63296 137.941 2.35638C136.732 3.09014 135.673 4.06676 134.794 5.25007C133.921 6.43854 133.255 7.88538 132.821 9.54408L132.64 10.2313L142.513 12.2672L142.673 11.6368C142.88 10.8049 143.314 10.128 144.001 9.55959C144.678 9.00152 145.52 8.72765 146.574 8.72765C147.7 8.72765 148.62 9.03252 149.379 9.66293C150.103 10.2572 150.454 10.9858 150.454 11.89C150.454 12.6186 150.315 13.2025 150.046 13.6211C149.762 14.0603 149.395 14.391 148.93 14.6287C148.429 14.8871 147.866 15.0628 147.251 15.1558C146.595 15.2539 145.918 15.3056 145.226 15.3056H142.012V23.3924H144.502C145.35 23.3924 146.207 23.4183 147.049 23.4699C147.835 23.5164 148.548 23.6663 149.168 23.9143C149.746 24.1468 150.206 24.4931 150.563 24.9633C150.898 25.4077 151.074 26.0846 151.074 26.963C151.074 28.1773 150.733 29.1385 150.036 29.898C149.364 30.6318 148.263 31.0038 146.776 31.0038C145.298 31.0038 144.182 30.6783 143.469 30.0376C142.725 29.371 142.244 28.4719 141.997 27.2937L141.857 26.6168L132.345 28.8439L132.495 29.5002C133.291 32.9416 134.97 35.5046 137.476 37.1168C139.94 38.7031 142.911 39.504 146.311 39.504C148.155 39.504 149.932 39.2663 151.596 38.8065C153.28 38.3362 154.768 37.6076 156.024 36.6465C157.289 35.6751 158.312 34.4401 159.062 32.9726C159.816 31.4999 160.198 29.774 160.198 27.8466C160.203 26.6995 160.033 25.604 159.702 24.5757Z", fill: "#AAAAAA" } }), e("path", { attrs: { d: "M186.935 21.3047C186.356 19.7597 185.524 18.4059 184.465 17.2742C183.406 16.1426 182.109 15.2383 180.616 14.5769C179.118 13.9207 177.444 13.59 175.631 13.59C175.259 13.59 174.892 13.6106 174.535 13.6571L182.941 0.847412H171.843L163.613 13.6985C163.024 14.6337 162.461 15.5432 161.924 16.4268C161.376 17.3311 160.885 18.2922 160.477 19.2946C160.064 20.2971 159.733 21.3719 159.485 22.488C159.232 23.6145 159.108 24.8753 159.108 26.2343C159.108 28.2237 159.485 30.0529 160.229 31.6703C160.973 33.2825 162.001 34.688 163.288 35.8506C164.574 37.0081 166.098 37.9176 167.834 38.548C169.56 39.1784 171.451 39.4936 173.45 39.4936C175.419 39.4936 177.299 39.1784 179.04 38.548C180.787 37.9176 182.326 37.0081 183.613 35.8506C184.899 34.688 185.933 33.2825 186.677 31.6703C187.421 30.0529 187.803 28.2237 187.803 26.2343C187.808 24.5033 187.514 22.8446 186.935 21.3047ZM178.689 25.9191C178.689 27.4021 178.219 28.5958 177.258 29.562C176.292 30.5283 175.052 30.9986 173.461 30.9986C171.869 30.9986 170.629 30.5283 169.663 29.562C168.697 28.5958 168.232 27.4073 168.232 25.9191C168.232 24.4361 168.702 23.2425 169.663 22.2762C170.629 21.3099 171.869 20.8397 173.461 20.8397C175.052 20.8397 176.292 21.3099 177.258 22.2762C178.219 23.2425 178.689 24.4361 178.689 25.9191Z", fill: "#AAAAAA" } }), e("path", { attrs: { d: "M215.847 13.192C214.989 13.192 214.188 13.0318 213.449 12.7114C212.711 12.3911 212.06 11.9467 211.502 11.3886C210.938 10.8305 210.499 10.1795 210.179 9.43537C209.859 8.69645 209.698 7.89552 209.698 7.03775C209.698 6.17998 209.859 5.37905 210.179 4.64012C210.499 3.9012 210.944 3.25012 211.502 2.69206C212.06 2.13399 212.711 1.6896 213.449 1.36923C214.188 1.04886 214.989 0.888672 215.847 0.888672C216.704 0.888672 217.505 1.04886 218.244 1.36923C218.983 1.6896 219.634 2.13399 220.192 2.69206C220.75 3.25529 221.194 3.9012 221.514 4.64012C221.835 5.37905 221.995 6.17998 221.995 7.03775C221.995 7.89552 221.835 8.69645 221.514 9.43537C221.194 10.1743 220.75 10.8254 220.192 11.3886C219.629 11.9518 218.983 12.3911 218.244 12.7114C217.505 13.0318 216.704 13.192 215.847 13.192ZM215.847 10.8202C216.906 10.8202 217.805 10.4533 218.533 9.72474C219.267 8.99098 219.629 8.09704 219.629 7.03775C219.629 5.97845 219.262 5.07934 218.533 4.35076C217.805 3.617 216.906 3.25529 215.847 3.25529C214.788 3.25529 213.889 3.62217 213.16 4.35076C212.432 5.07934 212.065 5.97845 212.065 7.03775C212.065 8.09704 212.432 8.99098 213.16 9.72474C213.889 10.4533 214.788 10.8202 215.847 10.8202Z", fill: "#AAAAAA" } }), e("path", { attrs: { d: "M212.85 14.1222C212.147 13.8173 211.512 13.4246 210.938 12.9441L205.219 18.6694L205.224 18.7676C205.235 19.1551 205.245 19.522 205.245 19.8579C205.245 20.8035 205.204 21.9507 205.116 23.2735C205.033 24.5446 204.811 25.7848 204.455 26.9526C204.114 28.0636 203.592 29.0092 202.894 29.7688C202.274 30.4457 201.422 30.7712 200.295 30.7712C199.138 30.7712 198.281 30.4457 197.676 29.7739C196.989 29.0143 196.472 28.0636 196.131 26.9526C195.775 25.7796 195.553 24.5446 195.47 23.2735C195.382 21.9662 195.341 20.819 195.341 19.8631C195.341 18.9071 195.382 17.76 195.47 16.4527C195.547 15.1815 195.775 13.9465 196.131 12.7735C196.467 11.6626 196.989 10.717 197.676 9.9522C198.281 9.28045 199.138 8.95491 200.295 8.95491C201.422 8.95491 202.274 9.28562 202.894 9.95737C203.592 10.717 204.119 11.6626 204.455 12.7684C204.656 13.4298 204.821 14.148 204.94 14.9025L205.007 15.3365L209.301 11.0425C209.099 10.7221 208.918 10.3863 208.763 10.0297C208.36 9.10477 208.159 8.10748 208.159 7.03268C208.159 5.95789 208.36 4.9606 208.763 4.03565C208.893 3.74112 209.042 3.45692 209.203 3.18305C208.67 2.70249 208.107 2.26327 207.518 1.87573C205.612 0.635577 203.184 0 200.29 0C197.397 0 194.964 0.635577 193.062 1.88089C191.187 3.11588 189.683 4.72807 188.598 6.67614C187.534 8.58804 186.785 10.7376 186.377 13.0681C185.974 15.352 185.767 17.636 185.767 19.8527C185.767 22.0747 185.974 24.3586 186.377 26.6426C186.79 28.973 187.534 31.1278 188.598 33.0345C189.683 34.9826 191.182 36.5947 193.062 37.8297C194.964 39.0802 197.397 39.7106 200.29 39.7106C203.184 39.7106 205.617 39.0751 207.518 37.8297C209.394 36.5947 210.892 34.9826 211.977 33.0345C213.041 31.1226 213.79 28.973 214.204 26.6426C214.607 24.3534 214.813 22.0695 214.813 19.8527C214.813 18.163 214.679 16.3958 214.426 14.5924C213.878 14.4943 213.351 14.3444 212.85 14.1222Z", fill: "#AAAAAA" } }), e("path", { attrs: { d: "M0 0.883545V4.21645H13.3348V39.3592H16.9255V4.21645H30.2654V0.883545H0Z", fill: "#AAAAAA" } }), e("path", { attrs: { d: "M38.1547 4.02526V19.5426H48.6686C54.8219 19.5426 58.5418 16.8505 58.5418 11.7194C58.5418 6.71742 56.1703 4.02526 48.6014 4.02526H38.1547ZM47.9659 22.6843H38.1547V39.3592H34.564V0.883545H48.9889C58.3506 0.883545 62.1325 5.11556 62.1325 11.7194C62.1325 17.6204 58.5418 21.6612 51.6806 22.4932L64.3128 38.6513V39.354H60.3397L47.9659 22.6843Z", fill: "#AAAAAA" } }), e("path", { attrs: { d: "M93.8445 24.927V0.883545H97.4353V25.0613C97.4353 34.874 92.3049 40.0051 82.69 40.0051C73.008 40.0051 67.175 35.0032 67.175 25.0613V0.883545H70.7657V24.5446C70.7657 31.5979 73.6486 36.791 82.69 36.791C91.2768 36.791 93.8445 32.0475 93.8445 24.927Z", fill: "#AAAAAA" } }), e("path", { attrs: { d: "M102.571 0.883545H127.768V4.15444H106.162V18.07H125.334V21.3357H106.162V36.0883H127.706V39.3592H102.571V0.883545Z", fill: "#AAAAAA" } })]);
}, gT = [], mT = /* @__PURE__ */ U(
  fT,
  pT,
  gT,
  !1,
  null,
  null
);
const vT = mT.exports, AT = {
  name: "True360SecondaryWhiteSvg",
  extends: ne
};
var bT = function() {
  var t = this, e = t._self._c;
  return e("svg", { attrs: { viewBox: "0 0 222 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" } }, [e("title", [t._v("True 360")]), e("desc", [t._v("The stylized logo of True 360")]), e("path", { attrs: { d: "M159.702 24.5757C159.366 23.5371 158.881 22.5967 158.245 21.7802C157.61 20.9586 156.824 20.261 155.915 19.703C155.569 19.4911 155.202 19.3103 154.815 19.1552C156.049 18.6023 157.062 17.7962 157.842 16.7421C158.994 15.1816 159.578 13.2852 159.578 11.1098C159.578 9.24438 159.211 7.60635 158.488 6.23702C157.77 4.87802 156.788 3.72571 155.574 2.82661C154.37 1.93266 152.96 1.27125 151.384 0.852701C149.829 0.444485 148.196 0.237793 146.528 0.237793C144.931 0.237793 143.386 0.408314 141.945 0.749355C140.483 1.0904 139.139 1.63296 137.941 2.35638C136.732 3.09014 135.673 4.06676 134.794 5.25007C133.921 6.43854 133.255 7.88538 132.821 9.54408L132.64 10.2313L142.513 12.2672L142.673 11.6368C142.88 10.8049 143.314 10.128 144.001 9.55959C144.678 9.00152 145.52 8.72765 146.574 8.72765C147.7 8.72765 148.62 9.03252 149.379 9.66293C150.103 10.2572 150.454 10.9858 150.454 11.89C150.454 12.6186 150.315 13.2025 150.046 13.6211C149.762 14.0603 149.395 14.391 148.93 14.6287C148.429 14.8871 147.866 15.0628 147.251 15.1558C146.595 15.2539 145.918 15.3056 145.226 15.3056H142.012V23.3924H144.502C145.35 23.3924 146.207 23.4183 147.049 23.4699C147.835 23.5164 148.548 23.6663 149.168 23.9143C149.746 24.1468 150.206 24.4931 150.563 24.9633C150.898 25.4077 151.074 26.0846 151.074 26.963C151.074 28.1773 150.733 29.1385 150.036 29.898C149.364 30.6318 148.263 31.0038 146.776 31.0038C145.298 31.0038 144.182 30.6783 143.469 30.0376C142.725 29.371 142.244 28.4719 141.997 27.2937L141.857 26.6168L132.345 28.8439L132.495 29.5002C133.291 32.9416 134.97 35.5046 137.476 37.1168C139.94 38.7031 142.911 39.504 146.311 39.504C148.155 39.504 149.932 39.2663 151.596 38.8065C153.28 38.3362 154.768 37.6076 156.024 36.6465C157.289 35.6751 158.312 34.4401 159.062 32.9726C159.816 31.4999 160.198 29.774 160.198 27.8466C160.203 26.6995 160.033 25.604 159.702 24.5757Z", fill: "white" } }), e("path", { attrs: { d: "M186.935 21.3047C186.356 19.7597 185.524 18.4059 184.465 17.2742C183.406 16.1426 182.109 15.2383 180.616 14.5769C179.118 13.9207 177.444 13.59 175.631 13.59C175.259 13.59 174.892 13.6106 174.535 13.6571L182.941 0.847412H171.843L163.613 13.6985C163.024 14.6337 162.461 15.5432 161.924 16.4268C161.376 17.3311 160.885 18.2922 160.477 19.2946C160.064 20.2971 159.733 21.3719 159.485 22.488C159.232 23.6145 159.108 24.8753 159.108 26.2343C159.108 28.2237 159.485 30.0529 160.229 31.6703C160.973 33.2825 162.001 34.688 163.288 35.8506C164.574 37.0081 166.098 37.9176 167.834 38.548C169.56 39.1784 171.451 39.4936 173.45 39.4936C175.419 39.4936 177.299 39.1784 179.04 38.548C180.787 37.9176 182.326 37.0081 183.613 35.8506C184.899 34.688 185.933 33.2825 186.677 31.6703C187.421 30.0529 187.803 28.2237 187.803 26.2343C187.808 24.5033 187.514 22.8446 186.935 21.3047ZM178.689 25.9191C178.689 27.4021 178.219 28.5958 177.258 29.562C176.292 30.5283 175.052 30.9986 173.461 30.9986C171.869 30.9986 170.629 30.5283 169.663 29.562C168.697 28.5958 168.232 27.4073 168.232 25.9191C168.232 24.4361 168.702 23.2425 169.663 22.2762C170.629 21.3099 171.869 20.8397 173.461 20.8397C175.052 20.8397 176.292 21.3099 177.258 22.2762C178.219 23.2425 178.689 24.4361 178.689 25.9191Z", fill: "white" } }), e("path", { attrs: { d: "M215.847 13.192C214.989 13.192 214.188 13.0318 213.449 12.7114C212.711 12.3911 212.06 11.9467 211.502 11.3886C210.938 10.8305 210.499 10.1795 210.179 9.43537C209.859 8.69645 209.698 7.89552 209.698 7.03775C209.698 6.17998 209.859 5.37905 210.179 4.64012C210.499 3.9012 210.944 3.25012 211.502 2.69206C212.06 2.13399 212.711 1.6896 213.449 1.36923C214.188 1.04886 214.989 0.888672 215.847 0.888672C216.704 0.888672 217.505 1.04886 218.244 1.36923C218.983 1.6896 219.634 2.13399 220.192 2.69206C220.75 3.25529 221.194 3.9012 221.514 4.64012C221.835 5.37905 221.995 6.17998 221.995 7.03775C221.995 7.89552 221.835 8.69645 221.514 9.43537C221.194 10.1743 220.75 10.8254 220.192 11.3886C219.629 11.9518 218.983 12.3911 218.244 12.7114C217.505 13.0318 216.704 13.192 215.847 13.192ZM215.847 10.8202C216.906 10.8202 217.805 10.4533 218.533 9.72474C219.267 8.99098 219.629 8.09704 219.629 7.03775C219.629 5.97845 219.262 5.07934 218.533 4.35076C217.805 3.617 216.906 3.25529 215.847 3.25529C214.788 3.25529 213.889 3.62217 213.16 4.35076C212.432 5.07934 212.065 5.97845 212.065 7.03775C212.065 8.09704 212.432 8.99098 213.16 9.72474C213.889 10.4533 214.788 10.8202 215.847 10.8202Z", fill: "white" } }), e("path", { attrs: { d: "M212.85 14.1222C212.147 13.8173 211.512 13.4246 210.938 12.9441L205.219 18.6694L205.224 18.7676C205.235 19.1551 205.245 19.522 205.245 19.8579C205.245 20.8035 205.204 21.9507 205.116 23.2735C205.033 24.5446 204.811 25.7848 204.455 26.9526C204.114 28.0636 203.592 29.0092 202.894 29.7688C202.274 30.4457 201.422 30.7712 200.295 30.7712C199.138 30.7712 198.281 30.4457 197.676 29.7739C196.989 29.0143 196.472 28.0636 196.131 26.9526C195.775 25.7796 195.553 24.5446 195.47 23.2735C195.382 21.9662 195.341 20.819 195.341 19.8631C195.341 18.9071 195.382 17.76 195.47 16.4527C195.547 15.1815 195.775 13.9465 196.131 12.7735C196.467 11.6626 196.989 10.717 197.676 9.9522C198.281 9.28045 199.138 8.95491 200.295 8.95491C201.422 8.95491 202.274 9.28562 202.894 9.95737C203.592 10.717 204.119 11.6626 204.455 12.7684C204.656 13.4298 204.821 14.148 204.94 14.9025L205.007 15.3365L209.301 11.0425C209.099 10.7221 208.918 10.3863 208.763 10.0297C208.36 9.10477 208.159 8.10748 208.159 7.03268C208.159 5.95789 208.36 4.9606 208.763 4.03565C208.893 3.74112 209.042 3.45692 209.203 3.18305C208.67 2.70249 208.107 2.26327 207.518 1.87573C205.612 0.635577 203.184 0 200.29 0C197.397 0 194.964 0.635577 193.062 1.88089C191.187 3.11588 189.683 4.72807 188.598 6.67614C187.534 8.58804 186.785 10.7376 186.377 13.0681C185.974 15.352 185.767 17.636 185.767 19.8527C185.767 22.0747 185.974 24.3586 186.377 26.6426C186.79 28.973 187.534 31.1278 188.598 33.0345C189.683 34.9826 191.182 36.5947 193.062 37.8297C194.964 39.0802 197.397 39.7106 200.29 39.7106C203.184 39.7106 205.617 39.0751 207.518 37.8297C209.394 36.5947 210.892 34.9826 211.977 33.0345C213.041 31.1226 213.79 28.973 214.204 26.6426C214.607 24.3534 214.813 22.0695 214.813 19.8527C214.813 18.163 214.679 16.3958 214.426 14.5924C213.878 14.4943 213.351 14.3444 212.85 14.1222Z", fill: "white" } }), e("path", { attrs: { d: "M0 0.883545V4.21645H13.3348V39.3592H16.9255V4.21645H30.2654V0.883545H0Z", fill: "white" } }), e("path", { attrs: { d: "M38.1547 4.02526V19.5426H48.6686C54.8219 19.5426 58.5418 16.8505 58.5418 11.7194C58.5418 6.71742 56.1703 4.02526 48.6014 4.02526H38.1547ZM47.9659 22.6843H38.1547V39.3592H34.564V0.883545H48.9889C58.3506 0.883545 62.1325 5.11556 62.1325 11.7194C62.1325 17.6204 58.5418 21.6612 51.6806 22.4932L64.3128 38.6513V39.354H60.3397L47.9659 22.6843Z", fill: "white" } }), e("path", { attrs: { d: "M93.8445 24.927V0.883545H97.4353V25.0613C97.4353 34.874 92.3049 40.0051 82.69 40.0051C73.008 40.0051 67.175 35.0032 67.175 25.0613V0.883545H70.7657V24.5446C70.7657 31.5979 73.6486 36.791 82.69 36.791C91.2768 36.791 93.8445 32.0475 93.8445 24.927Z", fill: "white" } }), e("path", { attrs: { d: "M102.571 0.883545H127.768V4.15444H106.162V18.07H125.334V21.3357H106.162V36.0883H127.706V39.3592H102.571V0.883545Z", fill: "white" } })]);
}, yT = [], _T = /* @__PURE__ */ U(
  AT,
  bT,
  yT,
  !1,
  null,
  null
);
const xT = _T.exports, CT = {
  name: "AcvLegacyPhoneNumberInput",
  deprecated: "AcvLegacyPhoneNumberInput is deprecated. Please AcvPhoneNumber",
  components: {
    TheMask: Sa.TheMask
  },
  mixins: [
    ue
  ],
  props: {
    value: {
      type: [Number, String],
      default: ""
    },
    mask: {
      type: [String],
      default: "(###) ###-####"
    },
    placeholder: {
      type: [String],
      default: "(555) 555-5555"
    },
    className: {
      type: String,
      default: "form-control"
    }
  },
  data() {
    return {
      defaultvPhoneMaskOptions: {
        mask: this.mask,
        masked: !1,
        allowBlank: !1,
        placeholder: this.placeholder,
        type: "tel"
      }
    };
  },
  computed: {
    vPhoneMaskOptions() {
      return { ...this.defaultvPhoneMaskOptions, ...this.maskOptions };
    }
  }
};
var ST = function() {
  var t = this, e = t._self._c;
  return e("the-mask", t._b({ class: ["acv-phone-number-input", t.className], attrs: { id: t.internalId, name: t.internalId }, on: { keyup: function(n) {
    return t.$emit("keyup", n);
  } }, model: { value: t.internalValue, callback: function(n) {
    t.internalValue = n;
  }, expression: "internalValue" } }, "the-mask", t.vPhoneMaskOptions, !1));
}, wT = [], kT = /* @__PURE__ */ U(
  CT,
  ST,
  wT,
  !1,
  null,
  null
);
const Lg = kT.exports, OT = {
  name: "AcvLegacyPhoneNumberInputWithExtension",
  deprecated: "AcvLegacyPhoneNumberInputWithExtension is deprecated. Please AcvPhoneNumber",
  components: {
    TheMask: Sa.TheMask,
    AcvLegacyPhoneNumberInput: Lg
  },
  mixins: [
    ue
  ],
  props: {
    additionalClasses: {
      type: String,
      default: ""
    },
    value: {
      type: Object,
      default: () => ({
        phone: "",
        extension: ""
      })
    },
    phoneMask: {
      type: [String],
      default: "(###) ###-####"
    },
    phonePlaceholder: {
      type: [String],
      default: "(555) 555-5555"
    },
    className: {
      type: String,
      default: "form-control"
    },
    extMask: {
      type: String,
      default: "x###"
    },
    extPlaceholder: {
      type: String,
      default: "x123"
    }
  },
  data() {
    return {
      defaultExtensionMaskOptions: {
        mask: this.extMask,
        masked: !1,
        allowBlank: !1,
        placeholder: this.extPlaceholder,
        type: "tel"
      }
    };
  },
  computed: {
    internalPhone: {
      get() {
        return this.internalValue.phone;
      },
      set(i) {
        this.internalValue = {
          phone: i,
          extension: this.internalValue.extension
        };
      }
    },
    internalExtension: {
      get() {
        return this.internalValue.extension;
      },
      set(i) {
        this.internalValue = {
          phone: this.internalValue.phone,
          extension: i
        };
      }
    },
    extensionMaskOptions() {
      return { ...this.defaultExtensionMaskOptions, ...this.maskOptions };
    }
  }
};
var MT = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "acv-phone-with-extension tw-flexbox-row-align-center" }, [e("acv-legacy-phone-number-input", { class: t.additionalClasses, attrs: { id: `phone-number-w-ext-${t.internalId}`, name: `phone-number-w-ext-${t.internalId}`, placeholder: t.phonePlaceholder, mask: t.phoneMask }, on: { keyup: function(n) {
    return t.$emit("keyup", n);
  } }, model: { value: t.internalPhone, callback: function(n) {
    t.internalPhone = n;
  }, expression: "internalPhone" } }), e("the-mask", t._b({ staticClass: "form-control acv-phone-number-extension-input", class: t.additionalClasses, attrs: { id: `phone-number-w-ext-ext-${t.internalId}`, name: `phone-number-w-ext-ext-${t.internalId}` }, on: { keyup: function(n) {
    return t.$emit("keyup", n);
  } }, model: { value: t.internalExtension, callback: function(n) {
    t.internalExtension = n;
  }, expression: "internalExtension" } }, "the-mask", t.extensionMaskOptions, !1))], 1);
}, TT = [], DT = /* @__PURE__ */ U(
  OT,
  MT,
  TT,
  !1,
  null,
  "9d9c1885"
);
const PT = DT.exports, LT = {
  name: "AcvLegacyZipCodeInput",
  deprecated: "AcvLegacyZipCodeInput is deprecated. Please AcvZipCodeInput",
  directives: {
    mask: Sa.mask
  },
  components: {
    AcvLabel: wa
  },
  mixins: [
    ue
  ],
  props: {
    value: {
      type: [String, Number],
      required: !0
    },
    label: {
      type: String,
      default: "Zip Code"
    },
    placeholder: {
      type: String,
      default: "12345"
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  data: () => ({
    zipCodeMask: "#####"
  })
};
var IT = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "zip-code-input tw-flexbox-col-align-start-wrap", class: {
    disabled: t.disabled
  } }, [t._t("label", function() {
    return [e("acv-label", { staticClass: "zip-code-input-label", attrs: { tag: "label", for: `${t.internalId}-zipCode` } }, [t._v(" " + t._s(t.label) + " ")])];
  }), e("input", { directives: [{ name: "model", rawName: "v-model", value: t.internalValue, expression: "internalValue" }, { name: "mask", rawName: "v-mask", value: t.zipCodeMask, expression: "zipCodeMask" }], attrs: { id: `${t.internalId}-zipCode`, type: "text", name: `${t.internalId}-zipCode`, placeholder: t.placeholder, disabled: t.disabled }, domProps: { value: t.internalValue }, on: { blur: function(n) {
    return t.$emit("inputFocusLost", n);
  }, input: function(n) {
    n.target.composing || (t.internalValue = n.target.value);
  } } })], 2);
}, ET = [], $T = /* @__PURE__ */ U(
  LT,
  IT,
  ET,
  !1,
  null,
  "fe7e792e"
);
const BT = $T.exports, Zd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AcvAnimatedInteger: F6,
  AcvAuctionsPrimaryDarkSvg: aM,
  AcvAuctionsPrimaryLightSvg: dM,
  AcvAuctionsSecondaryBlackSvg: mM,
  AcvAuctionsSecondaryGraySvg: _M,
  AcvAuctionsSecondaryWhiteSvg: kM,
  AcvBadge: xa,
  AcvBanner: Qd,
  AcvBaseInput: Ce,
  AcvBaseSvg: ne,
  AcvBottomNavigation: $1,
  AcvBottomSheet: J1,
  AcvButton: bi,
  AcvCallToActionTable: Zx,
  AcvCapitalPrimaryDarkSvg: PM,
  AcvCapitalPrimaryLightSvg: BM,
  AcvCapitalSecondaryDarkSvg: VM,
  AcvCard: th,
  AcvCardSubtitle: bm,
  AcvCardText: Sm,
  AcvCardTitle: Tm,
  AcvCheckbox: ls,
  AcvCheckboxList: e2,
  AcvCheckboxTree: A2,
  AcvChip: Em,
  AcvCollapse: eh,
  AcvConfirmationTextInputs: O2,
  AcvCurrencyInput: yh,
  AcvDataGrid: Cl,
  AcvDataPagination: sh,
  AcvDataTable: e0,
  AcvDateField: Yv,
  AcvDialog: m0,
  AcvDivider: Js,
  AcvEmptyState: k0,
  AcvEventTimeline: O_,
  AcvExpansionPanel: $0,
  AcvFadeIn: j6,
  AcvFileUpload: eC,
  AcvFlexbox: Oa,
  AcvFloatingActionButton: Xv,
  AcvFlyoutMenu: tp,
  AcvGallery: Tb,
  AcvGalleryCategoryBar: Hh,
  AcvGalleryList: Vh,
  AcvGraph: LO,
  AcvIcon: ie,
  AcvIconButton: Ee,
  AcvIntersectionObserver: Lh,
  AcvLabel: wa,
  AcvLazyImage: Dl,
  AcvLegacyPhoneNumberInput: Lg,
  AcvLegacyPhoneNumberInputWithExtension: PT,
  AcvLegacyZipCodeInput: BT,
  AcvLightbox: jh,
  AcvList: cs,
  AcvListButton: Wh,
  AcvListButtonList: my,
  AcvListItem: us,
  AcvListItemContent: vh,
  AcvListItemIcon: Qb,
  AcvListItemSubtitle: iy,
  AcvListItemTitle: oy,
  AcvLoadingIndicator: _y,
  AcvMenu: UO,
  AcvMenuList: Pg,
  AcvMenuListItem: Dg,
  AcvMobileOverlay: Uy,
  AcvMoney: bh,
  AcvMoneyField: e3,
  AcvMultiSelect: a3,
  AcvNavigationDrawer: Gh,
  AcvNavigationDrawerItem: Zh,
  AcvPagination: oh,
  AcvPhoneNumber: d3,
  AcvProgressBar: Kh,
  AcvProgressIndicator: Ca,
  AcvPullToRefresh: d_,
  AcvRadio: Ol,
  AcvRadioTree: y3,
  AcvRangeSlider: U3,
  AcvScrollbar: ka,
  AcvSearchBar: J3,
  AcvSegmentedControl: Dh,
  AcvSelect: Sl,
  AcvSelectField: oA,
  AcvSlideOut: m_,
  AcvSnackbar: Uh,
  AcvSnackbarList: By,
  AcvStatusBadge: Xh,
  AcvStepper: L_,
  AcvStepperContent: V_,
  AcvStepperHeader: U_,
  AcvStepperItems: Q_,
  AcvStepperStep: i5,
  AcvSvgGradient: eM,
  AcvTable: Vb,
  AcvTextField: Pe,
  AcvTextarea: hA,
  AcvTimeCounter: o5,
  AcvTimeField: vA,
  AcvToastMessage: Yh,
  AcvToastMessageList: Py,
  AcvToggleButtonGroup: xA,
  AcvToggleSwitch: Ph,
  AcvTooltip: os,
  AcvTopBar: h5,
  AcvTour: b5,
  AcvTransportationPrimaryDarkSvg: UM,
  AcvTransportationSecondaryDarkSvg: QM,
  AcvValidationMessages: hh,
  AcvVisibilityChange: G6,
  AcvZipCodeInput: PA,
  True360PrimaryDarkSvg: iT,
  True360PrimaryLightSvg: oT,
  True360SecondaryBlackSvg: hT,
  True360SecondaryGraySvg: vT,
  True360SecondaryWhiteSvg: xT
}, Symbol.toStringTag, { value: "Module" }));
var Ig = {}, Eg = {}, Sc = {};
(function(i) {
  Object.defineProperty(i, "__esModule", {
    value: !0
  }), Object.defineProperty(i, "default", {
    enumerable: !0,
    get: function() {
      return t;
    }
  });
  function t(e) {
    if (e = `${e}`, e === "0")
      return "0";
    if (/^[+-]?(\d+|\d*\.\d+)(e[+-]?\d+)?(%|\w+)?$/.test(e))
      return e.replace(/^[+-]?/, (s) => s === "-" ? "" : "-");
    let n = [
      "var",
      "calc",
      "min",
      "max",
      "clamp"
    ];
    for (const s of n)
      if (e.includes(`${s}(`))
        return `calc(${e} * -1)`;
  }
})(Sc);
var $g = {};
(function(i) {
  Object.defineProperty(i, "__esModule", {
    value: !0
  }), Object.defineProperty(i, "default", {
    enumerable: !0,
    get: function() {
      return t;
    }
  });
  const t = [
    "preflight",
    "container",
    "accessibility",
    "pointerEvents",
    "visibility",
    "position",
    "inset",
    "isolation",
    "zIndex",
    "order",
    "gridColumn",
    "gridColumnStart",
    "gridColumnEnd",
    "gridRow",
    "gridRowStart",
    "gridRowEnd",
    "float",
    "clear",
    "margin",
    "boxSizing",
    "lineClamp",
    "display",
    "aspectRatio",
    "size",
    "height",
    "maxHeight",
    "minHeight",
    "width",
    "minWidth",
    "maxWidth",
    "flex",
    "flexShrink",
    "flexGrow",
    "flexBasis",
    "tableLayout",
    "captionSide",
    "borderCollapse",
    "borderSpacing",
    "transformOrigin",
    "translate",
    "rotate",
    "skew",
    "scale",
    "transform",
    "animation",
    "cursor",
    "touchAction",
    "userSelect",
    "resize",
    "scrollSnapType",
    "scrollSnapAlign",
    "scrollSnapStop",
    "scrollMargin",
    "scrollPadding",
    "listStylePosition",
    "listStyleType",
    "listStyleImage",
    "appearance",
    "columns",
    "breakBefore",
    "breakInside",
    "breakAfter",
    "gridAutoColumns",
    "gridAutoFlow",
    "gridAutoRows",
    "gridTemplateColumns",
    "gridTemplateRows",
    "flexDirection",
    "flexWrap",
    "placeContent",
    "placeItems",
    "alignContent",
    "alignItems",
    "justifyContent",
    "justifyItems",
    "gap",
    "space",
    "divideWidth",
    "divideStyle",
    "divideColor",
    "divideOpacity",
    "placeSelf",
    "alignSelf",
    "justifySelf",
    "overflow",
    "overscrollBehavior",
    "scrollBehavior",
    "textOverflow",
    "hyphens",
    "whitespace",
    "textWrap",
    "wordBreak",
    "borderRadius",
    "borderWidth",
    "borderStyle",
    "borderColor",
    "borderOpacity",
    "backgroundColor",
    "backgroundOpacity",
    "backgroundImage",
    "gradientColorStops",
    "boxDecorationBreak",
    "backgroundSize",
    "backgroundAttachment",
    "backgroundClip",
    "backgroundPosition",
    "backgroundRepeat",
    "backgroundOrigin",
    "fill",
    "stroke",
    "strokeWidth",
    "objectFit",
    "objectPosition",
    "padding",
    "textAlign",
    "textIndent",
    "verticalAlign",
    "fontFamily",
    "fontSize",
    "fontWeight",
    "textTransform",
    "fontStyle",
    "fontVariantNumeric",
    "lineHeight",
    "letterSpacing",
    "textColor",
    "textOpacity",
    "textDecoration",
    "textDecorationColor",
    "textDecorationStyle",
    "textDecorationThickness",
    "textUnderlineOffset",
    "fontSmoothing",
    "placeholderColor",
    "placeholderOpacity",
    "caretColor",
    "accentColor",
    "opacity",
    "backgroundBlendMode",
    "mixBlendMode",
    "boxShadow",
    "boxShadowColor",
    "outlineStyle",
    "outlineWidth",
    "outlineOffset",
    "outlineColor",
    "ringWidth",
    "ringColor",
    "ringOpacity",
    "ringOffsetWidth",
    "ringOffsetColor",
    "blur",
    "brightness",
    "contrast",
    "dropShadow",
    "grayscale",
    "hueRotate",
    "invert",
    "saturate",
    "sepia",
    "filter",
    "backdropBlur",
    "backdropBrightness",
    "backdropContrast",
    "backdropGrayscale",
    "backdropHueRotate",
    "backdropInvert",
    "backdropOpacity",
    "backdropSaturate",
    "backdropSepia",
    "backdropFilter",
    "transitionProperty",
    "transitionDelay",
    "transitionDuration",
    "transitionTimingFunction",
    "willChange",
    "contain",
    "content",
    "forcedColorAdjust"
  ];
})($g);
var Bg = {};
(function(i) {
  Object.defineProperty(i, "__esModule", {
    value: !0
  }), Object.defineProperty(i, "default", {
    enumerable: !0,
    get: function() {
      return t;
    }
  });
  function t(e, n) {
    return e === void 0 ? n : Array.isArray(e) ? e : [
      ...new Set(n.filter((r) => e !== !1 && e[r] !== !1).concat(Object.keys(e).filter((r) => e[r] !== !1)))
    ];
  }
})(Bg);
var Rg = {}, Ya = {}, wc = { exports: {} }, vt = String, Fg = function() {
  return { isColorSupported: !1, reset: vt, bold: vt, dim: vt, italic: vt, underline: vt, inverse: vt, hidden: vt, strikethrough: vt, black: vt, red: vt, green: vt, yellow: vt, blue: vt, magenta: vt, cyan: vt, white: vt, gray: vt, bgBlack: vt, bgRed: vt, bgGreen: vt, bgYellow: vt, bgBlue: vt, bgMagenta: vt, bgCyan: vt, bgWhite: vt, blackBright: vt, redBright: vt, greenBright: vt, yellowBright: vt, blueBright: vt, magentaBright: vt, cyanBright: vt, whiteBright: vt, bgBlackBright: vt, bgRedBright: vt, bgGreenBright: vt, bgYellowBright: vt, bgBlueBright: vt, bgMagentaBright: vt, bgCyanBright: vt, bgWhiteBright: vt };
};
wc.exports = Fg();
wc.exports.createColors = Fg;
var Ng = wc.exports;
(function(i) {
  var t = { npm_config_user_agent: "npm/10.9.2 node/v22.14.0 linux x64 workspaces/false", NODE_VERSION: "22.14.0", HOSTNAME: "804d0c43b6a1", YARN_VERSION: "1.22.22", npm_node_execpath: "/usr/local/bin/node", SHLVL: "2", npm_config_noproxy: "", HOME: "/root", npm_package_json: "/app/package.json", npm_config_userconfig: "/root/.npmrc", npm_config_local_prefix: "/app", COLOR: "0", npm_config_prefix: "/usr/local", npm_config_npm_version: "10.9.2", npm_config_registry: "https://nexus.infra.acvauctions.com/repository/npm-public/", npm_config_cache: "/root/.npm", npm_config_node_gyp: "/usr/local/lib/node_modules/npm/node_modules/node-gyp/bin/node-gyp.js", PATH: "/app/node_modules/.bin:/node_modules/.bin:/usr/local/lib/node_modules/npm/node_modules/@npmcli/run-script/lib/node-gyp-bin:/usr/local/sbin:/usr/local/bin:/usr/sbin:/usr/bin:/sbin:/bin", NODE: "/usr/local/bin/node", npm_package_name: "@acv/shared-vuejs", npm_lifecycle_script: "vite build", npm_package_version: "3.45.0", npm_lifecycle_event: "build", npm_config_globalconfig: "/usr/local/etc/npmrc", npm_config_init_module: "/root/.npm-init.js", PWD: "/app", npm_execpath: "/usr/local/lib/node_modules/npm/bin/npm-cli.js", npm_config_global_prefix: "/usr/local", npm_command: "run-script", INIT_CWD: "/app", EDITOR: "vi", NODE_ENV: "production" };
  Object.defineProperty(i, "__esModule", {
    value: !0
  });
  function e(c, u) {
    for (var d in u) Object.defineProperty(c, d, {
      enumerable: !0,
      get: u[d]
    });
  }
  e(i, {
    dim: function() {
      return o;
    },
    default: function() {
      return l;
    }
  });
  const n = /* @__PURE__ */ s(Ng);
  function s(c) {
    return c && c.__esModule ? c : {
      default: c
    };
  }
  let r = /* @__PURE__ */ new Set();
  function a(c, u, d) {
    typeof process < "u" && t.JEST_WORKER_ID || d && r.has(d) || (d && r.add(d), console.warn(""), u.forEach((h) => console.warn(c, "-", h)));
  }
  function o(c) {
    return n.default.dim(c);
  }
  const l = {
    info(c, u) {
      a(n.default.bold(n.default.cyan("info")), ...Array.isArray(c) ? [
        c
      ] : [
        u,
        c
      ]);
    },
    warn(c, u) {
      a(n.default.bold(n.default.yellow("warn")), ...Array.isArray(c) ? [
        c
      ] : [
        u,
        c
      ]);
    },
    risk(c, u) {
      a(n.default.bold(n.default.magenta("risk")), ...Array.isArray(c) ? [
        c
      ] : [
        u,
        c
      ]);
    }
  };
})(Ya);
(function(i) {
  Object.defineProperty(i, "__esModule", {
    value: !0
  }), Object.defineProperty(i, "default", {
    enumerable: !0,
    get: function() {
      return s;
    }
  });
  const t = /* @__PURE__ */ e(Ya);
  function e(r) {
    return r && r.__esModule ? r : {
      default: r
    };
  }
  function n({ version: r, from: a, to: o }) {
    t.default.warn(`${a}-color-renamed`, [
      `As of Tailwind CSS ${r}, \`${a}\` has been renamed to \`${o}\`.`,
      "Update your configuration file to silence this warning."
    ]);
  }
  const s = {
    inherit: "inherit",
    current: "currentColor",
    transparent: "transparent",
    black: "#000",
    white: "#fff",
    slate: {
      50: "#f8fafc",
      100: "#f1f5f9",
      200: "#e2e8f0",
      300: "#cbd5e1",
      400: "#94a3b8",
      500: "#64748b",
      600: "#475569",
      700: "#334155",
      800: "#1e293b",
      900: "#0f172a",
      950: "#020617"
    },
    gray: {
      50: "#f9fafb",
      100: "#f3f4f6",
      200: "#e5e7eb",
      300: "#d1d5db",
      400: "#9ca3af",
      500: "#6b7280",
      600: "#4b5563",
      700: "#374151",
      800: "#1f2937",
      900: "#111827",
      950: "#030712"
    },
    zinc: {
      50: "#fafafa",
      100: "#f4f4f5",
      200: "#e4e4e7",
      300: "#d4d4d8",
      400: "#a1a1aa",
      500: "#71717a",
      600: "#52525b",
      700: "#3f3f46",
      800: "#27272a",
      900: "#18181b",
      950: "#09090b"
    },
    neutral: {
      50: "#fafafa",
      100: "#f5f5f5",
      200: "#e5e5e5",
      300: "#d4d4d4",
      400: "#a3a3a3",
      500: "#737373",
      600: "#525252",
      700: "#404040",
      800: "#262626",
      900: "#171717",
      950: "#0a0a0a"
    },
    stone: {
      50: "#fafaf9",
      100: "#f5f5f4",
      200: "#e7e5e4",
      300: "#d6d3d1",
      400: "#a8a29e",
      500: "#78716c",
      600: "#57534e",
      700: "#44403c",
      800: "#292524",
      900: "#1c1917",
      950: "#0c0a09"
    },
    red: {
      50: "#fef2f2",
      100: "#fee2e2",
      200: "#fecaca",
      300: "#fca5a5",
      400: "#f87171",
      500: "#ef4444",
      600: "#dc2626",
      700: "#b91c1c",
      800: "#991b1b",
      900: "#7f1d1d",
      950: "#450a0a"
    },
    orange: {
      50: "#fff7ed",
      100: "#ffedd5",
      200: "#fed7aa",
      300: "#fdba74",
      400: "#fb923c",
      500: "#f97316",
      600: "#ea580c",
      700: "#c2410c",
      800: "#9a3412",
      900: "#7c2d12",
      950: "#431407"
    },
    amber: {
      50: "#fffbeb",
      100: "#fef3c7",
      200: "#fde68a",
      300: "#fcd34d",
      400: "#fbbf24",
      500: "#f59e0b",
      600: "#d97706",
      700: "#b45309",
      800: "#92400e",
      900: "#78350f",
      950: "#451a03"
    },
    yellow: {
      50: "#fefce8",
      100: "#fef9c3",
      200: "#fef08a",
      300: "#fde047",
      400: "#facc15",
      500: "#eab308",
      600: "#ca8a04",
      700: "#a16207",
      800: "#854d0e",
      900: "#713f12",
      950: "#422006"
    },
    lime: {
      50: "#f7fee7",
      100: "#ecfccb",
      200: "#d9f99d",
      300: "#bef264",
      400: "#a3e635",
      500: "#84cc16",
      600: "#65a30d",
      700: "#4d7c0f",
      800: "#3f6212",
      900: "#365314",
      950: "#1a2e05"
    },
    green: {
      50: "#f0fdf4",
      100: "#dcfce7",
      200: "#bbf7d0",
      300: "#86efac",
      400: "#4ade80",
      500: "#22c55e",
      600: "#16a34a",
      700: "#15803d",
      800: "#166534",
      900: "#14532d",
      950: "#052e16"
    },
    emerald: {
      50: "#ecfdf5",
      100: "#d1fae5",
      200: "#a7f3d0",
      300: "#6ee7b7",
      400: "#34d399",
      500: "#10b981",
      600: "#059669",
      700: "#047857",
      800: "#065f46",
      900: "#064e3b",
      950: "#022c22"
    },
    teal: {
      50: "#f0fdfa",
      100: "#ccfbf1",
      200: "#99f6e4",
      300: "#5eead4",
      400: "#2dd4bf",
      500: "#14b8a6",
      600: "#0d9488",
      700: "#0f766e",
      800: "#115e59",
      900: "#134e4a",
      950: "#042f2e"
    },
    cyan: {
      50: "#ecfeff",
      100: "#cffafe",
      200: "#a5f3fc",
      300: "#67e8f9",
      400: "#22d3ee",
      500: "#06b6d4",
      600: "#0891b2",
      700: "#0e7490",
      800: "#155e75",
      900: "#164e63",
      950: "#083344"
    },
    sky: {
      50: "#f0f9ff",
      100: "#e0f2fe",
      200: "#bae6fd",
      300: "#7dd3fc",
      400: "#38bdf8",
      500: "#0ea5e9",
      600: "#0284c7",
      700: "#0369a1",
      800: "#075985",
      900: "#0c4a6e",
      950: "#082f49"
    },
    blue: {
      50: "#eff6ff",
      100: "#dbeafe",
      200: "#bfdbfe",
      300: "#93c5fd",
      400: "#60a5fa",
      500: "#3b82f6",
      600: "#2563eb",
      700: "#1d4ed8",
      800: "#1e40af",
      900: "#1e3a8a",
      950: "#172554"
    },
    indigo: {
      50: "#eef2ff",
      100: "#e0e7ff",
      200: "#c7d2fe",
      300: "#a5b4fc",
      400: "#818cf8",
      500: "#6366f1",
      600: "#4f46e5",
      700: "#4338ca",
      800: "#3730a3",
      900: "#312e81",
      950: "#1e1b4b"
    },
    violet: {
      50: "#f5f3ff",
      100: "#ede9fe",
      200: "#ddd6fe",
      300: "#c4b5fd",
      400: "#a78bfa",
      500: "#8b5cf6",
      600: "#7c3aed",
      700: "#6d28d9",
      800: "#5b21b6",
      900: "#4c1d95",
      950: "#2e1065"
    },
    purple: {
      50: "#faf5ff",
      100: "#f3e8ff",
      200: "#e9d5ff",
      300: "#d8b4fe",
      400: "#c084fc",
      500: "#a855f7",
      600: "#9333ea",
      700: "#7e22ce",
      800: "#6b21a8",
      900: "#581c87",
      950: "#3b0764"
    },
    fuchsia: {
      50: "#fdf4ff",
      100: "#fae8ff",
      200: "#f5d0fe",
      300: "#f0abfc",
      400: "#e879f9",
      500: "#d946ef",
      600: "#c026d3",
      700: "#a21caf",
      800: "#86198f",
      900: "#701a75",
      950: "#4a044e"
    },
    pink: {
      50: "#fdf2f8",
      100: "#fce7f3",
      200: "#fbcfe8",
      300: "#f9a8d4",
      400: "#f472b6",
      500: "#ec4899",
      600: "#db2777",
      700: "#be185d",
      800: "#9d174d",
      900: "#831843",
      950: "#500724"
    },
    rose: {
      50: "#fff1f2",
      100: "#ffe4e6",
      200: "#fecdd3",
      300: "#fda4af",
      400: "#fb7185",
      500: "#f43f5e",
      600: "#e11d48",
      700: "#be123c",
      800: "#9f1239",
      900: "#881337",
      950: "#4c0519"
    },
    get lightBlue() {
      return n({
        version: "v2.2",
        from: "lightBlue",
        to: "sky"
      }), this.sky;
    },
    get warmGray() {
      return n({
        version: "v3.0",
        from: "warmGray",
        to: "stone"
      }), this.stone;
    },
    get trueGray() {
      return n({
        version: "v3.0",
        from: "trueGray",
        to: "neutral"
      }), this.neutral;
    },
    get coolGray() {
      return n({
        version: "v3.0",
        from: "coolGray",
        to: "gray"
      }), this.gray;
    },
    get blueGray() {
      return n({
        version: "v3.0",
        from: "blueGray",
        to: "slate"
      }), this.slate;
    }
  };
})(Rg);
var Hg = {};
(function(i) {
  Object.defineProperty(i, "__esModule", {
    value: !0
  }), Object.defineProperty(i, "defaults", {
    enumerable: !0,
    get: function() {
      return t;
    }
  });
  function t(e, ...n) {
    for (let a of n) {
      for (let o in a) {
        var s;
        !(e == null || (s = e.hasOwnProperty) === null || s === void 0) && s.call(e, o) || (e[o] = a[o]);
      }
      for (let o of Object.getOwnPropertySymbols(a)) {
        var r;
        !(e == null || (r = e.hasOwnProperty) === null || r === void 0) && r.call(e, o) || (e[o] = a[o]);
      }
    }
    return e;
  }
})(Hg);
var Vg = {};
(function(i) {
  Object.defineProperty(i, "__esModule", {
    value: !0
  }), Object.defineProperty(i, "toPath", {
    enumerable: !0,
    get: function() {
      return t;
    }
  });
  function t(e) {
    if (Array.isArray(e)) return e;
    let n = e.split("[").length - 1, s = e.split("]").length - 1;
    if (n !== s)
      throw new Error(`Path is invalid. Has unbalanced brackets: ${e}`);
    return e.split(/\.(?![^\[]*\])|[\[\]]/g).filter(Boolean);
  }
})(Vg);
var zg = {}, Ua = {};
(function(i) {
  var t = { npm_config_user_agent: "npm/10.9.2 node/v22.14.0 linux x64 workspaces/false", NODE_VERSION: "22.14.0", HOSTNAME: "804d0c43b6a1", YARN_VERSION: "1.22.22", npm_node_execpath: "/usr/local/bin/node", SHLVL: "2", npm_config_noproxy: "", HOME: "/root", npm_package_json: "/app/package.json", npm_config_userconfig: "/root/.npmrc", npm_config_local_prefix: "/app", COLOR: "0", npm_config_prefix: "/usr/local", npm_config_npm_version: "10.9.2", npm_config_registry: "https://nexus.infra.acvauctions.com/repository/npm-public/", npm_config_cache: "/root/.npm", npm_config_node_gyp: "/usr/local/lib/node_modules/npm/node_modules/node-gyp/bin/node-gyp.js", PATH: "/app/node_modules/.bin:/node_modules/.bin:/usr/local/lib/node_modules/npm/node_modules/@npmcli/run-script/lib/node-gyp-bin:/usr/local/sbin:/usr/local/bin:/usr/sbin:/usr/bin:/sbin:/bin", NODE: "/usr/local/bin/node", npm_package_name: "@acv/shared-vuejs", npm_lifecycle_script: "vite build", npm_package_version: "3.45.0", npm_lifecycle_event: "build", npm_config_globalconfig: "/usr/local/etc/npmrc", npm_config_init_module: "/root/.npm-init.js", PWD: "/app", npm_execpath: "/usr/local/lib/node_modules/npm/bin/npm-cli.js", npm_config_global_prefix: "/usr/local", npm_command: "run-script", INIT_CWD: "/app", EDITOR: "vi", NODE_ENV: "production" };
  Object.defineProperty(i, "__esModule", {
    value: !0
  });
  function e(h, f) {
    for (var p in f) Object.defineProperty(h, p, {
      enumerable: !0,
      get: f[p]
    });
  }
  e(i, {
    flagEnabled: function() {
      return l;
    },
    issueFlagNotices: function() {
      return u;
    },
    default: function() {
      return d;
    }
  });
  const n = /* @__PURE__ */ r(Ng), s = /* @__PURE__ */ r(Ya);
  function r(h) {
    return h && h.__esModule ? h : {
      default: h
    };
  }
  let a = {
    optimizeUniversalDefaults: !1,
    generalizedModifiers: !0,
    disableColorOpacityUtilitiesByDefault: !1,
    relativeContentPathsByDefault: !1
  }, o = {
    future: [
      "hoverOnlyWhenSupported",
      "respectDefaultRingColorOpacity",
      "disableColorOpacityUtilitiesByDefault",
      "relativeContentPathsByDefault"
    ],
    experimental: [
      "optimizeUniversalDefaults",
      "generalizedModifiers"
    ]
  };
  function l(h, f) {
    if (o.future.includes(f)) {
      var p, g, m;
      return h.future === "all" || ((m = (g = h == null || (p = h.future) === null || p === void 0 ? void 0 : p[f]) !== null && g !== void 0 ? g : a[f]) !== null && m !== void 0 ? m : !1);
    }
    if (o.experimental.includes(f)) {
      var v, b, _;
      return h.experimental === "all" || ((_ = (b = h == null || (v = h.experimental) === null || v === void 0 ? void 0 : v[f]) !== null && b !== void 0 ? b : a[f]) !== null && _ !== void 0 ? _ : !1);
    }
    return !1;
  }
  function c(h) {
    if (h.experimental === "all")
      return o.experimental;
    var f;
    return Object.keys((f = h == null ? void 0 : h.experimental) !== null && f !== void 0 ? f : {}).filter((p) => o.experimental.includes(p) && h.experimental[p]);
  }
  function u(h) {
    if (t.JEST_WORKER_ID === void 0 && c(h).length > 0) {
      let f = c(h).map((p) => n.default.yellow(p)).join(", ");
      s.default.warn("experimental-flags-enabled", [
        `You have enabled experimental features: ${f}`,
        "Experimental features in Tailwind CSS are not covered by semver, may introduce breaking changes, and can change at any time."
      ]);
    }
  }
  const d = o;
})(Ua);
(function(i) {
  Object.defineProperty(i, "__esModule", {
    value: !0
  }), Object.defineProperty(i, "normalizeConfig", {
    enumerable: !0,
    get: function() {
      return r;
    }
  });
  const t = Ua, e = /* @__PURE__ */ s(Ya);
  function n(a) {
    if (typeof WeakMap != "function") return null;
    var o = /* @__PURE__ */ new WeakMap(), l = /* @__PURE__ */ new WeakMap();
    return (n = function(c) {
      return c ? l : o;
    })(a);
  }
  function s(a, o) {
    if (a && a.__esModule)
      return a;
    if (a === null || typeof a != "object" && typeof a != "function")
      return {
        default: a
      };
    var l = n(o);
    if (l && l.has(a))
      return l.get(a);
    var c = {}, u = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var d in a)
      if (d !== "default" && Object.prototype.hasOwnProperty.call(a, d)) {
        var h = u ? Object.getOwnPropertyDescriptor(a, d) : null;
        h && (h.get || h.set) ? Object.defineProperty(c, d, h) : c[d] = a[d];
      }
    return c.default = a, l && l.set(a, c), c;
  }
  function r(a) {
    if ((() => {
      if (a.purge || !a.content || !Array.isArray(a.content) && !(typeof a.content == "object" && a.content !== null))
        return !1;
      if (Array.isArray(a.content))
        return a.content.every((c) => typeof c == "string" ? !0 : !(typeof (c == null ? void 0 : c.raw) != "string" || c != null && c.extension && typeof (c == null ? void 0 : c.extension) != "string"));
      if (typeof a.content == "object" && a.content !== null) {
        if (Object.keys(a.content).some((c) => ![
          "files",
          "relative",
          "extract",
          "transform"
        ].includes(c)))
          return !1;
        if (Array.isArray(a.content.files)) {
          if (!a.content.files.every((c) => typeof c == "string" ? !0 : !(typeof (c == null ? void 0 : c.raw) != "string" || c != null && c.extension && typeof (c == null ? void 0 : c.extension) != "string")))
            return !1;
          if (typeof a.content.extract == "object") {
            for (let c of Object.values(a.content.extract))
              if (typeof c != "function")
                return !1;
          } else if (!(a.content.extract === void 0 || typeof a.content.extract == "function"))
            return !1;
          if (typeof a.content.transform == "object") {
            for (let c of Object.values(a.content.transform))
              if (typeof c != "function")
                return !1;
          } else if (!(a.content.transform === void 0 || typeof a.content.transform == "function"))
            return !1;
          if (typeof a.content.relative != "boolean" && typeof a.content.relative < "u")
            return !1;
        }
        return !0;
      }
      return !1;
    })() || e.default.warn("purge-deprecation", [
      "The `purge`/`content` options have changed in Tailwind CSS v3.0.",
      "Update your configuration file to eliminate this warning.",
      "https://tailwindcss.com/docs/upgrade-guide#configure-content-sources"
    ]), a.safelist = (() => {
      var c;
      let { content: u, purge: d, safelist: h } = a;
      return Array.isArray(h) ? h : Array.isArray(u == null ? void 0 : u.safelist) ? u.safelist : Array.isArray(d == null ? void 0 : d.safelist) ? d.safelist : Array.isArray(d == null || (c = d.options) === null || c === void 0 ? void 0 : c.safelist) ? d.options.safelist : [];
    })(), a.blocklist = (() => {
      let { blocklist: c } = a;
      if (Array.isArray(c)) {
        if (c.every((u) => typeof u == "string"))
          return c;
        e.default.warn("blocklist-invalid", [
          "The `blocklist` option must be an array of strings.",
          "https://tailwindcss.com/docs/content-configuration#discarding-classes"
        ]);
      }
      return [];
    })(), typeof a.prefix == "function")
      e.default.warn("prefix-function", [
        "As of Tailwind CSS v3.0, `prefix` cannot be a function.",
        "Update `prefix` in your configuration to be a string to eliminate this warning.",
        "https://tailwindcss.com/docs/upgrade-guide#prefix-cannot-be-a-function"
      ]), a.prefix = "";
    else {
      var l;
      a.prefix = (l = a.prefix) !== null && l !== void 0 ? l : "";
    }
    a.content = {
      relative: (() => {
        let { content: c } = a;
        return c != null && c.relative ? c.relative : (0, t.flagEnabled)(a, "relativeContentPathsByDefault");
      })(),
      files: (() => {
        let { content: c, purge: u } = a;
        return Array.isArray(u) ? u : Array.isArray(u == null ? void 0 : u.content) ? u.content : Array.isArray(c) ? c : Array.isArray(c == null ? void 0 : c.content) ? c.content : Array.isArray(c == null ? void 0 : c.files) ? c.files : [];
      })(),
      extract: (() => {
        let c = (() => {
          var h, f, p, g, m, v, b, _, S, C;
          return !((h = a.purge) === null || h === void 0) && h.extract ? a.purge.extract : !((f = a.content) === null || f === void 0) && f.extract ? a.content.extract : !((p = a.purge) === null || p === void 0 || (g = p.extract) === null || g === void 0) && g.DEFAULT ? a.purge.extract.DEFAULT : !((m = a.content) === null || m === void 0 || (v = m.extract) === null || v === void 0) && v.DEFAULT ? a.content.extract.DEFAULT : !((b = a.purge) === null || b === void 0 || (_ = b.options) === null || _ === void 0) && _.extractors ? a.purge.options.extractors : !((S = a.content) === null || S === void 0 || (C = S.options) === null || C === void 0) && C.extractors ? a.content.options.extractors : {};
        })(), u = {}, d = (() => {
          var h, f, p, g;
          if (!((h = a.purge) === null || h === void 0 || (f = h.options) === null || f === void 0) && f.defaultExtractor)
            return a.purge.options.defaultExtractor;
          if (!((p = a.content) === null || p === void 0 || (g = p.options) === null || g === void 0) && g.defaultExtractor)
            return a.content.options.defaultExtractor;
        })();
        if (d !== void 0 && (u.DEFAULT = d), typeof c == "function")
          u.DEFAULT = c;
        else if (Array.isArray(c))
          for (let { extensions: h, extractor: f } of c ?? [])
            for (let p of h)
              u[p] = f;
        else typeof c == "object" && c !== null && Object.assign(u, c);
        return u;
      })(),
      transform: (() => {
        let c = (() => {
          var d, h, f, p, g, m;
          return !((d = a.purge) === null || d === void 0) && d.transform ? a.purge.transform : !((h = a.content) === null || h === void 0) && h.transform ? a.content.transform : !((f = a.purge) === null || f === void 0 || (p = f.transform) === null || p === void 0) && p.DEFAULT ? a.purge.transform.DEFAULT : !((g = a.content) === null || g === void 0 || (m = g.transform) === null || m === void 0) && m.DEFAULT ? a.content.transform.DEFAULT : {};
        })(), u = {};
        return typeof c == "function" ? u.DEFAULT = c : typeof c == "object" && c !== null && Object.assign(u, c), u;
      })()
    };
    for (let c of a.content.files)
      if (typeof c == "string" && /{([^,]*?)}/g.test(c)) {
        e.default.warn("invalid-glob-braces", [
          `The glob pattern ${(0, e.dim)(c)} in your Tailwind CSS configuration is invalid.`,
          `Update it to ${(0, e.dim)(c.replace(/{([^,]*?)}/g, "$1"))} to silence this warning.`
        ]);
        break;
      }
    return a;
  }
})(zg);
var jg = {};
(function(i) {
  Object.defineProperty(i, "__esModule", {
    value: !0
  }), Object.defineProperty(i, "default", {
    enumerable: !0,
    get: function() {
      return t;
    }
  });
  function t(e) {
    if (Object.prototype.toString.call(e) !== "[object Object]")
      return !1;
    const n = Object.getPrototypeOf(e);
    return n === null || Object.getPrototypeOf(n) === null;
  }
})(jg);
var Wg = {};
(function(i) {
  Object.defineProperty(i, "__esModule", {
    value: !0
  }), Object.defineProperty(i, "cloneDeep", {
    enumerable: !0,
    get: function() {
      return t;
    }
  });
  function t(e) {
    return Array.isArray(e) ? e.map((n) => t(n)) : typeof e == "object" && e !== null ? Object.fromEntries(Object.entries(e).map(([n, s]) => [
      n,
      t(s)
    ])) : e;
  }
})(Wg);
var Yg = {}, Ug = {};
(function(i) {
  Object.defineProperty(i, "__esModule", {
    value: !0
  }), Object.defineProperty(i, "default", {
    enumerable: !0,
    get: function() {
      return t;
    }
  });
  function t(e) {
    return e.replace(/\\,/g, "\\2c ");
  }
})(Ug);
var kc = {}, Oc = {}, Zg = {};
(function(i) {
  Object.defineProperty(i, "__esModule", {
    value: !0
  }), Object.defineProperty(i, "default", {
    enumerable: !0,
    get: function() {
      return t;
    }
  });
  const t = {
    aliceblue: [
      240,
      248,
      255
    ],
    antiquewhite: [
      250,
      235,
      215
    ],
    aqua: [
      0,
      255,
      255
    ],
    aquamarine: [
      127,
      255,
      212
    ],
    azure: [
      240,
      255,
      255
    ],
    beige: [
      245,
      245,
      220
    ],
    bisque: [
      255,
      228,
      196
    ],
    black: [
      0,
      0,
      0
    ],
    blanchedalmond: [
      255,
      235,
      205
    ],
    blue: [
      0,
      0,
      255
    ],
    blueviolet: [
      138,
      43,
      226
    ],
    brown: [
      165,
      42,
      42
    ],
    burlywood: [
      222,
      184,
      135
    ],
    cadetblue: [
      95,
      158,
      160
    ],
    chartreuse: [
      127,
      255,
      0
    ],
    chocolate: [
      210,
      105,
      30
    ],
    coral: [
      255,
      127,
      80
    ],
    cornflowerblue: [
      100,
      149,
      237
    ],
    cornsilk: [
      255,
      248,
      220
    ],
    crimson: [
      220,
      20,
      60
    ],
    cyan: [
      0,
      255,
      255
    ],
    darkblue: [
      0,
      0,
      139
    ],
    darkcyan: [
      0,
      139,
      139
    ],
    darkgoldenrod: [
      184,
      134,
      11
    ],
    darkgray: [
      169,
      169,
      169
    ],
    darkgreen: [
      0,
      100,
      0
    ],
    darkgrey: [
      169,
      169,
      169
    ],
    darkkhaki: [
      189,
      183,
      107
    ],
    darkmagenta: [
      139,
      0,
      139
    ],
    darkolivegreen: [
      85,
      107,
      47
    ],
    darkorange: [
      255,
      140,
      0
    ],
    darkorchid: [
      153,
      50,
      204
    ],
    darkred: [
      139,
      0,
      0
    ],
    darksalmon: [
      233,
      150,
      122
    ],
    darkseagreen: [
      143,
      188,
      143
    ],
    darkslateblue: [
      72,
      61,
      139
    ],
    darkslategray: [
      47,
      79,
      79
    ],
    darkslategrey: [
      47,
      79,
      79
    ],
    darkturquoise: [
      0,
      206,
      209
    ],
    darkviolet: [
      148,
      0,
      211
    ],
    deeppink: [
      255,
      20,
      147
    ],
    deepskyblue: [
      0,
      191,
      255
    ],
    dimgray: [
      105,
      105,
      105
    ],
    dimgrey: [
      105,
      105,
      105
    ],
    dodgerblue: [
      30,
      144,
      255
    ],
    firebrick: [
      178,
      34,
      34
    ],
    floralwhite: [
      255,
      250,
      240
    ],
    forestgreen: [
      34,
      139,
      34
    ],
    fuchsia: [
      255,
      0,
      255
    ],
    gainsboro: [
      220,
      220,
      220
    ],
    ghostwhite: [
      248,
      248,
      255
    ],
    gold: [
      255,
      215,
      0
    ],
    goldenrod: [
      218,
      165,
      32
    ],
    gray: [
      128,
      128,
      128
    ],
    green: [
      0,
      128,
      0
    ],
    greenyellow: [
      173,
      255,
      47
    ],
    grey: [
      128,
      128,
      128
    ],
    honeydew: [
      240,
      255,
      240
    ],
    hotpink: [
      255,
      105,
      180
    ],
    indianred: [
      205,
      92,
      92
    ],
    indigo: [
      75,
      0,
      130
    ],
    ivory: [
      255,
      255,
      240
    ],
    khaki: [
      240,
      230,
      140
    ],
    lavender: [
      230,
      230,
      250
    ],
    lavenderblush: [
      255,
      240,
      245
    ],
    lawngreen: [
      124,
      252,
      0
    ],
    lemonchiffon: [
      255,
      250,
      205
    ],
    lightblue: [
      173,
      216,
      230
    ],
    lightcoral: [
      240,
      128,
      128
    ],
    lightcyan: [
      224,
      255,
      255
    ],
    lightgoldenrodyellow: [
      250,
      250,
      210
    ],
    lightgray: [
      211,
      211,
      211
    ],
    lightgreen: [
      144,
      238,
      144
    ],
    lightgrey: [
      211,
      211,
      211
    ],
    lightpink: [
      255,
      182,
      193
    ],
    lightsalmon: [
      255,
      160,
      122
    ],
    lightseagreen: [
      32,
      178,
      170
    ],
    lightskyblue: [
      135,
      206,
      250
    ],
    lightslategray: [
      119,
      136,
      153
    ],
    lightslategrey: [
      119,
      136,
      153
    ],
    lightsteelblue: [
      176,
      196,
      222
    ],
    lightyellow: [
      255,
      255,
      224
    ],
    lime: [
      0,
      255,
      0
    ],
    limegreen: [
      50,
      205,
      50
    ],
    linen: [
      250,
      240,
      230
    ],
    magenta: [
      255,
      0,
      255
    ],
    maroon: [
      128,
      0,
      0
    ],
    mediumaquamarine: [
      102,
      205,
      170
    ],
    mediumblue: [
      0,
      0,
      205
    ],
    mediumorchid: [
      186,
      85,
      211
    ],
    mediumpurple: [
      147,
      112,
      219
    ],
    mediumseagreen: [
      60,
      179,
      113
    ],
    mediumslateblue: [
      123,
      104,
      238
    ],
    mediumspringgreen: [
      0,
      250,
      154
    ],
    mediumturquoise: [
      72,
      209,
      204
    ],
    mediumvioletred: [
      199,
      21,
      133
    ],
    midnightblue: [
      25,
      25,
      112
    ],
    mintcream: [
      245,
      255,
      250
    ],
    mistyrose: [
      255,
      228,
      225
    ],
    moccasin: [
      255,
      228,
      181
    ],
    navajowhite: [
      255,
      222,
      173
    ],
    navy: [
      0,
      0,
      128
    ],
    oldlace: [
      253,
      245,
      230
    ],
    olive: [
      128,
      128,
      0
    ],
    olivedrab: [
      107,
      142,
      35
    ],
    orange: [
      255,
      165,
      0
    ],
    orangered: [
      255,
      69,
      0
    ],
    orchid: [
      218,
      112,
      214
    ],
    palegoldenrod: [
      238,
      232,
      170
    ],
    palegreen: [
      152,
      251,
      152
    ],
    paleturquoise: [
      175,
      238,
      238
    ],
    palevioletred: [
      219,
      112,
      147
    ],
    papayawhip: [
      255,
      239,
      213
    ],
    peachpuff: [
      255,
      218,
      185
    ],
    peru: [
      205,
      133,
      63
    ],
    pink: [
      255,
      192,
      203
    ],
    plum: [
      221,
      160,
      221
    ],
    powderblue: [
      176,
      224,
      230
    ],
    purple: [
      128,
      0,
      128
    ],
    rebeccapurple: [
      102,
      51,
      153
    ],
    red: [
      255,
      0,
      0
    ],
    rosybrown: [
      188,
      143,
      143
    ],
    royalblue: [
      65,
      105,
      225
    ],
    saddlebrown: [
      139,
      69,
      19
    ],
    salmon: [
      250,
      128,
      114
    ],
    sandybrown: [
      244,
      164,
      96
    ],
    seagreen: [
      46,
      139,
      87
    ],
    seashell: [
      255,
      245,
      238
    ],
    sienna: [
      160,
      82,
      45
    ],
    silver: [
      192,
      192,
      192
    ],
    skyblue: [
      135,
      206,
      235
    ],
    slateblue: [
      106,
      90,
      205
    ],
    slategray: [
      112,
      128,
      144
    ],
    slategrey: [
      112,
      128,
      144
    ],
    snow: [
      255,
      250,
      250
    ],
    springgreen: [
      0,
      255,
      127
    ],
    steelblue: [
      70,
      130,
      180
    ],
    tan: [
      210,
      180,
      140
    ],
    teal: [
      0,
      128,
      128
    ],
    thistle: [
      216,
      191,
      216
    ],
    tomato: [
      255,
      99,
      71
    ],
    turquoise: [
      64,
      224,
      208
    ],
    violet: [
      238,
      130,
      238
    ],
    wheat: [
      245,
      222,
      179
    ],
    white: [
      255,
      255,
      255
    ],
    whitesmoke: [
      245,
      245,
      245
    ],
    yellow: [
      255,
      255,
      0
    ],
    yellowgreen: [
      154,
      205,
      50
    ]
  };
})(Zg);
(function(i) {
  Object.defineProperty(i, "__esModule", {
    value: !0
  });
  function t(p, g) {
    for (var m in g) Object.defineProperty(p, m, {
      enumerable: !0,
      get: g[m]
    });
  }
  t(i, {
    parseColor: function() {
      return h;
    },
    formatColor: function() {
      return f;
    }
  });
  const e = /* @__PURE__ */ n(Zg);
  function n(p) {
    return p && p.__esModule ? p : {
      default: p
    };
  }
  let s = /^#([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})?$/i, r = /^#([a-f\d])([a-f\d])([a-f\d])([a-f\d])?$/i, a = /(?:\d+|\d*\.\d+)%?/, o = /(?:\s*,\s*|\s+)/, l = /\s*[,/]\s*/, c = /var\(--(?:[^ )]*?)(?:,(?:[^ )]*?|var\(--[^ )]*?\)))?\)/, u = new RegExp(`^(rgba?)\\(\\s*(${a.source}|${c.source})(?:${o.source}(${a.source}|${c.source}))?(?:${o.source}(${a.source}|${c.source}))?(?:${l.source}(${a.source}|${c.source}))?\\s*\\)$`), d = new RegExp(`^(hsla?)\\(\\s*((?:${a.source})(?:deg|rad|grad|turn)?|${c.source})(?:${o.source}(${a.source}|${c.source}))?(?:${o.source}(${a.source}|${c.source}))?(?:${l.source}(${a.source}|${c.source}))?\\s*\\)$`);
  function h(p, { loose: g = !1 } = {}) {
    var m, v;
    if (typeof p != "string")
      return null;
    if (p = p.trim(), p === "transparent")
      return {
        mode: "rgb",
        color: [
          "0",
          "0",
          "0"
        ],
        alpha: "0"
      };
    if (p in e.default)
      return {
        mode: "rgb",
        color: e.default[p].map((O) => O.toString())
      };
    let b = p.replace(r, (O, k, P, x, R) => [
      "#",
      k,
      k,
      P,
      P,
      x,
      x,
      R ? R + R : ""
    ].join("")).match(s);
    if (b !== null)
      return {
        mode: "rgb",
        color: [
          parseInt(b[1], 16),
          parseInt(b[2], 16),
          parseInt(b[3], 16)
        ].map((O) => O.toString()),
        alpha: b[4] ? (parseInt(b[4], 16) / 255).toString() : void 0
      };
    var _;
    let S = (_ = p.match(u)) !== null && _ !== void 0 ? _ : p.match(d);
    if (S === null)
      return null;
    let C = [
      S[2],
      S[3],
      S[4]
    ].filter(Boolean).map((O) => O.toString());
    return C.length === 2 && C[0].startsWith("var(") ? {
      mode: S[1],
      color: [
        C[0]
      ],
      alpha: C[1]
    } : !g && C.length !== 3 || C.length < 3 && !C.some((O) => /^var\(.*?\)$/.test(O)) ? null : {
      mode: S[1],
      color: C,
      alpha: (m = S[5]) === null || m === void 0 || (v = m.toString) === null || v === void 0 ? void 0 : v.call(m)
    };
  }
  function f({ mode: p, color: g, alpha: m }) {
    let v = m !== void 0;
    return p === "rgba" || p === "hsla" ? `${p}(${g.join(", ")}${v ? `, ${m}` : ""})` : `${p}(${g.join(" ")}${v ? ` / ${m}` : ""})`;
  }
})(Oc);
(function(i) {
  Object.defineProperty(i, "__esModule", {
    value: !0
  });
  function t(r, a) {
    for (var o in a) Object.defineProperty(r, o, {
      enumerable: !0,
      get: a[o]
    });
  }
  t(i, {
    withAlphaValue: function() {
      return n;
    },
    default: function() {
      return s;
    }
  });
  const e = Oc;
  function n(r, a, o) {
    if (typeof r == "function")
      return r({
        opacityValue: a
      });
    let l = (0, e.parseColor)(r, {
      loose: !0
    });
    return l === null ? o : (0, e.formatColor)({
      ...l,
      alpha: a
    });
  }
  function s({ color: r, property: a, variable: o }) {
    let l = [].concat(a);
    if (typeof r == "function")
      return {
        [o]: "1",
        ...Object.fromEntries(l.map((u) => [
          u,
          r({
            opacityVariable: o,
            opacityValue: `var(${o})`
          })
        ]))
      };
    const c = (0, e.parseColor)(r);
    return c === null ? Object.fromEntries(l.map((u) => [
      u,
      r
    ])) : c.alpha !== void 0 ? Object.fromEntries(l.map((u) => [
      u,
      r
    ])) : {
      [o]: "1",
      ...Object.fromEntries(l.map((u) => [
        u,
        (0, e.formatColor)({
          ...c,
          alpha: `var(${o})`
        })
      ]))
    };
  }
})(kc);
var Mc = {}, Gg = {}, Za = {};
(function(i) {
  Object.defineProperty(i, "__esModule", {
    value: !0
  }), Object.defineProperty(i, "splitAtTopLevelOnly", {
    enumerable: !0,
    get: function() {
      return t;
    }
  });
  function t(e, n) {
    let s = [], r = [], a = 0, o = !1;
    for (let l = 0; l < e.length; l++) {
      let c = e[l];
      s.length === 0 && c === n[0] && !o && (n.length === 1 || e.slice(l, l + n.length) === n) && (r.push(e.slice(a, l)), a = l + n.length), o = o ? !1 : c === "\\", c === "(" || c === "[" || c === "{" ? s.push(c) : (c === ")" && s[s.length - 1] === "(" || c === "]" && s[s.length - 1] === "[" || c === "}" && s[s.length - 1] === "{") && s.pop();
    }
    return r.push(e.slice(a)), r;
  }
})(Za);
(function(i) {
  Object.defineProperty(i, "__esModule", {
    value: !0
  });
  function t(l, c) {
    for (var u in c) Object.defineProperty(l, u, {
      enumerable: !0,
      get: c[u]
    });
  }
  t(i, {
    parseBoxShadowValue: function() {
      return a;
    },
    formatBoxShadowValue: function() {
      return o;
    }
  });
  const e = Za;
  let n = /* @__PURE__ */ new Set([
    "inset",
    "inherit",
    "initial",
    "revert",
    "unset"
  ]), s = /\ +(?![^(]*\))/g, r = /^-?(\d+|\.\d+)(.*?)$/g;
  function a(l) {
    return (0, e.splitAtTopLevelOnly)(l, ",").map((u) => {
      let d = u.trim(), h = {
        raw: d
      }, f = d.split(s), p = /* @__PURE__ */ new Set();
      for (let g of f)
        r.lastIndex = 0, !p.has("KEYWORD") && n.has(g) ? (h.keyword = g, p.add("KEYWORD")) : r.test(g) ? p.has("X") ? p.has("Y") ? p.has("BLUR") ? p.has("SPREAD") || (h.spread = g, p.add("SPREAD")) : (h.blur = g, p.add("BLUR")) : (h.y = g, p.add("Y")) : (h.x = g, p.add("X")) : h.color ? (h.unknown || (h.unknown = []), h.unknown.push(g)) : h.color = g;
      return h.valid = h.x !== void 0 && h.y !== void 0, h;
    });
  }
  function o(l) {
    return l.map((c) => c.valid ? [
      c.keyword,
      c.x,
      c.y,
      c.blur,
      c.spread,
      c.color
    ].filter(Boolean).join(" ") : c.raw).join(", ");
  }
})(Gg);
(function(i) {
  Object.defineProperty(i, "__esModule", {
    value: !0
  });
  function t(T, V) {
    for (var N in V) Object.defineProperty(T, N, {
      enumerable: !0,
      get: V[N]
    });
  }
  t(i, {
    normalize: function() {
      return l;
    },
    normalizeAttributeSelectors: function() {
      return c;
    },
    url: function() {
      return d;
    },
    number: function() {
      return h;
    },
    percentage: function() {
      return f;
    },
    length: function() {
      return m;
    },
    lineWidth: function() {
      return b;
    },
    shadow: function() {
      return _;
    },
    color: function() {
      return S;
    },
    image: function() {
      return C;
    },
    gradient: function() {
      return k;
    },
    position: function() {
      return x;
    },
    familyName: function() {
      return R;
    },
    genericName: function() {
      return L;
    },
    absoluteSize: function() {
      return j;
    },
    relativeSize: function() {
      return I;
    }
  });
  const e = Oc, n = Gg, s = Za;
  let r = [
    "min",
    "max",
    "clamp",
    "calc"
  ];
  function a(T) {
    return r.some((V) => new RegExp(`^${V}\\(.*\\)`).test(T));
  }
  const o = /* @__PURE__ */ new Set([
    // Concrete properties
    "scroll-timeline-name",
    "timeline-scope",
    "view-timeline-name",
    "font-palette",
    "anchor-name",
    "anchor-scope",
    "position-anchor",
    "position-try-options",
    // Shorthand properties
    "scroll-timeline",
    "animation-timeline",
    "view-timeline",
    "position-try"
  ]);
  function l(T, V = null, N = !0) {
    let z = V && o.has(V.property);
    return T.startsWith("--") && !z ? `var(${T})` : T.includes("url(") ? T.split(/(url\(.*?\))/g).filter(Boolean).map((E) => /^url\(.*?\)$/.test(E) ? E : l(E, V, !1)).join("") : (T = T.replace(/([^\\])_+/g, (E, H) => H + " ".repeat(E.length - 1)).replace(/^_/g, " ").replace(/\\_/g, "_"), N && (T = T.trim()), T = u(T), T);
  }
  function c(T) {
    return T.includes("=") && (T = T.replace(/(=.*)/g, (V, N) => {
      if (N[1] === "'" || N[1] === '"')
        return N;
      if (N.length > 2) {
        let z = N[N.length - 1];
        if (N[N.length - 2] === " " && (z === "i" || z === "I" || z === "s" || z === "S"))
          return `="${N.slice(1, -2)}" ${N[N.length - 1]}`;
      }
      return `="${N.slice(1)}"`;
    })), T;
  }
  function u(T) {
    let V = [
      "theme"
    ], N = [
      "min-content",
      "max-content",
      "fit-content",
      // Env
      "safe-area-inset-top",
      "safe-area-inset-right",
      "safe-area-inset-bottom",
      "safe-area-inset-left",
      "titlebar-area-x",
      "titlebar-area-y",
      "titlebar-area-width",
      "titlebar-area-height",
      "keyboard-inset-top",
      "keyboard-inset-right",
      "keyboard-inset-bottom",
      "keyboard-inset-left",
      "keyboard-inset-width",
      "keyboard-inset-height",
      "radial-gradient",
      "linear-gradient",
      "conic-gradient",
      "repeating-radial-gradient",
      "repeating-linear-gradient",
      "repeating-conic-gradient",
      "anchor-size"
    ];
    return T.replace(/(calc|min|max|clamp)\(.+\)/g, (z) => {
      let E = "";
      function H() {
        let y = E.trimEnd();
        return y[y.length - 1];
      }
      for (let y = 0; y < z.length; y++) {
        let $ = function(J) {
          return J.split("").every((lt, Q) => z[y + Q] === lt);
        }, D = function(J) {
          let lt = 1 / 0;
          for (let ot of J) {
            let st = z.indexOf(ot, y);
            st !== -1 && st < lt && (lt = st);
          }
          let Q = z.slice(y, lt);
          return y += Q.length - 1, Q;
        }, Z = z[y];
        if ($("var"))
          E += D([
            ")",
            ","
          ]);
        else if (N.some((J) => $(J))) {
          let J = N.find((lt) => $(lt));
          E += J, y += J.length - 1;
        } else V.some((J) => $(J)) ? E += D([
          ")"
        ]) : $("[") ? E += D([
          "]"
        ]) : [
          "+",
          "-",
          "*",
          "/"
        ].includes(Z) && ![
          "(",
          "+",
          "-",
          "*",
          "/",
          ","
        ].includes(H()) ? E += ` ${Z} ` : E += Z;
      }
      return E.replace(/\s+/g, " ");
    });
  }
  function d(T) {
    return T.startsWith("url(");
  }
  function h(T) {
    return !isNaN(Number(T)) || a(T);
  }
  function f(T) {
    return T.endsWith("%") && h(T.slice(0, -1)) || a(T);
  }
  let g = `(?:${[
    "cm",
    "mm",
    "Q",
    "in",
    "pc",
    "pt",
    "px",
    "em",
    "ex",
    "ch",
    "rem",
    "lh",
    "rlh",
    "vw",
    "vh",
    "vmin",
    "vmax",
    "vb",
    "vi",
    "svw",
    "svh",
    "lvw",
    "lvh",
    "dvw",
    "dvh",
    "cqw",
    "cqh",
    "cqi",
    "cqb",
    "cqmin",
    "cqmax"
  ].join("|")})`;
  function m(T) {
    return T === "0" || new RegExp(`^[+-]?[0-9]*.?[0-9]+(?:[eE][+-]?[0-9]+)?${g}$`).test(T) || a(T);
  }
  let v = /* @__PURE__ */ new Set([
    "thin",
    "medium",
    "thick"
  ]);
  function b(T) {
    return v.has(T);
  }
  function _(T) {
    let V = (0, n.parseBoxShadowValue)(l(T));
    for (let N of V)
      if (!N.valid)
        return !1;
    return !0;
  }
  function S(T) {
    let V = 0;
    return (0, s.splitAtTopLevelOnly)(T, "_").every((z) => (z = l(z), z.startsWith("var(") ? !0 : (0, e.parseColor)(z, {
      loose: !0
    }) !== null ? (V++, !0) : !1)) ? V > 0 : !1;
  }
  function C(T) {
    let V = 0;
    return (0, s.splitAtTopLevelOnly)(T, ",").every((z) => (z = l(z), z.startsWith("var(") ? !0 : d(z) || k(z) || [
      "element(",
      "image(",
      "cross-fade(",
      "image-set("
    ].some((E) => z.startsWith(E)) ? (V++, !0) : !1)) ? V > 0 : !1;
  }
  let O = /* @__PURE__ */ new Set([
    "conic-gradient",
    "linear-gradient",
    "radial-gradient",
    "repeating-conic-gradient",
    "repeating-linear-gradient",
    "repeating-radial-gradient"
  ]);
  function k(T) {
    T = l(T);
    for (let V of O)
      if (T.startsWith(`${V}(`))
        return !0;
    return !1;
  }
  let P = /* @__PURE__ */ new Set([
    "center",
    "top",
    "right",
    "bottom",
    "left"
  ]);
  function x(T) {
    let V = 0;
    return (0, s.splitAtTopLevelOnly)(T, "_").every((z) => (z = l(z), z.startsWith("var(") ? !0 : P.has(z) || m(z) || f(z) ? (V++, !0) : !1)) ? V > 0 : !1;
  }
  function R(T) {
    let V = 0;
    return (0, s.splitAtTopLevelOnly)(T, ",").every((z) => (z = l(z), z.startsWith("var(") ? !0 : z.includes(" ") && !/(['"])([^"']+)\1/g.test(z) || /^\d/g.test(z) ? !1 : (V++, !0))) ? V > 0 : !1;
  }
  let B = /* @__PURE__ */ new Set([
    "serif",
    "sans-serif",
    "monospace",
    "cursive",
    "fantasy",
    "system-ui",
    "ui-serif",
    "ui-sans-serif",
    "ui-monospace",
    "ui-rounded",
    "math",
    "emoji",
    "fangsong"
  ]);
  function L(T) {
    return B.has(T);
  }
  let Y = /* @__PURE__ */ new Set([
    "xx-small",
    "x-small",
    "small",
    "medium",
    "large",
    "x-large",
    "xx-large",
    "xxx-large"
  ]);
  function j(T) {
    return Y.has(T);
  }
  let w = /* @__PURE__ */ new Set([
    "larger",
    "smaller"
  ]);
  function I(T) {
    return w.has(T);
  }
})(Mc);
var Kg = {};
(function(i) {
  Object.defineProperty(i, "__esModule", {
    value: !0
  }), Object.defineProperty(i, "backgroundSize", {
    enumerable: !0,
    get: function() {
      return n;
    }
  });
  const t = Mc, e = Za;
  function n(s) {
    let r = [
      "cover",
      "contain"
    ];
    return (0, e.splitAtTopLevelOnly)(s, ",").every((a) => {
      let o = (0, e.splitAtTopLevelOnly)(a, "_").filter(Boolean);
      return o.length === 1 && r.includes(o[0]) ? !0 : o.length !== 1 && o.length !== 2 ? !1 : o.every((l) => (0, t.length)(l) || (0, t.percentage)(l) || l === "auto");
    });
  }
})(Kg);
(function(i) {
  Object.defineProperty(i, "__esModule", {
    value: !0
  });
  function t(x, R) {
    for (var B in R) Object.defineProperty(x, B, {
      enumerable: !0,
      get: R[B]
    });
  }
  t(i, {
    updateAllClasses: function() {
      return c;
    },
    asValue: function() {
      return h;
    },
    parseColorFormat: function() {
      return g;
    },
    asColor: function() {
      return v;
    },
    asLookupValue: function() {
      return b;
    },
    typeMap: function() {
      return S;
    },
    coerceValue: function() {
      return k;
    },
    getMatchingTypes: function() {
      return P;
    }
  });
  const e = /* @__PURE__ */ l(Ug), n = kc, s = Mc, r = /* @__PURE__ */ l(Sc), a = Kg, o = Ua;
  function l(x) {
    return x && x.__esModule ? x : {
      default: x
    };
  }
  function c(x, R) {
    x.walkClasses((B) => {
      B.value = R(B.value), B.raws && B.raws.value && (B.raws.value = (0, e.default)(B.raws.value));
    });
  }
  function u(x, R) {
    if (!f(x))
      return;
    let B = x.slice(1, -1);
    if (R(B))
      return (0, s.normalize)(B);
  }
  function d(x, R = {}, B) {
    let L = R[x];
    if (L !== void 0)
      return (0, r.default)(L);
    if (f(x)) {
      let Y = u(x, B);
      return Y === void 0 ? void 0 : (0, r.default)(Y);
    }
  }
  function h(x, R = {}, { validate: B = () => !0 } = {}) {
    var L;
    let Y = (L = R.values) === null || L === void 0 ? void 0 : L[x];
    return Y !== void 0 ? Y : R.supportsNegativeValues && x.startsWith("-") ? d(x.slice(1), R.values, B) : u(x, B);
  }
  function f(x) {
    return x.startsWith("[") && x.endsWith("]");
  }
  function p(x) {
    let R = x.lastIndexOf("/"), B = x.lastIndexOf("[", R), L = x.indexOf("]", R);
    return x[R - 1] === "]" || x[R + 1] === "[" || B !== -1 && L !== -1 && B < R && R < L && (R = x.lastIndexOf("/", B)), R === -1 || R === x.length - 1 ? [
      x,
      void 0
    ] : f(x) && !x.includes("]/[") ? [
      x,
      void 0
    ] : [
      x.slice(0, R),
      x.slice(R + 1)
    ];
  }
  function g(x) {
    if (typeof x == "string" && x.includes("<alpha-value>")) {
      let R = x;
      return ({ opacityValue: B = 1 }) => R.replace(/<alpha-value>/g, B);
    }
    return x;
  }
  function m(x) {
    return (0, s.normalize)(x.slice(1, -1));
  }
  function v(x, R = {}, { tailwindConfig: B = {} } = {}) {
    var L;
    if (((L = R.values) === null || L === void 0 ? void 0 : L[x]) !== void 0) {
      var Y;
      return g((Y = R.values) === null || Y === void 0 ? void 0 : Y[x]);
    }
    let [j, w] = p(x);
    if (w !== void 0) {
      var I, T, V, N;
      let z = (N = (I = R.values) === null || I === void 0 ? void 0 : I[j]) !== null && N !== void 0 ? N : f(j) ? j.slice(1, -1) : void 0;
      return z === void 0 ? void 0 : (z = g(z), f(w) ? (0, n.withAlphaValue)(z, m(w)) : ((T = B.theme) === null || T === void 0 || (V = T.opacity) === null || V === void 0 ? void 0 : V[w]) === void 0 ? void 0 : (0, n.withAlphaValue)(z, B.theme.opacity[w]));
    }
    return h(x, R, {
      validate: s.color
    });
  }
  function b(x, R = {}) {
    var B;
    return (B = R.values) === null || B === void 0 ? void 0 : B[x];
  }
  function _(x) {
    return (R, B) => h(R, B, {
      validate: x
    });
  }
  let S = {
    any: h,
    color: v,
    url: _(s.url),
    image: _(s.image),
    length: _(s.length),
    percentage: _(s.percentage),
    position: _(s.position),
    lookup: b,
    "generic-name": _(s.genericName),
    "family-name": _(s.familyName),
    number: _(s.number),
    "line-width": _(s.lineWidth),
    "absolute-size": _(s.absoluteSize),
    "relative-size": _(s.relativeSize),
    shadow: _(s.shadow),
    size: _(a.backgroundSize)
  }, C = Object.keys(S);
  function O(x, R) {
    let B = x.indexOf(R);
    return B === -1 ? [
      void 0,
      x
    ] : [
      x.slice(0, B),
      x.slice(B + 1)
    ];
  }
  function k(x, R, B, L) {
    if (B.values && R in B.values)
      for (let { type: j } of x ?? []) {
        let w = S[j](R, B, {
          tailwindConfig: L
        });
        if (w !== void 0)
          return [
            w,
            j,
            null
          ];
      }
    if (f(R)) {
      let j = R.slice(1, -1), [w, I] = O(j, ":");
      if (!/^[\w-_]+$/g.test(w))
        I = j;
      else if (w !== void 0 && !C.includes(w))
        return [];
      if (I.length > 0 && C.includes(w))
        return [
          h(`[${I}]`, B),
          w,
          null
        ];
    }
    let Y = P(x, R, B, L);
    for (let j of Y)
      return j;
    return [];
  }
  function* P(x, R, B, L) {
    let Y = (0, o.flagEnabled)(L, "generalizedModifiers"), [j, w] = p(R);
    if (Y && B.modifiers != null && (B.modifiers === "any" || typeof B.modifiers == "object" && (w && f(w) || w in B.modifiers)) || (j = R, w = void 0), w !== void 0 && j === "" && (j = "DEFAULT"), w !== void 0 && typeof B.modifiers == "object") {
      var T, V;
      let N = (V = (T = B.modifiers) === null || T === void 0 ? void 0 : T[w]) !== null && V !== void 0 ? V : null;
      N !== null ? w = N : f(w) && (w = m(w));
    }
    for (let { type: N } of x ?? []) {
      let z = S[N](j, B, {
        tailwindConfig: L
      });
      z !== void 0 && (yield [
        z,
        N,
        w ?? null
      ]);
    }
  }
})(Yg);
var Xg = {};
(function(i) {
  Object.defineProperty(i, "__esModule", {
    value: !0
  }), Object.defineProperty(i, "default", {
    enumerable: !0,
    get: function() {
      return t;
    }
  });
  function t(e) {
    return typeof e == "function" ? e({}) : e;
  }
})(Xg);
(function(i) {
  Object.defineProperty(i, "__esModule", {
    value: !0
  }), Object.defineProperty(i, "default", {
    enumerable: !0,
    get: function() {
      return B;
    }
  });
  const t = /* @__PURE__ */ f(Sc), e = /* @__PURE__ */ f($g), n = /* @__PURE__ */ f(Bg), s = /* @__PURE__ */ f(Rg), r = Hg, a = Vg, o = zg, l = /* @__PURE__ */ f(jg), c = Wg, u = Yg, d = kc, h = /* @__PURE__ */ f(Xg);
  function f(L) {
    return L && L.__esModule ? L : {
      default: L
    };
  }
  function p(L) {
    return typeof L == "function";
  }
  function g(L, ...Y) {
    let j = Y.pop();
    for (let w of Y)
      for (let I in w) {
        let T = j(L[I], w[I]);
        T === void 0 ? (0, l.default)(L[I]) && (0, l.default)(w[I]) ? L[I] = g({}, L[I], w[I], j) : L[I] = w[I] : L[I] = T;
      }
    return L;
  }
  const m = {
    colors: s.default,
    negative(L) {
      return Object.keys(L).filter((Y) => L[Y] !== "0").reduce((Y, j) => {
        let w = (0, t.default)(L[j]);
        return w !== void 0 && (Y[`-${j}`] = w), Y;
      }, {});
    },
    breakpoints(L) {
      return Object.keys(L).filter((Y) => typeof L[Y] == "string").reduce((Y, j) => ({
        ...Y,
        [`screen-${j}`]: L[j]
      }), {});
    }
  };
  function v(L, ...Y) {
    return p(L) ? L(...Y) : L;
  }
  function b(L) {
    return L.reduce((Y, { extend: j }) => g(Y, j, (w, I) => w === void 0 ? [
      I
    ] : Array.isArray(w) ? [
      I,
      ...w
    ] : [
      I,
      w
    ]), {});
  }
  function _(L) {
    return {
      ...L.reduce((Y, j) => (0, r.defaults)(Y, j), {}),
      // In order to resolve n config objects, we combine all of their `extend` properties
      // into arrays instead of objects so they aren't overridden.
      extend: b(L)
    };
  }
  function S(L, Y) {
    if (Array.isArray(L) && (0, l.default)(L[0]))
      return L.concat(Y);
    if (Array.isArray(Y) && (0, l.default)(Y[0]) && (0, l.default)(L))
      return [
        L,
        ...Y
      ];
    if (Array.isArray(Y))
      return Y;
  }
  function C({ extend: L, ...Y }) {
    return g(Y, L, (j, w) => !p(j) && !w.some(p) ? g({}, j, ...w, S) : (I, T) => g({}, ...[
      j,
      ...w
    ].map((V) => v(V, I, T)), S));
  }
  function* O(L) {
    let Y = (0, a.toPath)(L);
    if (Y.length === 0 || (yield Y, Array.isArray(L)))
      return;
    let j = /^(.*?)\s*\/\s*([^/]+)$/, w = L.match(j);
    if (w !== null) {
      let [, I, T] = w, V = (0, a.toPath)(I);
      V.alpha = T, yield V;
    }
  }
  function k(L) {
    const Y = (j, w) => {
      for (const I of O(j)) {
        let T = 0, V = L;
        for (; V != null && T < I.length; )
          V = V[I[T++]], V = p(V) && (I.alpha === void 0 || T <= I.length - 1) ? V(Y, m) : V;
        if (V !== void 0) {
          if (I.alpha !== void 0) {
            let N = (0, u.parseColorFormat)(V);
            return (0, d.withAlphaValue)(N, I.alpha, (0, h.default)(N));
          }
          return (0, l.default)(V) ? (0, c.cloneDeep)(V) : V;
        }
      }
      return w;
    };
    return Object.assign(Y, {
      theme: Y,
      ...m
    }), Object.keys(L).reduce((j, w) => (j[w] = p(L[w]) ? L[w](Y, m) : L[w], j), {});
  }
  function P(L) {
    let Y = [];
    return L.forEach((j) => {
      Y = [
        ...Y,
        j
      ];
      var w;
      const I = (w = j == null ? void 0 : j.plugins) !== null && w !== void 0 ? w : [];
      I.length !== 0 && I.forEach((T) => {
        T.__isOptionsFunction && (T = T());
        var V;
        Y = [
          ...Y,
          ...P([
            (V = T == null ? void 0 : T.config) !== null && V !== void 0 ? V : {}
          ])
        ];
      });
    }), Y;
  }
  function x(L) {
    return [
      ...L
    ].reduceRight((j, w) => p(w) ? w({
      corePlugins: j
    }) : (0, n.default)(w, j), e.default);
  }
  function R(L) {
    return [
      ...L
    ].reduceRight((j, w) => [
      ...j,
      ...w
    ], []);
  }
  function B(L) {
    let Y = [
      ...P(L),
      {
        prefix: "",
        important: !1,
        separator: ":"
      }
    ];
    var j, w;
    return (0, o.normalizeConfig)((0, r.defaults)({
      theme: k(C(_(Y.map((I) => (j = I == null ? void 0 : I.theme) !== null && j !== void 0 ? j : {})))),
      corePlugins: x(Y.map((I) => I.corePlugins)),
      plugins: R(L.map((I) => (w = I == null ? void 0 : I.plugins) !== null && w !== void 0 ? w : []))
    }, ...Y));
  }
})(Eg);
var Qg = {}, RT = {
  content: [],
  presets: [],
  darkMode: "media",
  // or 'class'
  theme: {
    accentColor: ({ theme: i }) => ({
      ...i("colors"),
      auto: "auto"
    }),
    animation: {
      none: "none",
      spin: "spin 1s linear infinite",
      ping: "ping 1s cubic-bezier(0, 0, 0.2, 1) infinite",
      pulse: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
      bounce: "bounce 1s infinite"
    },
    aria: {
      busy: 'busy="true"',
      checked: 'checked="true"',
      disabled: 'disabled="true"',
      expanded: 'expanded="true"',
      hidden: 'hidden="true"',
      pressed: 'pressed="true"',
      readonly: 'readonly="true"',
      required: 'required="true"',
      selected: 'selected="true"'
    },
    aspectRatio: {
      auto: "auto",
      square: "1 / 1",
      video: "16 / 9"
    },
    backdropBlur: ({ theme: i }) => i("blur"),
    backdropBrightness: ({ theme: i }) => i("brightness"),
    backdropContrast: ({ theme: i }) => i("contrast"),
    backdropGrayscale: ({ theme: i }) => i("grayscale"),
    backdropHueRotate: ({ theme: i }) => i("hueRotate"),
    backdropInvert: ({ theme: i }) => i("invert"),
    backdropOpacity: ({ theme: i }) => i("opacity"),
    backdropSaturate: ({ theme: i }) => i("saturate"),
    backdropSepia: ({ theme: i }) => i("sepia"),
    backgroundColor: ({ theme: i }) => i("colors"),
    backgroundImage: {
      none: "none",
      "gradient-to-t": "linear-gradient(to top, var(--tw-gradient-stops))",
      "gradient-to-tr": "linear-gradient(to top right, var(--tw-gradient-stops))",
      "gradient-to-r": "linear-gradient(to right, var(--tw-gradient-stops))",
      "gradient-to-br": "linear-gradient(to bottom right, var(--tw-gradient-stops))",
      "gradient-to-b": "linear-gradient(to bottom, var(--tw-gradient-stops))",
      "gradient-to-bl": "linear-gradient(to bottom left, var(--tw-gradient-stops))",
      "gradient-to-l": "linear-gradient(to left, var(--tw-gradient-stops))",
      "gradient-to-tl": "linear-gradient(to top left, var(--tw-gradient-stops))"
    },
    backgroundOpacity: ({ theme: i }) => i("opacity"),
    backgroundPosition: {
      bottom: "bottom",
      center: "center",
      left: "left",
      "left-bottom": "left bottom",
      "left-top": "left top",
      right: "right",
      "right-bottom": "right bottom",
      "right-top": "right top",
      top: "top"
    },
    backgroundSize: {
      auto: "auto",
      cover: "cover",
      contain: "contain"
    },
    blur: {
      0: "0",
      none: "",
      sm: "4px",
      DEFAULT: "8px",
      md: "12px",
      lg: "16px",
      xl: "24px",
      "2xl": "40px",
      "3xl": "64px"
    },
    borderColor: ({ theme: i }) => ({
      ...i("colors"),
      DEFAULT: i("colors.gray.200", "currentColor")
    }),
    borderOpacity: ({ theme: i }) => i("opacity"),
    borderRadius: {
      none: "0px",
      sm: "0.125rem",
      DEFAULT: "0.25rem",
      md: "0.375rem",
      lg: "0.5rem",
      xl: "0.75rem",
      "2xl": "1rem",
      "3xl": "1.5rem",
      full: "9999px"
    },
    borderSpacing: ({ theme: i }) => ({
      ...i("spacing")
    }),
    borderWidth: {
      DEFAULT: "1px",
      0: "0px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    boxShadow: {
      sm: "0 1px 2px 0 rgb(0 0 0 / 0.05)",
      DEFAULT: "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
      md: "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
      lg: "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
      xl: "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
      "2xl": "0 25px 50px -12px rgb(0 0 0 / 0.25)",
      inner: "inset 0 2px 4px 0 rgb(0 0 0 / 0.05)",
      none: "none"
    },
    boxShadowColor: ({ theme: i }) => i("colors"),
    brightness: {
      0: "0",
      50: ".5",
      75: ".75",
      90: ".9",
      95: ".95",
      100: "1",
      105: "1.05",
      110: "1.1",
      125: "1.25",
      150: "1.5",
      200: "2"
    },
    caretColor: ({ theme: i }) => i("colors"),
    colors: ({ colors: i }) => ({
      inherit: i.inherit,
      current: i.current,
      transparent: i.transparent,
      black: i.black,
      white: i.white,
      slate: i.slate,
      gray: i.gray,
      zinc: i.zinc,
      neutral: i.neutral,
      stone: i.stone,
      red: i.red,
      orange: i.orange,
      amber: i.amber,
      yellow: i.yellow,
      lime: i.lime,
      green: i.green,
      emerald: i.emerald,
      teal: i.teal,
      cyan: i.cyan,
      sky: i.sky,
      blue: i.blue,
      indigo: i.indigo,
      violet: i.violet,
      purple: i.purple,
      fuchsia: i.fuchsia,
      pink: i.pink,
      rose: i.rose
    }),
    columns: {
      auto: "auto",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12",
      "3xs": "16rem",
      "2xs": "18rem",
      xs: "20rem",
      sm: "24rem",
      md: "28rem",
      lg: "32rem",
      xl: "36rem",
      "2xl": "42rem",
      "3xl": "48rem",
      "4xl": "56rem",
      "5xl": "64rem",
      "6xl": "72rem",
      "7xl": "80rem"
    },
    container: {},
    content: {
      none: "none"
    },
    contrast: {
      0: "0",
      50: ".5",
      75: ".75",
      100: "1",
      125: "1.25",
      150: "1.5",
      200: "2"
    },
    cursor: {
      auto: "auto",
      default: "default",
      pointer: "pointer",
      wait: "wait",
      text: "text",
      move: "move",
      help: "help",
      "not-allowed": "not-allowed",
      none: "none",
      "context-menu": "context-menu",
      progress: "progress",
      cell: "cell",
      crosshair: "crosshair",
      "vertical-text": "vertical-text",
      alias: "alias",
      copy: "copy",
      "no-drop": "no-drop",
      grab: "grab",
      grabbing: "grabbing",
      "all-scroll": "all-scroll",
      "col-resize": "col-resize",
      "row-resize": "row-resize",
      "n-resize": "n-resize",
      "e-resize": "e-resize",
      "s-resize": "s-resize",
      "w-resize": "w-resize",
      "ne-resize": "ne-resize",
      "nw-resize": "nw-resize",
      "se-resize": "se-resize",
      "sw-resize": "sw-resize",
      "ew-resize": "ew-resize",
      "ns-resize": "ns-resize",
      "nesw-resize": "nesw-resize",
      "nwse-resize": "nwse-resize",
      "zoom-in": "zoom-in",
      "zoom-out": "zoom-out"
    },
    divideColor: ({ theme: i }) => i("borderColor"),
    divideOpacity: ({ theme: i }) => i("borderOpacity"),
    divideWidth: ({ theme: i }) => i("borderWidth"),
    dropShadow: {
      sm: "0 1px 1px rgb(0 0 0 / 0.05)",
      DEFAULT: ["0 1px 2px rgb(0 0 0 / 0.1)", "0 1px 1px rgb(0 0 0 / 0.06)"],
      md: ["0 4px 3px rgb(0 0 0 / 0.07)", "0 2px 2px rgb(0 0 0 / 0.06)"],
      lg: ["0 10px 8px rgb(0 0 0 / 0.04)", "0 4px 3px rgb(0 0 0 / 0.1)"],
      xl: ["0 20px 13px rgb(0 0 0 / 0.03)", "0 8px 5px rgb(0 0 0 / 0.08)"],
      "2xl": "0 25px 25px rgb(0 0 0 / 0.15)",
      none: "0 0 #0000"
    },
    fill: ({ theme: i }) => ({
      none: "none",
      ...i("colors")
    }),
    flex: {
      1: "1 1 0%",
      auto: "1 1 auto",
      initial: "0 1 auto",
      none: "none"
    },
    flexBasis: ({ theme: i }) => ({
      auto: "auto",
      ...i("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      "1/5": "20%",
      "2/5": "40%",
      "3/5": "60%",
      "4/5": "80%",
      "1/6": "16.666667%",
      "2/6": "33.333333%",
      "3/6": "50%",
      "4/6": "66.666667%",
      "5/6": "83.333333%",
      "1/12": "8.333333%",
      "2/12": "16.666667%",
      "3/12": "25%",
      "4/12": "33.333333%",
      "5/12": "41.666667%",
      "6/12": "50%",
      "7/12": "58.333333%",
      "8/12": "66.666667%",
      "9/12": "75%",
      "10/12": "83.333333%",
      "11/12": "91.666667%",
      full: "100%"
    }),
    flexGrow: {
      0: "0",
      DEFAULT: "1"
    },
    flexShrink: {
      0: "0",
      DEFAULT: "1"
    },
    fontFamily: {
      sans: [
        "ui-sans-serif",
        "system-ui",
        "sans-serif",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
        '"Noto Color Emoji"'
      ],
      serif: ["ui-serif", "Georgia", "Cambria", '"Times New Roman"', "Times", "serif"],
      mono: [
        "ui-monospace",
        "SFMono-Regular",
        "Menlo",
        "Monaco",
        "Consolas",
        '"Liberation Mono"',
        '"Courier New"',
        "monospace"
      ]
    },
    fontSize: {
      xs: ["0.75rem", { lineHeight: "1rem" }],
      sm: ["0.875rem", { lineHeight: "1.25rem" }],
      base: ["1rem", { lineHeight: "1.5rem" }],
      lg: ["1.125rem", { lineHeight: "1.75rem" }],
      xl: ["1.25rem", { lineHeight: "1.75rem" }],
      "2xl": ["1.5rem", { lineHeight: "2rem" }],
      "3xl": ["1.875rem", { lineHeight: "2.25rem" }],
      "4xl": ["2.25rem", { lineHeight: "2.5rem" }],
      "5xl": ["3rem", { lineHeight: "1" }],
      "6xl": ["3.75rem", { lineHeight: "1" }],
      "7xl": ["4.5rem", { lineHeight: "1" }],
      "8xl": ["6rem", { lineHeight: "1" }],
      "9xl": ["8rem", { lineHeight: "1" }]
    },
    fontWeight: {
      thin: "100",
      extralight: "200",
      light: "300",
      normal: "400",
      medium: "500",
      semibold: "600",
      bold: "700",
      extrabold: "800",
      black: "900"
    },
    gap: ({ theme: i }) => i("spacing"),
    gradientColorStops: ({ theme: i }) => i("colors"),
    gradientColorStopPositions: {
      "0%": "0%",
      "5%": "5%",
      "10%": "10%",
      "15%": "15%",
      "20%": "20%",
      "25%": "25%",
      "30%": "30%",
      "35%": "35%",
      "40%": "40%",
      "45%": "45%",
      "50%": "50%",
      "55%": "55%",
      "60%": "60%",
      "65%": "65%",
      "70%": "70%",
      "75%": "75%",
      "80%": "80%",
      "85%": "85%",
      "90%": "90%",
      "95%": "95%",
      "100%": "100%"
    },
    grayscale: {
      0: "0",
      DEFAULT: "100%"
    },
    gridAutoColumns: {
      auto: "auto",
      min: "min-content",
      max: "max-content",
      fr: "minmax(0, 1fr)"
    },
    gridAutoRows: {
      auto: "auto",
      min: "min-content",
      max: "max-content",
      fr: "minmax(0, 1fr)"
    },
    gridColumn: {
      auto: "auto",
      "span-1": "span 1 / span 1",
      "span-2": "span 2 / span 2",
      "span-3": "span 3 / span 3",
      "span-4": "span 4 / span 4",
      "span-5": "span 5 / span 5",
      "span-6": "span 6 / span 6",
      "span-7": "span 7 / span 7",
      "span-8": "span 8 / span 8",
      "span-9": "span 9 / span 9",
      "span-10": "span 10 / span 10",
      "span-11": "span 11 / span 11",
      "span-12": "span 12 / span 12",
      "span-full": "1 / -1"
    },
    gridColumnEnd: {
      auto: "auto",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12",
      13: "13"
    },
    gridColumnStart: {
      auto: "auto",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12",
      13: "13"
    },
    gridRow: {
      auto: "auto",
      "span-1": "span 1 / span 1",
      "span-2": "span 2 / span 2",
      "span-3": "span 3 / span 3",
      "span-4": "span 4 / span 4",
      "span-5": "span 5 / span 5",
      "span-6": "span 6 / span 6",
      "span-7": "span 7 / span 7",
      "span-8": "span 8 / span 8",
      "span-9": "span 9 / span 9",
      "span-10": "span 10 / span 10",
      "span-11": "span 11 / span 11",
      "span-12": "span 12 / span 12",
      "span-full": "1 / -1"
    },
    gridRowEnd: {
      auto: "auto",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12",
      13: "13"
    },
    gridRowStart: {
      auto: "auto",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12",
      13: "13"
    },
    gridTemplateColumns: {
      none: "none",
      subgrid: "subgrid",
      1: "repeat(1, minmax(0, 1fr))",
      2: "repeat(2, minmax(0, 1fr))",
      3: "repeat(3, minmax(0, 1fr))",
      4: "repeat(4, minmax(0, 1fr))",
      5: "repeat(5, minmax(0, 1fr))",
      6: "repeat(6, minmax(0, 1fr))",
      7: "repeat(7, minmax(0, 1fr))",
      8: "repeat(8, minmax(0, 1fr))",
      9: "repeat(9, minmax(0, 1fr))",
      10: "repeat(10, minmax(0, 1fr))",
      11: "repeat(11, minmax(0, 1fr))",
      12: "repeat(12, minmax(0, 1fr))"
    },
    gridTemplateRows: {
      none: "none",
      subgrid: "subgrid",
      1: "repeat(1, minmax(0, 1fr))",
      2: "repeat(2, minmax(0, 1fr))",
      3: "repeat(3, minmax(0, 1fr))",
      4: "repeat(4, minmax(0, 1fr))",
      5: "repeat(5, minmax(0, 1fr))",
      6: "repeat(6, minmax(0, 1fr))",
      7: "repeat(7, minmax(0, 1fr))",
      8: "repeat(8, minmax(0, 1fr))",
      9: "repeat(9, minmax(0, 1fr))",
      10: "repeat(10, minmax(0, 1fr))",
      11: "repeat(11, minmax(0, 1fr))",
      12: "repeat(12, minmax(0, 1fr))"
    },
    height: ({ theme: i }) => ({
      auto: "auto",
      ...i("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      "1/5": "20%",
      "2/5": "40%",
      "3/5": "60%",
      "4/5": "80%",
      "1/6": "16.666667%",
      "2/6": "33.333333%",
      "3/6": "50%",
      "4/6": "66.666667%",
      "5/6": "83.333333%",
      full: "100%",
      screen: "100vh",
      svh: "100svh",
      lvh: "100lvh",
      dvh: "100dvh",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    hueRotate: {
      0: "0deg",
      15: "15deg",
      30: "30deg",
      60: "60deg",
      90: "90deg",
      180: "180deg"
    },
    inset: ({ theme: i }) => ({
      auto: "auto",
      ...i("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      full: "100%"
    }),
    invert: {
      0: "0",
      DEFAULT: "100%"
    },
    keyframes: {
      spin: {
        to: {
          transform: "rotate(360deg)"
        }
      },
      ping: {
        "75%, 100%": {
          transform: "scale(2)",
          opacity: "0"
        }
      },
      pulse: {
        "50%": {
          opacity: ".5"
        }
      },
      bounce: {
        "0%, 100%": {
          transform: "translateY(-25%)",
          animationTimingFunction: "cubic-bezier(0.8,0,1,1)"
        },
        "50%": {
          transform: "none",
          animationTimingFunction: "cubic-bezier(0,0,0.2,1)"
        }
      }
    },
    letterSpacing: {
      tighter: "-0.05em",
      tight: "-0.025em",
      normal: "0em",
      wide: "0.025em",
      wider: "0.05em",
      widest: "0.1em"
    },
    lineHeight: {
      none: "1",
      tight: "1.25",
      snug: "1.375",
      normal: "1.5",
      relaxed: "1.625",
      loose: "2",
      3: ".75rem",
      4: "1rem",
      5: "1.25rem",
      6: "1.5rem",
      7: "1.75rem",
      8: "2rem",
      9: "2.25rem",
      10: "2.5rem"
    },
    listStyleType: {
      none: "none",
      disc: "disc",
      decimal: "decimal"
    },
    listStyleImage: {
      none: "none"
    },
    margin: ({ theme: i }) => ({
      auto: "auto",
      ...i("spacing")
    }),
    lineClamp: {
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6"
    },
    maxHeight: ({ theme: i }) => ({
      ...i("spacing"),
      none: "none",
      full: "100%",
      screen: "100vh",
      svh: "100svh",
      lvh: "100lvh",
      dvh: "100dvh",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    maxWidth: ({ theme: i, breakpoints: t }) => ({
      ...i("spacing"),
      none: "none",
      xs: "20rem",
      sm: "24rem",
      md: "28rem",
      lg: "32rem",
      xl: "36rem",
      "2xl": "42rem",
      "3xl": "48rem",
      "4xl": "56rem",
      "5xl": "64rem",
      "6xl": "72rem",
      "7xl": "80rem",
      full: "100%",
      min: "min-content",
      max: "max-content",
      fit: "fit-content",
      prose: "65ch",
      ...t(i("screens"))
    }),
    minHeight: ({ theme: i }) => ({
      ...i("spacing"),
      full: "100%",
      screen: "100vh",
      svh: "100svh",
      lvh: "100lvh",
      dvh: "100dvh",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    minWidth: ({ theme: i }) => ({
      ...i("spacing"),
      full: "100%",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    objectPosition: {
      bottom: "bottom",
      center: "center",
      left: "left",
      "left-bottom": "left bottom",
      "left-top": "left top",
      right: "right",
      "right-bottom": "right bottom",
      "right-top": "right top",
      top: "top"
    },
    opacity: {
      0: "0",
      5: "0.05",
      10: "0.1",
      15: "0.15",
      20: "0.2",
      25: "0.25",
      30: "0.3",
      35: "0.35",
      40: "0.4",
      45: "0.45",
      50: "0.5",
      55: "0.55",
      60: "0.6",
      65: "0.65",
      70: "0.7",
      75: "0.75",
      80: "0.8",
      85: "0.85",
      90: "0.9",
      95: "0.95",
      100: "1"
    },
    order: {
      first: "-9999",
      last: "9999",
      none: "0",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12"
    },
    outlineColor: ({ theme: i }) => i("colors"),
    outlineOffset: {
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    outlineWidth: {
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    padding: ({ theme: i }) => i("spacing"),
    placeholderColor: ({ theme: i }) => i("colors"),
    placeholderOpacity: ({ theme: i }) => i("opacity"),
    ringColor: ({ theme: i }) => ({
      DEFAULT: i("colors.blue.500", "#3b82f6"),
      ...i("colors")
    }),
    ringOffsetColor: ({ theme: i }) => i("colors"),
    ringOffsetWidth: {
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    ringOpacity: ({ theme: i }) => ({
      DEFAULT: "0.5",
      ...i("opacity")
    }),
    ringWidth: {
      DEFAULT: "3px",
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    rotate: {
      0: "0deg",
      1: "1deg",
      2: "2deg",
      3: "3deg",
      6: "6deg",
      12: "12deg",
      45: "45deg",
      90: "90deg",
      180: "180deg"
    },
    saturate: {
      0: "0",
      50: ".5",
      100: "1",
      150: "1.5",
      200: "2"
    },
    scale: {
      0: "0",
      50: ".5",
      75: ".75",
      90: ".9",
      95: ".95",
      100: "1",
      105: "1.05",
      110: "1.1",
      125: "1.25",
      150: "1.5"
    },
    screens: {
      sm: "640px",
      md: "768px",
      lg: "1024px",
      xl: "1280px",
      "2xl": "1536px"
    },
    scrollMargin: ({ theme: i }) => ({
      ...i("spacing")
    }),
    scrollPadding: ({ theme: i }) => i("spacing"),
    sepia: {
      0: "0",
      DEFAULT: "100%"
    },
    skew: {
      0: "0deg",
      1: "1deg",
      2: "2deg",
      3: "3deg",
      6: "6deg",
      12: "12deg"
    },
    space: ({ theme: i }) => ({
      ...i("spacing")
    }),
    spacing: {
      px: "1px",
      0: "0px",
      0.5: "0.125rem",
      1: "0.25rem",
      1.5: "0.375rem",
      2: "0.5rem",
      2.5: "0.625rem",
      3: "0.75rem",
      3.5: "0.875rem",
      4: "1rem",
      5: "1.25rem",
      6: "1.5rem",
      7: "1.75rem",
      8: "2rem",
      9: "2.25rem",
      10: "2.5rem",
      11: "2.75rem",
      12: "3rem",
      14: "3.5rem",
      16: "4rem",
      20: "5rem",
      24: "6rem",
      28: "7rem",
      32: "8rem",
      36: "9rem",
      40: "10rem",
      44: "11rem",
      48: "12rem",
      52: "13rem",
      56: "14rem",
      60: "15rem",
      64: "16rem",
      72: "18rem",
      80: "20rem",
      96: "24rem"
    },
    stroke: ({ theme: i }) => ({
      none: "none",
      ...i("colors")
    }),
    strokeWidth: {
      0: "0",
      1: "1",
      2: "2"
    },
    supports: {},
    data: {},
    textColor: ({ theme: i }) => i("colors"),
    textDecorationColor: ({ theme: i }) => i("colors"),
    textDecorationThickness: {
      auto: "auto",
      "from-font": "from-font",
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    textIndent: ({ theme: i }) => ({
      ...i("spacing")
    }),
    textOpacity: ({ theme: i }) => i("opacity"),
    textUnderlineOffset: {
      auto: "auto",
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    transformOrigin: {
      center: "center",
      top: "top",
      "top-right": "top right",
      right: "right",
      "bottom-right": "bottom right",
      bottom: "bottom",
      "bottom-left": "bottom left",
      left: "left",
      "top-left": "top left"
    },
    transitionDelay: {
      0: "0s",
      75: "75ms",
      100: "100ms",
      150: "150ms",
      200: "200ms",
      300: "300ms",
      500: "500ms",
      700: "700ms",
      1e3: "1000ms"
    },
    transitionDuration: {
      DEFAULT: "150ms",
      0: "0s",
      75: "75ms",
      100: "100ms",
      150: "150ms",
      200: "200ms",
      300: "300ms",
      500: "500ms",
      700: "700ms",
      1e3: "1000ms"
    },
    transitionProperty: {
      none: "none",
      all: "all",
      DEFAULT: "color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter",
      colors: "color, background-color, border-color, text-decoration-color, fill, stroke",
      opacity: "opacity",
      shadow: "box-shadow",
      transform: "transform"
    },
    transitionTimingFunction: {
      DEFAULT: "cubic-bezier(0.4, 0, 0.2, 1)",
      linear: "linear",
      in: "cubic-bezier(0.4, 0, 1, 1)",
      out: "cubic-bezier(0, 0, 0.2, 1)",
      "in-out": "cubic-bezier(0.4, 0, 0.2, 1)"
    },
    translate: ({ theme: i }) => ({
      ...i("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      full: "100%"
    }),
    size: ({ theme: i }) => ({
      auto: "auto",
      ...i("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      "1/5": "20%",
      "2/5": "40%",
      "3/5": "60%",
      "4/5": "80%",
      "1/6": "16.666667%",
      "2/6": "33.333333%",
      "3/6": "50%",
      "4/6": "66.666667%",
      "5/6": "83.333333%",
      "1/12": "8.333333%",
      "2/12": "16.666667%",
      "3/12": "25%",
      "4/12": "33.333333%",
      "5/12": "41.666667%",
      "6/12": "50%",
      "7/12": "58.333333%",
      "8/12": "66.666667%",
      "9/12": "75%",
      "10/12": "83.333333%",
      "11/12": "91.666667%",
      full: "100%",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    width: ({ theme: i }) => ({
      auto: "auto",
      ...i("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      "1/5": "20%",
      "2/5": "40%",
      "3/5": "60%",
      "4/5": "80%",
      "1/6": "16.666667%",
      "2/6": "33.333333%",
      "3/6": "50%",
      "4/6": "66.666667%",
      "5/6": "83.333333%",
      "1/12": "8.333333%",
      "2/12": "16.666667%",
      "3/12": "25%",
      "4/12": "33.333333%",
      "5/12": "41.666667%",
      "6/12": "50%",
      "7/12": "58.333333%",
      "8/12": "66.666667%",
      "9/12": "75%",
      "10/12": "83.333333%",
      "11/12": "91.666667%",
      full: "100%",
      screen: "100vw",
      svw: "100svw",
      lvw: "100lvw",
      dvw: "100dvw",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    willChange: {
      auto: "auto",
      scroll: "scroll-position",
      contents: "contents",
      transform: "transform"
    },
    zIndex: {
      auto: "auto",
      0: "0",
      10: "10",
      20: "20",
      30: "30",
      40: "40",
      50: "50"
    }
  },
  plugins: []
};
(function(i) {
  Object.defineProperty(i, "__esModule", {
    value: !0
  }), Object.defineProperty(i, "default", {
    enumerable: !0,
    get: function() {
      return s;
    }
  });
  const t = /* @__PURE__ */ n(RT), e = Ua;
  function n(r) {
    return r && r.__esModule ? r : {
      default: r
    };
  }
  function s(r) {
    var a;
    const o = ((a = r == null ? void 0 : r.presets) !== null && a !== void 0 ? a : [
      t.default
    ]).slice().reverse().flatMap((u) => s(u instanceof Function ? u() : u)), l = {
      // Add experimental configs here...
      respectDefaultRingColorOpacity: {
        theme: {
          ringColor: ({ theme: u }) => ({
            DEFAULT: "#3b82f67f",
            ...u("colors")
          })
        }
      },
      disableColorOpacityUtilitiesByDefault: {
        corePlugins: {
          backgroundOpacity: !1,
          borderOpacity: !1,
          divideOpacity: !1,
          placeholderOpacity: !1,
          ringOpacity: !1,
          textOpacity: !1
        }
      }
    }, c = Object.keys(l).filter((u) => (0, e.flagEnabled)(r, u)).map((u) => l[u]);
    return [
      r,
      ...c,
      ...o
    ];
  }
})(Qg);
(function(i) {
  Object.defineProperty(i, "__esModule", {
    value: !0
  }), Object.defineProperty(i, "default", {
    enumerable: !0,
    get: function() {
      return s;
    }
  });
  const t = /* @__PURE__ */ n(Eg), e = /* @__PURE__ */ n(Qg);
  function n(r) {
    return r && r.__esModule ? r : {
      default: r
    };
  }
  function s(...r) {
    let [, ...a] = (0, e.default)(r[0]);
    return (0, t.default)([
      ...r,
      ...a
    ]);
  }
})(Ig);
let Ho = Ig;
var FT = (Ho.__esModule ? Ho : { default: Ho }).default;
const NT = /* @__PURE__ */ as(FT), HT = {
  install(i, t = {}) {
    const { tailwindConfig: e } = t, n = NT(e || t1);
    i.prototype.$tailwindHelper = {
      config: n,
      getCurrentBreakpoint() {
        let s;
        const r = Object.entries(this.config.theme.screens);
        r.sort((a, o) => {
          const l = [a[1].split("px")][0][0], c = [o[1].split("px")][0][0], u = parseInt(l, 10), d = parseInt(c, 10);
          return u > d ? 1 : u < d ? -1 : 0;
        });
        for (let a = 0; a < r.length; a += 1) {
          const o = parseInt([r[a][1].split("px")], 10);
          if (window.innerWidth >= o)
            s = r[a];
          else {
            s || ([s] = r);
            break;
          }
        }
        return {
          key: s[0],
          valueString: s[1],
          value: parseInt([s[1].split("px")], 10)
        };
      },
      getCurrentBreakpointByKey(s) {
        const r = this.config.theme.screens[s];
        return r ? {
          key: s,
          valueString: r,
          value: parseInt([r.split("px")], 10)
        } : null;
      }
    };
  }
}, VT = {
  install(i, t = {}) {
    const { tailwindConfig: e } = t;
    Object.keys(Zd).forEach((n) => {
      const s = Zd[n];
      i.component(s.name, s);
    }), i.use(r1), i.use(HT, {
      tailwindConfig: e
    });
  }
}, zT = (i, t, e) => {
  Object.keys(e).length && i.classList.add(e[t]);
};
function UT(i, { value: t }, { context: e }) {
  zT(i, t, e.mappedClasses);
}
typeof window < "u" && window.Vue && window.Vue.use(VT);
export {
  F6 as AcvAnimatedInteger,
  aM as AcvAuctionsPrimaryDarkSvg,
  dM as AcvAuctionsPrimaryLightSvg,
  mM as AcvAuctionsSecondaryBlackSvg,
  _M as AcvAuctionsSecondaryGraySvg,
  kM as AcvAuctionsSecondaryWhiteSvg,
  xa as AcvBadge,
  Qd as AcvBanner,
  Ce as AcvBaseInput,
  ne as AcvBaseSvg,
  $1 as AcvBottomNavigation,
  J1 as AcvBottomSheet,
  bi as AcvButton,
  Zx as AcvCallToActionTable,
  PM as AcvCapitalPrimaryDarkSvg,
  BM as AcvCapitalPrimaryLightSvg,
  VM as AcvCapitalSecondaryDarkSvg,
  th as AcvCard,
  bm as AcvCardSubtitle,
  Sm as AcvCardText,
  Tm as AcvCardTitle,
  ls as AcvCheckbox,
  e2 as AcvCheckboxList,
  A2 as AcvCheckboxTree,
  Em as AcvChip,
  eh as AcvCollapse,
  O2 as AcvConfirmationTextInputs,
  yh as AcvCurrencyInput,
  Cl as AcvDataGrid,
  sh as AcvDataPagination,
  e0 as AcvDataTable,
  Yv as AcvDateField,
  m0 as AcvDialog,
  Js as AcvDivider,
  k0 as AcvEmptyState,
  O_ as AcvEventTimeline,
  $0 as AcvExpansionPanel,
  j6 as AcvFadeIn,
  eC as AcvFileUpload,
  Oa as AcvFlexbox,
  Xv as AcvFloatingActionButton,
  tp as AcvFlyoutMenu,
  Tb as AcvGallery,
  Hh as AcvGalleryCategoryBar,
  Vh as AcvGalleryList,
  LO as AcvGraph,
  ie as AcvIcon,
  Ee as AcvIconButton,
  Lh as AcvIntersectionObserver,
  wa as AcvLabel,
  Dl as AcvLazyImage,
  Lg as AcvLegacyPhoneNumberInput,
  PT as AcvLegacyPhoneNumberInputWithExtension,
  BT as AcvLegacyZipCodeInput,
  jh as AcvLightbox,
  cs as AcvList,
  Wh as AcvListButton,
  my as AcvListButtonList,
  us as AcvListItem,
  vh as AcvListItemContent,
  Qb as AcvListItemIcon,
  iy as AcvListItemSubtitle,
  oy as AcvListItemTitle,
  _y as AcvLoadingIndicator,
  UO as AcvMenu,
  Pg as AcvMenuList,
  Dg as AcvMenuListItem,
  Uy as AcvMobileOverlay,
  bh as AcvMoney,
  e3 as AcvMoneyField,
  a3 as AcvMultiSelect,
  Gh as AcvNavigationDrawer,
  Zh as AcvNavigationDrawerItem,
  oh as AcvPagination,
  d3 as AcvPhoneNumber,
  Kh as AcvProgressBar,
  Ca as AcvProgressIndicator,
  d_ as AcvPullToRefresh,
  Ol as AcvRadio,
  y3 as AcvRadioTree,
  U3 as AcvRangeSlider,
  ka as AcvScrollbar,
  J3 as AcvSearchBar,
  Dh as AcvSegmentedControl,
  Sl as AcvSelect,
  oA as AcvSelectField,
  m_ as AcvSlideOut,
  Uh as AcvSnackbar,
  By as AcvSnackbarList,
  Xh as AcvStatusBadge,
  L_ as AcvStepper,
  V_ as AcvStepperContent,
  U_ as AcvStepperHeader,
  Q_ as AcvStepperItems,
  i5 as AcvStepperStep,
  eM as AcvSvgGradient,
  Vb as AcvTable,
  Pe as AcvTextField,
  hA as AcvTextarea,
  o5 as AcvTimeCounter,
  vA as AcvTimeField,
  Yh as AcvToastMessage,
  Py as AcvToastMessageList,
  xA as AcvToggleButtonGroup,
  Ph as AcvToggleSwitch,
  os as AcvTooltip,
  h5 as AcvTopBar,
  b5 as AcvTour,
  UM as AcvTransportationPrimaryDarkSvg,
  QM as AcvTransportationSecondaryDarkSvg,
  hh as AcvValidationMessages,
  G6 as AcvVisibilityChange,
  PA as AcvZipCodeInput,
  yi as BackgroundStyles,
  Mn as BorderStyles,
  en as FontStyles,
  ue as Inputs,
  lh as LifeCycleEvents,
  qd as NavigationProperties,
  Bb as ShimmerMixin,
  fe as SizeStyles,
  HT as TailwindHelper,
  iT as True360PrimaryDarkSvg,
  oT as True360PrimaryLightSvg,
  hT as True360SecondaryBlackSvg,
  vT as True360SecondaryGraySvg,
  xT as True360SecondaryWhiteSvg,
  VT as default,
  $h as dragged,
  r1 as filters,
  UT as mapToClasses,
  mh as money,
  Ib as shimmer,
  uh as toggle
};
